/*!
* # SeriouslyRAD UI
* http://www.seriouslyrad.com/
*
* Copyright (c) 2016 - 2024 Seriously RAD Limited - All Rights Reserved
* Unauthorized copying of this file, via any medium is strictly prohibited
* Proprietary and confidential
*
*/

    "use strict";

    // #region Fixes

    $$(() =>
    {
        // Disable Backspace
        $$(document)
            .off("keydown")
            .on("keydown", evt =>
            {
                var
                    preventEvent = false;

                if (evt.key === "Backspace")
                {
                    var
                        element = evt.srcElement || evt.currentTarget;

                    if (element === document)
                        return;

                    var
                        tagName = element.tagName.toUpperCase(),
                        type = element.type.toUpperCase();

                    if
                        (
                        tagName === "INPUT"
                        &&
                        (
                            type === "TEXT"
                            || type === "PASSWORD"
                            || type === "FILE"
                            || type === "SEARCH"
                            || type === "EMAIL"
                            || type === "NUMBER"
                            || type === "DATE"
                        )
                        || tagName === "TEXTAREA"
                    )
                    {
                        preventEvent = element.readOnly || element.disabled;
                    }
                    else
                        preventEvent = true;
                }

                if (preventEvent)
                    evt.preventDefault();
            });

        setTimeout(() =>
        {
            $$("html").removeClass("ios");

            var
                isIE11 = !!(navigator.userAgent.match(/Trident/) && navigator.userAgent.match(/rv[ :]11/));

            if (isIE11)
                $$("html").addClass("ie11");
        });
    });

    // #endregion

    // #region Base Controls

    // #region Mixins

    // Property Bound Control Mixin
    classFactory.createMixin({
        namespace: "seriouslyrad.ui.web",
        name: "PropertyBoundControlMixin",
        properties: [
            { name: "dataSourceProperty", type: "string" },
            { name: "dataSourcePropertyType", type: "string" },
            { name: "value" }
        ],
        propertyAttributes: [
            {
                propertyName: "dataSourceProperty",
                designer: {
                    category: "Data",
                    displayName: "Data Source Property"
                }
            },
            {
                propertyName: "dataSourcePropertyType",
                designer: {
                    category: "Data",
                    displayName: "Data Source Property Type"
                }
            },
            {
                propertyName: "value",
                designer: {
                    category: "Appearance",
                    displayName: "Value"
                }
            }
        ],
        createConstructor: namespace =>
        {
            return function ()
            {
                this.__processDataSourcePropertyValueChanged = true;
                this.addCssClass("rad-control-property-bound-control");
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _dataSourcePropertyChanged: function (change)
                {
                    this.refreshFromDataSource();
                },
                _dataSourcePropertyTypeChanged: function (change)
                {
                    this.refreshFromDataSource();
                },
                _getDataSourceValue: function ()
                {
                    var
                        dataSource = this.dataSourceGet(),
                        dataSourceProperty = this.dataSourcePropertyGet();

                    if (!dataSource || !dataSourceProperty)
                        return;

                    return dataSource.propertyValueByPathGet(dataSourceProperty);
                },
                _refreshFromDataSource: function ()
                {
                    this.super._refreshFromDataSource();

                    if (!this.dataSourceGet() || !this.dataSourcePropertyGet())
                        return;

                    var
                        value = this._getDataSourceValue();

                    if (value === undefined)
                    {
                        value = null;
                        this._setDataSourceValue(value, true);
                    }

                    this.valueSet(value);
                },
                _setDataSourceValue: function (value, inhibitEvent)
                {
                    var
                        dataSource = this.dataSourceGet(),
                        dataSourceProperty = this.dataSourcePropertyGet();

                    if (!dataSource || !dataSourceProperty)
                        return;

                    dataSource.propertyValueByPathSet(dataSourceProperty, value, inhibitEvent);
                },
                _valueChanged: function (change)
                {
                    this.triggerHandler("valueChanged", change);
                },

                // Event Handlers
                onDataSourcePropertyValueChanged: function (evt, change)
                {
                    var
                        self = evt.data.self;

                    if (!self.__processDataSourcePropertyValueChanged)
                        return;

                    var
                        dataSourceProperty = self.dataSourcePropertyGet();

                    if (!dataSourceProperty)
                        return;

                    if (!(dataSourceProperty + ".").startsWith(change.path + "."))
                        return;

                    self.refreshFromDataSource();
                }
            };
        }
    });

    // #endregion

    // Control
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "Control",
        abstract: true,
        properties: [
            { name: "$$element" },
            { name: "controlClass", type: "string" },
            { name: "controlNamespace", type: "string" },
            { name: "cssClass", type: "string" },
            { name: "dataSource" },
            { name: "dataSourceControlSelector", type: "string" },
            { name: "dataSourceControl" },
            { name: "designMode", type: "boolean" },
            { name: "dimmed", type: "boolean" },
            { name: "draggable", type: "boolean" },
            { name: "elementType", type: "string" },
            { name: "enabled", type: "boolean" },
            { name: "height", type: "float" },
            { name: "inline", type: "boolean" },
            { name: "isVisible", type: "boolean" },
            { name: "left", type: "float" },
            { name: "maxHeight" },
            { name: "maxWidth" },
            { name: "minHeight" },
            { name: "minWidth" },
            {
                name: "page",
                boundEvents: [
                    { name: "activated", target: "onPageActivated" },
                    { name: "deactivated", target: "onPageDeactivated" },
                    { name: "loaded", target: "onPageLoaded" }
                ]
            },
            { name: "pageVariableName" },
            { name: "position" },
            { name: "propagateInputEvents" },
            { name: "size" },
            { name: "suspendLayout", type: "boolean" },
            { name: "tabStop", type: "boolean" },
            { name: "tabStopDisabled", type: "boolean" },
            { name: "tag" },
            { name: "text", type: "string" },
            { name: "top", type: "float" },
            { name: "visible", type: "boolean" },
            { name: "visibleEvaluator" },
            { name: "width", type: "float" }
        ],
        propertyAttributes: [
            {
                propertyName: "cssClass",
                designer: {
                    category: "Appearance",
                    displayName: "CSS Class",
                    helpText: "The CSS class to apply to the control element"
                }
            },
            /* TODO: This needs to go back in but how do we serialize a data source?
            {
                propertyName: "dataSource",
                designer: {
                    category: "Data",
                    displayName: "Data Source"
                }
            }, */
            /* TODO: If the controls are disabled they are not selectable.
            {
                propertyName: "enabled",
                designer: {
                    category: "Behavior",
                    displayName: "Enabled"
                }
            }, */
            {
                propertyName: "inline",
                designer: {
                    category: "Appearance",
                    displayName: "Inline"
                }
            },
            {
                propertyName: "maxWidth",
                designer: {
                    category: "Appearance",
                    displayName: "Max. Width"
                }
            },
            {
                propertyName: "minWidth",
                designer: {
                    category: "Appearance",
                    displayName: "Min. Width"
                }
            },
            /* TODO: This needs to go back in but how do we serialize a tag?
            {
                propertyName: "tag",
                designer: {
                    category: "Data",
                    displayName: "Tag"
                }
            }, */
            {
                propertyName: "text",
                designer: {
                    category: "Appearance",
                    displayName: "Text"
                }
            },
            {
                propertyName: "visible",
                designer: {
                    category: "Behavior",
                    displayName: "Visible"
                }
            },
            {
                propertyName: "visibleEvaluator",
                designer: {
                    category: "Behavior",
                    displayName: "Visible Evaluator",
                    propertyEditorClass: "seriouslyrad.ui.web.PropertyEditorEvaluatorTree"
                }
            }
        ],
        boundEvents: [
            { name: "ancestorChanged", target: "onAncestorChanged" },
            { name: "ancestorVisibilityChanged", target: "onAncestorVisibilityChanged" },
            { name: "click", target: "onClick" },
            { name: "parentChanged", target: "onParentChanged" },
            { name: "mouseup", target: "onMouseUp" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                cssClass: String.empty,
                elementType: "div",
                enabled: true,
                inline: false,
                isVisible: true,
                propagateInputEvents: true,
                suspendLayout: false,
                tabStop: false,
                tabStopDisabled: false,
                text: String.empty,
                visible: true
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.__refreshingFromDataSource = false;
                this.__refreshFromDataSourceSuspended = false;

                this._updatePropertiesFromElement();
                this._setIds();
                this._createElement();
                this._createElementComplete();

                if (this instanceof namespace.Page)
                    this.pageSet(this);

                this._savePropertyDefaults();

                this._bindEvents();

                this.addCssClass(this.cssClassGet());

                // Trigger Property Changes
                this.$$elementTriggerChange();
                this.dataSourceTriggerChange();
                this.dataSourceControlTriggerChange();
                this.designModeTriggerChange();
                this.dimmedTriggerChange();
                this.draggableTriggerChange();
                this.enabledTriggerChange();
                this.heightTriggerChange();
                this.inlineTriggerChange();
                this.isVisibleTriggerChange();
                this.leftTriggerChange();
                this.maxHeightTriggerChange();
                this.maxWidthTriggerChange();
                this.minHeightTriggerChange();
                this.minWidthTriggerChange();
                this.pageTriggerChange();
                this.tabStopDisabledTriggerChange();
                this.textTriggerChange();
                this.topTriggerChange();
                this.visibleTriggerChange();
                this.visibleEvaluatorTriggerChange();
                this.widthTriggerChange();

                this.updateVisibility();

                this.dataSourceControlSet(this._getDataSourceControl());
                this.dataSourceControlTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _$$elementChanged: function (change)
                {
                    if (change.originalValue)
                        change.originalValue.removeRadControl();

                    if (change.currentValue)
                        change.currentValue.radControl(this);

                    this._setPage();
                },
                _bindEvents: function ()
                {
                },
                _appendToOrPrependTo: function (elementOrContainerControl, append, beforeSelector)
                {
                    var
                        element = this.$$elementGet()?.get(0);

                    if (!element)
                        return;

                    if (typeof elementOrContainerControl === "string")
                        elementOrContainerControl = $$(elementOrContainerControl).firstOrDefault();
                    else if (Array.isArray(elementOrContainerControl))
                        elementOrContainerControl = elementOrContainerControl.firstOrDefault();
                    else if (elementOrContainerControl instanceof jQuery)
                        elementOrContainerControl = elementOrContainerControl.get(0);

                    if (!elementOrContainerControl)
                        return;

                    if (elementOrContainerControl instanceof Element)
                    {
                        const
                            originalParent = element.parentElement;

                        let
                            beforeElements;

                        if (beforeSelector)
                            beforeElements = elementOrContainerControl.querySelectorAll(beforeSelector);

                        if (beforeElements && beforeElements.length)
                            elementOrContainerControl.insertBefore(element, beforeElements[0]);
                        else if (append)
                            elementOrContainerControl.append(element);
                        else
                            elementOrContainerControl.prepend(element);

                        [element]
                            .concat(Array.from(element.querySelectorAll(".rad-control")))
                            .forEach(item => { $$.radControl(item)?.triggerHandler("ancestorChanged") });

                        this.triggerHandler("parentChanged", { originalValue: originalParent ? $$(originalParent) : null, currentValue: $$(elementOrContainerControl) });

                        return;
                    }

                    if (elementOrContainerControl instanceof namespace.ContainerControl)
                    {
                        if (append)
                            elementOrContainerControl.append(this, beforeSelector);
                        else
                            elementOrContainerControl.prepend(this, beforeSelector);

                        return;
                    }

                    console.error("Only Elements and ContainerControls are supported.");
                },
                _createElement: function ()
                {
                    var
                        $$element = this.$$elementGet(),
                        elementType = this.elementTypeGet();

                    if ($$element && $$element.length)
                        $$element.changeTagName(elementType);
                    else
                        $$element = $$.create$$({ nodeName: elementType });

                    $$element.attr("id", this.controlId);
                    $$element.radControl(this);
                    $$element.addClass(this.cssClassGet());

                    this.$$elementSet($$element);
                },
                _createElementComplete: function ()
                {
                    /* Intentionally empty */
                },
                _dataSourceChanged: function (change)
                {
                    if (change.originalValue)
                    {
                        change.originalValue.off("afterSaveChanges", { self: this }, this.onDataSourceAfterSaveChanges);
                        change.originalValue.off("beforeSaveChanges", { self: this }, this.onDataSourceBeforeSaveChanges);
                        change.originalValue.off("propertyValueChanged", { self: this }, this.onDataSourcePropertyValueChanged);
                        change.originalValue.off("validating", { self: this }, this.onDataSourceValidating);
                        change.originalValue.off("validationErrorsChanged", { self: this }, this.onDataSourceValidationErrorsChanged);
                    }

                    if (change.currentValue)
                    {
                        change.currentValue.on("afterSaveChanges", { self: this }, this.onDataSourceAfterSaveChanges);
                        change.currentValue.on("beforeSaveChanges", { self: this }, this.onDataSourceBeforeSaveChanges);
                        change.currentValue.on("propertyValueChanged", { self: this }, this.onDataSourcePropertyValueChanged);
                        change.currentValue.on("validating", { self: this }, this.onDataSourceValidating);
                        change.currentValue.on("validationErrorsChanged", { self: this },  this.onDataSourceValidationErrorsChanged);
                    }

                    this.refreshFromDataSource();

                    this.triggerHandler("dataSourceChanged", change);
                },
                _dataSourceControlChanged: function (change)
                {
                    if (change.originalValue)
                        change.originalValue.off("dataSourceChanged", { self: this }, this.onDataSourceControlDataSourceChanged);

                    if (change.currentValue)
                        change.currentValue.on("dataSourceChanged", { self: this }, this.onDataSourceControlDataSourceChanged);
                },
                _designModeChanged: function (change)
                {
                    if (change.currentValue)
                        this.addCssClass("rad-state-design");
                    else
                        this.removeCssClass("rad-state-design");
                },
                _dimmedChanged: function (change)
                {
                    this._updateTabIndexFromState();
                },
                _dispose: function ()
                {
                    var
                        dataSourceControl = this.dataSourceControlGet();

                    if (dataSourceControl)
                        dataSourceControl.off("dataSourceChanged", { self: this }, this.onDataSourceControlDataSourceChanged);

                    var
                        dataSource = this.dataSourceGet();

                    if (dataSource)
                    {
                        dataSource.off("afterSaveChanges", { self: this }, this.onDataSourceAfterSaveChanges);
                        dataSource.off("beforeSaveChanges", { self: this }, this.onDataSourceBeforeSaveChanges);
                        dataSource.off("propertyValueChanged", { self: this }, this.onDataSourcePropertyValueChanged);
                        dataSource.off("validating", { self: this }, this.onDataSourceValidating);
                        dataSource.off("validationErrorsChanged", { self: this }, this.onDataSourceValidationErrorsChanged);
                    }

                    if (this.visibleEvaluator)
                        this.visibleEvaluator.off("valueChanged", { self: this }, this.onVisibleEvaluatorValueChanged);

                    this.$$elementGet()?.dataRemove();
                    this.$$elementSet(null);

                    this.super._dispose();
                },
                _draggableChanged: function (change)
                {
                    var
                        $$element = this.$$elementGet();

                    if (change.currentValue)
                    {
                        window.dragDropManager.createDragDropItems($$element);
                        window.dragDropManager.createDragDropHandles($$element);
                    }
                    else
                    {
                        if (!this.__isConstructing())
                        {
                            window.dragDropManager.disableDragDropItems($$element);
                            window.dragDropManager.disableDragDropHandles($$element);
                        }
                    }
                },
                _enabledChanged: function (change)
                {
                    var
                        $$element = this.$$elementGet();

                    if (!$$element)
                        return;

                    if (change.currentValue)
                    {
                        $$element.removeClass("disabled");
                        $$element.removeAttr("disabled");
                        this.tabStopDisabledSet(false);
                    }
                    else
                    {
                        $$element.addClass("disabled");
                        $$element.attr("disabled", "disabled");
                        this.tabStopDisabledSet(true);
                    }

                    this._updateTabIndexFromState();
                },
                _getDataSourceControl: function ()
                {
                    var
                        $$element = this.$$elementGet(),
                        dataSourceControlSelector = this.dataSourceControlSelectorGet();

                    if ($$element && dataSourceControlSelector)
                        return $$element.closest(dataSourceControlSelector).radControl();

                    return this.dataSourceControlGet();
                },
                _getFocusElement: function ()
                {
                    return this.$$elementGet();
                },
                _getScrollParent: function ($$element)
                {
                    if (!$$element.length)
                        return null;

                    if ($$element[0].scrollHeight > $$element[0].clientHeight)
                        return $$element;
                    else
                        return this._getScrollParent($$element.parent());
                },
                _heightChanged: function (change)
                {
                    var
                        element = this.$$elementGet()[0];

                    var
                        original = element.style.height !== undefined && !String.isNullOrWhitespace(element.style.height) ? element.style.height : String.empty,
                        current = change.currentValue !== null ? String.format("{0}px", change.currentValue) : String.empty;

                    if (current !== original)
                        element.style.height = current;
                },
                _inlineChanged: function (change)
                {
                    if (change.currentValue)
                        this.addCssClass("rad-inline");
                    else
                        this.removeCssClass("rad-inline");
                },
                _isShown: function ()
                {
                    var
                        $$element = this.$$elementGet();

                    if (!$$element)
                        return;

                    return $$element.outerHeight() > 0 || $$element.outerWidth() > 0;
                },
                _isVisibleChanged: function (change)
                {
                    if (change.currentValue)
                        this.removeCssClass("rad-state-hidden");
                    else
                        this.addCssClass("rad-state-hidden");

                    this.trigger("isVisibleChanged", change);
                    this._triggerAncestorVisibilityChanged(change);
                },
                _leftChanged: function (change)
                {
                    const
                        $$element = this.$$elementGet();

                    if (!$$element)
                        return;

                    $$element.css({ left: change.currentValue });
                },
                _loadingDequeue: function (hideImmediately)
                {
                    var
                        self = this;

                    if (!self.controlOverlayLoader)
                        return;

                    if (Object.isNullOrUndefined(self.controlOverlayLoader.queueLength))
                        self.controlOverlayLoader.queueLength = 0;

                    self.controlOverlayLoader.queueLength--;

                    if (self.controlOverlayLoader.queueLength < 0)
                        self.controlOverlayLoader.queueLength = 0;

                    if (self.controlOverlayLoader.queueLength === 0)
                    {
                        if (self.showLoaderTimeoutId)
                        {
                            clearTimeout(self.showLoaderTimeoutId);
                            self.showLoaderTimeoutId = 0;
                        }

                        hideImmediately
                            ? self.controlOverlayLoader.hideImmediately()
                            : self.controlOverlayLoader.hide();
                    }
                },
                _loadingEnqueue: function ()
                {
                    var
                        self = this;

                    if (!self.controlOverlayLoader)
                    {
                        self.controlOverlayLoader = new namespace.ControlOverlayLoader();
                        self.$$elementGet().append(self.controlOverlayLoader.$$elementGet());
                    }

                    if (Object.isNullOrUndefined(self.controlOverlayLoader.queueLength))
                        self.controlOverlayLoader.queueLength = 0;

                    self.controlOverlayLoader.queueLength++;

                    if (!self.showLoaderTimeoutId)
                    {
                        self.showLoaderTimeoutId = setTimeout(() =>
                        {
                            self.showLoaderTimeoutId = 0;
                            self.controlOverlayLoader.show();
                        }, 250);
                    }
                },
                _maxHeightChanged: function (change)
                {
                    const
                        $$element = this.$$elementGet();

                    if (!$$element)
                        return;

                    $$element.css({ maxHeight: change.currentValue });
                },
                _maxWidthChanged: function (change)
                {
                    const
                        $$element = this.$$elementGet();

                    if (!$$element)
                        return;

                    $$element.css({ maxWidth: change.currentValue });
                },
                _minHeightChanged: function (change)
                {
                    const
                        $$element = this.$$elementGet();

                    if (!$$element)
                        return;

                    $$element.css({ minHeight: change.currentValue });
                },
                _minWidthChanged: function (change)
                {
                    const
                        $$element = this.$$elementGet();

                    if (!$$element)
                        return;

                    $$element.css({ minWidth: change.currentValue });
                },
                _pageChanged: function (change)
                {
                    var
                        pageVariableName = this.pageVariableNameGet();

                    if (change.originalValue)
                    {
                        if (pageVariableName)
                            delete change.originalValue[pageVariableName];
                    }

                    if (change.currentValue)
                    {
                        if (pageVariableName)
                            change.currentValue[pageVariableName] = this;
                    }
                },
                _positionGet: function ()
                {
                    return {
                        left: this.leftGet(),
                        top: this.topGet()
                    };
                },
                _positionSet: function (value)
                {
                    if (value)
                    {
                        this.leftSet(value.left !== undefined ? value.left : null);
                        this.topSet(value.top !== undefined ? value.top : null);
                    }
                },
                _refreshFromDataSource: function ()
                {
                    /* Intentionally empty */
                },
                _resumeRefreshFromDataSource: function ()
                {
                    this.__refreshFromDataSourceSuspended = false;
                    this.refreshFromDataSource();
                },
                _savePropertyDefaults: function ()
                {
                    var
                        self = this,
                        propertyDefaults = {};

                    this[".classDefinition"].properties
                        .each(item =>
                        {
                            switch (item.type)
                            {
                                case "array":
                                case "boolean":
                                case "float":
                                case "int":
                                case "string":
                                    propertyDefaults[item.name] = self[".properties"][item.name] !== undefined ? self[".properties"][item.name] : null;
                                    break;
                            }
                        });

                    this[".propertyDefaults"] = propertyDefaults;
                },
                _setPage: function ()
                {
                    var
                        page = this;

                    while (page)
                    {
                        if (page instanceof namespace.Page)
                            break;

                        page = page.parentPageGet();
                    }

                    this.pageSet(page ? page : null);
                },
                _setIds: function ()
                {
                    var
                        $$element = this.$$elementGet(),
                        element = $$element?.length ? $$element[0] : null;

                    if (!element || !element.hasAttribute("id"))
                        this.controlId = "control-" + namespace.Control.controlIdFactory.getNextId();
                    else
                        this.controlId = element.getAttribute("id");

                    this.labelTargetId = this.controlId;
                },
                _sizeGet: function ()
                {
                    return {
                        width: this.widthGet(),
                        height: this.heightGet()
                    };
                },
                _sizeSet: function (value)
                {
                    if (value)
                    {
                        this.widthSet(value.width !== undefined ? value.width : null);
                        this.heightSet(value.height !== undefined ? value.height : null);
                    }
                },
                _suspendRefreshFromDataSource: function ()
                {
                    this.__refreshFromDataSourceSuspended = true;
                },
                _tabStopDisabledChanged: function (change)
                {
                    var
                        $$focusElement = this._getFocusElement(),
                        focusElement = $$focusElement?.length ? $$focusElement[0] : null;

                    if (!focusElement)
                        return;

                    if (change.currentValue)
                    {
                        var
                            tabIndex = focusElement.getAttribute("tabindex");

                        if (tabIndex !== undefined)
                            focusElement.setAttribute("data-tabindex-backup", tabIndex);
                        else
                            focusElement.removeAttribute("data-tabindex-backup");

                        focusElement.setAttribute("tabindex", -1);
                    }
                    else
                    {
                        var
                            tabIndexBackup = focusElement.getAttribute("data-tabindex-backup");

                        if (!Object.isNullOrUndefined(tabIndexBackup))
                            focusElement.setAttribute("tabindex", tabIndexBackup);
                        //else
                        //    $$focusElement.removeAttr("tabindex");

                        focusElement.removeAttribute("data-tabindex-backup");
                    }
                },
                _textChanged: function (change)
                {
                    this.triggerHandler("textChanged", change);
                },
                _toggleTabIndexStateOnElement: function ()
                {
                    /* INFO: We need to consider current enabled & dimmed
                       state, and set the tabindex and backup attributes
                       as needed. */

                    this.tabStopDisabledSet(this.dimmedGet() || !this.enabledGet());
                },
                _topChanged: function (change)
                {
                    const
                        $$element = this.$$elementGet();

                    if (!$$element)
                        return;

                    $$element.css({ top: change.currentValue });
                },
                _triggerAncestorVisibilityChanged: function (change)
                {
                    const
                        $$element = this.$$elementGet();

                    if (!$$element)
                        return;

                    const
                        $$controlElements = $$element.find(".rad-control");

                    for (let controlElement of $$controlElements)
                        $$.radControl(controlElement)?.triggerHandler("ancestorVisibilityChanged", change);
                },
                _updatePropertiesFromElement: function ()
                {
                    var
                        $$element = this.$$elementGet();

                    if (!$$element)
                        return;

                    var
                        data = $$element.dataGet(),
                        propertyDefinitions = this[".classDefinition"].properties;

                    for (var i = 0; i < propertyDefinitions.length; i++)
                    {
                        var
                            propertyDefinition = propertyDefinitions[i],
                            dataName = propertyDefinition.name;

                        if (Object.prototype.hasOwnProperty.call(data, dataName))
                            this[".properties"][propertyDefinition.name] = objectHelper.asType(data[dataName], propertyDefinition.type);
                    }
                },
                _updateTabIndexFromState: function ()
                {
                    /* INFO: Needs to consider current enabled & dimmed
                       state, and set the tabindex and backup attributes
                       as needed. */

                    if (this.tabStopGet())
                        this._toggleTabIndexStateOnElement();
                },
                _visibleChanged: function (change)
                {
                    this.updateVisibility();
                },
                _visibleEvaluatorChanged: function (change)
                {
                    if (this.visibleEvaluator)
                    {
                        this.visibleEvaluator.off("valueChanged", { self: this }, this.onVisibleEvaluatorValueChanged);
                        this.visibleEvaluator.contextSet(null);
                    }

                    if (change.currentValue)
                    {
                        this.visibleEvaluator =
                            change.currentValue instanceof seriouslyrad.logicevaluation.Evaluator
                                ? change.currentValue
                                : seriouslyrad.logicevaluation.Evaluator.fromDataObject(change.currentValue);

                        this.visibleEvaluator.on("valueChanged", { self: this }, this.onVisibleEvaluatorValueChanged);
                        this.visibleEvaluator.contextSet(this);
                    }
                    else
                        this.visibleEvaluator = null;

                    this.updateVisibility();
                },
                _widthChanged: function (change)
                {
                    var
                        element = this.$$elementGet()[0],
                        original = element.style.width !== undefined && !String.isNullOrWhitespace(element.style.width) ? element.style.width : String.empty,
                        current = change.currentValue !== null ? String.format("{0}px", change.currentValue) : String.empty;

                    if (current !== original)
                        element.style.width = current;
                },

                // Public Methods
                addCssClass: function (className)
                {
                    if (!className)
                        return;

                    var
                        $$element = this.$$elementGet();

                    if (!$$element)
                        return;

                    $$element.addClass(className);
                },
                after: function (controlOrElementOrSelector)
                {
                    var
                        $$elementAfter;

                    if (controlOrElementOrSelector instanceof namespace.Control)
                        $$elementAfter = controlOrElementOrSelector.$$elementGet();
                    else if (controlOrElementOrSelector instanceof jQuery)
                        $$elementAfter = $$(controlOrElementOrSelector.toArray());
                    else if (typeof controlOrElementOrSelector === "string" || Array.isArray(controlOrElementOrSelector) || controlOrElementOrSelector instanceof Element)
                        $$elementAfter = $$(controlOrElementOrSelector);

                    if ($$elementAfter?.length)
                        $$elementAfter.after(this.$$elementGet());

                    return this;
                },
                appendTo: function ($$elementOrContainerControl, beforeSelector)
                {
                    this._appendToOrPrependTo($$elementOrContainerControl, true, beforeSelector);
                    return this;
                },
                before: function (controlOrElementOrSelector)
                {
                    var
                        $$elementBefore;

                    if (controlOrElementOrSelector instanceof namespace.Control)
                        $$elementBefore = controlOrElementOrSelector.$$elementGet();
                    else if (controlOrElementOrSelector instanceof jQuery)
                        $$elementBefore = $$(controlOrElementOrSelector.toArray());
                    else if (typeof controlOrElementOrSelector === "string" || Array.isArray(controlOrElementOrSelector) || controlOrElementOrSelector instanceof Element)
                        $$elementBefore = $$(controlOrElementOrSelector);

                    if ($$elementBefore?.length)
                        $$elementBefore.before(this.$$elementGet());

                    return this;
                },
                bringToFront: function ()
                {
                    var
                        parentControl = this.parentControlGet();

                    if (parentControl && parentControl instanceof namespace.ContainerControl)
                    {
                        parentControl.append(this);
                        return;
                    }

                    var
                        $$element = this.$$elementGet(),
                        $$parent = $$element.parent();

                    $$parent.append($$element);
                },
                clearCssClasses: function ()
                {
                    var
                        $$element = this.$$elementGet();

                    if (!$$element)
                        return;

                    $$element.removeClass();
                },
                dataSourceSet: function (value)
                {
                    if (value && !(value instanceof seriouslyrad.data.DataSource))
                        value = new seriouslyrad.data.DataSource({ data: value });

                    return this._dataSourceSet(value);
                },
                designablePropertiesGet: function ()
                {
                    return this[".classDefinition"].designablePropertiesGet();
                },
                designablePropertyValuesGet: function (changedOnly)
                {
                    var
                        self = this,
                        designablePropertyValues = {},
                        value;

                    self.designablePropertiesGet()
                        .each(item =>
                        {
                            value = self[item.name + "Get"]();

                            if (changedOnly && value === self[".propertyDefaults"][item.name])
                                return;

                            designablePropertyValues[item.name] = value;
                        });

                    return designablePropertyValues;
                },
                detach: function ()
                {
                    namespace.Control.$$detachedElements.append(this.$$elementGet());
                },
                focus: function ()
                {
                    var
                        $$focusElement = this._getFocusElement();

                    if (!$$focusElement)
                        return;

                    $$focusElement.focus();
                },
                focusNextControl: function ()
                {
                    var
                        $$focusElement = this._getFocusElement();

                    if (!$$focusElement || !$$focusElement.length)
                        return;

                    var
                        $$inputs = $$(FOCUSABLE_ELEMENTS_SELECTOR + ", [tabindex]");

                    if (!$$inputs.length)
                        return;

                    var
                        nextIndex = $$inputs.index($$focusElement[0]) + 1;

                    if (nextIndex >= $$inputs.length)
                        nextIndex = 0;

                    var
                        nextInputElement = $$inputs.get(nextIndex);

                    if (!nextInputElement)
                        return;

                    var
                        control = $$(nextInputElement).closest(".rad-control").radControl();

                    if (control)
                        control.focus();
                },
                getEventHandlerTarget: function (eventName)
                {
                    if (namespace.Control.htmlEventNames[eventName])
                        return this.$$elementGet();

                    if ($$.event.special[eventName])
                        return this.$$elementGet();

                    return this.super.getEventHandlerTarget();
                },
                getScrollParent: function ()
                {
                    var
                        $$element = this.$$elementGet();

                    if (!$$element)
                        return null;

                    return this._getScrollParent($$element.parent());
                },
                hasCssClass: function (className)
                {
                    var
                        $$element = this.$$elementGet();

                    if (!$$element)
                        return false;

                    return $$element.hasClass(className);
                },
                hide: function ()
                {
                    this.visibleSet(false);
                },
                nextControl: function ()
                {
                    var
                        $$element = this.$$elementGet(),
                        finished = false;

                    while (!finished)
                    {
                        $$element = $$element.next();

                        if (!$$element.length)
                        {
                            finished = true;
                            continue;
                        }

                        var
                            control = $$element.radControl();

                        if (control)
                            return control;
                    }

                    return null;
                },
                parentControlGet: function ()
                {
                    return this.parentControlOfTypeGet(namespace.Control);
                },
                parentControlOfTypeGet: function (type)
                {
                    var
                        $$element = this.$$elementGet();

                    if (!$$element)
                        return null;

                    var
                        currentElement = $$element.get(0),
                        currentControl;

                    while (currentElement && currentElement.parentElement)
                    {
                        currentElement = currentElement.parentElement.closest(".rad-control");
                        currentControl = $$.radControl(currentElement);

                        if (currentControl instanceof type)
                            return currentControl;
                    }

                    return null;
                },
                parentPageGet: function ()
                {
                    return this.parentControlOfTypeGet(namespace.Page);
                },
                prependTo: function ($$elementOrContainerControl)
                {
                    this._appendToOrPrependTo($$elementOrContainerControl, false);
                    return this;
                },
                previousControl: function ()
                {
                    var
                        $$element = this.$$elementGet(),
                        finished = false;

                    while (!finished)
                    {
                        $$element = $$element.prev();

                        if (!$$element.length)
                        {
                            finished = true;
                            continue;
                        }

                        var
                            control = $$element.radControl();

                        if (control)
                            return control;
                    }

                    return null;
                },
                refreshFromDataSource: function ()
                {
                    if (this.__refreshFromDataSourceSuspended)
                        return;

                    if (this.__refreshingFromDataSource)
                        return;

                    this.__refreshingFromDataSource = true;
                    this._refreshFromDataSource();
                    this.__refreshingFromDataSource = false;
                },
                remove: function ()
                {
                    var
                        self = this,
                        $$element = this.$$elementGet(),
                        parentControl = this.parentControlGet();

                    self.removeControls([
                        self.controlOverlayLoader,
                        $$element
                    ]);

                    if (parentControl instanceof seriouslyrad.ui.web.ContainerControl)
                        namespace.ContainerControl._triggerControlsChanged(parentControl);

                    setTimeout(() =>
                    {
                        self.dispose();
                        self = null;
                    });
                },
                removeControls: function (controls)
                {
                    if (Array.isArray(controls))
                        controls.each(item => { item?.remove && item.remove(); });
                },
                removeCssClass: function (className)
                {
                    var
                        $$element = this.$$elementGet();

                    if (!$$element)
                        return;

                    $$element.removeClass(className);
                },
                scrollToAsync: function ()
                {
                    var
                        $$element = this.$$elementGet(),
                        $$scrollParent = this.getScrollParent();

                    if (!$$element || !$$scrollParent || !$$scrollParent.length)
                        return Promise.resolve();

                    return (
                        $$scrollParent
                            .stop()
                            .animate({
                                scrollTop: $$element.offset().top - $$scrollParent.offset().top + $$scrollParent.scrollTop()
                            }, 500)
                            .promise()
                    );
                },
                sendToBack: function ()
                {
                    var
                        parentControl = this.parentControlGet();

                    if (parentControl && parentControl instanceof namespace.ContainerControl)
                    {
                        parentControl.prepend(this);
                        return;
                    }

                    var
                        $$element = this.$$elementGet(),
                        $$parent = $$element.parent();

                    $$parent.prepend($$element);
                },
                show: function ()
                {
                    this.visibleSet(true);
                },
                viewElementGet: function ()
                {
                    return $$.create$$({ nodeName: "p", text: this.textGet() });
                },
                visibleEvaluatorSet: function (value)
                {
                    if (typeof value === "string")
                        value = value.fromJson();

                    this._visibleEvaluatorSet(value);
                },
                updateVisibility: function ()
                {
                    this.isVisibleSet(this.visibleGet() && (!this.visibleEvaluator || this.visibleEvaluator.valueGet()));
                },

                // Event Handlers
                onAncestorChanged: function (evt)
                {
                    var
                        self = evt.data.self;

                    self._setPage();
                    self.dataSourceControlSet(self._getDataSourceControl());
                },
                onDataSourceAfterSaveChanges: function (evt, eventData)
                {
                    /* Intentionally empty */
                },
                onDataSourceBeforeSaveChanges: function (evt, eventData)
                {
                    /* Intentionally empty */
                },
                onDataSourceControlDataSourceChanged: function (evt, change)
                {
                    evt.data.self.dataSourceSet(change.currentValue);
                },
                onDataSourcePropertyValueChanged: function (evt, change)
                {
                    var
                        self = evt.data.self;

                    self.refreshFromDataSource();
                },
                onDataSourceValidating: function (evt, eventData)
                {
                    /* Intentionally empty */
                },
                onDataSourceValidationErrorsChanged: function (evt, change)
                {
                    /* Intentionally empty */
                },
                onMouseUp: function (evt)
                {
                    if (evt.data.self.designModeGet())
                        return;

                    if (evt.data.self.propagateInputEventsGet())
                        return;

                    evt.stopPropagation();
                },
                onVisibleEvaluatorValueChanged: function (evt, change)
                {
                    evt.data.self.updateVisibility();
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.controlIdFactory =
            {
                id: 0,
                getNextId: function ()
                {
                    return this.id++;
                }
            };

            classConstructor.createFromClassPath = (classPath, namespace, properties) =>
            {
                var
                    controlClass = classFactory.getObjectByPath({ path: classPath, namespace: namespace });

                if (!controlClass)
                    controlClass = classFactory.getObjectByPath({ path: classPath });

                if (!controlClass)
                {
                    console.error("Control class '" + classPath + "' not found.");
                    return;
                }

                var
                    control = new controlClass(properties);

                // Remove initialization attributes
                var
                    i,
                    attributesToRemove = [],
                    $$controlElement = control.$$elementGet();

                for (i = 0; i < $$controlElement[0].attributes.length; i++)
                {
                    if ($$controlElement[0].attributes[i].nodeName.startsWith("data-"))
                    {
                        if (!controlClass.preservedDataAttributes || !controlClass.preservedDataAttributes.contains($$controlElement[0].attributes[i].nodeName))
                            attributesToRemove.push($$controlElement[0].attributes[i].nodeName);
                    }
                }

                for (i = 0; i < attributesToRemove.length; i++)
                    $$controlElement.removeAttr(attributesToRemove[i]);

                return control;
            };
            classConstructor.createFromElement = element =>
            {
                if (Array.isArray(element))
                    element = element.firstOrDefault();
                else if (element instanceof jQuery)
                    element = element.get(0);

                if (!element)
                    console.error("element is required.");

                let
                    control = $$.radControl(element);

                if (control)
                    return control;

                const
                    controlNamespacePath = element.closest("[data-control-namespace]")?.getAttribute("data-control-namespace");

                let
                    controlNamespace;

                if (controlNamespacePath)
                    controlNamespace = classFactory.getObjectByPath({ path: controlNamespacePath });

                var
                    controlClassPath = element.getAttribute("data-control-class");

                if (!controlClassPath)
                    return;

                control = classConstructor.createFromClassPath(controlClassPath, controlNamespace, { $$element: $$(element) });

                return control;
            };
            classConstructor.$$detachedElements = $$.create$$({ nodeName: "div" });
            classConstructor.find = selector =>
            {
                return (
                    $$("body")
                        .add(classConstructor.$$detachedElements)
                        .find(selector)
                        .radControl()
                );
            };
            classConstructor.htmlEventNames = {
                abort: true,
                afterprint: true,
                animationend: true,
                animationiteration: true,
                animationstart: true,
                beforeprint: true,
                beforeunload: true,
                blur: true,
                canplay: true,
                canplaythrough: true,
                change: true,
                click: true,
                contextmenu: true,
                copy: true,
                cut: true,
                dblclick: true,
                drag: true,
                dragend: true,
                dragenter: true,
                dragleave: true,
                dragover: true,
                dragstart: true,
                drop: true,
                durationchange: true,
                ended: true,
                error: true,
                focus: true,
                focusin: true,
                focusout: true,
                fullscreenchange: true,
                fullscreenerror: true,
                hashchange: true,
                input: true,
                invalid: true,
                keydown: true,
                keypress: true,
                keyup: true,
                load: true,
                loadeddata: true,
                loadedmetadata: true,
                loadstart: true,
                message: true,
                mousedown: true,
                mouseenter: true,
                mouseleave: true,
                mousemove: true,
                mouseover: true,
                mouseout: true,
                mouseup: true,
                mousewheel: true,
                offline: true,
                online: true,
                open: true,
                pagehide: true,
                pageshow: true,
                paste: true,
                pause: true,
                play: true,
                playing: true,
                popstate: true,
                progress: true,
                ratechange: true,
                resize: true,
                reset: true,
                scroll: true,
                search: true,
                seeked: true,
                seeking: true,
                select: true,
                show: true,
                stalled: true,
                storage: true,
                submit: true,
                suspend: true,
                timeupdate: true,
                toggle: true,
                touchcancel: true,
                touchend: true,
                touchmove: true,
                touchstart: true,
                transitionend: true,
                unload: true,
                volumechange: true,
                waiting: true,
                wheel: true
            };
        }
    });

    // Container Control
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "ContainerControl",
        inherits: "Control",
        abstract: true,
        properties: [
            { name: "$$containerElement" },
            { name: "autoFocusChildElement", type: "boolean" }
        ],
        createPropertyDefaults: namespace => ({
            autoFocusChildElement: true
        }),
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _appendOrPrepend: function ($$elementOrControlOrArrayOf, append, beforeSelector)
                {
                    if ($$elementOrControlOrArrayOf instanceof jQuery)
                        $$elementOrControlOrArrayOf = $$elementOrControlOrArrayOf.toArray();

                    const
                        containerElement = this.$$containerElementGet().get(0),
                        elementOrControls = Array.isArray($$elementOrControlOrArrayOf) ? $$elementOrControlOrArrayOf : [$$elementOrControlOrArrayOf],
                        elementsToAdd = [];

                    for (let elementOrControl of elementOrControls)
                    {
                        if (Array.isArray(elementOrControl))
                            elementOrControl = elementOrControl.firstOrDefault();
                        else if (elementOrControl instanceof jQuery)
                            elementOrControl = elementOrControl.get(0);

                        if (!elementOrControl)
                            continue;

                        let
                            elementToAdd = {};

                        if (elementOrControl instanceof Element)
                        {
                            elementToAdd.control = $$(elementOrControl).radControl();
                            elementToAdd.element = elementOrControl;
                        }
                        else if (elementOrControl instanceof namespace.Control)
                        {
                            elementToAdd.control = elementOrControl;
                            elementToAdd.element = elementToAdd.control.$$elementGet().get(0);
                        }
                        else
                            console.error("Only Elements and Controls are supported.");

                        if (elementToAdd.control && !this._isAllowedControlClass(elementToAdd.control))
                            console.error("The supplied Control is not of an accepted type.");

                        elementToAdd.originalParent = elementToAdd.element.parentElement;
                        elementsToAdd.push(elementToAdd);
                    }

                    if (elementsToAdd.length)
                    {
                        let
                            beforeElements;

                        if (beforeSelector)
                            beforeElements = containerElement.querySelectorAll(beforeSelector);

                        if (beforeElements && beforeElements.length)
                        {
                            for (let elementToAdd of elementsToAdd)
                                containerElement.insertBefore(elementToAdd.element, beforeElements[0]);
                        }
                        else if (append)
                            containerElement.append.apply(containerElement, elementsToAdd.select(item => item.element));
                        else
                            containerElement.prepend.apply(containerElement, elementsToAdd.select(item => item.element));

                        elementsToAdd
                            .map(item => [item.element].concat(Array.from(item.element.querySelectorAll(".rad-control"))))
                            .reduce((a, b) => a.concat(b), [])
                            .forEach(item => { $$.radControl(item)?.triggerHandler("ancestorChanged") });

                        elementsToAdd
                            .where(item => item.control)
                            .forEach(item => { item.control.triggerHandler("parentChanged", { originalValue: item.originalParent ? $$(item.originalParent) : null, currentValue: $$(containerElement) }) });
                    }

                    return this;
                },
                _createChildControls: function ()
                {
                    const
                        $$children = this.$$containerElementGet().children();

                    for (let element of $$children)
                    {
                        const
                            control = namespace.Control.createFromElement(element);

                        if (!control)
                            continue;

                        if (!this._isAllowedControlClass(control))
                            console.error("One or more of the child controls are not of an accepted type.");
                    }

                    namespace.ContainerControl._triggerControlsChanged(this);
                },
                _createContainerElement: function ()
                {
                    this.$$containerElementSet(this.$$elementGet());
                },
                _createElement: function ()
                {
                    this.super._createElement();

                    var
                        $$element = this.$$elementGet();

                    this.$$initialContents = $$element.children();
                    this._createContainerElement();
                },
                _createElementComplete: function ()
                {
                    this.super._createElementComplete();

                    var
                        $$containerElement = this.$$containerElementGet();

                    this.addCssClass("rad-control-container-control");
                    $$containerElement.addClass("rad-control-container");

                    if (!$$containerElement.is(this.$$elementGet()))
                        $$containerElement.append(this.$$initialContents.not(this._getRootElements()));

                    this._createChildControls();
                },
                _designModeChanged: function (change)
                {
                    this.super._designModeChanged(change);

                    this.controlsGet()
                        .each(item =>
                        {
                            item.designModeSet(change.currentValue);
                        });
                },
                _dispose: function ()
                {
                    this.$$initialContents = null;
                    this.$$containerElementSet(null);

                    this.super._dispose();
                },
                /* TODO: Needs renaming. This returns the list of elements that are supposed to
                   be in the root element and should not move when the ContainerControl moves
                   content from the root element to the container element */
                _getRootElements: function ()
                {
                    return this.$$containerElementGet();
                },
                _isAllowedControlClass: function (control)
                {
                    var
                        allowedControlClasses = this[".classDefinition"].classConstructor.allowedChildControlClasses;

                    if (!allowedControlClasses)
                        return true;

                    return (
                        allowedControlClasses
                            .firstOrDefault(item => classFactory.objectInstanceOf(control, item)) !== null
                    );
                },

                // Public Methods
                append: function ($$elementOrControlOrArrayOf, beforeSelector)
                {
                    var result = this._appendOrPrepend($$elementOrControlOrArrayOf, true, beforeSelector);
                    namespace.ContainerControl._triggerControlsChanged(this);
                    return result;
                },
                controlsClear: function (detach)
                {
                    this.controlsGet()
                        .each(item =>
                        {
                            if (detach)
                            {
                                item.detach();
                                return;
                            }
                            
                            item.remove();
                        });

                    namespace.ContainerControl._triggerControlsChanged(this);
                },
                controlsGet: function (recursive)
                {
                    var
                        controls = [],
                        $$containerElement = this.$$containerElementGet();

                    if ($$containerElement)
                    {
                        const
                            $$children = this.$$containerElementGet().children();

                        for (let child of $$children)
                        {
                            const
                                control = $$.radControl(child);

                            if (!control)
                                continue;

                            if (control instanceof namespace.Control)
                                controls.push(control);

                            if (recursive && control instanceof namespace.ContainerControl)
                            {
                                const
                                    subChildren = control.controlsGet(true);

                                for (let subChild of subChildren)
                                    controls.push(subChild);
                            }
                        }
                    }

                    return controls;
                },
                focus: function ()
                {
                    var
                        self = this,
                        autoFocusChildElement = self.autoFocusChildElementGet(),
                        $$element = self.$$elementGet(),
                        element = $$element?.length ? $$element[0] : this;

                    if (!autoFocusChildElement || element?.hasAttribute("tabindex"))
                    {
                        self.super.focus();
                        return;
                    }

                    var
                        focusableElement = self.$$containerElementGet().find(FOCUSABLE_ELEMENTS_SELECTOR + ", [tabindex]").first();

                    if (focusableElement.length)
                    {
                        var
                            control = focusableElement.radControl();

                        if (control)
                            control.focus();
                        else
                            focusableElement.focus();
                    }
                },
                prepend: function ($$elementOrControlOrArrayOf)
                {
                    var result = this._appendOrPrepend($$elementOrControlOrArrayOf, false);
                    namespace.ContainerControl._triggerControlsChanged(this);
                    return result;
                },
                remove: function ()
                {
                    for (let control of this.controlsGet())
                        control.remove();

                    this.super.remove();
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            var
                containerControlsWhereControlsChanged = [],
                triggerControlsChangedTimeoutId = 0;

            function _triggerControlsChanged()
            {
                containerControlsWhereControlsChanged = containerControlsWhereControlsChanged.distinct();

                for (let containerControl of containerControlsWhereControlsChanged)
                    containerControl.trigger("controlsChanged");

                triggerControlsChangedTimeoutId = 0;
                containerControlsWhereControlsChanged = [];
            }

            classConstructor._triggerControlsChanged = containerControl =>
            {
                containerControlsWhereControlsChanged.push(containerControl);

                if (!triggerControlsChangedTimeoutId)
                    triggerControlsChangedTimeoutId = setTimeout(() => { _triggerControlsChanged(); });
            };
        }
    });

    // Property Bound Control
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "PropertyBoundControl",
        inherits: "Control",
        properties: [
            { name: "dataSourceProperty", type: "string" },
            { name: "dataSourcePropertyType", type: "string" },
            { name: "value" }
        ],
        propertyAttributes: [
            {
                propertyName: "dataSourceProperty",
                designer: {
                    category: "Data",
                    displayName: "Data Source Property"
                }
            },
            {
                propertyName: "dataSourcePropertyType",
                designer: {
                    category: "Data",
                    displayName: "Data Source Property Type"
                }
            },
            {
                propertyName: "value",
                designer: {
                    category: "Appearance",
                    displayName: "Value"
                }
            }
        ],
        createConstructor: namespace =>
        {
            return function ()
            {
                this.__processDataSourcePropertyValueChanged = true;
                this.addCssClass("rad-control-property-bound-control");

                // Trigger Property Changes

                this._suspendRefreshFromDataSource();
                this.dataSourceTriggerChange();
                this.dataSourcePropertyTriggerChange();
                this.dataSourcePropertyTypeTriggerChange();
                this._resumeRefreshFromDataSource();

                this.valueTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _appendToOrPrependTo: function ($$elementOrContainerControl, append, beforeSelector)
                {
                    this.super._appendToOrPrependTo($$elementOrContainerControl, append, beforeSelector);
                    this.dataSourceControlSet(this._getDataSourceControl());
                },
                _dataSourcePropertyChanged: function (change)
                {
                    this.refreshFromDataSource();
                },
                _dataSourcePropertyTypeChanged: function (change)
                {
                    this.refreshFromDataSource();
                },
                _getDataSourceValue: function ()
                {
                    var
                        dataSource = this.dataSourceGet(),
                        dataSourceProperty = this.dataSourcePropertyGet();

                    if (!dataSource || !dataSourceProperty)
                        return;

                    return dataSource.propertyValueByPathGet(dataSourceProperty);
                },
                _refreshFromDataSource: function ()
                {
                    this.super._refreshFromDataSource();

                    if (!this.dataSourceGet() || !this.dataSourcePropertyGet())
                        return;

                    var
                        value = this._getDataSourceValue();

                    if (value === undefined)
                    {
                        value = null;
                        this._setDataSourceValue(value, true);
                    }

                    this.valueSet(value);
                },
                _setDataSourceValue: function (value, inhibitEvent)
                {
                    var
                        dataSource = this.dataSourceGet(),
                        dataSourceProperty = this.dataSourcePropertyGet();

                    if (!dataSource || !dataSourceProperty)
                        return;

                    dataSource.propertyValueByPathSet(dataSourceProperty, value, inhibitEvent);
                },
                _inlineChanged: function (change)
                {
                    this.super._inlineChanged(change);

                    if (change.currentValue)
                        this.removeCssClass("fluid");
                    else
                        this.addCssClass("fluid");
                },
                _valueChanged: function (change)
                {
                    this.triggerHandler("valueChanged", change);
                },

                // Public Methods

                // Event Handlers
                onDataSourcePropertyValueChanged: function (evt, change)
                {
                    var
                        self = evt.data.self;

                    if (!self.__processDataSourcePropertyValueChanged)
                        return;

                    var
                        dataSourceProperty = self.dataSourcePropertyGet();

                    if (!dataSourceProperty)
                        return;

                    if (!(dataSourceProperty + ".").startsWith(change.path + "."))
                        return;

                    self.refreshFromDataSource();
                }
            };
        }
    });

    // Input Control
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "InputControl",
        inherits: "PropertyBoundControl",
        abstract: true,
        properties: [
            { name: "errorState", type: "boolean" },
            { name: "mandatory", type: "boolean" },
            { name: "mandatoryEvaluator" },
            { name: "readOnly", type: "boolean" }
        ],
        propertyAttributes: [
            {
                propertyName: "mandatory",
                designer: {
                    category: "Behavior",
                    displayName: "Mandatory"
                }
            },
            {
                propertyName: "mandatoryEvaluator",
                designer: {
                    category: "Behavior",
                    displayName: "Mandatory Evaluator",
                    propertyEditorClass: "seriouslyrad.ui.web.PropertyEditorEvaluatorTree"
                }
            }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                errorState: false,
                mandatory: false,
                propagateInputEvents: false,
                readOnly: false
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.__processElementValueChanged = true;
                this.__updatingDataSource = false;

                this.addCssClass("rad-control-input-control");

                // Trigger Property Changes
                this.errorStateTriggerChange();
                this.mandatoryTriggerChange();
                this.mandatoryEvaluatorTriggerChange();
                this.readOnlyTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _dispose: function ()
                {
                    if (this.mandatoryEvaluator)
                        this.mandatoryEvaluator.off("valueChanged", { self: this }, this.onMandatoryEvaluatorValueChanged);

                    this.super._dispose();
                },
                _errorStateChanged: function (change)
                {
                    if (change.currentValue)
                        this.addCssClass("rad-state-error");
                    else
                        this.removeCssClass("rad-state-error");
                },
                _mandatoryChanged: function (change)
                {
                    this.updateMandatory();
                },
                _mandatoryEvaluatorChanged: function (change)
                {
                    if (this.mandatoryEvaluator)
                    {
                        this.mandatoryEvaluator.off("valueChanged", { self: this }, this.onMandatoryEvaluatorValueChanged);
                        this.mandatoryEvaluator.contextSet(null);
                    }

                    if (change.currentValue)
                    {
                        this.mandatoryEvaluator = seriouslyrad.logicevaluation.Evaluator.fromDataObject(change.currentValue);
                        this.mandatoryEvaluator.on("valueChanged", { self: this }, this.onMandatoryEvaluatorValueChanged);
                        this.mandatoryEvaluator.contextSet(this);
                    }
                    else
                        this.mandatoryEvaluator = null;
                },
                _updateDataSource: function ()
                {
                    var
                        dataSource = this.dataSourceGet();

                    if (!dataSource)
                        return;

                    var
                        dataSourceProperty = this.dataSourcePropertyGet();

                    if (!dataSourceProperty)
                        return;

                    var
                        dataSourcePropertyType = this.dataSourcePropertyTypeGet(),
                        value = this.valueGet();

                    if (dataSourcePropertyType)
                        value = window.objectHelper.asType(value, dataSourcePropertyType);

                    dataSource.propertyValueByPathSet(dataSourceProperty, value);
                },
                _valueChanged: function (change)
                {
                    this.updateDataSource();
                    this.super._valueChanged(change);
                },

                // Public Methods
                isMandatoryGet: function ()
                {
                    return this.visibleGet() && (this.mandatoryGet() || this.mandatoryEvaluator?.valueGet());
                },
                mandatoryEvaluatorSet: function (value)
                {
                    if (typeof value === "string")
                        value = value.fromJson();

                    this._mandatoryEvaluatorSet(value);
                },
                updateDataSource: function ()
                {
                    if (this.__isConstructing())
                        return;

                    if (this.__refreshingFromDataSource)
                        return;

                    if (this.__updatingDataSource)
                        return;

                    this._suspendRefreshFromDataSource();
                    this.__updatingDataSource = true;
                    this._updateDataSource();
                    this.__updatingDataSource = false;
                    this._resumeRefreshFromDataSource();
                },
                updateMandatory: function ()
                {
                    if (this.isMandatoryGet())
                        this.addCssClass("rad-state-mandatory");
                    else
                        this.removeCssClass("rad-state-mandatory");
                },
                updateVisibility: function ()
                {
                    this.super.updateVisibility();
                    this.updateMandatory();
                },

                // Event Handlers
                onMandatoryEvaluatorValueChanged: function (evt)
                {
                    evt.data.self.updateMandatory();
                }
            };
        }
    });

    // Input List Control
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "InputListControl",
        inherits: "InputControl",
        abstract: true,
        properties: [
            { name: "listDataSource" },
            { name: "listDataSourceDescriptionProperty", type: "string" },
            { name: "listDataSourceValueProperty", type: "string" }
        ],
        propertyAttributes: [
            {
                propertyName: "listDataSource",
                designer: {
                    category: "Data",
                    displayName: "List Data Source"
                }
            },
            {
                propertyName: "listDataSourceValueProperty",
                designer: {
                    category: "Data",
                    displayName: "List Data Source Value Property"
                }
            },
            {
                propertyName: "listDataSourceDescriptionProperty",
                designer: {
                    category: "Data",
                    displayName: "List Data Source Description Property"
                }
            }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                listDataSourceDescriptionProperty: "description",
                listDataSourceValueProperty: "value"
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.__refreshListDataSourceSuspended = false;
                this.__refreshingListDataSource = false;

                this.addCssClass("rad-control-input-list-control");

                var
                    listDataSource = this[".properties"].listDataSource;

                if (listDataSource && !(listDataSource instanceof seriouslyrad.data.DataSource))
                    this[".properties"].listDataSource = new seriouslyrad.data.DataSource({ data: listDataSource });

                // Trigger Property Changes
                this._suspendRefreshListDataSource();
                this.listDataSourceTriggerChange();
                this.listDataSourceValuePropertyTriggerChange();
                this.listDataSourceDescriptionPropertyTriggerChange();
                this._resumeRefreshListDataSource();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _listDataSourceChanged: function (change)
                {
                    this.refreshListDataSource();
                },
                _listDataSourceValuePropertyChanged: function ()
                {
                    this.refreshListDataSource();
                },
                _listDataSourceDescriptionPropertyChanged: function ()
                {
                    this.refreshListDataSource();
                },
                _refreshListDataSource: function ()
                {
                    /* Intentionally empty */
                },
                _resumeRefreshListDataSource: function ()
                {
                    this.__refreshListDataSourceSuspended = false;
                    this.refreshListDataSource();
                },
                _suspendRefreshListDataSource: function ()
                {
                    this.__refreshListDataSourceSuspended = true;
                },

                // Public Methods
                listDataSourceSet: function (value)
                {
                    if (value && !(value instanceof seriouslyrad.data.DataSource))
                        value = new seriouslyrad.data.DataSource({ data: value });

                    return this._listDataSourceSet(value);
                },
                refreshListDataSource: function ()
                {
                    if (this.__refreshListDataSourceSuspended)
                        return;

                    if (this.__refreshingListDataSource)
                        return;

                    this.__refreshingListDataSource = true;
                    this._refreshListDataSource();
                    this.__refreshingListDataSource = false;
                }
            };
        }
    });

    // #endregion

    // #region Display Controls

    // Accordion
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "Accordion",
        inherits: "ContainerControl",
        properties: [
            { name: "allowMultiplePanelsOpen", type: "boolean" }
        ],
        propertyAttributes: [
            {
                propertyName: "allowMultiplePanelsOpen",
                designer: {
                    category: "Appearance",
                    displayName: "Allow Multiple Panels Open"
                }
            }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                allowMultiplePanelsOpen: false
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                var
                    self = this;

                self.addCssClass("rad-control-accordion ui accordion fluid styled");
                self._setFirstPanelActive();

                self.$$elementGet()
                    .accordion({
                        exclusive: !self.allowMultiplePanelsOpenGet(),
                        onClose: function ()
                        {
                            self._triggerAncestorVisibilityChanged({ originalValue: true, currentValue: false });
                        },
                        onOpen: function ()
                        {
                            self._triggerAncestorVisibilityChanged({ originalValue: false, currentValue: true });
                        },
                        selector: {
                            trigger: '>.rad-control-accordion-panel>.title'
                        }
                    });
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _allowMultiplePanelsOpenChanged: function (change)
                {
                    var
                        $$element = this.$$elementGet();

                    if (!$$element)
                        return;

                    $$element.accordion("setting", { exclusive: !change.currentValue });
                },
                _setFirstPanelActive: function ()
                {
                    var
                        controls = this.controlsGet();

                    if (controls.length === 0)
                        return;

                    controls[0].$$titleElement.addClass("active");
                    controls[0].$$containerWrapper.addClass("active");
                    controls[0].show();
                },

                // Public Methods
                allClosed: function ()
                {
                    return !this.controlsGet().any(item => item.isOpen());
                },
                append: function ($$elementOrControl)
                {
                    this.super.append($$elementOrControl);

                    if (this.controlsGet().length === 1)
                        this._setFirstPanelActive();

                    return this;
                },
                close: function (index, immediately)
                {
                    if (index < 0)
                        return;

                    if (immediately)
                    {
                        var
                            accordionPanels = this.controlsGet();

                        if (!accordionPanels || index > accordionPanels.length - 1)
                            return;

                        accordionPanels[index]._removeActiveClass();
                    }
                    else
                        this.$$elementGet().accordion("close", index);
                },
                closeAll: function (immediately)
                {
                    this.controlsGet().each(item => { item.close(immediately); });
                },
                open: function (index)
                {
                    this.$$elementGet().accordion("open", index);
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.allowedChildControlClasses = [
                "seriouslyrad.ui.web.AccordionPanel"
            ];
            classConstructor.createForInterfaceDesigner = () =>
            {
                return new classConstructor().append(new namespace.AccordionPanel({ text: "Panel1" }));
            };
        }
    });

    // Accordion Panel
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "AccordionPanel",
        inherits: "ContainerControl",
        properties: [
            { name: "icon", type: "string" }
        ],
        propertyAttributes: [
            {
                propertyName: "icon",
                designer: {
                    category: "Appearance",
                    displayName: "Icon"
                }
            }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                text: "Panel"
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-accordion-panel");
                this.$$containerWrapper.addClass("rad-control-container-wrapper content");

                // Trigger Property Changes
                this.iconTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _createContainerElement: function ()
                {
                    var
                        $$element = this.$$elementGet();

                    this.$$containerWrapper = $$element.find(">.rad-control-container-wrapper");

                    if (!this.$$containerWrapper.length)
                        this.$$containerWrapper = $$.create$$({ nodeName: "div" }).appendTo($$element);

                    var
                        $$containerElement = this.$$containerWrapper.find(">.rad-control-container");

                    if (!$$containerElement.length)
                        $$containerElement = $$.create$$({ nodeName: "div" }).appendTo(this.$$containerWrapper);

                    this.$$containerElementSet($$containerElement);
                },
                _createElement: function ()
                {
                    this.super._createElement();

                    var
                        $$element = this.$$elementGet();

                    this.$$titleElement = $$element.find(">.title");
                    if (!this.$$titleElement.length)
                    {
                        this.$$titleElement =
                            $$.create$$({
                                nodeName: "div",
                                attributes: { "class": "title" },
                                children: [
                                    { nodeName: "i", attributes: { "class": "dropdown icon" } },
                                    { nodeName: "span" }
                                ]
                            });
                        this.$$titleElement.insertBefore(this.$$containerWrapper);
                    }

                    this.$$icon =
                        $$.create$$({
                            nodeName: "i",
                            attributes: { "class": "icon" },
                            children: [{ nodeName: "span" }]
                        }).insertBefore(this.$$titleElement);
                },
                _iconChanged: function (change)
                {
                    if (change.originalValue)
                        this.$$icon.removeClass(change.originalValue);

                    if (change.currentValue)
                    {
                        this.addCssClass("rad-control-accordion-panel-icon");
                        this.$$icon.addClass(change.currentValue);
                    }
                    else
                        this.removeCssClass("rad-control-accordion-panel-icon");
                },
                _removeActiveClass: function ()
                {
                    this.$$titleElement.removeClass("active");
                    this.$$containerWrapper.removeClass("active");
                    this._triggerAncestorVisibilityChanged({ originalValue: true, currentValue: false });
                },
                _textChanged: function (change)
                {
                    this.super._textChanged(change);
                    this.$$titleElement.find(">span").text(change.currentValue);
                },

                // Public Methods
                close: function (immediately)
                {
                    var
                        accordion = this.parentControlGet();

                    if (!accordion)
                        return;

                    accordion.close(this.indexGet(), immediately);
                },
                indexGet: function ()
                {
                    var
                        accordion = this.parentControlGet();

                    if (!accordion)
                        return -1;

                    var
                        accordionPanels = accordion.controlsGet();

                    for (var i = 0; i < accordionPanels.length; i++)
                    {
                        if (accordionPanels[i] === this)
                            return i;
                    }

                    return -1;
                },
                isOpen: function ()
                {
                    return this.$$elementGet().find(">.title").hasClass("active");
                },
                open: function ()
                {
                    var
                        accordion = this.parentControlGet();

                    if (!accordion)
                        return;

                    accordion.open(this.indexGet());
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.allowedParentControlClasses = [
                "seriouslyrad.ui.web.Accordion"
            ];
            classConstructor.dragDropDraggableCssClass = "ui styled accordion";
        }
    });

    // Card List
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "CardList",
        inherits: "ContainerControl",
        properties: [
            { name: "stackable", type: "boolean" }
        ],
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-card-list ui cards");

                // Trigger Property Changes
                this.stackableTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _stackableChanged: function (change)
                {
                    if (change.currentValue)
                        this.addCssClass("stackable");
                    else
                        this.removeCssClass("stackable");
                }

                // Public Methods
            };
        }
    });

    // Card
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "Card",
        inherits: "Control",
        properties: [
            { name: "buttons", type: "array" },
            { name: "iconClass", type: "string" },
            { name: "imageUrl", type: "string" },
            { name: "subTitle", type: "string" },
            { name: "title", type: "string" }
        ],
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-card card");

                // Trigger Property Changes
                this.buttonsTriggerChange();
                this.iconClassTriggerChange();
                this.imageUrlTriggerChange();
                this.subTitleTriggerChange();
                this.titleTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _buttonsChanged: function (change)
                {
                    var
                        self = this;

                    self.$$buttonContainer.children().detach();
                    self.$$extraContent.hide();

                    if (!change.currentValue || !change.currentValue.length || change.currentValue.length === 0)
                    {
                        self.$$extraContent.hide();
                        return;
                    }

                    change.currentValue
                        .forEach(button => { button.appendTo(self.$$buttonContainer); });

                    self.$$extraContent.show();
                },
                _createElement: function ()
                {
                    this.super._createElement();

                    var
                        $$element = this.$$elementGet();

                    this.$$content = $$.create$$({ nodeName: "span", attributes: { "class": "content" } }).appendTo($$element);
                    this.$$iconContainer = $$.create$$({ nodeName: "span" }).appendTo(this.$$content);
                    this.$$image =
                        $$.create$$({
                            nodeName: "i",
                            attributes: { "class": "right floated mini ui image" },
                            children: [{nodeName: "span"}]
                        }).hide().appendTo(this.$$content);
                    this.$$title = $$.create$$({ nodeName: "span", attributes: { "class": "header" } }).appendTo(this.$$content);
                    this.$$subTitle = $$.create$$({ nodeName: "span", attributes: { "class": "meta" } }).appendTo(this.$$content);
                    this.$$description = $$.create$$({ nodeName: "span", attributes: { "class": "description" } }).appendTo(this.$$content);
                    this.$$extraContent = $$.create$$({ nodeName: "span", attributes: { "class": "extra content" } }).hide().appendTo($$element);
                    this.$$buttonContainer = $$.create$$({ nodeName: "span", attributes: { "class": "ui five buttons" } }).appendTo(this.$$extraContent);
                },
                _iconClassChanged: function (change)
                {
                    if (change.originalValue)
                        this.$$image.removeClass(change.originalValue).hide();

                    if (change.currentValue)
                        this.$$image.addClass(change.currentValue).show();
                },
                _subTitleChanged: function (change)
                {
                    this.$$subTitle.text(change.currentValue);
                },
                _textChanged: function (change)
                {
                    this.super._textChanged(change);
                    this.$$description.text(change.currentValue);
                },
                _titleChanged: function (change)
                {
                    this.$$title.text(change.currentValue);
                },

                // Public Methods
                removeAsync: function ()
                {
                    var
                        $$element = this.$$elementGet();

                    return (
                        $$element.stop()
                            .animate(
                                {
                                    opacity: 0
                                },
                                200
                            )
                            .promise()
                            .then(() =>
                            {
                                return $$element.animate({ height: 0, marginTop: 0, marginBottom: 0 }).promise();
                            })
                            .then(() =>
                            {
                                $$element.remove();
                            })
                    );
                }

                // Event Handlers
            };
        }
    });

    // Carousel TODO: Complete
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "Carousel",
        inherits: "ContainerControl",
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-carousel");

                this._updateLayoutTimeoutId = 0;
                this._currentSlide = -1;
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _appendOrPrepend: function (...args)
                {
                    var
                        self = this;

                    this._queueUpdateLayout();

                    return self.super._appendOrPrepend.apply(this.super, args);
                },
                _bindEvents: function ()
                {
                    this.super._bindEvents();

                    $$(window).on("resize", { self: this }, this.onWindowResize);
                    this.$$buttonArrowLeft.on("click", { self: this }, this.onButtonArrowLeftClicked);
                    this.$$buttonArrowRight.on("click", { self: this }, this.onButtonArrowRightClicked);
                },
                _createChildControls: function ()
                {
                    this.super._createChildControls();
                    this._updateLayout();
                },
                _createContainerElement: function ()
                {
                    var
                        $$element = this.$$elementGet(),
                        $$viewport = $$element.find(">.rad-viewport"),
                        $$containerElement = $$element.find(">.rad-control-container");

                    if (!$$viewport.length)
                        $$viewport = $$.create$$({ nodeName: "div", attributes: { "class": "rad-viewport" } }).appendTo($$element);

                    if (!$$containerElement.length)
                        $$containerElement = $$viewport.find(">.rad-control-container");

                    if (!$$containerElement.length)
                        $$containerElement = $$.create$$({ nodeName: "div", attributes: { "class": "rad-control-container" } });

                    $$containerElement.appendTo($$viewport);

                    // Controls
                    this.$$buttonArrowLeft =
                        $$.create$$({
                            nodeName: "button",
                            attributes: { "class": "rad-arrow rad-action-previous" },
                            children: [{ nodeName: "i", attributes: { "class": "icon angle left" } }]
                        }).appendTo($$viewport);

                    this.$$buttonArrowRight =
                        $$.create$$({
                            nodeName: "button",
                            attributes: { "class": "rad-arrow rad-action-next" },
                            children: [{ nodeName: "i", attributes: { "class": "icon angle right" } }]
                        }).appendTo($$viewport);

                    // Dots
                    this.$$dotContainer =
                        $$.create$$({ nodeName: "ul", attributes: { "class": "rad-dot-container" } })
                            .appendTo($$element);

                    this.$$viewport = $$viewport;
                    this.$$containerElementSet($$containerElement);
                },
                _dispose: function ()
                {
                    $$(window).off("resize", this.onWindowResize);
                    this.$$buttonArrowLeft.off("click", this.onButtonArrowLeftClicked);
                    this.$$buttonArrowRight.off("click", this.onButtonArrowRightClicked);

                    var
                        page = this.pageGet();

                    if (page)
                        page.off("shown", { self: this }, this.onPageShown);

                    this.super._dispose();
                },
                _pageChanged: function (change)
                {
                    this.super._pageChanged(change);

                    if (change.originalValue)
                        change.originalValue.off("shown", { self: this }, this.onPageShown);

                    if (change.currentValue)
                        change.currentValue.on("shown", { self: this }, this.onPageShown);
                },
                _queueUpdateLayout: function ()
                {
                    var
                        self = this;

                    if (!self._isShown())
                        return;

                    if (self._updateLayoutTimeoutId)
                    {
                        clearTimeout(self._updateLayoutTimeoutId);
                        self._updateLayoutTimeoutId = 0;
                    }

                    self._updateLayoutTimeoutId = setTimeout(() => { self._updateLayout(); });
                },
                _updateLayout: function ()
                {
                    var
                        self = this,
                        $$element = self.$$elementGet(),
                        $$containerElement = self.$$containerElementGet();

                    $$containerElement.find(">.rad-clone").remove();

                    self.heightSet(null);

                    var
                        controls = self.controlsGet(),
                        maxHeight = controls.select((item, index) => { return item.$$elementGet().outerHeight(); }).max();

                    maxHeight = maxHeight ? maxHeight : 200;

                    // Set height
                    self.$$viewport.height(maxHeight);
                    controls.each((item, index) => { item.heightSet(maxHeight); });

                    // Clone end slides
                    if (controls.length)
                    {
                        $$containerElement.append(controls.first().$$elementGet().clone().addClass("rad-clone"));
                        $$containerElement.prepend(controls.last().$$elementGet().clone().addClass("rad-clone"));
                    }

                    // Rebuild dots
                    self.$$dotContainer.empty();

                    controls.each((item, index) =>
                    {
                        self.$$dotContainer.append("<li><button class=\"rad-dot\"><i class=\"icon circle\"></i></button></li>");
                    });

                    $$containerElement.css({ "width": "100%" });
                    //alert(controls.length * $$element.outerWidth());

                    $$containerElement.css({ "width": controls.length * $$element.outerWidth() });

                    if (controls.length > self._currentSlide)
                        self.setCurrentSlide(controls.length);
                    
                    if (controls.length && self._currentSlide === -1)
                        self.setCurrentSlide(0);
                },

                // Public Methods
                next: function ()
                {
                    this.setCurrentSlide(this._currentSlide + 1);
                },
                previous: function ()
                {
                    this.setCurrentSlide(this._currentSlide - 1);
                },
                setCurrentSlide: function (index)
                {
                    var
                        $$element = this.$$elementGet(),
                        controls = this.controlsGet();

                    if (index < 0)
                        index = 0;

                    if (index >= controls.length)
                        index = controls.length - 1;

                    var
                        x = (index + 0) * $$element.outerWidth();

                    this.$$containerElementGet().css({ "transform": "translateX(-" + x + "px)" });
                    this._currentSlide = index;
                },

                // Event Handlers
                onAncestorVisibilityChanged: function (evt, change)
                {
                    if (change.currentValue)
                        evt.data.self._queueUpdateLayout();
                },
                onButtonArrowLeftClicked: function (evt)
                {
                    evt.data.self.previous();
                },
                onButtonArrowRightClicked: function (evt)
                {
                    evt.data.self.next();
                },
                onWindowResize: function (evt)
                {
                    evt.data.self._queueUpdateLayout();
                },
                onPageShown: function (evt)
                {
                    evt.data.self._updateLayout();
                }
            };
        }
    });

    // #region Charts

    // Chart
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "Chart",
        inherits: "Control",
        properties: [
            { name: "chartType", type: "string" },
            { name: "colorScheme", type: "string" },
            { name: "options" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                chartType: namespace.Chart.chartType.line,
                colorScheme: "brewer.SetOne3",
                options: {}
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-chart");

                // Trigger Property Changes
                this.chartTypeTriggerChange();
                this.colorSchemeTriggerChange();
                this.optionsTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _chartTypeChanged: function (change)
                {
                    this._queueInitializeChart();
                },
                _colorSchemeChanged: function (change)
                {
                    this._queueInitializeChart();
                },
                _createElement: function ()
                {
                    this.super._createElement();

                    var
                        $$element = this.$$elementGet();

                    this.$$canvasHolder = $$.create$$({ nodeName: "div" })
                        .appendTo($$element);

                    this.$$canvas = $$.create$$({ nodeName: "canvas" })
                        .appendTo(this.$$canvasHolder);

                    this.chartContext = this.$$canvas[0].getContext("2d");
                },
                _dataSourceChanged: function (change)
                {
                    this.super._dataSourceChanged(change);
                    this._updateChartData();
                },
                _initializeChart: function ()
                {
                    var
                        defaultOptions = {
                            aspectRatio: 2,
                            responsive: true,
                            plugins: {
                                colorschemes: {
                                    scheme: this.colorSchemeGet()
                                },
                                legend: {
                                    position: "bottom"
                                },
                                //tooltip: {
                                //    callbacks: {
                                //        label: function (args)
                                //        {
                                //            const
                                //                dataSetLabel = args.dataset?.label ?? String.empty,
                                //                dataLabel = args.label ?? String.empty;

                                //            return `${dataSetLabel}${(dataSetLabel && dataLabel ? " - " : String.empty)}${dataLabel}: ${args.formattedValue}`;
                                //        }
                                //    }
                                //}
                            }
                        };

                    var
                        combinedOptions = Object.extend(true, {}, defaultOptions, this.optionsGet());

                    //if (chartOptions.type === namespace.Chart.chartType.barStacked)
                    //{
                    //    chartOptions.type = "bar";
                    //    chartOptions.options.scales = {
                    //        xAxes: [{
                    //            barPercentage: 0.4,
                    //            stacked: true,
                    //            ticks: {
                    //                min: 0
                    //            }
                    //        }],
                    //        yAxes: [{
                    //            barPercentage: 0.4,
                    //            stacked: true,
                    //            ticks: {
                    //                min: 0
                    //            }
                    //        }]
                    //    };
                    //}

                    if (this.chart)
                        this.chart.destroy();

                    var
                        chartConfiguration = {
                            type: this.chartTypeGet(),
                            options: combinedOptions
                        };

                    this.chart = new Chart(this.chartContext, chartConfiguration);
                    this._updateChartData();
                },
                _optionsChanged: function (change)
                {
                    this._queueInitializeChart();
                },
                _queueInitializeChart: function ()
                {
                    var
                        self = this;

                    if (self._queueInitializeChartTimeoutId)
                        return;

                    self._queueInitializeChartTimeoutId = setTimeout(() => { self._queueInitializeChartTimeoutId = 0; self._initializeChart(); });
                },
                _updateChartData: function ()
                {
                    var
                        self = this;

                    if (!self.chart)
                        return;

                    var
                        data = this.dataSourceGet()?.dataGet() || null;

                    if (data === null)
                    {
                        while (self.chart.data.labels.length)
                            self.chart.data.labels.pop();

                        while (self.chart.data.datasets.length)
                            self.chart.data.datasets.pop();

                        return;
                    }

                    // Labels
                    while (self.chart.data.labels.length > data.labels.length)
                        self.chart.data.labels.pop();

                    data.labels.each((item, index) =>
                    {
                        if (index >= self.chart.data.labels.length)
                            self.chart.data.labels.push(item);
                        else
                            self.chart.data.labels[index] = item;
                    });

                    // Data Sets
                    while (self.chart.data.datasets.length > data.datasets.length)
                        self.chart.data.datasets.pop();

                    data.datasets.each((item, index) =>
                    {
                        if (index >= self.chart.data.datasets.length)
                            self.chart.data.datasets.push(item);
                        else
                        {
                            self.chart.data.datasets[index].label = item.label;

                            // Data
                            while (self.chart.data.datasets[index].data.length > item.data.length)
                                self.chart.data.datasets[index].data.pop();

                            item.data
                                .each((item2, index2) =>
                                {
                                    if (index2 >= self.chart.data.datasets[index].data.length)
                                        self.chart.data.datasets[index].data.push(item2);
                                    else
                                        self.chart.data.datasets[index].data[index2] = item2;
                                });

                            // Background Color
                            if (objectHelper.typeOf(item.backgroundColor) === "array")
                            {
                                while (self.chart.data.datasets[index].backgroundColor.length > item.backgroundColor.length)
                                    self.chart.data.datasets[index].backgroundColor.pop();

                                item.backgroundColor.each((item2, index2) =>
                                {
                                    if (index2 >= self.chart.data.datasets[index].backgroundColor.length)
                                        self.chart.data.datasets[index].backgroundColor.push(item2);
                                    else
                                        self.chart.data.datasets[index].backgroundColor[index2] = item2;
                                });
                            }
                        }
                    });

                    self.chart.update();
                },

                // Event Handlers
                onPageActivated: function (evt)
                {
                    evt.data.self._queueInitializeChart();
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.chartType =
            {
                bar: "bar",
                barStacked: "barStacked",
                doughnut: "doughnut",
                line: "line",
                pie: "pie",
                polarArea: "polarArea",
                radar: "radar"
            };

            Chart.defaults.defaultFontSize = 10;
            Chart.register({
                id: "centerText",
                beforeDraw: function (chart)
                {
                    if (chart.options.centerText)
                    {
                        const
                            width = chart.width,
                            height = chart.height,
                            ctx = chart.ctx;

                        ctx.restore();

                        const
                            fontSize = (height / 80).toFixed(2);

                        ctx.font = fontSize + "em sans-serif";
                        ctx.textBaseline = "middle";

                        //var legendHeight = chart.legend.height;

                        const
                            text = chart.options.centerText,
                            textX = Math.round((width - ctx.measureText(text).width) / 2),
                            textY = height / 2 - (chart.titleBlock.height ? chart.titleBlock.height - 15 : 0);

                        ctx.fillText(text, textX, textY);
                        ctx.save();
                    }
                }
            });
            Chart.register({
                id: "showCount",
                beforeDraw: function (chart)
                {
                    if (chart.options.showCount)
                    {
                        const
                            { chartArea, ctx } = chart;

                        ctx.restore();

                        const
                            fontSize = (chartArea.height / 80).toFixed(2);

                        ctx.font = fontSize + "em sans-serif";
                        ctx.textBaseline = "middle";

                        //var legendHeight = chart.legend.height;

                        const
                            count =
                                chart.data.datasets
                                    .map(item => item.data)
                                    .reduce((a, b) => a.concat(b), [])
                                    .reduce((a, b) => a + b, 0)
                        const
                            text = Number.toStringAbbreviated(count, 0),
                            textX = Math.round(chartArea.left + (chartArea.width - ctx.measureText(text).width) / 2),
                            textY = chartArea.top + (chartArea.height / 2);

                        ctx.fillText(text, textX, textY);
                        ctx.save();
                    }
                }
            });
            Chart.register({
                id: "doughnutBackground",
                beforeDatasetsDraw: chart =>
                {
                    if (chart.options.doughnutBackground)
                    {
                        if (!chart.data.datasets?.length)
                            return;

                        const
                            { chartArea, ctx } = chart,
                            innerRadius = chart.getDatasetMeta(chart.data.datasets.length - 1).controller.innerRadius,
                            outerRadius = chart.getDatasetMeta(0).controller.outerRadius,
                            radiusLength = outerRadius - innerRadius;

                        if (chart.options.doughnutBackground.enabled)
                        {
                            const
                                x = chartArea.left + (chartArea.width / 2),
                                y = chartArea.top + (chartArea.height / 2);

                            ctx.beginPath();
                            ctx.arc(x, y, outerRadius - radiusLength / 2, 0, 2 * Math.PI);
                            ctx.lineWidth = radiusLength;
                            ctx.strokeStyle = chart.options.doughnutBackground.color || "#f0f0f0";
                            ctx.stroke();
                        }
                    }
                }
            });

            Chart.Tooltip.positioners.mouse = function (elements, eventPosition)
            {
                return {
                    x: eventPosition.x,
                    y: eventPosition.y
                };
            };
        }
    });

    // Progress Bar Chart
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "ProgressBarChart",
        inherits: "Control",
        properties: [
            { name: "value", type: "float" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                value: 0
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-chart-progress-bar");

                // Trigger Property Changes
                this.valueTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _createElement: function ()
                {
                    this.super._createElement();

                    var
                        $$element = this.$$elementGet();

                    this.$$track =
                        $$("<div class=\"rad-track\"></div>")
                            .appendTo($$element);

                    this.$$bar =
                        $$("<div class=\"rad-bar\"></div>")
                            .appendTo(this.$$track);

                    this._updateLayout();
                },
                _updateLayout: function ()
                {
                    var
                        value = this.valueGet();

                    this.$$bar.css("width", String.format("{0}%", value));

                    if (Math.round(value) >= 100)
                        this.addCssClass("rad-style-full");
                    else
                        this.removeCssClass("rad-style-full");
                },
                _valueChanged: function (change)
                {
                    this._updateLayout();
                },

                // Public Methods
                valueSet: function (value)
                {
                    this._valueSet(Math.clamp(value || 0, 0, 100));
                },

                // Event Handlers
                onPageActivated: function (evt, eventData)
                {
                    evt.data.self._updateLayout();
                }
            };
        }
    });

    // Ring Chart
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "RingChart",
        inherits: "Control",
        properties: [
            { name: "ringScale", type: "int" },
            { name: "value", type: "float" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                ringScale: 40,
                value: 0
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-chart-ring");

                // Trigger Property Changes
                this.valueTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _calculateCircumference: function ()
                {
                    return this.$$elementGet().outerWidth() * this.ringScaleGet() / 100 * 2 * Math.PI;
                },
                _createElement: function ()
                {
                    this.super._createElement();

                    var
                        $$element = this.$$elementGet(),
                        ringScale = this.ringScaleGet();

                    this.$$background =
                        $$(String.format("<svg xmlns=\"http://www.w3.org/2000/svg\" class=\"rad-background\"><circle class=\"circle\" r=\"{0}%\" cx=\"50%\" cy=\"50%\"/></svg>", ringScale))
                            .appendTo($$element);

                    this.$$ring =
                        $$(String.format("<svg xmlns=\"http://www.w3.org/2000/svg\" class=\"rad-ring\"><circle class=\"circle\" r=\"{0}%\" cx=\"50%\" cy=\"50%\"/></svg>", ringScale))
                            .appendTo($$element);

                    this.ringCircleElement = this.$$ring.find(">circle")[0];

                    this.$$ringOverlay =
                        $$(String.format("<svg xmlns=\"http://www.w3.org/2000/svg\" class=\"rad-ring-overlay\"><circle class=\"circle\" r=\"{0}%\" cx=\"50%\" cy=\"50%\"/></svg>", ringScale))
                            .appendTo($$element);

                    this.ringOverlayCircleElement = this.$$ringOverlay.find(">circle")[0];

                    this.$$text =
                        $$("<span class=\"rad-text\"></span>")
                            .appendTo($$element);

                    this._updateLayout();
                },
                _updateLayout: function (retry)
                {
                    const
                        circumference = this._calculateCircumference();

                    if (circumference === 0)
                    {
                        this.ringCircleElement.style.stroke = "none";

                        if (!retry)
                            setTimeout(() => this._updateLayout(true), 500);

                        return;
                    }

                    const
                        value = this.valueGet();

                    this.ringCircleElement.style.strokeDasharray = String.format("{0}px {0}px", circumference);
                    this.ringCircleElement.style.strokeDashoffset = String.format("{0}px", circumference - value / 100 * circumference);
                    this.ringCircleElement.style.stroke = String.empty;
                    this.ringOverlayCircleElement.style.strokeDasharray = String.format("1px {0}px", (circumference - 4) / 4);
                    this.$$text.text(String.format("{0}%", Math.round(value)));

                    if (Math.round(value) >= 100)
                        this.addCssClass("rad-style-full");
                    else
                        this.removeCssClass("rad-style-full");
                },
                _valueChanged: function (change)
                {
                    this._updateLayout();
                },

                // Public Methods
                valueSet: function (value)
                {
                    this._valueSet(Math.clamp(value || 0, 0, 100));
                },

                // Event Handlers
                onAncestorVisibilityChanged: function (evt, change)
                {
                    if (change.currentValue)
                        evt.data.self._updateLayout();
                },
                onPageActivated: function (evt, eventData)
                {
                    evt.data.self._updateLayout();
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            $$(window).on("resize", () =>
            {
                $$(".rad-control-chart-ring").each((index, element) =>
                {
                    var
                        ring = $$.radControl(element);

                    if (ring)
                        ring._updateLayout();
                });
            });
        }
    });

    // #endregion

    // Image
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "Image",
        inherits: "Control",
        properties: [
            { name: "alt", type: "string" },
            { name: "resizeToFit", type: "boolean" },
            { name: "src", type: "string" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                elementType: "img",
                resizeToFit: false
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                // Trigger Property Changes
                this.altTriggerChange();
                this.resizeToFitTriggerChange();
                this.srcTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _altChanged: function (change)
                {
                    this.$$elementGet().attr("alt", change.currentValue);
                },
                _fixSrc: function (src)
                {
                    return (
                        src?.startsWith("/")
                            ? window.applicationInformation.virtualDirectory + src.substr(1)
                            : src
                    );
                },
                _resizeToFit: function ()
                {
                    var
                        $$element = this.$$elementGet(),
                        $$parentElement = $$element.parent(),
                        parentElementHeight = $$parentElement.outerHeight(),
                        parentElementWidth = $$parentElement.outerWidth(),
                        ratio;

                    if (parentElementHeight && parentElementWidth)
                    {
                        var
                            elementAspectRatio = parentElementWidth / parentElementHeight,
                            imageAspectRatio = $$element[0].naturalWidth / $$element[0].naturalHeight;

                        if (imageAspectRatio === elementAspectRatio)
                        {
                            $$element.css({
                                height: String.empty,
                                left: String.empty,
                                top: String.empty,
                                width: String.empty
                            });
                        }
                        else if (imageAspectRatio > elementAspectRatio)
                        {
                            ratio = parentElementHeight * imageAspectRatio / parentElementWidth;

                            $$element.css({
                                height: String.empty,
                                left: String.format("{0}%", (1 - ratio) / 2 * 100),
                                top: String.empty,
                                width: String.format("{0}%", ratio * 100)
                            });
                        }
                        else
                        {
                            ratio = parentElementWidth / imageAspectRatio / parentElementHeight;

                            $$element.css({
                                height: String.format("{0}%", ratio * 100),
                                left: String.empty,
                                top: String.format("{0}%", (1 - ratio) / 2 * 100),
                                width: String.empty
                            });
                        }
                    }
                },
                _resizeToFitChanged: function (change)
                {
                    if (change.currentValue)
                        $$(window).on("resize", { self: this }, this.onWindowResize);
                    else
                        $$(window).off("resize", this.onWindowResize);
                },
                _srcChanged: function (change)
                {
                    this.$$elementGet().attr("src", change.currentValue);
                },

                // Public Methods
                setSrcAsync: function (value)
                {
                    const
                        $$element = this.$$elementGet(),
                        src = this._fixSrc(value);

                    return new Promise((resolve, reject) =>
                    {
                        if ($$element[0].src === src)
                            resolve();
                        else
                        {
                            $$element[0].onload = () =>
                            {
                                if (this.resizeToFitGet())
                                    this._resizeToFit();

                                resolve();
                            };

                            $$element[0].onerror = error =>
                            {
                                reject(error);
                            };

                            this._srcSet(src);
                        }
                    });
                },
                srcSet: function (value)
                {
                    const
                        $$element = this.$$elementGet(),
                        src = this._fixSrc(value);

                    $$element[0].onload = () =>
                    {
                        if (this.resizeToFitGet())
                            this._resizeToFit();
                    };

                    this._srcSet(src);
                },

                // Event Handlers
                onWindowResize: function (evt)
                {
                    evt.data.self._resizeToFit();
                }
            };
        }
    });

    // Label
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "Label",
        inherits: "Control",
        properties: [
            { name: "associatedControlId", type: "string" },
            { name: "associatedControl" },
            { name: "colon", type: "boolean" }
        ],
        propertyAttributes: [
            {
                propertyName: "associatedControlId",
                designer: {
                    category: "Behavior",
                    displayName: "Associated Control Id"
                }
            },
            {
                propertyName: "associatedControl",
                designer: {
                    category: "Behavior",
                    displayName: "Associated Control"
                }
            },
            {
                propertyName: "colon",
                designer: {
                    category: "Appearance",
                    displayName: "Colon"
                }
            }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                elementType: "label",
                colon: true,
                text: "Label"
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                var
                    self = this,
                    _associatedControlId = self.associatedControlIdGet(),
                    _associatedControl = self.associatedControlGet();

                self.addCssClass("rad-control-label field");
               
                if (_associatedControl)
                    this.$$elementGet().attr("for", _associatedControl.labelTargetId);
                else if (_associatedControlId)
                {
                    var
                        $$associatedControl = $$("#" + _associatedControlId);

                    if ($$associatedControl.length)
                    {
                        setTimeout(() =>
                        {
                            self.associatedControlSet($$associatedControl.radControl());
                        });
                    }
                }

                // Trigger Property Changes
                this.colonTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _associatedControlChanged: function (change)
                {
                    if (change.currentValue?.labelTargetId)
                        this.$$elementGet().attr("for", change.currentValue.labelTargetId);
                },
                _colonChanged: function (change)
                {
                    this._updateLayout();
                },
                _createElement: function ()
                {
                    this.super._createElement();

                    var
                        $$element = this.$$elementGet();

                    $$element.append($$.create$$({ nodeName: "span" }));
                    $$element.append($$.createNbsp());
                    $$element.append($$.create$$({ nodeName: "span", attributes: { "class": "rad-asterisk" }, text: "*" }));
                },
                _textChanged: function (change)
                {
                    this.super._textChanged(change);
                    this._updateLayout();
                },
                _updateLayout: function ()
                {
                    var
                        $$element = this.$$elementGet(),
                        text = this.textGet();

                    $$element.attr("title", text);
                    $$element.find(">span").first().text(text + (this.colonGet() ? ":" : String.empty));
                },

                // Event Handlers
                onClick: function (evt)
                {
                    /* Check the type of the associated control's element to see if it's labelable in the spec:
                        see https://www.w3.org/TR/html5/forms.html#category-label */
                    
                    var
                        self = evt.data.self;

                    if (!self.associatedControlGet())
                        return;

                    var labelTarget = $$("#" + self.associatedControlGet().labelTargetId);
                        
                    if (!labelTarget)
                        return;

                    var
                        nodeName = labelTarget.prop("nodeName");

                    if (!nodeName)
                        return;

                    var
                        labelTargetType = nodeName.toLowerCase();

                    // On NON labelable element, trigger a focus. edge case = element type is an input with type=hidden, or switches
                    if (labelTarget.hasClass("rad-control-switch"))
                    {
                        labelTarget.find(">input").trigger("focus");
                        evt.preventDefault();
                    }
                    else if (labelTargetType === "input" && labelTarget.attr("type") === "hidden" || !namespace.Label.labelableElementTypes.contains(labelTargetType))
                    {
                        labelTarget.trigger("focus");
                        evt.preventDefault();
                    }
                }
            };
        },
        classCreated: function(namespace, classConstructor)
        {
            classConstructor.labelableElementTypes = ["button", "input", "keygen", "meter", "output", "progress", "select", "textarea"];
        }
    });

    // Labelled Control
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "LabelledControl",
        inherits: "Control",
        properties: [
            { name: "control" },
            { name: "controlProperties" },
            { name: "labelText", type: "string" }
        ],
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-labelled-control");

                // Trigger Property Changes
                this.labelTextTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _createElement: function ()
                {
                    this.super._createElement();

                    var
                        $$element = this.$$elementGet();

                    var
                        control = this.controlGet();

                    if (!control)
                    {
                        var
                            $$childElement = $$element.children().first();

                        if ($$childElement.length)
                        {
                            control = namespace.Control.createFromElement($$childElement);
                            this.controlSet(control);
                        }
                    }

                    if (!control)
                        console.error("Control is mandatory.");

                    var
                        controlProperties = this.controlPropertiesGet();

                    if (controlProperties)
                        control.setProperties(controlProperties);

                    this.labelControl = new namespace.Label({ associatedControl: control, colon: true });
                    this.labelControl.appendTo($$element);
                    this.$$controlContainer = $$.create$$({ nodeName: "div", attributes: { "class": "rad-control-container" } }).appendTo($$element);
                    $$.create$$({ nodeName: "div", attributes: { "class": "rad-clear-float" } }).appendTo($$element);

                    control.appendTo(this.$$controlContainer);
                },
                _controlChanged: function (change)
                {
                    if (!this.labelControl)
                        this.labelControl = new namespace.Label({ associatedControl: change.currentValue, colon: true });
                    else
                        this.labelControl.associatedControlSet(change.currentValue);
                },
                _labelTextChanged: function (change)
                {
                    this.labelControl.textSet(change.currentValue);
                }

                // Public Methods

                // Event Handlers
            };
        }
    });

    // Lazy Data Table
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "LazyDataTable",
        inherits: "Control",
        properties: [
            { name: "$$defaultSortColumn" },
            { name: "$$sortColumn" },
            { name: "additionalDataServiceParameters", type: "object" },
            { name: "columns", type: "array" },
            { name: "dataServiceId", type: "string" },
            { name: "dataServiceOperation", type: "string" },
            { name: "selectedRows" },
            { name: "sortDescending", type: "boolean" },
            { name: "stackable", type: "boolean" },
            { name: "topN", type: "int" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                sortDescending: false
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-lazy-data-table");

                // Trigger Property Changes
                this.columnsTriggerChange();
                this.stackableTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _addCellContents: function ($$cell, column, dataSource)
                {
                    if (column.addCellContents)
                    {
                        column.addCellContents.apply(this, arguments);
                        return;
                    }

                    if (column.cssClass?.contains("rad-column-select"))
                    {
                        var
                            checkbox =
                                new namespace.CheckBox({ type: namespace.CheckBox.type.checkBox, value: this.headerRowCheckBox.valueGet()})
                                    .appendTo($$cell);

                        checkbox.on("valueChanged", { self: this }, this.onTableRowSelectCheckBoxValueChanged);

                        if (column.dataSourceProperty && !Object.isNullOrUndefined(dataSource[column.dataSourceProperty]))
                            checkbox.$$elementGet()?.data(dataSource[column.dataSourceProperty]);

                        return;
                    }

                    if (!column.dataSourceProperty)
                        return;

                    let
                        value = dataSource[column.dataSourceProperty];

                    if (Object.isNullOrUndefined(value))
                        return;

                    const
                        dataDateFormatString = "yyyy-MM-ddTHH:mm:ss.fffffffZ",
                        valueType = window.objectHelper.typeOf(value);

                    let
                        stringForDisplay = null;

                    if (valueType !== undefined && valueType !== null)
                    {
                        switch (valueType)
                        {
                            case "boolean":
                                {
                                    stringForDisplay = value ? "Yes" : "No";
                                    break;
                                }
                            case "date":
                                {
                                    stringForDisplay = value.toString(column.formatString ? column.formatString : "dd/MM/yyyy HH:mm:ss");
                                    break;
                                }
                            case "number":
                                {
                                    stringForDisplay = column.formatString ? value.toStringFormat(column.formatString) : value.toString();
                                    break;
                                }
                            case "string":
                                {
                                    if (value.isDate && value.isDate(dataDateFormatString))
                                        stringForDisplay = Date.fromString(value, dataDateFormatString).toString(column.formatString ? column.formatString : "dd/MM/yyyy HH:mm:ss");
                                    else
                                        stringForDisplay = value.toString();
                                    break;
                                }
                            default:
                                {
                                    stringForDisplay = value.toString();
                                    break;
                                }
                        }
                    }

                    $$.create$$({ nodeName: "span" })
                        .appendTo($$cell)
                        .text(stringForDisplay);
                },
                _bindEvents: function ()
                {
                    this.super._bindEvents();

                    this.$$thead.on("click", ">tr>th,>tr>td", { self: this }, this.onTableColumnHeaderClicked);
                },
                _createElement: function ()
                {
                    this.super._createElement();

                    var
                        $$element = this.$$elementGet();

                    this.$$table =
                        $$.create$$({ nodeName: "table" })
                            .appendTo($$element);

                    this.$$thead =
                        $$.create$$({ nodeName: "thead" })
                            .appendTo(this.$$table);

                    this.$$tbody =
                        $$.create$$({ nodeName: "tbody" })
                            .appendTo(this.$$table);

                    this.panelNoResults
                        = new namespace.Panel({ cssClass: "rad-panel-no-results" })
                            .appendTo($$element);

                    this.$$pNoResultsText
                        = $$.create$$({ nodeName: "p", text: "No Records" })
                            .appendTo(this.panelNoResults.$$elementGet());
                },
                _columnsChanged: function (change)
                {
                    var
                        self = this,
                        $$row,
                        $$cell,
                        $$i,
                        $$defaultSortColumn;

                    self.headerRowCheckBox = null;
                    self.$$thead.empty();
                    self.clearData();

                    if (change.currentValue && Array.isArray(change.currentValue))
                    {
                        $$row =
                            $$.create$$({ nodeName: "tr" })
                                .appendTo(self.$$thead);

                        change.currentValue
                            .each(item =>
                            {
                                var
                                    isSelectColumn = item.cssClass?.contains("rad-column-select");

                                if (isSelectColumn && self.headerRowCheckBox)
                                    return;

                                $$cell =
                                    $$.create$$({ nodeName: "th" })
                                        .appendTo($$row);

                                $$.data($$cell[0], item);

                                if (isSelectColumn)
                                {
                                    self.headerRowCheckBox =
                                        new namespace.CheckBox({ type: namespace.CheckBox.type.checkBox })
                                            .appendTo($$cell);

                                    self.headerRowCheckBox.on("valueChanged", { self: self }, self.onTableColumnHeaderSelectCheckBoxValueChanged);
                                }
                                else
                                {
                                    $$.create$$({ nodeName: "span", text: item.name })
                                        .appendTo($$cell);
                                }

                                $$i =
                                    $$.create$$({
                                        nodeName: "i",
                                        attributes: {
                                            "class": "rad-icon rad-icon-ascending"
                                        }
                                    }).appendTo($$cell);

                                $$i.append(svgHelper.createSvg("icon-chevron-up"));

                                $$i =
                                    $$.create$$({
                                        nodeName: "i",
                                        attributes: {
                                            "class": "rad-icon rad-icon-descending"
                                        }
                                    }).appendTo($$cell);

                                $$i.append(svgHelper.createSvg("icon-chevron-down"));

                                if (item.cssClass)
                                    $$cell.addClass(item.cssClass);

                                if (item.sortable && !isSelectColumn)
                                {
                                    $$cell.addClass("rad-feature-sortable");

                                    if (!$$defaultSortColumn || item.defaultSort === true)
                                        $$defaultSortColumn = $$cell;
                                }

                                if (item.dataSourceProperty)
                                    $$cell.addClass(String.format("rad-column-{0}", item.dataSourceProperty.toDashed()));
                            });
                    }

                    self.$$defaultSortColumnSet($$defaultSortColumn);
                    self.$$sortColumnSet($$defaultSortColumn);
                    self.sortDescendingSet(false);
                },
                _extend: function (data)
                {
                    if (!data || !data.results || !Array.isArray(data.results[0]))
                        return;

                    const
                        self = this;

                    data.results[0]
                        .each(item =>
                        {
                            const
                                $$row =
                                    $$.create$$({ nodeName: "tr" })
                                        .appendTo(self.$$tbody);

                            self._updateRow($$row, item);
                            self.lastId = item.id;
                        });

                    self._updateDisplay();
                },
                _handleSelectHeaderClick: function ()
                {
                    if (!this.headerRowCheckBox)
                        return;

                    this._setAllCheckBoxValues(this.headerRowCheckBox.valueGet());
                },
                _loadDataAsync: function (options, showLoading)
                {
                    return (
                        application.webApiClient
                            .createApiMethodRequest("DataService", "CallDataService", { id: this.dataServiceIdGet(), operation: this.dataServiceOperationGet(), data: (options || {}).toJson() }, null, showLoading)
                            .executeAsync()
                    );
                },
                _selectedRowsChanged: function (change)
                {
                    var
                        self = this;

                    if (self.selectedRowsChangedTimeoutId)
                        return;

                    self.selectedRowsChangedTimeoutId = setTimeout(() =>
                    {
                        self.selectedRowsChangedTimeoutId = 0;
                        self.triggerHandler("selectedRowsChanged", change);
                    });
                },
                _setAllCheckBoxValues: function (value)
                {
                    this.updatingRowSelectCheckBox = true;
                    this.$$tbody.find(">tr>td.rad-column-select .rad-control-check-box").each((index, element) =>
                    {
                        $$.radControl(element).valueSet(value);
                    });
                    this.updatingRowSelectCheckBox = false;

                    this._updateSelectedRows();
                },
                _setSortedColumn: function ($$cell)
                {
                    if (!$$cell.hasClass("rad-feature-sortable"))
                        return;

                    var
                        $$sortColumn = this.$$sortColumnGet();

                    if ($$sortColumn.is($$cell))
                        this.sortDescendingSet(!this.sortDescendingGet());
                    else
                    {
                        this.$$sortColumnSet($$cell);
                        this.sortDescendingSet(false);
                    }

                    this.loadDataAsync(true);
                },
                _stackableChanged: function (change)
                {
                    if (change.currentValue)
                        this.addCssClass("rad-feature-stackable");
                    else
                        this.removeCssClass("rad-feature-stackable");
                },
                _updateDisplay: function ()
                {
                    var
                        $$sortColumn = this.$$sortColumnGet(),
                        sortDescending = this.sortDescendingGet(),
                        anyResults = this.getRows().length > 0;

                    this.$$thead.find(">tr>th,>tr>td").each(function (index, element)
                    {
                        var
                            $$this = $$(element);

                        $$this.removeClass("rad-state-sorted rad-state-sorted-ascending rad-state-sorted-descending");

                        if ($$this.is($$sortColumn))
                            $$this.addClass(String.format("rad-state-sorted rad-state-sorted-{0}", sortDescending ? "descending" : "ascending"));
                    });

                    if (anyResults)
                        this.panelNoResults.hide();
                    else
                        this.panelNoResults.show();
                },
                _updateRow: function ($$row, data)
                {
                    var
                        self = this,
                        columns = self.columnsGet(),
                        $$cell;

                    $$row.children().remove();

                    $$.data($$row[0], data);

                    if (data.id)
                        $$row.attr("data-id", data.id);

                    columns
                        .each(column =>
                        {
                            $$cell =
                                $$.create$$({
                                    nodeName: "td",
                                    children: [{
                                        nodeName: "span",
                                        attributes: {
                                            "class": "rad-column-description"
                                        },
                                        text: column.name
                                    }]
                                }).appendTo($$row);

                            $$.data($$cell[0], data);

                            if (column.cssClass)
                                $$cell.addClass(column.cssClass);

                            if (column.dataSourceProperty)
                                $$cell.addClass(String.format("rad-column-{0}", column.dataSourceProperty.toDashed()));

                            self._addCellContents($$cell, column, data);

                            self.triggerHandler("cellCreated", { $$row: $$row, $$cell: $$cell, column: column, data: data });
                        });
                },
                _updateRows: function (data)
                {
                    for (let i = 0; i < data.length; i++)
                        this._updateRow(this.$$tbody.find(`tr[data-id='${data[i].id}']`), data[i]);
                },
                _updateSelectColumnHeaderDisplay: function ()
                {
                    if (!this.headerRowCheckBox)
                        return;

                    var
                        checkBoxes = [];

                    this.$$tbody.find(">tr>td.rad-column-select .rad-control-check-box").each(function (index, element)
                    {
                        checkBoxes.push($$.radControl(element));
                    });

                    var
                        checkBoxesChecked =
                            checkBoxes.where(item => !!item.valueGet());

                    this.updatingHeaderSelectCheckBox = true;
                    this.headerRowCheckBox.valueSet(checkBoxesChecked.length === checkBoxes.length);
                    this.updatingHeaderSelectCheckBox = false;

                    this._updateSelectedRows();
                },
                _updateSelectedRows: function ()
                {
                    var
                        checkBoxes = [];

                    this.$$tbody.find(">tr>td.rad-column-select .rad-control-check-box").each(function (index, element)
                    {
                        checkBoxes.push($$.radControl(element));
                    });

                    var
                        $$selectedRows = $$();

                    checkBoxes
                        .where(item => !!item.valueGet())
                        .each(item => { $$selectedRows = $$selectedRows.add(item.$$elementGet().closest("tr")); });

                    this.selectedRowsSet($$selectedRows);
                },

                // Public Methods
                clearData: function ()
                {
                    this.lastId = null;
                    this.$$tbody.empty();
                    this.selectedRowsSet([]);
                    this.triggerHandler("dataCleared");
                    this.panelNoResults.hide();
                },
                deselectAll: function ()
                {
                    this._setAllCheckBoxValues(false);
                    this._updateSelectColumnHeaderDisplay();
                },
                getRows: function ()
                {
                    return this.$$tbody.find(">tr");
                },
                loadDataAsync: function (reset)
                {
                    var
                        self = this;

                    if (reset)
                        self.lastId = null;

                    var
                        additionalDataServiceParameters = self.additionalDataServiceParametersGet(),
                        topN = self.topNGet(),
                        $$sortColumn = self.$$sortColumnGet(),
                        sortColumnData = $$sortColumn.data() ?? null,
                        orderBy = sortColumnData?.dataSourceProperty ? sortColumnData.dataSourceProperty : null,
                        options = {
                            startAfterId: self.lastId ? self.lastId : null,
                            top: topN,
                            orderBy: orderBy,
                            orderByDescending: self.sortDescendingGet(),
                            searchText: null
                        };

                    if (additionalDataServiceParameters)
                        options = Object.extend(true, {}, options, additionalDataServiceParameters);

                    self.triggerHandler("dataLoading");

                    return (
                        self
                            ._loadDataAsync(options, Object.isNullOrUndefined(self.lastId))
                            .then(data =>
                            {
                                if (!options.startAfterId)
                                    self.clearData();

                                self._extend(data);
                                self.triggerHandler("dataLoaded", data);

                                self._updateSelectColumnHeaderDisplay();

                                return data;
                            })
                    );
                },
                selectAll: function ()
                {
                    this._setAllCheckBoxValues(true);
                    this._updateSelectColumnHeaderDisplay();
                },
                updateAdditionalDataServiceParameters: function (parameters)
                {
                    const
                        additionalDataServiceParameters = this.additionalDataServiceParametersGet() ?? {};

                    this.additionalDataServiceParametersSet($$.extend(true, {}, additionalDataServiceParameters, parameters));
                },

                // Event Handlers
                onTableColumnHeaderClicked: function (evt)
                {
                    evt.data.self._setSortedColumn($$(evt.currentTarget));
                },
                onTableColumnHeaderSelectCheckBoxValueChanged: function (evt)
                {
                    var
                        self = evt.data.self;

                    if (self.updatingHeaderSelectCheckBox)
                        return;

                    self._handleSelectHeaderClick();
                },
                onTableRowSelectCheckBoxValueChanged: function (evt)
                {
                    var
                        self = evt.data.self;

                    if (self.updatingRowSelectCheckBox)
                        return;

                    self._updateSelectColumnHeaderDisplay();
                }
            };
        }
    });

    // Group Box
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "GroupBox",
        inherits: "ContainerControl",
        properties: [
            { name: "headerAlignment", type: "string" }
        ],
        propertyAttributes: [
            {
                propertyName: "headerAlignment",
                designer: {
                    category: "Appearance",
                    displayName: "Header Alignment"
                }
            }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                headerAlignment: "left",
                text: "GroupBox"
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-group-box ui segments");
                this.$$headerElement.addClass("ui segment secondary");
                this.$$containerElementGet().addClass("ui segment");

                this.$$headerElement.css({ textAlign: this.headerAlignmentGet() });
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _createContainerElement: function ()
                {
                    var
                        $$element = this.$$elementGet(),
                        $$containerElement = $$element.find(">.rad-control-container");

                    if (!$$containerElement.length)
                        $$containerElement = $$.create$$({ nodeName: "div", attributes: { "class": "rad-control-container" } }).appendTo($$element);

                    this.$$containerElementSet($$containerElement);
                },
                _createElement: function ()
                {
                    this.super._createElement();

                    var
                        $$element = this.$$elementGet();

                    this.$$headerElement = $$element.find(">.rad-header");
                    if (!this.$$headerElement.length)
                        this.$$headerElement = $$.create$$({ nodeName: "div", attributes: { "class": "rad-header" } }).prependTo($$element);

                    this.$$titleElement = this.$$headerElement.find(">h5");
                    if (!this.$$titleElement.length)
                        this.$$titleElement = $$.create$$({ nodeName: "h5" }).appendTo(this.$$headerElement);
                },
                _getRootElements: function ()
                {
                    return (
                        this.super._getRootElements()
                            .add(this.$$headerElement)
                    );
                },
                _textChanged: function (change)
                {
                    this.super._textChanged(change);
                    this.$$titleElement.text(change.currentValue);
                }
            };
        }
    });

    // Panel
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "Panel",
        inherits: "ContainerControl",
        properties: [
            { name: "style", type: "string" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                style: namespace.Panel.styles.none
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-panel");

                // Trigger Property Changes
                this.styleTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _styleChanged: function (change)
                {
                    var
                        $$element = this.$$elementGet();

                    if (change.currentValue === "bordered")
                        $$element.addClass("rad-style-bordered");
                    else
                        $$element.removeClass("rad-style-bordered");
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.styles = {
                none: "none",
                bordered: "bordered"
            };
        }
    });

    // Form
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "Form",
        inherits: "Panel",
        properties: [
            { name: "autoComplete", type: "string" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                elementType: "form"
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-form");

                // Trigger Property Changes
                this.autoCompleteTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _autoCompleteChanged: function (change)
                {
                    var
                        $$element = this.$$elementGet();

                    if (change.currentValue)
                        $$element.attr("autocomplete", change.currentValue);
                    else
                        $$element.removeAttr("autocomplete");
                }
            };
        },
    });

    // Infinite Scroll Panel
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "InfiniteScrollPanel",
        inherits: "Panel",
        properties: [
            { name: "hasNextResults", type: "boolean" },
            { name: "hasPreviousResults", type: "boolean" },
            { name: "scrollTop", type: "int" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                hasNextResults: true,
                hasPreviousResults: true,
                scrollTop: 0
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-infinite-scroll-panel");

                // Trigger Property Changes
                this.hasNextResultsTriggerChange();
                this.hasPreviousResultsTriggerChange();
                this.scrollTopTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _bindEvents: function ()
                {
                    this.super._bindEvents();

                    this.on("scroll", { self: this }, this.onScroll);
                },
                _createContainerElement: function ()
                {
                    var
                        $$element = this.$$elementGet();

                    this.$$topLoader =
                        $$.create$$({
                            nodeName: "div",
                            attributes: { "class": "rad-loader rad-loader-top" },
                            children: [
                                { nodeName: "div", attributes: { "class": "ui active centered inline loader" } }
                            ]
                        }).appendTo($$element);

                    var
                        $$containerElement = $$.create$$({ nodeName: "div" }).appendTo($$element);

                    this.$$bottomLoader =
                        $$.create$$({
                            nodeName: "div",
                            attributes: { "class": "rad-loader rad-loader-bottom" },
                            children: [
                                { nodeName: "div", attributes: { "class": "ui active centered inline loader" } }
                            ]
                        }).appendTo($$element);

                    this.$$containerElementSet($$containerElement);
                },
                _hasNextResultsChanged: function (change)
                {
                    if (change.currentValue)
                        this.removeCssClass("rad-state-no-next-results");
                    else
                        this.addCssClass("rad-state-no-next-results");
                },
                _hasPreviousResultsChanged: function (change)
                {
                    if (change.currentValue)
                        this.removeCssClass("rad-state-no-previous-results");
                    else
                        this.addCssClass("rad-state-no-previous-results");
                },
                _restoreScrollTop: function ()
                {
                    if (!this._isShown())
                        return;

                    var
                        $$element = this.$$elementGet();

                    if (!$$element)
                        return;

                    $$element.scrollTop(this.scrollTopGet());
                },
                _scrollTopChanged: function (change)
                {
                    var
                        $$element = this.$$elementGet(),
                        scrollTop = change.currentValue || 0,
                        elementScrollTop = Math.round($$element.scrollTop());

                    if (elementScrollTop !== scrollTop)
                        $$element.scrollTop(scrollTop);
                },

                // Public Methods
                isContentScrollable: function ()
                {
                    var
                        $$element = this.$$elementGet(),
                        $$containerElement = this.$$containerElementGet();

                    return $$containerElement[0].clientHeight > $$element[0].clientHeight;
                },

                // Event Handlers
                onAncestorVisibilityChanged: function (evt, change)
                {
                    if (change.currentValue)
                        evt.data.self._restoreScrollTop();
                },
                onScroll: function (evt)
                {
                    var
                        self = evt.data.self,
                        $$element = $$(evt.target),
                        scrollTop = Math.round($$element.scrollTop()),
                        location;

                    self.scrollTopSet(scrollTop);

                    if (scrollTop === 0 && self.hasPreviousResultsGet())
                        location = "top";
                    else if ($$element[0].scrollHeight - $$element[0].scrollTop - $$element[0].clientHeight < 5 && self.hasNextResultsGet())
                        location = "bottom";

                    if (location)
                    {
                        var
                            scrollHeight = Math.round($$element[0].scrollHeight);

                        self.triggerHandler(
                            "loadMore",
                            {
                                location: location,
                                callback: function ()
                                {
                                    if (location === "top")
                                        self.scrollTopSet(Math.round($$element[0].scrollHeight) - scrollHeight);
                                }
                            }
                        );
                    }
                }
            };
        }
    });

    // Message Panel
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "MessagePanel",
        inherits: "Panel",
        properties: [
            { name: "icon", type: "string" },
            { name: "title", type: "string" },
            { name: "type", type: "string" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                type: namespace.MessagePanel.type.none
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-message-panel ui icon message");

                // Trigger Property Changes
                this.iconTriggerChange();
                this.titleTriggerChange();
                this.typeTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _createContainerElement: function ()
                {
                    var
                        $$element = this.$$elementGet();

                    this.$$iconElement = $$.create$$({ nodeName: "i" });

                    var
                        $$containerElement =
                            $$.create$$({
                                nodeName: "div",
                                attributes: { "class": "content" },
                                children: [
                                    { nodeName: "div", attributes: { "class": "header" } },
                                    { nodeName: "p" }
                                ]
                            }).appendTo($$element);

                    this.$$containerElementSet($$containerElement);
                },
                _iconChanged: function (change)
                {
                    this.$$iconElement[0].className = String.empty;
                    this.$$iconElement.detach();

                    if (change.currentValue)
                    {
                        this.$$iconElement.addClass(String.format("icon {0}", change.currentValue));
                        this.$$iconElement.prependTo(this.$$elementGet());
                    }
                },
                _textChanged: function (change)
                {
                    this.super._textChanged(change);
                    this.$$containerElementGet().find(">p").text(change.currentValue);
                },
                _titleChanged: function (change)
                {
                    this.$$containerElementGet().find(">.header").text(change.currentValue);
                },
                _typeChanged: function (change)
                {
                    this.removeCssClass("negative positive");

                    switch (change.currentValue)
                    {
                        case namespace.MessagePanel.type.negative:
                            this.addCssClass("negative");
                            break;
                        case namespace.MessagePanel.type.positive:
                            this.addCssClass("positive");
                            break;
                    }
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.type = {
                none: "none",
                negative: "negative",
                positive: "positive"
            };
        }
    });

    // Progress Bar
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "ProgressBar",
        inherits: "Control",
        properties: [
            { name: "total", type: "int" },
            { name: "value", type: "int" },
            { name: "invertStyles", type: "boolean" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                text: "Loaded {value} of {total}",
                value: 0,
                invertStyles: false
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.showDate = new Date();

                this.addCssClass("rad-control-progress-bar");

                // Trigger Property Changes
                this.valueTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _createElement: function ()
                {
                    this.super._createElement();

                    var
                        $$element = this.$$elementGet();

                    this.$$progress =
                        $$.create$$({
                            nodeName: "div",
                            attributes: { "class": "ui blue small progress" },
                            children: [
                                { nodeName: "div", attributes: { "class": "bar" } },
                                { nodeName: "div", attributes: { "class": "label" } }
                            ]
                        }).appendTo($$element).progress();

                    if (this.invertStylesGet())
                        this.$$progress.addClass("inverted");

                    this._updateProgressBarData();
                },
                _invertStylesChanged: function (change)
                {
                    if (change.currentValue && !this.$$progress.hasClass("inverted"))
                        this.$$progress.addClass("inverted");
                    else if (!change.currentValue)
                        this.$$progress.removeClass("inverted");
                },
                _textChanged: function (change)
                {
                    this.super._textChanged(change);

                    this._updateProgressBarData();
                },
                _totalChanged: function (change)
                {
                    this._updateProgressBarData();
                },
                _updateProgressBarData: function ()
                {
                    this.$$progress.progress({
                        total: this.totalGet(),
                        value: this.valueGet(),
                        text: {
                            active: this.textGet()
                        }
                    });
                },
                _valueChanged: function (change)
                {
                    this.showDate = new Date();
                    this._updateProgressBarData();
                },

                // Public Methods

                reset: function ()
                {
                    this.$$progress.progress("reset");
                    this.valueSet(0);
                }
            };
        }
    });

    // Progress Pips
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "ProgressPips",
        inherits: "Control",
        properties: [
            { name: "mode", type: "string" },
            { name: "progress", type: "int" },
            { name: "total", type: "int" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                mode: namespace.ProgressPips.modes.fill
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-progress-pips");

                // Trigger Property Changes
                this.progressTriggerChange();
                this.totalTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _createElement: function ()
                {
                    this.super._createElement();

                    var
                        $$element = this.$$elementGet();

                    this.$$pipWrapper = $$.create$$({ nodeName: "div", attributes: { "class": "rad-pip-wrapper" } }).appendTo($$element);
                },
                _progressChanged: function (change)
                {
                    this._updateLayout();
                },
                _totalChanged: function (change)
                {
                    this.$$pipWrapper.empty();

                    for (var i = 0; i < change.currentValue; i++)
                    {
                        var
                            $$pip = $$.create$$({ nodeName: "div", attributes: { "class": "rad-pip" } });

                        window.svgHelper.createSvg("pip-background").addClass("rad-pip-background").appendTo($$pip);
                        window.svgHelper.createSvg("pip-foreground").addClass("rad-pip-foreground").appendTo($$pip);

                        this.$$pipWrapper.append($$pip);
                    }
                    this._updateLayout();
                },
                _updateLayout: function ()
                {
                    var
                        progress = this.progressGet(),
                        mode = this.modeGet(),
                        counter = 0;

                    this.$$pipWrapper.find(".rad-pip").each((index, element) =>
                    {
                        if (mode === namespace.ProgressPips.modes.fill && progress > counter)
                            $$(element).addClass("rad-state-active");
                        else if (mode === namespace.ProgressPips.modes.single && progress === counter)
                            $$(element).addClass("rad-state-active");
                        else
                            $$(element).removeClass("rad-state-active");

                        counter++;
                    });
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.modes = {
                "fill": "fill",
                "single": "single"
            };
        }
    });

    // Screen Console
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "ScreenConsole",
        inherits: "Control",
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-screen-console");
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _createElement: function ()
                {
                    this.super._createElement();

                    var
                        $$element = this.$$elementGet();

                    $$element.empty().append("<pre><code></code></pre>");
                    this.$$outputElement = $$element.find(">pre>code");
                },

                // Public Methods
                log: function (...args)
                {
                    var
                        message = String.empty;

                    for (var i = 0; i < args.length; i++)
                    {
                        if (typeof args[i] === "object")
                            message += args[i].toJson();
                        else
                            message += args[i];
                    }

                    var
                        text = this.$$outputElement.text();

                    text += (text.length ? "\r\n" : String.empty) + (typeof message === "object" ? message.toJson() : message);

                    this.$$outputElement.text(text);
                }
            };
        }
    });

    // Success Panel
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "SuccessPanel",
        inherits: "Panel",
        properties: [
            { name: "shouldScrollToTop", type: "boolean" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                shouldScrollToTop: true,
                visible: false
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-success-panel");
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _createElement: function ()
                {
                    this.super._createElement();

                    var
                        $$element = this.$$elementGet();

                    this.$$titleElement = $$.create$$({ nodeName: "h3" }).appendTo($$element);
                },

                // Public Methods
                setHtml: function (html)
                {
                    var
                        self = this;

                    if (html)
                    {
                        self.$$titleElement.html(html);
                        self.show();
                    }
                    else
                        self.hide();
                },
                setMessage: function (message)
                {
                    var
                        self = this;

                    if (message)
                    {
                        self.$$titleElement.text(message);
                        self.show();
                    }
                    else
                        self.hide();
                },
                show: function ()
                {
                    this.super.show();

                    if (this.shouldScrollToTopGet())
                        this.pageGet().scrollToTop();
                }
            };
        }
    });

    // SVG
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "SVG",
        inherits: "Control",
        properties: [
            { name: "svgKey", type: "string" }
        ],
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-svg");

                // Trigger Property Changes
                this.svgKeyTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _svgKeyChanged: function (change)
                {
                    if (change.currentValue)
                    {
                        var
                            $$element = this.$$elementGet();

                        $$element.empty();
                        $$element.append(window.svgHelper.createSvg(change.currentValue));

                        this.show();
                    }
                    else
                        this.hide();
                }
            };
        }
    });

    // Swiper
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "Swiper",
        inherits: "Panel",
        properties: [
            { name: "swiperConfigurationData", type: "object" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                swiperConfigurationData: {
                    centeredSlides: false,
                    direction: "horizontal",
                    loop: false,
                    loopedSlides: 0,
                    slidesPerView: "auto"
                }
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-swiper");
            };
        },
        createPrototype: namespace =>
        {
            return {
                _bindEvents: function ()
                {
                    this.super._bindEvents();

                    this.buttonToStart.on("click", { self: this }, this.onButtonToStartClicked);
                    this.buttonToEnd.on("click", { self: this }, this.onButtonToEndClicked);
                },
                _createContainerElement: function ()
                {
                    var
                        $$element = this.$$elementGet();

                    this.$$swiperContainer = $$.create$$({ nodeName: "div", attributes: { "class": "swiper-container" } }).appendTo($$element);
                    this.$$swiperWrapper = $$.create$$({ nodeName: "div", attributes: { "class": "swiper-wrapper" } }).appendTo(this.$$swiperContainer);

                    this.$$containerElementSet(this.$$swiperWrapper);
                },
                _createElement: function ()
                {
                    this.super._createElement();

                    var
                        $$element = this.$$elementGet();

                    this.progressPips = new namespace.ProgressPips({
                        mode: namespace.ProgressPips.modes.single
                    });

                    this.buttonToStart = new namespace.Button({ icon: "icon-chevron-left", inline: true, showLabel: false, cssClass: "button-start" });
                    this.buttonToEnd = new namespace.Button({ icon: "icon-chevron-right", inline: true, showLabel: false, cssClass: "button-end" });

                    $$element.prepend(this.buttonToStart.$$elementGet());
                    $$element.append(this.buttonToEnd.$$elementGet());
                    $$element.append(this.progressPips.$$elementGet());

                },
                _getRootElements: function ()
                {
                    return (
                        this.super._getRootElements()
                            .add(this.progressPips.$$elementGet())
                            .add(this.buttonToStart.$$elementGet())
                            .add(this.buttonToEnd.$$elementGet())
                    );
                },
                _setupSwiper: function ()
                {
                    var
                        self = this;

                    self.progressPips.visibleSet(false);

                    if (!self.$$swiperContainer)
                        return;

                    if (!self.$$swiperContainer.length)
                        return;

                    if (self.$$swiperContainer[0].swiper)
                        self.$$swiperContainer[0].swiper.destroy();

                    if (!self.$$swiperContainer.height())
                        return;

                    var
                        $$slides = self.$$swiperContainer.find(".swiper-slide");

                    self.progressPips.progressSet($$slides.length > 0 ? 0 : null);
                    self.progressPips.totalSet($$slides.length);

                    if ($$slides.length <= 1)
                        return;

                    this.activeSwiper =
                        new Swiper(self.$$swiperContainer[0], Object.extend({}, self.swiperConfigurationDataGet(), {
                            on: {
                                fromEdge: function ()
                                {
                                    // Event will be fired when Swiper goes from beginning or end position
                                    self._updateButtonVisibility();
                                },
                                slideChange: function ()
                                {
                                    var
                                        loopedSlides = 0;

                                    if (this.loopedSlides)
                                        loopedSlides = this.loopedSlides;

                                    self.progressPips.totalSet(this.slides.length - (loopedSlides * 2));
                                    self.progressPips.progressSet(this.realIndex);
                                },
                                slideChangeTransitionEnd: function ()
                                {
                                    // Ensure we move to a real slide and not a duplicate
                                    this.slideToLoop(this.realIndex, 0, false);
                                    self._updateButtonVisibility();
                                },
                                toEdge: function ()
                                {
                                    // Event will be fired when Swiper goes to beginning or end position
                                    self._updateButtonVisibility();
                                }
                            }
                        }));

                    self.progressPips.visibleSet(true);
                    self._updateButtonVisibility();
                },
                _swiperConfigurationDataChanged: function (change)
                {
                    this._setupSwiper();
                },
                _updateButtonVisibility: function ()
                {
                    if (!this.activeSwiper)
                    {
                        this.buttonToEnd.enabledSet(false);
                        this.buttonToStart.enabledSet(false);
                        return;
                    }

                    this.buttonToEnd.enabledSet(!this.activeSwiper.isEnd);
                    this.buttonToStart.enabledSet(!this.activeSwiper.isBeginning);
                },

                // Public Methods
                remove: function ()
                {
                    this.removeControls([
                        this.progressPips,
                        this.buttonToStart,
                        this.buttonToEnd
                    ]);

                    this.super.remove();
                },

                // Event Handlers
                onButtonToEndClicked: function (evt)
                {
                    evt.preventDefault();
                    evt.stopPropagation();

                    var
                        self = evt.data.self;

                    if (!self.activeSwiper)
                        return;

                    if (!self.activeSwiper.isEnd && self.activeSwiper.slides && Array.isArray(self.activeSwiper.slides))
                        self.activeSwiper.slideTo(self.activeSwiper.slides.length - 1);
                },
                onButtonToStartClicked: function (evt)
                {
                    evt.preventDefault();
                    evt.stopPropagation();

                    var
                        self = evt.data.self;

                    if (!self.activeSwiper)
                        return;

                    if (!self.activeSwiper.isBeginning)
                        self.activeSwiper.slideTo(0);
                },
                onPageActivated: function (evt, eventData)
                {
                    evt.data.self._setupSwiper();
                }
            };
        }
    });

    // Tab Pages
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "TabPages",
        inherits: "ContainerControl",
        properties: [
            { name: "activeTab", type: "int" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                activeTab: null
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-tab-pages");
                this.$$linkContainer.addClass("rad-link-container ui top attached tabular menu");

                this.$$linkContainer.prependTo(this.$$elementGet());
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _activeTabChanged: function (change)
                {
                    var
                        self = this,
                        controls = self.controlsGet(),
                        $$links = self.$$linkContainer.find(">a"),
                        originalTabPage,
                        currentTabPage;

                    controls
                        .each((itemControl, indexControl) =>
                        {
                            if (indexControl === change.currentValue)
                            {
                                itemControl.addCssClass("active");
                                $$($$links[indexControl]).addClass("active");

                                currentTabPage = controls[indexControl];
                            }
                            else
                            {
                                itemControl.removeCssClass("active");
                                $$($$links[indexControl]).removeClass("active");

                                if (indexControl === change.originalValue)
                                    originalTabPage = controls[indexControl];
                            }
                        });

                    if (originalTabPage)
                        originalTabPage._triggerAncestorVisibilityChanged({ originalValue: true, currentValue: false });

                    if (currentTabPage)
                        currentTabPage._triggerAncestorVisibilityChanged({ originalValue: false, currentValue: true });

                    self.triggerHandler("activeTabChanged", change);
                },
                _createChildControls: function ()
                {
                    this.super._createChildControls();

                    var
                        self = this,
                        controls = this.controlsGet();

                    controls.each(item =>
                    {
                        if (item instanceof namespace.TabPage)
                        {
                            item
                                .$$tabButton
                                .appendTo(self.$$linkContainer);
                        }
                    });

                    if (controls.length > 0)
                    {
                        setTimeout(() =>
                        {
                            self.activeTabSet(0);
                        });
                    }
                },
                _createElement: function ()
                {
                    this.super._createElement();

                    var
                        $$element = this.$$elementGet();

                    this.$$linkContainer = $$element.find(">.rad-link-container");

                    if (!this.$$linkContainer.length)
                        this.$$linkContainer = $$.create$$({ nodeName: "div" }).appendTo($$element);
                },
                _getRootElements: function ()
                {
                    return (
                        this.super._getRootElements()
                            .add(this.$$linkContainer)
                    );
                },
                _setInitialActiveTab: function ()
                {
                    if (this.activeTabGet() === null)
                        this.activeTabSet(0);
                },

                // Public Methods
                activeTabSet: function (value)
                {
                    var
                        controls = this.controlsGet();

                    if (!controls || value < 0 || value >= controls.length)
                        return;

                    this._activeTabSet(value);
                },
                append: function ($$elementOrContainerControl)
                {
                    this.super.append($$elementOrContainerControl);

                    if (!($$elementOrContainerControl instanceof namespace.TabPage))
                        return this;

                    $$elementOrContainerControl
                        .$$tabButton
                        .appendTo(this.$$linkContainer);

                    if (this.controlsGet().length === 1)
                        this.activeTabSet(0);

                    this.$$linkContainer.prependTo(this.$$elementGet());

                    return this;
                },

                // Event Handlers
                onAncestorVisibilityChanged: function (evt, change)
                {
                    if (change.currentValue)
                        evt.data.self._setInitialActiveTab();
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.allowedChildControlClasses = [
                "seriouslyrad.ui.web.TabPage"
            ];
            classConstructor.createForInterfaceDesigner = () =>
            {
                var
                    tabPage = new namespace.TabPage({ text: "TabPage1" });

                var
                    tabPages = new classConstructor().append(tabPage);

                tabPage.$$elementGet().tab();

                return tabPages;
            };

            $$(document).on("click", ".rad-control-tab-pages > .rad-link-container > a", evt =>
            {
                evt.preventDefault();
                evt.stopPropagation();

                var
                    anchor = evt.currentTarget,
                    $$target = $$(anchor),
                    tabPages = $$target.closest(".rad-control-tab-pages").radControl(),
                    tabIndex = 0;

                while ((anchor = anchor.previousSibling) !== null)
                    tabIndex++;

                tabPages.activeTabSet(tabIndex);
            });
        }
    });

    // Tree Node
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "TreeNode",
        inherits: "ContainerControl",
        mixins: [
            "PropertyBoundControlMixin"
        ],
        properties: [
            { name: "allowSelect", type: "boolean" },
            { name: "collapseAll", type: "boolean" },
            { name: "iconCssClass", type: "string" },
            { name: "isExpanded", type: "boolean" },
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                allowSelect: true,
                collapseAll: true,
                isExpanded: false
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.__processDataSourcePropertyValueChanged = true;
                this.addCssClass("rad-control-tree-node");

                // Trigger Property Changes
                this._suspendRefreshFromDataSource();
                this.dataSourceTriggerChange();
                this.dataSourcePropertyTriggerChange();
                this.dataSourcePropertyTypeTriggerChange();
                this._resumeRefreshFromDataSource();

                this.iconCssClassTriggerChange();
                this.isExpandedTriggerChange();
                this.valueTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _appendToOrPrependTo: function ($$elementOrContainerControl, append, beforeSelector)
                {
                    this.super._appendToOrPrependTo($$elementOrContainerControl, append, beforeSelector);
                    this.dataSourceControlSet(this._getDataSourceControl());
                },
                _bindEvents: function ()
                {
                    this.super._bindEvents();

                    this.on("controlsChanged", { self: this }, this.onControlsChanged);
                    this.on("valueChanged", { self: this }, this.onValueChanged);
                    this.buttonExpandCollapse.on("click", { self: this }, this.onButtonExpandCollapseClicked);
                    this.text.on("click", { self: this }, this.onTextClicked);
                },
                _createContainerElement: function ()
                {
                    var
                        $$element = this.$$elementGet(),
                        $$containerElement = $$.create$$({ nodeName: "div" }).appendTo($$element);

                    this.$$containerElementSet($$containerElement);
                },
                _createElement: function ()
                {
                    this.super._createElement();

                    var
                        $$element = this.$$elementGet(),
                        $$containerElement = this.$$containerElementGet();

                    $$containerElement.addClass("rad-container-tree-nodes");

                    this.panelNodeWrapper =
                        new namespace.Panel({ cssClass: "rad-node-wrapper" });

                    $$element.prepend(this.panelNodeWrapper.$$elementGet());

                    this.buttonExpandCollapse =
                        new namespace.Button({ cssClass: "rad-action-expand-collapse", showLabel: false })
                            .appendTo(this.panelNodeWrapper);

                    this.panelIcon =
                        new namespace.Panel({ cssClass: "rad-icon" })
                            .appendTo(this.panelNodeWrapper);

                    this.text =
                        new namespace.Text({ cssClass: "rad-text" })
                            .appendTo(this.panelNodeWrapper);
                },
                _iconCssClassChanged: function (change)
                {
                    if (change.originalValue)
                        this.panelIcon.removeCssClass(change.originalValue);

                    if (change.currentValue)
                    {
                        this.panelIcon.show();
                        this.panelIcon.addCssClass(change.currentValue);
                    }
                    else
                        this.panelIcon.hide();
                },
                _isExpandedChanged: function (change)
                {
                    this._updateLayout();
                },
                _textChanged: function (change)
                {
                    this.super._textChanged(change);
                    this.text.valueSet(change.currentValue);
                },
                _treeViewGet: function ()
                {
                    return this.parentControlOfTypeGet(namespace.TreeView);
                },
                _updateLayout: function ()
                {
                    var
                        isExpanded = this.isExpandedGet(),
                        $$containerElement = this.$$containerElementGet();

                    this.buttonExpandCollapse.removeCssClass("icon-chevron-down");
                    this.buttonExpandCollapse.removeCssClass("icon-chevron-right");

                    if (this.controlsGet().length)
                    {
                        if (isExpanded)
                        {
                            $$containerElement.show();
                            this.buttonExpandCollapse.addCssClass("icon-chevron-down");
                        }
                        else
                        {
                            $$containerElement.hide();
                            this.buttonExpandCollapse.addCssClass("icon-chevron-right");
                        }
                    }
                    else
                        $$containerElement.hide();
                },

                // Public Methods
                collapse: function (recursive)
                {
                    this.isExpandedSet(false);

                    if (!recursive)
                        return;

                    this.controlsGet()
                        .where(item => item instanceof namespace.TreeNode)
                        .each(item => { item.collapse(recursive); });
                },
                deselect: function ()
                {
                    var
                        _treeView = this._treeViewGet();

                    this.removeCssClass("rad-state-selected");

                    if (_treeView.selectedNodeGet() === this)
                        _treeView.selectedNodeSet(null);
                },
                ensureVisible: function ()
                {
                    var
                        currentParentControl = this.parentControlGet();

                    while (currentParentControl && currentParentControl instanceof namespace.TreeNode)
                    {
                        currentParentControl.expand();
                        currentParentControl = currentParentControl.parentControlGet();
                    }
                },
                expand: function (recursive)
                {
                    if (!this.controlsGet().length)
                    {
                        this.isExpandedSet(false);
                        return;
                    }

                    this.isExpandedSet(true);

                    if (!recursive)
                        return;

                    this.controlsGet()
                        .where(item => item instanceof namespace.TreeNode)
                        .each(item => { item.expand(recursive); });
                },
                isExpandedSet: function (value)
                {
                    if (!this.controlsGet().length)
                        value = false;

                    return this._isExpandedSet(value);
                },
                select: function ()
                {
                    if (!this.allowSelectGet())
                        return;

                    var
                        _treeView = this._treeViewGet();

                    this.addCssClass("rad-state-selected");

                    _treeView.selectedNodeSet(this);
                },
                toggle: function ()
                {
                    this.isExpandedSet(!this.isExpandedGet());
                },

                // Event Handlers
                onButtonExpandCollapseClicked: function (evt)
                {
                    evt.preventDefault();
                    evt.stopPropagation();

                    var
                        self = evt.data.self;

                    if (self.collapseAllGet())
                    {
                        if (self.isExpandedGet())
                            self.collapse(true);
                        else
                            self.expand();
                    }
                    else
                        self.toggle();
                },
                onControlsChanged: function (evt)
                {
                    evt.data.self._updateLayout();
                },
                onTextClicked: function (evt)
                {
                    evt.preventDefault();
                    evt.stopPropagation();

                    evt.data.self.select();
                },
                onValueChanged: function (evt, change)
                {
                    evt.data.self.textSet(change.currentValue);
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.allowedChildControlClasses = [
                "seriouslyrad.ui.web.TreeNode"
            ];
            classConstructor.allowedParentControlClasses = [
                "seriouslyrad.ui.web.TreeNode",
                "seriouslyrad.ui.web.TreeView"
            ];
        }
    });

    // Tree View
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "TreeView",
        inherits: "ContainerControl",
        properties: [
            { name: "selectedNode" }
        ],
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-tree-view");
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _bindEvents: function ()
                {
                    this.super._bindEvents();

                    this.on("click", { self: this }, this.onClicked);
                    this.on("controlsChanged", { self: this }, this.onControlsChanged);
                },
                _selectedNodeChanged: function (change)
                {
                    this.controlsGet(true)
                        .where(item => item instanceof namespace.TreeNode)
                        .each(item => { if (!change.currentValue || change.currentValue !== item) item.deselect(); });

                    this._triggerSelectedNodeChanged(change);
                },
                _triggerSelectedNodeChanged: function (change)
                {
                    this.triggerHandler("selectedNodeChanged", change);
                },

                // Public Methods
                collapseAll: function ()
                {
                    this.controlsGet(true)
                        .where(item => item instanceof namespace.TreeNode)
                        .each(item => { item.collapse(); });
                },
                expandAll: function ()
                {
                    this.controlsGet(true)
                        .where(item => item instanceof namespace.TreeNode)
                        .each(item => { item.expand(); });
                },

                // Event Handlers
                onClicked: function (evt)
                {
                    evt.preventDefault();
                    evt.stopPropagation();

                    evt.data.self.selectedNodeSet(null);
                },
                onControlsChanged: function (evt)
                {
                    var
                        self = evt.data.self,
                        controls = self.controlsGet(true),
                        selectedNode = self.selectedNodeGet();

                    if (!controls.length || selectedNode !== null && !controls.contains(selectedNode))
                        self.selectedNodeSet(null);
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.allowedChildControlClasses = [
                "seriouslyrad.ui.web.TreeNode"
            ];
        }
    });

    // Swiper Tab Pages
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "SwiperTabPages",
        inherits: "ContainerControl",
        properties: [
            { name: "activeTab", type: "int" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                activeTab: null
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-tab-pages rad-control-swiper-tab-pages");
                this.swiper.$$elementGet().addClass("rad-link-container ui top attached tabular menu");

                this.swiper.$$elementGet().prependTo(this.$$elementGet());
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _activeTabChanged: function (change)
                {
                    var
                        self = this,
                        controls = self.controlsGet().where(item => item instanceof namespace.TabPage),
                        $$links = self.swiper.$$containerElementGet().find("a"),
                        originalTabPage,
                        currentTabPage;

                    controls
                        .each((itemControl, indexControl) =>
                        {
                            if (indexControl === change.currentValue)
                            {
                                itemControl.addCssClass("active");
                                $$($$links[indexControl]).addClass("active");

                                currentTabPage = controls[indexControl];
                            }
                            else
                            {
                                itemControl.removeCssClass("active");
                                $$($$links[indexControl]).removeClass("active");

                                if (indexControl === change.originalValue)
                                    originalTabPage = controls[indexControl];
                            }
                        });

                    if (originalTabPage)
                        originalTabPage._triggerAncestorVisibilityChanged({ originalValue: true, currentValue: false });

                    if (currentTabPage)
                        currentTabPage._triggerAncestorVisibilityChanged({ originalValue: false, currentValue: true });

                    self.triggerHandler("activeTabChanged", change);
                },
                _createChildControls: function ()
                {
                    this.super._createChildControls();

                    var
                        self = this,
                        controls = this.controlsGet().where(item => item instanceof namespace.TabPage);

                    controls
                        .each(item =>
                        {
                            item
                                .$$tabButton
                                .addClass("swiper-slide");

                            item
                                .$$tabButton
                                .appendTo(self.swiper.$$containerElementGet());
                        });

                    if (controls.length > 0)
                    {
                        setTimeout(() =>
                        {
                            self.activeTabSet(0);
                        });
                    }
                },
                _createElement: function ()
                {
                    this.super._createElement();

                    var
                        $$element = this.$$elementGet();

                    this.swiper = new namespace.Swiper().appendTo($$element);
                },
                _getRootElements: function ()
                {
                    return (
                        this.super._getRootElements()
                            .add(this.swiper.$$elementGet())
                    );
                },
                _setInitialActiveTab: function ()
                {
                    if (this.activeTabGet() === null)
                        this.activeTabSet(0);
                },

                // Public Methods
                activeTabSet: function (value)
                {
                    var
                        controls = this.controlsGet();

                    if (!controls || value < 0 || value >= controls.length)
                        return;

                    this._activeTabSet(value);
                },
                append: function ($$elementOrContainerControl)
                {
                    this.super.append($$elementOrContainerControl);

                    if (!($$elementOrContainerControl instanceof namespace.TabPage))
                        return this;

                    $$elementOrContainerControl
                        .$$tabButton
                        .appendTo(this.swiper.$$containerElementGet());

                    if (this.controlsGet().length === 1)
                        this.activeTabSet(0);

                    this.swiper.$$elementGet().prependTo(this.$$elementGet());

                    return this;
                },

                // Event Handlers
                onAncestorVisibilityChanged: function (evt, change)
                {
                    if (change.currentValue)
                        evt.data.self._setInitialActiveTab();
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.allowedChildControlClasses = [
                "seriouslyrad.ui.web.TabPage",
                "seriouslyrad.ui.web.Swiper"
            ];
            classConstructor.createForInterfaceDesigner = () =>
            {
                var
                    tabPage = new namespace.TabPage({ text: "TabPage1" });

                var
                    tabPages = new classConstructor().append(tabPage);

                tabPage.$$elementGet().tab();

                return tabPages;
            };

            $$(document).on("click", ".rad-control-tab-pages > .rad-link-container a", evt =>
            {
                evt.preventDefault();
                evt.stopPropagation();

                var
                    anchor = evt.currentTarget,
                    $$target = $$(anchor),
                    tabPages = $$target.closest(".rad-control-tab-pages").radControl(),
                    tabIndex = 0;

                while ((anchor = anchor.previousSibling) !== null)
                    tabIndex++;

                tabPages.activeTabSet(tabIndex);
            });
        }
    });

    // Tab Page
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "TabPage",
        inherits: "ContainerControl",
        createPropertyDefaults: namespace =>
        {
            return {
                text: "TabPage"
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-tab-page ui bottom attached tab segment");
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _createElement: function ()
                {
                    this.super._createElement();

                    this.$$tabButton = $$.create$$({ nodeName: "a", attributes: { "class": "item", href: "#" } });
                    this.$$text = $$.create$$({ nodeName: "span", attributes: { "class": "text" } }).appendTo(this.$$tabButton);
                },
                _isVisibleChanged: function (change)
                {
                    this.super._isVisibleChanged(change);

                    if (change.currentValue)
                        this.$$tabButton.show();
                    else
                        this.$$tabButton.hide();
                },
                _textChanged: function (change)
                {
                    this.super._textChanged(change);

                    if (this.$$text)
                    {
                        this.$$text.html(
                            (change.currentValue ? change.currentValue : String.empty)
                                .htmlEncode()
                                .replace(/\r/gi, String.empty)
                                .replace(/\n/gi, "<br />")
                        );
                    }
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.allowedParentControlClasses = [
                "seriouslyrad.ui.web.TabPages"
            ];
        }
    });

    // Table
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "Table",
        inherits: "Control",
        properties: [
            { name: "asyncRefreshFromDataSource", type: "boolean" },
            { name: "footerVisible", type: "boolean" },
            { name: "headerVisible", type: "boolean" },
            { name: "ledger", type: "boolean" },
            { name: "lightweight", type: "boolean" },
            { name: "linkUrls", type: "boolean" },
            { name: "messageWhenNoRows", type: "string" },
            { name: "rowIcon", type: "string" },
            { name: "rowIconDataSourcePath", type: "string" },
            { name: "rowIconMobile", type: "string" },
            { name: "rowClickable", type: "boolean" },
            { name: "rowSelectType", type: "string" },
            { name: "selectedItems", type: "array" },
            { name: "stackable", type: "boolean" },
            { name: "tableRowClass" },
        ],
        propertyAttributes: [
            {
                propertyName: "rowIcon",
                designer: {
                    category: "Appearance",
                    displayName: "Row Icon"
                }
            },
            {
                propertyName: "rowIconMobile",
                designer: {
                    category: "Appearance",
                    displayName: "Row Icon (Mobile)"
                }
            },
            {
                propertyName: "rowClickable",
                designer: {
                    category: "Behavior",
                    displayName: "Row Clickable"
                }
            },
            {
                propertyName: "rowSelectType",
                designer: {
                    category: "Behavior",
                    displayName: "Row Select Type"
                }
            }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                asyncRefreshFromDataSource: true,
                footerVisible: false,
                headerVisible: true,
                ledger: false,
                lightweight: false,
                rowClickable: false,
                rowSelectType: namespace.Table.rowSelectTypes.none,
                selectedItems: [],
                stackable: true,
                tableRowClass: namespace.TableRow
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.__selectedItemsUpdateSuspended = false;
                this.__settingRowSelectionState = false;

                this.addCssClass("rad-control-table");

                this._updateCellColumnDescriptions();
                //this._updateTableHead();

                // Trigger Property Changes
                this.headerVisibleTriggerChange();
                this.ledgerTriggerChange();
                this.linkUrlsTriggerChange();
                this.rowIconTriggerChange();
                this.rowIconMobileTriggerChange();
                this.rowClickableTriggerChange();
                this.rowSelectTypeTriggerChange();
                this.footerVisibleTriggerChange();
                this.stackableTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _addNoResultsRow: function ()
                {
                    var
                        messageWhenNoRows = this.messageWhenNoRowsGet();

                    if (!messageWhenNoRows)
                        return;

                    var
                        row = new namespace.TableRowNoResults({ table: this }),
                        columns = this.columnsGet();

                    row.suspendLayoutSet(true);

                    var
                        cell = new namespace.TableCell({
                            columnSpan: columns.length,
                            dataSource: new seriouslyrad.data.DataSource({ data: { text: messageWhenNoRows } }),
                            dataSourceProperty: "text",
                            tableRow: row
                        });

                    row.append(cell);

                    row.suspendLayoutSet(false);

                    this.tableBody.append(row);
                },
                _createElement: function ()
                {
                    this.super._createElement();

                    var
                        self = this,
                        $$element = this.$$elementGet();

                    $$element.children().each((index, element) =>
                    {
                        var
                            control = namespace.Control.createFromElement($$(element));

                        if (!control)
                            return;

                        if (control instanceof namespace.TableHead)
                        {
                            if (!self.tableHead)
                                self.tableHead = control;
                            return;
                        }

                        if (control instanceof namespace.TableBody)
                        {
                            if (!self.tableBody)
                                self.tableBody = control;
                            return;
                        }

                        if (control instanceof namespace.TableFoot)
                        {
                            if (!self.tableFoot)
                                self.tableFoot = control;
                            return;
                        }

                        console.error("One or more of the child controls are not of an accepted type.");
                    });

                    this.$$table =
                        $$.create$$({ nodeName: "table", attributes: { "class": "ui celled table" } })
                            .appendTo($$element);

                    if (!this.tableHead)
                        this.tableHead = new namespace.TableHead();

                    if (!this.tableBody)
                        this.tableBody = new namespace.TableBody();

                    if (!this.tableFoot)
                        this.tableFoot = new namespace.TableFoot();

                    this.tableHead.appendTo(this.$$table);
                    this.tableBody.appendTo(this.$$table);
                    this.tableFoot.appendTo(this.$$table);
                },
                _footerVisibleChanged: function (change)
                {
                    this.tableFoot.visibleSet(change.currentValue);
                },
                _headerVisibleChanged: function (change)
                {
                    this.tableHead.visibleSet(change.currentValue);
                },
                _ledgerChanged: function (change)
                {
                    if (change.currentValue)
                        this.addCssClass("rad-feature-ledger");
                    else
                        this.removeCssClass("rad-feature-ledger");
                },
                _refreshFromDataSource: function ()
                {
                    this.super._refreshFromDataSource();

                    var
                        self = this;

                    if (self.selectionColumn)
                        self.selectionColumn.checkBox.valueSet(false);

                    var
                        dataSource = self.dataSourceGet();

                    if (!dataSource)
                        return;

                    var
                        data = dataSource.dataGet();

                    if (!data)
                        return;

                    if (!data.length)
                    {
                        self.addCssClass("rad-state-no-results");
                        self.clear();
                        self._addNoResultsRow();
                        return;
                    }

                    self.removeCssClass("rad-state-no-results");

                    var
                        lightweight = self.lightweightGet(),
                        columns,
                        tableCellClasses;

                    if (lightweight)
                    {
                        columns = self.columnsGet();
                        tableCellClasses = columns.select(item => item.tableCellClassGet());
                    }

                    function createRow(item)
                    {
                        var
                            tableRow = self.newRow(),
                            rowDataSource = new seriouslyrad.data.DataSource({ data: item });

                        rowDataSource.tableRow = tableRow;

                        rowDataSource.on("propertyValueChanged", { self: self }, self.onRowDataSourcePropertyValueChanged);

                        if (lightweight)
                        {
                            var
                                $$tds = tableRow.find("td");

                            tableRow.data("dataSource", rowDataSource);

                            columns
                                .each((column, index) =>
                                {
                                    var
                                        tableCellClass = tableCellClasses[index];

                                    if (tableCellClass.createLightweightContent)
                                    {
                                        if ($$tds.length > index)
                                            tableCellClass.createLightweightContent($$($$tds[index]), column, rowDataSource);
                                    }
                                });
                        }
                        else
                            tableRow.dataSourceSet(rowDataSource);

                        return tableRow;
                    }

                    if (self.asyncRefreshFromDataSourceGet())
                    {

                        if (!self.asyncIterator)
                            self.asyncIterator = new seriouslyrad.AsyncIterator();

                        self._loadingEnqueue();

                        self.asyncIterator
                            .forEach(data, item => createRow(item))
                            .then(results => { self.clear(); self.addRows(results); })
                            .catch(() => { /* Intentionally empty */ })
                            .finally(() => { self._loadingDequeue(); });
                    }
                    else
                    {
                        self.clear();
                        self.addRows(data.select(item => createRow(item)));
                    }
                },
                _rowClickableChanged: function (change)
                {
                    if (change.currentValue)
                        this.addCssClass("rad-feature-clickable");
                    else
                        this.removeCssClass("rad-feature-clickable");
                },
                _rowClicked: function (row)
                {
                    var
                        rowSelectType = this.rowSelectTypeGet();

                    if (this.rowClickableGet())
                    {
                        this.triggerHandler("rowClicked", row);
                        return;
                    }

                    if (rowSelectType === seriouslyrad.ui.web.Table.rowSelectTypes.single || rowSelectType === seriouslyrad.ui.web.Table.rowSelectTypes.multiple)
                    {
                        var
                            tableCellSelection = row.controlsGet().firstOrDefault(item => item instanceof namespace.TableCellSelection);

                        if (tableCellSelection)
                            tableCellSelection.checkBox.valueSet(!tableCellSelection.checkBox.valueGet());

                        return;
                    }

                    if (rowSelectType === seriouslyrad.ui.web.Table.rowSelectTypes.singleNoCheckBox)
                        this._setRowSelectionState(row, true);
                },
                _rowIconChanged: function (change)
                {
                    this._updateColumns();
                },
                _rowIconDataSourcePathChanged: function (change)
                {
                    this._updateColumns();
                },
                _rowIconMobileChanged: function (change)
                {
                    this._updateColumns();
                },
                _rowSelectTypeChanged: function (change)
                {
                    this._updateColumns();
                },
                _selectedItemsChanged: function (change)
                {
                    this.triggerHandler("selectedItemsChanged", change);
                },
                _selectedItemsUpdateResume: function ()
                {
                    this.__selectedItemsUpdateSuspended = false;

                    if (this.lightweightGet())
                    {
                        var
                            selectedRows = [];

                        this.rowsGet()
                            .each(function (index, element)
                            {
                                var
                                    $$this = $$(element);

                                if ($$this.hasClass("rad-state-selected"))
                                    selectedRows.push(element);
                            });

                        this._updateSelectedItems(selectedRows);
                    }
                    else
                    {
                        this._updateSelectedItems(
                            this.rowsGet()
                                .where(item => item._selectedGet())
                        );
                    }
                },
                _selectedItemsUpdateSuspend: function ()
                {
                    this.__selectedItemsUpdateSuspended = true;
                },
                _setRowSelectionState: function (row, selected)
                {
                    if (this.__settingRowSelectionState)
                        return;

                    var
                        rowIsSelected =
                            this.lightweightGet()
                                ? row.hasClass("rad-state-selected")
                                : row.hasCssClass("rad-state-selected");

                    if (rowIsSelected === selected)
                        return;

                    this.__settingRowSelectionState = true;

                    var
                        rowSelectType = this.rowSelectTypeGet();

                    if (this.lightweightGet())
                    {
                        if (selected)
                        {
                            row.addClass("rad-state-selected");

                            if (rowSelectType === namespace.Table.rowSelectTypes.single || rowSelectType === namespace.Table.rowSelectTypes.singleNoCheckBox)
                            {
                                this.rowsGet()
                                    .each((index, element) =>
                                    {
                                        $$(element).removeClass("rad-state-selected");
                                    });
                            }

                            row.addClass("rad-state-selected");
                        }
                        else
                            row.removeClass("rad-state-selected");

                        if (!this.__selectedItemsUpdateSuspended)
                        {
                            var
                                selectedRows = [];

                            this.rowsGet()
                                .each((index, element) =>
                                {
                                    var
                                        $$this = $$(element);

                                    if ($$this.hasClass("rad-state-selected"))
                                        selectedRows.push(element);
                                });

                            this._updateSelectedItems(selectedRows);
                        }
                    }
                    else
                    {
                        if (selected)
                        {
                            row.select();

                            if (rowSelectType === namespace.Table.rowSelectTypes.single || rowSelectType === namespace.Table.rowSelectTypes.singleNoCheckBox)
                            {
                                this.rowsGet()
                                    .where(item => item !== row)
                                    .each(item => { item.deselect(); });
                            }
                        }
                        else
                            row.deselect();

                        if (!this.__selectedItemsUpdateSuspended)
                        {
                            this._updateSelectedItems(
                                this.rowsGet()
                                    .where(item => item._selectedGet())
                            );
                        }
                    }

                    this.triggerHandler("rowSelectionStateChanged", {
                        originalValue: !selected,
                        currentValue: selected,
                        row: row
                    });

                    this.__settingRowSelectionState = false;
                },
                _stackableChanged: function (change)
                {
                    if (change.currentValue)
                        this.$$table.removeClass("unstackable");
                    else
                        this.$$table.addClass("unstackable");
                },
                _triggerRowDataSourceChanged: function (tableRow, change)
                {
                    this.trigger("rowDataSourceChanged", {
                        currentValue: change.currentValue,
                        dataSource: change.dataSource,
                        originalValue: change.originalValue,
                        path: change.path,
                        tableRow: tableRow
                    });
                },
                _updateCellColumnDescriptions: function ()
                {
                    var
                        columns = this.columnsGet(),
                        tableRows = this.tableBody.controlsGet();

                    for (var i = 0; i < tableRows.length; i++)
                    {
                        var
                            tableCells = tableRows[i].controlsGet();

                        for (var j = 0; j < columns.length; j++)
                        {
                            if (tableCells.length > j)
                                tableCells[j].columnDescriptionSet(columns[j].textGet());
                            else
                                break;
                        }
                    }
                },
                _updateColumns: function ()
                {
                    var
                        columnsChanged = false,
                        rowSelectType = this.rowSelectTypeGet();

                    if (rowSelectType)
                        this.addCssClass("rad-feature-selectable");
                    else
                        this.removeCssClass("rad-feature-selectable");

                    if (rowSelectType === seriouslyrad.ui.web.Table.rowSelectTypes.single || rowSelectType === seriouslyrad.ui.web.Table.rowSelectTypes.multiple)
                    {
                        if (!this.selectionColumn)
                        {
                            this.selectionColumn =
                                new namespace.TableColumnSelection({
                                    rowSelectType: this.rowSelectTypeGet(),
                                    table: this
                                });
                            columnsChanged = true;
                        }

                        this.selectionColumn.rowSelectTypeSet(this.rowSelectTypeGet());
                    }
                    else
                    {
                        if (this.selectionColumn)
                        {
                            this.selectionColumn.remove();
                            this.selectionColumn = null;
                            columnsChanged = true;
                        }
                    }

                    var
                        rowIcon = this.rowIconGet(),
                        rowIconDataSourcePath = this.rowIconDataSourcePathGet(),
                        rowIconMobile = this.rowIconMobileGet();

                    if ((rowIcon || rowIconDataSourcePath || rowIconMobile) && !this.iconColumn)
                    {
                        this.iconColumn =
                            new namespace.TableColumnIcon({
                                table: this
                            });
                        columnsChanged = true;
                    }
                    else if (this.iconColumn)
                    {
                        this.iconColumn.remove();
                        this.iconColumn = null;
                        columnsChanged = true;
                    }

                    if (columnsChanged)
                        this.clear();

                    if (this.iconColumn)
                        this.iconColumn.prependTo(this.tableHead);

                    if (this.selectionColumn)
                        this.selectionColumn.prependTo(this.tableHead);
                },
                _updateSelectedItems: function (selectedItems)
                {
                    if (this.selectedItemsGet().sequenceEqualTo(selectedItems))
                        return;

                    this.selectedItemsSet(selectedItems);
                },

                // Public Methods
                addColumn: function (tableColumn)
                {
                    this.tableHead.append(tableColumn);
                    tableColumn.tableSet(this);
                    this.tableFoot.$$containerElementGet().prop("colSpan", this.tableHead.controlsGet().length);
                },
                addRow: function (tableRowOrArrayOf, prepend) // Deprecate
                {
                    return this.addRows(tableRowOrArrayOf, prepend);
                },
                addRows: function (tableRowOrArrayOf, prepend)
                {
                    const
                        tableRows = Array.isArray(tableRowOrArrayOf) ? tableRowOrArrayOf : [tableRowOrArrayOf];

                    if (this.lightweightGet())
                    {
                        if (prepend)
                            this.tableBody.prepend(tableRows);
                        else
                            this.tableBody.append(tableRows);

                        return;
                    }

                    const
                        columns = this.columnsGet();

                    tableRows
                        .forEach(item =>
                        {
                            const
                                cells = item.controlsGet();

                            for (var i = 0; i < columns.length; i++)
                            {
                                if (cells.length <= i)
                                    break;

                                cells[i].columnDescriptionSet(columns[i].textGet());
                            }
                        });

                    if (prepend)
                        this.tableBody.prepend(tableRows);
                    else
                        this.tableBody.append(tableRows);

                    //this._updateTableHead();
                },
                clear: function ()
                {
                    this._updateSelectedItems([]);

                    for (let control of this.tableBody.controlsGet())
                        control.remove();

                    //this._updateTableHead();
                },
                columnsClear: function ()
                {
                    this.clear();

                    if (this.iconColumn)
                        this.iconColumn.detach();

                    if (this.selectionColumn)
                        this.selectionColumn.detach();

                    var result = this.tableHead.controlsClear();

                    this._updateColumns();

                    return result;
                },
                columnsGet: function ()
                {
                    return this.tableHead.controlsGet();
                },
                newRow: function (properties)
                {
                    var
                        self = this;

                    if (this.lightweightGet())
                    {
                        var
                            columnCount = self.columnsGet().length,
                            $$trElement = $$.create$$({ nodeName: "tr" });

                        while (columnCount--)
                            $$trElement.append(document.createElement("td"));

                        return $$trElement;
                    }

                    var
                        tableRowClass = self.tableRowClassGet();

                    properties = properties || {};
                    properties.table = self;

                    var
                        row = new tableRowClass(properties);

                    row.suspendLayoutSet(true);

                    row.append(
                        self.columnsGet().map(item =>
                            item.tableCellClassGet().create({
                                table: self,
                                tableColumn: item,
                                tableRow: row
                            }))
                    );

                    row.suspendLayoutSet(false);

                    return row;
                },
                remove: function ()
                {
                    this.removeControls([
                        this.tableHead,
                        this.tableBody,
                        this.tableFoot,
                        this.iconColumn,
                        this.selectionColumn
                    ]);

                    this.super.remove();
                },
                rowsGet: function ()
                {
                    if (this.lightweightGet())
                        return this.$$elementGet().find("tbody tr");

                    return this.tableBody.controlsGet();
                },

                // Event Handlers
                onRowDataSourcePropertyValueChanged: function (evt, change)
                {
                    evt.data.self.triggerHandler("rowDataSourcePropertyValueChanged", {
                        dataSource: change.dataSource,
                        path: change.path,
                        originalValue: change.originalValue,
                        currentValue: change.currentValue,
                        row: change.dataSource.tableRow
                    });
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.rowSelectTypes = {
                none: null,
                single: "single",
                singleNoCheckBox: "singleNoCheckBox",
                multiple: "multiple"
            };
            classConstructor.createForInterfaceDesigner = () =>
            {
                var
                    table = new classConstructor();

                table.addColumn(new namespace.TableColumn());
                table.addRow(table.newRow());

                return table;
            };
        }
    });

    // Table Header Row
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "TableHead",
        inherits: "ContainerControl",
        createPropertyDefaults: namespace =>
        {
            return {
                elementType: "thead"
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-table-head");
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _createContainerElement: function ()
                {
                    var
                        $$element = this.$$elementGet(),
                        $$containerElement = $$element.find(">tr");

                    if (!$$containerElement.length)
                        $$containerElement = $$.create$$({ nodeName: "tr" }).appendTo($$element);

                    this.$$containerElementSet($$containerElement);
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.allowedParentControlClasses = [
                "seriouslyrad.ui.web.Table"
            ];  
            classConstructor.allowedChildControlClasses = [
                "seriouslyrad.ui.web.TableColumnBase"
            ];
        }
    });

    // Table Footer Row
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "TableFoot",
        inherits: "ContainerControl",
        createPropertyDefaults: namespace =>
        {
            return {
                elementType: "tfoot"
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-table-foot");
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _createContainerElement: function ()
                {
                    var
                        $$element = this.$$elementGet(),
                        $$rowElement = $$element.find(">tr");

                    if (!$$rowElement.length)
                        $$rowElement = $$.create$$({ nodeName: "tr" }).appendTo($$element);

                    var
                        $$cellElement = $$rowElement.find(">td");

                    if (!$$cellElement.length)
                        $$cellElement = $$.create$$({ nodeName: "td" }).appendTo($$rowElement);

                    this.$$containerElementSet($$cellElement);
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.allowedParentControlClasses = [
                "seriouslyrad.ui.web.Table"
            ];
        }
    });

    // Table Column Base
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "TableColumnBase",
        inherits: "ContainerControl",
        abstract: true,
        properties: [
            { name: "table" },
            { name: "tableCellClass" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                elementType: "th"
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-table-column-base");
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.allowedParentControlClasses = [
                "seriouslyrad.ui.web.TableHead"
            ];
        }
    });

    // Table Column
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "TableColumn",
        inherits: "TableColumnBase",
        properties: [
            { name: "dataSourceProperty", type: "string" },
            { name: "formatString", type: "string" }
        ],
        propertyAttributes: [
            {
                propertyName: "dataSourceProperty",
                designer: {
                    category: "Data",
                    displayName: "Data Source Property"
                }
            }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                tableCellClass: namespace.TableCell
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-table-column-text");
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _textChanged: function (change)
                {
                    this.super._textChanged(change);
                    this.$$containerElementGet().text(change.currentValue);
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.allowedParentControlClasses = [
                "seriouslyrad.ui.web.TableHead"
            ];
        }
    });

    // Table Column (Icon)
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "TableColumnIcon",
        inherits: "TableColumnBase",
        createPropertyDefaults: namespace =>
        {
            return {
                tableCellClass: namespace.TableCellIcon
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-table-column-icon");
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.allowedParentControlClasses = [
                "seriouslyrad.ui.web.TableHead"
            ];
        }
    });
    
    // Table Column (Image)
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "TableColumnImage",
        inherits: "TableColumn",
        properties: [
            { name: "imageMaxHeight", type: "string" },
            { name: "imageMaxWidth", type: "string" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                tableCellClass: namespace.TableCellImage
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-table-column-image");
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.allowedParentControlClasses = [
                "seriouslyrad.ui.web.TableHead"
            ];
        }
    });

    // Table Column (Selection)
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "TableColumnSelection",
        inherits: "TableColumnBase",
        properties: [
            { name: "rowSelectType", type: "string" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                rowSelectType: namespace.Table.rowSelectTypes.single,
                tableCellClass: namespace.TableCellSelection
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-table-column-selection");

                // Trigger Property Changes
                this.rowSelectTypeTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _bindEvents: function ()
                {
                    this.super._bindEvents();

                    this.checkBox.on("valueChanged", { self: this }, this.onCheckBoxValueChanged);
                },
                _createElement: function ()
                {
                    this.super._createElement();

                    this.checkBox =
                        new namespace.CheckBox()
                            .appendTo(this);
                },
                _rowSelectTypeChanged: function (change)
                {
                    this.checkBox.visibleSet(change.currentValue === namespace.Table.rowSelectTypes.multiple);
                },
                _setRowsSelectedState: function (selected)
                {
                    var
                        table = this.tableGet();

                    if (!table)
                        return;

                    table._selectedItemsUpdateSuspend();

                    if (table.lightweightGet())
                    {
                        table.$$elementGet().find(".rad-control-table-selection-cell .rad-control-check-box")
                            .each((index, element) =>
                            {
                                var
                                    $$checkBox = $$(element),
                                    checkBox = $$checkBox.radControl();

                                if (checkBox)
                                {
                                    var
                                        $$row = $$checkBox.closest("tr");

                                    checkBox.valueSet(selected);
                                    table._setRowSelectionState($$row, selected);
                                }
                            });
                    }
                    else
                    {
                        table
                            .rowsGet()
                            .each(row =>
                            {
                                var
                                    tableCellSelection = row.controlsGet().firstOrDefault(item => item instanceof namespace.TableCellSelection);

                                if (tableCellSelection)
                                    tableCellSelection.checkBox.valueSet(selected);
                            });
                    }

                    table._selectedItemsUpdateResume();
                },

                // Event Handlers
                onCheckBoxValueChanged: function (evt, change)
                {
                    evt.data.self._setRowsSelectedState(change.currentValue);
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.allowedParentControlClasses = [
                "seriouslyrad.ui.web.TableHead"
            ];
        }
    });

    // Table Body
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "TableBody",
        inherits: "ContainerControl",
        createPropertyDefaults: namespace =>
        {
            return {
                elementType: "tbody"
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-table-body");
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.allowedParentControlClasses = [
                "seriouslyrad.ui.web.Table"
            ];
            classConstructor.allowedChildControlClasses = [
                "seriouslyrad.ui.web.TableRow"
            ];
        }
    });

    // Table Row
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "TableRow",
        inherits: "ContainerControl",
        properties: [
            { name: "table" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                elementType: "tr"
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-table-row");
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _bindEvents: function ()
                {
                    this.super._bindEvents();
                    this.on("mousedown", { self: this }, this.onMouseDown);
                    this.on("mouseup", { self: this }, this.onMouseUp);
                },
                _getTable: function ()
                {
                    return this.$$elementGet()?.closest(".rad-control-table").radControl();
                },
                _refreshFromDataSource: function ()
                {
                    this.super._refreshFromDataSource();

                    const
                        dataSource = this.dataSourceGet();

                    if (!dataSource)
                        return;

                    for (let cell of this.cellsGet())
                        cell.dataSourceSet(dataSource);
                },
                _selectedGet: function ()
                {
                    return this.hasCssClass("rad-state-selected");
                },
                _suspendLayoutChanged: function (change)
                {
                    this.super._suspendLayoutChanged(change);

                    if (!change.currentValue)
                    {
                        var
                            dataSource = this.dataSourceGet();

                        this.dataSourceSet(null);
                        this.dataSourceSet(dataSource);
                    }
                },

                // Public Methods
                append: function ($$elementOrControl)
                {
                    this.super.append($$elementOrControl);

                    if (!this.suspendLayoutGet())
                        this.controlsGet().last().dataSourceSet(this.dataSourceGet());

                    return this;
                },
                cellsGet: function ()
                {
                    return this.controlsGet();
                },
                click: function ()
                {
                    var
                        table = this._getTable();

                    if (table)
                        table._rowClicked(this);
                },
                deselect: function ()
                {
                    var
                        selectionCell = this.cellsGet().firstOrDefault(item => item instanceof seriouslyrad.ui.web.TableCellSelection);

                    if (selectionCell)
                        selectionCell.deselect();

                    this.removeCssClass("rad-state-selected");
                },
                prepend: function ($$elementOrControl)
                {
                    this.super.prepend($$elementOrControl);

                    if (!this.suspendLayoutGet())
                        this.controlsGet().first().dataSourceSet(this.dataSourceGet());

                    return this;
                },
                remove: function ()
                {
                    var
                        table = this._getTable();

                    if (table)
                        table._setRowSelectionState(this, false);

                    var
                        rowDataSource = this.dataSourceGet(),
                        rowData = rowDataSource ? rowDataSource.dataGet() : null;

                    if (rowData)
                    {
                        var
                            tableDataSource = table ? table.dataSourceGet() : null,
                            tableData = tableDataSource ? tableDataSource.dataGet() : null;

                        if (tableData)
                            tableData.remove(rowData);
                    }

                    return this.super.remove();
                },
                select: function ()
                {
                    var
                        selectionCell = this.cellsGet().firstOrDefault(item => item instanceof seriouslyrad.ui.web.TableCellSelection);

                    if (selectionCell)
                        selectionCell.select();

                    this.addCssClass("rad-state-selected");
                },
                toggle: function ()
                {
                    if (this._selectedGet())
                        this.deselect();
                    else
                        this.select();
                },

                // Event Handlers
                onDataSourcePropertyValueChanged: function (evt, change)
                {
                    this.super.onDataSourcePropertyValueChanged(evt, change);
                    evt.data.self.tableGet()._triggerRowDataSourceChanged(evt.data.self, change);
                },
                onMouseDown: function (evt)
                {
                    var
                        self = evt.data.self;

                    if (evt.button === 0)
                        self.startPoint = window.eventHelper.getInputCoordinates(evt);
                },
                onMouseUp: function (evt)
                {
                    this.super.onMouseUp(evt);

                    var
                        self = evt.data.self;

                    if (!self.startPoint)
                        return;

                    var
                        startPoint = self.startPoint,
                        endPoint = window.eventHelper.getInputCoordinates(evt);

                    self.startPoint = null;

                    if (!endPoint)
                        return;

                    if (startPoint.distanceTo(endPoint) > 10)
                        return;

                    self.click();
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.allowedParentControlClasses = [
                "seriouslyrad.ui.web.TableBody"
            ];
            classConstructor.allowedChildControlClasses = [
                "seriouslyrad.ui.web.TableCellBase"
            ];
        }
    });

    // Table Row (No Results)
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "TableRowNoResults",
        inherits: "TableRow",
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-table-row-no-results");
            };
        }
    });

    // Table Cell Base
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "TableCellBase",
        inherits: "ContainerControl",
        abstract: true,
        properties: [
            { name: "columnDescription", type: "string" },
            { name: "table" },
            { name: "tableColumn" },
            { name: "tableRow" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                elementType: "td"
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-table-cell-base");
                this.$$columnDescription.addClass("column-description");
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _columnDescriptionChanged: function (change)
                {
                    this.$$columnDescription.text(change.currentValue);
                },
                _createContainerElement: function ()
                {
                    var
                        $$element = this.$$elementGet(),
                        $$containerElement = $$.create$$({ nodeName: "div" }),
                        text = $$element.text();

                    this.$$columnDescription = $$.create$$({ nodeName: "span" });
                    this.$$contentsElement = $$.create$$({ nodeName: "div", attributes: { "class": "contents" } });
                    this.$$text = $$.create$$({ nodeName: "span", attributes: { "class": "text" } });

                    if (text?.replace(/[ \r\n]/g, String.empty).length)
                        this[".properties"].text = text;

                    $$element.append(this.$$columnDescription);
                    $$element.append(this.$$contentsElement);
                    this.$$contentsElement.append(this.$$text);
                    $$element.append($$containerElement);
                    
                    this.$$containerElementSet($$containerElement);
                },
                _textChanged: function (change)
                {
                    this.super._textChanged(change);

                    var
                        self = this,
                        lines = change.currentValue ? change.currentValue.replace(/\r/gi, String.empty).split("\n") : null;

                    self.$$text.empty();

                    if (!lines)
                        return;

                    lines.each((item, index) =>
                    {
                        self.$$text.append($$.createText(item));

                        if (index < lines.length - 1)
                            self.$$text.append($$.create$$({ nodeName: "br" }));
                    });
                },

                // Event Handlers
                onMouseUp: function (evt)
                {
                    /* Intentionally empty */
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.allowedParentControlClasses = [
                "seriouslyrad.ui.web.TableRow"
            ];
        }
    });

    // Table Cell
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "TableCell",
        inherits: "TableCellBase",
        properties: [
            { name: "booleanStyle", type: "string" },
            { name: "columnSpan", type: "int" },
            { name: "dataSourceProperty", type: "string" },
            { name: "formatString", type: "string" }
        ],
        propertyAttributes: [
            {
                propertyName: "dataSourceProperty",
                designer: {
                    category: "Data",
                    displayName: "Data Source Property"
                }
            }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                booleanStyle: namespace.TableCell.booleanStyle.yesNo,
                columnSpan: 1,
                elementType: "td"
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-table-cell");

                // Trigger Property Changes
                this.columnSpanTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _columnSpanChanged: function (change)
                {
                    var
                        $$element = this.$$elementGet();

                    if (!$$element)
                        return;

                    var
                        columnSpan = change.currentValue ? change.currentValue : 1;

                    $$element.prop("colSpan", columnSpan === 1 ? String.empty : columnSpan);
                },
                _dataSourcePropertyChanged: function (change)
                {
                    this.refreshFromDataSource();
                },
                _getDataSourceProperty: function ()
                {
                    return this.dataSourcePropertyGet();
                },
                _refreshFromDataSource: function ()
                {
                    this.super._refreshFromDataSource();

                    var
                        dataSource = this.dataSourceGet(),
                        dataSourceProperty = this._getDataSourceProperty(),
                        dataDateFormatString = "yyyy-MM-ddTHH:mm:ss.fffffffZ",
                        formatString = this.formatStringGet(),
                        table = this.tableGet();

                    if (this.$$elementForDisplay)
                    {
                        this.$$elementForDisplay.remove();
                        this.$$elementForDisplay = null;
                    }

                    if (!dataSource || !dataSourceProperty)
                    {
                        this.textSet(String.empty);
                        return;
                    }

                    var
                        dataSourcePropertyValue = dataSource.propertyValueByPathGet(dataSourceProperty),
                        dataSourcePropertyValueType = window.objectHelper.typeOf(dataSourcePropertyValue),
                        stringForDisplay = String.empty,
                        urlProtocolsToLink = [
                            "http://",
                            "https://"
                        ];

                    if (dataSourcePropertyValue !== undefined && dataSourcePropertyValue !== null)
                    {
                        switch (dataSourcePropertyValueType)
                        {
                            case "boolean":
                                {
                                    switch (this.booleanStyleGet())
                                    {
                                        case namespace.TableCell.booleanStyle.yesNo:
                                            stringForDisplay = dataSourcePropertyValue ? "Yes" : "No";
                                            break;
                                        case namespace.TableCell.booleanStyle.tickCross:
                                            this.$$elementForDisplay =
                                                $$.create$$({
                                                    nodeName: "i",
                                                    attributes: { "class": dataSourcePropertyValue ? "check icon" : "times icon" }
                                                });

                                            break;
                                        case namespace.TableCell.booleanStyle.tickNoCross:
                                            this.$$elementForDisplay =
                                                $$.create$$({
                                                    nodeName: "i",
                                                    attributes: { "class": dataSourcePropertyValue ? "check icon" : String.empty }
                                                });
                                            break;
                                        default:
                                            stringForDisplay = dataSourcePropertyValue ? "True" : "False";
                                            break;
                                    }
                                    break;
                                }
                            case "date":
                                {
                                    stringForDisplay = dataSourcePropertyValue.toString(formatString ? formatString : "dd/MM/yyyy HH:mm:ss");
                                    break;
                                }
                            case "number":
                                {
                                    stringForDisplay = dataSourcePropertyValue.toStringFormat(formatString);
                                    break;
                                }
                            case "string":
                                {
                                    if (dataSourcePropertyValue.isDate && dataSourcePropertyValue.isDate(dataDateFormatString))
                                        // Date string
                                        stringForDisplay = Date.fromString(dataSourcePropertyValue, dataDateFormatString).toString(formatString ? formatString : "dd/MM/yyyy HH:mm:ss");
                                    else if (table?.linkUrlsGet() && urlProtocolsToLink.any(item =>dataSourcePropertyValue.startsWith(item, { ignoreCase: true })))
                                    {
                                        this.$$elementForDisplay = $$.create$$({ nodeName: "a", attributes: { target: "_system" } });
                                        this.$$elementForDisplay.attr("href", dataSourcePropertyValue);
                                        this.$$elementForDisplay.text(dataSourcePropertyValue);
                                        this.$$elementForDisplay.on("click mousedown mouseup", evt =>
                                        {
                                            evt.stopPropagation();
                                        });
                                    }
                                    else
                                        stringForDisplay = dataSourcePropertyValue.toString();
                                    break;
                                }
                            default:
                                {
                                    stringForDisplay = dataSourcePropertyValue.toString();
                                    break;
                                }
                        }
                    }

                    if (this.$$elementForDisplay)
                    {
                        this.textSet(null);
                        this.$$contentsElement.append(this.$$elementForDisplay);
                    }
                    else
                        this.textSet(stringForDisplay);
                },

                // Event Handlers
                onDataSourcePropertyValueChanged: function (evt, change)
                {
                    var
                        self = evt.data.self;

                    if (change.path !== self.dataSourcePropertyGet())
                        return;

                    self.refreshFromDataSource();
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.booleanStyle = {
                none: "none",
                yesNo: "yesNo",
                tickCross: "tickCross",
                tickNoCross: "tickNoCross"
            };

            classConstructor.allowedParentControlClasses = [
                "seriouslyrad.ui.web.TableRow"
            ];

            classConstructor.create = options =>
            {
                return new classConstructor({
                    table: options.table,
                    tableColumn: options.tableColumn,
                    tableRow: options.tableRow,
                    dataSourceProperty: options.tableColumn.dataSourcePropertyGet(),
                    formatString: options.tableColumn.formatStringGet()
                });
            };

            classConstructor.createLightweightContent = ($$tableCell, tableColumn, rowDataSource) =>
            {
                var
                    control = $$tableCell.dataGet("control") || {};

                control.tableColumn = tableColumn;
                control.rowDataSource = rowDataSource;
                control.viewControl =
                    new namespace.Text({
                        dataSourceProperty: control.tableColumn.dataSourcePropertyGet()
                    })
                        .appendTo($$tableCell);

                control.viewControl.show();

                if (control.viewControl.dataSourceSet)
                    control.viewControl.dataSourceSet(rowDataSource);

                $$tableCell.data("control", control);
            };
        }
    });

    // Table Cell (Icon)
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "TableCellIcon",
        inherits: "TableCellBase",
        properties: [
            { name: "icon", type: "string" },
            { name: "iconDataSourcePath", type: "string" },
            { name: "iconMobile", type: "string" }
        ],
        propertyAttributes: [
            {
                propertyName: "icon",
                designer: {
                    category: "Appearance",
                    displayName: "Icon"
                }
            }
        ],
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-table-icon-cell");

                // Trigger Property Changes
                this.iconTriggerChange();
                this.iconMobileTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _createElement: function ()
                {
                    this.super._createElement();

                    this.$$contentsElement.hide();

                    var
                        $$containerElement = this.$$containerElementGet();

                    this.$$icon =
                        $$.create$$({
                            nodeName: "i",
                            attributes: { "class": "rad-device-desktop" },
                            children: [{ nodeName: "span" }]
                        }).appendTo($$containerElement);
                    this.$$iconMobile =
                        $$.create$$({
                            nodeName: "i",
                            attributes: { "class": "rad-device-mobile" },
                            children: [{ nodeName: "span" }]
                        }).appendTo($$containerElement);
                },
                _dataSourceChanged: function (change)
                {
                    this.super._dataSourceChanged(change);
                    this._updateIconFromDataSource();
                },
                _iconChanged: function (change)
                {
                    if (change.originalValue)
                        this.$$icon.removeClass(change.originalValue);

                    if (change.currentValue)
                        this.$$icon.addClass(change.currentValue);
                },
                _iconDataSourcePathChanged: function (change)
                {
                    if (change.originalValue)
                        this.iconSet(null);

                    this._updateIconFromDataSource();
                },
                _iconMobileChanged: function (change)
                {
                    if (change.originalValue)
                        this.$$iconMobile.removeClass(change.originalValue);

                    if (change.currentValue)
                        this.$$iconMobile.addClass(change.currentValue);
                },
                _updateIconFromDataSource: function ()
                {
                    var
                        dataSource = this.dataSourceGet();

                    if (!dataSource)
                        return;

                    var
                        iconDataSourcePath = this.iconDataSourcePathGet();

                    if (iconDataSourcePath)
                    {
                        var
                            iconValue = dataSource.propertyValueByPathGet(iconDataSourcePath);

                        this.iconSet(iconValue ? String.format("rad-icon-{0}-16", iconValue) : null);
                        this.iconMobileSet(iconValue ? String.format("rad-icon-{0}-48", iconValue) : null);
                    }
                },

                // Event Handlers
                onDataSourcePropertyValueChanged: function (evt)
                {
                    evt.data.self._updateIconFromDataSource();
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.allowedParentControlClasses = [
                "seriouslyrad.ui.web.TableRow"
            ];

            classConstructor.create = options =>
            {
                return new classConstructor({
                    table: options.table,
                    tableColumn: options.tableColumn,
                    tableRow: options.tableRow,
                    icon: options.table.rowIconGet(),
                    iconDataSourcePath: options.table.rowIconDataSourcePathGet(),
                    iconMobile: options.table.rowIconMobileGet()
                });
            };
        }
    });

    // Table Cell (Image)
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "TableCellImage",
        inherits: "TableCellBase",
        properties: [
            { name: "dataSourceProperty", type: "string" },
            { name: "image", type: "string" },
            { name: "imageMaxHeight", type: "string" },
            { name: "imageMaxWidth", type: "string" }
        ],
        propertyAttributes: [
            {
                propertyName: "image",
                designer: {
                    category: "Appearance",
                    displayName: "Image (Url)"
                }
            },
            {
                propertyName: "imageMaxHeight",
                designer: {
                    category: "Appearance",
                    displayName: "Image Maximum Allowed Height"
                }
            },
            {
                propertyName: "imageMaxWidth",
                designer: {
                    category: "Appearance",
                    displayName: "Image Maximum Allowed Width"
                }
            }
        ],
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-table-image-cell");

                // Trigger Property Changes
                this.imageTriggerChange();
                this.imageMaxHeightTriggerChange();
                this.imageMaxWidthTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _createElement: function ()
                {
                    this.super._createElement();

                    this.$$contentsElement.hide();

                    var
                        $$containerElement = this.$$containerElementGet();

                    this.$$image =
                        $$.create$$({
                            nodeName: "img",
                            attributes: { "class": "rad-control-table-image-cell-image" }
                        }).appendTo($$containerElement);
                },
                _dataSourcePropertyChanged: function (change)
                {
                    this.refreshFromDataSource();
                },
                _imageChanged: function (change)
                {
                    if (change.currentValue)
                    {
                        this.$$image
                            .attr(
                                "src",
                                change.currentValue.startsWith("/") && !change.currentValue.startsWith(window.applicationInformation.virtualDirectory)
                                    ? window.applicationInformation.virtualDirectory + change.currentValue.substr(1)
                                    : change.currentValue
                            );
                    }
                    else
                        this.$$image.removeAttr("src");
                },
                _imageMaxHeightChanged: function (change)
                {
                    this.$$image.css("max-height", change.currentValue);
                },
                _imageMaxWidthChanged: function (change)
                {
                    this.$$image.css("max-width", change.currentValue);
                },
                _refreshFromDataSource: function ()
                {
                    this.super._refreshFromDataSource();

                    var
                        dataSource = this.dataSourceGet(),
                        dataSourceProperty = this.dataSourcePropertyGet();

                    if (!dataSource || !dataSourceProperty)
                    {
                        this.imageSet(String.empty);
                        return;
                    }

                    var
                        dataSourcePropertyValue = dataSource.propertyValueByPathGet(dataSourceProperty),
                        stringForDisplay = String.empty;

                    if (dataSourcePropertyValue !== undefined && dataSourcePropertyValue !== null)
                        stringForDisplay = dataSourcePropertyValue.toString();

                    this.imageSet(stringForDisplay);
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.allowedParentControlClasses = [
                "seriouslyrad.ui.web.TableRow"
            ];

            classConstructor.create = options =>
            {
                return new classConstructor({
                    table: options.table,
                    tableColumn: options.tableColumn,
                    tableRow: options.tableRow,
                    dataSourceProperty: options.tableColumn.dataSourcePropertyGet(),
                    imageMaxHeight: options.tableColumn.imageMaxHeightGet(),
                    imageMaxWidth: options.tableColumn.imageMaxWidthGet()
                });
            };
        }
    });

    // Table Cell (Selection)
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "TableCellSelection",
        inherits: "TableCellBase",
        createPropertyDefaults: namespace =>
        {
            return {
                selectionIcon: "square outline icon",
                selectionIconMobile: "square outline icon",
                selectionIconSelected: "checkmark box icon",
                selectionIconMobileSelected: "checkmark box icon"
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-table-selection-cell");
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _bindEvents: function ()
                {
                    this.super._bindEvents();

                    this.checkBox.on("valueChanged", { self: this }, this.onCheckBoxValueChanged);
                },
                _createElement: function ()
                {
                    this.super._createElement();

                    this.$$contentsElement.hide();

                    var
                        $$containerElement = this.$$containerElementGet();

                    this.checkBox =
                        new namespace.CheckBox()
                            .appendTo($$containerElement);
                },

                // Public Methods
                deselect: function ()
                {
                    this.checkBox.valueSet(false);
                },
                select: function ()
                {
                    this.checkBox.valueSet(true);
                },

                // Event Handlers
                onCheckBoxValueChanged: function (evt, change)
                {
                    var
                        $$tableRow = evt.data.self.$$elementGet().closest(".rad-control-table-row"),
                        $$table = $$tableRow.closest(".rad-control-table"),
                        tableRow = $$tableRow.radControl(),
                        table = $$table.radControl();

                    if (table && tableRow)
                        table._setRowSelectionState(tableRow, change.currentValue);
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.allowedParentControlClasses = [
                "seriouslyrad.ui.web.TableRow"
            ];

            classConstructor.create = options =>
            {
                return new classConstructor({
                    table: options.table,
                    tableColumn: options.tableColumn,
                    tableRow: options.tableRow
                });
            };

            classConstructor.createLightweightContent = ($$tableCell, tableColumn, rowDataSource) =>
            {
                $$tableCell.addClass("rad-control-table-selection-cell");

                var
                    checkBox = new namespace.CheckBox().appendTo($$tableCell);

                checkBox.on("valueChanged", (evt, change) =>
                {
                    var
                        $$tableRow = $$(evt.target).closest("tr"),
                        $$table = $$tableRow.closest(".rad-control-table"),
                        table = $$table.radControl();

                    if (table && $$tableRow.length)
                        table._setRowSelectionState($$tableRow, change.currentValue);
                });

                var
                    $$tableRow = $$tableCell.closest("tr");

                $$tableRow.on("click", evt =>
                {
                    checkBox.valueSet(!checkBox.valueGet());
                });
            };
        }
    });

    // Table Cell (Tick)
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "TableCellTick",
        inherits: "TableCell",
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-table-cell-tick");
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _createElement: function ()
                {
                    this.super._createElement();

                    this.$$contentsElement.hide();

                    var
                        $$containerElement = this.$$containerElementGet();

                    this.$$svg =
                        window.svgHelper.createSvg("icon-tick")
                            .hide()
                            .appendTo($$containerElement);
                },
                _updateIconFromDataSource: function ()
                {
                    var
                        dataSourceProperty = this.dataSourcePropertyGet(),
                        dataSource = this.dataSourceGet(),
                        value = dataSourceProperty && dataSource ? dataSource.propertyValueByPathGet(dataSourceProperty) : null;

                    if (value)
                        this.$$svg.show();
                    else
                        this.$$svg.hide();
                },

                // Public Methods
                refreshFromDataSource: function ()
                {
                    this._updateIconFromDataSource();
                    this.super.refreshFromDataSource();
                },
                toggle: function ()
                {
                    var
                        dataSourceProperty = this.dataSourcePropertyGet(),
                        dataSource = this.dataSourceGet();

                    if (!dataSourceProperty || !dataSource)
                        return;

                    var
                        value = dataSource.propertyValueByPathGet(dataSourceProperty);

                    dataSource.propertyValueByPathSet(dataSourceProperty, value ? false : true);
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.create = options =>
            {
                return new classConstructor({
                    table: options.table,
                    tableColumn: options.tableColumn,
                    tableRow: options.tableRow,
                    dataSourceProperty: options.tableColumn.dataSourcePropertyGet(),
                    formatString: options.tableColumn.formatStringGet()
                });
            };
        }
    });

    // Table Column (Tick)
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "TableColumnTick",
        inherits: "TableColumn",
        createPropertyDefaults: namespace =>
        {
            return {
                tableCellClass: namespace.TableCellTick
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-table-column-tick");
            };
        }
    });

    // Table (Select Items)
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "TableSelectItems",
        inherits: "Table",
        properties: [
            { name: "allowMultipleSelection", type: "boolean" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                allowMultipleSelection: false
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-table-select-items");
            };
        },
        createPrototype: namespace =>
        {
            return {
                // Public Methods
                deselectAll: function ()
                {
                    var
                        tableRows = this.rowsGet();

                    tableRows.each(item =>
                    {
                        var
                            tableRowDataSource = item.dataSourceGet();

                        if (!tableRowDataSource)
                            return;

                        tableRowDataSource.propertyValueByPathSet("selected", false);
                    });
                },
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            $$(document).on("click", ".rad-control-table-select-items table tr", evt =>
            {
                evt.preventDefault();
                evt.stopPropagation();

                var
                    $$target = $$(evt.currentTarget),
                    tr = $$target.radControl();

                if (!tr)
                    return;

                var
                    tableCellTick = tr.controlsGet().firstOrDefault(item => item instanceof namespace.TableCellTick);

                if (!tableCellTick)
                    return;

                var
                    $$tableCellTick = tableCellTick.$$elementGet(),
                    $$tableTarget = $$tableCellTick.closest(".rad-control-table"),
                    table = $$tableTarget.radControl();

                if (!table)
                    return;

                if (!table.allowMultipleSelectionGet())
                    table.deselectAll();

                tableCellTick.toggle();
            });
        }
    });

    // Validation Panel
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "ValidationPanel",
        inherits: "Panel",
        properties: [
            { name: "shouldPluralizeValidationErrorText", type: "boolean" },
            { name: "shouldScrollToTop", type: "boolean" },
            { name: "titleTextWhenValidationError", type: "string" },
            { name: "validationErrors", type: "array" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                shouldPluralizeValidationErrorText: true,
                shouldScrollToTop: true,
                titleTextWhenValidationError: "Validation error",
                visible: false
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-validation-panel");

                // Trigger Property Changes
                this.titleTextWhenValidationErrorTriggerChange();
                this.validationErrorsTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _createElement: function ()
                {
                    this.super._createElement();

                    var
                        $$element = this.$$elementGet();

                    this.$$titleElement = $$.create$$({ nodeName: "h3" }).appendTo($$element);
                    this.$$listElement = $$.create$$({ nodeName: "ul" }).appendTo($$element);
                },
                _validationErrorsChanged: function (change)
                {
                    this.setErrorMessages(
                        change.currentValue
                            ? change.currentValue.select(item => item.errorMessage)
                            : null
                    );
                },

                // Public Methods
                setErrorMessages: function (messages, type, forceVisible)
                {
                    var
                        self = this,
                        titleTextWhenValidationError = self.titleTextWhenValidationErrorGet();

                    type = type ? type : "Validation error";

                    self.$$listElement.empty();

                    if (String.isNullOrEmpty(titleTextWhenValidationError) && type === "Validation error")
                        this.$$titleElement.hide();
                    else
                    {
                        this.$$titleElement.show();

                        self.$$titleElement.text(
                            type === "Validation error"
                                ? titleTextWhenValidationError + (messages?.length > 1 && self.shouldPluralizeValidationErrorTextGet() ? "s" : String.empty)
                                : type
                        );
                    }

                    if (messages?.length)
                    {
                        messages.each(item =>
                        {
                            self.$$listElement.append(String.formatWithHtmlEncode("<li>{0}</li>", item));
                        });

                        self.show();
                    }
                    else
                        self.hide();

                    if (forceVisible)
                        self.show();
                },
                show: function ()
                {
                    this.super.show();

                    if (this.shouldScrollToTopGet())
                    {
                        var
                            page = this.pageGet();

                        if (page)
                            page.scrollToTop();
                    }
                }
            };
        }
    });

    // Version Information
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "VersionInformation",
        inherits: "Control",
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-version-information");
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _createElement: function ()
                {
                    this.super._createElement();

                    var
                        $$element = this.$$elementGet(),
                        versionInformation = window.AppVersion ? String.format("v{0} (Build {1})", window.AppVersion.version, window.AppVersion.build) : null;

                    this.$$span = $$.create$$({ nodeName: "span", text: versionInformation });
                    $$element.append(this.$$span);

                    if (!versionInformation)
                        this.hide();
                    else
                        this.show();
                }
            };
        }
    });

    // #region Widgets

    // Widget (Base)
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "Widget",
        inherits: "Panel",
        properties: [
            { name: "autoTrigger", type: "boolean"},
            { name: "columns", type: "array" },
            { name: "dataServiceId", type: "string" },
            { name: "dataServiceOperation", type: "string" },
            { name: "dataServiceParameters", type: "object" },
            { name: "dataServiceParametersFromPageDataSource", type: "object" },
            { name: "noDataText", type: "string" },
            { name: "showEdit", type: "boolean" },
            { name: "svgKey", type: "string" },
            { name: "titleText", type: "string" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                autoTrigger: true,
                dataServiceParameters: {},
                dataServiceParametersFromPageDataSource: null,
                noDataText: "No data!",
                showEdit: false,
                svgKey: null,
                titleText: null
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-widget rad-style-bordered");

                // Trigger Property Changes
                this.noDataTextTriggerChange();
                this.showEditTriggerChange();
                this.svgKeyTriggerChange();
                this.titleTextTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _bindEvents: function ()
                {
                    this.super._bindEvents();

                    this.buttonEdit.on("click", { self: this }, this.onButtonEditClicked);
                },
                _createElement: function ()
                {
                    this.super._createElement();

                    var
                        $$element = this.$$elementGet();

                    // #region Panel Header

                    this.paneHeader =
                        new seriouslyrad.ui.web.Panel({ cssClass: "rad-panel-header" })
                            .appendTo($$element);

                    this.paneleft =
                        new seriouslyrad.ui.web.Panel({ cssClass: "rad-panel-left" })
                            .appendTo(this.paneHeader);

                    this.svg =
                        new seriouslyrad.ui.web.SVG({ elementType: "span" })
                            .appendTo(this.paneleft);

                    this.$$titleText = $$.create$$({
                        nodeName: "span",
                        children: [
                            { text: String.empty }
                        ]
                    }).appendTo(this.paneleft.$$elementGet());

                    this.panelRight =
                        new seriouslyrad.ui.web.Panel({ cssClass: "rad-panel-right" })
                            .appendTo(this.paneHeader);

                    this.buttonEdit =
                        new seriouslyrad.ui.web.Button({ inline: true, cssClass: "rad-link-button", text: "Edit" })
                            .appendTo(this.panelRight);

                    // #endregion

                    // #region Widget contents

                    this.panelContentsWrapper =
                        new seriouslyrad.ui.web.Panel({ cssClass: "rad-panel-wrapper" })
                            .appendTo($$element);

                    this.$$loader =
                        $$.create$$({
                            nodeName: "div",
                            attributes: { "class": "rad-loader" },
                            children: [{ nodeName: "div", attributes: { "class": "ui active centered inline loader" } }]
                        }).appendTo(this.panelContentsWrapper.$$elementGet());

                    this.$$noData =
                        $$.create$$({
                            nodeName: "div",
                            attributes: { "class": "rad-no-data" },
                            children: [{ nodeName: "div", attributes: { "class": "inner", text: "No data!" } }]
                        }).appendTo(this.panelContentsWrapper.$$elementGet());

                    // #endregion
                },
                _loadDataAsync: function (options, showLoading)
                {
                    return (
                        application.webApiClient
                            .createApiMethodRequest("DataService", "CallDataService", { id: this.dataServiceIdGet(), operation: this.dataServiceOperationGet(), data: (options || {}).toJson() }, null, showLoading)
                            .executeAsync()
                    );
                },
                _pageChanged: function (change)
                {
                    this.super._pageChanged(change);

                    if (change.originalValue)
                        change.originalValue.off("dataSourceChanged", { self: this }, this.onPageDataSourceChanged);

                    if (change.currentValue)
                        change.currentValue.on("dataSourceChanged", { self: this }, this.onPageDataSourceChanged);
                },
                _noDataTextChanged: function (change)
                {
                    this.$$noData.find(">.inner").text(change.currentValue);
                },
                _shouldLoad: function ()
                {
                    var
                        page = this.pageGet(),
                        autoTrigger = this.autoTriggerGet();

                    if (!page)
                        return false;

                    return (
                        page.activatedGet()
                        && this._isShown()
                        && autoTrigger
                    );
                },
                _showEditChanged: function (change)
                {
                    if (change.currentValue)
                        this.buttonEdit.show();
                    else
                        this.buttonEdit.hide();
                },
                _svgKeyChanged: function (change)
                {
                    this.svg.svgKeySet(change.currentValue);
                },
                _titleTextChanged: function (change)
                {
                    this.$$titleText.text(change.currentValue);
                    this.$$titleText.hide();

                    if (!String.isNullOrWhitespace(change.currentValue))
                        this.$$titleText.show();
                },
                _updateDisplay: function (data)
                {
                    /* Intentionally empty */
                },

                // Public Methods
                loadDataAsync: function (force)
                {
                    var
                        self = this;

                    if (!force && !self._shouldLoad())
                        return Promise.resolve();

                    var
                        dataServiceParameters = self.dataServiceParametersGet(),
                        dataServiceParametersFromPageDataSource = self.dataServiceParametersFromPageDataSourceGet(),
                        dataServiceParametersFromPageDataSourceKeys = dataServiceParametersFromPageDataSource ? Object.keys(dataServiceParametersFromPageDataSource) : [];

                    self.addCssClass("rad-state-loading");
                    self.removeCssClass("rad-state-no-data");

                    if (Array.isArray(dataServiceParametersFromPageDataSourceKeys) && dataServiceParametersFromPageDataSourceKeys.length)
                    {
                        var
                            page = self.pageGet(),
                            pageDataSource = page ? page.dataSourceGet() : null,
                            data = pageDataSource ? pageDataSource.dataGet() : null;

                        if (pageDataSource)
                            self.dataSourceSet(pageDataSource);

                        dataServiceParameters = {};

                        if (data)
                        {
                            dataServiceParametersFromPageDataSourceKeys
                                .each(item =>
                                {
                                    dataServiceParameters[item] = data[dataServiceParametersFromPageDataSource[item]];
                                });
                        }
                    }

                    return (
                        self
                            ._loadDataAsync(dataServiceParameters)
                            .then(data =>
                            {
                                self._updateDisplay(data);
                            })
                            .finally(() =>
                            {
                                self.removeCssClass("rad-state-loading");
                            })
                    );
                },

                // Event Handlers
                onAncestorVisibilityChanged: function (evt, change)
                {
                    if (change.currentValue && evt.data.self.autoTriggerGet())
                        evt.data.self.loadDataAsync();
                },
                onButtonEditClicked: function (evt)
                {
                    evt.data.self.trigger("editClicked");
                },
                onPageActivated: function (evt, eventData)
                {
                    var
                        self = evt.data.self;

                    if (self._shouldLoad())
                        eventData.promises.push(self.loadDataAsync());
                },
                onPageDataSourceChanged: function (evt, change)
                {
                    var
                        self = evt.data.self;

                    self.dataSourceSet(change.currentValue);

                    if (change.originalValue && self._shouldLoad())
                        self.loadDataAsync();
                }
            };
        }
    });

    // Widget (Single Value)
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "WidgetSingleValue",
        inherits: "Widget",
        properties: [
            { name: "description", type: "string" },
            { name: "value", type: "string" },
            { name: "valuePlaceHolder", type: "string" },
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                description: String.empty,
                value: "0",
                valuePlaceHolder: "??"
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-widget-single-numeric");

                // Trigger Property Changes
                this.descriptionTriggerChange();
                this.valueTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _createElement: function ()
                {
                    this.super._createElement();

                    // #region Widget contents

                    this.panelContentsInner =
                        new seriouslyrad.ui.web.Panel({ cssClass: "rad-panel-inner" })
                            .appendTo(this.panelContentsWrapper);

                    this.textValue =
                        new seriouslyrad.ui.web.Text({ cssClass: "rad-text-value", elementType: "div" })
                            .appendTo(this.panelContentsInner);

                    this.textDescription =
                        new seriouslyrad.ui.web.Text({ cssClass: "rad-text-description", elementType: "div" })
                            .appendTo(this.panelContentsInner);

                    // #endregion
                },
                _descriptionChanged: function (change)
                {
                    this.textDescription.textSet(change.currentValue);
                },
                _updateDisplay: function (data)
                {
                    var
                        newValue = data?.value || this.valuePlaceHolderGet();

                    this.valueSet(newValue);
                },
                _valueChanged: function (change)
                {
                    this.textValue.textSet(change.currentValue);
                }
            };
        }
    });

    // Widget (Double Value)
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "WidgetDoubleValue",
        inherits: "Widget",
        properties: [
            { name: "descriptionOne", type: "string" },
            { name: "descriptionTwo", type: "string" },
            { name: "valueOne", type: "string" },
            { name: "valueOnePlaceHolder", type: "string" },
            { name: "valueTwo", type: "string" },
            { name: "valueTwoPlaceHolder", type: "string" },
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                descriptionOne: String.empty,
                descriptionTwo: String.empty,
                valueOne: "0",
                valueOnePlaceHolder: "??",
                valueTwo: "0",
                valueTwoPlaceHolder: "??"
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-widget-double-numeric");

                // Trigger Property Changes
                this.valueOneTriggerChange();
                this.descriptionOneTriggerChange();
                this.valueTwoTriggerChange();
                this.descriptionTwoTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _createElement: function ()
                {
                    this.super._createElement();

                    // #region Widget contents

                    this.panelContentsInnerOne =
                        new seriouslyrad.ui.web.Panel({ cssClass: "rad-panel-inner" })
                            .appendTo(this.panelContentsWrapper);

                    this.textValueOne =
                        new seriouslyrad.ui.web.Text({ cssClass: "rad-text-value", elementType: "div" })
                            .appendTo(this.panelContentsInnerOne);

                    this.textDescriptionOne =
                        new seriouslyrad.ui.web.Text({ cssClass: "rad-text-description", elementType: "div" })
                            .appendTo(this.panelContentsInnerOne);

                    this.$$spacer =
                        $$.create$$({
                            nodeName: "div",
                            attributes: { "class": "rad-spacer" },
                        }).appendTo(this.panelContentsWrapper.$$elementGet());

                    this.panelContentsInnerTwo =
                        new seriouslyrad.ui.web.Panel({ cssClass: "rad-panel-inner" })
                            .appendTo(this.panelContentsWrapper);

                    this.textValueTwo =
                        new seriouslyrad.ui.web.Text({ cssClass: "rad-text-value", elementType: "div" })
                            .appendTo(this.panelContentsInnerTwo);

                    this.textDescriptionTwo =
                        new seriouslyrad.ui.web.Text({ cssClass: "rad-text-description", elementType: "div" })
                            .appendTo(this.panelContentsInnerTwo);

                    // #endregion
                },
                _descriptionOneChanged: function (change)
                {
                    this.textDescriptionOne.textSet(change.currentValue);
                },
                _descriptionTwoChanged: function (change)
                {
                    this.textDescriptionTwo.textSet(change.currentValue);
                },
                _updateDisplay: function (data)
                {
                    var
                        newValues = data && Array.isArray(data) ? data : [this.valueOnePlaceHolderGet(), this.valueTwoPlaceHolderGet()];

                    this.valueOneSet(!Object.isNullOrUndefined(newValues[0].value) ? newValues[0].value : this.valueOnePlaceHolderGet());
                    this.valueTwoSet(!Object.isNullOrUndefined(newValues[1].value) ? newValues[1].value : this.valueTwoPlaceHolderGet());
                },
                _valueOneChanged: function (change)
                {
                    this.textValueOne.textSet(change.currentValue);
                },
                _valueTwoChanged: function (change)
                {
                    this.textValueTwo.textSet(change.currentValue);
                }
            };
        }
    });

    // Widget (Key Value List)
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "WidgetKeyValueList",
        inherits: "Widget",
        properties: [
            { name: "displayMultiLine", type: "boolean" },
            { name: "value", type: "Array" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                displayMultiLine: false,
                value: [],
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-widget-key-value-list");

                // Trigger Property Changes
                this.displayMultiLineTriggerChange();
                this.valueTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _createElement: function ()
                {
                    this.super._createElement();

                    // #region Widget contents

                    this.panelContentsInner =
                        new seriouslyrad.ui.web.Panel({ cssClass: "rad-panel-inner" })
                            .appendTo(this.panelContentsWrapper);

                    // #endregion
                },
                _displayMultiLineChanged: function (change)
                {
                    if (change.currentValue)
                        this.addCssClass("rad-style-multi-line");
                    else
                        this.removeCssClass("rad-style-multi-line");

                    this._postProcessing();
                },
                _updateDisplay: function (data)
                {
                    var
                        newValue = data && Array.isArray(data) ? data : [];

                    this.valueSet(newValue);
                },
                _postProcessing: function ()
                {
                    var
                        $$panelContentsInnerElement = this.panelContentsInner.$$elementGet(),
                        multiLine = this.displayMultiLineGet();

                    $$panelContentsInnerElement.find(".rad-pair-value").each((index, element) =>
                    {
                        $$(element).html(multiLine ? $$(element).html().replace(/,/g, "<br />") : $$(element).html().replace(/<br \/>/g, ","));
                    });
                },
                _valueChanged: function (change)
                {
                    var
                        $$panelContentsInnerElement = this.panelContentsInner.$$elementGet();

                    this.panelContentsInner.controlsClear();
                    $$panelContentsInnerElement.empty();

                    if (!change.currentValue.length)
                    {
                        this.addCssClass("rad-state-no-data");
                        return;
                    }

                    this.removeCssClass("rad-state-no-data");

                    change.currentValue.forEach(item =>
                    {
                        $$.create$$({
                            nodeName: "div",
                            attributes: { "class": "rad-pair-container" },
                            children: [{
                                nodeName: "span",
                                attributes: { "class": "rad-pair-key" },
                                text: String.format("{0}:", item.key)
                            }, {
                                nodeName: "span",
                                attributes: { "class": "rad-pair-value" },
                                text: item.value
                            }]
                        }).appendTo($$panelContentsInnerElement);
                    });

                    this._postProcessing();
                }
            };
        }
    });

    // Widget (Percentage Graph)
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "WidgetPercentageGraph",
        inherits: "WidgetDoubleValue",
        createPropertyDefaults: namespace =>
        {
            return {
                descriptionOne: "Used",
                descriptionTwo: "Capacity",
                valueOne: "0",
                valueTwo: "0"
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-widget-percentage-graph");
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _createElement: function ()
                {
                    this.super._createElement();

                    // #region Widget contents

                    this.panelContentsInnerThree =
                        new seriouslyrad.ui.web.Panel({ cssClass: "rad-panel-inner rad-panel-chart" })
                            .appendTo(this.panelContentsWrapper, String.format("#{0}", this.panelContentsInnerTwo.controlId));

                    this.ringChart =
                        new seriouslyrad.ui.web.RingChart()
                            .appendTo(this.panelContentsInnerThree);

                    this.$$spacer.detach();

                    // #endregion
                },
                _updateDisplay: function (data)
                {
                    this.super._updateDisplay(data);

                    var
                        newValues = data && Array.isArray(data) ? data : [this.valueOnePlaceHolderGet(), this.valueTwoPlaceHolderGet(), "0"],
                        newPercentage = parseFloat(newValues[2].value);

                    this.ringChart.valueSet(newPercentage);
                }
            };
        }
    });

    // Widget (Progress Graph)
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "WidgetProgressGraph",
        inherits: "WidgetDoubleValue",
        properties: [
            { name: "descriptionThree", type: "string" },
            { name: "units", type: "string" },
            { name: "valueThree", type: "string" },
            { name: "valueThreePlaceHolder", type: "string" },
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                descriptionOne: "Start",
                descriptionTwo: "Current",
                descriptionThree: "End",
                valueOne: "0",
                valueTwo: "0",
                valueThree: "0",
                valueThreePlaceHolder: "??",
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-widget-progress-graph");

                this.valueThreeTriggerChange();
                this.descriptionThreeTriggerChange();
                this.unitsTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _createElement: function ()
                {
                    this.super._createElement();

                    // #region Widget contents

                    this.panelContentsInnerTwo.addCssClass("rad-panel-inner-wide");
                    this.textValueTwo.addCssClass("rad-text-value-large");

                    this.panelContentsInnerThree =
                        new seriouslyrad.ui.web.Panel({ cssClass: "rad-panel-inner" })
                            .appendTo(this.panelContentsWrapper);

                    this.textValueThree =
                        new seriouslyrad.ui.web.Text({ cssClass: "rad-text-value", elementType: "div" })
                            .appendTo(this.panelContentsInnerThree);

                    this.textDescriptionThree =
                        new seriouslyrad.ui.web.Text({ cssClass: "rad-text-description", elementType: "div" })
                            .appendTo(this.panelContentsInnerThree);

                    this.textUnits =
                        new seriouslyrad.ui.web.Text({ cssClass: "rad-text-description rad-text-units", elementType: "div" })
                            .prependTo(this.panelContentsInnerTwo);

                    this.panelContentsInnerChart =
                        new seriouslyrad.ui.web.Panel({ cssClass: "rad-panel-inner rad-panel-chart" })
                            .appendTo(this.panelContentsWrapper);

                    this.chart =
                        new seriouslyrad.ui.web.ProgressBarChart()
                            .appendTo(this.panelContentsInnerChart);

                    this.$$spacer.detach();

                    // #endregion
                },
                _descriptionThreeChanged: function (change)
                {
                    this.textDescriptionThree.textSet(change.currentValue);
                },
                _unitsChanged: function (change)
                {
                    this.textUnits.textSet(change.currentValue);
                },
                _updateDisplay: function (data)
                {
                    this.super._updateDisplay(data);

                    var
                        newValues = data && Array.isArray(data) ? data : [this.valueOnePlaceHolderGet(), this.valueTwoPlaceHolderGet(), this.valueThreePlaceHolderGet(), 0],
                        newPercentage = parseFloat(newValues[3].value);

                    this.valueThreeSet(!Object.isNullOrUndefined(newValues[2].value) ? newValues[2].value : this.valueThreePlaceHolderGet());

                    this.chart.valueSet(newPercentage);
                },
                _valueThreeChanged: function (change)
                {
                    this.textValueThree.textSet(change.currentValue);
                }
            };
        }
    });

    // #endregion

    // Wizard
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "Wizard",
        inherits: "Panel",
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-wizard");

                this.isAnimating = false;
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _createChildControls: function ()
                {
                    this.super._createChildControls();

                    this.panels = this.controlsGet();
                    this.panels.each((item, index) =>
                    {
                        if (index > 0)
                            item.$$elementGet().detach();
                    });
                    this.currentStep = this.panels.length ? 0 : null;
                },
                _createContainerElement: function ()
                {
                    var
                        $$element = this.$$elementGet(),
                        $$containerElement = $$.create$$({ nodeName: "div" }).appendTo($$element);

                    this.$$containerElementSet($$containerElement);
                },

                // Public Methods
                controlsClear: function (detach)
                {
                    var
                        returnValue = this.super.controlsClear(detach);

                    this.panels = [];
                    this.currentStep = null;

                    return returnValue;
                },
                goToStep: function (step)
                {
                    if (step < 0 || step > this.panels.length - 1)
                        return;

                    this.navigateToPanelAsync(this.panels[step], step < this.currentStep);
                },
                navigateToPanelAsync: function (panel, back)
                {
                    var
                        self = this;

                    if (!panel || self.isAnimating)
                        return Promise.resolve();

                    self.isAnimating = true;

                    return (
                        new Promise(
                            resolve =>
                            {
                                if (!self.panels.contains(panel))
                                    self.panels.push(panel);

                                var
                                    $$element = self.$$elementGet(),
                                    $$containerElement = self.$$containerElementGet(),
                                    currentStep = self.currentStep,
                                    currentPanel = currentStep >= 0 && currentStep < self.panels.length ? self.panels[currentStep] : null,
                                    $$currentPanel = currentPanel ? currentPanel.$$elementGet() : null,
                                    nextStep = self.panels.indexOf(panel);

                                if (panel === currentPanel)
                                {
                                    resolve();
                                    return;
                                }

                                if (!$$currentPanel || !self._isShown())
                                {
                                    $$containerElement.children().detach();
                                    self.append(panel);
                                    self.currentStep = nextStep;
                                    resolve();
                                    return;
                                }

                                var
                                    nextPanel = panel,
                                    $$nextPanel = nextPanel.$$elementGet(),
                                    transitionTimeHeight = 0.25,
                                    transitionTimeLeft = 0.5,
                                    currentHeight = $$containerElement.outerHeight();

                                // Fix styles
                                $$currentPanel.css({
                                    float: "left",
                                    width: "50%"
                                });
                                $$nextPanel.css({
                                    float: "left",
                                    width: "50%"
                                });
                                $$containerElement.css({
                                    height: currentHeight,
                                    left: back ? "-100%" : "0%",
                                    overflow: "hidden",
                                    width: "200%"
                                });
                                $$element.css({
                                    overflow: "hidden"
                                });

                                // Add new panel
                                if (!back)
                                    self.append(panel);
                                else
                                    self.prepend(panel);

                                var
                                    endAnimationPropertiesSeen = {};

                                // Setup animation end event
                                $$containerElement.on(TRANSITION_END_EVENTS, evt =>
                                {
                                    endAnimationPropertiesSeen[evt.originalEvent.propertyName] = true;

                                    if (!endAnimationPropertiesSeen.height || !endAnimationPropertiesSeen.left)
                                        return;

                                    $$containerElement.off(TRANSITION_END_EVENTS);

                                    // Reset styles
                                    $$element.css({
                                        overflow: String.empty
                                    });
                                    $$containerElement.css({
                                        height: String.empty,
                                        left: String.empty,
                                        overflow: String.empty,
                                        transition: String.empty,
                                        width: String.empty
                                    });
                                    $$nextPanel.css({
                                        float: String.empty,
                                        width: String.empty
                                    });
                                    $$currentPanel.css({
                                        float: String.empty,
                                        width: String.empty
                                    });

                                    // Remove previous panel
                                    $$currentPanel.detach();

                                    self.currentStep = nextStep;
                                    panel.focus();
                                    resolve();
                                });

                                // Scroll up
                                const
                                    $$scrollParent = self.getScrollParent(),
                                    scrollPromise =
                                        $$scrollParent && $$scrollParent.length
                                            ? $$scrollParent.stop().animate({ scrollTop: 0 }, 500).promise()
                                            : Promise.resolve();

                                scrollPromise
                                    .then(() =>
                                    {
                                        var
                                            stepHeight = $$nextPanel.outerHeight();

                                        endAnimationPropertiesSeen.height = currentHeight === stepHeight;

                                        // Animate to new panel
                                        $$containerElement.css({
                                            height: stepHeight,
                                            left: back ? "0%" : "-100%",
                                            transition:
                                                currentHeight > stepHeight
                                                    ? String.format("height {0}s ease {1}s, left {1}s ease", transitionTimeHeight, transitionTimeLeft)
                                                    : String.format("height {0}s ease, left {1}s ease {0}s", transitionTimeHeight, transitionTimeLeft)
                                        });
                                    });
                            })
                            .finally(() =>
                            {
                                self.isAnimating = false;
                            })
                    );
                },
                nextStep: function ()
                {
                    this.goToStep(this.currentStep + 1);
                },
                previousStep: function ()
                {
                    this.goToStep(this.currentStep - 1);
                },
                totalStepsGet: function ()
                {
                    return this.panels.length;
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.allowedChildControlClasses = [
                "seriouslyrad.ui.web.Panel"
            ];
        }
    });

    // #endregion

    // #region Input Controls

    // #region Mixins

    classFactory.createMixin({
        namespace: "seriouslyrad.ui.web",
        name: "CopyValueToClipboardMixin",
        createPrototype: namespace =>
        {
            return {
                // Public Methods
                copyValueToClipboard: function ()
                {
                    var textArea = document.createElement("textarea");
                    textArea.value = this.valueGet();
                    textArea.setAttribute("readonly", String.empty);
                    textArea.style.position = "absolute";
                    textArea.style.left = "-9999px";
                    document.body.appendChild(textArea);
                    textArea.select();
                    document.execCommand("copy");
                    document.body.removeChild(textArea);
                }
            };
        }
    });

    classFactory.createMixin({
        namespace: "seriouslyrad.ui.web",
        name: "SoftDeleteEnabledListMixin",
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _getSoftDeletedListItemAsync: function (info)
                {
                    // Try and fetch record from soft-deleted records
                    return (
                        window.application.webApiClient
                            .createEntityGetRequest(
                                info.primaryEntity,
                                info.requiredId,
                                [
                                    "id",
                                    "deletedGuid",
                                    info.primaryEntityDescriptionProperty
                                ],
                                { "RAD-Option-Include-Soft-Deleted": true }
                            )
                            .executeAsync()
                            .then(softDeletedRecord =>
                            {
                                info.listData.push(softDeletedRecord);
                                info.listData = info.listData.sort(item => window.objectHelper.propertyValueByPathGet(item, info.primaryEntityOrderProperty));
                            })
                    );
                }
            };
        }
    });

    // #endregion

    // Calendar
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "Calendar",
        inherits: "InputControl",
        properties: [
            { name: "dateFormat", type: "string" },
            { name: "disableMinute", type: "string" },
            { name: "disableMonth", type: "string" },
            { name: "disableYear", type: "string" },
            { name: "iconLocation", type: "string" },
            { name: "placeholder", type: "string" },
            { name: "type", type: "string" },
            { name: "updateOnBlur", type: "string" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                dateFormat: null,
                disableMinute: false,
                disableMonth: false,
                disableYear: false,
                iconLocation: "left",
                type: namespace.Calendar.types.datetime,
                updateOnBlur: false
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-calendar");
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _bindEvents: function ()
                {
                    this.super._bindEvents();

                    this.on("blur", "input", { self: this }, this.onBlur);
                },
                _createElement: function ()
                {
                    var
                        self = this;

                    self.super._createElement();

                    var
                        $$element = self.$$elementGet(),
                        page = self.pageGet(),
                        updateOnBlur = self.updateOnBlurGet();

                    self.$$calendar =
                        $$.create$$({
                            nodeName: "div",
                            attributes: { "class": "ui calendar" }
                        }).appendTo($$element);
                    self.$$inputWrapper =
                        $$.create$$({
                            nodeName: "div",
                            attributes: { "class": String.format("ui input {0} icon", self.iconLocationGet()) }
                        }).appendTo(self.$$calendar);
                    self.$$icon =
                        $$.create$$({
                            nodeName: "i",
                            attributes: { "class": "calendar icon" }
                        }).appendTo(self.$$inputWrapper);
                    self.$$input =
                        $$.create$$({
                            nodeName: "input",
                            attributes: {
                                autocomplete: "new-password",
                                id: String.formatWithHtmlEncode("{0}-input", self.controlId),
                                placeholder: String.formatWithHtmlEncode("{0}", self.placeholderGet()),
                                type: "text"
                            }
                        }).appendTo(self.$$inputWrapper);

                    self.labelTargetId = self.controlId + "-input";

                    var
                        settings = {
                            ampm: false,
                            disableMinute: self.disableMinuteGet(),
                            disableMonth: self.disableMonthGet(),
                            disableYear: self.disableYearGet(),
                            onChange: function ()
                            {
                                if (updateOnBlur)
                                    return;

                                // TODO: https://github.com/fomantic/Fomantic-UI/issues/417
                                setTimeout(() =>
                                {
                                    self._elementValueChanged();
                                });
                            },
                            onHide: function (date, mode)
                            {
                                // TODO: https://github.com/fomantic/Fomantic-UI/issues/417
                                setTimeout(() =>
                                {
                                    self._elementValueChanged();
                                });
                            },
                            popupOptions: {
                                boundary: page ? page.$$containerElementGet()[0] : window,
                                observeChanges: false
                            },
                            type: self.typeGet()
                        },
                        formatter = null,
                        dateFormat = self.dateFormatGet();

                    if (dateFormat)
                    {
                        formatter = {
                            date: function (date, settings)
                            {
                                if (!date)
                                    return String.empty;

                                return date.toString(dateFormat);
                            }
                        };
                    }

                    if (formatter)
                        settings.formatter = formatter;

                    self.$$calendar.calendar(settings);
                },
                _elementValueChanged: function ()
                {
                    if (!this.__processElementValueChanged)
                        return;

                    this.super.valueSet(this._elementValueGet());
                },
                _elementValueGet: function ()
                {
                    var
                        value = this.$$calendar.calendar("get date"),
                        type = this.typeGet();

                    if (!value)
                        return null;

                    switch (type)
                    {
                        case namespace.Calendar.types.date:
                            return value.toString("yyyy-MM-dd") + "T00:00:00.0000000Z";
                        case namespace.Calendar.types.datetime:
                            return value.toString("yyyy-MM-ddTHH:mm:ss.fffffff") + "Z";
                        default:
                            console.error(String.format("Type \"{0}\" is currently unsupported", type));
                    }
                },
                _elementValueSet: function (value)
                {
                    this.__processElementValueChanged = false;

                    if (value)
                        this.$$calendar.calendar("set date", Date.fromString(value, "yyyy-MM-ddTHH:mm:ss.fffffffZ").convertToUTC());
                    else
                        this.$$calendar.calendar("set date", null);

                    this.__processElementValueChanged = true;
                },
                _enabledChanged: function (change)
                {
                    this.super._enabledChanged(change);

                    if (change.currentValue)
                        this.$$calendar.removeClass("disabled");
                    else
                        this.$$calendar.addClass("disabled");
                },
                _getFocusElement: function ()
                {
                    return this.$$input;
                },
                _iconLocationChanged: function (change)
                {
                    if (change.originalValue)
                        self.$$inputWrapper.removeCssClass(change.originalValue);

                    if (change.currentValue)
                        self.$$inputWrapper.removeCssClass(change.currentValue);
                },
                _pageChanged: function (change)
                {
                    this.super._pageChanged(change);

                    if (!this.$$calendar)
                        return;

                    this.$$calendar.calendar("setting", "popupOptions", {
                        boundary: change.currentValue ? change.currentValue.$$containerElementGet()[0] : window,
                        observeChanges: false
                    });
                },

                // Public Methods
                textGet: function ()
                {
                    var
                        value = this.valueGet();

                    if (!value)
                        return String.empty;

                    return Date.fromString(value, "yyyy-MM-ddTHH:mm:ss.fffffffZ").convertToUTC().toString("dd/MM/yyyy HH:mm:ss");
                },
                valueSet: function (value)
                {
                    if (value && !value.isDate("yyyy-MM-ddTHH:mm:ss.fffffffZ"))
                        value = null;

                    if (this.valueGet() === value)
                        return false;

                    this._elementValueSet(value);
                    this.super.valueSet(this._elementValueGet());

                    return true;
                },

                // Event Handlers
                onBlur: function (evt)
                {
                    if (evt.data.self.updateOnBlurGet())
                        evt.data.self._elementValueChanged();
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.types = {
                date: "date",
                datetime: "datetime",
                month: "month",
                time: "time",
                year: "year"
            };
        }
    });

    // Color Picker
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "ColorPicker",
        inherits: "InputControl",
        properties: [
            { name: "supportAlpha", type: "boolean" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                supportAlpha: false,
                tabStop: true
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-color-picker");

                // Trigger Property Changes
                this.supportAlphaTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _bindEvents: function ()
                {
                    this.super._bindEvents();
                    this.$$inputElementColor.on("change", { self: this }, this.on$$InputElementColorChange);
                    this.$$inputElementAlpha.on("change", { self: this }, this.on$$InputElementAlphaChange);
                },
                _createElement: function ()
                {
                    this.super._createElement();

                    var
                        $$element = this.$$elementGet();

                    this.$$inputElementColor =
                        $$.create$$({
                            nodeName: "input",
                            attributes: {
                                id: String.format("{0}-input-color", this.controlId),
                                type: "color"
                            }
                        }).appendTo($$element);

                    this.$$inputElementAlpha =
                        $$.create$$({
                            nodeName: "input",
                            attributes: {
                                step: 0.1,
                                type: "range",
                                max: 1,
                                min: 0,
                                value: 1
                            }
                        }).appendTo($$element);

                    $$element.attr("tabindex", 0);
                    this.labelTargetId = this.$$inputElementColor.attr("id");
                },
                _elementValueChanged: function ()
                {
                    if (!this.__processElementValueChanged)
                        return;

                    this.super.valueSet(this._elementValueGet());
                },
                _elementValueGet: function ()
                {
                    var
                        color = seriouslyrad.ui.Color.fromString(this.$$inputElementColor.val() || "#ffffff00"),
                        supportAlpha = this.supportAlphaGet();

                    color.aSet(supportAlpha ? this.$$inputElementAlpha.val() || 255 : 255);

                    return (
                        supportAlpha
                            ? color.toRgbaHexString()
                            : color.toRgbHexString()
                    );
                },
                _elementValueSet: function (value)
                {
                    this.__processElementValueChanged = false;

                    var
                        color = seriouslyrad.ui.Color.fromString(value || "#ffffff00"),
                        supportAlpha = this.supportAlphaGet();

                    this.$$inputElementColor.val(color.toRgbHexString());
                    this.$$inputElementAlpha.val(supportAlpha ? (color.aGet() || 1) : 1);

                    this.__processElementValueChanged = true;
                },
                _supportAlphaChanged: function (change)
                {
                    if (change.currentValue)
                        this.$$inputElementAlpha.show();
                    else
                        this.$$inputElementAlpha.hide();
                },
                _valueChanged: function (change)
                {
                    this.super._valueChanged(change);
                    this._elementValueSet(change.currentValue);
                },

                // Public Methods
                textGet: function ()
                {
                    return this.valueGet();
                },

                // Event Handlers
                on$$InputElementAlphaChange: function (evt)
                {
                    evt.data.self._elementValueChanged();
                },
                on$$InputElementColorChange: function (evt)
                {
                    evt.data.self._elementValueChanged();
                },
                onClick: function (evt)
                {
                    evt.stopPropagation();
                }
            };
        }
    });

    // Combo Box
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "ComboBox",
        inherits: "InputListControl",
        properties: [
            { name: "allowEmptySelection", type: "boolean" },
            { name: "dropDownContextSelector", type: "string" },
            { name: "emptySelectionText", type: "string" },
            { name: "placeholder", type: "string" },
            { name: "selectedItem" }
        ],
        propertyAttributes: [
            {
                propertyName: "placeholder",
                designer: {
                    category: "Appearance",
                    displayName: "Placeholder"
                }
            }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                allowEmptySelection: true,
                tabStop: true
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-combo-box ui selection dropdown");

                // Trigger Property Changes
                this.placeholderTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _bindEvents: function ()
                {
                    this.super._bindEvents();
                    this.on("change", { self: this }, this.onChange);
                    this.on("focus", { self: this }, this.onFocus);
                    this.on("keyup", { self: this }, this.onKeyUp);
                },
                _createElement: function ()
                {
                    this.super._createElement();

                    var
                        $$element = this.$$elementGet();

                    this.$$inputElement =
                        $$.create$$({
                            nodeName: "input",
                            attributes: { type: "hidden" }
                        }).appendTo($$element);

                    this.$$iconElement = $$.create$$("i", "dropdown icon").appendTo($$element);
                    this.$$placeHolderElement = $$.create$$("div", "default text").appendTo($$element);
                    this.$$menuElement = $$.create$$("div", "menu").appendTo($$element);

                    $$element.attr("tabindex", 0);
                },
                _elementValueChanged: function ()
                {
                    if (!this.__processElementValueChanged)
                        return;

                    this.valueSet(this._elementValueGet());
                },
                _elementValueGet: function ()
                {
                    var
                        option = this._getSelectedOption(),
                        listDataSourceValueProperty = this.listDataSourceValuePropertyGet();

                    if (!option || !listDataSourceValueProperty || option[listDataSourceValueProperty] === "~~~")
                        return null;

                    return option[listDataSourceValueProperty];
                },
                _elementValueSet: function (value)
                {
                    this.__processElementValueChanged = false;

                    this.$$elementGet().dropdown("set selected", !Object.isNullOrUndefined(value) ? value.toString() : String.empty);

                    if (Object.isNullOrUndefined(value) || value === "~~~")
                    {
                        this.$$placeHolderElement.text(this.placeholderGet());
                        this.$$placeHolderElement.addClass("default");
                    }

                    this.__processElementValueChanged = true;
                },
                _getSelectedOption: function ()
                {
                    var
                        $$element = this.$$elementGet(),
                        value = $$element.dropdown("get value"),
                        $$item = this.$$menuElement.find(String.format(">div[data-value=\"{0}\"]", value));

                    if (!$$item || !$$item.length)
                        return null;

                    var
                        option = $$item.dataGet("rad-option");

                    return option ? option : null;
                },
                _placeholderChanged: function (change)
                {
                    if (!Object.isNullOrUndefined(this.valueGet()))
                        return;

                    this.$$placeHolderElement.text(change.currentValue);
                    this.$$placeHolderElement.addClass("default");
                    // this line tells semantic that this is the default state (for use later with "restore defaults")
                    this.$$elementGet().dropdown("save defaults");
                },
                _refreshListDataSource: function ()
                {
                    this.super._refreshListDataSource();

                    var
                        self = this,
                        dataSource = self.dataSourceGet(),
                        dataSourceProperty = self.dataSourcePropertyGet(),
                        backupValue = dataSource && dataSourceProperty ? dataSource.propertyValueByPathGet(dataSourceProperty) : self.valueGet(),
                        listDataSource = self.listDataSourceGet(),
                        listData = listDataSource ? listDataSource.dataGet() : null,
                        listDataSourceValueProperty = self.listDataSourceValuePropertyGet(),
                        listDataSourceDescriptionProperty = self.listDataSourceDescriptionPropertyGet();

                    if (!listData || !listDataSourceValueProperty || !listDataSourceDescriptionProperty)
                        return;

                    self.$$menuElement.empty();

                    if (self.allowEmptySelectionGet())
                    {
                        if (!self.emptySelectionItem)
                            self.emptySelectionItem = {};

                        self.emptySelectionItem[listDataSourceDescriptionProperty] = self.emptySelectionTextGet() ?? String.empty;
                        self.emptySelectionItem[listDataSourceValueProperty] = "~~~";

                        self.$$menuElement.append($$.create({
                            nodeName: "div",
                            attributes: {
                                "class": "item",
                                "data-value": String.htmlEncode(self.emptySelectionItem[listDataSourceValueProperty])
                            },
                            text: self.emptySelectionItem[listDataSourceDescriptionProperty],
                            data: { "rad-option": self.emptySelectionItem }
                        }));
                    }

                    self.$$menuElement.append(
                        listData.select(item => $$.create({
                            nodeName: "div",
                            attributes: {
                                "class": "item",
                                "data-value": String.htmlEncode(item[listDataSourceValueProperty])
                            },
                            text: item[listDataSourceDescriptionProperty],
                            data: { "rad-option": item }
                        }))
                    );

                    self.$$elementGet().dropdown("refresh");

                    self.valueSet(backupValue);
                },

                // Public Methods
                appendTo: function (...args)
                {
                    var
                        result = this.super.appendTo.apply(this.super, args);

                    if (!this.__dropDownInitialized)
                    {
                        var
                            dropDownContextSelector = this.dropDownContextSelectorGet(),
                            $$dropDownContext = dropDownContextSelector ? this.$$elementGet().parent().closest(dropDownContextSelector) : null,
                            dropDownContext = $$dropDownContext?.length ? $$dropDownContext[0] : window;

                        this.$$elementGet().dropdown({
                            context: dropDownContext,
                            showOnFocus: false
                        });

                        /* INFO: LEAVE THESE LINES IN
                           Replace placeholder as it gets cleared when the dropdown initializes. */
                        this.$$placeHolderElement.text(this.placeholderGet());
                        this.$$placeHolderElement.addClass("default");

                        // this line tells semantic that this is the default state (for use later with "restore defaults")
                        this.$$elementGet().dropdown("save defaults");

                        this.__dropDownInitialized = true;
                    }

                    return result;
                },
                focus: function ()
                {
                    this.focusMethodCalled = true;
                    this.super.focus();
                    this.focusMethodCalled = false;
                },
                textGet: function ()
                {
                    var
                        selectedItem = this.selectedItemGet(),
                        listDataSourceDescriptionProperty = this.listDataSourceDescriptionPropertyGet();

                    if (!selectedItem || !listDataSourceDescriptionProperty)
                        return null;

                    return selectedItem[listDataSourceDescriptionProperty];
                },
                valueSet: function (value)
                {
                    value = value === undefined ? null : value;

                    var
                        listDataSource = this.listDataSourceGet(),
                        listDataSourceData = listDataSource?.dataGet ? listDataSource.dataGet() : null,
                        listDataSourceValueProperty = this.listDataSourceValuePropertyGet(),
                        selectedItem =
                            value !== null && listDataSourceData && listDataSourceValueProperty
                                ? listDataSourceData.firstOrDefault(item => item[listDataSourceValueProperty] === value)
                                : null;

                    if (!selectedItem)
                    {
                        if (listDataSourceData?.length && listDataSourceValueProperty && !this.allowEmptySelectionGet())
                        {
                            selectedItem = listDataSourceData.first();
                            value = selectedItem[listDataSourceValueProperty];
                            this._setDataSourceValue(value);
                        }
                        else
                            value = null;
                    }

                    let
                        elementValue = value;

                    if (elementValue === null && this.allowEmptySelectionGet())
                        elementValue = "~~~";

                    this.selectedItemSet(selectedItem);
                    this.super.valueSet(value);
                    this._elementValueSet(elementValue);
                },

                // Event Handlers
                onChange: function (evt)
                {
                    evt.data.self._elementValueChanged();
                },
                onClick: function (evt)
                {
                    evt.stopPropagation();
                },
                onFocus: function (evt)
                {
                    var
                        self = evt.data.self,
                        $$element = self.$$elementGet();

                    if (!self.focusMethodCalled)
                        setTimeout(() => { $$element.dropdown("show"); $$element = null; }, 250);
                },
                onKeyUp: function (evt)
                {
                    var
                        self = evt.data.self,
                        $$element = self.$$elementGet();

                    if (evt.key === "Escape" && $$element.dropdown("is visible"))
                        evt.stopPropagation();
                }
            };
        }
    });

    // Combo Box (Application Entity)
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "ComboBoxApplicationEntity",
        inherits: "ComboBox",
        mixins: [
            "SoftDeleteEnabledListMixin"
        ],
        properties: [
            { name: "primaryEntity", type: "string" },
            { name: "primaryEntityDescriptionProperty", type: "string" },
            { name: "primaryEntityFilter", type: "string" },
            { name: "primaryEntityOrderProperty", type: "string" }
        ],
        propertyAttributes: [
            {
                propertyName: "primaryEntity",
                designer: {
                    category: "Data",
                    displayName: "Primary Entity"
                }
            },
            {
                propertyName: "primaryEntityDescriptionProperty",
                designer: {
                    category: "Data",
                    displayName: "Primary Entity Description Property"
                }
            },
            {
                propertyName: "primaryEntityFilter",
                designer: {
                    category: "Data",
                    displayName: "Primary Entity Filter"
                }
            },
            {
                propertyName: "primaryEntityOrderProperty",
                designer: {
                    category: "Data",
                    displayName: "Primary Entity Order Property"
                }
            }
        ],
        createPrototype: namespace =>
        {
            return {
                // Public Methods
                loadDataAsync: function ()
                {
                    var
                        self = this;

                    return new Promise((resolve, reject) =>
                    {
                        var
                            dataSource = self.dataSourceGet(),
                            data = dataSource ? dataSource.dataGet() : null,
                            primaryEntity = this.primaryEntityGet(),
                            primaryEntityFilter = this.primaryEntityFilterGet(),
                            primaryEntityDescriptionProperty = this.primaryEntityDescriptionPropertyGet(),
                            primaryEntityOrderProperty = this.primaryEntityOrderPropertyGet();

                        if (!primaryEntity)
                        {
                            reject("primaryEntity is not set");
                            return;
                        }

                        if (!primaryEntityDescriptionProperty)
                        {
                            reject("primaryEntityDescriptionProperty is not set");
                            return;
                        }

                        if (!primaryEntityOrderProperty)
                            primaryEntityOrderProperty = primaryEntityDescriptionProperty;

                        if (primaryEntityFilter)
                        {
                            primaryEntityFilter = primaryEntityFilter.replace(/\[([^\]]+)\]/g, (match, p1) =>
                            {
                                var
                                    value = data ? data[p1] : null;

                                if (Object.isNullOrUndefined(value))
                                    return "null";

                                return value.toString();
                            });
                        }

                        window.application.webApiClient
                            .createEntitySearchRequest(
                                primaryEntity,
                                primaryEntityFilter,
                                primaryEntityOrderProperty,
                                ["id", primaryEntityDescriptionProperty]
                            )
                            .executeAsync()
                            .then(data =>
                            {
                                data = data ?? [];

                                const
                                    dataSourceProperty = self.dataSourcePropertyGet(),
                                    dataSource = self.dataSourceGet(),
                                    requiredId =
                                        dataSourceProperty && dataSource
                                            ? dataSource.propertyValueByPathGet(dataSourceProperty)
                                            : null;

                                if (requiredId === null || data.any(item => item.id === requiredId))
                                {
                                    self.listDataSourceSet(data.select(item => ({ value: item.id, description: window.objectHelper.propertyValueByPathGet(item, primaryEntityDescriptionProperty) })));
                                    resolve();
                                    return;
                                }

                                self
                                    ._getSoftDeletedListItemAsync({
                                        listData: data,
                                        primaryEntity: primaryEntity,
                                        primaryEntityDescriptionProperty: primaryEntityDescriptionProperty,
                                        primaryEntityOrderProperty: primaryEntityOrderProperty,
                                        requiredId: requiredId
                                    })
                                    .finally(() =>
                                    {
                                        self.listDataSourceSet(data.select(item => ({ value: item.id, description: window.objectHelper.propertyValueByPathGet(item, primaryEntityDescriptionProperty), deleted: !!item.deletedGuid })));
                                        resolve();
                                    });
                            })
                            .catch(error =>
                            {
                                reject(error);
                            });
                    });
                },

                // Event Handlers
                onPageLoaded: function (evt, eventData)
                {
                    eventData.promises.push(evt.data.self.loadDataAsync());
                }
            };
        }
    });

    // Combo Box (Data Service)
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "ComboBoxDataService",
        inherits: "ComboBox",
        properties: [
            { name: "dataServiceId", type: "string" },
            { name: "dataServiceData", type: "string" },
            { name: "dataServiceOperation", type: "string" }
        ],
        propertyAttributes: [
            {
                propertyName: "dataServiceId",
                designer: {
                    category: "Data",
                    displayName: "Data Service Id"
                }
            },
            {
                propertyName: "dataServiceData",
                designer: {
                    category: "Data",
                    displayName: "Data Service Data"
                }
            }
        ],
        createPrototype: namespace =>
        {
            return {
                // Public Methods
                loadDataAsync: function ()
                {
                    var
                        self = this,
                        dataServiceId = self.dataServiceIdGet();

                    if (dataServiceId)
                    {
                        var
                            dataServiceData = self.dataServiceDataGet();

                        return (
                            window.application.webApiClient
                                .createApiMethodRequest("DataService", "CallDataService", { id: dataServiceId, operation: self.dataServiceOperationGet(), data: dataServiceData })
                                .executeAsync()
                                .then(data =>
                                {
                                    self.listDataSourceSet(data.select(item => ({ value: item.id, description: item.description })));
                                    self.triggerHandler("listDataSourceChanged");
                                })
                        );
                    }

                    return Promise.resolve();
                },

                // Event Handlers
                onPageLoaded: function (evt, eventData)
                {
                    eventData.promises.push(evt.data.self.loadDataAsync());
                }
            };
        }
    });

    // Combo Box (Lookup Item)
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "ComboBoxLookupItem",
        inherits: "ComboBoxDataService",
        properties: [
            { name: "lookupType", type: "string" },
            { name: "orderBy", type: "string" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                dataServiceId: "ba3b8690-f223-4e10-baa8-5483b67589b3",
                dataServiceOperation: "ListByType",
                orderBy: "Description"
            };
        },
        createPrototype: namespace =>
        {
            return {
                // Public Methods
                loadDataAsync: function ()
                {
                    if (this.__isConstructing())
                        return;

                    var
                        dataSourceProperty = this.dataSourcePropertyGet(),
                        dataSource = this.dataSourceGet();

                    this.dataServiceDataSet({
                        lookupType: this.lookupTypeGet(),
                        requiredId:
                            dataSourceProperty && dataSource
                                ? dataSource.propertyValueByPathGet(dataSourceProperty)
                                : null,
                        orderBy: this.orderByGet()
                    }.toJson());

                    return this.super.loadDataAsync();
                }
            };
        }
    });

    // Combo Box (Yes / No)
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "ComboBoxYesNo",
        inherits: "ComboBox",
        createPropertyDefaults: namespace =>
        {
            return {
                listDataSource: [
                    { value: false, description: "No" },
                    { value: true, description: "Yes" }
                ]
            };
        }
    });

    // Communication Addresses
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "CommunicationAddresses",
        inherits: "InputControl",
        properties: [
            { name: "communicationType" },
            { name: "placeholder", type: "string" },
            { name: "title" }
        ],
        propertyAttributes: [
            {
                propertyName: "placeholder",
                designer: {
                    category: "Appearance",
                    displayName: "Placeholder"
                }
            },
            {
                propertyName: "communicationType",
                designer: {
                    category: "Behavior",
                    displayName: "Communication Type"
                }
            },
            {
                propertyName: "title",
                designer: {
                    category: "Appearance",
                    displayName: "Popup Title"
                }
            }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                communicationType: namespace.CommunicationAddresses.communicationType.Email,
                title: "Communication Addresses"
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-communication-addresses ui form input");

                // Trigger Property Changes
                this.placeholderTriggerChange();
                this.titleTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _bindEvents: function ()
                {
                    this.super._bindEvents();
                    this.button.on("click", { self: this }, this.onButtonClicked);
                },
                _createElement: function ()
                {
                    this.super._createElement();

                    var
                        $$element = this.$$elementGet();

                    this.textBox = new namespace.TextBox({ enabled: false }).appendTo($$element);
                    this.button = new namespace.Button({ icon: "list", inline: true, showLabel: false }).appendTo($$element);
                    this.dialog = new namespace.Dialog();
                },
                _elementValueGet: function ()
                {
                    return this.textBox.valueGet();
                },
                _elementValueSet: function (value)
                {
                    this.__processElementValueChanged = false;
                    this.textBox.valueSet(value);
                    this.__processElementValueChanged = true;
                },
                _enabledChanged: function (change)
                {
                    this.super._enabledChanged(change);

                    this.button.enabledSet(change.currentValue);
                },
                _placeholderChanged: function (change)
                {
                    this.textBox.placeholderSet(change.currentValue);
                },
                _titleChanged: function (change)
                {
                    this.dialog.titleSet(change.currentValue);
                },
                _valueChanged: function (change)
                {
                    this.super._valueChanged(change);

                    this._elementValueSet(change.currentValue);
                },

                // Public Methods
                remove: function ()
                {
                    if (this.button)
                    {
                        this.button.remove();
                        this.button = null;
                    }

                    this.super.remove();
                },
                valueGet: function ()
                {
                    return this.textBox.valueGet();
                },

                // Event Handlers
                onButtonClicked: function (evt)
                {
                    var
                        self = evt.data.self;

                    self.dialog
                        .openAsync()
                        .then(result =>
                        {
                        //    if (result[0] === namespace.Dialog.dialogResult.ok)
                        //        self._elementValueSet(result.scannedCode);
                        });
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.communicationType =
                {
                    Mobile: "Mobile",
                    Phone: "Phone",
                    Fax: "Fax",
                    Email: "Email"
                };
        }
    });

    // Check Box
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "CheckBox",
        inherits: "InputControl",
        properties: [
            { name: "labelText", type: "string" },
            { name: "textYesNo", type: "boolean" },
            { name: "type", type: "string" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                type: namespace.CheckBox.type.checkBox
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-check-box ui checkbox");

                // Trigger Property Changes
                this.labelTextTriggerChange();
                this.textYesNoTriggerChange();
                this.typeTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _bindEvents: function ()
                {
                    this.super._bindEvents();

                    this.$$valueElement.on("change", { self: this }, this.onValueElementChanged);
                },
                _createElement: function ()
                {
                    this.super._createElement();

                    var
                        $$element = this.$$elementGet();

                    this.$$valueElement =
                        $$(String.formatWithHtmlEncode("<input id=\"{0}-input\" type=\"{1}\" />", this.controlId, this.typeGet().toLowerCase()))
                            .appendTo($$element);

                    this.$$labelElement =
                        $$(String.formatWithHtmlEncode("<label for=\"{0}-input\"></label>", this.controlId))
                            .appendTo($$element);

                    this.labelTargetId = this.$$valueElement.attr("id");
                },
                _elementValueChanged: function ()
                {
                    if (!this.__processElementValueChanged)
                        return;

                    this.super.valueSet(this._elementValueGet());
                },
                _elementValueGet: function ()
                {
                    return this.$$valueElement.is(":checked");
                },
                _elementValueSet: function (value)
                {
                    this.__processElementValueChanged = false;
                    this.$$valueElement.prop("checked", value === true);
                    this.__processElementValueChanged = true;
                },
                _enabledChanged: function (change)
                {
                    this.super._enabledChanged(change);

                    if (change.currentValue)
                        this.$$valueElement.removeAttr("disabled");
                    else
                        this.$$valueElement.attr("disabled", "disabled");
                },
                _labelTextChanged: function (change)
                {
                    this.$$labelElement.text(change.currentValue);
                },
                _typeChanged: function (change)
                {
                    if (change.currentValue === namespace.CheckBox.type.radio)
                        this.addCssClass("radio");
                    else
                        this.removeCssClass("radio");

                    this.$$valueElement.attr("type", change.currentValue.toLowerCase());
                },
                _valueChanged: function (change)
                {
                    this.super._valueChanged(change);
                    this._elementValueSet(change.currentValue);
                },

                // Public Methods
                textGet: function ()
                {
                    var
                        dataSource = this.dataSourceGet(),
                        dataSourceProperty = this.dataSourcePropertyGet(),
                        textYesNo = this.textYesNoGet();

                    if (!dataSource || !dataSourceProperty)
                        return null;

                    var
                        value = dataSource.propertyValueByPathGet(dataSourceProperty);

                    if (textYesNo)
                        return value ? "Yes" : "No";

                    return value;
                },
                valueGet: function ()
                {
                    return !!this.super.valueGet();
                },
                valueSet: function (value)
                {
                    this.super.valueSet(!!value);

                    if (value !== true && value !== false)
                        this._updateDataSource(); // Check box must be either true or false; update data source
                },

                // Event Handlers
                onValueElementChanged: function (evt)
                {
                    evt.data.self._elementValueChanged();
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.type =
            {
                checkBox: "checkBox",
                radio: "radio"
            };
        }
    });

    // Check Box List
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "CheckBoxList",
        inherits: "InputListControl",
        properties: [
            { name: "checkBoxType", type: "string" },
            { name: "horizontal", type: "boolean" }
        ],
        propertyAttributes: [
            {
                propertyName: "horizontal",
                designer: {
                    category: "Appearance",
                    displayName: "Horizontal"
                }
            }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                checkBoxType: namespace.CheckBox.type.checkBox,
                horizontal: false
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-check-box-list ui form");

                // Trigger Property Changes
                this.checkBoxTypeTriggerChange();
                this.horizontalTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _checkBoxTypeChanged: function (change)
                {
                    this.refreshListDataSource();
                },
                _createElement: function ()
                {
                    this.super._createElement();

                    var
                        $$element = this.$$elementGet();

                    this.$$fieldContainer = $$.create$$({ nodeName: "div", attributes: { "class": "fields" } }).appendTo($$element);
                },
                _elementValueChanged: function ()
                {
                    if (!this.__processElementValueChanged)
                        return;

                    this._suspendRefreshFromDataSource();
                    this.super.valueSet(this._elementValueGet());
                    this._resumeRefreshFromDataSource();
                },
                _elementValueGet: function ()
                {
                    var
                        checkboxes = this.$$elementGet().find(".checkbox > input:checked"),
                        value = null,
                        listDataSourceValueProperty = this.listDataSourceValuePropertyGet();

                    if (checkboxes.length > 0)
                    {
                        checkboxes.each((index, element) =>
                        {
                            if (value === null)
                                value = [];

                            var
                                option = $$(element).parent().dataGet("rad-option");

                            if (option)
                                value.push(option[listDataSourceValueProperty]);
                        });
                    }

                    switch (this.checkBoxTypeGet())
                    {
                        case namespace.CheckBox.type.checkBox:
                            return value;
                        case namespace.CheckBox.type.radio:
                            return value?.length ? value[0] : null;
                        default:
                            console.error("Not implemented.");
                            break;
                    }

                    return null;
                },
                _elementValueSet: function (value)
                {
                    this.__processElementValueChanged = false;

                    var
                        checkboxes = this.$$elementGet().find("input");

                    checkboxes.parent().removeClass("checked");
                    checkboxes.prop("checked", false);

                    if (value !== undefined && value !== null)
                    {
                        switch (this.checkBoxTypeGet())
                        {
                            case namespace.CheckBox.type.checkBox:
                                value.each(item =>
                                {
                                    checkboxes.filter("[value='" + item + "']").prop("checked", true);
                                });
                                break;
                            case namespace.CheckBox.type.radio:
                                checkboxes.filter("[value='" + value + "']").prop("checked", true);
                                break;
                            default:
                                console.error("Not implemented.");
                                break;
                        }
                    }

                    this.__processElementValueChanged = true;
                },
                _enabledChanged: function (change)
                {
                    this.super._enabledChanged(change);

                    this.$$elementGet().find(".checkbox").each((index, element) =>
                    {
                        if (!change.currentValue)
                            $$(element).addClass("disabled");
                        else
                            $$(element).removeClass("disabled");
                    });
                },
                _horizontalChanged: function (change)
                {
                    if (change.currentValue)
                    {
                        this.$$fieldContainer.removeClass("grouped");
                        this.$$fieldContainer.addClass("inline");
                    }
                    else
                    {
                        this.$$fieldContainer.addClass("grouped");
                        this.$$fieldContainer.removeClass("inline");
                    }
                },
                _readOnlyChanged: function (change)
                {
                    this.super._readOnlyChanged(change);

                    this.$$elementGet().find(".checkbox").each((index, element) =>
                    {
                        if (change.currentValue)
                            $$(element).addClass("read-only");
                        else
                            $$(element).removeClass("read-only");
                    });
                },
                _refreshListDataSource: function ()
                {
                    this.super._refreshListDataSource();

                    var
                        self = this,
                        checkBoxType = this.checkBoxTypeGet(),
                        backupValue = self._elementValueGet();

                    self.$$fieldContainer.empty();
                    self.labelTargetId = null;

                    var
                        listDataSource = self.listDataSourceGet();

                    if (!listDataSource)
                        return;

                    var
                        listData = listDataSource.dataGet();

                    if (!listData)
                        return;

                    var
                        listDataSourceValueProperty = self.listDataSourceValuePropertyGet();

                    if (!listDataSourceValueProperty)
                        return;

                    var
                        listDataSourceDescriptionProperty = self.listDataSourceDescriptionPropertyGet();

                    if (!listDataSourceDescriptionProperty)
                        return;

                    listData.each(item =>
                    {
                        var
                            itemId = String.format("{0}-{1}", self.controlId, item[listDataSourceValueProperty]);

                        var
                            option =
                                $$(
                                    String.format(
                                        "<div class=\"field\">"
                                        + "    <div class=\"ui{0}{1} checkbox\" id=\"{2}\">"
                                        + "        <input type=\"{3}\" name=\"{4}\" value=\"{5}\">"
                                        + "        <label><span>{6}</span>{7}</label>"
                                        + "    </div>"
                                        + "</div>",
                                        checkBoxType === namespace.CheckBox.type.radio ? " radio" : String.empty,
                                        self.readOnlyGet() ? " read-only" : String.empty,
                                        String.htmlEncode(itemId),
                                        checkBoxType.toLowerCase(),
                                        checkBoxType === namespace.CheckBox.type.radio ? self.controlId : itemId,
                                        String.htmlEncode(item[listDataSourceValueProperty]),
                                        String.htmlEncode(item[listDataSourceDescriptionProperty]),
                                        item["imageUrl"]
                                            ? String.format(
                                                "<img src=\"{0}\" />",
                                                encodeURI(window.applicationInformation.virtualDirectory + item["imageUrl"])
                                            )
                                            : String.empty
                                    )
                                )
                                    .appendTo(self.$$fieldContainer);

                        option.find(".checkbox").data("rad-option", item);

                        if (self.labelTargetId === null)
                            self.labelTargetId = itemId;
                    });

                    self.$$elementGet().find(".checkbox").checkbox({
                        onChange: function ()
                        {
                            self._elementValueChanged();
                        }
                    });

                    self._elementValueSet(backupValue);
                },

                // Public Methods
                textGet: function ()
                {
                    var
                        checkboxes = this.$$elementGet().find(".checkbox > input:checked"),
                        value = String.empty,
                        listDataSourceDescriptionProperty = this.listDataSourceDescriptionPropertyGet();

                    if (checkboxes.length > 0)
                    {
                        checkboxes.each((index, element) =>
                        {
                            var
                                option = $$(element).parent().dataGet("rad-option");

                            if (option)
                                value += (value.length ? ", " : String.empty) + option[listDataSourceDescriptionProperty];
                        });
                    }

                    return value;
                },
                valueSet: function (value)
                {
                    if (window.objectHelper.typeOf(value) === "string")
                        value = value.split(",");

                    if (value !== undefined && value !== null)
                    {
                        switch (this.checkBoxTypeGet())
                        {
                            case namespace.CheckBox.type.checkBox:
                                if (!Array.isArray(value) || value.length === 0)
                                    value = null;
                                break;
                            case namespace.CheckBox.type.radio:
                                break;
                            default:
                                console.error("Not implemented.");
                                break;
                        }
                    }

                    if (this.valueGet() === value)
                        return false;

                    this._elementValueSet(value);
                    this.super.valueSet(this._elementValueGet());

                    return true;
                }
            };
        }
    });

    // Check Box List (Permission)
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "CheckBoxListPermission",
        inherits: "CheckBoxList",
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _powersOfTwoFromArray: function (powers)
                {
                    var
                        value = 0;

                    if (powers)
                        powers.each(item => { value += item; });

                    return value;
                },
                _powersOfTwoToArray: function (value)
                {
                    var
                        powers = [],
                        power = 0;

                    while (value !== 0)
                    {
                        if ((value & 1) !== 0)
                            powers.push(1 << power);
                        ++power;
                        value >>>= 1;
                    }

                    return powers;
                },
                _refreshFromDataSource: function ()
                {
                    var
                        dataSource = this.dataSourceGet(),
                        dataSourceProperty = this.dataSourcePropertyGet();

                    if (dataSource && dataSourceProperty && dataSource.propertyValueByPathGet(dataSourceProperty) === null)
                        dataSource.propertyValueByPathSet(dataSourceProperty, 0);

                    this.super._refreshFromDataSource();
                },

                // Public Methods
                textGet: function ()
                {
                    var
                        value = this.super.textGet();

                    if (!value)
                        value = "None";

                    return value;
                },
                valueGet: function ()
                {
                    var
                        value = this._powersOfTwoFromArray(this.super.valueGet());

                    return value === null ? 0 : value;
                },
                valueSet: function (value)
                {
                    if (value === null)
                        value = 0;

                    return this.super.valueSet(this._powersOfTwoToArray(value));
                }
            };
        }
    });

    // Date
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "Date",
        inherits: "InputControl",
        properties: [
            { name: "keyShortcutsActive", type: "boolean" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                keyShortcutsActive: true
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-date");
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _bindEvents: function ()
                {
                    this.super._bindEvents();
                    this.day.on("valueChanged", { self: this }, this.onDayValueChanged);
                    this.month.on("valueChanged", { self: this }, this.onMonthValueChanged);
                    this.year.on("valueChanged", { self: this }, this.onYearValueChanged);

                    this.on("keyup", { self: this }, this.onKeyUp);
                },
                _createElement: function ()
                {
                    this.super._createElement();

                    var
                        $$element = this.$$elementGet(),
                        monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
                        startYear = 1900,
                        endYear = (new Date()).getFullYear() + 10,
                        i, days = [], months = [], years = [];

                    if (endYear < startYear)
                        endYear = startYear;

                    for (i = 1; i <= 31; i++)
                        days.push({ value: i, description: i.toString().padLeft(2, "0") });

                    for (i = 1; i <= 12; i++)
                        months.push({ value: i, description: monthNames[i - 1] });

                    for (i = endYear; i >= startYear; i--)
                        years.push({ value: i, description: i });

                    this.day = new namespace.ComboBox({ inline: true, listDataSource: days, placeholder: "Day" }).appendTo($$element);
                    this.month = new namespace.ComboBox({ inline: true, listDataSource: months, placeholder: "Month" }).appendTo($$element);
                    this.year = new namespace.ComboBox({ inline: true, listDataSource: years, placeholder: "Year" }).appendTo($$element);

                    this.labelTargetId = this.day.labelTargetId;
                },
                _elementValueChanged: function ()
                {
                    if (!this.__processElementValueChanged)
                        return;

                    this.super.valueSet(this._elementValueGet());
                },
                _elementValueGet: function ()
                {
                    var
                        day = this.day.valueGet(),
                        month = this.month.valueGet(),
                        year = this.year.valueGet(),
                        value = null;

                    if (year !== null && month !== null && day !== null)
                        value = String.format("{0}-{1}-{2}T00:00:00.0000000Z", year, month.toString().padLeft(2, "0"), day.toString().padLeft(2, "0"));

                    return value;
                },
                _elementValueSet: function (value)
                {
                    this.__processElementValueChanged = false;

                    if (!value)
                    {
                        this.day.valueSet(null);
                        this.month.valueSet(null);
                        this.year.valueSet(null);
                    }
                    else
                    {
                        this.day.valueSet(parseInt(value.substr(8, 2)));
                        this.month.valueSet(parseInt(value.substr(5, 2)));
                        this.year.valueSet(parseInt(value.substr(0, 4)));
                    }

                    this.__processElementValueChanged = true;
                },
                _enabledChanged: function (change)
                {
                    this.super._enabledChanged(change);

                    this.day.enabledSet(change.currentValue);
                    this.month.enabledSet(change.currentValue);
                    this.year.enabledSet(change.currentValue);
                },

                // Public Methods
                remove: function ()
                {
                    if (this.day)
                    {
                        this.day.remove();
                        this.day = null;
                    }

                    if (this.month)
                    {
                        this.month.remove();
                        this.month = null;
                    }

                    if (this.year)
                    {
                        this.year.remove();
                        this.year = null;
                    }

                    this.super.remove();
                },
                setToday: function ()
                {
                    var
                        date = new Date();

                    this.valueSet(date.toString("yyyy-MM-dd"));
                },
                setYesterday: function ()
                {
                    var
                        date = new Date();

                    date.setDate(date.getDate() - 1);

                    this.valueSet(date.toString("yyyy-MM-dd"));
                },
                textGet: function ()
                {
                    var
                        value = this.valueGet();

                    if (!value)
                        return String.empty;

                    return Date.fromString(value, "yyyy-MM-ddTHH:mm:ss.fffffffZ").convertToUTC().toString("dd/MM/yyyy");
                },
                valueSet: function (value)
                {
                    if (this.valueGet() === value)
                        return false;

                    this._elementValueSet(value);
                    this.super.valueSet(this._elementValueGet());

                    return true;
                },

                // Event Handlers
                onDayValueChanged: function (evt)
                {
                    evt.data.self._elementValueChanged();
                },
                onKeyUp: function (evt)
                {
                    var
                        self = evt.data.self;

                    if (self.keyShortcutsActiveGet())
                    {
                        var
                            keyCaptured = false;

                        switch (evt.key)
                        {
                            case "T":
                            case "t":
                                evt.data.self.setToday();
                                keyCaptured = true;
                                break;
                            case "Y":
                            case "y":
                                evt.data.self.setYesterday();
                                keyCaptured = true;
                                break;
                        }

                        if (keyCaptured)
                        {
                            evt.preventDefault();
                            evt.stopPropagation();
                        }
                    }
                },
                onMonthValueChanged: function (evt)
                {
                    evt.data.self._elementValueChanged();
                },
                onYearValueChanged: function (evt)
                {
                    evt.data.self._elementValueChanged();
                }
            };
        }
    });

    // Date Time
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "DateTime",
        inherits: "InputControl",
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-date-time");
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _bindEvents: function ()
                {
                    this.super._bindEvents();
                    this.date.on("valueChanged", { self: this }, this.onDateValueChanged);
                    this.time.on("valueChanged", { self: this }, this.onTimeValueChanged);

                    this.on("keyup", { self: this }, this.onKeyUp);
                },
                _createElement: function ()
                {
                    this.super._createElement();

                    var
                        $$element = this.$$elementGet();

                    this.date = new namespace.Date({ keyShortcutsActive: false }).appendTo($$element);
                    this.time = new namespace.Time({ keyShortcutsActive: false }).appendTo($$element);

                    this.labelTargetId = this.date.labelTargetId;
                },
                _elementValueChanged: function ()
                {
                    if (!this.__processElementValueChanged)
                        return;

                    this.super.valueSet(this._elementValueGet());
                },
                _elementValueGet: function ()
                {
                    var
                        dateString = this.date.valueGet(),
                        timeString = this.time.valueGet(),
                        value = null;

                    if (dateString !== null && timeString !== null)
                    {
                        var
                            date = Date.fromString(dateString, "yyyy-MM-dd");

                        date.setHours(parseInt(timeString.substr(0, 2)));
                        date.setMinutes(parseInt(timeString.substr(3, 2)));
                        date.setSeconds(parseInt(timeString.substr(6, 2)));

                        value = date.toString("yyyy-MM-ddTHH:mm:ss.fffffff") + "Z";
                    }

                    return value;
                },
                _elementValueSet: function (value)
                {
                    this.__processElementValueChanged = false;

                    if (!value)
                    {
                        this.date.valueSet(null);
                        this.time.valueSet(null);
                    }
                    else
                    {
                        value = Date.fromString(value, "yyyy-MM-ddTHH:mm:ss.fffffffZ").convertToUTC().toString("yyyy-MM-ddTHH:mm:ss");
                        this.date.valueSet(value.substr(0, 10));
                        this.time.valueSet(value.substr(11, 8));
                    }

                    this.__processElementValueChanged = true;
                },
                _enabledChanged: function (change)
                {
                    this.super._enabledChanged(change);

                    this.date.enabledSet(change.currentValue);
                    this.time.enabledSet(change.currentValue);
                },

                // Public Methods
                remove: function ()
                {
                    if (this.date)
                    {
                        this.date.remove();
                        this.date = null;
                    }

                    if (this.time)
                    {
                        this.time.remove();
                        this.time = null;
                    }

                    this.super.remove();
                },
                textGet: function ()
                {
                    var
                        value = this.valueGet();

                    if (!value)
                        return String.empty;

                    return Date.fromString(value, "yyyy-MM-ddTHH:mm:ss.fffffffZ").convertToUTC().toString("dd/MM/yyyy HH:mm:ss");
                },
                valueSet: function (value)
                {
                    if (value && !value.isDate("yyyy-MM-ddTHH:mm:ss.fffffffZ"))
                        value = null;

                    if (this.valueGet() === value)
                        return false;

                    this._elementValueSet(value);
                    this.super.valueSet(this._elementValueGet());

                    return true;
                },

                // Event Handlers
                onDateValueChanged: function (evt)
                {
                    evt.data.self._elementValueChanged();
                },
                onKeyUp: function (evt)
                {
                    var
                        keyCaptured = false;

                    switch (evt.key)
                    {
                        case "T":
                        case "t":
                            evt.data.self.date.setToday();
                            evt.data.self.time.valueSet("00:00:00");
                            keyCaptured = true;
                            break;
                        case "Y":
                        case "y":
                            evt.data.self.date.setYesterday();
                            evt.data.self.time.valueSet("00:00:00");
                            keyCaptured = true;
                            break;
                    }

                    if (keyCaptured)
                    {
                        evt.preventDefault();
                        evt.stopPropagation();
                    }
                },
                onTimeValueChanged: function (evt)
                {
                    evt.data.self._elementValueChanged();
                }
            };
        }
    });

    // File Upload
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "FileUpload",
        inherits: "InputControl",
        properties: [
            { name: "allowMultipleFiles", type: "boolean" },
            { name: "hideCurrentNameElement", type: "boolean" },
            { name: "selectedFiles" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                allowMultipleFiles: false,
                hideCurrentNameElement: false
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-file-upload");

                // Trigger Property Changes
                this.allowMultipleFilesTriggerChange();
                this.hideCurrentNameElementTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _allowMultipleFilesChanged: function (change)
                {
                    if (change.currentValue)
                        this.$$fileUploadElement.attr("multiple", "multiple");
                    else
                        this.$$fileUploadElement.removeAttr("multiple");
                },
                _bindEvents: function ()
                {
                    this.super._bindEvents();

                    this.$$fileUploadElement.on("change", { self: this }, this.onFileUploadElementChanged);
                },
                _createElement: function ()
                {
                    this.super._createElement();

                    var
                        $$element = this.$$elementGet();

                    this.$$container = $$.create$$({ nodeName: "div", attributes: { "class": "rad-container" } }).appendTo($$element);
                    this.$$currentNameElement = $$.create$$({ nodeName: "p" }).appendTo(this.$$container);
                    this.$$fileUploadElement = $$(String.formatWithHtmlEncode("<input id=\"{0}-input\" type=\"file\" />", this.controlId)).appendTo(this.$$container);
                    this.$$fileUploadLabel = $$(String.formatWithHtmlEncode("<label for=\"{0}-input\">Choose file</label>", this.controlId)).appendTo(this.$$container);
                    this.$$fileUploadLabelNewFile = $$.create$$("span", null, "No file chosen").appendTo(this.$$container);
                    this.labelTargetId = this.$$fileUploadElement.attr("id");
                },
                _elementValueChanged: function ()
                {
                    if (!this.__processElementValueChanged)
                        return;

                    var
                        data = this.$$fileUploadElement.dataGet("upload-information")

                    if (data)
                        this.$$fileUploadLabelNewFile.html(data.select(item => item.fileName).join("<br />"));
                    else
                        this.$$fileUploadLabelNewFile.empty();

                    this.super.valueSet(this._elementValueGet());
                },
                _elementValueGet: function ()
                {
                    var
                        value = this.$$fileUploadElement.dataGet("upload-information"),
                        json;

                    if (!value)
                        return null;

                    try { json = value.toJson(); }
                    catch (e) { /* Continue regardless of error */ }

                    if (!json)
                        return null;

                    return json;
                },
                _elementValueSet: function (value)
                {
                    this.__processElementValueChanged = false;

                    if (!value)
                        this.$$fileUploadElement.data("upload-information", null);
                    else
                    {
                        var
                            obj = null;

                        try { obj = value.fromJson(); }
                        catch (e) { /* Continue regardless of error */ }

                        this.$$fileUploadElement.data("upload-information", obj);
                    }

                    this.__processElementValueChanged = true;
                },
                _getFileUploadGuidAsync: function (fileUpload)
                {
                    return (
                        window.utility
                            .newGuidAsync()
                            .then(data =>
                            {
                                fileUpload.guid = data;
                            })
                    );
                },
                _hideCurrentNameElementChanged: function (change)
                {
                    if (change.currentValue)
                        this.$$currentNameElement.hide();
                    else
                        this.$$currentNameElement.show();
                },
                _selectedFilesChanged: function (change)
                {
                    var
                        self = this,
                        selectedFiles = change.currentValue;

                    if (selectedFiles?.length)
                    {
                        var
                            uploadInformation = [];

                        for (var i = 0; i < selectedFiles.length; i++)
                            uploadInformation.push({ guid: null, fileName: selectedFiles[i].name });

                        Promise.all(uploadInformation.select(item => self._getFileUploadGuidAsync(item)))
                            .then(() =>
                            {
                                self.$$fileUploadElement.data("upload-information", uploadInformation);
                                self._elementValueChanged();
                            });
                    }
                    else
                    {
                        self.$$fileUploadElement.data("upload-information", null);
                        self._elementValueChanged();
                    }
                },
                _valueChanged: function (change)
                {
                    this.super._valueChanged(change);

                    var
                        text = this.textGet();

                    if (text)
                        this.$$currentNameElement.html(text.replace(/\r\n/gi, "<br/>"));
                    else
                        this.$$currentNameElement.empty();
                },
                _valueSet: function (value)
                {
                    // BM: Fix for old data.
                    if (value)
                    {
                        var
                            valueObject = value.fromJson();

                        if (!Array.isArray(valueObject))
                            value = [valueObject].toJson();
                    }

                    this.super._valueSet(value);

                    if (!value)
                        this.resetFileUploadElement();
                },

                // Public Methods
                resetFileUploadElement: function ()
                {
                    this.$$fileUploadElement.wrap("<form>").closest("form").get(0)?.reset();
                    this.$$fileUploadElement.unwrap();
                    this.$$fileUploadLabelNewFile.text("No file chosen");
                },
                textGet: function ()
                {
                    var
                        fileUploadInformation = this.valueGetAsObject();

                    return fileUploadInformation ? fileUploadInformation.select(item => item.fileName).join("\r\n") : String.empty;
                },
                uploadFilesAsync: function ()
                {
                    var
                        selectedFiles = this.selectedFilesGet();

                    if (selectedFiles?.length)
                    {
                        var
                            fileUploadInformation = this.valueGetAsObject(),
                            requests = [];

                        for (var i = 0; i < selectedFiles.length; i++)
                        {
                            // TODO: Implement a progress bar
                            var
                                fileInformation = fileUploadInformation[i],
                                formData = new FormData();

                            formData.append("file[]", selectedFiles[i], selectedFiles[i].name);

                            requests.push(
                                window.application.webApiClient.createFileUploadRequest("file", "uploadfile/" + fileInformation.guid, formData)
                                    .executeAsync()
                            );
                        }

                        return Promise.all(requests);
                    }

                    return Promise.resolve();
                },
                valueGetAsObject: function ()
                {
                    var
                        value = this.valueGet();

                    if (!value)
                        return null;

                    var
                        obj = null;

                    try { obj = value.fromJson(); }
                    catch (e) { /* Continue regardless of error */ }

                    return obj;
                },

                // Event Handlers
                onDataSourceBeforeSaveChanges: function (evt, eventData)
                {
                    this.super.onDataSourceBeforeSaveChanges(evt, eventData);
                    eventData.promises.push(evt.data.self.uploadFilesAsync());
                },
                onFileUploadElementChanged: function (evt)
                {
                    var
                        self = evt.data.self;

                    self.selectedFilesSet(self.$$fileUploadElement[0].files);
                }
            };
        }
    });

    // Image Picker
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "ImagePicker",
        inherits: "InputControl",
        createPropertyDefaults: namespace =>
        {
            return {
                tabStop: true
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-image-picker");
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _bindEvents: function ()
                {
                    this.super._bindEvents();
                    this.$$inputElementImage.on("change", { self: this }, this.on$$InputElementImageChange);
                },
                _createElement: function ()
                {
                    this.super._createElement();

                    var
                        $$element = this.$$elementGet();

                    this.$$inputElementImage =
                        $$.create$$({
                            nodeName: "input",
                            attributes: {
                                id: String.format("{0}-input-image", this.controlId),
                                type: "file"
                            }
                        }).appendTo($$element);

                    $$element.attr("tabindex", 0);
                    this.labelTargetId = this.$$inputElementImage.attr("id");
                },
                _elementValueChanged: function (base64Data)
                {
                    if (!this.__processElementValueChanged)
                        return;

                    this.super.valueSet(base64Data);
                },
                _elementValueGet: function ()
                {
                    return this.$$inputElementImage.val();
                },
                _elementValueSet: function (value)
                {
                    this.__processElementValueChanged = false;

                    this.$$inputElementImage.val(value);

                    this.__processElementValueChanged = true;
                },
                _loadImageAsync: function (src)
                {
                    return new Promise((resolve, reject) =>
                    {
                        var
                            img = new Image();

                        img.addEventListener("load", () => { resolve(img); img = null; });
                        img.addEventListener("error", error => { reject(error); img = null; });
                        img.src = src;
                    });
                },

                // Event Handlers
                on$$InputElementImageChange: function (evt)
                {
                    var
                        self = evt.data.self,
                        objectUrl = evt.target.files?.length ? URL.createObjectURL(evt.target.files[0]) : null,
                        canvas,
                        context2d,
                        base64Data;

                    if (!objectUrl)
                        return;

                    self._loadingEnqueue();

                    self._loadImageAsync(objectUrl)
                        .then(img =>
                        {
                            canvas = $$.create("canvas");
                            canvas.width = img.width;
                            canvas.height = img.height;

                            context2d = canvas.getContext("2d");
                            context2d.drawImage(img, 0, 0);

                            base64Data = canvas.toDataURL("image/png");

                            evt.data.self._elementValueChanged(base64Data);

                            self._loadingDequeue();
                        })
                        .finally(() =>
                        {
                            base64Data = null;
                            context2d = null;
                            canvas = null;

                            self._loadingDequeue();
                        });
                },
            };
        }
    });

    // List
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "List",
        inherits: "InputControl",
        properties: [
            { name: "selectedItem" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                height: 50,
                tabStop: true
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-list");

                // Trigger Property Changes
                this.selectedItemTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _bindEvents: function ()
                {
                    this.super._bindEvents();

                    this.table.on("selectedItemChanged", { self: this }, this.onTableSelectedItemChanged);
                },
                _createElement: function ()
                {
                    this.super._createElement();

                    var
                        $$element = this.$$elementGet();

                    this.table =
                        new namespace.Table({ headerVisible: false, ledger: true, footerVisible: false, rowSelectable: true, rowSelectableType: namespace.Table.rowSelectTypes.single })
                        .appendTo($$element);

                    this.table.addColumn(new seriouslyrad.ui.web.TableColumn({ text: "Description", dataSourceProperty: "description" }));
                },
                _selectedItemChanged: function (change)
                {
                    this.trigger("selectedItemChanged", change);
                },
                _valueChanged: function (change)
                {
                    this.super._valueChanged(change);
                    this.table.dataSourceSet(change.currentValue);
                },

                // Public Methods
                remove: function ()
                {
                    if (this.table)
                    {
                        this.table.remove();
                        this.table = null;
                    }

                    this.super.remove();
                },

                // Event Handlers
                onTableSelectedItemChanged: function (evt, row)
                {
                    evt.data.self.selectedItemSet(row);
                }
            };
        }
    });

    // List Select
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "ListSelect",
        inherits: "InputControl",
        properties: [
            { name: "allowMultipleSelection", type: "boolean" }
        ],
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-list-select");

                // Trigger Property Changes
                this.allowMultipleSelectionTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _allowMultipleSelectionChanged: function (change)
                {
                    if (change.currentValue !== null && this.selectItemsDialog)
                        this.selectItemsDialog.allowMultipleSelectionSet(change.currentValue);
                },
                _bindEvents: function ()
                {
                    this.super._bindEvents();

                    this.buttonExpand.on("click", { self: this }, this.onButtonExpandClicked);
                },
                _createElement: function ()
                {
                    this.super._createElement();

                    var
                        $$element = this.$$elementGet();

                    this.textBoxSelectionDisplay =
                        new namespace.TextBox({ readOnly: true })
                            .appendTo($$element);

                    this.buttonExpand =
                        new namespace.Button({ cssClass: "rad-control-button-expand", inline: true, showLabel: false, svgKey: "icon-elipsis" })
                        .appendTo($$element);
                },
                _loadDataAsync: function ()
                {
                    return Promise.resolve();
                },
                _textGet: function ()
                {
                    return this.textBoxSelectionDisplay.valueGet();
                },
                _updateDisplay: function ()
                {
                    var
                        self = this,
                        value = self.valueGet(),
                        displayValue = String.empty;

                    if (value?.length)
                    {
                        var
                            dataValue = null;

                        if (self.selectItemsDialog)
                        {
                            var
                                data = self.selectItemsDialog.tableOptions.dataSourceGet();

                            dataValue = data ? data.dataGet() : null;
                        }

                        if (!dataValue && self.passedInitialData)
                        {
                            dataValue = self.passedInitialData;
                        }

                        if (dataValue?.length && value?.length)
                        {
                            if (!(value instanceof Array))
                                value = [value];

                            value
                                .each(selectedItem =>
                                {
                                    var
                                        match = dataValue.firstOrDefault(item => item.value === selectedItem);

                                    if (match)
                                    {
                                        if (displayValue)
                                            displayValue += ", ";

                                        displayValue += match.description;
                                    }
                                });
                        }
                    }

                    self.textBoxSelectionDisplay.valueSet(displayValue);
                },
                _valueChanged: function (change)
                {
                    this.super._valueChanged(change);
                    this._updateDisplay();
                },

                // Public Methods
                openSelectItemsDialogAsync: function ()
                {
                    var
                        self = this;

                    if (!self.selectItemsDialog)
                    {
                        self.selectItemsDialog = new namespace.SelectItemsDialog({
                            loadDataFunction: () => self._loadDataAsync(),
                            allowMultipleSelection: self.allowMultipleSelectionGet()
                        });
                    }

                    return (
                        self.selectItemsDialog
                            .onClosed(result =>
                            {
                                if (result[0] !== seriouslyrad.ui.web.Dialog.dialogResult.ok)
                                    return;

                                self.valueSet(result[1]);
                            })
                            .openAsync(self.valueGet())
                    );
                },

                // Event Handlers
                onButtonExpandClicked: function (evt)
                {
                    evt.data.self.openSelectItemsDialogAsync();
                }
            };
        }
    });

    // List Select (Application Entity)
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "ListSelectApplicationEntity",
        inherits: "ListSelect",
        properties: [
            { name: "primaryEntity", type: "string" },
            { name: "primaryEntityDescriptionProperty", type: "string" },
            { name: "primaryEntityOrderProperty", type: "string" }
        ],
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-list-select-application-entity");
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _loadDataAsync: function ()
                {
                    var
                        primaryEntity = this.primaryEntityGet(),
                        primaryEntityDescriptionProperty = this.primaryEntityDescriptionPropertyGet(),
                        primaryEntityOrderProperty = this.primaryEntityOrderPropertyGet();

                    if (!primaryEntity)
                        return Promise.reject("primaryEntity is not set");

                    if (!primaryEntityDescriptionProperty)
                        return Promise.reject("primaryEntityDescriptionProperty is not set");

                    if (!primaryEntityOrderProperty)
                        primaryEntityOrderProperty = primaryEntityDescriptionProperty;

                    return (
                        window.application.webApiClient
                            .createEntitySearchRequest(
                                primaryEntity,
                                null,
                                primaryEntityOrderProperty,
                                ["id", primaryEntityDescriptionProperty]
                            )
                            .executeAsync()
                            .then(data =>
                            {
                                if (!Array.isArray(data))
                                    return [];

                                return data.select(item => ({ value: item.id, description: window.objectHelper.propertyValueByPathGet(item, primaryEntityDescriptionProperty) }));
                            })
                    );
                }
            };
        }
    });

    // Multi Digit Code
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "MultiDigitCode",
        inherits: "InputControl",
        properties: [
            { name: "numberOfDigits", type: "int" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                numberOfDigits: 6
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-multi-digit-code");

                // Trigger Property Changes
                this.numberOfDigitsTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _addTextBoxes: function (numberToAdd)
                {
                    if (!this.textBoxes || !Array.isArray(this.textBoxes))
                        this.textBoxes = [];

                    var
                        originalLength = this.textBoxes.length,
                        $$element = this.$$elementGet(),
                        stopLoopAt = originalLength ? originalLength + numberToAdd + 1 : originalLength + numberToAdd;

                    for (var i = originalLength; i < stopLoopAt; i++)
                    {
                        this.textBoxes[i] =
                            new namespace.TextBox({ inline: true, maximumLength: 1, type: namespace.TextBox.type.number })
                                .appendTo($$element);

                        this.textBoxes[i].on("valueChanged", { self: this, index: i }, this.onTextBoxValueChanged);
                        this.textBoxes[i].on("keydown", { self: this, index: i }, this.onKeyDown);
                        this.textBoxes[i].on("keyup", { self: this, index: i }, this.onKeyUp);
                        this.textBoxes[i].on("paste", { self: this, index: i }, this.onPaste);
                    }
                },
                _dispose: function ()
                {
                    var
                        self = this;

                    if (Array.isArray(this.textBoxes))
                    {
                        this.textBoxes.forEach(item =>
                        {
                            item.off("valueChanged", { self: self }, self.onTextBoxValueChanged);
                            item.off("keyup", { self: self }, self.onKeyUp);
                            item.off("paste", { self: self }, self.onPaste);
                        });
                    }

                    this.super._dispose();
                },
                _elementValueChanged: function ()
                {
                    if (!this.__processElementValueChanged)
                        return;

                    this.super.valueSet(this._elementValueGet());
                },
                _elementValueGet: function ()
                {
                    var
                        characters = [];

                    if (Array.isArray(this.textBoxes))
                    {
                        this.textBoxes.forEach(item =>
                        {
                            characters.push(item.valueGet());
                        });
                    }

                    return characters.join(String.empty);
                },
                _elementValueSet: function (value)
                {
                    this.__processElementValueChanged = false;

                    var
                        characters = value.split(String.empty);

                    if (Array.isArray(this.textBoxes))
                    {
                        for (var i = 0; i < this.textBoxes.length; i++)
                        {
                            this.textBoxes[i].valueSet(characters.length > i ? characters[i] : null);
                        }
                    }

                    this.__processElementValueChanged = true;
                },
                _enabledChanged: function (change)
                {
                    this.super._enabledChanged(change);

                    if (Array.isArray(this.textBoxes))
                    {
                        this.textBoxes.forEach(item =>
                        {
                            item.enabledSet(change.currentValue);
                        });
                    }
                },
                _getFocusElement: function ()
                {
                    if (this.textBoxes?.length)
                        return this.textBoxes[0]._getFocusElement();

                    return this.super._getFocusElement();
                },
                _numberOfDigitsChanged: function (change)
                {
                    if (!this.textBoxes === undefined || !Array.isArray(this.textBoxes))
                        this.textBoxes = [];

                    if (!change.currentValue && this.textBoxes.length)
                        this._removeTextBoxes(this.textBoxes.length);
                    else if (change.currentValue && !this.textBoxes.length)
                        this._addTextBoxes(change.currentValue);
                    else if (change.currentValue < this.textBoxes.length)
                        this._removeTextBoxes(this.textBoxes.length - change.currentValue);
                    else if (change.currentValue > this.textBoxes.length)
                        this._addTextBoxes(change.currentValue - this.textBoxes.length);
                },
                _removeTextBoxes: function (numberToRemove)
                {
                    if (!Array.isArray(this.textBoxes) || !this.textBoxes.length)
                        return;

                    if (numberToRemove > this.textBoxes.length)
                        numberToRemove = this.textBoxes.length;

                    var
                        originalLength = this.textBoxes.length;

                    for (var i = originalLength - 1; i >= (originalLength - 1) - numberToRemove; i--)
                    {
                        this.textBoxes[i].off("valueChanged", { self: this }, this.onTextBoxValueChanged);
                        this.textBoxes[i].remove();
                    }

                    this.textBoxes.length = originalLength - numberToRemove;
                },

                // Public Methods
                textGet: function ()
                {
                    var
                        value = this.valueGet();

                    if (!value)
                        return String.empty;

                    return value;
                },
                valueSet: function (value)
                {
                    if (!value)
                        value = String.empty;

                    if (this.valueGet() === value)
                        return false;

                    this._elementValueSet(value);
                    this.super.valueSet(this._elementValueGet());

                    return true;
                },

                // Event Handlers
                onKeyDown: function (evt)
                {
                    const
                        self = evt.data.self;

                    let
                        keyHandled = false,
                        value;

                    switch (evt.key)
                    {
                        case "Backspace":

                            if (evt.data.index === undefined)
                                break;

                            value = self.textBoxes[evt.data.index].valueGet();

                            if (value)
                                self.textBoxes[evt.data.index].valueSet(String.empty);
                            else if (evt.data.index > 0)
                            {
                                self.textBoxes[evt.data.index - 1].valueSet(String.empty);
                                self.textBoxes[evt.data.index - 1].focus();
                            }

                            keyHandled = true;

                            break;
                    }

                    if (keyHandled)
                    {
                        evt.preventDefault();
                        evt.stopPropagation();
                    }
                },
                onKeyUp: function (evt)
                {
                    const
                        self = evt.data.self;

                    let
                        keyHandled = false,
                        value;

                    switch (evt.key)
                    {
                        case "Alt":
                        case "ArrowDown":
                        case "ArrowLeft":
                        case "ArrowRight":
                        case "ArrowUp":
                        case "Backspace":
                        case "Cancel":
                        case "CapsLock":
                        case "Control":
                        case "Delete":
                        case "End":
                        case "Enter":
                        case "Escape":
                        case "Home":
                        case "Insert":
                        case "PageDown":
                        case "PageUp":
                        case "Pause":
                        case "Shift":
                        case "Tab":
                            break;

                        default:

                            if (evt.data.index === undefined)
                                break;

                            value = self.textBoxes[evt.data.index].valueGet();

                            if (!value)
                                break;

                            const
                                finalIndex = Math.min(evt.data.index + value.length, self.textBoxes.length);

                            for (let i = evt.data.index; i < finalIndex; i++)
                                self.textBoxes[i].valueSet(value.substring(i - evt.data.index, i - evt.data.index + 1));

                            self.textBoxes[finalIndex < self.textBoxes.length ? finalIndex : self.textBoxes.length - 1].focus();

                            keyHandled = true;

                            break;
                    }

                    if (keyHandled)
                    {
                        evt.preventDefault();
                        evt.stopPropagation();
                    }
                },
                onPaste: function (evt)
                {
                    evt.preventDefault();
                    evt.stopPropagation();

                    const
                        self = evt.data.self,
                        numberOfTextBoxes = Array.isArray(self.textBoxes) ? self.textBoxes.length : 0;

                    let
                        pastedText = evt.originalEvent.clipboardData.getData("text");
                        
                    if (pastedText.length > numberOfTextBoxes)
                        pastedText = pastedText.substr(0, numberOfTextBoxes);

                    self.valueSet(pastedText);

                    if (Array.isArray(self.textBoxes) && self.textBoxes.length)
                        self.textBoxes[pastedText.length < self.textBoxes.length ? pastedText.length : self.textBoxes.length - 1].focus();

                    return false;
                },
                onTextBoxValueChanged: function (evt)
                {
                    evt.data.self._elementValueChanged();
                },
            };
        }
    });

    // Numeric Up Down
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "NumericUpDown",
        inherits: "InputControl",
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-numeric-up-down ui right labeled input");
                this.$$buttonContainer.addClass("rad-button-container ui mini vertical buttons");
                this.$$plusButton.addClass("rad-button-plus ui icon button");
                this.$$plusButton.find(">i").addClass("up chevron icon");
                this.$$minusButton.addClass("rad-button-minus ui icon button");
                this.$$minusButton.find(">i").addClass("down chevron icon");
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _bindEvents: function ()
                {
                    this.super._bindEvents();

                    var
                        self = this;

                    self.$$plusButton.on("click", () =>
                    {
                        var value = self.valueGet();
                        self.valueSet(isNaN(value) || value === null ? 0 : value + 1);
                    });

                    self.$$minusButton.on("click", () =>
                    {
                        var value = self.valueGet();
                        self.valueSet(isNaN(value) || value === null ? 0 : value - 1);
                    });

                    self.$$valueElement.on("change input keyup", () => { self._elementValueChanged(); });
                },
                _createElement: function ()
                {
                    this.super._createElement();

                    var
                        $$element = this.$$elementGet();

                    this.$$valueElement = $$element.find(">input");
                    if (!this.$$valueElement.length)
                        this.$$valueElement = $$(String.formatWithHtmlEncode("<input id=\"{0}-input\" type=\"text\" />", this.controlId)).appendTo($$element);

                    this.$$buttonContainer = $$element.find(">.rad-button-container");
                    if (!this.$$buttonContainer.length)
                        this.$$buttonContainer = $$.create$$({ nodeName: "div" }).appendTo($$element);

                    this.$$plusButton = this.$$buttonContainer.find(".rad-button-plus");
                    if (!this.$$plusButton.length)
                    {
                        this.$$plusButton =
                            $$.create$$({
                                nodeName: "button",
                                children: [{ nodeName: "i" }]
                            }).appendTo(this.$$buttonContainer);
                    }

                    this.$$minusButton = this.$$buttonContainer.find(".rad-button-minus");
                    if (!this.$$minusButton.length)
                    {
                        this.$$minusButton =
                            $$.create$$({
                                nodeName: "button",
                                children: [{ nodeName: "i" }]
                            }).appendTo(this.$$buttonContainer);
                    }
                },
                _elementValueChanged: function ()
                {
                    if (!this.__processElementValueChanged)
                        return;

                    this.super.valueSet(this._elementValueGet());
                },
                _elementValueGet: function ()
                {
                    var
                        value = parseInt(this.$$valueElement.val());

                    return isNaN(value) ? null : value;
                },
                _elementValueSet: function (value)
                {
                    this.__processElementValueChanged = false;
                    this.$$valueElement.val(value);
                    this.__processElementValueChanged = true;
                },

                // Public Methods
                textGet: function ()
                {
                    return this.valueGet();
                },
                valueSet: function (value)
                {
                    if (this.valueGet() === value)
                        return false;

                    this._elementValueSet(value);
                    this.super.valueSet(this._elementValueGet());

                    return true;
                }
            };
        }
    });

    // Rank
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "Rank",
        inherits: "InputListControl",
        properties: [
            { name: "numberOfRanks", type: "int" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                numberOfRanks: 3
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-rank");

                // Trigger Property Changes
                this.numberOfRanksTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _elementValueChanged: function ()
                {
                    if (!this.__processElementValueChanged)
                        return;

                    this.super.valueSet(this._elementValueGet());
                },
                _elementValueGet: function ()
                {
                    var
                        checkboxes = this.$$elementGet().find(".checkbox > input:checked"),
                        value = null,
                        listDataSourceValueProperty = this.listDataSourceValuePropertyGet(),
                        numberOfRanks = this.numberOfRanksGet();

                    if (checkboxes.length > 0)
                    {
                        for (var i = 0; i < numberOfRanks; i++)
                        {
                            checkboxes
                                .filter("[data-rank='" + (i + 1) + "']")
                                .each((index, element) =>
                                {
                                    if (value === null)
                                        value = [];

                                    var
                                        option = $$(element).parent().dataGet("rad-option");

                                    if (option)
                                        value.push(option[listDataSourceValueProperty]);
                                });
                        }
                    }

                    if (value?.length < this.numberOfRanksGet())
                        value = null;

                    return value;
                },
                _elementValueSet: function (value)
                {
                    this.__processElementValueChanged = false;

                    var
                        checkboxes = this.$$elementGet().find("input");

                    checkboxes.parent().removeClass("checked");
                    checkboxes.prop("checked", false);

                    if (value)
                    {
                        value.each((item, index) =>
                        {
                            checkboxes
                                .filter("[data-rank='" + (index + 1) + "']")
                                .filter("[value='" + item + "']")
                                .prop("checked", true);
                        });
                    }

                    this.__processElementValueChanged = true;
                },
                _enabledChanged: function (change)
                {
                    this.super._enabledChanged(change);

                    this.$$elementGet().find(".checkbox").each((index, element) =>
                    {
                        if (!change.currentValue)
                            $$(element).addClass("disabled");
                        else
                            $$(element).removeClass("disabled");
                    });
                },
                _numberOfRanksChanged: function (change)
                {
                    this.refreshListDataSource();
                },
                _readOnlyChanged: function (change)
                {
                    this.super._readOnlyChanged(change);

                    this.$$elementGet().find(".checkbox").each((index, element) =>
                    {
                        if (change.currentValue)
                            $$(element).addClass("read-only");
                        else
                            $$(element).removeClass("read-only");
                    });
                },
                _refreshListDataSource: function ()
                {
                    this.super._refreshListDataSource();

                    var
                        self = this,
                        $$element = self.$$elementGet();
                    //backupValue = self._elementValueGet();

                    $$element.empty();
                    self.labelTargetId = null;

                    var
                        listDataSource = self.listDataSourceGet();

                    if (!listDataSource)
                        return;

                    var
                        listData = listDataSource.dataGet();

                    if (!listData)
                        return;

                    var
                        listDataSourceValueProperty = self.listDataSourceValuePropertyGet();

                    if (!listDataSourceValueProperty)
                        return;

                    var
                        listDataSourceDescriptionProperty = self.listDataSourceDescriptionPropertyGet();

                    if (!listDataSourceDescriptionProperty)
                        return;

                    var
                        numberOfRanks = self.numberOfRanksGet(),
                        $$table = $$.create$$("table").appendTo($$element),
                        $$thead = $$.create$$("thead").appendTo($$table),
                        $$tbody = $$.create$$("tbody").appendTo($$table),
                        $$tr,
                        $$th,
                        $$td;

                    $$tr = $$.create$$({ nodeName: "tr" }).appendTo($$thead);
                    $$.create$$("th").appendTo($$tr);

                    for (var i = 0; i < numberOfRanks; i++)
                    {
                        $$th = $$.create$$("th").addClass("rank").appendTo($$tr);
                        $$th.text(i + 1);
                    }

                    listData.each(item =>
                    {
                        var
                            itemId = String.format("{0}-{1}", self.controlId, item[listDataSourceValueProperty]);

                        $$tr = $$.create$$({ nodeName: "tr" }).appendTo($$tbody);
                        $$td = $$.create$$("td").appendTo($$tr);
                        $$td.text(item[listDataSourceDescriptionProperty]);

                        for (var i = 0; i < numberOfRanks; i++)
                        {
                            $$td = $$.create$$("td").addClass("rank").appendTo($$tr);

                            var
                                option =
                                    $$(
                                        String.format(
                                            "<div class=\"field\">"
                                            + "    <div class=\"ui radio{0} checkbox\" id=\"{1}\">"
                                            + "        <input type=\"radio\" name=\"{2}\" value=\"{3}\" data-rank=\"{4}\">"
                                            + "        <label></label>"
                                            + "    </div>"
                                            + "</div>",
                                            self.readOnlyGet() ? " read-only" : String.empty,
                                            String.htmlEncode(itemId + "-" + i),
                                            self.controlId + "-" + i,
                                            String.htmlEncode(item[listDataSourceValueProperty]),
                                            i + 1
                                        )
                                    )
                                        .appendTo($$td);

                            option.find(".checkbox").data("rad-option", item);

                            if (self.labelTargetId === null)
                                self.labelTargetId = itemId + "-" + i;
                        }
                    });

                    self.$$elementGet().find(".checkbox").checkbox({
                        onChange: function ()
                        {
                            self._elementValueChanged();
                        }
                    });

                    //self._elementValueSet(backupValue);
                },

                // Public Methods
                textGet: function ()
                {
                    var
                        checkboxes = this.$$elementGet().find(".checkbox > input:checked"),
                        value = String.empty,
                        listDataSourceDescriptionProperty = this.listDataSourceDescriptionPropertyGet();

                    if (checkboxes.length > 0)
                    {
                        checkboxes.each((index, element) =>
                        {
                            var
                                option = $$(element).parent().dataGet("rad-option");

                            if (option)
                                value += (value.length ? ", " : String.empty) + option[listDataSourceDescriptionProperty];
                        });
                    }

                    return value;
                },
                valueSet: function (value)
                {
                    if (window.objectHelper.typeOf(value) === "string")
                        value = value.split(",");

                    if (value)
                    {
                        if (!Array.isArray(value) || value.length === 0)
                            value = null;
                    }

                    if (this.valueGet() === value)
                        return false;

                    this._elementValueSet(value);
                    this.super.valueSet(this._elementValueGet());

                    return true;
                }
            };
        }
    });

    // Text Box
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "TextBox",
        inherits: "InputControl",
        properties: [
            { name: "autoComplete", type: "boolean" },
            { name: "changeEvent", type: "string" },
            { name: "icon", type: "string" },
            { name: "inputMax", type: "float" },
            { name: "inputMin", type: "float" },
            { name: "inputSize", type: "int" },
            { name: "leftLabelText", type: "string" },
            { name: "maximumLength", type: "int" },
            { name: "placeholder", type: "string" },
            { name: "rightLabelText", type: "string" },
            { name: "svgKey", type: "string" },
            { name: "type", type: "string" }
        ],
        propertyAttributes: [
            {
                propertyName: "placeholder",
                designer: {
                    category: "Appearance",
                    displayName: "Placeholder"
                }
            },
            {
                propertyName: "type",
                designer: {
                    category: "Behavior",
                    displayName: "Type"
                }
            }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                autoComplete: false,
                changeEvent: "change input keyup",
                labeled: false,
                type: namespace.TextBox.type.normal
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-text-box ui form");

                // Trigger Property Changes
                this.autoCompleteTriggerChange();
                this.iconTriggerChange();
                this.inputMaxTriggerChange();
                this.inputMinTriggerChange();
                this.inputSizeTriggerChange();
                this.leftLabelTextTriggerChange();
                this.placeholderTriggerChange();
                this.rightLabelTextTriggerChange();
                this.svgKeyTriggerChange();
                this.typeTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _autoCompleteChanged: function (change)
                {
                    if (change.currentValue === false)
                        this.$$valueElement.attr("autocomplete", "new-password"); // Use "new-password" rather than "off" so Chrome obeys
                    else
                        this.$$valueElement.removeAttr("autocomplete");
                },
                _createElement: function ()
                {
                    this.super._createElement();

                    switch (this.typeGet())
                    {
                        case namespace.TextBox.type.date:
                        case namespace.TextBox.type.email:
                        case namespace.TextBox.type.normal:
                        case namespace.TextBox.type.password:
                            this.addCssClass("input");
                            break;
                        case namespace.TextBox.type.multiline:
                            this.addCssClass("form");
                            break;
                    }

                    this._createInternalElements();
                },
                _createInternalElements: function ()
                {
                    var
                        $$element = this.$$elementGet(),
                        type = this.typeGet(),
                        htmlInputType,
                        numberStep,
                        maximumLength = this.maximumLengthGet();

                    switch (type)
                    {
                        case namespace.TextBox.type.date:
                            htmlInputType = "text";
                            break;
                        case namespace.TextBox.type.email:
                            htmlInputType = "email";
                            break;
                        case namespace.TextBox.type.multiline:
                            htmlInputType = String.empty;
                            break;
                        case namespace.TextBox.type.normal:
                            htmlInputType = "text";
                            break;
                        case namespace.TextBox.type.number:
                        case namespace.TextBox.type.number2Dp:
                            htmlInputType = "number";
                            break;
                        case namespace.TextBox.type.password:
                            htmlInputType = "password";
                            break;
                        default:
                            console.error(String.format("Type \"{0}\" is not supported", type));
                            break;
                    }

                    switch (type)
                    {
                        case namespace.TextBox.type.number:
                            numberStep = "1";
                            break;
                        case namespace.TextBox.type.number2Dp:
                            numberStep = "0.01";
                            break;
                    }

                    $$element.empty();

                    if (this.$$valueElement)
                    {
                        this.$$valueElement.off("blur", this.onValueElementBlurred);
                        this.$$valueElement.off(this.changeEventGet(), this.onValueElementChanged);
                        this.$$valueElement.off("focus", this.onValueElementFocussed);
                        this.$$valueElement.off("keyup", this.onValueElementKeyUp);
                    }

                    switch (type)
                    {
                        case namespace.TextBox.type.multiline:
                            // No left label
                            break;
                        default:
                            this.$$leftLabelElement = $$.create$$({
                                nodeName: "div",
                                attributes: { "class": "ui label" }
                            }).hide().appendTo($$element);
                            break;
                    }

                    this.$$iconElement = $$.create$$({
                        nodeName: "i",
                        attributes: { "class": "icon" }
                    }).hide().appendTo($$element);

                    this.$$svgWrapper = $$.create$$({
                        nodeName: "span",
                        attributes: { "class": "rad-svg-wrapper" }
                    }).hide().appendTo($$element);

                    switch (type)
                    {
                        case namespace.TextBox.type.multiline:
                            this.$$valueElement = $$(String.formatWithHtmlEncode("<textarea id=\"{0}-textarea\"></textarea>", this.controlId)).appendTo($$element);
                            break;
                        case namespace.TextBox.type.number:
                        case namespace.TextBox.type.number2Dp:
                            this.$$valueElement = $$(String.formatWithHtmlEncode("<input id=\"{0}-input\" type=\"{1}\" step=\"{2}\" />", this.controlId, htmlInputType, numberStep)).appendTo($$element);
                            break;
                        default:
                            this.$$valueElement = $$(String.formatWithHtmlEncode("<input id=\"{0}-input\" type=\"{1}\" />", this.controlId, htmlInputType)).appendTo($$element);
                            break;
                    }

                    this.$$valueElement.on("blur", { self: this }, this.onValueElementBlurred);
                    this.$$valueElement.on(this.changeEventGet(), { self: this }, this.onValueElementChanged);
                    this.$$valueElement.on("focus", { self: this }, this.onValueElementFocussed);
                    this.$$valueElement.on("keyup", { self: this }, this.onValueElementKeyUp);

                    switch (type)
                    {
                        case namespace.TextBox.type.multiline:
                            // No right label
                            break;
                        default:
                            this.$$rightLabelElement = $$.create$$({
                                nodeName: "div",
                                attributes: { "class": "ui label" }
                            }).hide().appendTo($$element);
                            break;
                    }

                    if (maximumLength)
                        this.$$valueElement.attr("maxlength", maximumLength);
                    else
                        this.$$valueElement.removeAttr("maxlength");

                    this.labelTargetId = this.$$valueElement.attr("id");
                },
                _elementValueChanged: function ()
                {
                    if (!this.__processElementValueChanged)
                        return;

                    this.super.valueSet(this._elementValueGet());
                },
                _elementValueGet: function ()
                {
                    return this._formatValue(this.$$valueElement.val());
                },
                _elementValueSet: function (value)
                {
                    this.__processElementValueChanged = false;
                    this.$$valueElement.val(this._formatValue(value));
                    this.__processElementValueChanged = true;
                },
                _enabledChanged: function (change)
                {
                    this.super._enabledChanged(change);

                    if (change.currentValue)
                        this.$$valueElement.removeAttr("disabled");
                    else
                        this.$$valueElement.attr("disabled", "disabled");
                },
                _formatValue: function (value)
                {
                    if (Object.isNullOrUndefined(value))
                        return null;

                    switch (this.typeGet())
                    {
                        case namespace.TextBox.type.number2Dp:
                            {
                                var
                                    valueFloat = parseFloat(value);

                                return !isNaN(valueFloat) ? valueFloat.toFixed(2) : null;
                            }
                        default:
                            return value;
                    }
                },
                _getFocusElement: function ()
                {
                    return this.$$valueElement;
                },
                _iconChanged: function (change)
                {
                    if (change.originalValue)
                    {
                        this.removeCssClass("icon");
                        this.$$iconElement.removeClass(change.originalValue);
                        this.$$iconElement.hide();
                    }

                    if (change.currentValue)
                    {
                        this.addCssClass("icon");
                        this.$$iconElement.addClass(change.currentValue);
                        this.$$iconElement.show();
                    }
                },
                _inputMaxChanged: function (change)
                {
                    if (this.$$valueElement)
                        this.$$valueElement.attr("max", change.currentValue || String.empty);
                },
                _inputMinChanged: function (change)
                {
                    if (this.$$valueElement)
                        this.$$valueElement.attr("min", change.currentValue || String.empty);
                },
                _inputSizeChanged: function (change)
                {
                    if (this.$$valueElement)
                        this.$$valueElement.attr("size", change.currentValue || String.empty);
                },
                _leftLabelTextChanged: function (change)
                {
                    this._updateLayout();
                },
                _maximumLengthChanged: function (change)
                {
                    if (change.currentValue)
                        this.$$valueElement.attr("maxlength", change.currentValue);
                    else
                        this.$$valueElement.removeAttr("maxlength");
                },
                _placeholderChanged: function (change)
                {
                    this.$$valueElement.attr("placeholder", change.currentValue);
                },
                _readOnlyChanged: function (change)
                {
                    this.super._readOnlyChanged(change);

                    if (change.currentValue)
                        this.addCssClass("read-only");
                    else
                        this.removeCssClass("read-only");

                    this.$$valueElement.prop("readOnly", change.currentValue);
                },
                _rightLabelTextChanged: function (change)
                {
                    this._updateLayout();
                },
                _svgKeyChanged: function (change)
                {
                    if (change.currentValue)
                    {
                        this.$$svgWrapper.empty();
                        this.$$svgWrapper.append(window.svgHelper.createSvg(change.currentValue)).show();
                    }
                    else
                        this.$$svgWrapper.hide();
                },
                _typeChanged: function (change)
                {
                    if (this.__isConstructing())
                        return;

                    this._createInternalElements();

                    // Trigger Property Changes
                    this.autoCompleteTriggerChange();
                    this.iconTriggerChange();
                    this.inputMaxTriggerChange();
                    this.inputMinTriggerChange();
                    this.inputSizeTriggerChange();
                    this.leftLabelTextTriggerChange();
                    this.placeholderTriggerChange();
                    this.rightLabelTextTriggerChange();
                    this.svgKeyTriggerChange();
                },
                _valueChanged: function (change)
                {
                    this.super._valueChanged(change);
                    this._elementValueSet(change.currentValue);
                },
                _updateLayout: function ()
                {
                    if (!(this.$$leftLabelElement && this.$$rightLabelElement))
                        return;

                    var
                        leftLabelText = this.leftLabelTextGet(),
                        rightLabelText = this.rightLabelTextGet();

                    this.$$leftLabelElement.text(leftLabelText);
                    this.$$rightLabelElement.text(rightLabelText);

                    if (leftLabelText || rightLabelText)
                    {
                        if (rightLabelText)
                            this.addCssClass("right labeled");
                        else
                            this.addCssClass("labeled");
                    }
                    else
                        this.removeCssClass("right labeled");

                    if (leftLabelText)
                        this.$$leftLabelElement.show();
                    else
                        this.$$leftLabelElement.hide();

                    if (rightLabelText)
                        this.$$rightLabelElement.show();
                    else
                        this.$$rightLabelElement.hide();
                },

                // Public Methods
                select: function ()
                {
                    this.$$valueElement.select();
                },
                textGet: function ()
                {
                    return this.valueGet();
                },

                // Event Handlers
                onValueElementBlurred: function (evt)
                {
                    const
                        self = evt.data.self;

                    if (self.typeGet() === namespace.TextBox.type.date)
                    {
                        self.$$valueElement?.attr("type", "text");

                        const
                            value = self.valueGet();

                        self.valueSet(
                            /[0-9]{4}-[0-9]{2}-[0-9]{2}/.test(value)
                                ? `${value.substring(8, 10)}-${value.substring(5, 7)}-${value.substring(0, 4)}`
                                : null
                        );
                    }
                },
                onValueElementChanged: function (evt)
                {
                    evt.data.self._elementValueChanged();
                },
                onValueElementFocussed: function (evt)
                {
                    const
                        self = evt.data.self;

                    if (self.typeGet() === namespace.TextBox.type.date)
                    {
                        const
                            value = self.valueGet();

                        self.valueSet(
                            /[0-9]{2}-[0-9]{2}-[0-9]{4}/.test(value)
                                ? `${value.substring(6, 10)}-${value.substring(3, 5)}-${value.substring(0, 2)}`
                                : null
                        );

                        self.$$valueElement?.attr("type", "date");
                    }
                },
                onValueElementKeyUp: function (evt)
                {
                    if (evt.data.self.typeGet() === namespace.TextBox.type.multiline)
                    {
                        switch (evt.key)
                        {
                            case "Enter":
                                evt.stopPropagation();
                                break;
                        }
                    }
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.type =
            {
                date: "date",
                email: "email",
                multiline: "multiline",
                normal: "normal",
                number: "number",
                number2Dp: "number2Dp",
                password: "password"
            };
        }
    });

    // Barcode Text Box
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "BarcodeTextBox",
        inherits: "InputControl",
        properties: [
            { name: "allowManualEntry", type: "boolean" },
            { name: "barcodeType" },
            { name: "placeholder", type: "string" },
            { name: "title" }
        ],
        propertyAttributes: [
            {
                propertyName: "placeholder",
                designer: {
                    category: "Appearance",
                    displayName: "Placeholder"
                }
            },
            {
                propertyName: "allowManualEntry",
                designer: {
                    category: "Behavior",
                    displayName: "Allow Manual Barcode Entry"
                }
            },
            {
                propertyName: "barcodeType",
                designer: {
                    category: "Behavior",
                    displayName: "Barcode Type"
                }
            },
            {
                propertyName: "title",
                designer: {
                    category: "Appearance",
                    displayName: "Popup Title"
                }
            }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                allowManualEntry: false,
                barcodeType: namespace.BarcodeTextBox.barcodeType.code_128_reader
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-barcode-text-box ui form input");

                // Trigger Property Changes
                this.placeholderTriggerChange();
                this.barcodeTypeTriggerChange();
                this.allowManualEntryTriggerChange();
                this.titleTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _allowManualEntryChanged: function (change)
                {
                    this.dialog.allowManualEntrySet(change.currentValue);
                },
                _barcodeTypeChanged: function (change)
                {

                    var
                        barcodeSettings = this.dialog.barcodeSettingsGet();

                    barcodeSettings.decoder.readers = [{
                        format: change.currentValue,
                        config: {}
                    }];

                    this.dialog.barcodeSettingsSet(window.objectHelper.cloneObject(barcodeSettings));
                },
                _bindEvents: function ()
                {
                    this.super._bindEvents();
                    this.button.on("click", { self: this }, this.onButtonClicked);
                },
                _createElement: function ()
                {
                    this.super._createElement();

                    var
                        $$element = this.$$elementGet();

                    this.textBox = new namespace.TextBox({ enabled: false }).appendTo($$element);
                    this.button = new namespace.Button({ icon: "barcode", inline: true, showLabel: false }).appendTo($$element);
                    this.dialog = new namespace.BarcodeDialog();
                },
                _elementValueGet: function ()
                {
                    return this.textBox.valueGet();
                },
                _elementValueSet: function (value)
                {
                    this.__processElementValueChanged = false;
                    this.textBox.valueSet(value);
                    this.__processElementValueChanged = true;
                },
                _enabledChanged: function (change)
                {
                    this.super._enabledChanged(change);

                    this.button.enabledSet(change.currentValue);
                },
                _placeholderChanged: function (change)
                {
                    this.textBox.placeholderSet(change.currentValue);
                },
                _titleChanged: function (change)
                {
                    this.dialog.titleSet(change.currentValue);
                },
                _valueChanged: function (change)
                {
                    this.super._valueChanged(change);

                    this._elementValueSet(change.currentValue);
                },

                // Public Methods
                remove: function ()
                {
                    if (this.button)
                    {
                        this.button.remove();
                        this.button = null;
                    }

                    this.super.remove();
                },
                valueGet: function ()
                {
                    return this.textBox.valueGet();
                },

                // Event Handlers
                onButtonClicked: function (evt)
                {
                    var
                        self = evt.data.self;

                    self.dialog
                        .openAsync()
                        .then(result =>
                        {
                            if (result[0] === namespace.Dialog.dialogResult.ok)
                                self._elementValueSet(result.scannedCode);
                        });
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.barcodeType =
                {
                    code_128_reader: "code_128_reader",
                    ean_reader: "ean_reader",
                    ean_8_reader: "ean_8_reader",
                    code_39_reader: "code_39_reader",
                    code_39_vin_reader: "code_39_vin_reader",
                    codabar_reader: "codabar_reader",
                    upc_reader: "upc_reader",
                    upc_e_reader: "upc_e_reader",
                    i2of5_reader: "i2of5_reader"
                };
        }
    });

    // Entity Picker
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "EntityPicker",
        inherits: "InputControl",
        properties: [
            { name: "dialogClassPath", type: "string" }
        ],
        createConstructor: namespace =>
            function ()
            {
                this.addCssClass("rad-control-entity-picker");
            },
        createPrototype: namespace => ({
            // "Protected" Methods
            _bindEvents: function ()
            {
                this.super._bindEvents();

                this.buttonClear.on("click", { self: this }, this.onButtonClearClicked);
                this.buttonSearch.on("click", { self: this }, this.onButtonSearchClicked);
            },
            _createElement: function ()
            {
                this.super._createElement();

                const
                    $$element = this.$$elementGet();

                this.wrapper =
                    new seriouslyrad.ui.web.Panel({ cssClass: "rad-wrapper" })
                        .appendTo($$element);

                this.$$descriptionElement =
                    $$.create$$({
                        nodeName: "p",
                        attributes: { "class": "rad-description" }
                    });

                this.wrapper.append(this.$$descriptionElement);

                this.buttonClear =
                    new namespace.Button({ cssClass: "rad-action-clear", inline: true, svgKey: "icon-cross" });

                this.buttonClear.$$elementGet().appendTo($$element);

                this.buttonSearch =
                    new namespace.Button({ cssClass: "rad-action-search", inline: true, svgKey: "icon-search" });

                this.buttonSearch.$$elementGet().appendTo($$element);
            },
            _openDialogAsync: function ()
            {
                return this.dialog.openAsync();
            },
            _readOnlyChanged: function (change)
            {
                this.buttonSearch.enabledSet(!change.currentValue);
            },
            _refreshFromDataSource: function ()
            {
                this.super._refreshFromDataSource()
                this._updateTextAsync();
            },
            _textChanged: function (change)
            {
                this.super._textChanged(change);
                this.$$descriptionElement.text(change.currentValue);
                this.$$descriptionElement.attr("title", change.currentValue ?? String.empty);
            },
            _updateTextAsync: function ()
            {
                return Promise.resolve();
            },

            // Event Handlers
            onButtonClearClicked: function (evt)
            {
                evt.data.self.valueSet(null);
            },
            onButtonSearchClicked: function (evt)
            {
                const
                    self = evt.data.self;

                if (!self.dialog)
                {
                    const
                        dialogClassPath = self.dialogClassPathGet();

                    if (dialogClassPath)
                    {
                        let
                            controlClass =
                                classFactory.getObjectByPath({ path: dialogClassPath, namespace: namespace })
                                ?? classFactory.getObjectByPath({ path: dialogClassPath });

                        if (controlClass)
                            self.dialog = new controlClass();
                    }
                }

                if (self.dialog)
                {
                    self._openDialogAsync()
                        .then(returnValue =>
                        {
                            const
                                dialogResult = returnValue[0],
                                selectedItemId = returnValue[1];

                            if (dialogResult !== namespace.Dialog.dialogResult.ok)
                                return;

                            self.valueSet(selectedItemId);

                            self._loadingEnqueue()

                            self._updateTextAsync()
                                .finally(() => self._loadingDequeue());
                        });
                }
            }
        })
    });

    // #endregion

    // Source Code
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "SourceCode",
        inherits: "InputControl",
        properties: [
            { name: "mode", type: "string" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                mode: namespace.SourceCode.mode.csharp,
                propagateInputEvents: true
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-source-code");

                // Trigger Property Changes
                this.modeTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _bindEvents: function ()
                {
                    var
                        self = this;

                    self.super._bindEvents();

                    self.on("keyup", { self: self }, self.onKeyUp);
                    self.$$handle.on("mousedown", { self: self }, self.onHandleElementMouseDown);
                    self.editor.on("change", (editor, change) => { self.onEditorChanged({ data: { self: self } }, { editor: editor, change: change }); });
                },
                _dispose: function ()
                {
                    if (this.editor)
                        this.editor.toTextArea();

                    this.super._dispose();
                },
                _createElement: function ()
                {
                    this.super._createElement();

                    var
                        $$element = this.$$elementGet();

                    this.$$valueElement =
                        $$.create$$({
                            nodeName: "textarea"
                        }).appendTo($$element);

                    this.editor = CodeMirror.fromTextArea(this.$$valueElement[0], {
                        _owner: this,
                        extraKeys: {
                            "Tab": function (cm)
                            {
                                cm.replaceSelection("  ", "end");
                            }
                        },
                        lineNumbers: true,
                        mode: this.modeGet(),
                        matchBrackets: true
                    });

                    this.triggerHandler("editorCreated", this.editor);

                    this.$$handle =
                        $$.create$$({
                            nodeName: "div",
                            attributes: { "class": "rad-handle" }
                        }).appendTo($$element);
                },
                _elementValueChanged: function ()
                {
                    this.__elementValueChanging = true;
                    this.super.valueSet(this._elementValueGet());
                    this.__elementValueChanging = false;
                },
                _elementValueGet: function ()
                {
                    return this.$$valueElement.val();
                },
                _elementValueSet: function (value)
                {
                    if (this.__elementValueChanging)
                        return;

                    this.editor.getDoc().setValue(!Object.isNullOrUndefined(value) ? value : String.empty);
                },
                _modeChanged: function (change)
                {
                    if (this.editor)
                        this.editor.setOption("mode", change.currentValue);
                },
                _valueChanged: function (change)
                {
                    this.super._valueChanged(change);
                    this._elementValueSet(change.currentValue);
                },

                // Event Handlers
                onAncestorVisibilityChanged: function (evt, change)
                {
                    evt.data.self.editor.refresh();
                },
                onBodyMouseMove: function (evt)
                {
                    var
                        self = evt.data.self;

                    self.editor.setSize(null, Math.max(100, (self.resizeInfo.startHeight + evt.originalEvent.y - self.resizeInfo.startY)) + "px");
                },
                onEditorChanged: function (evt, eventData)
                {
                    var
                        self = evt.data.self;

                    self.editor.save();
                    self._elementValueChanged();
                },
                onHandleElementMouseDown: function (evt)
                {
                    var
                        self = evt.data.self;

                    if (!self.editor)
                        return;

                    self.resizeInfo = {
                        startX: evt.originalEvent.x,
                        startY: evt.originalEvent.y,
                        startHeight: self.$$elementGet().find(".CodeMirror").outerHeight()
                    };

                    $$("body").on("mousemove", { self: self }, self.onBodyMouseMove);
                    $$(window).on("mouseup", { self: self }, self.onWindowMouseUp);
                },
                onKeyUp: function (evt)
                {
                    switch (evt.key)
                    {
                        case "Enter":
                        case "Escape":
                            evt.stopPropagation();
                            break;
                    }
                },
                onPageActivated: function (evt, eventData)
                {
                    evt.data.self.editor.refresh();
                },
                onWindowMouseUp: function (evt)
                {
                    var
                        self = evt.data.self;

                    $$("body").off("mousemove", self.onBodyMouseMove);
                    $$(window).off("mouseup", self.onWindowMouseUp);
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.mode =
            {
                csharp: "text/x-csharp",
                css: "text/css",
                html: "text/html",
                less: "text/x-less",
                javascript: "text/javascript",
                scss: "text/x-scss",
                xml: "text/xml"
            };
        }
    });

    // Time
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "Time",
        inherits: "InputControl",
        properties: [
            { name: "keyShortcutsActive", type: "boolean" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                keyShortcutsActive: true
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-time");
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _bindEvents: function ()
                {
                    this.super._bindEvents();
                    this.hour.on("valueChanged", { self: this }, this.onHourValueChanged);
                    this.minute.on("valueChanged", { self: this }, this.onMinuteValueChanged);
                    this.second.on("valueChanged", { self: this }, this.onSecondValueChanged);

                    this.on("keyup", { self: this }, this.onKeyUp);
                },
                _createElement: function ()
                {
                    this.super._createElement();

                    var
                        $$element = this.$$elementGet(),
                        i, hours = [], minutesSeconds = [];

                    for (i = 0; i <= 23; i++)
                        hours.push({ value: i, description: i.toString().padLeft(2, "0") });

                    for (i = 0; i <= 59; i++)
                        minutesSeconds.push({ value: i, description: i.toString().padLeft(2, "0") });

                    this.hour = new namespace.ComboBox({ inline: true, listDataSource: hours, placeholder: "HH" }).appendTo($$element);
                    this.minute = new namespace.ComboBox({ inline: true, listDataSource: minutesSeconds, placeholder: "MM" }).appendTo($$element);
                    this.second = new namespace.ComboBox({ inline: true, listDataSource: minutesSeconds, placeholder: "SS" }).appendTo($$element);

                    this.labelTargetId = this.hour.labelTargetId;
                },
                _elementValueChanged: function ()
                {
                    if (!this.__processElementValueChanged)
                        return;

                    this.super.valueSet(this._elementValueGet());
                },
                _elementValueGet: function ()
                {
                    var
                        hour = this.hour.valueGet(),
                        minute = this.minute.valueGet(),
                        second = this.second.valueGet(),
                        value = null;

                    if (hour !== null && minute !== null && second !== null)
                        value = String.format("{0}:{1}:{2}", hour.toString().padLeft(2, "0"), minute.toString().padLeft(2, "0"), second.toString().padLeft(2, "0"));

                    return value;
                },
                _elementValueSet: function (value)
                {
                    this.__processElementValueChanged = false;

                    if (!value)
                    {
                        this.hour.valueSet(null);
                        this.minute.valueSet(null);
                        this.second.valueSet(null);
                    }
                    else
                    {
                        this.hour.valueSet(parseInt(value.substr(0, 2)));
                        this.minute.valueSet(parseInt(value.substr(3, 2)));
                        this.second.valueSet(parseInt(value.substr(6, 2)));
                    }

                    this.__processElementValueChanged = true;
                },
                _enabledChanged: function (change)
                {
                    this.super._enabledChanged(change);

                    this.hour.enabledSet(change.currentValue);
                    this.minute.enabledSet(change.currentValue);
                    this.second.enabledSet(change.currentValue);
                },

                // Public Methods
                remove: function ()
                {
                    if (this.hour)
                    {
                        this.hour.remove();
                        this.hour = null;
                    }

                    if (this.minute)
                    {
                        this.minute.remove();
                        this.minute = null;
                    }

                    if (this.second)
                    {
                        this.second.remove();
                        this.second = null;
                    }

                    this.super.remove();
                },
                setNow: function ()
                {
                    var
                        date = new Date();

                    this.valueSet(date.toString("HH:mm:ss"));
                },
                valueSet: function (value)
                {
                    if (this.valueGet() === value)
                        return false;

                    this._elementValueSet(value);
                    this.super.valueSet(this._elementValueGet());

                    return true;
                },

                // Event Handler
                onHourValueChanged: function (evt)
                {
                    evt.data.self._elementValueChanged();
                },
                onKeyUp: function (evt)
                {
                    var
                        self = evt.data.self;

                    if (self.keyShortcutsActiveGet())
                    {
                        var
                            keyCaptured = false;

                        if (evt.key === "N" || evt.key === "n")
                        {
                            evt.data.self.setNow();
                            keyCaptured = true;
                        }

                        if (keyCaptured)
                        {
                            evt.preventDefault();
                            evt.stopPropagation();
                        }
                    }
                },
                onMinuteValueChanged: function (evt)
                {
                    evt.data.self._elementValueChanged();
                },
                onSecondValueChanged: function (evt)
                {
                    evt.data.self._elementValueChanged();
                }
            };
        }
    });

    // Time Span
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "TimeSpan",
        inherits: "InputControl",
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-time-span");
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _bindEvents: function ()
                {
                    this.super._bindEvents();
                    this.days.on("valueChanged", { self: this }, this.onDaysValueChanged);
                    this.hours.on("valueChanged", { self: this }, this.onHoursValueChanged);
                    this.minutes.on("valueChanged", { self: this }, this.onMinutesValueChanged);
                    this.seconds.on("valueChanged", { self: this }, this.onSecondsValueChanged);
                },
                _createElement: function ()
                {
                    this.super._createElement();

                    var
                        $$element = this.$$elementGet();

                    this.days = new namespace.TextBox({ inline: true, placeholder: "Days", type: namespace.TextBox.type.number }).appendTo($$element);
                    this.hours = new namespace.TextBox({ inline: true, maximumLength: 2, placeholder: "Hours", type: namespace.TextBox.type.number }).appendTo($$element);
                    this.minutes = new namespace.TextBox({ inline: true, maximumLength: 2, placeholder: "Mins", type: namespace.TextBox.type.number }).appendTo($$element);
                    this.seconds = new namespace.TextBox({ inline: true, maximumLength: 2, placeholder: "Secs", type: namespace.TextBox.type.number }).appendTo($$element);

                    this.labelTargetId = this.days.labelTargetId;
                },
                _elementValueChanged: function ()
                {
                    if (!this.__processElementValueChanged)
                        return;

                    this.super.valueSet(this._elementValueGet());
                },
                _elementValueGet: function ()
                {
                    var
                        days = parseInt(this.days.valueGet()),
                        hours = parseInt(this.hours.valueGet()),
                        minutes = parseInt(this.minutes.valueGet()),
                        seconds = parseInt(this.seconds.valueGet()),
                        value = null;

                    if (!isNaN(days) && !isNaN(hours) && !isNaN(minutes) && !isNaN(seconds))
                        value = String.format("{0}.{1}:{2}:{3}", days, hours.toString().padLeft(2, "0"), minutes.toString().padLeft(2, "0"), seconds.toString().padLeft(2, "0"));

                    return value;
                },
                _elementValueSet: function (value)
                {
                    this.__processElementValueChanged = false;

                    if (!value)
                    {
                        this.days.valueSet(null);
                        this.hours.valueSet(null);
                        this.minutes.valueSet(null);
                        this.seconds.valueSet(null);
                    }
                    else
                    {
                        this.days.valueSet(parseInt(value.substr(0, value.length - 9)));
                        this.hours.valueSet(parseInt(value.substr(value.length - 8, 2)));
                        this.minutes.valueSet(parseInt(value.substr(value.length - 5, 2)));
                        this.seconds.valueSet(parseInt(value.substr(value.length - 2, 2)));
                    }

                    this.__processElementValueChanged = true;
                },
                _enabledChanged: function (change)
                {
                    this.super._enabledChanged(change);

                    this.days.enabledSet(change.currentValue);
                    this.hours.enabledSet(change.currentValue);
                    this.minutes.enabledSet(change.currentValue);
                    this.seconds.enabledSet(change.currentValue);
                },

                // Public Methods
                remove: function ()
                {
                    if (this.days)
                    {
                        this.days.remove();
                        this.days = null;
                    }

                    if (this.hours)
                    {
                        this.hours.remove();
                        this.hours = null;
                    }

                    if (this.minutes)
                    {
                        this.minutes.remove();
                        this.minutes = null;
                    }

                    if (this.seconds)
                    {
                        this.seconds.remove();
                        this.seconds = null;
                    }

                    this.super.remove();
                },
                valueSet: function (value)
                {
                    if (this.valueGet() === value)
                        return false;

                    this._elementValueSet(value);
                    this.super.valueSet(this._elementValueGet());

                    return true;
                },

                // Event Handler
                onDaysValueChanged: function (evt)
                {
                    evt.data.self._elementValueChanged();
                },
                onHoursValueChanged: function (evt)
                {
                    evt.data.self._elementValueChanged();
                },
                onMinutesValueChanged: function (evt)
                {
                    evt.data.self._elementValueChanged();
                },
                onSecondsValueChanged: function (evt)
                {
                    evt.data.self._elementValueChanged();
                }
            };
        }
    });

    // Schedule
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "Schedule",
        inherits: "InputControl",
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-schedule");
                this.updateLayout();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _bindEvents: function ()
                {
                    this.super._bindEvents();
                    this.frequency.on("valueChanged", { self: this }, this.onControlValueChanged);
                    this.oneTimeDateTime.on("valueChanged", { self: this }, this.onControlValueChanged);
                    this.frequencyDailyEveryX.on("valueChanged", { self: this }, this.onControlValueChanged);
                    this.frequencyWeeklyEveryX.on("valueChanged", { self: this }, this.onControlValueChanged);
                    this.frequencyWeeklyOn.on("valueChanged", { self: this }, this.onControlValueChanged);
                    this.frequencyMonthlyFrequencyType.on("valueChanged", { self: this }, this.onControlValueChanged);
                    this.frequencyMonthlyDayByNumberDayX.on("valueChanged", { self: this }, this.onControlValueChanged);
                    this.frequencyMonthlyDayByNumberEveryX.on("valueChanged", { self: this }, this.onControlValueChanged);
                    this.frequencyMonthlyDayByDayDayNumber.on("valueChanged", { self: this }, this.onControlValueChanged);
                    this.frequencyMonthlyDayByDayDayType.on("valueChanged", { self: this }, this.onControlValueChanged);
                    this.frequencyMonthlyDayByDayEveryX.on("valueChanged", { self: this }, this.onControlValueChanged);
                    this.dailyFrequencyType.on("valueChanged", { self: this }, this.onControlValueChanged);
                    this.dailyFrequencyOnceTime.on("valueChanged", { self: this }, this.onControlValueChanged);
                    this.dailyFrequencyEveryX.on("valueChanged", { self: this }, this.onControlValueChanged);
                    this.dailyFrequencyEveryTimePeriod.on("valueChanged", { self: this }, this.onControlValueChanged);
                    this.dailyFrequencyEveryStartTime.on("valueChanged", { self: this }, this.onControlValueChanged);
                    this.dailyFrequencyEveryEndTime.on("valueChanged", { self: this }, this.onControlValueChanged);
                    this.durationStartDate.on("valueChanged", { self: this }, this.onControlValueChanged);
                    this.durationEndType.on("valueChanged", { self: this }, this.onControlValueChanged);
                    this.durationEndDate.on("valueChanged", { self: this }, this.onControlValueChanged);
                },
                _createElement: function ()
                {
                    this.super._createElement();

                    var
                        $$element = this.$$elementGet(),
                        labelWidth = 100;

                    this.scheduleTypeGroupBox = new namespace.GroupBox({ text: "Schedule Type" });
                    $$element.append(this.scheduleTypeGroupBox.$$elementGet());

                    this.frequency = new namespace.ComboBox({
                        text: "Frequency",
                        inline: true,
                        minWidth: "8em",
                        listDataSource: [
                            { value: "oneTime", description: "One Time" },
                            { value: "daily", description: "Daily" },
                            { value: "weekly", description: "Weekly" },
                            { value: "monthly", description: "Monthly" }
                        ]
                    });
                    this.scheduleTypeGroupBox.append(new namespace.Label({ inline: true, text: "Frequency", minWidth: labelWidth, associatedControl: this.frequency }));
                    this.scheduleTypeGroupBox.append(this.frequency);

                    // One Time
                    this.oneTimeGroupBox = new namespace.GroupBox({ text: "One Time Occurance" });
                    $$element.append(this.oneTimeGroupBox.$$elementGet());

                    this.oneTimeDateTime = new namespace.DateTime({ inline: true });
                    this.oneTimeGroupBox.append(new namespace.Label({ inline: true, text: "Date", minWidth: labelWidth, associatedControl: this.oneTimeDateTime }));
                    this.oneTimeGroupBox.append(this.oneTimeDateTime);

                    // Daily
                    this.dailyGroupBox = new namespace.GroupBox({ text: "Daily Occurance" });
                    $$element.append(this.dailyGroupBox.$$elementGet());

                    this.frequencyDailyEveryX = new namespace.ComboBox({
                        inline: true,
                        minWidth: "5em",
                        listDataSource: function ()
                        {
                            var options = [];

                            for (var i = 1; i <= 100; i++)
                                options.push({ value: i, description: i.toString() });

                            return options;
                        }()
                    });
                    this.dailyGroupBox.append(new namespace.Label({ inline: true, text: "Recurs every", minWidth: labelWidth, associatedControl: this.frequencyDailyEveryX }));
                    this.dailyGroupBox.append(this.frequencyDailyEveryX);
                    this.dailyGroupBox.append(new namespace.Label({ inline: true, colon: false, text: "day(s)" }));

                    // Weekly
                    this.weeklyGroupBox = new namespace.GroupBox({ text: "Weekly Occurance" });
                    $$element.append(this.weeklyGroupBox.$$elementGet());

                    this.weeklyContainer1 = new namespace.Panel();
                    this.weeklyGroupBox.append(this.weeklyContainer1);

                    this.frequencyWeeklyEveryX = new namespace.ComboBox({
                        inline: true,
                        minWidth: "5em",
                        listDataSource: function ()
                        {
                            var options = [];

                            for (var i = 1; i <= 100; i++)
                                options.push({ value: i, description: i.toString() });

                            return options;
                        }()
                    });
                    this.weeklyContainer1.append(new namespace.Label({ inline: true, text: "Recurs every", minWidth: labelWidth, associatedControl: this.frequencyWeeklyEveryX }));
                    this.weeklyContainer1.append(this.frequencyWeeklyEveryX);
                    this.weeklyContainer1.append(new namespace.Label({ inline: true, colon: false, text: "week(s)" }));

                    this.weeklyContainer2 = new namespace.Panel();
                    this.weeklyGroupBox.append(this.weeklyContainer2);

                    this.frequencyWeeklyOn = new namespace.CheckBoxList({
                        inline: true,
                        listDataSource: [
                            { value: 0, description: "Monday" },
                            { value: 1, description: "Tuesday" },
                            { value: 2, description: "Wednesday" },
                            { value: 3, description: "Thursday" },
                            { value: 4, description: "Friday" },
                            { value: 5, description: "Saturday" },
                            { value: 6, description: "Sunday" }
                        ]
                    });
                    this.weeklyContainer2.append(new namespace.Label({ inline: true, text: "On", minWidth: labelWidth, associatedControl: this.frequencyWeeklyOn, cssClass: "rad-vertical-align-top" }));
                    this.weeklyContainer2.append(this.frequencyWeeklyOn);

                    // Monthly
                    this.monthlyGroupBox = new namespace.GroupBox({ text: "Monthly Occurance" });
                    $$element.append(this.monthlyGroupBox.$$elementGet());

                    this.monthlyContainer1 = new namespace.Panel();
                    this.monthlyGroupBox.append(this.monthlyContainer1);

                    this.frequencyMonthlyFrequencyType = new namespace.ComboBox({
                        inline: true,
                        minWidth: "9em",
                        listDataSource: [
                            { value: "dayByNumber", description: "By Number" },
                            { value: "dayByDay", description: "By Type" }
                        ]
                    });
                    this.monthlyContainer1.append(new namespace.Label({ inline: true, text: "Type", minWidth: labelWidth, associatedControl: this.frequencyMonthlyFrequencyType }));
                    this.monthlyContainer1.append(this.frequencyMonthlyFrequencyType);

                    this.monthlyContainer2 = new namespace.Panel();
                    this.monthlyGroupBox.append(this.monthlyContainer2);

                    this.frequencyMonthlyDayByNumberDayX = new namespace.ComboBox({
                        inline: true,
                        minWidth: "4.5em",
                        listDataSource: function ()
                        {
                            var options = [];

                            for (var i = 1; i <= 31; i++)
                                options.push({ value: i, description: i.toString() });

                            return options;
                        }()
                    });
                    this.monthlyContainer2.append(new namespace.Label({ inline: true, text: "On day", minWidth: labelWidth, associatedControl: this.frequencyMonthlyDayByNumberDayX }));
                    this.monthlyContainer2.append(this.frequencyMonthlyDayByNumberDayX);

                    this.frequencyMonthlyDayByNumberEveryX = new namespace.ComboBox({
                        inline: true,
                        minWidth: "5em",
                        listDataSource: function ()
                        {
                            var options = [];

                            for (var i = 1; i <= 100; i++)
                                options.push({ value: i, description: i.toString() });

                            return options;
                        }()
                    });
                    this.monthlyContainer2.append(new namespace.Label({ inline: true, text: "of every", associatedControl: this.frequencyMonthlyDayByNumberEveryX }));
                    this.monthlyContainer2.append(this.frequencyMonthlyDayByNumberEveryX);
                    this.monthlyContainer2.append(new namespace.Label({ inline: true, colon: false, text: "month(s)" }));

                    this.monthlyContainer3 = new namespace.Panel();
                    this.monthlyGroupBox.append(this.monthlyContainer3);

                    this.frequencyMonthlyDayByDayDayNumber = new namespace.ComboBox({
                        inline: true,
                        minWidth: "6.5em",
                        listDataSource: [
                            { value: "first", description: "First" },
                            { value: "second", description: "Second" },
                            { value: "third", description: "Third" },
                            { value: "fourth", description: "Fourth" },
                            { value: "last", description: "Last" }
                        ]
                    });
                    this.monthlyContainer3.append(new namespace.Label({ inline: true, text: "On the", minWidth: labelWidth, associatedControl: this.frequencyMonthlyDayByDayDayNumber }));
                    this.monthlyContainer3.append(this.frequencyMonthlyDayByDayDayNumber);

                    this.frequencyMonthlyDayByDayDayType = new namespace.ComboBox({
                        inline: true,
                        minWidth: "10em",
                        listDataSource: [
                            { value: "monday", description: "Monday" },
                            { value: "tuesday", description: "Tuesday" },
                            { value: "wednesday", description: "Wednesday" },
                            { value: "thursday", description: "Thursday" },
                            { value: "friday", description: "Friday" },
                            { value: "saturday", description: "Saturday" },
                            { value: "sunday", description: "Sunday" },
                            { value: "day", description: "Day" },
                            { value: "weekDay", description: "Week Day" },
                            { value: "weekendDay", description: "Weekend Day" }
                        ]
                    });
                    this.monthlyContainer3.append(this.frequencyMonthlyDayByDayDayType);

                    this.frequencyMonthlyDayByDayEveryX = new namespace.ComboBox({
                        inline: true,
                        minWidth: "5em",
                        listDataSource: function ()
                        {
                            var options = [];

                            for (var i = 1; i <= 100; i++)
                                options.push({ value: i, description: i.toString() });

                            return options;
                        }()
                    });
                    this.monthlyContainer3.append(new namespace.Label({ inline: true, text: "of every", associatedControl: this.frequencyMonthlyDayByDayEveryX }));
                    this.monthlyContainer3.append(this.frequencyMonthlyDayByDayEveryX);
                    this.monthlyContainer3.append(new namespace.Label({ inline: true, colon: false, text: "month(s)" }));

                    // Daily Frequency
                    this.dailyFrequencyGroupBox = new namespace.GroupBox({ text: "Daily Frequency" });
                    $$element.append(this.dailyFrequencyGroupBox.$$elementGet());

                    this.dailyFrequencyContainer1 = new namespace.Panel();
                    this.dailyFrequencyGroupBox.append(this.dailyFrequencyContainer1);

                    this.dailyFrequencyType = new namespace.ComboBox({
                        inline: true,
                        minWidth: "8.5em",
                        listDataSource: [
                            { value: "once", description: "Once" },
                            { value: "recurring", description: "Repeatedly" }
                        ]
                    });
                    this.dailyFrequencyContainer1.append(new namespace.Label({ inline: true, text: "Occurs", minWidth: labelWidth, associatedControl: this.dailyFrequencyType }));
                    this.dailyFrequencyContainer1.append(this.dailyFrequencyType);
                    this.labelEachDay = new namespace.Label({ inline: true, text: "each day, at" });
                    this.dailyFrequencyContainer1.append(this.labelEachDay);
                    this.labelEachDayEvery = new namespace.Label({ inline: true, text: "each day, every" });
                    this.dailyFrequencyContainer1.append(this.labelEachDayEvery);

                    this.dailyFrequencyOnceTime = new namespace.Time({ inline: true });
                    this.dailyFrequencyContainer1.append(this.dailyFrequencyOnceTime);
                    this.labelEachDay.associatedControlSet(this.dailyFrequencyOnceTime);

                    this.dailyFrequencyEveryX = new namespace.ComboBox({
                        inline: true,
                        minWidth: "4.5em",
                        listDataSource: function ()
                        {
                            var options = [];

                            for (var i = 1; i <= 60; i++)
                                options.push({ value: i, description: i.toString() });

                            return options;
                        }()
                    });
                    this.dailyFrequencyContainer1.append(this.dailyFrequencyEveryX);
                    this.labelEachDayEvery.associatedControlSet(this.dailyFrequencyEveryX);

                    this.dailyFrequencyEveryTimePeriod = new namespace.ComboBox({
                        inline: true,
                        minWidth: "8em",
                        listDataSource: [
                            { value: "hours", description: "Hour(s)" },
                            { value: "minutes", description: "Minute(s)" },
                            { value: "seconds", description: "Second(s)" }
                        ]
                    });
                    this.dailyFrequencyContainer1.append(this.dailyFrequencyEveryTimePeriod);

                    this.dailyFrequencyContainer2 = new namespace.Panel();
                    this.dailyFrequencyGroupBox.append(this.dailyFrequencyContainer2);

                    this.dailyFrequencyEveryStartTime = new namespace.Time({ inline: true });
                    this.dailyFrequencyContainer2.append(new namespace.Label({ inline: true, text: "Between", minWidth: labelWidth, associatedControl: this.dailyFrequencyEveryStartTime }));
                    this.dailyFrequencyContainer2.append(this.dailyFrequencyEveryStartTime);

                    this.dailyFrequencyContainer3 = new namespace.Panel();
                    this.dailyFrequencyGroupBox.append(this.dailyFrequencyContainer3);

                    this.dailyFrequencyEveryEndTime = new namespace.Time({ inline: true });
                    this.dailyFrequencyContainer3.append(new namespace.Label({ inline: true, text: "And", minWidth: labelWidth, associatedControl: this.dailyFrequencyEveryEndTime }));
                    this.dailyFrequencyContainer3.append(this.dailyFrequencyEveryEndTime);

                    // Duration
                    this.durationGroupBox = new namespace.GroupBox({ text: "Duration" });
                    $$element.append(this.durationGroupBox.$$elementGet());

                    this.durationContainer1 = new namespace.Panel();
                    this.durationGroupBox.append(this.durationContainer1);

                    this.durationStartDate = new namespace.Date({ inline: true });
                    this.durationContainer1.append(new namespace.Label({ inline: true, text: "From", minWidth: labelWidth, associatedControl: this.durationStartDate }));
                    this.durationContainer1.append(this.durationStartDate);

                    this.durationContainer2 = new namespace.Panel();
                    this.durationGroupBox.append(this.durationContainer2);

                    this.durationEndType = new namespace.ComboBox({
                        inline: true,
                        minWidth: "6.5em",
                        listDataSource: [
                            { value: "none", description: "None" },
                            { value: "finite", description: "Finite" }
                        ]
                    });
                    this.durationContainer2.append(new namespace.Label({ inline: true, text: "End Type", minWidth: labelWidth, associatedControl: this.durationEndType }));
                    this.durationContainer2.append(this.durationEndType);

                    this.durationContainer3 = new namespace.Panel();
                    this.durationGroupBox.append(this.durationContainer3);

                    this.durationEndDate = new namespace.Date({ inline: true });
                    this.durationContainer3.append(new namespace.Label({ inline: true, text: "To", minWidth: labelWidth, associatedControl: this.durationEndDate }));
                    this.durationContainer3.append(this.durationEndDate);
                },
                _createScheduleDescription: function ()
                {
                    var
                        value = this.valueGet();

                    if (!value)
                        return null;

                    var
                        valueObject = value.fromJson(),
                        description = String.empty,
                        oneTimeDateTime,
                        durationStartDate,
                        durationEndDate;

                    switch (valueObject.frequency)
                    {
                        case "oneTime":
                            oneTimeDateTime = Date.fromString(valueObject.oneTimeDateTime, "yyyy-MM-ddTHH:mm:ss.fffffffZ").convertToUTC();
                            description =
                                String.format(
                                    "Occurs on {0} at {1}.",
                                    oneTimeDateTime.toString("dd/MM/yyyy"),
                                    oneTimeDateTime.toString("HH:mm:ss")
                                );
                            break;
                        case "daily":
                            description =
                                String.format(
                                    "Occurs every{0} day{1}",
                                    valueObject.frequencyDailyEveryX > 1 ? " " + valueObject.frequencyDailyEveryX : String.empty,
                                    valueObject.frequencyDailyEveryX > 1 ? "s" : String.empty
                                );
                            break;
                        case "weekly":
                            description =
                                String.format(
                                    "Occurs every{0} week{1}{2}",
                                    valueObject.frequencyWeeklyEveryX > 1 ? " " + valueObject.frequencyWeeklyEveryX : String.empty,
                                    valueObject.frequencyWeeklyEveryX > 1 ? "s" : String.empty,
                                    this._getDayList(valueObject)
                                );
                            break;
                        case "monthly":
                            switch (valueObject.frequencyMonthlyFrequencyType)
                            {
                                case "dayByNumber":
                                    description =
                                        String.format(
                                            "Occurs every{0} month{1} on day {2} of that month",
                                            valueObject.frequencyMonthlyDayByNumberEveryX > 1 ? " " + valueObject.frequencyMonthlyDayByNumberEveryX : String.empty,
                                            valueObject.frequencyMonthlyDayByNumberEveryX > 1 ? "s" : String.empty,
                                            valueObject.frequencyMonthlyDayByNumberDayX
                                        );
                                    break;
                                case "dayByDay":
                                    description =
                                        String.format(
                                            "Occurs every{0}{1} of every{2} month{3}",
                                            String.format(" {0}", this._getDayNumberDescription(valueObject.frequencyMonthlyDayByDayDayNumber)),
                                            String.format(" {0}", this._getDayTypeDescription(valueObject.frequencyMonthlyDayByDayDayType)),
                                            valueObject.frequencyMonthlyDayByDayEveryX > 1 ? " " + valueObject.frequencyMonthlyDayByDayEveryX : String.empty,
                                            valueObject.frequencyMonthlyDayByDayEveryX > 1 ? "s" : String.empty
                                        );
                                    break;
                            }
                            break;
                    }

                    switch (valueObject.frequency)
                    {
                        case "oneTime":
                            break;
                        default:
                            switch (valueObject.dailyFrequencyType)
                            {
                                case "once":
                                    description +=
                                        String.format(
                                            " at {0}.",
                                            valueObject.dailyFrequencyOnceTime
                                        );
                                    break;
                                case "recurring":
                                    description +=
                                        String.format(
                                            " every{0} {1}{2} between {3} and {4}.",
                                            valueObject.dailyFrequencyEveryX > 1 ? " " + valueObject.dailyFrequencyEveryX : String.empty,
                                            this._getTimePeriodDescription(valueObject.dailyFrequencyEveryTimePeriod),
                                            valueObject.dailyFrequencyEveryX > 1 ? "s" : String.empty,
                                            valueObject.dailyFrequencyEveryStartTime.toString(),
                                            valueObject.dailyFrequencyEveryEndTime.toString()
                                        );
                                    break;
                            }
                            break;
                    }

                    switch (valueObject.frequency)
                    {
                        case "oneTime":
                            break;
                        default:
                            durationStartDate = Date.fromString(valueObject.durationStartDate, "yyyy-MM-ddTHH:mm:ss.fffffffZ").convertToUTC();

                            if (valueObject.durationEndDate)
                                durationEndDate = Date.fromString(valueObject.durationEndDate, "yyyy-MM-ddTHH:mm:ss.fffffffZ").convertToUTC();

                            description +=
                                String.format(
                                    " Schedule will be used {0} {1}{2}.",
                                    valueObject.durationEndType === "none"
                                        ? "from"
                                        : "between",
                                    durationStartDate.toString("dd/MM/yyyy"),
                                    valueObject.durationEndType === "finite"
                                        ? " and " + (durationEndDate ? durationEndDate.toString("dd/MM/yyyy") : String.empty)
                                        : String.empty
                                );
                            break;
                    }

                    return description;
                },
                _elementValueChanged: function ()
                {
                    if (!this.__processElementValueChanged)
                        return;

                    this.super.valueSet(this._elementValueGet());
                },
                _elementValueGet: function ()
                {
                    var
                        frequencyWeeklyOn = this.frequencyWeeklyOn.valueGet(),
                        valueObject = {
                            frequency: this.frequency.valueGet(),
                            oneTimeDateTime: this.oneTimeDateTime.valueGet(),
                            frequencyDailyEveryX: this.frequencyDailyEveryX.valueGet(),
                            frequencyWeeklyEveryX: this.frequencyWeeklyEveryX.valueGet(),
                            frequencyWeeklyOnMonday: !!(frequencyWeeklyOn?.contains(0)),
                            frequencyWeeklyOnTuesday: !!(frequencyWeeklyOn?.contains(1)),
                            frequencyWeeklyOnWednesday: !!(frequencyWeeklyOn?.contains(2)),
                            frequencyWeeklyOnThursday: !!(frequencyWeeklyOn?.contains(3)),
                            frequencyWeeklyOnFriday: !!(frequencyWeeklyOn?.contains(4)),
                            frequencyWeeklyOnSaturday: !!(frequencyWeeklyOn?.contains(5)),
                            frequencyWeeklyOnSunday: !!(frequencyWeeklyOn?.contains(6)),
                            frequencyMonthlyFrequencyType: this.frequencyMonthlyFrequencyType.valueGet(),
                            frequencyMonthlyDayByNumberDayX: this.frequencyMonthlyDayByNumberDayX.valueGet(),
                            frequencyMonthlyDayByNumberEveryX: this.frequencyMonthlyDayByNumberEveryX.valueGet(),
                            frequencyMonthlyDayByDayDayNumber: this.frequencyMonthlyDayByDayDayNumber.valueGet(),
                            frequencyMonthlyDayByDayDayType: this.frequencyMonthlyDayByDayDayType.valueGet(),
                            frequencyMonthlyDayByDayEveryX: this.frequencyMonthlyDayByDayEveryX.valueGet(),
                            dailyFrequencyType: this.dailyFrequencyType.valueGet(),
                            dailyFrequencyOnceTime: this.dailyFrequencyOnceTime.valueGet(),
                            dailyFrequencyEveryX: this.dailyFrequencyEveryX.valueGet(),
                            dailyFrequencyEveryTimePeriod: this.dailyFrequencyEveryTimePeriod.valueGet(),
                            dailyFrequencyEveryStartTime: this.dailyFrequencyEveryStartTime.valueGet(),
                            dailyFrequencyEveryEndTime: this.dailyFrequencyEveryEndTime.valueGet(),
                            durationEndType: this.durationEndType.valueGet(),
                            durationStartDate: this.durationStartDate.valueGet(),
                            durationEndDate: this.durationEndDate.valueGet()
                        };

                    return (
                        this._validateValue(valueObject)
                        ? valueObject.toJson()
                        : null
                    );
                },
                _elementValueSet: function (value)
                {
                    this.__processElementValueChanged = false;

                    if (!value)
                    {
                        this.frequency.valueSet(null);
                        this.oneTimeDateTime.valueSet(null);
                        this.frequencyDailyEveryX.valueSet(null);
                        this.frequencyWeeklyEveryX.valueSet(null);
                        this.frequencyWeeklyOn.valueSet(null);
                        this.frequencyMonthlyFrequencyType.valueSet(null);
                        this.frequencyMonthlyDayByNumberDayX.valueSet(null);
                        this.frequencyMonthlyDayByNumberEveryX.valueSet(null);
                        this.frequencyMonthlyDayByDayDayNumber.valueSet(null);
                        this.frequencyMonthlyDayByDayDayType.valueSet(null);
                        this.frequencyMonthlyDayByDayEveryX.valueSet(null);
                        this.dailyFrequencyType.valueSet(null);
                        this.dailyFrequencyOnceTime.valueSet(null);
                        this.dailyFrequencyEveryX.valueSet(null);
                        this.dailyFrequencyEveryTimePeriod.valueSet(null);
                        this.dailyFrequencyEveryStartTime.valueSet(null);
                        this.dailyFrequencyEveryEndTime.valueSet(null);
                        this.durationEndType.valueSet(null);
                        this.durationStartDate.valueSet(null);
                        this.durationEndDate.valueSet(null);
                    }
                    else
                    {
                        var
                            data = value.fromJson();

                        var
                            frequencyWeeklyOn = [];

                        if (data.frequencyWeeklyOnMonday)
                            frequencyWeeklyOn.push(0);

                        if (data.frequencyWeeklyOnTuesday)
                            frequencyWeeklyOn.push(1);

                        if (data.frequencyWeeklyOnWednesday)
                            frequencyWeeklyOn.push(2);

                        if (data.frequencyWeeklyOnThursday)
                            frequencyWeeklyOn.push(3);

                        if (data.frequencyWeeklyOnFriday)
                            frequencyWeeklyOn.push(4);

                        if (data.frequencyWeeklyOnSaturday)
                            frequencyWeeklyOn.push(5);

                        if (data.frequencyWeeklyOnSunday)
                            frequencyWeeklyOn.push(6);

                        this.frequency.valueSet(data.frequency);
                        this.oneTimeDateTime.valueSet(data.oneTimeDateTime);
                        this.frequencyDailyEveryX.valueSet(data.frequencyDailyEveryX);
                        this.frequencyWeeklyEveryX.valueSet(data.frequencyWeeklyEveryX);
                        this.frequencyWeeklyOn.valueSet(frequencyWeeklyOn);
                        this.frequencyMonthlyFrequencyType.valueSet(data.frequencyMonthlyFrequencyType);
                        this.frequencyMonthlyDayByNumberDayX.valueSet(data.frequencyMonthlyDayByNumberDayX);
                        this.frequencyMonthlyDayByNumberEveryX.valueSet(data.frequencyMonthlyDayByNumberEveryX);
                        this.frequencyMonthlyDayByDayDayNumber.valueSet(data.frequencyMonthlyDayByDayDayNumber);
                        this.frequencyMonthlyDayByDayDayType.valueSet(data.frequencyMonthlyDayByDayDayType);
                        this.frequencyMonthlyDayByDayEveryX.valueSet(data.frequencyMonthlyDayByDayEveryX);
                        this.dailyFrequencyType.valueSet(data.dailyFrequencyType);
                        this.dailyFrequencyOnceTime.valueSet(data.dailyFrequencyOnceTime);
                        this.dailyFrequencyEveryX.valueSet(data.dailyFrequencyEveryX);
                        this.dailyFrequencyEveryTimePeriod.valueSet(data.dailyFrequencyEveryTimePeriod);
                        this.dailyFrequencyEveryStartTime.valueSet(data.dailyFrequencyEveryStartTime);
                        this.dailyFrequencyEveryEndTime.valueSet(data.dailyFrequencyEveryEndTime);
                        this.durationEndType.valueSet(data.durationEndType);
                        this.durationStartDate.valueSet(data.durationStartDate);
                        this.durationEndDate.valueSet(data.durationEndDate);
                    }

                    this.__processElementValueChanged = true;
                },
                _enabledChanged: function (change)
                {
                    this.super._enabledChanged(change);

                    this.$$elementGet().find(".rad-control").each((index, element) =>
                    {
                        var
                            control = $$.radControl(element);

                        if (control)
                            control.enabledSet(change.currentValue);
                    });
                },
                _getDayList: function (schedule)
                {
                    var
                        days = [];

                    if (schedule.frequencyWeeklyOnMonday)
                        days.push("Monday");

                    if (schedule.frequencyWeeklyOnTuesday)
                        days.push("Tuesday");

                    if (schedule.frequencyWeeklyOnWednesday)
                        days.push("Wednesday");

                    if (schedule.frequencyWeeklyOnThursday)
                        days.push("Thursday");

                    if (schedule.frequencyWeeklyOnFriday)
                        days.push("Friday");

                    if (schedule.frequencyWeeklyOnSaturday)
                        days.push("Saturday");

                    if (schedule.frequencyWeeklyOnSunday)
                        days.push("Sunday");

                    if (days.length > 0)
                        return String.format(" on {0}", days.join(", "));

                    return String.empty;
                },
                _getDayNumberDescription: function (dayNumber)
                {
                    switch (dayNumber)
                    {
                        case "first":
                            return "first";
                        case "second":
                            return "second";
                        case "third":
                            return "third";
                        case "fourth":
                            return "fourth";
                        case "last":
                            return "last";
                        default:
                            console.error("Not implemented.");
                            break;
                    }
                },
                _getDayTypeDescription: function (dayType)
                {
                    switch (dayType)
                    {
                        case "monday":
                            return "monday";
                        case "tuesday":
                            return "tuesday";
                        case "wednesday":
                            return "wednesday";
                        case "thursday":
                            return "thursday";
                        case "friday":
                            return "friday";
                        case "saturday":
                            return "saturday";
                        case "sunday":
                            return "sunday";
                        case "day":
                            return "day";
                        case "weekDay":
                            return "week day";
                        case "weekendDay":
                            return "weekend day";
                        default:
                            console.error("Not implemented.");
                            break;
                    }
                },
                _getTimePeriodDescription: function (timePeriod)
                {
                    switch (timePeriod)
                    {
                        case "hours":
                            return "hour";
                        case "minutes":
                            return "minute";
                        case "seconds":
                            return "second";
                        default:
                            console.error("Not implemented.");
                            break;
                    }
                },
                _validateValue: function (valueObject)
                {
                    var
                        isValid = true;

                    switch (valueObject.frequency)
                    {
                        case "oneTime":
                            if (valueObject.oneTimeDateTime === null)
                                isValid = false;
                            break;
                        case "daily":
                            if (valueObject.frequencyDailyEveryX === null)
                                isValid = false;
                            break;
                        case "weekly":
                            if 
                                (
                                        valueObject.frequencyWeeklyEveryX === null
                                    ||
                                        valueObject.frequencyWeeklyOnMonday === null
                                        && valueObject.frequencyWeeklyOnTuesday === null
                                        && valueObject.frequencyWeeklyOnWednesday === null
                                        && valueObject.frequencyWeeklyOnThursday === null
                                        && valueObject.frequencyWeeklyOnFriday === null
                                        && valueObject.frequencyWeeklyOnSaturday === null
                                        && valueObject.frequencyWeeklyOnSunday === null
                                )
                                isValid = false;
                            break;
                        case "monthly":
                            switch (valueObject.frequencyMonthlyFrequencyType)
                            {
                                case "dayByNumber":
                                    if 
                                        (
                                            valueObject.frequencyMonthlyDayByNumberEveryX === null
                                            || valueObject.frequencyMonthlyDayByNumberDayX === null
                                        )
                                        isValid = false;
                                    break;
                                case "dayByDay":
                                    if 
                                        (
                                            valueObject.frequencyMonthlyDayByDayDayNumber === null
                                            || valueObject.frequencyMonthlyDayByDayDayType === null
                                            || valueObject.frequencyMonthlyDayByDayEveryX === null
                                        )
                                        isValid = false;
                                    break;
                                default:
                                    isValid = false;
                                    break;
                            }
                            break;
                        default:
                            isValid = false;
                            break;
                    }

                    if (isValid)
                    {
                        switch (valueObject.frequency)
                        {
                            case "oneTime":
                                break;
                            default:
                                switch (valueObject.dailyFrequencyType)
                                {
                                    case "once":
                                        if (valueObject.dailyFrequencyOnceTime === null)
                                            isValid = false;
                                        break;
                                    case "recurring":
                                        if 
                                            (
                                                valueObject.dailyFrequencyEveryX === null
                                                || valueObject.dailyFrequencyEveryTimePeriod === null
                                                || valueObject.dailyFrequencyEveryStartTime === null
                                                || valueObject.dailyFrequencyEveryEndTime === null
                                            )
                                            isValid = false;
                                        break;
                                    default:
                                        isValid = false;
                                        break;
                                }
                                break;
                        }
                    }

                    if (isValid)
                    {
                        switch (valueObject.frequency)
                        {
                            case "oneTime":
                                break;
                            default:
                                switch (valueObject.durationEndType)
                                {
                                    case "none":
                                        if (valueObject.durationStartDate === null)
                                            isValid = false;
                                        break;
                                    case "finite":
                                        if 
                                            (
                                                valueObject.durationStartDate === null
                                                || valueObject.durationEndDate === null
                                            )
                                            isValid = false;
                                        break;
                                    default:
                                        isValid = false;
                                        break;
                                }
                                break;
                        }
                    }

                    return isValid;
                },

                // Public Methods
                remove: function ()
                {
                    if (this.frequency)
                    {
                        this.frequency.remove();
                        this.frequency = null;
                    }

                    if (this.oneTimeDateTime)
                    {
                        this.oneTimeDateTime.remove();
                        this.oneTimeDateTime = null;
                    }

                    if (this.frequencyDailyEveryX)
                    {
                        this.frequencyDailyEveryX.remove();
                        this.frequencyDailyEveryX = null;
                    }

                    if (this.frequencyWeeklyEveryX)
                    {
                        this.frequencyWeeklyEveryX.remove();
                        this.frequencyWeeklyEveryX = null;
                    }

                    if (this.frequencyWeeklyOn)
                    {
                        this.frequencyWeeklyOn.remove();
                        this.frequencyWeeklyOn = null;
                    }

                    if (this.frequencyMonthlyFrequencyType)
                    {
                        this.frequencyMonthlyFrequencyType.remove();
                        this.frequencyMonthlyFrequencyType = null;
                    }

                    if (this.frequencyMonthlyDayByNumberDayX)
                    {
                        this.frequencyMonthlyDayByNumberDayX.remove();
                        this.frequencyMonthlyDayByNumberDayX = null;
                    }

                    if (this.frequencyMonthlyDayByNumberEveryX)
                    {
                        this.frequencyMonthlyDayByNumberEveryX.remove();
                        this.frequencyMonthlyDayByNumberEveryX = null;
                    }

                    if (this.frequencyMonthlyDayByDayDayNumber)
                    {
                        this.frequencyMonthlyDayByDayDayNumber.remove();
                        this.frequencyMonthlyDayByDayDayNumber = null;
                    }

                    if (this.frequencyMonthlyDayByDayDayType)
                    {
                        this.frequencyMonthlyDayByDayDayType.remove();
                        this.frequencyMonthlyDayByDayDayType = null;
                    }

                    if (this.frequencyMonthlyDayByDayEveryX)
                    {
                        this.frequencyMonthlyDayByDayEveryX.remove();
                        this.frequencyMonthlyDayByDayEveryX = null;
                    }

                    if (this.dailyFrequencyType)
                    {
                        this.dailyFrequencyType.remove();
                        this.dailyFrequencyType = null;
                    }

                    if (this.dailyFrequencyOnceTime)
                    {
                        this.dailyFrequencyOnceTime.remove();
                        this.dailyFrequencyOnceTime = null;
                    }

                    if (this.dailyFrequencyEveryX)
                    {
                        this.dailyFrequencyEveryX.remove();
                        this.dailyFrequencyEveryX = null;
                    }

                    if (this.dailyFrequencyEveryTimePeriod)
                    {
                        this.dailyFrequencyEveryTimePeriod.remove();
                        this.dailyFrequencyEveryTimePeriod = null;
                    }

                    if (this.dailyFrequencyEveryStartTime)
                    {
                        this.dailyFrequencyEveryStartTime.remove();
                        this.dailyFrequencyEveryStartTime = null;
                    }

                    if (this.dailyFrequencyEveryEndTime)
                    {
                        this.dailyFrequencyEveryEndTime.remove();
                        this.dailyFrequencyEveryEndTime = null;
                    }

                    if (this.durationStartDate)
                    {
                        this.durationStartDate.remove();
                        this.durationStartDate = null;
                    }

                    if (this.durationEndType)
                    {
                        this.durationEndType.remove();
                        this.durationEndType = null;
                    }

                    if (this.durationEndDate)
                    {
                        this.durationEndDate.remove();
                        this.durationEndDate = null;
                    }

                    this.super.remove();
                },
                textGet: function ()
                {
                    return this._createScheduleDescription();
                },
                updateLayout: function ()
                {
                    switch (this.frequency.valueGet())
                    {
                        case "oneTime":
                            this.oneTimeGroupBox.visibleSet(true);
                            break;
                        default:
                            this.oneTimeGroupBox.visibleSet(false);
                            break;
                    }

                    switch (this.frequency.valueGet())
                    {
                        case "daily":
                            this.dailyGroupBox.visibleSet(true);
                            break;
                        default:
                            this.dailyGroupBox.visibleSet(false);
                            break;
                    }

                    switch (this.frequency.valueGet())
                    {
                        case "weekly":
                            this.weeklyGroupBox.visibleSet(true);
                            break;
                        default:
                            this.weeklyGroupBox.visibleSet(false);
                            break;
                    }

                    switch (this.frequency.valueGet())
                    {
                        case "monthly":
                            this.monthlyGroupBox.visibleSet(true);

                            switch (this.frequencyMonthlyFrequencyType.valueGet())
                            {
                                case "dayByNumber":
                                    this.monthlyContainer2.visibleSet(true);
                                    break;
                                default:
                                    this.monthlyContainer2.visibleSet(false);
                                    break;
                            }

                            switch (this.frequencyMonthlyFrequencyType.valueGet())
                            {
                                case "dayByDay":
                                    this.monthlyContainer3.visibleSet(true);
                                    break;
                                default:
                                    this.monthlyContainer3.visibleSet(false);
                                    break;
                            }

                            break;
                        default:
                            this.monthlyGroupBox.visibleSet(false);
                            break;
                    }

                    switch (this.frequency.valueGet())
                    {
                        case "daily":
                        case "weekly":
                        case "monthly":
                            this.dailyFrequencyGroupBox.visibleSet(true);

                            switch (this.dailyFrequencyType.valueGet())
                            {
                                case "once":
                                    this.labelEachDay.visibleSet(true);
                                    this.dailyFrequencyOnceTime.visibleSet(true);
                                    break;
                                default:
                                    this.labelEachDay.visibleSet(false);
                                    this.dailyFrequencyOnceTime.visibleSet(false);
                                    break;
                            }

                            switch (this.dailyFrequencyType.valueGet())
                            {
                                case "recurring":
                                    this.labelEachDayEvery.visibleSet(true);
                                    this.dailyFrequencyEveryX.visibleSet(true);
                                    this.dailyFrequencyEveryTimePeriod.visibleSet(true);
                                    this.dailyFrequencyContainer2.visibleSet(true);
                                    this.dailyFrequencyContainer3.visibleSet(true);
                                    break;
                                default:
                                    this.labelEachDayEvery.visibleSet(false);
                                    this.dailyFrequencyEveryX.visibleSet(false);
                                    this.dailyFrequencyEveryTimePeriod.visibleSet(false);
                                    this.dailyFrequencyContainer2.visibleSet(false);
                                    this.dailyFrequencyContainer3.visibleSet(false);
                                    break;
                            }

                            this.durationGroupBox.visibleSet(true);

                            switch (this.durationEndType.valueGet())
                            {
                                case "finite":
                                    this.durationContainer3.visibleSet(true);
                                    break;
                                default:
                                    this.durationContainer3.visibleSet(false);
                                    break;
                            }

                            break;
                        default:
                            this.dailyFrequencyGroupBox.visibleSet(false);
                            this.durationGroupBox.visibleSet(false);
                            break;
                    }
                },
                valueSet: function (value)
                {
                    if (this.valueGet() === value)
                        return false;

                    this._elementValueSet(value);
                    this.super.valueSet(this._elementValueGet());

                    return true;
                },

                // Event Handlers
                onControlValueChanged: function (evt)
                {
                    evt.data.self._elementValueChanged();
                    evt.data.self.updateLayout();
                }
            };
        }
    });

    // Schedule Text
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "ScheduleText",
        inherits: "InputControl",
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-schedule-text");
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _createElement: function ()
                {
                    this.super._createElement();

                    const
                        $$element = this.$$elementGet();

                    this.$$text = $$.create$$("span").appendTo($$element);
                },
                _createScheduleDescription: function ()
                {
                    var
                        value = this.valueGet();

                    if (!value)
                        return null;

                    var
                        valueObject = value.fromJson(),
                        description = String.empty,
                        oneTimeDateTime,
                        durationStartDate,
                        durationEndDate;

                    switch (valueObject.frequency)
                    {
                        case "oneTime":
                            oneTimeDateTime = Date.fromString(valueObject.oneTimeDateTime, "yyyy-MM-ddTHH:mm:ss.fffffffZ").convertToUTC();
                            description =
                                String.format(
                                    "Occurs on {0} at {1}.",
                                    oneTimeDateTime.toString("dd/MM/yyyy"),
                                    oneTimeDateTime.toString("HH:mm:ss")
                                );
                            break;
                        case "daily":
                            description =
                                String.format(
                                    "Occurs every{0} day{1}",
                                    valueObject.frequencyDailyEveryX > 1 ? " " + valueObject.frequencyDailyEveryX : String.empty,
                                    valueObject.frequencyDailyEveryX > 1 ? "s" : String.empty
                                );
                            break;
                        case "weekly":
                            description =
                                String.format(
                                    "Occurs every{0} week{1}{2}",
                                    valueObject.frequencyWeeklyEveryX > 1 ? " " + valueObject.frequencyWeeklyEveryX : String.empty,
                                    valueObject.frequencyWeeklyEveryX > 1 ? "s" : String.empty,
                                    this._getDayList(valueObject)
                                );
                            break;
                        case "monthly":
                            switch (valueObject.frequencyMonthlyFrequencyType)
                            {
                                case "dayByNumber":
                                    description =
                                        String.format(
                                            "Occurs every{0} month{1} on day {2} of that month",
                                            valueObject.frequencyMonthlyDayByNumberEveryX > 1 ? " " + valueObject.frequencyMonthlyDayByNumberEveryX : String.empty,
                                            valueObject.frequencyMonthlyDayByNumberEveryX > 1 ? "s" : String.empty,
                                            valueObject.frequencyMonthlyDayByNumberDayX
                                        );
                                    break;
                                case "dayByDay":
                                    description =
                                        String.format(
                                            "Occurs every{0}{1} of every{2} month{3}",
                                            String.format(" {0}", this._getDayNumberDescription(valueObject.frequencyMonthlyDayByDayDayNumber)),
                                            String.format(" {0}", this._getDayTypeDescription(valueObject.frequencyMonthlyDayByDayDayType)),
                                            valueObject.frequencyMonthlyDayByDayEveryX > 1 ? " " + valueObject.frequencyMonthlyDayByDayEveryX : String.empty,
                                            valueObject.frequencyMonthlyDayByDayEveryX > 1 ? "s" : String.empty
                                        );
                                    break;
                            }
                            break;
                    }

                    switch (valueObject.frequency)
                    {
                        case "oneTime":
                            break;
                        default:
                            switch (valueObject.dailyFrequencyType)
                            {
                                case "once":
                                    description +=
                                        String.format(
                                            " at {0}.",
                                            valueObject.dailyFrequencyOnceTime
                                        );
                                    break;
                                case "recurring":
                                    description +=
                                        String.format(
                                            " every{0} {1}{2} between {3} and {4}.",
                                            valueObject.dailyFrequencyEveryX > 1 ? " " + valueObject.dailyFrequencyEveryX : String.empty,
                                            this._getTimePeriodDescription(valueObject.dailyFrequencyEveryTimePeriod),
                                            valueObject.dailyFrequencyEveryX > 1 ? "s" : String.empty,
                                            valueObject.dailyFrequencyEveryStartTime.toString(),
                                            valueObject.dailyFrequencyEveryEndTime.toString()
                                        );
                                    break;
                            }
                            break;
                    }

                    switch (valueObject.frequency)
                    {
                        case "oneTime":
                            break;
                        default:
                            durationStartDate = Date.fromString(valueObject.durationStartDate, "yyyy-MM-ddTHH:mm:ss.fffffffZ").convertToUTC();

                            if (valueObject.durationEndDate)
                                durationEndDate = Date.fromString(valueObject.durationEndDate, "yyyy-MM-ddTHH:mm:ss.fffffffZ").convertToUTC();

                            description +=
                                String.format(
                                    " Schedule will be used {0} {1}{2}.",
                                    valueObject.durationEndType === "none"
                                        ? "from"
                                        : "between",
                                    durationStartDate.toString("dd/MM/yyyy"),
                                    valueObject.durationEndType === "finite"
                                        ? " and " + (durationEndDate ? durationEndDate.toString("dd/MM/yyyy") : String.empty)
                                        : String.empty
                                );
                            break;
                    }

                    return description;
                },
                _getDayList: function (schedule)
                {
                    var
                        days = [];

                    if (schedule.frequencyWeeklyOnMonday)
                        days.push("Monday");

                    if (schedule.frequencyWeeklyOnTuesday)
                        days.push("Tuesday");

                    if (schedule.frequencyWeeklyOnWednesday)
                        days.push("Wednesday");

                    if (schedule.frequencyWeeklyOnThursday)
                        days.push("Thursday");

                    if (schedule.frequencyWeeklyOnFriday)
                        days.push("Friday");

                    if (schedule.frequencyWeeklyOnSaturday)
                        days.push("Saturday");

                    if (schedule.frequencyWeeklyOnSunday)
                        days.push("Sunday");

                    if (days.length > 0)
                        return String.format(" on {0}", days.join(", "));

                    return String.empty;
                },
                _getDayNumberDescription: function (dayNumber)
                {
                    switch (dayNumber)
                    {
                        case "first":
                            return "first";
                        case "second":
                            return "second";
                        case "third":
                            return "third";
                        case "fourth":
                            return "fourth";
                        case "last":
                            return "last";
                        default:
                            console.error("Not implemented.");
                            break;
                    }
                },
                _getDayTypeDescription: function (dayType)
                {
                    switch (dayType)
                    {
                        case "monday":
                            return "monday";
                        case "tuesday":
                            return "tuesday";
                        case "wednesday":
                            return "wednesday";
                        case "thursday":
                            return "thursday";
                        case "friday":
                            return "friday";
                        case "saturday":
                            return "saturday";
                        case "sunday":
                            return "sunday";
                        case "day":
                            return "day";
                        case "weekDay":
                            return "week day";
                        case "weekendDay":
                            return "weekend day";
                        default:
                            console.error("Not implemented.");
                            break;
                    }
                },
                _getTimePeriodDescription: function (timePeriod)
                {
                    switch (timePeriod)
                    {
                        case "hours":
                            return "hour";
                        case "minutes":
                            return "minute";
                        case "seconds":
                            return "second";
                        default:
                            console.error("Not implemented.");
                            break;
                    }
                },
                _textChanged: function (change)
                {
                    this.super._textChanged(change);
                    this.$$text.text(change.currentValue);
                },
                _valueChanged: function (change)
                {
                    this.super._valueChanged(change);
                    this.textSet(this._createScheduleDescription());
                },
            };
        }
    });

    // Switch
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "Switch",
        inherits: "InputControl",
        createPropertyDefaults: namespace =>
        {
            return {
                value: false
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-switch ui toggle checkbox");
                this._elementValueSet(this.valueGet());
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _bindEvents: function ()
                {
                    this.super._bindEvents();

                    var self = this;
                    self.$$valueElement.on("change", () => { self._elementValueChanged(); });
                },
                _createElement: function ()
                {
                    this.super._createElement();

                    var
                        $$element = this.$$elementGet();

                    this.$$valueElement = $$(String.formatWithHtmlEncode("<input id=\"{0}-input\" type=\"checkbox\" />", this.controlId)).appendTo($$element);
                    this.$$labelElement = $$(String.formatWithHtmlEncode("<label for=\"{0}-input\"></label>", this.controlId)).appendTo($$element);
                },
                _elementValueChanged: function ()
                {
                    if (!this.__processElementValueChanged)
                        return;

                    this.super.valueSet(this._elementValueGet());
                },
                _elementValueGet: function ()
                {
                    return this.$$valueElement.prop("checked");
                },
                _elementValueSet: function (value)
                {
                    this.__processElementValueChanged = false;
                    this.$$valueElement.prop("checked", !!value);
                    this.__processElementValueChanged = true;
                },
                _enabledChanged: function (change)
                {
                    this.$$valueElement.prop("disabled", change.currentValue ? String.empty : "disabled");
                },
                _textChanged: function (change)
                {
                    this.super._textChanged(change);
                    this.$$labelElement.text(change.currentValue);
                },

                // Public Methods
                valueSet: function (value)
                {
                    value = window.objectHelper.asType(value, "boolean");

                    if (this.valueGet() === value)
                        return false;

                    this._elementValueSet(value);
                    this.super.valueSet(this._elementValueGet());

                    return true;
                }
            };
        }
    });

    // Text
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "Text",
        inherits: "InputControl",
        mixins: [
            "CopyValueToClipboardMixin"
        ],
        properties: [
            { name: "preserveLineBreaks", type: "boolean" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                elementType: "p",
                text: String.empty
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-text");

                // Trigger Property Changes
                this.preserveLineBreaksTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _createElement: function ()
                {
                    this.super._createElement();

                    var
                        $$element = this.$$elementGet();

                    this.labelTargetId = this.controlId + "-span";
                    this.$$valueElement =
                        $$.create$$({
                            nodeName: "span",
                            attributes: { id: this.labelTargetId }
                        }).appendTo($$element);
                },
                _preserveLineBreaksChanged: function (change)
                {
                    if (change.currentValue)
                        this.addCssClass("rad-feature-preserve-line-breaks");
                    else
                        this.removeCssClass("rad-feature-preserve-line-breaks");
                },
                _textChanged: function (change)
                {
                    this.super._textChanged(change);

                    var
                        text = change.currentValue;

                    if (text)
                    {
                        var
                            dateResult = Date.tryFromString(text, "yyyy-MM-ddTHH:mm:ss");

                        if (dateResult.success)
                            text = dateResult.date.toString("dd/MM/yyyy HH:mm:ss");
                    }

                    this.$$valueElement.text(text);
                },
                _valueChanged: function (change)
                {
                    this.super._valueChanged(change);
                    this.textSet(change.currentValue);
                }
            };
        }
    });

    // Text (Application Entity)
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "TextApplicationEntity",
        inherits: "InputControl",
        properties: [
            { name: "primaryEntity", type: "string" },
            { name: "primaryEntityDescriptionProperty", type: "string" }
        ],
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _createElement: function ()
                {
                    this.super._createElement();

                    var
                        $$element = this.$$elementGet();

                    this.labelTargetId = this.controlId + "-p";
                    this.$$valueElement = $$(String.formatWithHtmlEncode("<p id=\"{0}\"></p>", this.labelTargetId)).appendTo($$element);
                },
                _textChanged: function (change)
                {
                    this.super._textChanged(change);
                    this.$$valueElement.text(change.currentValue);
                },

                // Public Methods
                loadDataAsync: function ()
                {
                    var
                        self = this,
                        dataSource = self.dataSourceGet(),
                        primaryEntity = this.primaryEntityGet(),
                        primaryEntityDescriptionProperty = this.primaryEntityDescriptionPropertyGet(),
                        dataSourceProperty = this.dataSourcePropertyGet(),
                        entityId = dataSource && dataSourceProperty ? dataSource.propertyValueByPathGet(dataSourceProperty) : null;

                    if (!primaryEntity)
                        return Promise.reject("primaryEntity is not set");

                    if (!primaryEntityDescriptionProperty)
                        return Promise.reject("primaryEntityDescriptionProperty is not set");

                    if (!entityId)
                    {
                        return new Promise(resolve =>
                        {
                            setTimeout(() =>
                            {
                                self.textSet(null);
                                resolve();
                            });
                        });
                    }

                    return (
                        window.application.webApiClient
                            .createEntityGetRequest(
                                primaryEntity,
                                entityId,
                                [
                                    "id",
                                    primaryEntityDescriptionProperty
                                ],
                                { "RAD-Option-Include-Soft-Deleted": true }
                            )
                            .executeAsync()
                            .then(data =>
                            {
                                self.textSet(data ? data[primaryEntityDescriptionProperty] : null);
                            })
                    );
                }
            };
        }
    });

    // #region Action Controls

    // #region Mixins

    classFactory.createMixin({
        namespace: "seriouslyrad.ui.web",
        name: "ActionButtonMixin",
        properties: [
            { name: "action", type: "string" },
            { name: "actionArguments", type: "array" },
            { name: "actionTarget" },
            { name: "actionTargetControlClass", type: "string" },
            { name: "actionTargetId", type: "string" },
            { name: "actionTargetSelector", type: "string" }
        ],
        propertyAttributes: [
            {
                propertyName: "action",
                designer: {
                    category: "Behavior",
                    displayName: "Action"
                }
            },
            {
                propertyName: "actionArguments",
                designer: {
                    category: "Behavior",
                    displayName: "Action Arguments"
                }
            },
            {
                propertyName: "actionTarget",
                designer: {
                    category: "Behavior",
                    displayName: "Action Target"
                }
            },
            {
                propertyName: "actionTargetId",
                designer: {
                    category: "Behavior",
                    displayName: "Action Target Id"
                }
            },
            {
                propertyName: "actionTargetSelector",
                designer: {
                    category: "Behavior",
                    displayName: "Action Target Selector"
                }
            }
        ],
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _applyActionButtonProperties: function ()
                {
                    var
                        actionTarget = this.actionTargetGet(),
                        actionTargetId = this.actionTargetIdGet(),
                        actionTargetControlClass = this.actionTargetControlClassGet(),
                        actionTargetSelector = this.actionTargetSelectorGet(),
                        control;

                    if (!actionTarget)
                    {
                        if (actionTargetId)
                        {
                            control = seriouslyrad.ui.web.Control.find("#" + actionTargetId);

                            if (!control)
                                console.error("Cannot find action target control using the supplied id.");

                            actionTarget = control;
                        }
                        else if (actionTargetControlClass)
                        {
                            var
                                controlClass = classFactory.getObjectByPath({ path: actionTargetControlClass });

                            if (!controlClass)
                            {
                                var
                                    controlNamespacePath = this.$$elementGet().closest("[data-control-namespace]").attr("data-control-namespace"),
                                    controlNamespace;

                                if (controlNamespacePath)
                                    controlNamespace = classFactory.getObjectByPath({ path: controlNamespacePath });

                                if (controlNamespace)
                                    controlClass = classFactory.getObjectByPath({ path: actionTargetControlClass, namespace: controlNamespace });
                            }

                            if (!controlClass)
                            {
                                console.error("Cannot find the supplied control class specified for the action target.");
                                return;
                            }

                            control = this;

                            while (control)
                            {
                                if (control instanceof controlClass)
                                {
                                    actionTarget = control;
                                    break;
                                }

                                control = control.parentControlGet();
                            }

                            if (!actionTarget)
                                console.error("Cannot find action target control using the supplied control class.");
                        }
                        else if (actionTargetSelector)
                        {
                            control = this.$$elementGet().closest(actionTargetSelector).radControl();

                            if (!control)
                                console.error("Cannot find action target control using the supplied selector.");

                            actionTarget = control;
                        }

                        if (actionTarget)
                            this.actionTargetSet(actionTarget);
                    }

                    if (actionTarget)
                    {
                        var
                            action = this.actionGet();

                        if (typeof actionTarget[action] !== "function")
                            console.error("Action target does not support the action \"" + action + "\".");
                    }
                },
                _processActionButtonClick: function (evt)
                {
                    var
                        action = this.actionGet(),
                        actionArguments = this.actionArgumentsGet(),
                        actionTarget = this.actionTargetGet();

                    if (actionTarget)
                    {
                        evt.preventDefault();

                        const
                            result = actionTarget[action].apply(actionTarget, actionArguments);

                        if (result instanceof Promise)
                            result.catch(() => { /* Intentionally empty */ });

                        return result;
                    }
                    else if (action)
                    {
                        switch (action)
                        {
                            case "back":

                                evt.preventDefault();

                                if (window.history.pushStateCounter > 0)
                                    window.history.back();
                                else if (navigator?.app?.exitApp)
                                    navigator.app.exitApp();

                                return Promise.resolve();
                        }
                    }

                    return null;
                }
            };
        }
    });

    classFactory.createMixin({
        namespace: "seriouslyrad.ui.web",
        name: "MfaProviderSelectionMixin",
        createPrototype: namespace =>
        {
            return {

                // Public Methods
                addMfaProviderOptionsToPanel: function (mfaProviders, panel, eventHandler)
                {
                    var
                        self = this;

                    mfaProviders
                        .each(item =>
                        {
                            var
                                panelInner = new seriouslyrad.ui.web.Panel({ tag: item })
                                    .appendTo(panel);

                            new seriouslyrad.ui.web.Button({ tag: item, text: item.description })
                                .appendTo(panelInner)
                                .on("click", { self: self }, eventHandler);

                            if (item.helpText)
                            {
                                $$.create$$({
                                    nodeName: "div",
                                    attributes: {
                                        "class": "rad-help",
                                        "data-tooltip": item.helpText,
                                        "data-variation": "fixed small",
                                        "data-position": "top right"
                                    },
                                    children: [{
                                        nodeName: "p",
                                        text: "What's this?"
                                    }, {
                                        attributes: { "class": "icon-question-circle" },
                                        nodeName: "i"
                                    }]
                                }).appendTo(panelInner.$$elementGet());
                            }

                            $$.create$$({
                                nodeName: "div",
                                attributes: { "class": "separator" },
                                children: [{
                                    nodeName: "span",
                                    attributes: { "class": "separator-line" }
                                },
                                {
                                    attributes: { "class": "separator-text" },
                                    nodeName: "span",
                                    text: "Or"
                                },
                                {
                                    nodeName: "span",
                                    attributes: { "class": "separator-line" }
                                },]
                            }).appendTo(panelInner.$$elementGet());
                        });
                }
            };
        }
    });

    // #endregion

    // Link
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "Link",
        inherits: "ContainerControl",
        mixins: [
            "ActionButtonMixin"
        ],
        properties: [
            { name: "disableSelfOnClick", type: "boolean" },
            { name: "href", type: "string" },
            { name: "target", type: "string" }
        ],
        propertyAttributes: [
            {
                propertyName: "href",
                designer: {
                    category: "Behavior",
                    displayName: "Url"
                }
            }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                disableSelfOnClick: false,
                elementType: "a",
                href: String.empty
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-link");

                this._applyActionButtonProperties();

                const
                    href = this.$$elementGet().attr("href");

                if (href)
                    this[".properties"].href = href;

                // Trigger Property Changes
                this.hrefTriggerChange();
                this.targetTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _bindEvents: function ()
                {
                    this.super._bindEvents();
                    this.on("mousedown touchstart", { self: this }, this.onMouseDownOrTouchStart);
                    this.on("keyup", { self: this }, this.onKeyUp);
                },
                _createElement: function ()
                {
                    this.super._createElement();

                    var
                        $$element = this.$$elementGet();

                    this.$$textElement = $$.create$$({ nodeName: "span", attributes: { "class": "rad-text" } }).appendTo($$element);

                    $$element.attr("tabindex", 0);
                },
                _hrefChanged: function (change)
                {
                    const
                        $$element = this.$$elementGet();

                    if (!$$element)
                        return;

                    if (change.currentValue)
                    {
                        $$element.attr(
                            "href",
                            change.currentValue.startsWith("/") && !change.currentValue.startsWith(window.applicationInformation.virtualDirectory)
                                ? window.applicationInformation.virtualDirectory + change.currentValue.substr(1)
                                : change.currentValue
                        );
                    }
                    else
                        $$element.removeAttr("href");
                },
                _targetChanged: function (change)
                {
                    this.$$elementGet().attr("target", change.currentValue);
                },
                _textChanged: function (change)
                {
                    this.super._textChanged(change);
                    this.$$textElement.text(change.currentValue);
                },

                // Public Methods
                click: function ()
                {
                    if (!this.enabledGet())
                        return;

                    this.trigger("click");
                },

                // Event Handlers
                onClick: function (evt)
                {
                    var
                        self = evt.data.self;

                    self.focus(); // Ensure button has focus (causes other changed events to fire)

                    if (self.disableSelfOnClickGet())
                        self.enabledSet(false);

                    self._processActionButtonClick(evt);
                },
                onKeyUp: function (evt)
                {
                    evt.stopPropagation();

                    if (evt.key === "Enter")
                    {
                        evt.preventDefault();
                        evt.data.self.click();
                    }
                },
                onMouseDownOrTouchStart: function (evt)
                {
                    evt.stopPropagation();
                }
            };
        }
    });

    // Button
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "Button",
        inherits: "Link",
        properties: [
            { name: "icon", type: "string" },
            { name: "iconToggle", type: "string" },
            { name: "iconAlignment", type: "string" },
            { name: "mode", type: "string" },
            { name: "showLabel", type: "boolean" },
            { name: "state", type: "boolean" },
            { name: "svgKey", type: "string" },
            { name: "svgKeyToggle", type: "string" }
        ],
        propertyAttributes: [
            {
                propertyName: "icon",
                designer: {
                    category: "Appearance",
                    displayName: "Icon"
                }
            },
            {
                propertyName: "showLabel",
                designer: {
                    category: "Appearance",
                    displayName: "Show Label"
                }
            }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                mode: namespace.Button.modes.normal,
                showLabel: true,
                state: false
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-button ui button icon");

                // Trigger Property Changes
                this.iconTriggerChange();
                this.iconAlignmentTriggerChange();
                this.showLabelTriggerChange();
                this.svgKeyTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _createElement: function ()
                {
                    this.super._createElement();

                    var
                        $$element = this.$$elementGet(),
                        iconElement = $$.create("i");

                    iconElement.appendChild($$.create("span"));

                    this.$$iconElement = $$(iconElement).prependTo($$element);

                    this.$$svgWrapper = $$.create$$("span", "rad-svg-wrapper").hide().prependTo($$element);
                },
                _iconChanged: function (change)
                {
                    this._updateLayout();
                },
                _iconAlignmentChanged: function (change)
                {
                    const
                        $$element = this.$$elementGet();

                    if (change.currentValue === namespace.Button.alignments.right)
                    {
                        $$element.append(this.$$iconElement);
                        $$element.append(this.$$svgWrapper);
                    }
                    else
                    {
                        $$element.prepend(this.$$iconElement);
                        $$element.prepend(this.$$svgWrapper);
                    }
                },
                _showLabelChanged: function (change)
                {
                    if (change.currentValue)
                        this.addCssClass("labeled");
                    else
                        this.removeCssClass("labeled");
                },
                _stateChanged: function (change)
                {
                    if (change.currentValue)
                        this.addCssClass("rad-state-on");
                    else
                        this.removeCssClass("rad-state-on");

                    this._updateLayout();

                    this.triggerHandler("stateChanged", change);
                },
                _svgKeyChanged: function (change)
                {
                    this._updateLayout();
                },
                _updateLayout: function ()
                {
                    var
                        state = this.stateGet(),
                        icon = state ? this.iconToggleGet() : this.iconGet(),
                        svgKey = state ? this.svgKeyToggleGet() : this.svgKeyGet();

                    this.$$iconElement.removeClass();

                    if (icon)
                    {
                        this.addCssClass("rad-icon");
                        this.$$iconElement.addClass(String.format("icon {0}", icon));
                    }
                    else
                    {
                        this.removeCssClass("rad-icon");

                        if (svgKey)
                        {
                            this.$$svgWrapper.empty();
                            this.$$svgWrapper.append(window.svgHelper.createSvg(svgKey));
                            this.$$svgWrapper.show();
                        }
                        else
                            this.$$svgWrapper.hide();
                    }
                },

                // Event Handlers
                onClick: function (evt)
                {
                    this.super.onClick(evt);

                    var
                        self = evt.data.self;

                    if (self.modeGet() === namespace.Button.modes.toggle)
                        self.stateSet(!self.stateGet());
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.alignments = {
                "left": null,
                "right": "right"
            };
            classConstructor.modes = {
                "normal": "normal",
                "toggle": "toggle"
            };

            $$(document).on("keydown", ".rad-control-button", evt =>
            {
                switch (evt.key)
                {
                    case "Enter":
                        {
                            $$(evt.target)
                                .radControl()
                                .click();

                            break;
                        }
                }
            });
        }
    });

    // Filter Panel
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "FilterPanel",
        inherits: "seriouslyrad.ui.web.Panel",
        properties: [
            { name: "filters", type: "array" },
            { name: "filterSources", type: "array" },
            { name: "lozengeClickTriggersEvent", type: "boolean" },
            { name: "showFilters", type: "boolean" },
            { name: "useAlternativeDtoFormatForFilters", type: "boolean" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                filters: [],
                filterSources: [],
                lozengeClickTriggersEvent: false,
                showFilters: true,
                useAlternativeDtoFormatForFilters: false
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-filter-panel");

                // Trigger Property Changes
                this.showFiltersTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _bindEvents: function ()
                {
                    this.super._bindEvents();

                    var
                        self = this;

                    self.panelCurrentFilters.on("click", ".rad-lozenge-filter", evt =>
                    {
                        evt.preventDefault();
                        evt.stopPropagation();

                        var
                            tagData = $$(evt.currentTarget).dataGet();

                        if (self.lozengeClickTriggersEventGet())
                            self.trigger("lozengeClicked", tagData);
                        else
                            self.removeFilter(tagData.radFilterData.type, tagData.radFilterData.value);
                    });
                },
                _createElement: function ()
                {
                    this.super._createElement();

                    var
                        $$element = this.$$elementGet();

                    $$.create$$({ nodeName: "span", text: "Filter by" }).appendTo($$element);

                    this.panelFilterControls =
                        new seriouslyrad.ui.web.Panel({ cssClass: "rad-filter-controls-panel" })
                            .appendTo($$element);

                    this.panelCurrentFilters =
                        new seriouslyrad.ui.web.Panel({ cssClass: "rad-current-filters-panel" })
                            .appendTo($$element);
                },
                _filtersChanged: function (change)
                {
                    var
                        self = this,
                        currentValue = change.currentValue ? change.currentValue : [],
                        filterDtoAlternate = {},
                        filterDto = [],
                        useAlternativeDtoFormatForFilters = self.useAlternativeDtoFormatForFiltersGet();

                    currentValue.forEach(item =>
                    {
                        if (!filterDtoAlternate[item.type])
                            filterDtoAlternate[item.type] = [];

                        if (Array.isArray(item.value))
                            item.value.forEach(itemInner =>
                            {
                                filterDtoAlternate[item.type].push(itemInner);
                                filterDto.push({ type: item.type, value: itemInner });
                            });
                        else
                        {
                            filterDtoAlternate[item.type].push(item.value);
                            filterDto.push({ type: item.type, value: item.value });
                        }
                    });

                    self.trigger("filtersChanged", { filters: (useAlternativeDtoFormatForFilters ? filterDtoAlternate : filterDto) });
                },
                _filterSourcesChanged: function (change)
                {
                    var
                        self = this,
                        originalTypes = change.originalValue?.length ? change.originalValue.select(item => item.type).distinct() : [],
                        currentValue = change.currentValue ? change.currentValue : [];

                    self.panelFilterControls.controlsClear();

                    currentValue.forEach(item =>
                    {
                        originalTypes.remove(item.type);

                        if (item.pickerDialogClass)
                        {
                            const
                                button = new seriouslyrad.ui.web.Button({ iconAlignment: namespace.Button.alignments.right, svgKey: "icon-search", text: item.placeholder })
                                    .appendTo(self.panelFilterControls);

                            button.on("click", { pickerDialogClass: item.pickerDialogClass, self: self, type: item.type, typeFriendly: item.typeFriendly }, self.onFilterButtonClicked);
                        }
                        else
                        {
                            const
                                filterControl = new seriouslyrad.ui.web.ComboBox({ placeholder: item.placeholder })
                                    .appendTo(self.panelFilterControls);

                            filterControl.listDataSourceSet(item.data);

                            filterControl.$$elementGet().attr("data-type", item.type);

                            filterControl.on("valueChanged", { self: self, type: item.type, typeFriendly: item.typeFriendly }, self.onFilterComboBoxValueChanged);
                        }
                    });

                    if (originalTypes.length)
                    {
                        self.filtersGet()
                            .where(item => originalTypes.contains(item.type))
                            .forEach(item => { self.removeFilter(item.type, item.value); });
                    }
                },
                _getFilterSourceForFilterType: function (filterType)
                {
                    var
                        filterSources = this.filterSourcesGet();

                    if (!filterSources.length)
                        return null;

                    return filterSources.firstOrDefault(item => item.type === filterType);
                },
                _getFilterSourceControlForFilterType: function (filterType)
                {
                    return this.panelFilterControls.controlsGet().firstOrDefault(item => item.$$elementGet().attr("data-type", type) === type);
                },
                _showFiltersChanged: function (change)
                {
                    if (change.currentValue)
                        this.show();
                    else
                        this.hide();
                },

                // Public Methods
                addFilter: function (type, value, description)
                {
                    var
                        filters = this.filtersGet().toJson().fromJson(),
                        filterData = { type: type, value: value, description: description },
                        filterSource = this._getFilterSourceForFilterType(type);

                    if (!filterSource)
                        return false;

                    if (filters.any(item => item.type === type && (Array.isArray(item.value) && Array.isArray(value) ? item.value.sequenceEqualTo(value) : item.value === value)))
                        return false;

                    filters.push(filterData);

                    this.filtersSet(filters);

                    var
                        $$tag =
                            $$.create$$({
                                nodeName: "span",
                                attributes: { "class": "rad-lozenge-filter" },
                                data: { radFilterData: filterData },
                                children: [
                                    {
                                        nodeName: "span",
                                        text: description
                                    },
                                    {
                                        nodeName: "i",
                                        attributes: { "class": "icon cross" },
                                    }
                                ]
                            }).appendTo(this.panelCurrentFilters.$$elementGet());

                    $$tag.attr("data-value", value);
                    $$tag.attr("data-type", type);
                },
                addFilterSource: function (type, placeholder, data)
                {
                    // data should be an array of value & description pairs

                    var
                        filtersSources = this.filterSourcesGet().toJson().fromJson(),
                        filterSourceData = { type: type, placeholder: placeholder, data: data },
                        filterSource = this._getFilterSourceForFilterType(type);

                    if (!filterSource)
                        return false;

                    filtersSources.push(filterSourceData);

                    this.filterSourcesSet(filtersSources);
                },
                clearFilters: function ()
                {
                    this.filtersSet([]);
                },
                clearFilterSources: function ()
                {
                    this.filterSourcesSet([]);
                },
                removeFilter: function (type, value)
                {
                    var
                        filters = this.filtersGet().toJson().fromJson();

                    filters.remove(item => item.type === type && (Array.isArray(item.value) ? item.value.sequenceEqualTo(value) : item.value === value));

                    this.filtersSet(filters);

                    this.panelCurrentFilters.$$elementGet().find(String.format("[data-type=\"{0}\"][data-value=\"{1}\"]", type, value)).remove();
                },

                // Event handlers
                onFilterButtonClicked: function (evt)
                {
                    const
                        self = evt.data.self,
                        pickerDialogClass = evt.data.pickerDialogClass,
                        type = evt.data.type,
                        typeFriendly = evt.data.typeFriendly;

                    if (!pickerDialogClass)
                        return;

                    if (!this.pickerDialogs)
                        this.pickerDialogs = {};

                    if (!this.pickerDialogs[pickerDialogClass])
                    {
                        this.pickerDialogs[pickerDialogClass] = namespace.Control.createFromClassPath(pickerDialogClass);
                        this.pickerDialogs[pickerDialogClass].addNewSet(false);
                        this.pickerDialogs[pickerDialogClass].returnPropertySet(null);
                    }

                    this.pickerDialogs[pickerDialogClass]
                        .openAsync()
                        .then(returnValue =>
                        {
                            const
                                dialogResult = returnValue[0],
                                selectedItem = returnValue[1];

                            if (dialogResult !== namespace.Dialog.dialogResult.ok)
                                return;

                            if (selectedItem)
                                self.addFilter(type, selectedItem.name, typeFriendly ? `${typeFriendly}: ${selectedItem.name}` : selectedItem.name);
                        });
                },
                onFilterComboBoxValueChanged: function (evt)
                {
                    evt.preventDefault();
                    evt.stopPropagation();

                    var
                        self = evt.data.self,
                        type = evt.data.type,
                        typeFriendly = evt.data.typeFriendly,
                        comboBox = evt.currentTarget,
                        selectedItem = comboBox.selectedItemGet();

                    if (comboBox)
                    {
                        if (selectedItem)
                            self.addFilter(type, selectedItem.value, typeFriendly ? `${typeFriendly}: ${selectedItem.description}` : selectedItem.description);

                        setTimeout(() => { comboBox.valueSet(null); });
                    }
                },
            };
        }
    });

    // Image Button
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "ImageButton",
        inherits: "Button",
        properties: [
            { name: "image", type: "string" },
        ],
        propertyAttributes: [
            {
                propertyName: "image",
                designer: {
                    category: "Appearance",
                    displayName: "Image"
                }
            }
        ],
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-image-button");

                // Trigger Property Changes
                this.imageTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _createElement: function ()
                {
                    this.super._createElement();

                    var
                        $$element = this.$$elementGet();

                    this.$$imageElement = $$.create$$("img").hide().appendTo($$element);
                },
                _imageChanged: function (change)
                {
                    if (change.currentValue)
                        this.$$imageElement.attr("src", change.currentValue).show();
                    else
                        this.$$imageElement.hide();
                }
            };
        }
    });

    // Main Menu
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "MainMenu",
        inherits: "ContainerControl",
        properties: [
            { name: "mobileTransition", type: "string" },
            { name: "showEntityIcon", type: "boolean" },
            { name: "transition", type: "string" }
        ],
        propertyAttributes: [
            {
                propertyName: "transition",
                designer: {
                    category: "Appearance",
                    displayName: "Transition"
                }
            }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                mobileTransition: namespace.MainMenu.transitions.overlay,
                showEntityIcon: true,
                transition: namespace.MainMenu.transitions.overlay
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-main-menu ui left vertical menu sidebar");
                this.$$elementGet()
                    .sidebar({
                        mobileTransition: this.mobileTransitionGet(),
                        transition: this.transitionGet(),
                        onVisible: function ()
                        {
                            $$("html").addClass("rad-state-main-menu-visible");
                        },
                        onHide: function ()
                        {
                            $$("html").removeClass("rad-state-main-menu-visible");
                        }
                    });

                this._fixChromeRedrawIssue();

                // Trigger Property Changes
                this.mobileTransitionTriggerChange();
                this.showEntityIconTriggerChange();
                this.transitionTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _createContainerElement: function ()
                {
                    var
                        $$element = this.$$elementGet(),
                        $$containerElement = $$.create$$({ nodeName: "div" }).appendTo($$element);

                    this.$$containerElementSet($$containerElement);
                },
                _fixChromeRedrawIssue: function ()
                {
                    /* INFO: Don't laugh.
                       Don't remove. */
                    if (window.chrome && window.navigator.vendor === "Google Inc.")
                    {
                        var
                            self = this,
                            firstDiv,
                            b = false;

                        self.on("scroll", () =>
                        {
                            if (!firstDiv)
                                firstDiv = self.$$elementGet().find(">div");
                            firstDiv.css({ borderWidth: b ? 1 : 0 });
                            b = !b;
                        });
                    }
                },
                _showEntityIconChanged: function (change)
                {
                    if (change.currentValue)
                        this.removeCssClass("rad-state-button-icons-hidden");
                    else
                        this.addCssClass("rad-state-button-icons-hidden");
                },

                // Public Methods
                close: function ()
                {
                    this.$$elementGet().sidebar("hide");
                },
                open: function ()
                {
                    this.$$elementGet().sidebar("show");
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.transitions = {
                overlay: "overlay",
                push: "push",
                scaleDown: "scale down"
            };

            $$(() =>
            {
                $$(document).on("click", "a.rad-action-main-menu-open", evt =>
                {
                    evt.preventDefault();
                    evt.stopPropagation();

                    if (classConstructor.instance)
                        classConstructor.instance.open();
                });
                $$(document).on("click", "a.rad-action-main-menu-close, .rad-control-main-menu a", evt =>
                {
                    const
                        target = evt.currentTarget.getAttribute("target");

                    if (target && target !== "_self")
                        return;

                    evt.preventDefault();
                    evt.stopPropagation();

                    if (classConstructor.instance)
                        classConstructor.instance.close();
                });
            });
        }
    });

    // Menu Item
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "MenuItem",
        inherits: "ContainerControl",
        properties: [
            { name: "key" },
            { name: "toggle", type: "boolean" },
            { name: "toggleState", type: "boolean" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                toggle: false,
                toggleState: false
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-menu-item");
                this.updateMenuElementTimeoutId = 0;
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _createChildControls: function ()
                {
                    this.super._createChildControls();

                    this._updateMenuElement();
                },
                _createElement: function ()
                {
                    this.super._createElement();

                    this.$$menuElement = $$.create$$({
                        nodeName: "div",
                        attributes: { "class": "rad-menu ui menu vertical" }
                    });
                    this.$$menuElement.data("rad-control-menu-item", this);
                    this._updateMenuElement();
                },
                _menuItemSelected: function (menuItem)
                {
                    if (!this.openPromise)
                        return;

                    if (menuItem?.toggleGet())
                        menuItem.toggleStateSet(!menuItem.toggleStateGet());

                    this.openPromise.resolve(menuItem);
                    this.openPromise = null;
                },
                _toggleStateChanged: function (change)
                {
                    var
                        menu = this.menuGet();

                    if (menu)
                        menu._updateMenuElement();
                },
                _updateMenuElement: function ()
                {
                    var
                        self = this;

                    self.$$menuElement.empty();

                    self.$$menuElement.append(
                        $$.create$$({
                            nodeName: "a",
                            attributes: { "class": "item icon", href: "#" },
                            children: [{
                                nodeName: "i",
                                attributes: { "class": String.format("icon{0}", this.toggleGet() && this.toggleStateGet() ? " check" : String.empty) }
                            },
                            $$.createText(this.textGet())]
                        })
                    );

                    if (!(self instanceof namespace.Menu))
                    {
                        self.$$menuElement.find(">a").addClass("rad-action-back");
                        self.$$menuElement.find(">a>i").addClass("angle double left");
                    }

                    self.controlsGet().each(item =>
                    {
                        var
                            hasChildMenuItems = item.controlsGet().length > 0,
                            $$menuItemElement =
                                $$(
                                    String.formatWithHtmlEncode(
                                        "<a href=\"#\" class=\"item icon\"><i class=\"icon{0}\"></i>{1}</a>",
                                        item.toggleGet() && item.toggleStateGet() ? " check" : String.empty,
                                        item.textGet()
                                    )
                                );

                        if (hasChildMenuItems)
                            $$menuItemElement.append("<i class=\"icon dropdown\"></i>");

                        $$menuItemElement.data("rad-control-menu-item", item);
                        item._$$menuItemElement = $$menuItemElement;

                        self.$$menuElement.append($$menuItemElement);
                        item.updateVisibility();
                    });
                },

                // Public Methods
                append: function ($$elementOrControl)
                {
                    var
                        self = this;

                    if (self.updateMenuElementTimeoutId)
                        clearTimeout(self.updateMenuElementTimeoutId);

                    self.super.append($$elementOrControl);
                    self.updateMenuElementTimeoutId = setTimeout(() => { self._updateMenuElement(); self = null; });

                    return self;
                },
                controlsClear: function ()
                {
                    this.super.controlsClear();
                    this._updateMenuElement();
                },
                menuGet: function ()
                {
                    if (this instanceof namespace.Menu)
                        return this;

                    return this.$$elementGet().closest(".rad-control-menu").radControl();
                },
                openAsync: function ()
                {
                    if (this.openPromise)
                        console.error("The menu is already open");

                    this.openPromise = Promise.public();

                    namespace.Menu.dimmer.showElementOrControlAsync(this.$$menuElement);

                    return this.openPromise;
                },
                prepend: function ($$elementOrControl)
                {
                    this.super.prepend($$elementOrControl);
                    this._updateMenuElement();
                    return this;
                },
                updateVisibility: function ()
                {
                    this.super.updateVisibility();

                    if (!this._$$menuItemElement)
                        return;

                    if (this.isVisibleGet())
                        this._$$menuItemElement.show();
                    else
                        this._$$menuItemElement.hide();
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.allowedParentControlClasses = [
                "seriouslyrad.ui.web.Menu"];

            $$(document).on("click", ".rad-menu > a", evt =>
            {
                evt.preventDefault();
                evt.stopPropagation();

                var
                    $$target = $$(evt.currentTarget),
                    menu = $$target.closest(".rad-menu").dataGet("rad-control-menu-item"),
                    menuItem = $$target.dataGet("rad-control-menu-item");

                if (!menu)
                    return;

                if (!menuItem)
                {
                    if ($$target.hasClass("rad-action-back"))
                    {
                        menu._menuItemSelected(null);
                        namespace.Menu.dimmer.hideElementOrControlAsync(menu.$$menuElement);
                    }
                    return;
                }

                if (menuItem.controlsGet().length)
                {
                    menuItem.openAsync()
                        .then(childMenuItem =>
                        {
                            if (!childMenuItem) // Back clicked
                                return;

                            menu._menuItemSelected(childMenuItem);
                        });
                }
                else
                {
                    namespace.Menu.dimmer
                        .hideAllAsync()
                        .then(() =>
                        {
                            menu._menuItemSelected(menuItem);
                        });
                }
            });
            $$(document).on("click", ".rad-control-page-dimmer-menu", evt =>
            {
                evt.preventDefault();
                evt.stopPropagation();

                /* INFO: We're about to close all menus without selecting an option
                   so we need to resolve and null the promise property of each menu
                   in the dimmer
                */
                $$(evt.currentTarget)
                    .children()
                    .each((index, element) =>
                    {
                        var
                            menuItem = $$(element).dataGet("rad-control-menu-item");

                        if (menuItem.openPromise)
                        {
                            menuItem.openPromise.resolve(null);
                            menuItem.openPromise = null;
                        }
                    });

                namespace.Menu.dimmer
                    .hideAllAsync();
            });
        }
    });

    // Menu
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "Menu",
        inherits: "MenuItem",
        properties: [
            { name: "visibleMenuItemCount", type: "int" }
        ],
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-menu");
                this.detach();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _bindMenuItemVisibilityUpdated: function (menuItem)
                {
                    if (!menuItem)
                        return;

                    menuItem.on("isVisibleChanged", { self: this }, this.onMenuItemIsVisibleChanged);
                    this._updateVisibleMenuItemCount();
                },
                _unBindMenuItemVisibilityUpdated: function (menuItem)
                {
                    if (!menuItem)
                        return;

                    menuItem.off("isVisibleChanged", { self: this }, this.onMenuItemIsVisibleChanged);
                },
                _updateVisibleMenuItemCount: function ()
                {
                    this.visibleMenuItemCountSet(
                        this.controlsGet()
                            .count(item => item.isVisibleGet())
                    );
                },
                _visibleMenuItemCountChanged: function (change)
                {
                    this.triggerHandler("visibleMenuItemCountChanged", change);
                },

                // Public Methods
                append: function (menuItem)
                {
                    this._bindMenuItemVisibilityUpdated(menuItem);
                    var result = this.super.append(menuItem);
                    this._updateVisibleMenuItemCount();
                    return result;
                },
                clear: function ()
                {
                    var
                        self = this;

                    self.controlsGet()
                        .each(item => { self._unBindMenuItemVisibilityUpdated(item); });

                    var result = self.super.clear();
                    self._updateVisibleMenuItemCount();
                    return result;
                },
                prepend: function (menuItem)
                {
                    this._bindMenuItemVisibilityUpdated(menuItem);
                    var result = this.super.prepend(menuItem);
                    this._updateVisibleMenuItemCount();
                    return result;
                },
                remove: function (menuItem)
                {
                    this._unBindMenuItemVisibilityUpdated(menuItem);
                    this.super.remove(menuItem);
                    this._updateVisibleMenuItemCount();
                },

                // Event Handlers
                onMenuItemIsVisibleChanged: function (evt, change)
                {
                    evt.data.self._updateVisibleMenuItemCount();
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.allowedChildControlClasses = [
                "seriouslyrad.ui.web.MenuItem"
            ];

            $$(() =>
            {
                classConstructor.dimmer = new namespace.PageDimmer({ animationIn: "scale in", animationOut: "scale out", cssClass: "rad-control-page-dimmer-menu", repositionChildren: true });
            });

            $$(document).on("seriouslyrad.ui.PageManager:beforeInitialize", (evt, pageManager) =>
            {
                pageManager.registerBlockNavigationFunction(() =>
                {
                    return classConstructor.dimmer?.shown();
                });
            });
        }
    });

    // Toolbar
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "Toolbar",
        inherits: "ContainerControl",
        properties: [
            { name: "colorInverted", type: "boolean" },
            { name: "showLabels", type: "boolean" },
            { name: "scrollable", type: "boolean" }
        ],
        propertyAttributes: [
            {
                propertyName: "showLabels",
                designer: {
                    category: "Appearance",
                    displayName: "Show Labels"
                }
            }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                colorInverted: false,
                showLabels: false
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-toolbar ui icon");

                // Trigger Property Changes
                this.colorInvertedTriggerChange();
                this.showLabelsTriggerChange();
                this.scrollableTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _colorInvertedChanged: function (change)
                {
                    if (change.currentValue)
                        this.addCssClass("rad-state-color-inverted");
                    else
                        this.removeCssClass("rad-state-color-inverted");
                },
                _showLabelsChanged: function (change)
                {
                    if (change.currentValue)
                        this.addCssClass("rad-style-show-labels");
                    else
                        this.removeCssClass("rad-style-show-labels");
                },
                _scrollableChanged: function (change)
                {
                    if (change.currentValue)
                        this.addCssClass("rad-style-scrollable");
                    else
                        this.removeCssClass("rad-style-scrollable");
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.allowedChildControlClasses = [
                "seriouslyrad.ui.web.ToolbarItem"
            ];
        }
    });

    // Toolbar Item
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "ToolbarItem",
        inherits: "Control",
        abstract: true,
        properties: [
            { name: "dividing", type: "boolean" },
            { name: "showLabel", type: "boolean" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                dividing: true,
                showLabel: false
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-toolbar-item");

                // Trigger Property Changes
                this.dividingTriggerChange();
                this.showLabelTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _createElement: function ()
                {
                    this.super._createElement();

                    this.$$containerElement = $$.create$$("span", "rad-container").appendTo(this.$$elementGet());
                },
                _dividingChanged: function (change)
                {
                    if (change.currentValue)
                        this.addCssClass("rad-style-dividing");
                    else
                        this.removeCssClass("rad-style-dividing");
                },
                _showLabelChanged: function (change)
                {
                    if (change.currentValue)
                        this.addCssClass("rad-style-show-label");
                    else
                        this.removeCssClass("rad-style-show-label");
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.allowedParentControlClasses = [
                "seriouslyrad.ui.web.Toolbar"];
        }
    });

    // Toolbar Image
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "ToolbarImage",
        inherits: "ToolbarItem",
        properties: [
            { name: "image", type: "string" }
        ],
        propertyAttributes: [
            {
                propertyName: "image",
                designer: {
                    category: "Appearance",
                    displayName: "Image"
                }
            }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                elementType: "a"
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-toolbar-image");

                // Trigger Property Changes
                this.imageTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _createElement: function ()
                {
                    this.super._createElement();

                    this.$$imageElement =
                        $$.create$$({ nodeName: "img" })
                            .hide()
                            .appendTo(this.$$containerElement);
                },
                _imageChanged: function (change)
                {
                    if (change.currentValue)
                        this.$$imageElement.attr("src", change.currentValue).show();
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.allowedParentControlClasses = [
                "seriouslyrad.ui.web.Toolbar"];
            classConstructor.modes = {
                normal: "normal",
                toggle: "toggle"
            };
        }
    });

    // Toolbar Button
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "ToolbarButton",
        inherits: "ToolbarItem",
        mixins: [
            "ActionButtonMixin"
        ],
        properties: [
            { name: "alertCount", type: "int" },
            { name: "icon", type: "string" },
            { name: "iconInline", type: "boolean" },
            { name: "image", type: "string" },
            { name: "mode", type: "string" },
            { name: "showAlert", type: "boolean" },
            { name: "state", type: "boolean" },
            { name: "svgKey", type: "string" },
            { name: "toggleGroup", type: "string" },
            { name: "toggleGroupSelectionMandatory", type: "boolean" }
        ],
        propertyAttributes: [
            {
                propertyName: "icon",
                designer: {
                    category: "Appearance",
                    displayName: "Icon"
                }
            },
            {
                propertyName: "image",
                designer: {
                    category: "Appearance",
                    displayName: "Image"
                }
            },
            {
                propertyName: "mode",
                designer: {
                    category: "Behavior",
                    displayName: "Mode"
                }
            }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                elementType: "a",
                mode: namespace.ToolbarButton.modes.normal,
                state: false
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-toolbar-button");

                this._applyActionButtonProperties();

                // Trigger Property Changes
                this.alertCountTriggerChange();
                this.iconInlineTriggerChange();
                this.iconTriggerChange();
                this.imageTriggerChange();
                this.showAlertTriggerChange();
                this.textTriggerChange();
                this.stateTriggerChange();
                this.svgKeyTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _alertCountChanged: function (change)
                {
                    if (change.currentValue !== null)
                        this.$$alert.text(change.currentValue < 0 ? "0" : change.currentValue > 99 ? "99+" : change.currentValue.toString());
                    else
                        this.$$alert.text("!");

                    if (change.currentValue !== null && change.currentValue > (change.originalValue ? change.originalValue : 0))
                        this._pulseAlert();
                },
                _bindEvents: function ()
                {
                    this.super._bindEvents();
                    this.on("mousedown touchstart", { self: this }, evt => { evt.stopPropagation(); });
                },
                _createElement: function ()
                {
                    this.super._createElement();

                    var
                        $$element = this.$$elementGet();

                    this.$$svgWrapper = $$.create$$("span", "rad-svg-wrapper").hide().appendTo(this.$$containerElement);
                    this.$$imageElement = $$.create$$("img").hide().appendTo(this.$$containerElement);
                    this.$$iconElement = $$.create$$("i", "icon").hide().appendTo(this.$$containerElement);
                    this.$$textElement = $$.create$$("span", "rad-text").appendTo(this.$$containerElement);

                    this.$$alert = $$.create$$("span", "rad-alert").appendTo($$element);
                },
                _iconChanged: function (change)
                {
                    var
                        $$iconElement = this.$$iconElement;

                    if (change.originalValue)
                        $$iconElement.removeClass(change.originalValue);

                    if (change.currentValue)
                    {
                        $$iconElement.addClass(change.currentValue);
                        $$iconElement.show();
                    }
                    else
                        $$iconElement.hide();
                },
                _iconInlineChanged: function (change)
                {
                    if (change.currentValue)
                        this.addCssClass("rad-style-icon-inline");
                    else
                        this.removeCssClass("rad-style-icon-inline");
                },
                _imageChanged: function (change)
                {
                    if (change.currentValue)
                        this.$$imageElement.attr("src", change.currentValue.startsWith("/") ? String.format("{0}{1}", window.applicationInformation.virtualDirectory, change.currentValue.substr(1)) : change.currentValue).show();
                    else
                        this.$$imageElement.hide();
                },
                _pulseAlert: function ()
                {
                    this.$$alert.transition("flash");
                },
                _showAlertChanged: function (change)
                {
                    if (change.currentValue)
                        this.$$alert.css({ display: "block" });
                    else
                        this.$$alert.css({ display: "none" });
                },
                _stateChanged: function (change)
                {
                    var
                        self = this,
                        toggleGroup = self.toggleGroupGet(),
                        toolbar;

                    if (change.currentValue && toggleGroup)
                    {
                        toolbar = self.parentControlGet();

                        if (toolbar)
                        {
                            toolbar.controlsGet()
                                .where(item =>
                                {
                                    return (
                                        item !== self
                                        && item instanceof namespace.ToolbarButton
                                        && item.modeGet() === namespace.ToolbarButton.modes.toggle
                                        && item.toggleGroupGet() === toggleGroup
                                    );
                                })
                                .each(item => { item.stateSet(false); });
                        }
                    }

                    if (change.currentValue)
                        self.addCssClass("rad-state-on");
                    else
                        self.removeCssClass("rad-state-on");

                    self.triggerHandler("stateChanged", change);
                },
                _svgKeyChanged: function (change)
                {
                    if (change.currentValue)
                    {
                        this.$$svgWrapper.empty();
                        this.$$svgWrapper.append(window.svgHelper.createSvg(change.currentValue)).show();
                    }
                    else
                        this.$$svgWrapper.hide();
                },
                _textChanged: function (change)
                {
                    this.super._textChanged(change);
                    this.$$textElement.text(change.currentValue);

                    if (change.currentValue)
                        this.$$elementGet().attr("title", change.currentValue);
                    else
                        this.$$elementGet().removeAttr("title");
                },

                // Public Methods

                // Event Handlers
                onClick: function (evt)
                {
                    var
                        self = evt.data.self;

                    self.focus(); // Ensure button has focus (causes other changed events to fire)

                    self._processActionButtonClick(evt);

                    if (self.modeGet() === namespace.ToolbarButton.modes.toggle)
                    {
                        if (!self.toggleGroupSelectionMandatoryGet() || !self.stateGet())
                            self.stateSet(!self.stateGet());
                    }
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.allowedParentControlClasses = [
                "seriouslyrad.ui.web.Toolbar"];
            classConstructor.modes = {
                normal: "normal",
                toggle: "toggle"
            };
        }
    });

    // Toolbar Combo Box
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "ToolbarComboBox",
        inherits: "ToolbarItem",
        mixins: [
            "PropertyBoundControlMixin"
        ],
        properties: [
            { name: "allowEmptySelection", type: "boolean" },
            { name: "listDataSource" },
            { name: "listDataSourceValueProperty", type: "string" },
            { name: "listDataSourceDescriptionProperty", type: "string" },
            { name: "placeholder", type: "string" }
        ],
        propertyAttributes: [
            {
                propertyName: "listDataSource",
                designer: {
                    category: "Data",
                    displayName: "List Data Source"
                }
            },
            {
                propertyName: "listDataSourceValueProperty",
                designer: {
                    category: "Data",
                    displayName: "List Data Source Value Property"
                }
            },
            {
                propertyName: "listDataSourceDescriptionProperty",
                designer: {
                    category: "Data",
                    displayName: "List Data Source Description Property"
                }
            },
            {
                propertyName: "placeholder",
                designer: {
                    category: "Appearance",
                    displayName: "Placeholder"
                }
            }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                listDataSourceValueProperty: "value",
                listDataSourceDescriptionProperty: "description"
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-toolbar-combo-box item");

                // Trigger Property Changes
                this.allowEmptySelectionTriggerChange();
                this.listDataSourceValuePropertyTriggerChange();
                this.listDataSourceDescriptionPropertyTriggerChange();
                this.listDataSourceTriggerChange();
                this.placeholderTriggerChange();
            };
        },
        createPrototype: function(namespace)
        {
            return {
                // "Protected" Methods
                _allowEmptySelectionChanged: function (change)
                {
                    this.comboBox.allowEmptySelectionSet(change.currentValue);
                },
                _bindEvents: function ()
                {
                    this.super._bindEvents();

                    this.on("valueChanged", { self: this }, this.onValueChanged);
                    this.comboBox.on("valueChanged", { self: this }, this.onComboBoxValueChanged);
                },
                _createElement: function ()
                {
                    this.super._createElement();

                    this.comboBox = new namespace.ComboBox({ inline: true });
                    this.comboBox.$$elementGet().appendTo(this.$$containerElement);

                    this.label = new namespace.Label({ colon: false, associatedControl: this.comboBox });
                    this.label.$$elementGet().prependTo(this.$$containerElement);
                },
                _enabledChanged: function (change)
                {
                    this.comboBox.enabledSet(change.currentValue);
                },
                _listDataSourceChanged: function (change)
                {
                    this.comboBox.listDataSourceSet(change.currentValue);
                },
                _listDataSourceValuePropertyChanged: function (change)
                {
                    this.comboBox.listDataSourceValuePropertySet(change.currentValue);
                },
                _listDataSourceDescriptionPropertyChanged: function (change)
                {
                    this.comboBox.listDataSourceDescriptionPropertySet(change.currentValue);
                },
                _placeholderChanged: function (change)
                {
                    this.comboBox.placeholderSet(change.currentValue);
                },
                _textChanged: function (change)
                {
                    this.super._textChanged(change);
                    this.label.textSet(change.currentValue);
                },

                // Event Handlers
                onComboBoxValueChanged: function (evt, change)
                {
                    var
                        self = evt.data.self;

                    if (self._comboBoxChanging)
                        return;

                    self._comboBoxChanging = true;
                    self.valueSet(change.currentValue);
                    self._comboBoxChanging = false;
                },
                onValueChanged: function (evt, change)
                {
                    var
                        self = evt.data.self;

                    if (!self._comboBoxChanging)
                        self.comboBox.valueSet(change.currentValue);
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.allowedParentControlClasses = [
                "seriouslyrad.ui.web.Toolbar"];
        }
    });

    // Toolbar Menu
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "ToolbarMenu",
        inherits: "ToolbarButton",
        properties: [
            { name: "menu" }
        ],
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-toolbar-menu");

                // Trigger Property Changes
                this.menuTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _createElement: function ()
                {
                    this.super._createElement();

                    var
                        $$element = this.$$elementGet(),
                        $$menu = $$element.find(">[data-control-class]"),
                        menu;

                    if ($$menu.length > 1)
                        console.error("Only one child control of type Menu is supported.");

                    if ($$menu.length)
                    {
                        menu = namespace.Control.createFromElement($$menu);

                        if (!menu)
                            console.error("Menu could not be created.");

                        if (!(menu instanceof namespace.Menu))
                            console.error("Only type Menu is supported.");

                        menu.detach();
                        this.menuSet(menu);
                    }
                },

                // Public Methods
                openMenuAsync: function ()
                {
                    var
                        self = this,
                        menu = self.menuGet();

                    if (!menu)
                        return Promise.resolve();

                    return (
                        menu.openAsync()
                            .then(menuItem =>
                            {
                                self.triggerHandler("menuItemClicked", menuItem);
                            })
                    );
                },

                // Event Handlers
                onClick: function (evt)
                {
                    this.super.onClick(evt);

                    evt.preventDefault();

                    evt.data.self.openMenuAsync();
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.allowedParentControlClasses = [
                "seriouslyrad.ui.web.Toolbar"];
        }
    });

    // Toolbar Splitter
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "ToolbarSplitter",
        inherits: "ToolbarItem",
        createPropertyDefaults: namespace =>
        {
            return {
                elementType: "span"
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-toolbar-splitter");
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _createElement: function ()
                {
                    this.super._createElement();

                    this.$$span = $$.create$$({
                        nodeName: "span"
                    });

                    this.$$containerElement.append(this.$$span);
                },
                _textChanged: function (change)
                {
                    this.super._textChanged(change);
                    this.$$span.text(change.currentValue);
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.allowedParentControlClasses = [
                "seriouslyrad.ui.web.Toolbar"];
        }
    });

    // Toolbar Text Box
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "ToolbarTextBox",
        inherits: "ToolbarItem",
        mixins: [
            "PropertyBoundControlMixin"
        ],
        properties: [
            { name: "placeholder", type: "string" },
            { name: "textBoxProperties" }
        ],
        propertyAttributes: [
            {
                propertyName: "placeholder",
                designer: {
                    category: "Appearance",
                    displayName: "Placeholder"
                }
            }
        ],
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-toolbar-text-box item");

                // Trigger Property Changes
                this.placeholderTriggerChange();
            };
        },
        createPrototype: function(namespace)
        {
            return {
                // "Protected" Methods
                _bindEvents: function ()
                {
                    this.super._bindEvents();

                    this.on("valueChanged", { self: this }, this.onValueChanged);
                    this.textBox.on("valueChanged", { self: this }, this.onTextBoxValueChanged);
                },
                _createElement: function ()
                {
                    this.super._createElement();

                    var
                        textBoxProperties = this.textBoxPropertiesGet() || {};

                    textBoxProperties.inline = true;

                    this.textBox = new namespace.TextBox(textBoxProperties);
                    this.textBox.$$elementGet().appendTo(this.$$containerElement);

                    this.label = new namespace.Label({ colon: false, associatedControl: this.textBox });
                    this.label.$$elementGet().prependTo(this.$$containerElement);
                },
                _enabledChanged: function (change)
                {
                    this.textBox.enabledSet(change.currentValue);
                },
                _placeholderChanged: function (change)
                {
                    this.textBox.placeholderSet(change.currentValue);
                },
                _textChanged: function (change)
                {
                    this.super._textChanged(change);
                    this.label.textSet(change.currentValue);
                },

                // Event Handlers
                onTextBoxValueChanged: function (evt, change)
                {
                    var
                        self = evt.data.self;

                    if (self._textBoxChanging)
                        return;

                    self._textBoxChanging = true;
                    self.valueSet(change.currentValue);
                    self._textBoxChanging = false;
                },
                onValueChanged: function (evt, change)
                {
                    var
                        self = evt.data.self;

                    if (!self._textBoxChanging)
                        self.textBox.valueSet(change.currentValue);
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.allowedParentControlClasses = [
                "seriouslyrad.ui.web.Toolbar"];
        }
    });

    // Window Header
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "WindowHeader",
        inherits: "ContainerControl",
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-window-header ui fixed inverted main menu");
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _addScrollbarPadding: function ()
                {
                    this.$$elementGet().css({
                        paddingRight: window.pageManager.scrollBarDimensionsGet().width + "px"
                    });
                },
                _createContainerElement: function ()
                {
                    var
                        self = this,
                        $$element = self.$$elementGet(),
                        $$containerElement = $$.create$$("div", "ui container fluid").appendTo($$element);

                    self.$$containerElementSet($$containerElement);

                    $$(document).on("seriouslyrad.ui.Application:Ready", () =>
                    {
                        self._addScrollbarPadding();
                    });
                },
                _removeScrollbarPadding: function ()
                {
                    this.$$elementGet().css({
                        paddingRight: String.empty
                    });
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            $$(() =>
            {
                var
                    $$windowHeader = $$(".rad-control-window-header");

                if ($$windowHeader.length === 0)
                    return;

                if ($$windowHeader.length > 1)
                    console.error("Only one window header is supported.");

                classConstructor.instance = namespace.Control.createFromElement($$windowHeader);
            });
        }
    });

    // #endregion

    // #region Entity Set Controls

    // Entity Set Control
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "EntitySetControl",
        inherits: "Control",
        abstract: true
    });

    // Team Entity Property Permissions Control
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "TeamEntityPropertyPermissions",
        inherits: "EntitySetControl",
        properties: [
            { name: "editMode", type: "boolean" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                editMode: false
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-team-entity-property-permissions");
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _bindEvents: function ()
                {
                    this.super._bindEvents();

                    this.toolbarButtonEdit.on("click", { self: this }, this.onToolbarButtonEditClicked);
                    this.toolbarButtonSave.on("click", { self: this }, this.onToolbarButtonSaveClicked);
                },
                _createElement: function ()
                {
                    this.super._createElement();

                    var
                        $$element = this.$$elementGet();

                    this.toolbar =
                        new seriouslyrad.ui.web.Toolbar()
                        .appendTo($$element);

                    this.toolbarButtonSave =
                        new seriouslyrad.ui.web.ToolbarButton({ icon: "save", text: "Save" })
                        .appendTo(this.toolbar);

                    this.toolbarButtonEdit =
                        new seriouslyrad.ui.web.ToolbarButton({ icon: "edit", text: "Edit" })
                        .appendTo(this.toolbar);

                    this.panelContainer =
                        new seriouslyrad.ui.web.Panel({ cssClass: "rad-container" })
                        .appendTo($$element);
                },
                _createPropertyEditors: function (entityProperties, permissions, teamEntityPropertyPermissions)
                {
                    var
                        self = this,
                        teamEntityPermissionId = self.pageGet().dataSourceGet().propertyValueByPathGet("id");

                    self.panelContainer.controlsClear();

                    entityProperties.each(item =>
                    {
                        new seriouslyrad.ui.web.PropertyEditorCheckBoxListPermissionEntityProperty({
                            dataSource: { teamEntityPermissionId: teamEntityPermissionId, entityPropertyId: item.id, permission: null },
                            dataSourceProperty: "permission",
                            propertyDisplayName: item.displayName,
                            editorControlProperties: {
                                listDataSourceValueProperty: "value",
                                listDataSource: permissions
                            }
                        })
                        .appendTo(self.panelContainer);
                    });

                    self._populatePropertyEditors(teamEntityPropertyPermissions);
                },
                _dataSourceChanged: function (change)
                {
                    var
                        self = this;

                    self.panelContainer.controlsClear();

                    if (change.currentValue)
                    {
                        self._loadDataAsync()
                            .then(result =>
                            {
                                const
                                    properties = result[0],
                                    permissions = result[1],
                                    teamEntityPropertyPermissions = result[2];

                                self._createPropertyEditors(properties, permissions, teamEntityPropertyPermissions);
                            });
                    }
                },
                _loadDataAsync: function ()
                {
                    return new Promise((resolve, reject) =>
                    {
                        var
                            requests = [];

                        requests.push(
                            window.application.webApiClient
                                .createEntitySearchRequest(
                                    "EntityProperties",
                                    new seriouslyrad.ComparisonExpression({
                                        path: "entityId",
                                        value: this.dataSourceGet().propertyValueByPathGet("entityId")
                                    }),
                                    "displayName",
                                    ["id", "rowVersion", "name", "displayName"]
                                )
                                .executeAsync(),
                            window.application.webApiClient
                                .createApiMethodRequest("DataService", "CallDataService", { id: "48f9aaee-42b3-4315-a1df-7276230deb2a" })
                                .executeAsync(),
                            window.application.webApiClient
                                .createEntitySearchRequest(
                                    "TeamEntityPropertyPermissions",
                                    new seriouslyrad.ComparisonExpression({
                                        path: "teamEntityPermissionId",
                                        value: this.dataSourceGet().propertyValueByPathGet("Id")
                                    }),
                                    null,
                                    ["id", "rowVersion", "teamEntityPermissionId", "entityPropertyId", "permission"]
                                )
                                .executeAsync()
                        );

                        Promise.all(requests)
                            .then(results =>
                            {
                                resolve([results[0][0], results[1], results[2]]);
                            })
                            .catch(error =>
                            {
                                reject(error);
                            });
                    });
                },
                _populatePropertyEditors: function (teamEntityPropertyPermissions)
                {
                    teamEntityPropertyPermissions.each(item => { console.log(item); });
                },

                // Public Methods

                // Event Handlers
                onToolbarButtonEditClicked: function (evt)
                {
                    var
                        self = evt.data.self,
                        editMode = !self.editModeGet();

                    self.toolbarButtonEdit.enabledSet(false);

                    self.editModeSet(editMode);

                    self._loadDataAsync()
                        .then(result =>
                        {
                            const
                                properties = result[0],
                                permissions = result[1],
                                teamEntityPropertyPermissions = result[2];

                            self._createPropertyEditors(properties, permissions, teamEntityPropertyPermissions);
                            self.panelContainer.controlsGet().each(item => { item.editModeSet(editMode); });
                            self.toolbarButtonEdit.enabledSet(true);
                        });
                },
                onToolbarButtonSaveClicked: function (evt)
                {
                    var
                        self = evt.data.self,
                        requests = [];

                    self.panelContainer.controlsGet().each(item =>
                    {
                        requests.push(
                            window.application.webApiClient
                                .createEntitySaveRequest("TeamEntityPropertyPermissions", item, originalRecord)
                                .executeAsync()
                        );
                    });

                    window.fullPageLoader.enqueue();

                    Promise.all(requests)
                        .finally(() =>
                        {
                            window.fullPageLoader.dequeue();
                        });
                }
            };
        }
    });

    // #endregion

    // #region Multi Factor Login Controls

    // Multi Factor Login
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "MfaLogin",
        inherits: "Panel",
        abstract: true,
        properties: [
            { name: "mode", type: "string" },
            { name: "mfaProviderId", type: "string" },
            { name: "shownInDialog", type: "boolean" },
        ],
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _triggerCancel: function ()
                {
                    this.triggerHandler("cancel");
                },
                _triggerClose: function ()
                {
                    this.triggerHandler("close");
                },
                _triggerLogin: function (authenticationData, setupData)
                {
                    this.triggerHandler(
                        "login",
                        {
                            mfaProviderId: this.mfaProviderIdGet(),
                            authenticationData: authenticationData,
                            setupData: setupData
                        }
                    );
                },
                _triggerResetValidation: function ()
                {
                    this.triggerHandler("resetValidation");
                },
                _triggerTitleChange: function (title)
                {
                    this.triggerHandler("titleChange", { title: title });
                },
                _triggerValidationFailed: function (errorMessages)
                {
                    this.triggerHandler("validationFailed", { errorMessages: errorMessages });
                },

                // Public Methods
                back: function ()
                {
                    this._triggerCancel();
                },
                loginFailed: function (reason, additionalData)
                {
                    return {
                        handled: false,
                        reason: reason,
                        additionalData: additionalData
                    };
                },
                loginSuccessful: function (mfaRecoveryCodes)
                {
                    return {
                        handled: false,
                        mfaRecoveryCodes: mfaRecoveryCodes
                    };
                }
            };
        }
    });

    // Multi Factor Login (Authenticator App Provider)
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "AuthenticatorAppProviderLogin",
        inherits: "MfaLogin",
        properties: [
            { name: "numberOfDigits", type: "int" },
            { name: "recoveryCodeInstructions", type: "string" },
            { name: "setupChallengeInstructions", type: "string" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                mode: namespace.AuthenticatorAppProviderLogin.modes.request,
                mfaProviderId: "a54bd15c-402d-4394-93c5-2b7af35a826d",
                numberOfDigits: 6,
                recoveryCodeInstructions: "Here are your 2FA recovery codes. They can be used to give you access to the application should you become unable to access your authenticator app.",
                setupChallengeInstructions: "Scan the QR code below or copy and paste the code into your favourite authenticator app, then enter the resulting code below."
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                // Trigger Property Changes
                this.modeTriggerChange();
                this.recoveryCodeInstructionsTriggerChange();
                this.setupChallengeInstructionsTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _bindEvents: function ()
                {
                    this.super._bindEvents();

                    // Request
                    this.linkRecovery.on("click", { self: this }, this.onLinkRecoveryClicked);
                    this.buttonLoginWith.on("click", { self: this }, this.onButtonLoginWithClicked);
                    this.buttonCodeBack.on("click", { self: this }, this.onBackButtonClicked);

                    // Recovery
                    this.buttonRecover.on("click", { self: this }, this.onButtonRecoverClicked);
                    this.buttonRecoveryBack.on("click", { self: this }, this.onBackButtonClicked);

                    // Setup Challenge
                    this.buttonCopySetupChallengeKey.on("click", { self: this }, this.onButtonCopySetupChallengeKeyClicked);
                    this.buttonSetupChallenge.on("click", { self: this }, this.onButtonSetupChallengeClicked);
                    this.buttonSetupChallengeBack.on("click", { self: this }, this.onBackButtonClicked);

                    // Recovery Code
                    this.buttonCopyRecoveryCodes.on("click", { self: this }, this.onbuttonCopyRecoveryCodesClicked);
                    this.buttonSetupClose.on("click", { self: this }, this.onButtonSetupCloseClicked);

                    this.multiDigitCodeAuthenticationCode.on("keyup", { self: this, clickTarget: this.buttonLoginWith }, this.onTextBoxKeyUp);
                    this.textboxRecoveryCode.on("keyup", { self: this, clickTarget: this.buttonRecover }, this.onTextBoxKeyUp);
                    this.multiDigitCodeSetupChallengeAuthenticationCode.on("keyup", { self: this, clickTarget: this.buttonSetup }, this.onTextBoxKeyUp);
                },
                _createElement: function ()
                {
                    this.super._createElement();

                    var
                        numberOfDigits = this.numberOfDigitsGet();

                    // #region Request

                    this.panelRequest = new namespace.Panel({ visible: false });
                    this.panelRequest.appendTo(this);

                    this.multiDigitCodeAuthenticationCode = new namespace.MultiDigitCode({ mandatory: true, numberOfDigits: numberOfDigits });
                    new namespace.Label({ text: "Enter code from your authenticator app", minWidth: 100, associatedControl: this.multiDigitCodeAuthenticationCode }).appendTo(this.panelRequest);
                    this.multiDigitCodeAuthenticationCode.appendTo(this.panelRequest);

                    this.linkRecovery = new namespace.Link({ text: "Use Recovery Code" });
                    this.linkRecovery.appendTo(this.panelRequest);

                    this.panelRequestButtons = new namespace.Panel({ cssClass: "rad-login-buttons" });
                    this.panelRequestButtons.appendTo(this.panelRequest);

                    this.buttonCodeBack = new namespace.Button({ cssClass: "negative", inline: true, text: "Back" });
                    this.buttonCodeBack.appendTo(this.panelRequestButtons);

                    this.buttonLoginWith = new namespace.Button({ cssClass: "positive", inline: true, text: "Login" });
                    this.buttonLoginWith.appendTo(this.panelRequestButtons);

                    // #endregion

                    // #region Recovery

                    this.panelRecovery = new namespace.Panel({ visible: false });
                    this.panelRecovery.appendTo(this);

                    this.propertyEditorRecoveryCode =
                        new namespace.PropertyEditorTextBox({
                            cssClass: "last",
                            editMode: true,
                            mandatory: true,
                            propertyDisplayName: "Recovery Code"
                        }).appendTo(this.panelRecovery);

                    this.textboxRecoveryCode = this.propertyEditorRecoveryCode.editorControlGet();

                    this.panelRecoveryButtons = new namespace.Panel({ cssClass: "rad-login-buttons" });
                    this.panelRecoveryButtons.appendTo(this.panelRecovery);

                    this.buttonRecoveryBack = new namespace.Button({ cssClass: "negative", inline: true, text: "Back" });
                    this.buttonRecoveryBack.appendTo(this.panelRecoveryButtons);

                    this.buttonRecover = new namespace.Button({ cssClass: "positive", inline: true, text: "Login" });
                    this.buttonRecover.appendTo(this.panelRecoveryButtons);

                    // #endregion

                    // #region Setup Challenge

                    this.panelSetupChallenge = new namespace.Panel({ visible: false });
                    this.panelSetupChallenge.appendTo(this);

                    this.textSetupChallengeInstructions = new namespace.Text({ cssClass: "rad-control-text-instructions" });
                    this.textSetupChallengeInstructions.appendTo(this.panelSetupChallenge);

                    this.panelQrCode = new namespace.Panel({ cssClass: "rad-control-panel-qr-code" });
                    new namespace.Label({ text: "Scan code", minWidth: 100, associatedControl: this.panelQrCode }).appendTo(this.panelSetupChallenge);
                    this.panelQrCode.appendTo(this.panelSetupChallenge);

                    this.textSetupChallengeKey = new namespace.Text({ cssClass: "rad-control-text-mfa-key rad-control-text-with-copy-button" });
                    new namespace.Label({ text: "Or, enter manually", minWidth: 100, associatedControl: this.textSetupChallengeKey }).appendTo(this.panelSetupChallenge);
                    this.textSetupChallengeKey.appendTo(this.panelSetupChallenge);

                    this.buttonCopySetupChallengeKey = new namespace.Button({ cssClass: "action compact", inline: true, icon: "copy", showLabel: false });
                    this.buttonCopySetupChallengeKey.appendTo(this.textSetupChallengeKey.$$elementGet());

                    this.multiDigitCodeSetupChallengeAuthenticationCode = new namespace.MultiDigitCode({ mandatory: true, numberOfDigits: numberOfDigits });
                    new namespace.Label({ text: "Then, enter code from your authenticator app", minWidth: 100, associatedControl: this.multiDigitCodeSetupChallengeAuthenticationCode }).appendTo(this.panelSetupChallenge);
                    this.multiDigitCodeSetupChallengeAuthenticationCode.appendTo(this.panelSetupChallenge);

                    this.panelSetupChallengeButtons = new namespace.Panel({ cssClass: "rad-login-buttons" });
                    this.panelSetupChallengeButtons.appendTo(this.panelSetupChallenge);

                    this.buttonSetupChallengeBack = new namespace.Button({ cssClass: "negative", inline: true, text: "Back" });
                    this.buttonSetupChallengeBack.appendTo(this.panelSetupChallengeButtons);

                    this.buttonSetupChallenge = new namespace.Button({ cssClass: "positive", inline: true, text: "Finish" });
                    this.buttonSetupChallenge.appendTo(this.panelSetupChallengeButtons);

                    // #endregion

                    // #region Recovery Code

                    this.panelRecoveryCode = new namespace.Panel({ visible: false });
                    this.panelRecoveryCode.appendTo(this);

                    this.textRecoveryCodeInstructions = new namespace.Text({ cssClass: "rad-control-text-instructions" });
                    this.textRecoveryCodeInstructions.appendTo(this.panelRecoveryCode);

                    this.textRecoveryCodes = new namespace.Text({ cssClass: "rad-control-text-mfa-recover-code rad-control-text-with-copy-button", preserveLineBreaks: true });
                    new namespace.Label({ text: "Recovery Codes", minWidth: 100, associatedControl: this.textRecoveryCodes }).appendTo(this.panelRecoveryCode);
                    this.textRecoveryCodes.appendTo(this.panelRecoveryCode);

                    this.buttonCopyRecoveryCodes = new namespace.Button({ cssClass: "action compact", inline: true, icon: "copy", showLabel: false });
                    this.buttonCopyRecoveryCodes.appendTo(this.textRecoveryCodes.$$elementGet());

                    this.panelRecoveryCodeButtons = new namespace.Panel({ cssClass: "rad-login-buttons" });
                    this.panelRecoveryCodeButtons.appendTo(this.panelRecoveryCode);

                    // "Dummy" button
                    this.buttonSetupCloseBack = new namespace.Button();
                    this.buttonSetupCloseBack.$$elementGet().css({ visibility: "hidden" });
                    this.buttonSetupCloseBack.appendTo(this.panelRecoveryCodeButtons);

                    this.buttonSetupClose = new namespace.Button({ cssClass: "positive", inline: true, text: "Close" });
                    this.buttonSetupClose.appendTo(this.panelRecoveryCodeButtons);

                    // #endregion
                },
                _createQrCode: function (url)
                {
                    var
                        $$panelQrCode = this.panelQrCode.$$elementGet(),
                        size = 256;

                    $$panelQrCode.empty();
                    $$panelQrCode.css({ height: size, width: size });

                    if ($$panelQrCode?.length)
                    {
                        const
                            $$canvas = $$.create$$("canvas").appendTo($$panelQrCode);

                        new QRious({
                            background: "#ffffff",
                            backgroundAlpha: 1,
                            element: $$canvas[0],
                            foreground: "#000000",
                            foregroundAlpha: 1,
                            level: "H",
                            padding: 0,
                            size: size,
                            value: url
                        });
                    }
                },
                _hideAllPanels: function ()
                {
                    this.controlsGet()
                        .where(item => item instanceof namespace.Panel)
                        .forEach(item => { item.hide(); });
                },
                _loginAsync: function ()
                {
                    var
                        authenticationData = null,
                        setupData = null,
                        mode = this.modeGet();

                    switch (mode)
                    {
                        case namespace.AuthenticatorAppProviderLogin.modes.recovery:
                            authenticationData = {
                                recoveryCodeEncoded: this.textboxRecoveryCode.valueGet()
                            };
                            break;
                        case namespace.AuthenticatorAppProviderLogin.modes.request:
                            authenticationData = {
                                authenticationCode: parseInt(this.multiDigitCodeAuthenticationCode.valueGet())
                            };
                            break;
                        case namespace.AuthenticatorAppProviderLogin.modes.setupChallenge:
                            setupData = {
                                secretEncoded: this.mfaSetupInformation.secretEncoded,
                                authenticationCode: parseInt(this.multiDigitCodeSetupChallengeAuthenticationCode.valueGet()),
                                recoveryCodeEncoded: this.mfaSetupInformation.recoveryCodeEncoded
                            };
                            break;
                    }

                    return this._triggerLogin(authenticationData, setupData);
                },
                _modeChanged: function (change)
                {
                    this._hideAllPanels();
                    this._triggerResetValidation();

                    switch (change.currentValue)
                    {
                        case namespace.AuthenticatorAppProviderLogin.modes.recovery:
                            this._triggerTitleChange("2FA Recovery");
                            this.textboxRecoveryCode.valueSet(null);
                            this.panelRecovery.show();
                            break;
                        case namespace.AuthenticatorAppProviderLogin.modes.recoveryCodes:
                            this._triggerTitleChange("2FA Recovery Code");
                            this.panelRecoveryCode.show();
                            break;
                        case namespace.AuthenticatorAppProviderLogin.modes.request:
                            this._triggerTitleChange("2FA");
                            this.multiDigitCodeAuthenticationCode.valueSet(null);
                            this.panelRequest.show();
                            break;
                        case namespace.AuthenticatorAppProviderLogin.modes.setupChallenge:
                            this._triggerTitleChange("Setup 2FA");
                            this._createQrCode(this.mfaSetupInformation.url);
                            this.textSetupChallengeKey.valueSet(this.mfaSetupInformation.secretEncoded);
                            this.multiDigitCodeSetupChallengeAuthenticationCode.valueSet(null);
                            this.panelSetupChallenge.show();
                            break;
                    }
                },
                _numberOfDigitsChanged: function (change)
                {
                    this.multiDigitCodeAuthenticationCode.numberOfDigitsSet(change.currentValue);
                    this.multiDigitCodeSetupChallengeAuthenticationCode.numberOfDigitsSet(change.currentValue);
                },
                _recoveryCodeInstructionsChanged: function (change)
                {
                    this.textRecoveryCodeInstructions.valueSet(change.currentValue);
                    this.textRecoveryCodeInstructions.visibleSet(!!(change.currentValue?.length));
                },
                _setupChallengeInstructionsChanged: function (change)
                {
                    this.textSetupChallengeInstructions.valueSet(change.currentValue);
                    this.textSetupChallengeInstructions.visibleSet(!!(change.currentValue?.length));
                },
                _shownInDialogChanged: function (change)
                {
                    this.buttonSetupClose.visibleSet(!change.currentValue);
                },
                _validateRecovery: function ()
                {
                    var
                        recoveryCode = this.textboxRecoveryCode.valueGet(),
                        errorMessages = [];

                    this._validateRecoveryReset();

                    if (!recoveryCode)
                    {
                        errorMessages.push("Recovery Code is required");
                        this.textboxRecoveryCode.errorStateSet(true);
                    }

                    this._triggerValidationFailed(errorMessages);

                    return errorMessages.length === 0;
                },
                _validateRecoveryReset: function ()
                {
                    this.textboxRecoveryCode.errorStateSet(false);
                },
                _validateRequest: function ()
                {
                    var
                        code = this.multiDigitCodeAuthenticationCode.valueGet(),
                        errorMessages = [];

                    this._validateRequestReset();

                    if (!code)
                    {
                        errorMessages.push("Code is required");
                        this.multiDigitCodeAuthenticationCode.errorStateSet(true);
                    }
                    else if (isNaN(parseInt(code)))
                    {
                        errorMessages.push("Code is invalid");
                        this.multiDigitCodeAuthenticationCode.errorStateSet(true);
                    }

                    this._triggerValidationFailed(errorMessages);

                    return errorMessages.length === 0;
                },
                _validateRequestReset: function ()
                {
                    this.multiDigitCodeAuthenticationCode.errorStateSet(false);
                },
                _validateSetupChallenge: function ()
                {
                    var
                        setupCode = this.multiDigitCodeSetupChallengeAuthenticationCode.valueGet(),
                        errorMessages = [];

                    this._validateSetupChallengeReset();

                    if (!setupCode)
                    {
                        errorMessages.push("Code is required");
                        this.multiDigitCodeSetupChallengeAuthenticationCode.errorStateSet(true);
                    }
                    else if (isNaN(parseInt(setupCode)))
                    {
                        errorMessages.push("Code is invalid");
                        this.multiDigitCodeSetupChallengeAuthenticationCode.errorStateSet(true);
                    }

                    this._triggerValidationFailed(errorMessages);

                    return errorMessages.length === 0;
                },
                _validateSetupChallengeReset: function ()
                {
                    this.multiDigitCodeSetupChallengeAuthenticationCode.errorStateSet(false);
                },

                // Public Methods
                back: function ()
                {
                    switch (this.modeGet())
                    {
                        case namespace.AuthenticatorAppProviderLogin.modes.recovery:
                            this.modeSet(namespace.AuthenticatorAppProviderLogin.modes.request);
                            break;
                        case namespace.AuthenticatorAppProviderLogin.modes.recoveryCodes:
                            /* Intentionally empty */
                            break;
                        case namespace.AuthenticatorAppProviderLogin.modes.setupChallenge:
                        case namespace.AuthenticatorAppProviderLogin.modes.request:
                            this._triggerCancel();
                            break;
                    }
                },
                loginFailed: function (reason, data)
                {
                    var
                        result =
                        {
                            handled: false
                        };

                    switch (reason)
                    {
                        case "TotpCodeInvalid":
                            this._validateRequestReset();
                            this.multiDigitCodeAuthenticationCode.errorStateSet(true);
                            this._triggerValidationFailed(["Code is not valid"]);
                            result.handled = true;
                            break;
                        case "TotpCodeRequired":
                            this.modeSet(namespace.AuthenticatorAppProviderLogin.modes.request);
                            result.handled = true;
                            break;
                        case "TotpRecoveryCodeInvalid":
                            this._validateRecoveryReset();
                            this.textboxRecoveryCode.errorStateSet(true);
                            this._triggerValidationFailed(["Recovery Code is not valid"]);
                            result.handled = true;
                            break;
                        case "TotpRecoveryCodeUsed":
                            this._validateRecoveryReset();
                            this.textboxRecoveryCode.errorStateSet(true);
                            this._triggerValidationFailed(["Recovery Code has already been used"]);
                            result.handled = true;
                            break;
                        case "TotpRecoveryRequired":
                            this.modeSet(namespace.AuthenticatorAppProviderLogin.modes.recovery);
                            result.handled = true;
                            break;
                        case "TotpSetupCodeInvalid":
                            this._validateSetupChallengeReset();
                            this.multiDigitCodeSetupChallengeAuthenticationCode.errorStateSet(true);
                            this._triggerValidationFailed(["Code is not valid"]);
                            result.handled = true;
                            break;
                        case "TotpSetupRequired": // Not used (default to challenge)
                        case "TotpSetupChallengeRequired":
                            this.mfaSetupInformation = data;
                            this.modeSet(namespace.AuthenticatorAppProviderLogin.modes.setupChallenge);
                            result.handled = true;
                            break;
                    }

                    return result.handled ? result : this.super.loginFailed(reason);
                },
                loginSuccessful: function (mfaRecoveryCodes)
                {
                    if (Array.isArray(mfaRecoveryCodes) && mfaRecoveryCodes.length)
                    {
                        this.textRecoveryCodes.valueSet(mfaRecoveryCodes.join("\n"));
                        this.modeSet(namespace.AuthenticatorAppProviderLogin.modes.recoveryCodes);

                        return {
                            handled: true
                        };
                    }

                    return this.super.loginSuccessful(mfaRecoveryCodes);
                },

                // Event Handlers
                onBackButtonClicked: function (evt)
                {
                    evt.preventDefault();
                    evt.stopPropagation();
                    evt.data.self.back();
                },
                onButtonLoginWithClicked: function (evt)
                {
                    evt.preventDefault();
                    evt.stopPropagation();

                    if (evt.data.self._validateRequest())
                        evt.data.self._loginAsync();
                },
                onbuttonCopyRecoveryCodesClicked: function (evt)
                {
                    evt.preventDefault();
                    evt.stopPropagation();
                    evt.data.self.textRecoveryCodes.copyValueToClipboard();
                },
                onButtonCopySetupChallengeKeyClicked: function (evt)
                {
                    evt.preventDefault();
                    evt.stopPropagation();
                    evt.data.self.textSetupChallengeKey.copyValueToClipboard();
                },
                onButtonRecoverClicked: function (evt)
                {
                    evt.preventDefault();
                    evt.stopPropagation();

                    if (evt.data.self._validateRecovery())
                        evt.data.self._loginAsync();
                },
                onButtonSetupChallengeClicked: function (evt)
                {
                    evt.preventDefault();
                    evt.stopPropagation();

                    if (evt.data.self._validateSetupChallenge())
                        evt.data.self._loginAsync();
                },
                onButtonSetupCloseClicked: function (evt)
                {
                    evt.preventDefault();
                    evt.stopPropagation();

                    evt.data.self._triggerClose();
                },
                onLinkRecoveryClicked: function (evt)
                {
                    evt.preventDefault();
                    evt.stopPropagation();
                    evt.data.self.modeSet(namespace.AuthenticatorAppProviderLogin.modes.recovery);
                },
                onTextBoxKeyUp: function (evt)
                {
                    if (!evt.data.clickTarget)
                        return;

                    switch (evt.key)
                    {
                        case "Enter":
                            {
                                evt.preventDefault();
                                evt.stopPropagation();
                                evt.data.clickTarget.click();
                                break;
                            }
                    }
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.modes =
            {
                recovery: "recovery",
                recoveryCodes: "recoveryCodes",
                request: "request",
                setupChallenge: "setupChallenge"
            };
        }
    });

    // #endregion

    // #region Evaluator UI

    // Evaluator UI
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "EvaluatorUi",
        inherits: "InputControl",
        abstract: true,
        properties: [
            { name: "registeredEvaluatorUis", type: "array" },
            { name: "title", type: "string" },
            { name: "type", type: "string" }
        ],
        propertyAttributes: [
            {
                propertyName: "title",
                designer: {
                    category: "Appearance",
                    displayName: "Title"
                }
            }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                propagateInputEvents: true
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-evaluator-ui");
                this.typeSet(namespace.EvaluatorUi.getEvaluatorUiRegistration(this[".classDefinition"].classConstructor).dataType);
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _bindEvents: function ()
                {
                    this.super._bindEvents();

                    this.$$grabHandle.on("click", evt =>
                    {
                        evt.preventDefault();
                    });
                },
                _createElement: function ()
                {
                    this.super._createElement();

                    var
                        $$element = this.$$elementGet();

                    this.groupBox =
                        new namespace.GroupBox({ headerAlignment: "center", text: this.titleGet() });

                    this.groupBox
                        .append($$element.children())
                        .appendTo($$element);

                    this.groupBox._createChildControls();
                    this.groupBox.$$containerElementGet().addClass("rad-drag-drop-container");


                    this.$$grabHandle =
                        $$.create$$({
                            nodeName: "div",
                            attributes: { "class": "rad-action-drag" },
                            children: [{
                                nodeName: "i",
                                attributes: { "class": "icon content" }
                            }]
                        }).appendTo($$element);

                    this.$$closeButton =
                        $$.create$$({
                            nodeName: "a",
                            attributes: { "class": "rad-action-close", href: "#" },
                            children: [{
                                nodeName: "i",
                                attributes: { "class": "icon remove" }
                            }]
                        }).appendTo($$element);
                },
                _draggableChanged: function (change)
                {
                    /* INFO: Don't call super
                       this.super._draggableChanged(change); */

                    var
                        $$element = this.$$elementGet();

                    if (this.draggableGet())
                    {
                        window.dragDropManager.createDragDropItems($$element);
                        window.dragDropManager.createDragDropHandles(this.$$grabHandle);
                    }
                    else
                    {
                        if (!this.__isConstructing())
                        {
                            window.dragDropManager.disableDragDropItems($$element);
                            window.dragDropManager.disableDragDropHandles(this.$$grabHandle);
                        }
                    }
                },
                _titleChanged: function (change)
                {
                    this.groupBox.textSet(change.currentValue);
                },

                // Public Methods
                remove: function ()
                {
                    var
                        $$element =
                            this.$$elementGet(),
                        evaluatorTree =
                            $$element
                                .closest(".rad-control-evaluator-tree")
                                .radControl(),
                        evaluatorUiCollection =
                            $$element
                                .parent()
                                .closest(".rad-control-evaluator-ui-collection")
                                .radControl();

                    this.super.remove();

                    if (evaluatorUiCollection)
                        evaluatorUiCollection.updateButtons();

                    if (evaluatorTree)
                        evaluatorTree._elementValueChanged();
                },
                updateEvaluatorTree: function ()
                {
                    var
                        $$element = this.$$elementGet(),
                        evaluatorTree = $$element ? $$element.closest(".rad-control-evaluator-tree").radControl() : null;

                    if (!evaluatorTree)
                        return;

                    evaluatorTree._elementValueChanged();
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            var
                EvaluatorUi = classConstructor;

            EvaluatorUi.registeredEvaluatorUis = [];
            EvaluatorUi.getEvaluatorUiRegistration = classConstructor =>
            {
                return EvaluatorUi.registeredEvaluatorUis.first(item => item.classConstructor === classConstructor);
            };
            EvaluatorUi.fromDataObject = dataObject =>
            {
                var
                    registeredEvaluatorUi = EvaluatorUi.registeredEvaluatorUis.first(item => item.dataType === dataObject.type),
                    evaluator = new registeredEvaluatorUi.classConstructor();

                if (evaluator instanceof namespace.EvaluatorUiWrapper && dataObject.evaluator)
                {
                    evaluator.add(EvaluatorUi.fromDataObject(dataObject.evaluator));
                }
                else if (evaluator instanceof namespace.EvaluatorUiCollection && dataObject.evaluators)
                {
                    dataObject.evaluators.each(item =>
                    {
                        evaluator.add(EvaluatorUi.fromDataObject(item));
                    });
                }

                return evaluator;
            };

            $$(() =>
            {
                $$(document).trigger("seriouslyrad.ui.web.EvaluatorUi:RegisterEvaluatorUis", (name, classConstructor, dataType, type) =>
                {
                    EvaluatorUi.registeredEvaluatorUis.push({ name: name, classConstructor: classConstructor, dataType: dataType, type: type });
                });
            });
        }
    });

    // Evaluator UI Collection
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "EvaluatorUiCollection",
        inherits: "EvaluatorUi",
        abstract: true,
        properties: [
            { name: "singleItem", type: "boolean" }
        ],
        propertyAttributes: [
            {
                propertyName: "singleItem",
                designer: {
                    category: "Behavior",
                    displayName: "Single Item"
                }
            }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                singleItem: false
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-evaluator-ui-collection");
                this.updateButtons();

                window.dragDropManager.createDragDropAreas(this.groupBox.$$containerElementGet(), { singleItem: this.singleItemGet() });

                this.groupBox.controlsGet()
                    .each(item => { item.draggableSet(true); });
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _createElement: function ()
                {
                    this.super._createElement();

                    this.$$buttonContainer = $$.create$$({ nodeName: "div", attributes: { "class": "rad-button-container" } });
                    this.$$buttonContainer.appendTo(this.groupBox.$$elementGet());
                    this.buttonAdd = new namespace.Button({ text: "Add", cssClass: "rad-action-add" });
                    this.buttonAdd.appendTo(this.$$buttonContainer);
                },

                // Public Methods
                add: function (evaluatorUi)
                {
                    evaluatorUi.appendTo(this.groupBox); // TODO: Here to trigger code in evaluatorUi.appendTo. Needs a rethink.
                    this.append(evaluatorUi);
                    this.updateButtons();
                    this.updateEvaluatorTree();
                },
                append: function ($$elementOrControl)
                {
                    this.groupBox.append($$elementOrControl);
                    this.groupBox.controlsGet().each(item => { item.draggableSet(true); });
                    return this;
                },
                prepend: function ($$elementOrControl)
                {
                    this.groupBox.prepend($$elementOrControl);
                    this.groupBox.controlsGet().each(item => { item.draggableSet(true); });
                    return this;
                },
                textGet: function ()
                {
                    var
                        self = this,
                        controls = self.groupBox.controlsGet();

                    if (self.singleItemGet())
                    {
                        return (
                            "("
                            + self.titleGet().toUpperCase()
                            + (controls.length
                            ? " " + controls[0].textGet()
                            : String.empty)
                            + ")"
                        );
                    }

                    return (
                        "("
                        + controls.select((item, index) =>
                        {
                            return item.textGet()
                            +
                            (
                                index < controls.length - 1
                                ? " " + self.titleGet().toUpperCase()
                                : String.empty
                            );
                        }).join(" ")
                        + ")"
                    );
                },
                updateButtons: function ()
                {
                    if (this.singleItemGet() && this.groupBox.controlsGet().length === 1)
                        this.$$buttonContainer.hide();
                    else
                        this.$$buttonContainer.show();
                },
                valueGet: function ()
                {
                    var
                        value = {
                            type: this.typeGet()
                        },
                        controls = this.groupBox.controlsGet();

                    if (this.singleItemGet())
                    {
                        var
                            controlValue = controls.length ? controls[0].valueGet() : null;

                        value.evaluator =
                            controlValue
                            ? controlValue.fromJson()
                            : null;
                    }
                    else
                    {
                        value.evaluators =
                            controls.select(item =>
                            {
                                var
                                    itemValue = item.valueGet();

                                return (
                                    itemValue
                                    ? itemValue.fromJson()
                                    : null
                                );
                            });
                    }
                    return value.toJson();
                },
                valueSet: function (value)
                {
                    var
                        self = this,
                        valueObject,
                        evaluatorUi;

                    self.groupBox.controlsClear();

                    try { valueObject = value.fromJson(); }
                    catch (e) { /* Continue regardless of error */ }

                    if (valueObject)
                    {
                        if (self.singleItemGet())
                        {
                            if (valueObject.evaluator)
                            {
                                evaluatorUi = namespace.EvaluatorUi.fromDataObject(valueObject.evaluator);
                                evaluatorUi.draggableSet(true);
                                evaluatorUi.appendTo(self.groupBox);
                                evaluatorUi.valueSet(valueObject.evaluator.toJson());
                            }
                        }
                        else
                        {
                            if (valueObject.evaluators)
                            {
                                valueObject.evaluators.each(item =>
                                {
                                    evaluatorUi = namespace.EvaluatorUi.fromDataObject(item);
                                    evaluatorUi.draggableSet(true);
                                    evaluatorUi.appendTo(self.groupBox);
                                    evaluatorUi.valueSet(item.toJson());
                                });
                            }
                        }
                    }

                    self.updateButtons();

                    return true;
                }
            };
        }
    });

    // Evaluator UI Wrapper : TODO: Simplify and get rid of "singleItem"
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "EvaluatorUiWrapper",
        inherits: "EvaluatorUiCollection",
        abstract: true,
        createPropertyDefaults: namespace =>
        {
            return {
                singleItem: true
            };
        }
    });

    // And Evaluator UI
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "AndEvaluatorUi",
        inherits: "EvaluatorUiCollection",
        createPropertyDefaults: namespace =>
        {
            return {
                title: "And"
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-evaluator-ui-and");
            };
        }
    });

    // Not Evaluator UI
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "NotEvaluatorUi",
        inherits: "EvaluatorUiWrapper",
        createPropertyDefaults: namespace =>
        {
            return {
                title: "Not"
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-evaluator-ui-not");
            };
        }
    });

    // Or Evaluator UI
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "OrEvaluatorUi",
        inherits: "EvaluatorUiCollection",
        createPropertyDefaults: namespace =>
        {
            return {
                title: "Or"
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-evaluator-ui-or");
            };
        }
    });

    // Root Evaluator UI
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "RootEvaluatorUi",
        inherits: "EvaluatorUiCollection",
        createPropertyDefaults: namespace =>
        {
            return {
                singleItem: true,
                title: "Evaluator Tree"
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-evaluator-ui-root");
            };
        },
        createPrototype: namespace =>
        {
            return {
                // Public Methods
                textGet: function ()
                {
                    var
                        controls = this.groupBox.controlsGet();

                    return (
                        controls.length
                        ? controls[0].textGet()
                        : String.empty
                    );
                }
            };
        }
    });

    // True Evaluator UI
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "TrueEvaluatorUi",
        inherits: "EvaluatorUi",
        createPropertyDefaults: namespace =>
        {
            return {
                title: "True"
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-evaluator-ui-true");
                this.super.valueSet({ type: this.typeGet() }.toJson());
            };
        },
        createPrototype: namespace =>
        {
            return {
                // Public Methods
                textGet: function ()
                {
                    return "True";
                },
                valueSet: function (value)
                {
                    // Do nothing
                    return false;
                }
            };
        }
    });

    // Evaluator Tree
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "EvaluatorTree",
        inherits: "InputControl",
        properties: [
            { name: "evaluatorTypes", type: "array" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                evaluatorTypes: null,
                propagateInputEvents: true
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-evaluator-tree");

                this.rootEvaluatorUi.$$grabHandle.remove();
                this.rootEvaluatorUi.$$closeButton.remove();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _createElement: function ()
                {
                    this.super._createElement();

                    var
                        self = this,
                        $$element = this.$$elementGet();

                    self.rootEvaluatorUi =
                        new namespace.RootEvaluatorUi()
                        .append($$element.children())
                        .appendTo($$element);

                    // TODO: Children are not instantiated as this and the other Evaluator UIs don't interit from ContainerControl
                },
                _elementValueChanged: function (change)
                {
                    if (!this.__processElementValueChanged)
                        return;

                    this.super.valueSet(this._elementValueGet());
                },
                _elementValueGet: function ()
                {
                    var
                        value = this.rootEvaluatorUi.valueGet(),
                        rootElementUiValue = value ? value.fromJson() : null;

                    return (
                        rootElementUiValue?.evaluator
                        ? rootElementUiValue.evaluator.toJson()
                        : null
                    );
                },
                _elementValueSet: function (value)
                {
                    this.rootEvaluatorUi.valueSet(
                        {
                            evaluator:
                                typeof value === "string"
                                    ? value.fromJson()
                                    : value
                        }.toJson()
                    );
                },

                // Public Methods
                append: function ($$elementOrControl)
                {
                    return this.rootEvaluatorUi.append($$elementOrControl);
                },
                prepend: function ($$elementOrControl)
                {
                    return this.rootEvaluatorUi.prepend($$elementOrControl);
                },
                textGet: function ()
                {
                    return this.rootEvaluatorUi.textGet();
                },
                valueSet: function (value)
                {
                    if (this.valueGet() === value)
                        return false;

                    this._elementValueSet(value);
                    this.super.valueSet(this._elementValueGet());
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            var
                startEvaluatorTree = null,
                endEvaluatorTree = null;

            // Register Drag Drop

            window.dragDropManager.on("dragDropStarted", (evt, eventData) =>
            {
                startEvaluatorTree = eventData.$$area.closest(".rad-control-evaluator-tree").radControl();
            });

            window.dragDropManager.on("dragDropAreaChanged", (evt, eventData) =>
            {
                var
                    evaluatorUiCollectionNew = eventData.$$area.closest(".rad-control-evaluator-ui-collection").radControl(),
                    evaluatorUiCollectionOriginal = eventData.$$areaOriginal.closest(".rad-control-evaluator-ui-collection").radControl();

                if (evaluatorUiCollectionNew)
                    evaluatorUiCollectionNew.updateButtons();

                if (evaluatorUiCollectionOriginal)
                    evaluatorUiCollectionOriginal.updateButtons();
            });

            window.dragDropManager.on("dragDropEnded", (evt, eventData) =>
            {
                endEvaluatorTree = eventData.$$area.closest(".rad-control-evaluator-tree").radControl();

                if (startEvaluatorTree)
                    startEvaluatorTree._elementValueChanged();

                if (endEvaluatorTree && endEvaluatorTree !== startEvaluatorTree)
                    endEvaluatorTree._elementValueChanged();
            });

            // Register Buttons

            $$(document).on("click", ".rad-control-evaluator-tree .rad-action-close", evt =>
            {
                evt.preventDefault();

                var
                    $$target = $$(evt.currentTarget),
                    evaluatorTree = $$target.closest(".rad-control-evaluator-tree").radControl();

                $$target
                    .closest(".rad-control-evaluator-ui")
                    .radControl()
                    .remove();

                evaluatorTree._elementValueChanged();
            });

            $$(document).on("click", ".rad-control-evaluator-tree .rad-action-add", evt =>
            {
                evt.preventDefault();

                var
                    $$target = $$(evt.currentTarget),
                    evaluatorTree = $$target.closest(".rad-control-evaluator-tree").radControl();

                if (!evaluatorTree.menu)
                {
                    evaluatorTree.menu = new namespace.Menu({ text: "New Evaluator" });

                    var
                        evaluatorTypes = evaluatorTree.evaluatorTypesGet();

                    namespace.EvaluatorUi.registeredEvaluatorUis
                        .where(item =>
                        {
                            return (
                                (
                                    evaluatorTypes === null
                                    || evaluatorTypes.any(itemInner => itemInner === item.type)
                                )
                                && item.name
                            );
                        })
                        .orderBy(item => item.name)
                        .each(item =>
                        {
                            evaluatorTree.menu.append(new namespace.MenuItem({ text: item.name, tag: item }));
                        });
                }

                evaluatorTree.menu.$$target = $$target;

                evaluatorTree.menu
                    .openAsync()
                    .then(menuItem =>
                    {
                        if (!menuItem)
                            return;

                        var
                            parentEvaluatorUi =
                                evaluatorTree.menu.$$target
                                    .closest(".rad-control-evaluator-ui")
                                    .radControl(),
                            evaluatorUiClassConstructor = menuItem.tagGet().classConstructor;

                        parentEvaluatorUi.add(new evaluatorUiClassConstructor());
                    });
            });
        }
    });

    // Property Evaluator UI - TODO: Create "PagePropertyEvaluatorUi"
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "PropertyEvaluatorUi",
        inherits: "EvaluatorUi",
        properties: [
            { name: "propertyName", type: "string" },
            { name: "propertyType", type: "string" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                title: "Property"
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                var
                    self = this;

                self.addCssClass("rad-control-evaluator-ui-property");

                window.dragDropManager.disableDragDropAreas(self.groupBox.$$containerElementGet());
                self.groupBox.controlsGet().each(item => { item.draggableSet(false); });

                function controlValueChanged()
                {
                    self.$$elementGet()
                        .closest(".rad-control-evaluator-tree")
                        .radControl()
                        ._elementValueChanged();
                }

                self.comboBoxPropertyName.on("valueChanged", controlValueChanged);
                self.comboBoxComparerId.on("valueChanged", controlValueChanged);
                self.controlPropertyValue.on("valueChanged", controlValueChanged);
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _createElement: function ()
                {
                    // Required before this.super._createElement(); 
                    this.comboBoxPropertyName = new namespace.ComboBox();

                    this.super._createElement();

                    var
                        propertyName = this.propertyNameGet();

                    this.labelPropertyName = new namespace.Label({ text: "Property Name" });
                    this.labelPropertyName.appendTo(this.groupBox);

                    this.comboBoxPropertyName.appendTo(this.groupBox);
                    this.labelPropertyName.associatedControlSet(this.comboBoxPropertyName);

                    if (propertyName !== null)
                    {
                        this.labelPropertyName.visibleSet(false);
                        this.comboBoxPropertyName.visibleSet(false);
                    }

                    this.labelComparerId = new namespace.Label({ text: "Comparer" });
                    this.labelComparerId.appendTo(this.groupBox);

                    this.comboBoxComparerId = new namespace.ComboBox({
                        listDataSourceValueProperty: "id"
                    });

                    this.comboBoxComparerId.appendTo(this.groupBox);
                    this.comboBoxComparerId.listDataSourceSet(
                        seriouslyrad.logicevaluation.PropertyComparer.propertyComparers
                            .select(item => ({ id: item.id, description: item.description, operator: item.operator }))
                    );
                    this.labelComparerId.associatedControlSet(this.comboBoxComparerId);

                    this.labelPropertyValue = new namespace.Label({ text: "Property Value" });
                    this.labelPropertyValue.appendTo(this.groupBox);

                    this.controlPropertyValue = this._getControlPropertyValue();
                    this.controlPropertyValue.appendTo(this.groupBox);
                    this.labelPropertyValue.associatedControlSet(this.controlPropertyValue);

                    this.comboBoxPropertyName.valueSet(this.value ? this.value.propertyName : null);
                    this.controlPropertyValue.valueSet(this.value ? this.value.propertyValue : null);
                },
                _getControlPropertyValue: function ()
                {
                    var
                        propertyType = this.propertyTypeGet();

                    // TODO: Extend for all types
                    switch (propertyType)
                    {
                        case "boolean":
                            return new namespace.Switch();
                        case "int":
                            return new namespace.NumericUpDown();
                    }

                    return new namespace.TextBox();
                },
                _getPropertyValueForText: function ()
                {
                    var
                        propertyValue = this.controlPropertyValue.valueGet(),
                        propertyType = objectHelper.typeOf(propertyValue);

                    // TODO: Extend for all types
                    switch (propertyType)
                    {
                        case "object":
                        case "string":
                            return String.format("\"{0}\"", propertyValue);
                        case "boolean":
                            return propertyValue.toString().toUpperCase();
                    }

                    return propertyValue.toString();
                },
                _pageChanged: function (change)
                {
                    this.super._pageChanged(change);
                    this.onPageChanged({ data: { self: this } });
                },
                _populateComboBoxPropertyName: function ()
                {
                    var
                        propertyName = this.propertyNameGet();

                    if (propertyName !== null)
                        return;

                    var
                        page = this.pageGet();

                    if (page && page instanceof namespace.DetailsPage && page.applicationEntityProperties)
                    {
                        this.comboBoxPropertyName
                            .listDataSourceSet(
                                page.applicationEntityProperties
                                    .select(item => ({ value: item.name, description: item.name }))
                                    .orderBy(item => item.description)
                            );
                        return;
                    }

                    this.comboBoxPropertyName.listDataSourceSet(null);
                },

                // Public Methods
                textGet: function ()
                {
                    var
                        propertyName = this.propertyNameGet(),
                        comboBoxComparerSelectedItem = this.comboBoxComparerId.selectedItemGet();

                    if (propertyName === null)
                        propertyName = this.comboBoxPropertyName.textGet();

                    return String.format("([{0}] {1} {2})", propertyName, comboBoxComparerSelectedItem !== null ? comboBoxComparerSelectedItem.operator : String.empty, this._getPropertyValueForText());
                },
                valueGet: function ()
                {
                    var
                        propertyName = this.propertyNameGet();

                    return {
                        type: this.typeGet(),
                        propertyName: propertyName !== null ? propertyName : this.comboBoxPropertyName.valueGet(),
                        comparerId: this.comboBoxComparerId.valueGet(),
                        propertyValue: this.controlPropertyValue.valueGet()
                    }
                    .toJson();
                },
                valueSet: function (value)
                {
                    var
                        valueObject;

                    try { valueObject = value.fromJson(); }
                    catch (e) { /* Continue regardless of error */ }

                    this.comboBoxPropertyName.valueSet(valueObject ? valueObject.propertyName : null);
                    this.comboBoxComparerId.valueSet(valueObject ? valueObject.comparerId : null);
                    this.controlPropertyValue.valueSet(valueObject ? valueObject.propertyValue : null);

                    return true;
                },

                // Event Handlers
                onPageChanged: function (evt)
                {
                    evt.data.self._populateComboBoxPropertyName();
                }
            };
        }
    });

    // Team Evaluator UI
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "TeamEvaluatorUi",
        inherits: "EvaluatorUi",
        createPropertyDefaults: namespace =>
        {
            return {
                title: "Team"
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                var
                    self = this;

                self.addCssClass("rad-control-evaluator-ui-team");

                window.dragDropManager.disableDragDropAreas(self.groupBox.$$containerElementGet());
                self.groupBox.controlsGet().each(item => { item.draggableSet(false); });

                function controlValueChanged()
                {
                    self.$$elementGet()
                        .closest(".rad-control-evaluator-tree")
                        .radControl()
                        ._elementValueChanged();
                }

                self.textBoxTeamName.on("valueChanged", controlValueChanged);
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _createElement: function ()
                {
                    // Required before this.super._createElement(); 
                    this.comboBoxPropertyName = new namespace.ComboBox();

                    this.super._createElement();

                    this.labelTeamName = new namespace.Label({ text: "Team Name" });
                    this.labelTeamName.appendTo(this.groupBox);

                    this.textBoxTeamName = new namespace.TextBox();
                    this.textBoxTeamName.appendTo(this.groupBox);
                    this.labelTeamName.associatedControlSet(this.textBoxTeamName);

                    this.textBoxTeamName.valueSet(this.value ? this.value.teamName : null);
                },
                _pageChanged: function (change)
                {
                    this.super._pageChanged(change);
                    this.onPageChanged({ data: { self: this } });
                },
                _populateComboBoxPropertyName: function ()
                {
                    var
                        page = this.pageGet();

                    if (page && page instanceof namespace.DetailsPage && page.applicationEntityProperties)
                    {
                        this.comboBoxPropertyName
                            .listDataSourceSet(
                                page.applicationEntityProperties
                                    .select(item => ({ value: item.name, description: item.name }))
                                    .orderBy(item => item.description)
                            );
                        return;
                    }

                    this.comboBoxPropertyName.listDataSourceSet(null);
                },

                // Public Methods
                textGet: function ()
                {
                    return String.format("(Team = \"{0}\")", this.textBoxTeamName.textGet());
                },
                valueGet: function ()
                {
                    return {
                        type: this.typeGet(),
                        teamName: this.textBoxTeamName.valueGet()
                    }
                    .toJson();
                },
                valueSet: function (value)
                {
                    var
                        valueObject;

                    try { valueObject = value.fromJson(); }
                    catch (e) { /* Continue regardless of error */ }

                    this.textBoxTeamName.valueSet(valueObject ? valueObject.teamName : null);

                    return true;
                },

                // Event Handlers
                onPageChanged: function (evt)
                {
                    evt.data.self._populateComboBoxPropertyName();
                }
            };
        }
    });

    // Number Evaluator UI
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "NumberEvaluatorUi",
        inherits: "EvaluatorUi",
        abstract: true,
        createPropertyDefaults: namespace =>
        {
            return {
                title: "Number"
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                var
                    self = this;

                self.addCssClass("rad-control-evaluator-ui-property");

                window.dragDropManager.disableDragDropAreas(self.groupBox.$$containerElementGet());
                self.groupBox.controlsGet().each(item => { item.draggableSet(false); });

                function controlValueChanged()
                {
                    self.$$elementGet()
                        .closest(".rad-control-evaluator-tree")
                        .radControl()
                        ._elementValueChanged();
                }

                self.comboBoxComparerId.on("valueChanged", controlValueChanged);
                self.numericUpDownPropertyValue.on("valueChanged", controlValueChanged);
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _createElement: function ()
                {
                    this.super._createElement();

                    this.labelComparerId = new namespace.Label({ text: "Comparer" });
                    this.labelComparerId.appendTo(this.groupBox);

                    this.comboBoxComparerId = new namespace.ComboBox({
                        listDataSourceValueProperty: "id"
                    });

                    this.comboBoxComparerId.appendTo(this.groupBox);
                    this.comboBoxComparerId.listDataSourceSet(
                        seriouslyrad.logicevaluation.PropertyComparer.propertyComparers
                            .select(item => ({ id: item.id, description: item.description, operator: item.operator }))
                    );
                    this.labelComparerId.associatedControlSet(this.comboBoxComparerId);

                    this.labelPropertyValue = new namespace.Label({ text: "Property Value" });
                    this.labelPropertyValue.appendTo(this.groupBox);

                    this.numericUpDownPropertyValue = new namespace.NumericUpDown();
                    this.numericUpDownPropertyValue.appendTo(this.groupBox);
                    this.labelPropertyValue.associatedControlSet(this.numericUpDownPropertyValue);

                    this.numericUpDownPropertyValue.valueSet(this.value ? this.value.propertyValue : null);
                },

                // Public Methods
                textGet: function ()
                {
                    var
                        comboBoxComparerSelectedItem = this.comboBoxComparerId.selectedItemGet();

                    return String.format("([{0}] {1} {2})", this.titleGet(), comboBoxComparerSelectedItem !== null ? comboBoxComparerSelectedItem.operator : String.empty, this.numericUpDownPropertyValue.textGet());
                },
                valueGet: function ()
                {
                    return {
                        type: this.typeGet(),
                        comparerId: this.comboBoxComparerId.valueGet(),
                        propertyValue: this.numericUpDownPropertyValue.valueGet()
                    }
                    .toJson();
                },
                valueSet: function (value)
                {
                    var
                        valueObject;

                    try { valueObject = value.fromJson(); }
                    catch (e) { /* Continue regardless of error */ }

                    this.comboBoxComparerId.valueSet(valueObject ? valueObject.comparerId : null);
                    this.numericUpDownPropertyValue.valueSet(valueObject ? valueObject.propertyValue : null);

                    return true;
                }
            };
        }
    });

    // Combo Box Evaluator UI
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "ComboBoxEvaluatorUi",
        inherits: "EvaluatorUi",
        properties: [
            { name: "listDataSource" },
            { name: "listDataSourceDescriptionProperty", type: "string" },
            { name: "listDataSourceValueProperty", type: "string" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                listDataSourceValueProperty: "value",
                listDataSourceDescriptionProperty: "description",
                title: "Combo Box"
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                var
                    self = this;

                self.addCssClass("rad-control-evaluator-ui-property");

                window.dragDropManager.disableDragDropAreas(self.groupBox.$$containerElementGet());
                self.groupBox.controlsGet().each(item => { item.draggableSet(false); });

                function controlValueChanged()
                {
                    self.$$elementGet()
                        .closest(".rad-control-evaluator-tree")
                        .radControl()
                        ._elementValueChanged();
                }

                self.comboBoxPropertyValue.on("valueChanged", controlValueChanged);

                // Trigger Property Changes
                this.listDataSourceDescriptionPropertyTriggerChange();
                this.listDataSourceValuePropertyTriggerChange();
                this.listDataSourceTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _createElement: function ()
                {
                    this.super._createElement();

                    this.labelPropertyValue = new namespace.Label({ text: "Property Value" });
                    this.labelPropertyValue.appendTo(this.groupBox);

                    this.comboBoxPropertyValue = new namespace.ComboBox();
                    this.comboBoxPropertyValue.appendTo(this.groupBox);
                    this.labelPropertyValue.associatedControlSet(this.comboBoxPropertyValue);

                    this.comboBoxPropertyValue.valueSet(this.value ? this.value.propertyValue : null);
                },
                _listDataSourceChanged: function (change)
                {
                    this.comboBoxPropertyValue.listDataSourceSet(change.currentValue);
                },
                _listDataSourceDescriptionPropertyChanged: function (change)
                {
                    this.comboBoxPropertyValue.listDataSourceDescriptionPropertySet(change.currentValue);
                },
                _listDataSourceValuePropertyChanged: function (change)
                {
                    this.comboBoxPropertyValue.listDataSourceValuePropertySet(change.currentValue);
                },

                // Public Methods
                textGet: function ()
                {
                    return String.format("([{0}] is \"{1}\")", this.titleGet(), this.comboBoxPropertyValue.textGet());
                },
                valueGet: function ()
                {
                    return {
                        type: this.typeGet(),
                        propertyValue: this.comboBoxPropertyValue.valueGet()
                    }
                    .toJson();
                },
                valueSet: function (value)
                {
                    var
                        valueObject;

                    try { valueObject = value.fromJson(); }
                    catch (e) { /* Continue regardless of error */ }

                    this.comboBoxPropertyValue.valueSet(valueObject ? valueObject.propertyValue : null);

                    return true;
                }
            };
        }
    });

    $$(document).on("seriouslyrad.ui.web.EvaluatorUi:RegisterEvaluatorUis", (evt, registerEvaluatorUiCallback) =>
    {
        registerEvaluatorUiCallback(null, seriouslyrad.ui.web.RootEvaluatorUi, null, "Standard");

        registerEvaluatorUiCallback("And", seriouslyrad.ui.web.AndEvaluatorUi, "And", "Standard");
        registerEvaluatorUiCallback("Not", seriouslyrad.ui.web.NotEvaluatorUi, "Not", "Standard");
        registerEvaluatorUiCallback("Or", seriouslyrad.ui.web.OrEvaluatorUi, "Or", "Standard");

        registerEvaluatorUiCallback("True", seriouslyrad.ui.web.TrueEvaluatorUi, "True", "Boolean");

        registerEvaluatorUiCallback("Number", seriouslyrad.ui.web.NumberEvaluatorUi, "Number", "Numeric");

        registerEvaluatorUiCallback("Property", seriouslyrad.ui.web.PropertyEvaluatorUi, "Property", "EntityProperty");
        registerEvaluatorUiCallback("Team", seriouslyrad.ui.web.TeamEvaluatorUi, "Team", "Security");
    });

    // #endregion

    // View Edit Control
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "ViewEditControl",
        inherits: "Control",
        properties: [
            { name: "editMode", type: "boolean" },
            { name: "helpText", type: "string" },
            { name: "mandatory", type: "boolean" },
            { name: "mandatoryEvaluator" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                dataSourceControlSelector: ".rad-control-page",
                editMode: false
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-view-edit-control field");

                // Trigger Property Changes
                this.editModeTriggerChange();
                this.helpTextTriggerChange();
                this.mandatoryTriggerChange();
                this.mandatoryEvaluatorTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _createElement: function ()
                {
                    this.super._createElement();

                    var
                        $$element = this.$$elementGet();

                    this.labelControl =
                        new namespace.Label({ colon: true })
                        .appendTo($$element);

                    this.panelContents =
                        new namespace.Panel({ cssClass: "rad-field-contents" })
                        .appendTo($$element);

                    $$.create$$("div", "rad-clear-float")
                        .appendTo($$element);
                },
                _editModeChanged: function (change)
                {
                    if (change.currentValue)
                        this.addCssClass("rad-state-edit");
                    else
                        this.removeCssClass("rad-state-edit");
                },
                _mandatoryChanged: function (change)
                {
                    this.updateMandatory();
                },
                _mandatoryEvaluatorChanged: function (change)
                {
                    if (this.mandatoryEvaluator)
                    {
                        this.mandatoryEvaluator.off("valueChanged", { self: this }, this.onMandatoryEvaluatorValueChanged);
                        this.mandatoryEvaluator.contextSet(null);
                    }

                    if (change.currentValue)
                    {
                        this.mandatoryEvaluator = seriouslyrad.logicevaluation.Evaluator.fromDataObject(change.currentValue);
                        this.mandatoryEvaluator.on("valueChanged", { self: this }, this.onMandatoryEvaluatorValueChanged);
                        this.mandatoryEvaluator.contextSet(this);
                    }
                },
                _pageChanged: function (change)
                {
                    this.super._pageChanged(change);

                    if (change.originalValue)
                    {
                        change.originalValue.off("creatingSaveBatch", { self: this }, this.onPageCreatingSaveBatch);
                        change.originalValue.off("editModeChanged", { self: this }, this.onPageEditModeChanged);
                    }

                    if (change.currentValue)
                    {
                        change.currentValue.on("creatingSaveBatch", { self: this }, this.onPageCreatingSaveBatch);
                        change.currentValue.on("editModeChanged", { self: this }, this.onPageEditModeChanged);

                        if (!this.__isConstructing() && change.currentValue?.editModeGet)
                            this.editModeSet(change.currentValue.editModeGet());
                    }
                },
                _registerSaveRequests: function (data)
                {
                    /* Intentionally empty */
                },
                _textChanged: function (change)
                {
                    this.super._textChanged(change);
                    this.labelControl.textSet(change.currentValue);

                    if (change.currentValue)
                        this.labelControl.colonSet(true);
                    else
                        this.labelControl.colonSet(false);
                },

                // Public Methods
                isMandatoryGet: function ()
                {
                    return this.visibleGet() && (this.mandatoryGet() || this.mandatoryEvaluator?.valueGet());
                },
                loadDataAsync: function ()
                {
                    return Promise.resolve();
                },
                updateMandatory: function ()
                {
                    if (this.isMandatoryGet())
                        this.addCssClass("rad-state-mandatory");
                    else
                        this.removeCssClass("rad-state-mandatory");
                },

                // Event Handlers
                onMandatoryEvaluatorValueChanged: function (evt, change)
                {
                    evt.data.self.updateMandatory();
                },
                onPageCreatingSaveBatch: function (evt, eventData)
                {
                    evt.data.self._registerSaveRequests(eventData);
                },
                onPageEditModeChanged: function (evt, change)
                {
                    evt.data.self.editModeSet(change.currentValue);
                }
            };
        }
    });

    // Entity Extended Property
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "EntityExtendedProperty",
        inherits: "ViewEditControl",
        properties: [
            { name: "editorControl" },
            { name: "editorControlProperties" },
            { name: "extendedPropertyName", type: "string" },
            { name: "internalDataSource" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                editorControl: new namespace.TextBox()
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-entity-extended-property");

                var
                    internalDataSource = this[".properties"].internalDataSource;

                if (internalDataSource && !(internalDataSource instanceof seriouslyrad.data.DataSource))
                    this[".properties"].internalDataSource = new seriouslyrad.data.DataSource({ data: internalDataSource });
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _createElement: function ()
                {
                    this.super._createElement();

                    this.text =
                        new seriouslyrad.ui.web.Text({ dataSourceProperty: "value" })
                        .appendTo(this.panelContents);

                    var
                        editorControl = this.editorControlGet(),
                        editorControlProperties = this.editorControlPropertiesGet();

                    if (!editorControl)
                        console.error("Editor Control is mandatory.");

                    if (editorControlProperties)
                        editorControl.setProperties(editorControlProperties);

                    editorControl.visibleSet(false);
                    editorControl.dataSourcePropertySet("value");
                    editorControl.appendTo(this.panelContents);
                    this.labelControl.associatedControlSet(editorControl);
                },
                _dataSourceChanged: function (change)
                {
                    this.loadDataAsync();
                    this.super._dataSourceChanged(change);
                },
                _editModeChanged: function (change)
                {
                    this.super._editModeChanged(change);

                    var
                        editorControl = this.editorControlGet();

                    if (change.currentValue)
                    {
                        this.text.visibleSet(false);
                        editorControl.visibleSet(true);
                    }
                    else
                    {
                        this.text.visibleSet(true);
                        this.text.textSet(editorControl.textGet());
                        editorControl.visibleSet(false);
                    }
                },
                _internalDataSourceChanged: function (change)
                {
                    if (change.originalValue)
                        change.originalValue.off("propertyValueChanged", { self: this }, this.onInternalDataSourcePropertyValueChanged);

                    if (change.currentValue)
                        change.currentValue.on("propertyValueChanged", { self: this }, this.onInternalDataSourcePropertyValueChanged);

                    var
                        editorControl = this.editorControlGet();

                    //this.text.dataSourceSet(change.currentValue);
                    editorControl.dataSourceSet(change.currentValue);
                    this.text.textSet(editorControl.textGet());
                },
                _mandatoryChanged: function (change)
                {
                    this.super._mandatoryChanged(change);
                    this.editorControlGet().mandatorySet(change.currentValue);
                },
                _mandatoryEvaluatorChanged: function (change)
                {
                    this.super._mandatoryEvaluatorChanged(change);
                    this.editorControlGet().mandatoryEvaluatorSet(change.currentValue);
                },
                _registerSaveRequests: function (data)
                {
                    this.super._registerSaveRequests(data);

                    var
                        internalDataSource = this.internalDataSourceGet();

                    data.afterSaveRecordRequests.push(
                        window.application.webApiClient
                            .createEntitySaveRequest(
                                "EntityExtendedProperties",
                                internalDataSource.dataGet(),
                                internalDataSource.dataOriginalGet()
                            )
                    );
                },

                // Public Methods
                internalDataSourceSet: function (value)
                {
                    if (value && !(value instanceof seriouslyrad.data.DataSource))
                        value = new seriouslyrad.data.DataSource({ data: value });

                    return this._internalDataSourceSet(value);
                },
                loadDataAsync: function ()
                {
                    var
                        self = this,
                        page = self.pageGet(),
                        entityId = page.entityIdGet(),
                        recordId = page.recordIdGet(),
                        extendedPropertyName = self.extendedPropertyNameGet();

                    self.loading = true;

                    return (
                        window.application.webApiClient
                            .createEntitySearchRequest(
                                "EntityExtendedProperties",
                                new seriouslyrad.AndExpression({
                                    expressions: [
                                        new seriouslyrad.ComparisonExpression({
                                            path: "entityId",
                                            value: entityId
                                        }),
                                        new seriouslyrad.ComparisonExpression({
                                            path: "recordId",
                                            value: recordId
                                        }),
                                        new seriouslyrad.ComparisonExpression({
                                            path: "name",
                                            value: extendedPropertyName
                                        })
                                    ]
                                })
                            )
                            .executeAsync()
                            .then(data =>
                            {
                                self.internalDataSourceSet(data?.length === 1 ? data[0] : { entityId: entityId, recordId: recordId, name: extendedPropertyName });
                            })
                            .finally(() =>
                            {
                                self.loading = false;
                            })
                    );
                },

                // Event Handlers
                onInternalDataSourcePropertyValueChanged: function (evt, change)
                {
                    var
                        self = evt.data.self,
                        page = self.pageGet();

                    if (!self.loading && page?.editInProgressSet)
                        page.editInProgressSet(true);
                }
            };
        }
    });

    // Entity Extended Property (Combo Box Yes No)
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "EntityExtendedPropertyComboBoxYesNo",
        inherits: "EntityExtendedProperty",
        properties: [
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                editorControl: new namespace.ComboBox({ listDataSource: [{ value: "false", description: "No" }, { value: "true", description: "Yes" }] })
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-entity-extended-property-combo-box-yes-no");
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods

                // Public Methods

                // Event Handlers
            };
        }
    });

    // Entity Extended Property (Read Only)
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "EntityExtendedPropertyReadOnly",
        inherits: "EntityExtendedProperty",
        properties: [
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                editorControl: new namespace.Text()
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-entity-extended-property-read-only");
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _bindEvents: function ()
                {
                    this.super._bindEvents();

                    this.buttonCopy.on("click", { self: this }, this.onButtonCopyClicked);
                },
                _createElement: function ()
                {
                    this.super._createElement();

                    this.buttonCopy =
                        new namespace.Button({ cssClass: "action compact", inline: true, icon: "copy", showLabel: false })
                            .appendTo(this.panelContents);
                },
                _internalDataSourceChanged: function (change)
                {
                    this.super._internalDataSourceChanged(change);

                    var
                        visible = false;

                    if (change?.currentValue)
                    {
                        var
                            data = change.currentValue.dataGet();

                        if(data?.value)
                            visible = true;
                    }

                    this.buttonCopy.visibleSet(visible);
                },
                _registerSaveRequests: function (data)
                {
                    /* Intentionally empty */
                },

                // Public Methods

                // Event Handlers
                onButtonCopyClicked: function (evt)
                {
                    evt.preventDefault();
                    evt.stopPropagation();
                    evt.data.self.editorControlGet().copyValueToClipboard();
                },
            };
        }
    });

    // Application Entity Selection
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "ApplicationEntitySelection",
        inherits: "ViewEditControl",
        properties: [
            { name: "horizontal", type: "boolean" },
            { name: "listEntityDescriptionProperty", type: "string" },
            { name: "listEntityFilter", type: "string" },
            { name: "listEntitySetName", type: "string" },
            { name: "selectionEntityListForeignKeyProperty", type: "string" },
            { name: "selectionEntityRecordForeignKeyProperty", type: "string" },
            { name: "selectionEntitySetName", type: "string" }
        ],
        createConstructor: namespace =>
        {
            return function ()
            {
                // Trigger Property Changes
                this.horizontalTriggerChange();
                this.listEntityDescriptionPropertyTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _bindEvents: function ()
                {
                    this.super._bindEvents();
                    this.checkBoxList.on("valueChanged", { self: this }, this.onCheckBoxListValueChanged);
                },
                _createSelectionSaveRequestAsync: function (listForeignKeyValue, recordForeignKeyValue)
                {
                    var
                        selectionEntitySetName = this.selectionEntitySetNameGet(),
                        selectionEntityListForeignKeyProperty = this.selectionEntityListForeignKeyPropertyGet(),
                        selectionEntityRecordForeignKeyProperty = this.selectionEntityRecordForeignKeyPropertyGet();

                    return (
                        window.utility.newGuidAsync()
                            .then(guid =>
                            {
                                var
                                    record = {
                                        id: guid
                                    };

                                record[selectionEntityListForeignKeyProperty] = listForeignKeyValue;
                                record[selectionEntityRecordForeignKeyProperty] = recordForeignKeyValue;

                                return (
                                    window.application.webApiClient
                                        .createEntitySaveRequest(
                                            selectionEntitySetName,
                                            record
                                        )
                                );
                            })
                    );
                },
                _createElement: function ()
                {
                    this.super._createElement();

                    this.checkBoxList =
                        new seriouslyrad.ui.web
                            .CheckBoxList({
                                listDataSourceValueProperty: "id"
                            })
                            .appendTo(this.panelContents);
                },
                _createSelectionDeleteRequest: function (selectionId)
                {
                    return (
                        window.application.webApiClient
                            .createEntityDeleteRequest(
                                this.selectionEntitySetNameGet(),
                                selectionId
                            )
                    );
                },
                _dataSourceChanged: function (change)
                {
                    this.loadDataAsync();
                    this.super._dataSourceChanged(change);
                },
                _editModeChanged: function (change)
                {
                    this.super._editModeChanged(change);
                    this.checkBoxList.readOnlySet(!change.currentValue);
                },
                _horizontalChanged: function (change)
                {
                    this.checkBoxList.horizontalSet(change.currentValue);
                },
                _listEntityDescriptionPropertyChanged: function (change)
                {
                    this.checkBoxList.listDataSourceDescriptionPropertySet(change.currentValue);
                },
                _registerSaveRequests: function (data)
                {
                    var
                        self = this,
                        page = self.pageGet(),
                        recordId = page.recordIdGet(),
                        selectionEntitySetName = self.selectionEntitySetNameGet(),
                        selectionEntityListForeignKeyProperty = self.selectionEntityListForeignKeyPropertyGet(),
                        originalSelectionResponse = self.originalSelectionResponse,
                        originalSelection =
                            originalSelectionResponse?.length
                                ? originalSelectionResponse[0].select(item => item[selectionEntityListForeignKeyProperty])
                                : [],
                        currentSelection = self.checkBoxList.valueGet();

                    if (!currentSelection)
                        currentSelection = [];

                    // Delete Requests

                    originalSelection
                        .where(item =>
                        {
                            return !currentSelection.any(itemInner => itemInner === item);
                        })
                        .selectMany(item =>
                        {
                            return originalSelectionResponse[0].where(itemInner => itemInner[selectionEntityListForeignKeyProperty] === item);
                        })
                        .each(item =>
                        {
                            data.afterSaveRecordRequests.push(
                                window.application.webApiClient
                                    .createEntityDeleteRequest(
                                        selectionEntitySetName,
                                        item.id
                                    )
                            );
                        });

                    // Create Requests
                    currentSelection
                        .where(item =>
                        {
                            return !originalSelection.any(itemInner => itemInner === item);
                        })
                        .each(item =>
                        {
                            data.promises.push(
                                self._createSelectionSaveRequestAsync(item, recordId)
                                    .then(request =>
                                    {
                                        data.afterSaveRecordRequests.push(request);
                                    })
                            );
                        });
                },
                _resetValidation: function ()
                {
                    this.removeCssClass("rad-state-error");
                },
                _validate: function ()
                {
                    var
                        validationErrors = [];

                    if (this.isMandatoryGet() && !this.checkBoxList.valueGet())
                    {
                        validationErrors.push({
                            errorMessage: String.format("{0} is required.", this.textGet())
                        });
                    }

                    if (validationErrors.length)
                        this.addCssClass("rad-state-error");
                    else
                        this.removeCssClass("rad-state-error");

                    return validationErrors;
                },

                // Public Methods
                loadDataAsync: function ()
                {
                    var
                        self = this,
                        dataSource = self.dataSourceGet(),
                        data = dataSource ? dataSource.dataGet() : null,
                        page = self.pageGet(),
                        recordId = page.recordIdGet(),
                        listEntitySetName = self.listEntitySetNameGet(),
                        listEntityDescriptionProperty = self.listEntityDescriptionPropertyGet(),
                        listEntityFilter = self.listEntityFilterGet(),
                        selectionEntitySetName = self.selectionEntitySetNameGet(),
                        selectionEntityListForeignKeyProperty = self.selectionEntityListForeignKeyPropertyGet(),
                        selectionEntityRecordForeignKeyProperty = self.selectionEntityRecordForeignKeyPropertyGet();

                    if (!listEntitySetName)
                        return Promise.reject("List entity set name not set");

                    if (!listEntityDescriptionProperty)
                        return Promise.reject("List entity description property not set");

                    if (!selectionEntitySetName)
                        return Promise.reject("Selection entity set name not set");

                    if (!selectionEntityListForeignKeyProperty)
                        return Promise.reject("Selection entity list foreign key property not set");

                    if (!selectionEntityRecordForeignKeyProperty)
                        return Promise.reject("Selection entity record foreign key property not set");

                    self.loading = true;

                    if (listEntityFilter)
                    {
                        listEntityFilter = listEntityFilter.replace(/\[([^\]]+)\]/g, (match, p1) =>
                        {
                            var
                                value = data ? data[p1] : null;

                            if (Object.isNullOrUndefined(value))
                                return "null";

                            return value.toString();
                        });
                    }

                    return (
                        Promise
                            .all([
                                window.application.webApiClient
                                    .createEntitySearchRequest(
                                        listEntitySetName,
                                        listEntityFilter,
                                        listEntityDescriptionProperty,
                                        ["id", listEntityDescriptionProperty]
                                    )
                                    .executeAsync(),
                                window.application.webApiClient
                                    .createEntitySearchRequest(
                                        selectionEntitySetName,
                                        new seriouslyrad.ComparisonExpression({
                                            path: selectionEntityRecordForeignKeyProperty,
                                            value: recordId
                                        }),
                                        null,
                                        ["id", selectionEntityListForeignKeyProperty]
                                    )
                                    .executeAsync()
                            ])
                            .then(results =>
                            {
                                const
                                    listResponse = results[0],
                                    selectionResponse = results[1];

                                self.checkBoxList.listDataSourceSet(
                                    listResponse?.length
                                        ? listResponse[0]
                                        : null
                                );

                                self.originalSelectionResponse = selectionResponse;

                                self.checkBoxList.valueSet(
                                    selectionResponse?.length
                                        ? selectionResponse[0].select(item => item[selectionEntityListForeignKeyProperty])
                                        : null
                                );
                            })
                            .finally(() =>
                            {
                                self.loading = false;
                            })
                    );
                },

                // Event Handlers
                onCheckBoxListValueChanged: function (evt)
                {
                    var
                        self = evt.data.self;

                    if (self.loading)
                        return;

                    var
                        page = self.pageGet();

                    if (page?.editInProgressSet)
                        page.editInProgressSet(true);
                },
                onDataSourceValidating: function (evt, eventData)
                {
                    this.super.onDataSourceValidating(evt, eventData);
                    eventData.validationErrors.addRange(evt.data.self._validate());
                }
            };
        }
    });

    // Child Entity Text Input
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "ChildEntityTextInput",
        inherits: "ViewEditControl",
        properties: [
            { name: "entityRecordForeignKeyProperty", type: "string" },
            { name: "entityRecordProperties" },
            { name: "entityRecordTextInputProperty", type: "string" },
            { name: "entityRecordTextInputPropertyType", type: "string" },
            { name: "entitySetName", type: "string" }
        ],
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _bindEvents: function ()
                {
                    this.super._bindEvents();
                    this.textBox.on("valueChanged", { self: this }, this.onTextBoxValueChanged);
                },
                _createSaveRequestAsync: function (record)
                {
                    var
                        self = this,
                        initialPromise =
                            record.id
                                ? Promise.resolve()
                                : window.utility.newGuidAsync()
                                    .then(guid =>
                                    {
                                        record.id = guid;
                                    });

                    return (
                        initialPromise
                            .then(() =>
                            {
                                return (
                                    window.application.webApiClient
                                        .createEntitySaveRequest(
                                            self.entitySetNameGet(),
                                            record,
                                            self.originalRecord
                                        )
                                );
                            })
                    );
                },
                _createElement: function ()
                {
                    this.super._createElement();

                    this.text =
                        new seriouslyrad.ui.web.Text({ dataSourceProperty: "value" })
                            .appendTo(this.panelContents);

                    this.text.$$elementGet().css("color", "#aaa");

                    this.textBox =
                        new seriouslyrad.ui.web
                            .TextBox()
                            .appendTo(this.panelContents);

                    this.labelControl.associatedControlSet(this.textBox);
                },
                _dataSourceChanged: function (change)
                {
                    this.loadDataAsync();
                    this.super._dataSourceChanged(change);
                },
                _editModeChanged: function (change)
                {
                    this.super._editModeChanged(change);

                    if (change.currentValue)
                    {
                        this.text.visibleSet(false);
                        this.textBox.visibleSet(true);
                    }
                    else
                    {
                        this.text.visibleSet(true);
                        this.textBox.visibleSet(false);
                    }
                },
                _registerSaveRequests: function (data)
                {
                    var
                        textBoxValue = this.textBox.valueGet(),
                        originalRecord = this.originalRecord,
                        entitySetName = this.entitySetNameGet(),
                        entityRecordTextInputPropertyType = this.entityRecordTextInputPropertyTypeGet()

                    if (entityRecordTextInputPropertyType)
                        textBoxValue = window.objectHelper.asType(textBoxValue, entityRecordTextInputPropertyType);

                    if (!textBoxValue)
                    {
                        if (originalRecord)
                        {
                            data.afterSaveRecordRequests.push(
                                window.application.webApiClient
                                    .createEntityDeleteRequest(
                                        entitySetName,
                                        originalRecord.id
                                    )
                            );
                        }
                    }
                    else
                    {
                        var
                            page = this.pageGet(),
                            recordId = page.recordIdGet(),
                            entityRecordForeignKeyProperty = this.entityRecordForeignKeyPropertyGet(),
                            entityRecordTextInputProperty = this.entityRecordTextInputPropertyGet(),
                            entityRecordProperties = this.entityRecordPropertiesGet(),
                            entityRecordPropertyKeys = entityRecordProperties ? Object.keys(entityRecordProperties) : null,
                            record = this.originalRecord ? window.objectHelper.cloneObject(this.originalRecord) : {};

                        record[entityRecordForeignKeyProperty] = recordId;
                        record[entityRecordTextInputProperty] = textBoxValue;

                        if (entityRecordPropertyKeys?.length)
                        {
                            entityRecordPropertyKeys
                                .each(item =>
                                {
                                    record[item] = entityRecordProperties[item];
                                });
                        }

                        data.promises.push(
                            this._createSaveRequestAsync(record)
                                .then(request =>
                                {
                                    data.afterSaveRecordRequests.push(request);
                                })
                        );
                    }
                },
                _resetValidation: function ()
                {
                    this.removeCssClass("rad-state-error");
                },
                _validate: function ()
                {
                    var
                        validationErrors = [],
                        textBoxValue = this.textBox.valueGet(),
                        textBoxValueAsType,
                        entityRecordTextInputPropertyType = this.entityRecordTextInputPropertyTypeGet()

                    if (entityRecordTextInputPropertyType)
                    {
                        textBoxValueAsType = window.objectHelper.asType(textBoxValue, entityRecordTextInputPropertyType);

                        if (!String.isNullOrWhitespace(textBoxValue) && textBoxValueAsType === null)
                        {
                            validationErrors.push({
                                errorMessage: String.format("{0} must be of type {1}", this.textGet(), entityRecordTextInputPropertyType)
                            });
                        }
                    }

                    if (this.isMandatoryGet() && String.isNullOrWhitespace(textBoxValue))
                    {
                        validationErrors.push({
                            errorMessage: String.format("{0} is required.", this.textGet())
                        });
                    }

                    if (validationErrors.length)
                        this.addCssClass("rad-state-error");
                    else
                        this.removeCssClass("rad-state-error");

                    return validationErrors;
                },

                // Public Methods
                loadDataAsync: function ()
                {
                    var
                        self = this,
                        page = self.pageGet(),
                        recordId = page.recordIdGet(),
                        entitySetName = self.entitySetNameGet(),
                        entityRecordForeignKeyProperty = self.entityRecordForeignKeyPropertyGet(),
                        entityRecordTextInputProperty = self.entityRecordTextInputPropertyGet(),
                        entityRecordProperties = self.entityRecordPropertiesGet(),
                        entityRecordPropertyKeys = entityRecordProperties ? Object.keys(entityRecordProperties) : null,
                        defaultFilterExpression = new seriouslyrad.ComparisonExpression({
                            path: entityRecordForeignKeyProperty,
                            value: recordId
                        }),
                        filterExpression;

                    if (!entitySetName)
                        return Promise.reject("Entity set name not set");

                    if (!entityRecordForeignKeyProperty)
                        return Promise.reject("Entity record foreign key property not set");

                    if (!entityRecordTextInputProperty)
                        return Promise.reject("Entity record text input property not set");

                    self.loading = true;

                    if (entityRecordPropertyKeys?.length)
                    {
                        filterExpression = new seriouslyrad.AndExpression({
                            expressions: [
                                defaultFilterExpression
                            ]
                        });

                        entityRecordPropertyKeys
                            .each(item =>
                            {
                                filterExpression.add(
                                    new seriouslyrad.ComparisonExpression({
                                        path: item,
                                        value: entityRecordProperties[item]
                                    })
                                );
                            });
                    }
                    else
                        filterExpression = defaultFilterExpression;

                    return (
                        window.application.webApiClient
                            .createEntitySearchRequest(
                                entitySetName,
                                filterExpression,
                                null,
                                ["id", "rowVersion", entityRecordForeignKeyProperty, entityRecordTextInputProperty]
                            )
                            .executeAsync()
                            .then(response =>
                            {
                                self.error = false;

                                if (response?.length > 1)
                                {
                                    self.error = true;
                                    namespace.ErrorDialog.displayError(String.format("Only one record expected, but {0} were returned", response.length));
                                }
                                var
                                    record = response?.length ? response[0] : null;

                                self.originalRecord = record;

                                self.textBox.valueSet(record && record[entityRecordTextInputProperty] ? record[entityRecordTextInputProperty].toString() : null);
                            })
                            .finally(() =>
                            {
                                self.loading = false;
                            })
                    );
                },

                // Event Handlers
                onDataSourceValidating: function (evt, eventData)
                {
                    this.super.onDataSourceValidating(evt, eventData);
                    eventData.validationErrors.addRange(evt.data.self._validate());
                },
                onTextBoxValueChanged: function (evt)
                {
                    var
                        self = evt.data.self;

                    self.text.textSet(self.textBox.textGet());

                    if (self.loading)
                        return;

                    var
                        page = self.pageGet();

                    if (page?.editInProgressSet)
                        page.editInProgressSet(true);
                }
            };
        }
    });

    // #region Property Editors

    // Property Editor
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "PropertyEditor",
        inherits: "InputControl",
        properties: [
            { name: "editMode", type: "boolean" },
            { name: "editorControl" },
            { name: "editorControlProperties" },
            { name: "helpText", type: "string" },
            { name: "hideLabel", type: "boolean" },
            { name: "labelColon", type: "boolean" },
            { name: "maximumLength", type: "int" },
            { name: "propertyDisplayName", type: "string" }, // TODO: Use "text" instead?
            { name: "relevantEvaluator" },
            { name: "showInlineValidationMessages", type: "boolean" },
            { name: "validationErrors", type: "array" },
            { name: "validationMessages", type: "array" }, // TODO: Rewrite all to use "validationErrors" instead
            { name: "viewControl" },
            { name: "viewControlProperties" }
        ],
        propertyAttributes: [
            {
                propertyName: "helpText",
                designer: {
                    category: "Appearance",
                    displayName: "Help Text"
                }
            },
            {
                propertyName: "propertyDisplayName",
                designer: {
                    category: "Data",
                    displayName: "Property Display Name"
                }
            }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                dataSourceControlSelector: ".rad-control-page",
                editMode: false,
                hideLabel: false,
                labelColon: true,
                mandatory: false,
                propertyDisplayName: "Property",
                showInlineValidationMessages: false,
                validationMessages: null
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-property-editor field");
                this.processControlValueChanged = true;

                // Trigger Property Changes
                this.editModeTriggerChange();
                this.editorControlTriggerChange();
                this.helpTextTriggerChange();
                this.hideLabelTriggerChange();
                this.maximumLengthTriggerChange();
                this.propertyDisplayNameTriggerChange();
                this.relevantEvaluatorTriggerChange();
                this.showInlineValidationMessagesTriggerChange();
                this.validationErrorsTriggerChange();
                this.validationMessagesTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _controlValueChanged: function ()
                {
                    if (!this.processControlValueChanged)
                        return;

                    this.super.valueSet(this._controlValueGet());
                    this.updateDataSource();

                    this.errorStateSet(false);
                },
                _controlValueGet: function ()
                {
                    return this.editorControlGet().valueGet();
                },
                _controlValueSet: function (value)
                {
                    this.processControlValueChanged = false;
                    this.editorControlGet().valueSet(value);
                    this.processControlValueChanged = true;
                },
                _createElement: function ()
                {
                    this.super._createElement();

                    var
                        $$element = this.$$elementGet(),
                        viewControl = this.viewControlGet(),
                        viewControlProperties = this.viewControlPropertiesGet(),
                        editorControl = this.editorControlGet(),
                        editorControlProperties = this.editorControlPropertiesGet();

                    if (viewControl && viewControlProperties)
                        viewControl.setProperties(viewControlProperties);

                    if (!editorControl)
                    {
                        var
                            $$childElement = $$element.children().first();

                        if ($$childElement.length)
                        {
                            editorControl = namespace.Control.createFromElement($$childElement);
                            this.editorControlSet(editorControl);
                        }
                    }

                    if (!editorControl)
                        console.error("Editor Control is mandatory.");

                    if (editorControlProperties)
                        editorControl.setProperties(editorControlProperties);

                    this.labelControl = new namespace.Label({ associatedControl: editorControl, colon: this.labelColonGet() });
                    this.labelControl.appendTo($$element);
                    this.$$viewElement = $$.create$$("div", "rad-field-view").appendTo($$element);
                    this.$$editElement = $$.create$$("div", "rad-field-edit").appendTo($$element);
                    $$.create$$("div", "rad-clear-float").appendTo($$element);

                    // Make sure the property editor value is the same as the editorControl default.
                    this._valueSet(editorControl.valueGet());

                    if (viewControl)
                        viewControl.appendTo(this.$$viewElement);

                    editorControl.appendTo(this.$$editElement);
                },
                _dataSourceChanged: function (change)
                {
                    this.super._dataSourceChanged(change);

                    var
                        self = this,
                        viewControl = self.viewControlGet();

                    if (viewControl)
                        viewControl.dataSourceSet(change.currentValue);

                    this._setEditorControlDataSource();
                    this._updateValidationErrorsFromDataSource();

                    if (!self._loadDataAsyncTimeoutId)
                    {
                        self._loadDataAsyncTimeoutId = setTimeout(() =>
                        {
                            self._loadDataAsyncTimeoutId = 0;
                            self.loadDataAsync();
                        });
                    }
                },
                _dataSourcePropertyChanged: function (change)
                {
                    var
                        viewControl = this.viewControlGet();

                    if (viewControl)
                        viewControl.dataSourcePropertySet(change.currentValue);

                    this._setEditorControlDataSourceProperty();

                    this.super._dataSourcePropertyChanged(change);
                },
                _dataSourcePropertyTypeChanged: function (change)
                {
                    var
                        viewControl = this.viewControlGet();

                    if (viewControl)
                        viewControl.dataSourcePropertyTypeSet(change.currentValue);

                    this._setEditorControlDataSourcePropertyType();

                    this.super._dataSourcePropertyTypeChanged(change);
                },
                _editModeChanged: function (change)
                {
                    if (change.currentValue && !this.readOnlyGet())
                        this.addCssClass("rad-state-edit");
                    else
                        this.removeCssClass("rad-state-edit");
                },
                _editorControlChanged: function (change)
                {
                    if (change.originalValue)
                        this._editorControlEventsRemove(change.originalValue);

                    if (change.currentValue)
                        this._editorControlEventsAdd(change.currentValue);

                    if (!this.labelControl)
                        this.labelControl = new namespace.Label({ associatedControl: change.currentValue, colon: this.labelColonGet() });
                    else
                        this.labelControl.associatedControlSet(change.currentValue);
                },
                _editorControlEventsAdd: function (editorControl)
                {
                    if (!editorControl)
                        return;

                    editorControl.on("valueChanged", { self: this }, this.onEditorControlValueChanged);
                    editorControl.on("textChanged", { self: this }, this.onEditorControlTextChanged);

                    if (editorControl._getFocusElement)
                    {
                        var
                            $$focus = editorControl._getFocusElement();

                        $$focus.on("blur", { self: this }, this.onEditorControlBlur);
                        $$focus.on("focus", { self: this }, this.onEditorControlFocus);
                    }
                },
                _editorControlEventsRemove: function (editorControl)
                {
                    if (!editorControl)
                        return;

                    editorControl.off("valueChanged", { self: this }, this.onEditorControlValueChanged);
                    editorControl.off("textChanged", { self: this }, this.onEditorControlTextChanged);

                    if (editorControl._getFocusElement)
                    {
                        var
                            $$focus = editorControl._getFocusElement();

                        $$focus.off("blur", this.onEditorControlBlur);
                        $$focus.off("focus", this.onEditorControlFocus);
                    }
                },
                _enabledChanged: function (change)
                {
                    this.super._enabledChanged(change);
                    this.editorControlGet().enabledSet(change.currentValue);
                },
                _errorStateChanged: function (change)
                {
                    var
                        validationMessages = this.validationMessagesGet(),
                        hasValidationMessages = Array.isArray(validationMessages) && validationMessages.length,
                        showInlineValidationMessages = this.showInlineValidationMessagesGet();

                    this.super._errorStateChanged(change);
                    this.editorControlGet().errorStateSet(change.currentValue);

                    if (change.currentValue && showInlineValidationMessages && hasValidationMessages && this.validationPanel)
                    {
                        this.validationPanel.setErrorMessages(validationMessages);
                        this.validationPanel.show();
                    }
                    else if (this.validationPanel)
                        this.validationPanel.hide();
                },
                _hideLabelChanged: function (change)
                {
                    if (change.currentValue)
                        this.addCssClass("rad-state-label-hidden");
                    else
                        this.removeCssClass("rad-state-label-hidden");
                },
                _mandatoryChanged: function (change)
                {
                    this.super._mandatoryChanged(change);
                    this.editorControlGet().mandatorySet(this.mandatoryGet());
                },
                _mandatoryEvaluatorChanged: function (change)
                {
                    this.super._mandatoryEvaluatorChanged(change);
                    this.editorControlGet().mandatoryEvaluatorSet(this.mandatoryEvaluatorGet());
                },
                _maximumLengthChanged: function (change)
                {
                    var
                        editorControl = this.editorControlGet();

                    if (editorControl?.maximumLengthSet)
                        editorControl.maximumLengthSet(change.currentValue);
                },
                _pageChanged: function (change)
                {
                    this.super._pageChanged(change);

                    if (change.originalValue)
                    {
                        change.originalValue.off("creatingSaveBatch", { self: this }, this.onPageCreatingSaveBatch);
                        change.originalValue.off("editModeChanged", { self: this }, this.onPageEditModeChanged);
                    }

                    if (change.currentValue)
                    {
                        change.currentValue.on("creatingSaveBatch", { self: this }, this.onPageCreatingSaveBatch);
                        change.currentValue.on("editModeChanged", { self: this }, this.onPageEditModeChanged);

                        if (!this.__isConstructing() && change.currentValue?.editModeGet)
                            this.editModeSet(change.currentValue.editModeGet());
                    }
                },
                // TODO: Parent Changed
                _propertyDisplayNameChanged: function (change)
                {
                    this.labelControl.textSet(change.currentValue);
                },
                _readOnlyChanged: function (change)
                {
                    this.super._readOnlyChanged(change);

                    var
                        editorControl = this.editorControlGet();

                    if (editorControl instanceof seriouslyrad.ui.web.InputControl)
                        editorControl.readOnlySet(change.currentValue);
                },
                _registerSaveRequests: function (data)
                {
                    /* Intentionally empty */
                },
                _relevantEvaluatorChanged: function (change)
                {
                    if (this.relevantEvaluator)
                    {
                        this.relevantEvaluator.off("valueChanged", { self: this }, this.onRelevantEvaluatorValueChanged);
                        this.relevantEvaluator.contextSet(null);
                    }

                    if (change.currentValue)
                    {
                        this.relevantEvaluator =
                            change.currentValue instanceof seriouslyrad.logicevaluation.Evaluator
                                ? change.currentValue
                                : seriouslyrad.logicevaluation.Evaluator.fromDataObject(change.currentValue);

                        this.relevantEvaluator.on("valueChanged", { self: this }, this.onRelevantEvaluatorValueChanged);
                        this.relevantEvaluator.contextSet(this);
                    }
                    else
                        this.relevantEvaluator = null;

                    this.visibleEvaluatorSet(this.relevantEvaluator);
                },
                _setEditorControlDataSource: function ()
                {
                    this.editorControlGet().dataSourceSet(this.dataSourceGet());
                },
                _setEditorControlDataSourceProperty: function ()
                {
                    this.editorControlGet().dataSourcePropertySet(this.dataSourcePropertyGet());
                },
                _setEditorControlDataSourcePropertyType: function ()
                {
                    this.editorControlGet().dataSourcePropertyTypeSet(this.dataSourcePropertyTypeGet());
                },
                _showInlineValidationMessagesChanged: function (change)
                {
                    if (change.currentValue && !this.validationPanel)
                        this.validationPanel = new namespace.ValidationPanel({ shouldScrollToTop: false, titleTextWhenValidationError: String.empty }).appendTo(this.$$elementGet());
                },
                _updateValidationErrorsFromDataSource: function ()
                {
                    var
                        dataSource = this.dataSourceGet(),
                        dataSourceProperty = this.dataSourcePropertyGet(),
                        dataSourceValidationErrors = dataSource ? dataSource.validationErrorsGet() : null;

                    this.validationErrorsSet(
                        dataSourceValidationErrors && dataSourceProperty
                            ? dataSourceValidationErrors.where(item => item.propertyName?.toLowerCamelCasePath() === dataSourceProperty)
                            : null
                    );
                },
                _updateViewElement: function ()
                {
                    if (this.$$viewElement && !this.viewControlGet())
                    {
                        this.$$viewElement.empty();
                        this.$$viewElement.append($$.create$$({ nodeName: "p", text: this.editorControlGet().textGet() }));
                    }
                },
                _validate: function ()
                {
                    var
                        validationErrors = [],
                        value = this.valueGet(),
                        valueType = window.objectHelper.typeOf(value),
                        hasValue =
                            valueType === "string"
                                ? !String.isNullOrWhitespace(value)
                                : !Object.isNullOrUndefined(value);

                    if (this.isMandatoryGet() && !hasValue)
                    {
                        validationErrors.push({
                            errorMessage: String.format("{0} is required.", this.propertyDisplayNameGet())
                        });
                    }

                    if (validationErrors.length)
                        this.addCssClass("rad-state-error");
                    else
                        this.removeCssClass("rad-state-error");

                    return validationErrors;
                },
                _validationErrorsChanged: function (change)
                {
                    this.errorStateSet(!!(change.currentValue?.length));
                },
                _validationMessagesChanged: function (change)
                {
                    if (this.validationPanel)
                        this.validationPanel.setErrorMessages(change.currentValue);
                },
                _valueChanged: function (change)
                {
                    this.super._valueChanged(change);
                    this._updateViewElement();

                    if (change.currentValue)
                        this.removeCssClass("rad-state-empty");
                    else
                        this.addCssClass("rad-state-empty");
                },

                // Public Methods
                loadDataAsync: function ()
                {
                    return Promise.resolve();
                },
                relevantEvaluatorSet: function (value)
                {
                    if (typeof value === "string")
                        value = value.fromJson();

                    this._relevantEvaluatorSet(value);
                },
                remove: function ()
                {
                    this.removeControls([
                        this.labelControl,
                        this.editorControlGet(),
                        this.viewControlGet()
                    ]);

                    this.super.remove();
                },
                valueSet: function (value)
                {
                    if (this.valueGet() === value)
                        return false;

                    this._controlValueSet(value);
                    this.super.valueSet(this._controlValueGet());

                    this.updateDataSource();

                    return true;
                },
                valueSetSuper: function (value)
                {
                    this.super.valueSet(value); // For the event handler to use
                },

                // Event Handlers
                onDataSourceValidationErrorsChanged: function (evt, change)
                {
                    evt.data.self._updateValidationErrorsFromDataSource();
                },
                onEditorControlBlur: function (evt)
                {
                    evt.data.self.removeCssClass("rad-state-focussed");
                },
                onEditorControlFocus: function (evt)
                {
                    evt.data.self.addCssClass("rad-state-focussed");
                },
                onEditorControlTextChanged: function (evt)
                {
                    evt.data.self._updateViewElement();
                },
                onEditorControlValueChanged: function (evt)
                {
                    var
                        self = evt.data.self;

                    if (!self.processControlValueChanged)
                        return;

                    self.valueSetSuper(self._controlValueGet());
                    self._updateViewElement();
                    self.updateDataSource();
                    self.errorStateSet(false);
                },
                onPageCreatingSaveBatch: function (evt, eventData)
                {
                    evt.data.self._registerSaveRequests(eventData);
                },
                onPageEditModeChanged: function (evt, change)
                {
                    evt.data.self.editModeSet(change.currentValue);
                },
                onRelevantEvaluatorValueChanged: function (evt, change)
                {
                    /* Intentionally empty */
                }
            };
        }
    });

    // Property Editor: Barcode Text Box
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "PropertyEditorBarcodeTextBox",
        inherits: "PropertyEditor",
        properties: [
            { name: "allowManualEntry", type: "boolean" },
            { name: "barcodeType" },
            { name: "placeholder", type: "string" },
            { name: "title" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                editorControl: new namespace.BarcodeTextBox(),
                allowManualEntry: false,
                barcodeType: namespace.BarcodeTextBox.barcodeType.code_128_reader
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                // Trigger Property Changes
                this.placeholderTriggerChange();
                this.barcodeTypeTriggerChange();
                this.allowManualEntryTriggerChange();
                this.titleTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _allowManualEntryChanged: function (change)
                {
                    this.editorControlGet().allowManualEntrySet(change.currentValue);
                },
                _barcodeTypeChanged: function (change)
                {
                    this.editorControlGet().barcodeTypeSet(change.currentValue);
                },
                _placeholderChanged: function (change)
                {
                    this.editorControlGet().placeholderSet(change.currentValue);
                },
                _titleChanged: function (change)
                {
                    this.editorControlGet().titleSet(change.currentValue);
                }
            };
        }
    });

    // Property Editor: Calendar
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "PropertyEditorCalendar",
        inherits: "PropertyEditor",
        createPropertyDefaults: namespace =>
        {
            return {
                editorControl: new namespace.Calendar()
            };
        }
    });

    // Property Editor: Check Box
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "PropertyEditorCheckBox",
        inherits: "PropertyEditor",
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-property-editor-check-box");
            };
        },
        createPropertyDefaults: namespace =>
        {
            return {
                editorControl: new namespace.CheckBox()
            };
        }
    });

    // Property Editor: Check Box List
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "PropertyEditorCheckBoxList",
        inherits: "PropertyEditor",
        properties: [
            { name: "listDataSource" },
            { name: "listDataSourceDescriptionProperty", type: "string" },
            { name: "listDataSourceValueProperty", type: "string" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                editorControl: new namespace.CheckBoxList(),
                listDataSourceDescriptionProperty: "description",
                listDataSourceValueProperty: "value"
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                // Trigger Property Changes
                this.listDataSourceTriggerChange();
                this.listDataSourceDescriptionPropertyTriggerChange();
                this.listDataSourceValuePropertyTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _listDataSourceChanged: function (change)
                {
                    this.editorControlGet().listDataSourceSet(change.currentValue);
                },
                _listDataSourceDescriptionPropertyChanged: function (change)
                {
                    this.editorControlGet().listDataSourceDescriptionPropertySet(change.currentValue);
                },
                _listDataSourceValuePropertyChanged: function (change)
                {
                    this.editorControlGet().listDataSourceValuePropertySet(change.currentValue);
                }
            };
        }
    });

    // Property Editor: Check Box List (Permission - Entity)
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "PropertyEditorCheckBoxListPermissionEntity",
        inherits: "PropertyEditorCheckBoxList",
        createPropertyDefaults: namespace =>
        {
            return {
                editorControl: new namespace.CheckBoxListPermission()
            };
        },
        createPrototype: namespace =>
        {
            return {

                // Public Methods
                loadDataAsync: function ()
                {
                    var
                        self = this;

                    return (
                        window.application.webApiClient
                            .createApiMethodRequest("DataService", "CallDataService", { id: "2de87e78-0a5e-4b11-81ba-1d7fb096c440" })
                            .executeAsync()
                            .then(data =>
                            {
                                self.editorControlGet().listDataSourceSet(data.select(item => ({ value: item.value, description: item.description })));
                            })
                    );
                }
            };
        }
    });

    // Property Editor: Check Box List (Permission - Entity Property)
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "PropertyEditorCheckBoxListPermissionEntityProperty",
        inherits: "PropertyEditorCheckBoxListPermissionEntity",
        createPrototype: namespace =>
        {
            return {
                // Public Methods
                loadDataAsync: function ()
                {
                    var
                        self = this;

                    return (
                        window.application.webApiClient
                            .createApiMethodRequest("DataService", "CallDataService", { id: "48f9aaee-42b3-4315-a1df-7276230deb2a" })
                            .executeAsync()
                            .then(data =>
                            {
                                self.editorControlGet().listDataSourceSet(data.select(item => ({ value: item.value, description: item.description })));
                            })
                    );
                },
                mandatorySet: function (value)
                {
                    this.super.mandatorySet(false);
                },
                mandatoryEvaluatorSet: function (value)
                {
                    this.super.mandatoryEvaluatorSet(null);
                },
                updateMandatory: function ()
                {
                    // Don't show mandatory state as we default to 0
                    this.removeCssClass("rad-state-mandatory");
                }
            };
        }
    });

    // Property Editor: Color Picker
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "PropertyEditorColorPicker",
        inherits: "PropertyEditor",
        createPropertyDefaults: namespace =>
        {
            return {
                editorControl: new namespace.ColorPicker()
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-property-editor-color-picker");
            };
        }
    });

    // Property Editor: Combo Box
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "PropertyEditorComboBox",
        inherits: "PropertyEditor",
        properties: [
            { name: "allowEmptySelection", type: "boolean" },
            { name: "emptySelectionText", type: "string" },
            { name: "listDataSource" },
            { name: "listDataSourceDescriptionProperty", type: "string" },
            { name: "listDataSourceValueProperty", type: "string" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                allowEmptySelection: true,
                editorControl: new namespace.ComboBox(),
                listDataSourceDescriptionProperty: "description",
                listDataSourceValueProperty: "value"
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-property-editor-combo-box");

                // Trigger Property Changes
                this.allowEmptySelectionTriggerChange();
                this.emptySelectionTextTriggerChange();
                this.listDataSourceTriggerChange();
                this.listDataSourceDescriptionPropertyTriggerChange();
                this.listDataSourceValuePropertyTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _allowEmptySelectionChanged: function (change)
                {
                    this.editorControlGet().allowEmptySelectionSet(change.currentValue);
                },
                _emptySelectionTextChanged: function (change)
                {
                    this.editorControlGet().emptySelectionTextSet(change.currentValue);
                },
                _listDataSourceChanged: function (change)
                {
                    this.editorControlGet().listDataSourceSet(change.currentValue);
                },
                _listDataSourceDescriptionPropertyChanged: function (change)
                {
                    this.editorControlGet().listDataSourceDescriptionPropertySet(change.currentValue);
                },
                _listDataSourceValuePropertyChanged: function (change)
                {
                    this.editorControlGet().listDataSourceValuePropertySet(change.currentValue);
                }
            };
        }
    });

    // Property Editor: Combo Box (Application Entity)
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "PropertyEditorComboBoxApplicationEntity",
        inherits: "PropertyEditorComboBox",
        properties: [
            { name: "foreignEntityAlias", type: "string" },
            { name: "primaryEntity", type: "string" },
            { name: "primaryEntityDescriptionProperty", type: "string" },
            { name: "primaryEntityFilter", type: "string" },
            { name: "primaryEntityOrderProperty", type: "string" }
        ],
        propertyAttributes: [
            {
                propertyName: "foreignEntityAlias",
                designer: {
                    category: "Data",
                    displayName: "Foreign Entity Alias"
                }
            },
            {
                propertyName: "primaryEntity",
                designer: {
                    category: "Data",
                    displayName: "Primary Entity"
                }
            },
            {
                propertyName: "primaryEntityDescriptionProperty",
                designer: {
                    category: "Data",
                    displayName: "Primary Entity Description Property"
                }
            },
            {
                propertyName: "primaryEntityFilter",
                designer: {
                    category: "Data",
                    displayName: "Primary Entity Filter"
                }
            },
            {
                propertyName: "primaryEntityOrderProperty",
                designer: {
                    category: "Data",
                    displayName: "Primary Entity Order Property"
                }
            }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                editorControl: new namespace.ComboBoxApplicationEntity()
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                // Trigger Property Changes
                this.primaryEntityTriggerChange();
                this.primaryEntityDescriptionPropertyTriggerChange();
                this.primaryEntityFilterTriggerChange();
                this.primaryEntityOrderPropertyTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _hideIfPathControl: function ()
                {
                    var
                        page = this.pageGet();

                    if (!page)
                        return;

                    var
                        pageDataSource = page.dataSourceGet(),
                        dataSourceProperty = this.dataSourcePropertyGet();

                    if (!pageDataSource)
                    {
                        this.visibleSet(true);
                        return;
                    }

                    var
                        location = window.pathHelper.getLocation(page.urlGet()),
                        pathParts = location.applicationRelativeUrl.trimEnd("/").split("/"),
                        primaryEntity = this.primaryEntityGet(),
                        foreignEntityAlias = this.foreignEntityAliasGet();

                    if (primaryEntity && foreignEntityAlias)
                    {
                        if 
                            (
                                pathParts.length === 4
                                && pathParts[0].equals(primaryEntity, { ignoreCase: true })
                                && pathParts[2].equals(foreignEntityAlias, { ignoreCase: true })
                            )
                        {
                            if (dataSourceProperty)
                            {
                                page.dataSourcePropertyFromUrl = dataSourceProperty;
                                pageDataSource.propertyValueByPathSet(dataSourceProperty, pathParts[1]);
                            }

                            this.visibleSet(false);
                        }
                        else
                            this.visibleSet(true);
                    }
                },
                _primaryEntityChanged: function (change)
                {
                    this.editorControlGet().primaryEntitySet(change.currentValue);
                },
                _primaryEntityDescriptionPropertyChanged: function (change)
                {
                    this.editorControlGet().primaryEntityDescriptionPropertySet(change.currentValue);
                },
                _primaryEntityFilterChanged: function (change)
                {
                    this.editorControlGet().primaryEntityFilterSet(change.currentValue);
                },
                _primaryEntityOrderPropertyChanged: function (change)
                {
                    this.editorControlGet().primaryEntityOrderPropertySet(change.currentValue);
                },

                // Public Methods
                loadDataAsync: function ()
                {
                    this._hideIfPathControl();
                    return this.editorControlGet().loadDataAsync();
                },

                // Event Handlers
                onDataSourcePropertyValueChanged: function (evt, change)
                {
                    var
                        self = evt.data.self,
                        primaryEntityFilter = self.primaryEntityFilterGet();

                    if (primaryEntityFilter?.indexOf(String.format("[{0}]", change.path)) >= 0)
                    {
                        self.valueSet(null);
                        setTimeout(() => { self.loadDataAsync(); });
                    }
                }
            };
        }
    });

    // Property Editor: Combo Box (Data Service)
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "PropertyEditorComboBoxDataService",
        inherits: "PropertyEditorComboBox",
        properties: [
            { name: "dataServiceId", type: "string" },
            { name: "dataServiceData", type: "string" },
            { name: "dataServiceOperation", type: "string" }
        ],
        propertyAttributes: [
            {
                propertyName: "dataServiceId",
                designer: {
                    category: "Data",
                    displayName: "Data Service Id"
                }
            },
            {
                propertyName: "dataServiceData",
                designer: {
                    category: "Data",
                    displayName: "Data Service Data"
                }
            }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                editorControl: new namespace.ComboBoxDataService()
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                // Trigger Property Changes
                this.dataServiceIdTriggerChange();
                this.dataServiceDataTriggerChange();
                this.dataServiceOperationTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _dataServiceIdChanged: function (change)
                {
                    this.editorControlGet().dataServiceIdSet(change.currentValue);
                },
                _dataServiceDataChanged: function (change)
                {
                    this.editorControlGet().dataServiceDataSet(change.currentValue);
                },
                _dataServiceOperationChanged: function (change)
                {
                    this.editorControlGet().dataServiceOperationSet(change.currentValue);
                },

                // Public Methods
                loadDataAsync: function ()
                {
                    return this.editorControlGet().loadDataAsync();
                }
            };
        }
    });

    // Property Editor: Combo Box (Lookup Item)
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "PropertyEditorComboBoxLookupItem",
        inherits: "PropertyEditorComboBox",
        properties: [
            { name: "lookupType", type: "string" },
            { name: "orderBy", type: "string" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                editorControl: new namespace.ComboBoxLookupItem(),
                orderBy: "Description"
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                // Trigger Property Changes
                this.lookupTypeTriggerChange();
                this.orderByTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _disableIfPathControl: function ()
                {
                    var
                        page = this.pageGet();

                    if (!page || !(page instanceof namespace.DetailsPage))
                        return;

                    var
                        pageDataSource = page.dataSourceGet(),
                        dataSourceProperty = this.dataSourcePropertyGet();

                    if (!pageDataSource)
                    {
                        this.visibleSet(true);
                        return;
                    }

                    var
                        location = window.pathHelper.getLocation(page.urlGet()),
                        pathParts = location.applicationRelativeUrl.trimEnd("/").split("/"),
                        entityName = page.entityNameGet();

                    if (entityName !== "LookupItem" || dataSourceProperty !== "typeLookupItemId")
                        return;

                    if (!page.newRecordGet())
                    {
                        this.enabledSet(false);
                        return;
                    }

                    if
                    (
                        pathParts.length === 4
                        && pathParts[0].equals("LookupItems", { ignoreCase: true })
                        && pathParts[2].equals("LookupItemsByType", { ignoreCase: true })
                    )
                    {
                        pageDataSource.propertyValueByPathSet(dataSourceProperty, pathParts[1]);

                        this.enabledSet(false);
                    }
                    else
                        this.enabledSet(true);
                },
                _lookupTypeChanged: function (change)
                {
                    this.editorControlGet().lookupTypeSet(change.currentValue);
                },
                _orderByChanged: function (change)
                {
                    this.editorControlGet().orderBySet(change.currentValue);
                },

                // Public Methods
                loadDataAsync: function ()
                {
                    if (this.__isConstructing())
                        return;

                    this._disableIfPathControl();

                    return this.super.loadDataAsync();
                }
            };
        }
    });

    // Property Editor: Combo Box (Options)
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "PropertyEditorComboBoxOptions",
        inherits: "PropertyEditorComboBox"
    });

    // Property Editor: Combo Box (Yes / No)
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "PropertyEditorComboBoxYesNo",
        inherits: "PropertyEditorComboBox",
        properties: [
            { name: "value", type: "boolean", override: true }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                editorControl: new namespace.ComboBox({ listDataSource: [{ value: false, description: "No" }, { value: true, description: "Yes" }] })
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _listDataSourceChanged: function (change)
                {
                    /* Intentionally empty */
                },
                _listDataSourceDescriptionPropertyChanged: function (change)
                {
                    /* Intentionally empty */
                },
                _listDataSourceValuePropertyChanged: function (change)
                {
                    /* Intentionally empty */
                }
            };
        }
    });

    // Property Editor: Date
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "PropertyEditorDate",
        inherits: "PropertyEditor",
        createPropertyDefaults: namespace =>
        {
            return {
                editorControl: new namespace.Date()
            };
        }
    });

    // Property Editor: Date / Time
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "PropertyEditorDateTime",
        inherits: "PropertyEditor",
        createPropertyDefaults: namespace =>
        {
            return {
                editorControl: new namespace.DateTime()
            };
        }
    });

    // Property Editor: Evaluator Tree
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "PropertyEditorEvaluatorTree",
        inherits: "PropertyEditor",
        createPropertyDefaults: namespace =>
        {
            return {
                editorControl: new namespace.EvaluatorTree(),
                propagateInputEvents: true
            };
        }
    });

    // Property Editor: Entity Picker
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "PropertyEditorEntityPicker",
        inherits: "PropertyEditor",
        properties: [
            { name: "dialogClassPath", type: "string" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                editorControl: new namespace.EntityPicker()
            };
        },
        createConstructor: namespace =>
            function ()
            {
                // Trigger Property Changes
                this.dialogClassPathTriggerChange();
            },
        createPrototype: namespace =>
        ({
            // "Protected" Methods
            _dialogClassPathChanged: function (change)
            {
                const
                    editorControl = this.editorControlGet();

                if (editorControl)
                    editorControl.dialogClassPathSet(change.currentValue);
            }
        })
    });

    // Property Editor: File Upload
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "PropertyEditorFileUpload",
        inherits: "PropertyEditor",
        createPropertyDefaults: namespace =>
        {
            return {
                editorControl: new namespace.FileUpload()
            };
        }
    });

    // Property Editor: Image Picker
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "PropertyEditorImagePicker",
        inherits: "PropertyEditor",
        createPropertyDefaults: namespace =>
        {
            return {
                editorControl: new namespace.ImagePicker()
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-property-editor-image-picker");
            };
        }
    });

    // Property Editor: List Select (Application Entity)
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "PropertyEditorListSelectApplicationEntity",
        inherits: "PropertyEditor",
        properties: [
            { name: "allowMultipleSelection", type: "boolean" },
            { name: "primaryEntity", type: "string" },
            { name: "primaryEntityDescriptionProperty", type: "string" },
            { name: "primaryEntityOrderProperty", type: "string" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                editorControl: new namespace.ListSelectApplicationEntity()
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-property-editor-list-select-appliction-entity");

                // Trigger Property Changes
                this.allowMultipleSelectionTriggerChange();
                this.primaryEntityTriggerChange();
                this.primaryEntityDescriptionPropertyTriggerChange();
                this.primaryEntityOrderPropertyTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _allowMultipleSelectionChanged: function (change)
                {
                    this.editorControlGet().allowMultipleSelectionSet(change.currentValue);
                },
                _primaryEntityChanged: function (change)
                {
                    this.editorControlGet().primaryEntitySet(change.currentValue);
                },
                _primaryEntityDescriptionPropertyChanged: function (change)
                {
                    this.editorControlGet().primaryEntityDescriptionPropertySet(change.currentValue);
                },
                _primaryEntityOrderPropertyChanged: function (change)
                {
                    this.editorControlGet().primaryEntityOrderPropertySet(change.currentValue);
                },
                _updateEmptyStatus: function ()
                {
                    var
                        value = this.valueGet();

                    if (value?.length)
                        this.removeCssClass("rad-state-empty");
                    else
                        this.addCssClass("rad-state-empty");
                },
                _valueChanged: function (change)
                {
                    this.super._valueChanged(change);
                    this._updateEmptyStatus();
                },
            };
        }
    });

    // Property Editor: Numeric Up Down
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "PropertyEditorNumericUpDown",
        inherits: "PropertyEditor",
        createPropertyDefaults: namespace =>
        {
            return {
                editorControl: new namespace.NumericUpDown()
            };
        }
    });

    // Property Editor: Schedule
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "PropertyEditorSchedule",
        inherits: "PropertyEditor",
        createPropertyDefaults: namespace =>
        {
            return {
                editorControl: new namespace.Schedule()
            };
        }
    });

    // Property Editor: Source Code
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "PropertyEditorSourceCode",
        inherits: "PropertyEditor",
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-property-editor-source-code");
            };
        },
        createPropertyDefaults: namespace =>
        {
            return {
                editorControl: new namespace.SourceCode(),
                propagateInputEvents: true
            };
        }
    });

    // Property Editor: Switch
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "PropertyEditorSwitch",
        inherits: "PropertyEditor",
        createPropertyDefaults: namespace =>
        {
            return {
                editorControl: new namespace.Switch()
            };
        }
    });

    // Property Editor: Text
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "PropertyEditorText",
        inherits: "PropertyEditor",
        createPropertyDefaults: namespace =>
        {
            return {
                editorControl: new namespace.Text()
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-property-editor-text");
            };
        }
    });

    // Property Editor: Text (Application Entity)
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "PropertyEditorTextApplicationEntity",
        inherits: "PropertyEditor",
        properties: [
            { name: "primaryEntity", type: "string" },
            { name: "primaryEntityDescriptionProperty", type: "string" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                editorControl: new namespace.TextApplicationEntity()
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                // Trigger Property Changes
                this.primaryEntityTriggerChange();
                this.primaryEntityDescriptionPropertyTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _primaryEntityChanged: function (change)
                {
                    this.editorControlGet().primaryEntitySet(change.currentValue);
                },
                _primaryEntityDescriptionPropertyChanged: function (change)
                {
                    this.editorControlGet().primaryEntityDescriptionPropertySet(change.currentValue);
                },

                // Public Methods
                loadDataAsync: function ()
                {
                    return this.editorControlGet().loadDataAsync();
                }
            };
        }
    });

    // Property Editor: Text Box
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "PropertyEditorTextBox",
        inherits: "PropertyEditor",
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-property-editor-text-box");
            };
        },
        createPropertyDefaults: namespace =>
        {
            return {
                editorControl: new namespace.TextBox()
            };
        }
    });

    // Property Editor: Text Box (Currency)
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "PropertyEditorTextBoxCurrency",
        inherits: "PropertyEditorTextBox"
    });

    // Property Editor: Text Box (Guid)
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "PropertyEditorTextBoxGuid",
        inherits: "PropertyEditorTextBox",
        createPropertyDefaults: namespace =>
        {
            return {
                maximumLength: 36
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _controlValueSet: function (value)
                {
                    if (!this._validateValue(value))
                        return;

                    this.super._controlValueSet(value);
                },
                _validateValue: function (value)
                {
                    if (value === null || value.isGuid())
                        return true;

                    namespace.ErrorDialog.displayError("Value must be a valid Guid.");

                    return false;
                },

                // Public Methods
                valueSet: function (value)
                {
                    if (!this._validateValue(value))
                        return;

                    this.super.valueSet(value);
                }
            };
        }
    });

    // Property Editor: Text Box (Large)
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "PropertyEditorTextBoxLarge",
        inherits: "PropertyEditorTextBox",
        createPropertyDefaults: namespace =>
        {
            return {
                maximumLength: 128
            };
        }
    });

    // Property Editor: Text Box (Medium)
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "PropertyEditorTextBoxMedium",
        inherits: "PropertyEditorTextBox",
        createPropertyDefaults: namespace =>
        {
            return {
                maximumLength: 64
            };
        }
    });

    // Property Editor: Text Box (Multiline)
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "PropertyEditorTextBoxMultiline",
        inherits: "PropertyEditor",
        createPropertyDefaults: namespace =>
        {
            return {
                editorControl: new namespace.TextBox({ type: namespace.TextBox.type.multiline })
            };
        }
    });

    // Property Editor: Text Box (Password)
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "PropertyEditorTextBoxPassword",
        inherits: "PropertyEditorTextBox",
        createPropertyDefaults: namespace =>
        {
            return {
                editorControl: new namespace.TextBox({ type: namespace.TextBox.type.password }),
                maximumLength: 64,
                viewControl: new namespace.PropertyEditorTextBoxPassword.TextPassword()
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            classFactory.create({
                namespace: classConstructor,
                name: "TextPassword",
                inherits: "seriouslyrad.ui.web.Text",
                createPrototype: namespace =>
                {
                    return {
                        // Public Methods
                        textSet: function (value)
                        {
                            this._textSet(value ? "****************" : null);
                        }
                    };
                }
            });
        }
    });

    // Property Editor: Text Box (Small)
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "PropertyEditorTextBoxSmall",
        inherits: "PropertyEditorTextBox",
        createPropertyDefaults: namespace =>
        {
            return {
                maximumLength: 16
            };
        }
    });

    // Property Editor: Time Span
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "PropertyEditorTimeSpan",
        inherits: "PropertyEditor",
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-property-editor-time-span");
            };
        },
        createPropertyDefaults: namespace =>
        {
            return {
                editorControl: new namespace.TimeSpan()
            };
        }
    });

    // Property Editor: Value
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "PropertyEditorValue",
        inherits: "PropertyEditorTextBox"
    });

    // #endregion

    // #region Entity Editors

    // Entity Editor
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "EntityEditor",
        inherits: "Control",
        abstract: true,
        properties: [
            { name: "editMode", type: "boolean" },
            { name: "editorControl" },
            { name: "editorControlProperties" },
            { name: "helpText", type: "string" },
            { name: "mandatory", type: "boolean" },
            { name: "mandatoryEvaluator" }
        ],
        propertyAttributes: [
            {
                propertyName: "helpText",
                designer: {
                    category: "Appearance",
                    displayName: "Help Text"
                }
            },
            {
                propertyName: "mandatory",
                designer: {
                    category: "Behavior",
                    displayName: "Mandatory"
                }
            },
            {
                propertyName: "mandatoryEvaluator",
                designer: {
                    category: "Behavior",
                    displayName: "Mandatory Evaluator",
                    propertyEditorClass: "seriouslyrad.ui.web.PropertyEditorEvaluatorTree"
                }
            }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                editMode: false,
                mandatory: false,
                text: "Property"
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-entity-editor field");
                this.processControlValueChanged = true;

                // Trigger Property Changes
                this.editModeTriggerChange();
                this.helpTextTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _bindEvents: function ()
                {
                    this.super._bindEvents();
                    this.editorControlGet().on("textChanged", { self: this }, this.onEditorControlTextChanged);
                },
                _createElement: function ()
                {
                    this.super._createElement();

                    var
                        $$element = this.$$elementGet(),
                        editorControl = this.editorControlGet();

                    if (!editorControl)
                    {
                        var
                            $$childElement = $$element.children().first();

                        if ($$childElement.length)
                        {
                            editorControl = namespace.Control.createFromElement($$childElement);
                            this.editorControlSet(editorControl);
                        }
                    }

                    if (!editorControl)
                        console.error("Editor Control is mandatory.");

                    var
                        editorControlProperties = this.editorControlPropertiesGet();

                    if (editorControlProperties)
                        editorControl.setProperties(editorControlProperties);

                    // Make sure the property editor value is the same as the editorControl default.
                    //this._valueSet(editorControl.valueGet());

                    this.labelControl = new namespace.Label({ associatedControl: editorControl, colon: true });
                    this.labelControl.appendTo($$element);
                    this.$$viewElement = $$.create$$("div", "rad-field-view").appendTo($$element);
                    this.$$editElement = $$.create$$("div", "rad-field-edit").appendTo($$element);
                    $$.create$$("div", "rad-clear-float").appendTo($$element);

                    editorControl.appendTo(this.$$editElement);
                },
                _editModeChanged: function (change)
                {
                    if (change.currentValue)
                        this.addCssClass("rad-state-edit");
                    else
                        this.removeCssClass("rad-state-edit");
                },
                _editorControlChanged: function (change)
                {
                    if (!this.labelControl)
                        this.labelControl = new namespace.Label({ associatedControl: change.currentValue, colon: true });
                    else
                        this.labelControl.associatedControlSet(change.currentValue);
                },
                _enabledChanged: function (change)
                {
                    this.super._enabledChanged(change);
                    this.editorControlGet().enabledSet(change.currentValue);
                },
                _errorStateChanged: function (change)
                {
                    this.super._errorStateChanged(change);
                    this.editorControlGet().errorStateSet(change.currentValue);
                },
                _mandatoryChanged: function (change)
                {
                    this.editorControlGet().mandatorySet(this.mandatoryGet());
                },
                _mandatoryEvaluatorChanged: function (change)
                {
                    this.editorControlGet().mandatoryEvaluatorSet(this.mandatoryEvaluatorGet());
                },
                _pageChanged: function (change)
                {
                    this.super._pageChanged(change);

                    if (change.originalValue)
                    {
                        change.originalValue.off("creatingSaveBatch", { self: this }, this.onPageCreatingSaveBatch);
                        change.originalValue.off("editModeChanged", { self: this }, this.onPageEditModeChanged);
                    }

                    if (change.currentValue)
                    {
                        change.currentValue.on("creatingSaveBatch", { self: this }, this.onPageCreatingSaveBatch);
                        change.currentValue.on("editModeChanged", { self: this }, this.onPageEditModeChanged);
                    }
                },
                _registerSaveRequests: function (data)
                {
                    /* Intentionally empty */
                },
                _textChanged: function (change)
                {
                    this.super._textChanged(change);

                    this.labelControl.textSet(change.currentValue);
                },

                // Public Methods
                loadDataAsync: function ()
                {
                    return Promise.resolve();
                },

                // Event Handlers
                onEditorControlTextChanged: function (evt)
                {
                    var
                        self = evt.data.self;

                    if (self.$$viewElement)
                    {
                        self.$$viewElement.empty();
                        self.$$viewElement.append($$.create$$({ nodeName: "p" }).text(self.editorControlGet().textGet()));
                    }
                },
                onPageCreatingSaveBatch: function (evt, eventData)
                {
                    evt.data.self._registerSaveRequests(eventData);
                },
                onPageEditModeChanged: function (evt, change)
                {
                    evt.data.self.editModeSet(change.currentValue);
                }
            };
        }
    });

    // #endregion

    // #region Page Dimmer

    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "PageDimmer",
        inherits: "ContainerControl",
        properties: [
            { name: "animationIn", type: "string" },
            { name: "animationOut", type: "string" },
            { name: "repositionChildren", type: "boolean" }
        ],
        propertyAttributes: [
            {
                propertyName: "animationIn",
                designer: {
                    category: "Appearance",
                    displayName: "Animation In"
                }
            },
            {
                propertyName: "animationOut",
                designer: {
                    category: "Appearance",
                    displayName: "Animation Out"
                }
            },
            {
                propertyName: "repositionChildren",
                designer: {
                    category: "Behavior",
                    displayName: "Reposition Children"
                }
            }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                animationIn: "fade in",
                animationOut: "fade out",
                repositionChildren: false
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-page-dimmer ui page dimmer");
                this.$$currentElement = null;
                this.currentControl = null;
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _bindEvents: function ()
                {
                    this.super._bindEvents();
                    $$(window).on("resizeend", { self: this }, this.onWindowResizeEnd);
                },
                _createElement: function ()
                {
                    this.super._createElement();

                    var
                        $$element = this.$$elementGet();

                    /* PH: fix for the IOS bug where the event handler never fires on the dimmer.
                       See http://stackoverflow.com/questions/14795944/jquery-click-events-not-working-in-ios */
                    // $$element.attr("onclick", String.empty); // This causes the console error: Refused to execute inline event handler because it violates the following Content Security Policy directive
                    if (window.device?.platform?.toLowerCase() === "ios")
                        $$element.css("cursor", "pointer");
                },
                _currentElementHideAsync: function ()
                {
                    var
                        self = this;

                    return new Promise(resolve =>
                    {
                        var
                            $$currentElement = self.$$currentElement,
                            currentControl = self.currentControl;

                        if ($$currentElement)
                        {
                            var
                                animationOut = this.currentControl?.animationOut !== void 0 ? this.currentControl.animationOut : this.animationOutGet();

                            if (animationOut && $$currentElement.css("display") !== "none")
                            {
                                $$currentElement
                                    .transition("stop all")
                                    .transition({
                                        animation: animationOut + " out",
                                        onComplete: function ()
                                        {
                                            if (currentControl)
                                                currentControl.hide();
                                            else if ($$currentElement)
                                                $$currentElement.hide();

                                            resolve();
                                        }
                                    });
                            }
                            else
                            {
                                setTimeout(() =>
                                {
                                    if (currentControl)
                                        currentControl.hide();
                                    else if ($$currentElement)
                                        $$currentElement.hide();

                                    resolve();
                                });
                            }
                        }
                        else
                            resolve();
                    });
                },
                _currentElementReposition: function (animate)
                {
                    if (!this.repositionChildrenGet())
                        return;

                    if (!this.$$currentElement || !this.$$currentElement.length)
                        return;

                    var
                        $$element = this.$$elementGet(),
                        elementWidthWithoutScrollbars = $$element.prop("clientWidth");

                    if (animate)
                    {
                        this.$$currentElement
                            .stop()
                            .animate({
                                top: this.$$currentElement.outerHeight(true) < $$element.height() * 0.7 ? $$element.height() * 0.3 : 0,
                                left: (elementWidthWithoutScrollbars - this.$$currentElement.outerWidth()) / 2
                            });
                    }
                    else
                    {
                        this.$$currentElement
                            .stop()
                            .css({
                                top: this.$$currentElement.outerHeight(true) < $$element.height() * 0.7 ? $$element.height() * 0.3 : 0,
                                left: (elementWidthWithoutScrollbars - this.$$currentElement.outerWidth()) / 2
                            });
                    }
                },
                _currentElementShowAsync: function ()
                {
                    var
                        self = this;

                    return new Promise((resolve, reject) =>
                    {
                        if (self.$$currentElement)
                        {
                            if (self.currentControl)
                                self.currentControl.show();
                            else
                                self.$$currentElement.show();

                            self._currentElementReposition(false);

                            self.$$currentElement.css("visibility", "hidden");
                            self.$$currentElement.removeClass("hidden");

                            let
                                initialPromise = Promise.resolve();

                            if (self.currentControl)
                            {
                                if (self.currentControl.loadAsync && self.currentControl.loadedGet && !self.currentControl.loadedGet())
                                    initialPromise = initialPromise.then(() => self.currentControl.loadAsync());

                                if (self.currentControl.activateAsync)
                                    initialPromise = initialPromise.then(() => self.currentControl.activateAsync());
                            }

                            initialPromise
                                .then(() =>
                                {
                                    self.$$currentElement.addClass("hidden");
                                    self.$$currentElement.css("visibility", String.empty);

                                    var
                                        animationIn = self.currentControl?.animationIn !== void 0 ? self.currentControl.animationIn : self.animationInGet();

                                    if (animationIn)
                                    {
                                        self.$$currentElement
                                            .transition("stop all")
                                            .transition({
                                                animation: animationIn + " in",
                                                onComplete: function ()
                                                {
                                                    resolve();
                                                }
                                            });
                                    }
                                    else
                                    {
                                        setTimeout(() =>
                                        {
                                            resolve();
                                        });
                                    }
                                })
                                .catch(error =>
                                {
                                    self.$$currentElement.addClass("hidden");
                                    self.$$currentElement.css("visibility", String.empty);

                                    let
                                        errorMessage;

                                    if (typeof error === "string")
                                        errorMessage = error;
                                    else if (error instanceof Error)
                                        errorMessage = error.message;
                                    else
                                        errorMessage = "An error occurred";

                                    namespace.ErrorDialog.displayError(errorMessage)
                                        .then(() =>
                                        {
                                            return self.hideElementOrControlAsync(self.$$currentElement);
                                        })
                                        .then(() =>
                                        {
                                            reject(errorMessage);
                                        });
                                });
                        }
                        else
                            resolve();
                    });
                },
                _disablePageScrolling: function ()
                {
                    var
                        scrollBarDimensions = window.pageManager.scrollBarDimensionsGet();

                    $$(".rad-control-page.rad-feature-scrollable >.rad-control-container-wrapper")
                        .each((index, element) =>
                        {
                            $$(element).css({
                                overflow: "hidden",
                                paddingRight: scrollBarDimensions.width + "px"
                            })
                        });
                },
                _disableTabStops: function ()
                {
                    if ($$("body").hasClass("rad-state-dimmed"))
                        return;

                    var
                        self = this,
                        $$element = self.$$elementGet()[0];

                    // Get all rad-controls excluding those contained within the dimmer
                    $$(".rad-control").not($$element).each((index, element) =>
                    {
                        var
                            control = $$.radControl(element);

                        if (!control)
                            return;
                        
                        control.dimmedSet(true);
                    });

                    // Get anything else that hasn't been dimmed and isn't within the dimmer
                    $$(FOCUSABLE_ELEMENTS_SELECTOR + ", [tabindex]").not("[data-tabindex-backup]").not($$element).each((index, element) =>
                    {
                        var
                            $$this = $$(element),
                            tabIndex = $$this.attr("tabindex");

                        if (tabIndex !== undefined)
                            $$this.attr("data-tabindex-backup", tabIndex);

                        $$this.attr("tabindex", -1);
                    });
                },
                _enablePageScrolling: function ()
                {
                    $$(".rad-control-page.rad-feature-scrollable >.rad-control-container-wrapper")
                        .each((index, element) =>
                        {
                            $$(element).css({
                                overflow: String.empty,
                                paddingRight: String.empty
                            })
                        });
                },
                _enableTabStops: function ()
                {
                    var
                        element = this.$$elementGet()[0];

                    // get all rad-controls excluding those contained within the dimmer
                    $$(".rad-control").not(element).each((index, element) =>
                    {
                        var
                            control = $$.radControl(element);

                        if (!control)
                            return;

                        control.dimmedSet(false);
                    });

                    // get anything else that is still dimmed
                    $$(FOCUSABLE_ELEMENTS_SELECTOR + ", [data-tabindex-backup]").each((index, element) =>
                    {
                        var
                            $$this = $$(element),
                            tabIndexBackup = $$this.attr("data-tabindex-backup");

                        if (tabIndexBackup !== undefined)
                        {
                            $$this.attr("tabindex", tabIndexBackup);
                            $$this.removeAttr("data-tabindex-backup");
                        }
                        else
                            $$this.removeAttr("tabindex");
                    });
                },
                _getElementFromElementOrControl: function ($$elementOrControl)
                {
                    if (Array.isArray($$elementOrControl))
                        return $$($$elementOrControl.firstOrDefault());
                    else if ($$elementOrControl instanceof jQuery)
                        return $$($$elementOrControl.get(0));
                    else if ($$elementOrControl instanceof namespace.Control)
                        return $$elementOrControl.$$elementGet();
                    return null;
                },
                _hide: function ()
                {
                    // Dimmer only hides if empty.
                    if (this.$$elementGet().children().length > 0)
                        return;

                    this.removeCssClass("visible active");
                    this.$$elementGet().detach();
                    namespace.PageDimmer.dimmersActive--;

                    if (namespace.PageDimmer.dimmersActive === 0)
                    {
                        this._enableTabStops();
                        $$("body").removeClass("rad-state-dimmed");
                        this._enablePageScrolling();
                    }
                },
                _show: function ()
                {
                    // Dimmer only shows if not already visible.
                    if (this.shown())
                        return;

                    if (namespace.PageDimmer.dimmersActive === 0)
                    {
                        this._disableTabStops();
                        $$("body").addClass("rad-state-dimmed");
                        this._disablePageScrolling();
                    }

                    if (!namespace.PageDimmer.dimmerWrapperElement)
                    {
                        namespace.PageDimmer.dimmerWrapperElement = $$.create({ nodeName: "div", attributes: { "class": "rad-control-page-dimmer-wrapper" } });
                        document.body.appendChild(namespace.PageDimmer.dimmerWrapperElement);
                    }
                    
                    this.appendTo(namespace.PageDimmer.dimmerWrapperElement);
                    this.addCssClass("visible active");

                    namespace.PageDimmer.dimmersActive++;
                },

                // Public Methods
                hideAllAsync: function ()
                {
                    var
                        self = this;

                    if (namespace.PageDimmer.dimmersActive === 0)
                        return Promise.resolve();

                    return (
                        self._currentElementHideAsync()
                            .then(() =>
                            {
                                for (let child of self.$$elementGet().children())
                                {
                                    const
                                        $$element = $$(child),
                                        control = $$element.radControl();

                                    if (control)
                                        control.detach();
                                    else
                                        $$element.detach();
                                }

                                self.$$currentElement = null;
                                self._hide();
                            })
                    );
                },
                hideElementOrControlAsync: function ($$elementOrControl)
                {
                    var
                        self = this;

                    if (namespace.PageDimmer.dimmersActive === 0)
                        return Promise.resolve();

                    var
                        $$elementToHide = self._getElementFromElementOrControl($$elementOrControl),
                        controlToHide = $$elementToHide.radControl();

                    if (!$$elementToHide || !$$elementToHide.length)
                        console.error("Unable to determine $$elementOrControl.");

                    if (!$$elementToHide.parent().is(self.$$elementGet()))
                        console.error("$$elementOrControl is not a direct child of the dimmer.");

                    if (!$$elementToHide.is(self.$$currentElement))
                    {
                        const
                            control = $$elementToHide.radControl();

                        if (control)
                            control.detach();
                        else
                            $$elementToHide.detach();

                        return Promise.resolve();
                    }

                    return new Promise((resolve, reject) =>
                    {
                        self._currentElementHideAsync()
                            .then(() =>
                            {
                                if (controlToHide)
                                    controlToHide.detach();
                                else
                                    $$elementToHide.detach();

                                var
                                    $$lastElement = self.$$elementGet().children().last();

                                if ($$lastElement.length)
                                {
                                    if ($$lastElement.is(self.$$currentElement))
                                    {
                                        resolve();
                                        return;
                                    }

                                    self.$$currentElement = self.$$elementGet().children().last();
                                    self.currentControl = self.$$currentElement.radControl();

                                    self._currentElementShowAsync()
                                        .then(() =>
                                        {
                                            resolve();
                                        })
                                        .catch(error =>
                                        {
                                            reject(error);
                                        });
                                }
                                else
                                {
                                    self.$$currentElement = null;
                                    self.currentControl = null;
                                    self._hide();
                                    resolve();
                                }
                            });
                    });
                },
                showElementOrControlAsync: function ($$elementOrControl)
                {
                    var
                        self = this,
                        $$elementToShow = self._getElementFromElementOrControl($$elementOrControl);

                    if (!$$elementToShow || !$$elementToShow.length)
                        console.error("Unable to determine $$elementOrControl.");

                    if ($$elementToShow.parent().is(self.$$elementGet()))
                        console.error("$$elementOrControl is already a direct child of the dimmer.");

                    if ($$elementToShow.is(self.$$currentElement))
                        return Promise.resolve();

                    return (
                        self._currentElementHideAsync()
                            .then(() =>
                            {
                                self._show();

                                $$elementToShow.appendTo(self.$$elementGet());
                                self.$$currentElement = $$elementToShow;
                                self.currentControl = self.$$currentElement.radControl();

                                if (self.currentControl instanceof namespace.Page)
                                    self.$$elementGet().css({ "overflow": self.currentControl.scrollableGet() ? "hidden" : "auto" });
                                else
                                    self.$$elementGet().css({ "overflow": String.empty });

                                return self._currentElementShowAsync();
                            })
                    );
                },
                shown: function ()
                {
                    return this.hasCssClass("visible active");
                },

                onWindowResizeEnd: function (evt)
                {
                    evt.data.self._currentElementReposition(true);
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.dimmersActive = 0;
        }
    });

    // #endregion

    // #region Loaders

    // Loader
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "FullPageLoader",
        inherits: "Control",
        properties: [
            { name: "mode", type: "string" },
            { name: "queueLength", type: "int" },
            { name: "total", type: "int" },
            { name: "value", type: "int" }
        ],
        propertyAttributes: [
            {
                propertyName: "mode",
                designer: {
                    category: "Behavior",
                    displayName: "Display Mode",
                    propertyEditorClass: seriouslyrad.ui.web.PropertyEditorComboBox,
                    propertyEditorProperties: {
                        editorControlProperties: {
                            listDataSource: [
                                { value: "loader", description: "Loader" },
                                { value: "progress", description: "Progress" }
                            ]
                        }
                    }
                }
            }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                mode: namespace.FullPageLoader.modes.loader,
                queueLength: 0,
                text: "Please wait...",
                value: 0
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-full-page-loader content hidden ui active dimmer");

                this.dimmer = new namespace.PageDimmer({ cssClass: "rad-control-full-page-dimmer" });
                this.waitTimeInMilliseconds = 250;
                this.dimmerShown = false;
                this.updatingDisplay = false;
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _createElement: function ()
                {
                    this.super._createElement();

                    var
                        $$element = this.$$elementGet();

                    switch (this.modeGet())
                    {
                        case "loader":
                            {
                                $$(String.formatWithHtmlEncode("<div class=\"ui text loader\">{0}</div>", this.textGet()))
                                    .appendTo($$element);

                                break;
                            }
                        case "progress":
                            {
                                this.progress = new namespace.ProgressBar({ total: this.totalGet(), text: this.textGet(), invertStyles: true });
                                this.progress.appendTo($$element);

                                this.addCssClass("rad-mode-progress");

                                break;
                            }
                    }
                },
                _queueLengthChanged: function (change)
                {
                    var
                        self = this;

                    if (!change.originalValue && change.currentValue)
                    {
                        if (self.modeGet() === "progress")
                            self.progress.reset();

                        if (!self.showDimmerTimeoutId)
                        {
                            self.showDimmerTimeoutId = setTimeout(() =>
                            {
                                self._updateDisplay();
                            }, self.waitTimeInMilliseconds);
                        }
                    }
                    else if (change.originalValue && !change.currentValue)
                    {
                        if (self.showDimmerTimeoutId)
                        {
                            clearTimeout(self.showDimmerTimeoutId);
                            self.showDimmerTimeoutId = 0;
                        }

                        self._updateDisplay();
                    }
                },
                _textChanged: function (change)
                {
                    this.super._textChanged(change);

                    switch (this.modeGet())
                    {
                        case "loader":
                            {
                                this.$$elementGet().find("> loader").html(change.currentValue);
                                break;
                            }
                        case "progress":
                            {
                                this.progress.textSet(change.currentValue);
                                break;
                            }
                    }
                },
                _totalChanged: function (change)
                {
                    if (this.modeGet() === "progress")
                        this.progress.totalSet(change.currentValue);
                },
                _updateDisplay: function ()
                {
                    var
                        self = this;

                    if (self.updatingDisplay)
                        return;

                    if (self.queueLengthGet() > 0 && !self.dimmerShown)
                    {
                        self.updatingDisplay = true;

                        self.dimmer.showElementOrControlAsync(self)
                            .then(() =>
                            {
                                self.dimmerShown = true;
                                self.updatingDisplay = false;
                                self._updateDisplay();
                            });
                    }
                    else if (self.queueLengthGet() === 0 && self.dimmerShown)
                    {
                        self.updatingDisplay = true;

                        self.dimmer.hideElementOrControlAsync(self)
                            .then(() =>
                            {
                                self.dimmerShown = false;
                                self.updatingDisplay = false;
                                self._updateDisplay();
                            });
                    }
                },
                _valueChanged: function (change)
                {
                    this.super._valueChanged(change);

                    if (this.modeGet() === "progress")
                        this.progress.valueSet(change.currentValue);
                },

                // Public Methods
                dequeue: function ()
                {
                    this.queueLengthSet(Math.max(0, this.queueLengthGet() - 1));
                },
                enqueue: function ()
                {
                    this.queueLengthSet(this.queueLengthGet() + 1);
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.modes = {
                loader: "loader",
                progress: "progress"
            };

            function isRequestSameOrigin(url)
            {
                return window.pathHelper.getLocation(window.location).origin === window.pathHelper.getLocation(url).origin;
            }

            $$(() =>
            {
                window.fullPageLoader = new classConstructor();

                $$(document).on("ajaxSend", (evt, eventData) =>
                {
                    const
                        options = eventData.options;

                    if (options.showLoading === undefined)
                        options.showLoading = true;

                    if (options.showLoading && !(window.applicationInformation.hideFullPageLoaderForSameOriginRequests && isRequestSameOrigin(options.url)))
                        window.fullPageLoader.enqueue();
                });

                $$(document).on("ajaxComplete", (evt, eventData) =>
                {
                    const
                        options = eventData.options;

                    if (options.showLoading === undefined)
                        options.showLoading = true;

                    if (options.showLoading && !(window.applicationInformation.hideFullPageLoaderForSameOriginRequests && isRequestSameOrigin(options.url)))
                        window.fullPageLoader.dequeue();
                });
            });
        }
    });

    // Control Overlay Loader
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "ControlOverlayLoader",
        inherits: "Control",
        properties: [
            { name: "showSpinner", type: "boolean" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                showSpinner: true,
                text: "Loading"
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-control-overlay-loader ui segment");

                // Trigger Property Changes
                this.showSpinnerTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _createElement: function ()
                {
                    this.super._createElement();

                    var
                        $$element = this.$$elementGet();

                    $$element.append(
                        $$.create([
                            { nodeName: "div", attributes: { "class": "ui active dimmer inverted" } },
                            { nodeName: "div", attributes: { "class": "ui text loader", text: "Loading" } },
                            { nodeName: "p" }
                        ])
                    );
                },
                _showSpinnerChanged: function (change)
                {
                    if (change.currentValue)
                        this.$$elementGet().find(".ui.text").addClass("loader");
                    else
                        this.$$elementGet().find(".ui.text").removeClass("loader");
                },
                _textChanged: function (change)
                {
                    this.super._textChanged(change);
                    this.$$elementGet().find(".ui.text").text(change.currentValue);
                },

                // Public Methods
                hide: function ()
                {
                    var
                        self = this;

                    if (self.hideTimeoutId)
                        return;

                    self.hideTimeoutId =
                        setTimeout(
                            () =>
                            {
                                self.hideTimeoutId = 0;
                                self.hideImmediately();
                                self = null;
                            },
                            Math.min(new Date() - self.dateShown, 200)
                        );
                },
                hideImmediately: function ()
                {
                    this.super.hide();
                },
                show: function ()
                {
                    if (self.hideTimeoutId)
                    {
                        clearTimeout(self.hideTimeoutId);
                        self.hideTimeoutId = 0;
                    }

                    this.dateShown = new Date();
                    this.super.show();
                }
            };
        }
    });

    // #endregion

    // #region Pages

    // Page
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "Page",
        inherits: "ContainerControl",
        properties: [
            { name: "active", type: "boolean" },
            { name: "activated", type: "boolean" },
            { name: "cacheExpiry", type: "int" },
            { name: "dialogAnimationIn", type: "string" },
            { name: "dialogAnimationOut", type: "string" },
            { name: "dialogView", type: "boolean" },
            { name: "loaded", type: "boolean" },
            { name: "navigationData" },
            { name: "noCache", type: "boolean" },
            { name: "scrollable", type: "boolean" },
            { name: "showPageHeader", type: "boolean" },
            { name: "title", type: "string" },
            { name: "transitionType", type: "string" },
            { name: "transitionName", type: "string" },
            { name: "url", type: "string" }
        ],
        propertyAttributes: [
            {
                propertyName: "title",
                designer: {
                    category: "Appearance",
                    displayName: "Title"
                }
            }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                activated: false,
                active: false,
                cacheExpiry: -1,
                cssClass: "rad-control-page",
                dialogAnimationIn: "slide left in",
                dialogAnimationOut: "slide left out",
                dialogView: false,
                isVisible: false,
                loaded: false,
                noCache: false,
                scrollable: true,
                showPageHeader: true,
                transitionType: "animation",
                transitionName: "bouncy"
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this._blockNavigationFunction = () =>
                {
                    return this.dialogViewGet() && this.dialogDimmer?.shown();
                };

                this.addCssClass("rad-control-page");

                this.$$headerElement.addClass("rad-page-header ui container fluid");
                this.$$containerWrapper.addClass("rad-control-container-wrapper");
                this.$$containerInnerWrapper.addClass("rad-control-container-inner-wrapper");
                this.$$containerElementGet().addClass("rad-control-container ui container fluid");

                // Trigger Property Changes
                this.cacheExpiryTriggerChange();
                this.scrollableTriggerChange();
                this.showPageHeaderTriggerChange();
                this.titleTriggerChange();
                this.transitionTypeTriggerChange();
                this.transitionNameTriggerChange();
                this.urlTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _activateAsync: function ()
                {
                    return Promise.resolve();
                },
                _activeChanged: function (change)
                {
                    this.triggerHandler("activeChanged", change);
                },
                _bindEvents: function ()
                {
                    this.super._bindEvents();
                },
                _cacheExpiryChanged: function (change)
                {
                    var
                        self = this;

                    if (!self.cacheExpiryTimeoutId)
                    {
                        window.clearTimeout(this.cacheExpiryTimeoutId);
                        this.cacheExpiryTimeoutId = 0;
                    }

                    var
                        currentValue = parseInt(change.currentValue);

                    if (isNaN(currentValue))
                        console.error("Cache expiry value must be a number, use -1 for no aging.");

                    if (currentValue === -1 || self.noCacheGet())
                        return;

                    if (currentValue === 0)
                    {
                        self.noCacheSet(true);
                        return;
                    }

                    self.cacheExpiryTimeoutId = window.setTimeout(() =>
                    {
                        if (self.isVisibleGet())
                            self.noCacheSet(true);
                        else
                            self.remove();
                    }, currentValue * 1000);
                },
                _createContainerElement: function ()
                {
                    var
                        $$element = this.$$elementGet();

                    this.$$headerElement = $$element.find(">.rad-page-header");
                    this.$$pageFooterElement = $$element.find(">.rad-control-page-footer");

                    this.$$containerWrapper = $$element.find(">.rad-control-container-wrapper").first();

                    if (!this.$$containerWrapper.length)
                        this.$$containerWrapper = $$.create$$({ nodeName: "div" });

                    this.$$containerInnerWrapper = this.$$containerWrapper.find(">.rad-control-container-inner-wrapper");

                    if (!this.$$containerInnerWrapper.length)
                        this.$$containerInnerWrapper = $$.create$$({ nodeName: "div" });

                    var
                        $$containerElement = $$element.find(">.rad-control-container");

                    if (!$$containerElement.length)
                        $$containerElement = this.$$containerWrapper.find(">.rad-control-container");

                    if (!$$containerElement.length)
                        $$containerElement = this.$$containerInnerWrapper.find(">.rad-control-container");

                    if (!$$containerElement.length)
                        $$containerElement = $$.create$$({ nodeName: "div" });

                    this.$$containerWrapper.appendTo($$element);
                    this.$$containerInnerWrapper.appendTo(this.$$containerWrapper);
                    $$containerElement.appendTo(this.$$containerInnerWrapper);

                    this.$$containerElementSet($$containerElement);
                },
                _createElement: function ()
                {
                    this.super._createElement();

                    if (!this.$$headerElement.length)
                    {
                        this.$$headerElement = $$.create$$({
                            nodeName: "div",
                            attributes: { "class": "rad-page-header ui container fluid" },
                            children: [
                                {
                                    nodeName: "h2",
                                    attributes: { "class": "ui dividing header" },
                                    children: [
                                        { nodeName: "span" }
                                    ]
                                }
                            ]
                        });
                    }

                    if (!this.$$titleElement)
                        this.$$titleElement = this.$$headerElement.find(">h2");

                    if (!this.$$titleTextElement)
                        this.$$titleTextElement = this.$$headerElement.find(">h2>span");

                    this.$$headerElement.hide();
                    
                    this.$$headerElement.prependTo(this.$$containerInnerWrapper);

                    this.$$pageFooterElement = this.$$elementGet().find(">.rad-control-page-footer");

                    if (this.$$pageFooterElement.length)
                    {
                        this.pageFooter = namespace.Control.createFromElement(this.$$pageFooterElement);
                        this.$$pageFooterElement.appendTo(this.$$elementGet());
                        this.pageFooter._addScrollbarPadding();
                    }
                },
                _deactivateAsync: function ()
                {
                    return Promise.resolve();
                },
                _dialogViewChanged: function (change)
                {
                    if (change.currentValue)
                    {
                        this.openedAsDialog = true;
                        this.addCssClass("rad-control-dialog");
                        this.$$headerElement.prependTo(this.$$elementGet());
                        this.$$headerElement.find(">h2").removeClass("dividing");
                        this.$$containerWrapper.addClass("content ui form");
                        this.$$pageFooterElement.addClass("rad-dialog-footer");

                        if (this.pageFooter)
                            this.pageFooter._removeScrollbarPadding();
                    }
                },
                _displayErrorDialogAsync: function (message)
                {
                    if (String.isNullOrWhitespace(message))
                        message = "An error occurred";

                    return new Promise(resolve =>
                    {
                        namespace
                            .ErrorDialog
                            .displayError(message)
                            .finally(() => { resolve(); });
                    });
                },
                _dispose: function ()
                {
                    this.$$headerElement = null;
                    this.$$pageFooterElement = null;
                    this.$$containerWrapper = null;
                    this.$$containerInnerWrapper = null;

                    this.super._dispose();
                },
                _getDialogDimmer: function ()
                {
                    if (!this.dialogDimmer)
                        this.dialogDimmer = new namespace.PageDimmer({ animationIn: this.dialogAnimationInGet(), animationOut: this.dialogAnimationOutGet(), cssClass: "rad-dialog-dimmer" });

                    return this.dialogDimmer;
                },
                _getRootElements: function ()
                {
                    let
                        $$rootElements = this.super._getRootElements();

                    if (this.$$headerElement.length)
                        $$rootElements = $$rootElements.add(this.$$headerElement);

                    $$rootElements = $$rootElements.add(this.$$containerWrapper);

                    if (this.$$pageFooterElement.length)
                        $$rootElements = $$rootElements.add(this.$$pageFooterElement);

                    return $$rootElements;
                },
                _loadAsync: function ()
                {
                    return Promise.resolve();
                },
                _scrollableChanged: function (change)
                {
                    if (change.currentValue)
                        this.addCssClass("rad-feature-scrollable");
                    else 
                        this.removeCssClass("rad-feature-scrollable");
                },
                _showPageHeaderChanged: function (change)
                {
                    if (change.currentValue)
                        this.$$headerElement.show();
                    else
                        this.$$headerElement.hide();
                },
                _titleChanged: function (change)
                {
                    this.$$headerElement.find(">h2>span").text(change.currentValue);
                },
                _urlChanged: function (change)
                {
                    if (!this.openedAsDialog && window.pageManager?.currentPageGet() === this)
                        window.pageManager.replaceUrl(change.currentValue);
                },

                // Public Methods
                activateAsync: function ()
                {
                    var
                        self = this,
                        eventData = { promises: [] };

                    self.trigger("beforeActivated", eventData);

                    return (
                        Promise.all(eventData.promises)
                            .then(() =>
                            {
                                return self._activateAsync();
                            })
                            .then(() =>
                            {
                                self.activatedSet(true);

                                eventData = { promises: [] };

                                self.trigger("activated", eventData);

                                return Promise.all(eventData.promises);
                            })
                            .then(() =>
                            {
                                self.activeSet(true);
                            })
                    );
                },
                closeAsync: function ()
                {
                    var
                        self = this;

                    if (self.openedAsDialog)
                    {
                        if (self.closePromise)
                            return self.closePromise;

                        self.closePromise = Promise.public();

                        var
                            promise = self.closePromise;

                        self.removeCssClass("visible");

                        self._getDialogDimmer().hideElementOrControlAsync(self)
                            .then(() =>
                            {
                                self.opened = false;

                                if (self.openPromise)
                                    self.openPromise.resolve([self.dialogResult, self.promiseData]);

                                self.closePromise.resolve();
                                self.closePromise = null;

                                window.pageManager?.unRegisterBlockNavigationFunction(self._blockNavigationFunction);
                            });

                        return promise;
                    }

                    if (history.pushStateCounter > 0)
                    {
                        return new Promise(resolve =>
                        {
                            window.history.back();
                            setTimeout(() => { resolve(); });
                        });
                    }

                    var
                        location = window.pathHelper.getLocation(self.urlGet()),
                        pathNameParts = location.pathname.trim("/").split("/");

                    pathNameParts.pop();

                    return window.pageManager.navigateAsync(String.format("/{0}{1}", pathNameParts.join("/"), pathNameParts.length ? "/" : String.empty), true, true);
                },
                deactivateAsync: function ()
                {
                    var
                        self = this,
                        eventData = { promises: [] };

                    self.trigger("beforeDeactivated", eventData);

                    return (
                        Promise.all(eventData.promises)
                            .then(() =>
                            {
                                return self._deactivateAsync();
                            })
                            .then(() =>
                            {
                                eventData = { promises: [] };

                                self.trigger("deactivated", eventData);

                                return Promise.all(eventData.promises);
                            })
                            .then(() =>
                            {
                                self.activeSet(false);
                            })
                    );
                },
                focus: function ()
                {
                    var
                        self = this;

                    self.super.focus();

                    // PH break out of execution due to safari renderer issue
                    setTimeout(() => { self.scrollToTop(true); });
                },
                hide: function ()
                {
                    this.super.hide();

                    if (this.noCacheGet())
                    {
                        this.remove();
                        return this;
                    }

                    return this;
                },
                loadAsync: function ()
                {
                    var
                        self = this,
                        eventData = { promises: [] };

                    self.trigger("beforeLoaded", eventData);

                    return (
                        Promise.all(eventData.promises)
                            .then(() =>
                            {
                                return self._loadAsync();
                            })
                            .then(() =>
                            {
                                self.loadedSet(true);

                                eventData = { promises: [] };

                                self.trigger("loaded", eventData);

                                return Promise.all(eventData.promises);
                            })
                    );
                },
                openAsDialogAsync: function ()
                {
                    var
                        self = this;

                    if (self.opened)
                        return self.openPromise;

                    self.dialogViewSet(true);

                    self.opened = true;

                    self.openPromise = Promise.public();

                    self.loadAsync()
                        .then(() =>
                        {
                            return self._getDialogDimmer().showElementOrControlAsync(self);
                        })
                        .then(() =>
                        {
                            window.pageManager?.registerBlockNavigationFunction(self._blockNavigationFunction);
                            self.focus();
                        })
                        .catch(error =>
                        {
                            self.openPromise.reject(error);
                            self.closeAsync();
                        });

                    return self.openPromise;
                },
                remove: function ()
                {
                    this.removeControls([
                        this.pageFooter
                    ]);

                    this.super.remove();
                },
                reset: function ()
                {
                    if (this.inhibitScrollToTopOnReset)
                        return;

                    this.$$containerWrapper[0].scrollTop = 0;
                },
                scrollToTop: function (withoutAnimation)
                {
                    this.$$containerWrapper
                        .stop()
                        .animate({
                            scrollTop: this.$$elementGet().position().top
                        }, withoutAnimation ? 0 : 500);
                },
                show: function ()
                {
                    this.super.show();

                    this.trigger("shown");

                    return this;
                },
                urlSet: function (value)
                {
                    if (value?.startsWith("#"))
                        value = window.location.pathname + window.location.search + value;

                    // If we change the URL, we need to make sure an existing page with the new Url is removed
                    var
                        page = value ? window.pageManager._getPageByUrl(value) : null;

                    if (page && page !== this)
                        page.remove();

                    this._urlSet(value);
                },
                updateNavigationData: function (navigationData)
                {
                    var
                        currentPage = window.pageManager.currentPageGet();

                    if (!currentPage || currentPage !== this)
                    {
                        console.error("Navigation data can only be updated by the current page");
                        return;
                    }

                    this.navigationDataSet(navigationData);
                    window.history.replaceState({ counter: window.history.pushStateCounter, navigationData: navigationData }, null, this.urlGet());
                }
            };
        }
    });

    // Splash Page
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "SplashPage",
        inherits: "Page",
        createPropertyDefaults: namespace =>
        {
            return {
                scrollable: false
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-splash-page");
            };
        }
    });

    // Page Footer
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "PageFooter",
        inherits: "ContainerControl",
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-page-footer");
                this.$$containerElementGet().addClass("ui container fluid");
                this.$$containerWrapper.addClass("rad-control-container-wrapper");
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _addScrollbarPadding: function ()
                {
                    this.$$containerWrapper.css({
                        paddingRight: window.pageManager.scrollBarDimensionsGet().width + "px"
                    });
                },
                _createContainerElement: function ()
                {
                    var
                        $$element = this.$$elementGet();

                    this.$$containerWrapper = $$element.find(">.rad-control-container-wrapper").first();

                    if (!this.$$containerWrapper.length)
                        this.$$containerWrapper = $$.create$$({ nodeName: "div" });

                    var
                        $$containerElement = $$element.find(">.rad-control-container-wrapper>.rad-control-container,>.rad-control-container").first();

                    if (!$$containerElement.length)
                        $$containerElement = $$.create$$({ nodeName: "div" });

                    this.$$containerWrapper.appendTo($$element);
                    $$containerElement.appendTo(this.$$containerWrapper);

                    this.$$containerElementSet($$containerElement);
                },
                _removeScrollbarPadding: function ()
                {
                    this.$$containerWrapper.css({
                        paddingRight: String.empty
                    });
                }
            };
        }
    });

    // Login Page
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "LoginPage",
        inherits: "Page",
        mixins: [
            "MfaProviderSelectionMixin"
        ],
        properties: [
            { name: "emailAddressVerificationInstructions", type: "string" },
            { name: "mode", type: "string" },
            { name: "mfaControl" },
            { name: "mfaInstructions", type: "string" },
            { name: "mfaUiClass", type: "string" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                buttonStyle: null,
                emailAddressVerificationInstructions: "You need to verify your email address. Please check your email for instructions.",
                mfaInstructions: "You are required to enable MFA (multi-factor authentication) on your account, please choose one of the available providers below.",
                mode: namespace.LoginPage.modes.login,
                showPageHeader: true
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-login-page");

                // Trigger Property Changes
                this.emailAddressVerificationInstructionsTriggerChange();
                this.modeTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _bindEvents: function ()
                {
                    this.super._bindEvents();

                    this.buttonChangePassword.on("click", { self: this }, this.onButtonChangePasswordClicked);
                    this.buttonForgotPasswordBack.on("click", { self: this }, this.onButtonForgotPasswordBackClicked);
                    this.buttonLogin.on("click", { self: this }, this.onButtonLoginClicked);
                    this.buttonSendPasswordReset.on("click", { self: this }, this.onButtonSendPasswordResetClicked);

                    this.linkForgottenPassword.on("click", { self: this }, this.onLinkForgottenPasswordClicked);

                    this.textboxEmailAddress.on("keyup", { self: this, clickTarget: this.buttonLogin }, this.onTextBoxKeyUp);
                    this.textboxEmailAddressForgotPassword.on("keyup", { self: this, clickTarget: this.buttonSendPasswordReset }, this.onTextBoxKeyUp);
                    this.textboxNewPasswordConfirm.on("keyup", { self: this, clickTarget: this.buttonChangePassword }, this.onTextBoxKeyUp);
                    this.textboxPassword.on("keyup", { self: this, clickTarget: this.buttonLogin }, this.onTextBoxKeyUp);
                },
                _changePasswordAsync: function ()
                {
                    var
                        self = this;

                    return new Promise((resolve, reject) =>
                    {
                        $$
                            .ajax({
                                type: "POST",
                                data: { newPassword: self.textboxNewPassword.valueGet(), token: self.changePasswordInformation.token }.toJson(),
                                dataType: "json",
                                contentType: "application/json",
                                url: window.applicationInformation.serverVirtualDirectory + "api/Security/ResetPassword"
                            })
                            .then(() =>
                            {
                                namespace.LoginMessageDialog.displayMessage("Thank you", "Password reset successfully.")
                                    .then(() =>
                                    {
                                        self.textboxPassword.valueSet(self.textboxNewPassword.valueGet());
                                        self.modeSet(namespace.LoginPage.modes.login);
                                    });

                                resolve();
                            })
                            .catch(xhr =>
                            {
                                var
                                    error = window.serverErrorHelper.processError(xhr);

                                if (error.type === "ValidationApiException")
                                {
                                    self.textboxNewPassword.errorStateSet(true);
                                    self.textboxNewPasswordConfirm.errorStateSet(true);

                                    self.validationPanel.setErrorMessages(error.validationErrors.select(item => item.errorMessage));

                                    reject();
                                    return;
                                }

                                namespace.LoginMessageDialog.displayMessage("Error", error.message)
                                    .finally(() =>
                                    {
                                        reject(error);
                                    });
                            });
                    });                   
                },
                _completeLogin: function ()
                {
                    var
                        self = this;

                    self._loginAsyncPromise.resolve();
                    self._loginAsyncPromise = null;

                    // Need to revisit this
                    seriouslyrad.server.AjaxRequest.unauthenticated = false;
                    
                    if (self.openedAsDialog)
                    {
                        self.dialogResult = namespace.Dialog.dialogResult.ok;
                        self.closeAsync();
                        return;
                    }

                    $$("html").addClass("rad-state-logging-in");
                    window.fullPageLoader.enqueue();

                    self.closeAsync()
                        .finally(() =>
                        {
                            setTimeout(() => { $$("html").removeClass("rad-state-logging-in"); }, 500);
                            window.fullPageLoader.dequeue();
                        });
                },
                _createElement: function ()
                {
                    this.super._createElement();

                    this.validationPanel =
                        new namespace.ValidationPanel()
                            .prependTo(this);

                    this.wizard =
                        new namespace.Wizard()
                            .appendTo(this);

                    // #region Login

                    this.panelLogin =
                        new namespace.Form({ cssClass: "rad-panel-mode-login" })
                            .appendTo(this.wizard);

                    this.propertyEditorEmailAddress =
                        new namespace.PropertyEditorTextBox({
                            cssClass: "rad-control-property-editor-text-box-email-address",
                            editMode: true,
                            mandatory: true,
                            propertyDisplayName: "Email Address"
                        }).appendTo(this.panelLogin);

                    this.textboxEmailAddress = this.propertyEditorEmailAddress.editorControlGet();

                    this.propertyEditorPassword =
                        new namespace.PropertyEditorTextBoxPassword({
                            cssClass: "rad-control-property-editor-text-box-password last",
                            editMode: true,
                            mandatory: true,
                            propertyDisplayName: "Password"
                        }).appendTo(this.panelLogin);

                    this.textboxPassword = this.propertyEditorPassword.editorControlGet();

                    this.panelLoginButtons = new namespace.Panel({ cssClass: "rad-login-buttons" });
                    this.panelLoginButtons.appendTo(this.panelLogin);

                    this.linkForgottenPassword = new namespace.Link({ cssClass: "rad-action-forgotten-password", text: "Forgotten password?" });
                    this.linkForgottenPassword.appendTo(this.panelLoginButtons);

                    this.buttonLogin = new namespace.Button({ cssClass: "rad-action-login positive", inline: true, text: "Login" });
                    this.buttonLogin.appendTo(this.panelLoginButtons);

                    // #endregion

                    // #region Email Address Verification

                    this.panelEmailAddressVerification = new namespace.Panel({ cssClass: "rad-panel-mode-email-address-verification" });

                    this.textEmailAddressVerificationInstructions = new namespace.Text({ cssClass: "rad-control-text-instructions" });
                    this.textEmailAddressVerificationInstructions.appendTo(this.panelEmailAddressVerification);

                    // #endregion

                    // #region Multi Factor Authentication Setup

                    this.panelMfaSetup = new namespace.Panel({ cssClass: "rad-panel-mode-mfa-setup" });

                    // #endregion

                    // #region Multi Factor Authentication Request

                    this.panelMfaRequest = new namespace.Panel({ cssClass: "rad-panel-mode-mfa-request" });

                    // #endregion

                    // #region Forgotten Password

                    this.panelForgotPassword = new namespace.Panel({ cssClass: "rad-panel-mode-forgot-password" });

                    this.propertyEmailAddressForgotPassword =
                        new namespace.PropertyEditorTextBox({
                            cssClass: "last",
                            editMode: true,
                            mandatory: true,
                            propertyDisplayName: "Email Address"
                        }).appendTo(this.panelForgotPassword);

                    this.textboxEmailAddressForgotPassword = this.propertyEmailAddressForgotPassword.editorControlGet();

                    this.panelForgotPasswordButtons = new namespace.Panel({ cssClass: "rad-login-buttons" });
                    this.panelForgotPasswordButtons.appendTo(this.panelForgotPassword);

                    this.buttonForgotPasswordBack = new namespace.Button({ cssClass: "negative", inline: true, text: "Back" });
                    this.buttonForgotPasswordBack.appendTo(this.panelForgotPasswordButtons);

                    this.buttonSendPasswordReset = new namespace.Button({ cssClass: "positive", inline: true, text: "Request Password Reset" });
                    this.buttonSendPasswordReset.appendTo(this.panelForgotPasswordButtons);

                    // #endregion

                    // #region Change Password

                    this.panelChangePassword = new namespace.Panel({ cssClass: "rad-panel-mode-change-password" });

                    this.propertyEditorNewPassword =
                        new namespace.PropertyEditorTextBoxPassword({
                            cssClass: "rad-control-property-editor-text-box-password",
                            editMode: true,
                            mandatory: true,
                            propertyDisplayName: "Password"
                        }).appendTo(this.panelChangePassword);

                    this.textboxNewPassword = this.propertyEditorNewPassword.editorControlGet();

                    this.propertyEditorNewPasswordConfirm =
                        new namespace.PropertyEditorTextBoxPassword({
                            cssClass: "rad-control-property-editor-text-box-password last",
                            editMode: true,
                            mandatory: true,
                            propertyDisplayName: "Confirm Password"
                        }).appendTo(this.panelChangePassword);

                    this.textboxNewPasswordConfirm = this.propertyEditorNewPasswordConfirm.editorControlGet();

                    this.panelChangePasswordButtons = new namespace.Panel({ cssClass: "rad-login-buttons" });
                    this.panelChangePasswordButtons.appendTo(this.panelChangePassword);

                    this.buttonChangePassword = new namespace.Button({ cssClass: "positive", inline: true, text: "Reset Password" });
                    this.buttonChangePassword.appendTo(this.panelChangePasswordButtons);

                    // #endregion
                },
                _emailAddressVerificationInstructionsChanged: function (change)
                {
                    this.textEmailAddressVerificationInstructions.valueSet(change.currentValue);
                    this.textEmailAddressVerificationInstructions.visibleSet(!!(change.currentValue?.length));
                },
                _hideAllPanels: function ()
                {
                    this.controlsGet()
                        .where(item => item instanceof namespace.Panel && !(item instanceof namespace.Wizard))
                        .forEach(item => { item.hide(); });
                },
                _loadAsync: function ()
                {
                    var
                        self = this;

                    self._reset();
                    self._resetValidation();
                    self.emailAddressVerificationInformation = {};
                    self.changePasswordInformation = {};
                    self.mfaSetupInformation = {};

                    switch (window.applicationInformation.queryStringParameters.action)
                    {
                        case "emailaddressverification":
                            self.emailAddressVerificationInformation.token = window.applicationInformation.queryStringParameters.token;

                            window.applicationInformation.queryStringParameters = {};

                            break;
                        case "passwordreset":
                            self.changePasswordInformation.token = window.applicationInformation.queryStringParameters.token;

                            window.applicationInformation.queryStringParameters = {};

                            self.modeSet(namespace.LoginPage.modes.changePassword);
                            break;
                    }

                    return this.super._loadAsync();
                },
                _loginAsync: function (mfaProviderId, mfaAuthenticationData, mfaSetupData)
                {
                    var
                        self = this;

                    if (!self._loginAsyncPromise)
                        self._loginAsyncPromise = Promise.public();

                    var
                        username = self.textboxEmailAddress.valueGet(),
                        password = self.textboxPassword.valueGet(),
                        mode = self.modeGet(),
                        loginRequest = {
                            authenticationScheme: window.application.authenticationSchemeGet()
                        };

                    switch (mode)
                    {
                        case namespace.LoginPage.modes.login:
                            if (self.emailAddressVerificationInformation.token)
                                loginRequest.emailAddressVerificationTokenGuid = self.emailAddressVerificationInformation.token;
                            break;
                    }

                    if (mfaProviderId)
                        loginRequest.mfaProviderId = mfaProviderId;

                    if (mfaAuthenticationData)
                        loginRequest.mfaAuthenticationData = mfaAuthenticationData.toJson();

                    if (mfaSetupData)
                        loginRequest.mfaSetupData = mfaSetupData.toJson();

                    if (window.fullPageLoader)
                        window.fullPageLoader.enqueue();

                    $$
                        .ajax({
                            type: "POST",
                            headers: Object.extend(true, {}, seriouslyrad.server.WebApiClient.staticHeaders, {
                                "Authorization": "Basic " + window.btoa(username + ":" + password)
                            }),
                            dataType: "json",
                            contentType: "application/json",
                            url: String.format("{0}api/Security/{1}", window.applicationInformation.serverVirtualDirectory, "Login"),
                            data: loginRequest.toJson(),
                            xhrFields: {
                                withCredentials: true
                            }
                        })
                        .then(results =>
                        {
                            const
                                data = results[0];

                            window.application.authenticationDataSet(data);

                            self.promiseData = data;
                            self.emailAddressVerificationInformation = {};

                            var
                                mfaControl = self.mfaControlGet(),
                                handled = mfaControl?.loginSuccessful(data.mfaRecoveryCodes).handled;

                            if (!handled)
                                self._completeLogin();
                        })
                        .catch(xhr =>
                        {
                            var
                                error = window.serverErrorHelper.processError(xhr),
                                handled = false;

                            if (["AuthenticationApiException", "MfaAuthenticationApiException"].contains(error.type))
                            {
                                switch (error.reason)
                                {
                                    case "accessDenied":
                                        self.validationPanel.setErrorMessages([error.message], "Access Denied");
                                        handled = true;
                                        break;
                                    case "authenticationFailed":
                                        self.textboxEmailAddress.errorStateSet(true);
                                        self.textboxPassword.errorStateSet(true);
                                        self.validationPanel.setErrorMessages([error.message ?? "Incorrect username or password"], "Authentication Failure");
                                        handled = true;
                                        break;
                                    case "emailAddressVerificationRequired":
                                        self.modeSet(namespace.LoginPage.modes.emailAddressVerification);
                                        handled = true;
                                        break;
                                    case "mfaFailed":
                                        if (error.additionalData?.mfaUiClass)
                                        {
                                            self.mfaUiClassSet(error.additionalData.mfaUiClass);
                                            handled = self.mfaControlGet().loginFailed(error.subReason, error.additionalData).handled;
                                            if (handled)
                                                self.modeSet(namespace.LoginPage.modes.mfaRequest);
                                        }
                                        break;
                                    case "mfaSetupRequired":
                                        self.panelMfaSetup.controlsClear();
                                        self.textMfaInstructions =
                                            new namespace.Text({ cssClass: "rad-control-text-instructions" })
                                                .appendTo(self.panelMfaSetup);

                                        self.textMfaInstructions.textSet(self.mfaInstructionsGet());

                                        if (error.additionalData?.mfaProviders)
                                            self.addMfaProviderOptionsToPanel(error.additionalData.mfaProviders, self.panelMfaSetup, self.onButtonMfaProviderSelectClicked);

                                        self.modeSet(namespace.LoginPage.modes.mfaSetup);
                                        handled = true;
                                        break;
                                    case "passwordExpired":
                                        self.changePasswordInformation.token = error.additionalData;
                                        self.modeSet(namespace.LoginPage.modes.changePassword);
                                        handled = true;
                                        break;
                                }
                            }

                            if (!handled)
                            {
                                namespace.LoginMessageDialog.displayMessage("Error", error.message)
                                    .finally(() =>
                                    {
                                        self._loginAsyncPromise.reject();
                                        self._loginAsyncPromise = null;
                                    });
                            }
                        })
                        .finally(() =>
                        {
                            if (window.fullPageLoader)
                                window.fullPageLoader.dequeue();
                        });

                    return self._loginAsyncPromise;
                },
                _modeChanged: function (change)
                {
                    this._hideAllPanels();
                    this._resetValidation();

                    switch (change.currentValue)
                    {
                        case namespace.LoginPage.modes.emailAddressVerification:
                            this.titleSet("Email Address Verification");
                            this.wizard.navigateToPanelAsync(this.panelEmailAddressVerification);
                            break;
                        case namespace.LoginPage.modes.changePassword:
                            this.titleSet("Change Password");
                            this.wizard.navigateToPanelAsync(this.panelChangePassword);
                            break;
                        case namespace.LoginPage.modes.login:
                            this.titleSet("Login");
                            this.wizard.navigateToPanelAsync(this.panelLogin, true)
                                .then(() =>
                                {
                                    const
                                        mfaControl = this.mfaControlGet();

                                    if (mfaControl)
                                        mfaControl.modeSet(null);
                                });
                            break;
                        case namespace.LoginPage.modes.forgotPassword:
                            {
                                this.titleSet("Forgotten password");

                                if (!this.textboxEmailAddressForgotPassword.valueGet())
                                    this.textboxEmailAddressForgotPassword.valueSet(this.textboxEmailAddress.valueGet());

                                this.wizard.navigateToPanelAsync(this.panelForgotPassword);

                                break;
                            }
                        case namespace.LoginPage.modes.mfaRequest:
                            this.titleSet("Multi Factor Authentication");
                            this.wizard.navigateToPanelAsync(this.panelMfaRequest);
                            break;
                        case namespace.LoginPage.modes.mfaSetup:
                            this.titleSet("Setup Multi Factor Authentication");
                            this.wizard.navigateToPanelAsync(this.panelMfaSetup);
                            break;
                    }
                },
                _mfaControlChanged: function (change)
                {
                    if (change.originalValue)
                    {
                        change.originalValue.off("cancel", { self: this }, this.onMfaControlCancelled);
                        change.originalValue.off("close", { self: this }, this.onMfaControlClosed);
                        change.originalValue.off("login", { self: this }, this.onMfaControlLogin);
                        change.originalValue.off("resetValidation", { self: this }, this.onMfaControlResetValidation);
                        change.originalValue.off("titleChange", { self: this }, this.onMfaControlTitleChanged);
                        change.originalValue.off("validationFailed", { self: this }, this.onMfaControlValidationFailed);
                        change.originalValue.remove();
                    }

                    if (change.currentValue)
                    {
                        change.currentValue.on("cancel", { self: this }, this.onMfaControlCancelled);
                        change.currentValue.on("close", { self: this }, this.onMfaControlClosed);
                        change.currentValue.on("login", { self: this }, this.onMfaControlLogin);
                        change.currentValue.on("resetValidation", { self: this }, this.onMfaControlResetValidation);
                        change.currentValue.on("titleChange", { self: this }, this.onMfaControlTitleChanged);
                        change.currentValue.on("validationFailed", { self: this }, this.onMfaControlValidationFailed);
                        change.currentValue.appendTo(this.panelMfaRequest);
                    }
                },
                _mfaUiClassChanged: function (change)
                {
                    this.mfaControlSet(change.currentValue ? namespace.Control.createFromClassPath(change.currentValue) : null);
                },
                _reset: function ()
                {
                    this.modeSet(namespace.LoginPage.modes.login);

                    this.controlsGet(true)
                        .where(item => item instanceof namespace.TextBox)
                        .forEach(item => { item.valueSet(null); });
                },
                _resetValidation: function ()
                {
                    this.validationPanel.setErrorMessages(null);

                    this.controlsGet(true)
                        .where(item => item.errorStateSet)
                        .forEach(item => { item.errorStateSet(false); });

                    this.controlsGet(true)
                        .where(item => item.validationMessagesSet)
                        .forEach(item => { item.validationMessagesSet([]); });
                },
                _sendPasswordResetAsync: function ()
                {
                    var
                        self = this;

                    return new Promise((resolve, reject) =>
                    {
                        $$
                            .ajax({
                                type: "POST",
                                data: { username: self.textboxEmailAddressForgotPassword.valueGet() }.toJson(),
                                dataType: "json",
                                contentType: "application/json",
                                url: window.applicationInformation.serverVirtualDirectory + "api/Security/RequestResetPassword"
                            })
                            .then(() =>
                            {
                                namespace.LoginMessageDialog.displayMessage("Thank you", "An email has been sent if the account exists.")
                                    .then(() =>
                                    {
                                        resolve();
                                        self.modeSet(namespace.LoginPage.modes.login);
                                    })
                                    .catch(error =>
                                    {
                                        reject(error);
                                    });
                            })
                            .catch(xhr =>
                            {
                                var
                                    error = window.serverErrorHelper.processError(xhr);

                                namespace.LoginMessageDialog.displayMessage("Error", error.message)
                                    .finally(() =>
                                    {
                                        reject();
                                    });
                            });
                    });
                },
                _validateChangePassword: function ()
                {
                    var
                        errorMessages = [],
                        password = this.textboxNewPassword.valueGet(),
                        passwordConfirm = this.textboxNewPasswordConfirm.valueGet(),
                        hasFailed = false;

                    this._validateChangePasswordReset();

                    if (!password)
                    {
                        if (this.propertyEditorNewPassword.showInlineValidationMessagesGet())
                            this.propertyEditorNewPassword.validationMessagesSet(["Password is required"])
                        else
                            errorMessages.push("Password is required");

                        this.propertyEditorNewPassword.errorStateSet(true);
                        hasFailed = true;
                    }
                    else if (password !== passwordConfirm)
                    {
                        if (this.propertyEditorNewPasswordConfirm.showInlineValidationMessagesGet())
                            this.propertyEditorNewPasswordConfirm.validationMessagesSet(["The passwords do not match"])
                        else
                            errorMessages.push("The passwords do not match");

                        this.propertyEditorNewPassword.errorStateSet(true);
                        this.propertyEditorNewPasswordConfirm.errorStateSet(true);
                        hasFailed = true;
                    }

                    this.validationPanel.setErrorMessages(errorMessages);

                    return !hasFailed;
                },
                _validateChangePasswordReset: function ()
                {
                    this.propertyEditorNewPassword.errorStateSet(false);
                    this.propertyEditorNewPassword.validationMessagesSet([]);
                    this.propertyEditorNewPasswordConfirm.errorStateSet(false);
                    this.propertyEditorNewPasswordConfirm.validationMessagesSet([]);
                },
                _validateLogin: function ()
                {
                    var
                        emailAddress = this.textboxEmailAddress.valueGet(),
                        password = this.textboxPassword.valueGet(),
                        errorMessages = [],
                        hasFailed = false;

                    this._validateLoginReset();

                    if (!emailAddress)
                    {
                        if (this.propertyEditorEmailAddress.showInlineValidationMessagesGet())
                            this.propertyEditorEmailAddress.validationMessagesSet(["Email Address is required"])
                        else
                            errorMessages.push("Email Address is required");

                        this.propertyEditorEmailAddress.errorStateSet(true);
                        hasFailed = true;
                    }

                    if (!password)
                    {
                        if (this.propertyEditorPassword.showInlineValidationMessagesGet())
                            this.propertyEditorPassword.validationMessagesSet(["Password is required"])
                        else
                            errorMessages.push("Password is required");

                        this.propertyEditorPassword.errorStateSet(true);
                        hasFailed = true;
                    }

                    this.validationPanel.setErrorMessages(errorMessages);

                    return !hasFailed;
                },
                _validateLoginReset: function ()
                {
                    this.propertyEditorEmailAddress.errorStateSet(false);
                    this.propertyEditorEmailAddress.validationMessagesSet([]);
                    this.propertyEditorPassword.errorStateSet(false);
                    this.propertyEditorPassword.validationMessagesSet([]);
                },
                _validateForgotPassword: function ()
                {
                    var
                        emailAddress = this.textboxEmailAddressForgotPassword.valueGet(),
                        errorMessages = [],
                        hasFailed = false;

                    this._validateForgotPasswordReset();

                    if (!emailAddress)
                    {
                        if (this.propertyEmailAddressForgotPassword.showInlineValidationMessagesGet())
                            this.propertyEmailAddressForgotPassword.validationMessagesSet(["Email Address is required"])
                        else
                            errorMessages.push("Email Address is required");

                        this.propertyEmailAddressForgotPassword.errorStateSet(true);
                        hasFailed = true;
                    }

                    this.validationPanel.setErrorMessages(errorMessages);

                    return !hasFailed;
                },
                _validateForgotPasswordReset: function ()
                {
                    this.propertyEmailAddressForgotPassword.errorStateSet(false);
                    this.propertyEmailAddressForgotPassword.validationMessagesSet([]);
                },

                // Event Handlers
                onButtonChangePasswordClicked: function (evt)
                {
                    evt.preventDefault();
                    evt.stopPropagation();

                    if (evt.data.self._validateChangePassword())
                        evt.data.self._changePasswordAsync();
                },
                onButtonForgotPasswordBackClicked: function (evt)
                {
                    evt.preventDefault();
                    evt.stopPropagation();
                    evt.data.self.modeSet(namespace.LoginPage.modes.login);
                },
                onButtonLoginClicked: function (evt)
                {
                    evt.preventDefault();
                    evt.stopPropagation();

                    if (evt.data.self._validateLogin())
                        evt.data.self._loginAsync();
                },
                onButtonMfaProviderSelectClicked: function (evt)
                {
                    evt.preventDefault();
                    evt.stopPropagation();

                    var
                        self = evt.data.self,
                        button = $$.radControl(evt.currentTarget),
                        tag = button ? button.tagGet() : null;

                    if (!tag)
                        return;

                    self.mfaUiClassSet(tag ? tag.uiClass : null);
                    self._loginAsync(tag.id);
                },
                onButtonSendPasswordResetClicked: function (evt)
                {
                    evt.preventDefault();
                    evt.stopPropagation();

                    if (evt.data.self._validateForgotPassword())
                        evt.data.self._sendPasswordResetAsync();
                },
                onLinkForgottenPasswordClicked: function (evt)
                {
                    evt.preventDefault();
                    evt.stopPropagation();
                    evt.data.self.modeSet(namespace.LoginPage.modes.forgotPassword);
                },
                onMfaControlCancelled: function (evt)
                {
                    evt.data.self.modeSet(namespace.LoginPage.modes.login);
                },
                onMfaControlClosed: function (evt)
                {
                    evt.data.self._completeLogin();
                },
                onMfaControlLogin: function (evt, eventData)
                {
                    evt.data.self._loginAsync(eventData.mfaProviderId, eventData.authenticationData, eventData.setupData);
                },
                onMfaControlResetValidation: function (evt)
                {
                    evt.data.self._resetValidation();
                },
                onMfaControlTitleChanged: function (evt, eventData)
                {
                    evt.data.self.titleSet(eventData.title);
                },
                onMfaControlValidationFailed: function (evt, eventData)
                {
                    evt.data.self.validationPanel.setErrorMessages(eventData.errorMessages);
                },
                onTextBoxKeyUp: function (evt)
                {
                    if (!evt.data.clickTarget)
                        return;

                    switch (evt.key)
                    {
                        case "Enter":
                            {
                                evt.preventDefault();
                                evt.stopPropagation();
                                evt.data.clickTarget.click();
                                break;
                            }
                    }
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.modes =
            {
                changePassword: "changePassword",
                emailAddressVerification: "emailAddressVerification",
                forgotPassword: "forgotPassword",
                login: "login",
                mfaRequest: "mfaRequest",
                mfaSetup: "mfaSetup"
            };
        }
    });

    // #endregion

    // #region Dialogs

    // Dialog
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "Dialog",
        inherits: "Page",
        properties: [
            { name: "animationIn", type: "string" },
            { name: "animationOut", type: "string" },
            { name: "autoClose", type: "boolean" },
            { name: "blockNavigation", type: "boolean" },
            { name: "buttonStyle", type: "string" },
            { name: "cancelButtonText", type: "string" },
            { name: "fullWidth", type: "boolean" },
            { name: "okButtonText", type: "string" }
        ],
        propertyAttributes: [
            {
                propertyName: "buttonStyle",
                designer: {
                    category: "Appearance",
                    displayName: "Button Style"
                }
            }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                animationIn: "slide left in",
                animationOut: "slide left out",
                autoClose: true,
                blockNavigation: true,
                buttonStyle: namespace.Dialog.buttonStyle.okOnly,
                cancelButtonText: "Cancel",
                okButtonText: "OK"
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this._blockNavigationFunction = () =>
                {
                    return this.dimmer?.shown();
                };

                this.opened = false;
                this.openPromise = null;
                this.closePromise = null;
                this.dialogResult = null;
                this.promiseData = null;

                this.addCssClass("rad-control-dialog");
                this.$$containerElementGet().addClass("rad-control-container content");
                this.$$footerElement.addClass("rad-dialog-footer");

                this.buttonOk.addCssClass("rad-button-ok ui button primary positive");
                this.buttonYes.addCssClass("rad-button-yes ui right labeled icon button positive");
                this.buttonNo.addCssClass("rad-button-no ui button negative");
                this.buttonAbort.addCssClass("rad-button-abort ui button primary");
                this.buttonRetry.addCssClass("rad-button-retry ui button primary");
                this.buttonIgnore.addCssClass("rad-button-ignore ui button primary");
                this.buttonCancel.addCssClass("rad-button-cancel ui button negative");

                this.$$containerWrapper.removeClass("container");
                this.$$containerWrapper.addClass("content ui form");

                this.detach();

                // Trigger Property Changes
                this.buttonStyleTriggerChange();
                this.cancelButtonTextTriggerChange();
                this.fullWidthTriggerChange();
                this.okButtonTextTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _bindEvents: function ()
                {
                    this.super._bindEvents();

                    this.on("keyup", { self: this }, this.onKeyUp);
                },
                _buttonStyleChanged: function (change)
                {
                    this.buttonOk.hide();
                    this.buttonYes.hide();
                    this.buttonNo.hide();
                    this.buttonAbort.hide();
                    this.buttonRetry.hide();
                    this.buttonIgnore.hide();
                    this.buttonCancel.hide();

                    switch (change.currentValue)
                    {
                        case namespace.Dialog.buttonStyle.okOnly:
                            this.buttonOk.show();
                            break;
                        case namespace.Dialog.buttonStyle.okCancel:
                            this.buttonOk.show();
                            this.buttonCancel.show();
                            break;
                        case namespace.Dialog.buttonStyle.yesNo:
                            this.buttonYes.show();
                            this.buttonNo.show();
                            break;
                        case namespace.Dialog.buttonStyle.yesNoCancel:
                            this.buttonYes.show();
                            this.buttonNo.show();
                            this.buttonCancel.show();
                            break;
                        case namespace.Dialog.buttonStyle.retryCancel:
                            this.buttonRetry.show();
                            this.buttonCancel.show();
                            break;
                        case namespace.Dialog.buttonStyle.abortRetryIgnore:
                            this.buttonAbort.show();
                            this.buttonRetry.show();
                            this.buttonIgnore.show();
                            break;
                        case namespace.Dialog.buttonStyle.cancelOnly:
                            this.buttonCancel.show();
                            break;
                    }
                },
                _cancelButtonTextChanged: function (change)
                {
                    this.buttonCancel.textSet(change.currentValue);
                },
                _createContainerElement: function ()
                {
                    var
                        $$element = this.$$elementGet();

                    this.$$footerElement = $$element.find(">.rad-dialog-footer");

                    this.super._createContainerElement();
                },
                _createElement: function ()
                {
                    this.super._createElement();

                    var
                        $$element = this.$$elementGet();

                    $$element.prop("tabindex", 0);
                    
                    this.$$headerElement.prependTo($$element);
                    
                    if (!this.$$footerElement.length)
                        this.$$footerElement = $$.create$$({ nodeName: "div" });
                    
                    this.$$footerElement.insertAfter(this.$$containerWrapper);

                    // Buttons
                    this.buttonOk = this._createFooterButton("OK", "rad-button-ok");
                    this.buttonYes = this._createFooterButton("Yes", "rad-button-yes");
                    this.buttonNo = this._createFooterButton("No", "rad-button-no");
                    this.buttonAbort = this._createFooterButton("Abort", "rad-button-abort");
                    this.buttonRetry = this._createFooterButton("Retry", "rad-button-retry");
                    this.buttonIgnore = this._createFooterButton("Ignore", "rad-button-ignore");
                    this.buttonCancel = this._createFooterButton("Cancel", "rad-button-cancel");
                },
                _createFooterButton: function (text, cssClass)
                {
                    var
                        $$button = this.$$footerElement.find(">." + cssClass);

                    if ($$button.length)
                        return namespace.Control.createFromElement($$button);

                    return new namespace.Button({ cssClass: cssClass, inline: true, text: text }).appendTo(this.$$footerElement);
                },
                _fullWidthChanged: function (change)
                {
                    if (change.currentValue)
                        this.addCssClass("rad-state-full-width");
                    else
                        this.removeCssClass("rad-state-full-width");
                },
                _getDimmer: function ()
                {
                    if (!this.dimmer)
                        this.dimmer = new namespace.PageDimmer({ animationIn: this.animationInGet(), animationOut: this.animationOutGet(), cssClass: "rad-dialog-dimmer" });

                    return this.dimmer;
                },
                _getRootElements: function ()
                {
                    return (
                        this.super._getRootElements()
                            .add(this.$$footerElement)
                    );
                },
                _okButtonTextChanged: function (change)
                {
                    this.buttonOk.textSet(change.currentValue);
                },

                // Public Methods
                buttonClicked: function ()
                {
                    this.triggerHandler("buttonClicked", [this.dialogResult, this.promiseData]);

                    if (!this.autoCloseGet())
                        return;

                    this.closeAsync();
                },
                closeAsync: function ()
                {
                    var
                        self = this;

                    if (self.closePromise)
                        return self.closePromise;

                    self.closePromise = Promise.public();

                    var
                        promise = self.closePromise;

                    self.removeCssClass("visible");

                    self._getDimmer().hideElementOrControlAsync(self)
                        .then(() =>
                        {
                            self.opened = false;

                            if (self.openPromise)
                                self.openPromise.resolve([self.dialogResult, self.promiseData]);

                            self.closePromise.resolve();
                            self.closePromise = null;

                            window.pageManager?.unRegisterBlockNavigationFunction(self._blockNavigationFunction);
                        });

                    return promise;
                },
                openAsync: function ()
                {
                    var
                        self = this;

                    if (self.opened)
                        return self.openPromise;

                    self.opened = true;

                    self.openPromise = Promise.public();
                    self.dialogResult = null;
                    self.promiseData = null;

                    self._getDimmer().showElementOrControlAsync(self)
                        .then(() =>
                        {
                            window.pageManager?.registerBlockNavigationFunction(self._blockNavigationFunction);
                            self.focus();
                        });

                    return self.openPromise;
                },

                // Event Handlers
                onKeyUp: function (evt)
                {
                    var
                        self = evt.data.self,
                        buttonStyle = self.buttonStyleGet(),
                        buttonToClick;

                    switch (evt.key)
                    {
                        case "Enter":
                            {
                                switch (buttonStyle)
                                {
                                    case namespace.Dialog.buttonStyle.abortRetryIgnore:
                                    case namespace.Dialog.buttonStyle.retryCancel:
                                        buttonToClick = self.buttonRetry;
                                        break;
                                    case namespace.Dialog.buttonStyle.okCancel:
                                    case namespace.Dialog.buttonStyle.okOnly:
                                        buttonToClick = self.buttonOk;
                                        break;
                                    case namespace.Dialog.buttonStyle.yesNo:
                                    case namespace.Dialog.buttonStyle.yesNoCancel:
                                        buttonToClick = self.buttonYes;
                                        break;
                                    case namespace.Dialog.buttonStyle.cancelOnly:
                                        break;
                                }
                                break;
                            }
                        case "Escape":
                            {
                                switch (buttonStyle)
                                {
                                    case namespace.Dialog.buttonStyle.abortRetryIgnore:
                                        buttonToClick = self.buttonAbort;
                                        break;
                                    case namespace.Dialog.buttonStyle.retryCancel:
                                    case namespace.Dialog.buttonStyle.okCancel:
                                    case namespace.Dialog.buttonStyle.yesNoCancel:
                                    case namespace.Dialog.buttonStyle.cancelOnly:
                                        buttonToClick = self.buttonCancel;
                                        break;
                                    case namespace.Dialog.buttonStyle.yesNo:
                                        buttonToClick = self.buttonNo;
                                        break;
                                    case namespace.Dialog.buttonStyle.okOnly:
                                        break;
                                }
                                break;
                            }
                    }

                    if (buttonToClick)
                    {
                        evt.preventDefault();
                        evt.stopPropagation();
                        buttonToClick.click();
                    }
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.dialogResult =
            {
                none: "none",
                ok: "ok",
                yes: "yes",
                no: "no",
                abort: "abort",
                retry: "retry",
                ignore: "ignore",
                cancel: "cancel"
            };
            classConstructor.buttonStyle =
            {
                okOnly: "okOnly",
                okCancel: "okCancel",
                yesNo: "yesNo",
                yesNoCancel: "yesNoCancel",
                retryCancel: "retryCancel",
                abortRetryIgnore: "abortRetryIgnore",
                cancelOnly: "cancelOnly"
            };

            $$(document).on("click", ".rad-control-dialog:not(.rad-control-dialog2) > .rad-dialog-footer > .ui.button", evt =>
            {
                evt.preventDefault();
                evt.stopPropagation();

                var
                    $$target = $$(evt.currentTarget),
                    dialog = $$target.closest(".rad-control-dialog").radControl();

                if ($$target.hasClass("rad-button-cancel"))
                    dialog.dialogResult = namespace.Dialog.dialogResult.cancel;
                else if ($$target.hasClass("rad-button-ignore"))
                    dialog.dialogResult = namespace.Dialog.dialogResult.ignore;
                else if ($$target.hasClass("rad-button-retry"))
                    dialog.dialogResult = namespace.Dialog.dialogResult.retry;
                else if ($$target.hasClass("rad-button-abort"))
                    dialog.dialogResult = namespace.Dialog.dialogResult.abort;
                else if ($$target.hasClass("rad-button-no"))
                    dialog.dialogResult = namespace.Dialog.dialogResult.no;
                else if ($$target.hasClass("rad-button-yes"))
                    dialog.dialogResult = namespace.Dialog.dialogResult.yes;
                else if ($$target.hasClass("rad-button-ok"))
                    dialog.dialogResult = namespace.Dialog.dialogResult.ok;

                dialog.buttonClicked();
            });
        }
    });

    // Dialog2
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "Dialog2",
        inherits: "Page",
        properties: [
            { name: "animationIn", type: "string" },
            { name: "animationOut", type: "string" },
            { name: "buttonStyle", type: "string" },
            { name: "blockNavigation", type: "boolean" },
            { name: "cancelButtonText", type: "string" },
            { name: "fullWidth", type: "boolean" },
            { name: "okButtonText", type: "string" }
        ],
        propertyAttributes: [
            {
                propertyName: "buttonStyle",
                designer: {
                    category: "Appearance",
                    displayName: "Button Style"
                }
            }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                animationIn: "slide left in",
                animationOut: "slide left out",
                blockNavigation: true,
                buttonStyle: namespace.Dialog.buttonStyle.okOnly,
                cancelButtonText: "Cancel",
                okButtonText: "OK"
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this._blockNavigationFunction = () =>
                {
                    return this.dimmer?.shown();
                };

                this.addCssClass("rad-control-dialog rad-control-dialog2");
                this.$$containerElementGet().addClass("rad-control-container content");
                this.$$footerElement.addClass("rad-dialog-footer");

                this.buttonOk.addCssClass("rad-button-ok ui button primary positive");
                this.buttonYes.addCssClass("rad-button-yes ui right labeled icon button positive");
                this.buttonNo.addCssClass("rad-button-no ui button negative");
                this.buttonAbort.addCssClass("rad-button-abort ui button primary");
                this.buttonRetry.addCssClass("rad-button-retry ui button primary");
                this.buttonIgnore.addCssClass("rad-button-ignore ui button primary");
                this.buttonCancel.addCssClass("rad-button-cancel ui button negative");

                this.$$containerWrapper.removeClass("container");
                this.$$containerWrapper.addClass("content ui form");

                this.detach();

                // Trigger Property Changes
                this.buttonStyleTriggerChange();
                this.cancelButtonTextTriggerChange();
                this.fullWidthTriggerChange();
                this.okButtonTextTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _bindEvents: function ()
                {
                    this.super._bindEvents();

                    this.on("keyup", { self: this }, this.onKeyUp);
                    this.on("click", ">.rad-dialog-footer >.ui.button", { self: this }, this.onFooterButtonClicked);
                },
                _buttonStyleChanged: function (change)
                {
                    this.buttonOk.hide();
                    this.buttonYes.hide();
                    this.buttonNo.hide();
                    this.buttonAbort.hide();
                    this.buttonRetry.hide();
                    this.buttonIgnore.hide();
                    this.buttonCancel.hide();

                    switch (change.currentValue)
                    {
                        case namespace.Dialog.buttonStyle.okOnly:
                            this.buttonOk.show();
                            break;
                        case namespace.Dialog.buttonStyle.okCancel:
                            this.buttonOk.show();
                            this.buttonCancel.show();
                            break;
                        case namespace.Dialog.buttonStyle.yesNo:
                            this.buttonYes.show();
                            this.buttonNo.show();
                            break;
                        case namespace.Dialog.buttonStyle.yesNoCancel:
                            this.buttonYes.show();
                            this.buttonNo.show();
                            this.buttonCancel.show();
                            break;
                        case namespace.Dialog.buttonStyle.retryCancel:
                            this.buttonRetry.show();
                            this.buttonCancel.show();
                            break;
                        case namespace.Dialog.buttonStyle.abortRetryIgnore:
                            this.buttonAbort.show();
                            this.buttonRetry.show();
                            this.buttonIgnore.show();
                            break;
                        case namespace.Dialog.buttonStyle.cancelOnly:
                            this.buttonCancel.show();
                            break;
                    }
                },
                _cancelButtonTextChanged: function (change)
                {
                    this.buttonCancel.textSet(change.currentValue);
                },
                _createContainerElement: function ()
                {
                    var
                        $$element = this.$$elementGet();

                    this.$$footerElement = $$element.find(">.rad-dialog-footer");

                    this.super._createContainerElement();
                },
                _createElement: function ()
                {
                    this.super._createElement();

                    var
                        $$element = this.$$elementGet();

                    $$element.prop("tabindex", 0);
                    
                    this.$$headerElement.prependTo($$element);
                    
                    if (!this.$$footerElement.length)
                        this.$$footerElement = $$.create$$({ nodeName: "div" });
                    
                    this.$$footerElement.insertAfter(this.$$containerWrapper);

                    // Buttons
                    this.buttonOk = this._createFooterButton("OK", "rad-button-ok");
                    this.buttonYes = this._createFooterButton("Yes", "rad-button-yes");
                    this.buttonNo = this._createFooterButton("No", "rad-button-no");
                    this.buttonAbort = this._createFooterButton("Abort", "rad-button-abort");
                    this.buttonRetry = this._createFooterButton("Retry", "rad-button-retry");
                    this.buttonIgnore = this._createFooterButton("Ignore", "rad-button-ignore");
                    this.buttonCancel = this._createFooterButton("Cancel", "rad-button-cancel");
                },
                _createFooterButton: function (text, cssClass)
                {
                    var
                        $$button = this.$$footerElement.find(">." + cssClass);

                    if ($$button.length)
                        return namespace.Control.createFromElement($$button);

                    return new namespace.Button({ cssClass: cssClass, inline: true, text: text }).appendTo(this.$$footerElement);
                },
                _fullWidthChanged: function (change)
                {
                    if (change.currentValue)
                        this.addCssClass("rad-state-full-width");
                    else
                        this.removeCssClass("rad-state-full-width");
                },
                _getDimmer: function ()
                {
                    if (!this.dimmer)
                        this.dimmer = new namespace.PageDimmer({ animationIn: this.animationInGet(), animationOut: this.animationOutGet(), cssClass: "rad-dialog-dimmer" });

                    return this.dimmer;
                },
                _getRootElements: function ()
                {
                    return (
                        this.super._getRootElements()
                            .add(this.$$footerElement)
                    );
                },
                _okButtonTextChanged: function (change)
                {
                    this.buttonOk.textSet(change.currentValue);
                },

                // Public Methods
                closeAsync: function ()
                {
                    var
                        self = this;

                    if (self.closePromise)
                        return self.closePromise;

                    self.removeCssClass("visible");

                    var
                        result = {
                            cancel: false,
                            dialogResult: self.dialogResult
                        };

                    var
                        closePromise =
                            self.onCloseAsync(result)
                                .then(() =>
                                {
                                    if (result.cancel)
                                    {
                                        self.closePromise = null;
                                        return;
                                    }

                                    return (
                                        self._getDimmer().hideElementOrControlAsync(self)
                                            .then(() =>
                                            {
                                                var
                                                    onClosedFn = self.openPromise.onClosedFn;

                                                self.openPromise = null;
                                                self.closePromise = null;

                                                window.pageManager?.unRegisterBlockNavigationFunction(self._blockNavigationFunction);

                                                onClosedFn && onClosedFn([self.dialogResult, self.promiseData]);
                                            })
                                    );
                                })
                                .catch(error =>
                                {
                                    self.closePromise = null;

                                    throw error;
                                });

                    self.closePromise = closePromise;

                    return self.closePromise;
                },
                onCloseAsync: function ()
                {
                    return Promise.resolve();
                },
                onClosed: function (fn)
                {
                    this.onClosedFn = fn;
                    return this;
                },
                openAsync: function ()
                {
                    var
                        self = this;

                    if (self.openPromise)
                        return self.openPromise;

                    self.dialogResult = null;

                    var
                        openPromise =
                            self._getDimmer().showElementOrControlAsync(self)
                                .then(() =>
                                {
                                    window.pageManager?.registerBlockNavigationFunction(self._blockNavigationFunction);
                                    self.focus();
                                });

                    self.openPromise = openPromise;
                    self.openPromise.onClosedFn = self.onClosedFn;
                    self.onClosedFn = null;

                    return self.openPromise;
                },

                // Event Handlers
                onFooterButtonClicked: function (evt)
                {
                    evt.preventDefault();
                    evt.stopPropagation();

                    var
                        self = evt.data.self,
                        $$target = $$(evt.currentTarget),
                        dialogResult;

                    if ($$target.hasClass("rad-button-cancel"))
                        dialogResult = namespace.Dialog.dialogResult.cancel;
                    else if ($$target.hasClass("rad-button-ignore"))
                        dialogResult = namespace.Dialog.dialogResult.ignore;
                    else if ($$target.hasClass("rad-button-retry"))
                        dialogResult = namespace.Dialog.dialogResult.retry;
                    else if ($$target.hasClass("rad-button-abort"))
                        dialogResult = namespace.Dialog.dialogResult.abort;
                    else if ($$target.hasClass("rad-button-no"))
                        dialogResult = namespace.Dialog.dialogResult.no;
                    else if ($$target.hasClass("rad-button-yes"))
                        dialogResult = namespace.Dialog.dialogResult.yes;
                    else if ($$target.hasClass("rad-button-ok"))
                        dialogResult = namespace.Dialog.dialogResult.ok;

                    if (dialogResult)
                    {
                        self.dialogResult = dialogResult;
                        self.closeAsync();
                    }
                },
                onKeyUp: function (evt)
                {
                    var
                        self = evt.data.self,
                        buttonStyle = self.buttonStyleGet(),
                        buttonToClick;

                    switch (evt.key)
                    {
                        case "Enter":
                            {
                                switch (buttonStyle)
                                {
                                    case namespace.Dialog.buttonStyle.abortRetryIgnore:
                                    case namespace.Dialog.buttonStyle.retryCancel:
                                        buttonToClick = self.buttonRetry;
                                        break;
                                    case namespace.Dialog.buttonStyle.okCancel:
                                    case namespace.Dialog.buttonStyle.okOnly:
                                        buttonToClick = self.buttonOk;
                                        break;
                                    case namespace.Dialog.buttonStyle.yesNo:
                                    case namespace.Dialog.buttonStyle.yesNoCancel:
                                        buttonToClick = self.buttonYes;
                                        break;
                                    case namespace.Dialog.buttonStyle.cancelOnly:
                                        break;
                                }
                                break;
                            }
                        case "Escape":
                            {
                                switch (buttonStyle)
                                {
                                    case namespace.Dialog.buttonStyle.abortRetryIgnore:
                                        buttonToClick = self.buttonAbort;
                                        break;
                                    case namespace.Dialog.buttonStyle.retryCancel:
                                    case namespace.Dialog.buttonStyle.okCancel:
                                    case namespace.Dialog.buttonStyle.yesNoCancel:
                                    case namespace.Dialog.buttonStyle.cancelOnly:
                                        buttonToClick = self.buttonCancel;
                                        break;
                                    case namespace.Dialog.buttonStyle.yesNo:
                                        buttonToClick = self.buttonNo;
                                        break;
                                    case namespace.Dialog.buttonStyle.okOnly:
                                        break;
                                }
                                break;
                            }
                    }

                    if (buttonToClick)
                    {
                        evt.preventDefault();
                        evt.stopPropagation();
                        buttonToClick.click();
                    }
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.dialogResult =
            {
                none: "none",
                ok: "ok",
                yes: "yes",
                no: "no",
                abort: "abort",
                retry: "retry",
                ignore: "ignore",
                cancel: "cancel"
            };
            classConstructor.buttonStyle =
            {
                okOnly: "okOnly",
                okCancel: "okCancel",
                yesNo: "yesNo",
                yesNoCancel: "yesNoCancel",
                retryCancel: "retryCancel",
                abortRetryIgnore: "abortRetryIgnore",
                cancelOnly: "cancelOnly"
            };
        }
    });

    // Barcode Dialog
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "BarcodeDialog",
        inherits: "Dialog",
        properties: [
            { name: "allowManualEntry", type: "boolean" },
            { name: "barcodeSettings" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                allowManualEntry: false,
                buttonStyle: namespace.Dialog.buttonStyle.okCancel,
                barcodeSettings: {
                    inputStream: {
                        type: "LiveStream",
                        constraints: {
                            width: { max: 640 },
                            height: { max: 480 },
                            facingMode: "environment",
                            //facingMode: "back",
                            aspectRatio: { min: 1, max: 2 }
                        }
                    },
                    locator: {
                        //patchSize: "medium",
                        patchSize: "large",
                        halfSample: true
                    },
                    numOfWorkers: 4,
                    decoder: {
                        readers: [{
                            //format: "code_128_reader",
                            format: "ean_reader",
                            config: {}
                        }]
                    },
                    locate: true // locate a barcode in a given image
                }
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-barcode-dialog");

                this.scannedCode = String.empty;
                this.lastCameraSelection = String.empty;
                this.scannerRunning = false;
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _allowManualEntryChanged: function (change)
                {
                    this.scannedCode = String.empty;

                    this.textScanResult.visibleSet(change.currentValue);

                    if (change.currentValue)
                        this.$$contentScanResult.hide();
                    else
                        this.$$contentScanResult.show();
                },
                _barcodeSettingsChanged: function (change)
                {
                    if (this.scannerRunning)
                    {
                        Quagga.stop();
                        this.initialiseScanner();
                    }
                },
                _createElement: function ()
                {
                    this.super._createElement();

                    var
                        allowManualEntry = this.allowManualEntryGet(),
                        containerElement = this.$$containerElementGet().get(0);

                    this.comboCameraSelection = new namespace.ComboBox({ placeHolder: "Select Camera", visible: false }).appendTo(containerElement);
                    
                    this.$$viewport = $$.create$$({ nodeName: "div", attributes: { "class": "rad-camera-viewport" } }).appendTo(containerElement);

                    this.textScanResult = new namespace.TextBox({ placeHolder: "Manual Entry" }).appendTo(containerElement);

                    this.$$contentScanResult = $$.create$$({ nodeName: "p" })
                    containerElement.append(this.$$contentScanResult);

                    this.textScanResult.visibleSet(allowManualEntry);

                    if (allowManualEntry)
                        this.$$contentScanResult.hide();
                },

                // Public Methods
                buttonClicked: function ()
                {
                    Quagga.stop();
                    this.scannerRunning = false;

                    if (this.allowManualEntryGet())
                        this.scannedCode = this.textScanResult.valueGet();

                    this.closeAsync();
                },
                initialiseScanner: function ()
                {
                    var settings = this.barcodeSettingsGet(),
                        self = this;

                    settings.inputStream.target = this.$$viewport.get(0);

                    Quagga.init(settings, err =>
                    {
                        if (err)
                        {
                            console.error(err);
                            return;
                        }

                        self.initCameraSelection();
                        Quagga.start();
                        self.scannerRunning = true;
                    });

                    Quagga.onProcessed(result =>
                    {
                        var drawingCtx = Quagga.canvas.ctx.overlay,
                            drawingCanvas = Quagga.canvas.dom.overlay;

                        if (result)
                        {
                            if (result.boxes)
                            {
                                drawingCtx.clearRect(0, 0, parseInt(drawingCanvas.getAttribute("width")), parseInt(drawingCanvas.getAttribute("height")));
                                result.boxes.where(box =>
                                {
                                    return box !== result.box;
                                }).each(box =>
                                {
                                    Quagga.ImageDebug.drawPath(box, { x: 0, y: 1 }, drawingCtx, { color: "green", lineWidth: 2 });
                                });
                            }

                            if (result.box)
                            {
                                Quagga.ImageDebug.drawPath(result.box, { x: 0, y: 1 }, drawingCtx, { color: "#00F", lineWidth: 2 });
                            }

                            if (result.codeResult?.code)
                            {
                                Quagga.ImageDebug.drawPath(result.line, { x: 'x', y: 'y' }, drawingCtx, { color: 'red', lineWidth: 3 });
                            }
                        }
                    });

                    self.lastcode = String.empty;

                    Quagga.onDetected(result =>
                    {
                        var code = result.codeResult.code;
                        if (code !== self.lastcode)
                        {
                            if (self.allowManualEntryGet())
                                self.textScanResult.valueSet(code);
                            else
                                self.$$contentScanResult.text(code);

                            self.scannedCode = code;
                        }

                        self.lastcode = code;
                    });
                },
                initCameraSelection: function ()
                {
                    var
                        streamLabel = Quagga.CameraAccess.getActiveStreamLabel(),
                        selectedOptionValue = String.empty,
                        self = this;

                    Quagga.CameraAccess.enumerateVideoDevices()
                    .then(devices =>
                    {
                        function pruneText(text)
                        {
                            return text.length > 30 ? text.substr(0, 30) : text;
                        }

                        var
                            options = [];

                        devices.each(device =>
                        {
                            options.push({
                                value: device.deviceId || device.id,
                                description: pruneText(device.label || device.deviceId || device.id)
                            });

                            if (streamLabel === device.label)
                                selectedOptionValue = device.deviceId || device.id;
                        });
                        
                        self.comboCameraSelection.listDataSourceSet(options);
                        self.comboCameraSelection.valueSet(selectedOptionValue);
                        self.comboCameraSelection.visibleSet(options.length > 1);

                        if (!self.hasBeenInitialised)
                        {
                            self.comboCameraSelection.on("valueChanged", { self: self }, self.onCameraSelectionChanged);
                            self.hasBeenInitialised = true;
                        }

                    });
                },
                openAsync: function ()
                {
                    this.initialiseScanner();
                    return this.super.openAsync();
                },

                // Event Handlers
                onCameraSelectionChanged: function (evt)
                {
                    // path should be inputStream.constraints.deviceId
                    var
                        self = evt.data.self,
                        settings = self.barcodeSettingsGet(),
                        newCamera = self.comboCameraSelection.valueGet();

                    if (!newCamera || self.lastCameraSelection === newCamera)
                        return;

                    settings.inputStream.constraints.deviceId = newCamera;
                    self.barcodeSettingsSet(window.objectHelper.cloneObject(settings));
                    self.lastCameraSelection = newCamera;
                }
            };
        }
    });

    // Confirm Save Changes Dialog
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "ConfirmSaveChangesDialog",
        inherits: "Dialog",
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-confirm-save-changes-dialog");
                this.animationIn = "fade";
                this.animationOut = null;
            };
        },
        createPropertyDefaults: namespace =>
        {
            return {
                buttonStyle: seriouslyrad.ui.web.Dialog.buttonStyle.okCancel,
                cancelButtonText: "Don't Save",
                okButtonText: "Save"
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _bindEvents: function ()
                {
                    this.super._bindEvents();
                    this.$$close.on("click", { self: this }, this.onCloseClicked);
                },
                _createChildControls: function ()
                {
                    this.super._createChildControls();

                    this.messagePanel =
                        new seriouslyrad.ui.web.Panel()
                            .appendTo(this);

                    this.messagePanel.$$elementGet().append(
                        $$.create([
                            {
                                nodeName: "h3",
                                text: "Save Changes"
                            },
                            {
                                nodeName: "p",
                                text: "Do you want to save the changes made?"
                            }
                        ])
                    );
                },
                _createElement: function ()
                {
                    this.super._createElement();

                    this.$$close =
                        $$.create$$({
                            nodeName: "a",
                            attributes: { "class": "rad-close", href: "#" },
                            children: [{ nodeName: "i", attributes: { "class": "times icon" } }]
                        }).appendTo(this.$$elementGet());

                    this.buttonCancel.removeCssClass("negative");
                    this.buttonCancel.addCssClass("positive");
                    this.buttonCancel.appendTo(this.$$footerElement);
                    this.buttonOk.appendTo(this.$$footerElement);
                },

                // Event Handlers
                onCloseClicked: function (evt)
                {
                    evt.preventDefault();
                    evt.stopPropagation();

                    evt.data.self.closeAsync();
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            var
                dialog = new classConstructor(),
                dialogQueue = [];

            function checkQueue()
            {
                if (!dialog.opened && dialogQueue.length)
                {
                    var
                        queueItem = dialogQueue.shift();

                    dialog.openAsync(queueItem.properties)
                        .then((...args) => { queueItem.promise.resolve.apply(queueItem.promise, args); })
                        .finally(() => { checkQueue(); });
                }
            }

            classConstructor.display = properties =>
            {
                var
                    promise = Promise.public();

                dialogQueue.push({ promise: promise, properties: properties });
                checkQueue();

                return promise;
            };
        }
    });

    // Message Dialog
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "MessageDialog",
        inherits: "Dialog",
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-message-dialog");
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _createElement: function ()
                {
                    this.super._createElement();

                    var
                        $$containerElement = this.$$containerElementGet();

                    this.$$textElement = $$.create$$({ nodeName: "p" }).appendTo($$containerElement);
                },
                _textChanged: function (change)
                {
                    this.super._textChanged(change);

                    this.$$textElement.text(change.currentValue);

                    if (change.currentValue?.length)
                        this.$$textElement.show();
                    else
                        this.$$textElement.hide();
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            var
                messageDialog,
                messageQueue = [],
                item;

            function checkQueue()
            {
                if (!messageDialog)
                    messageDialog = new classConstructor();

                if (!messageDialog.opened && messageQueue.length)
                {
                    item = messageQueue.shift();

                    messageDialog.setProperties(item.properties);

                    messageDialog.openAsync()
                        .then((...args) => { item.promise.resolve.apply(item.promise, args); })
                        .catch(error => { item.promise.reject(error); })
                        .finally(() => { checkQueue(); });
                }
            }

            classConstructor.displayMessage = (title, text, buttonStyle) =>
            {
                var
                    promise = Promise.public();

                messageQueue.push({
                    properties: {
                        buttonStyle: buttonStyle !== undefined ? buttonStyle : namespace.Dialog.buttonStyle.okOnly,
                        text: text,
                        title: title
                    },
                    promise: promise
                });

                checkQueue();

                return promise;
            };
        }
    });

    // Error Dialog
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "ErrorDialog",
        inherits: "MessageDialog",
        createPropertyDefaults: namespace =>
        {
            return {
                buttonStyle: namespace.Dialog.buttonStyle.okOnly,
                title: "Error"
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-error-dialog");
            };
        },
        createPrototype: namespace =>
        {
            return {
                // Public Methods
                openAsync: function (error)
                {
                    if (!error || typeof error === "string")
                    {
                        this.titleSet("The following error occurred:");
                        this.textSet(error ? error : "Unknown error");
                    }
                    else
                    {
                        this.titleSet(error.type);
                        this.textSet(error.message);
                    }

                    return this.super.openAsync();
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            var
                errorDialog,
                errorQueue = [],
                promiseQueue = [];

            function checkQueue()
            {
                if (!errorDialog)
                    errorDialog = new classConstructor();

                if (!errorDialog.opened && errorQueue.length)
                {
                    errorDialog.openAsync(errorQueue.shift())
                        .finally(() =>
                        {
                            checkQueue();
                        });
                }
                else
                {
                    while (promiseQueue.length)
                        promiseQueue.shift().resolve();
                }
            }

            classConstructor.displayError = error =>
            {
                var
                    promise = Promise.public();

                promiseQueue.push(promise);

                errorQueue.push(error);
                checkQueue();

                return promise;
            };
        }
    });

    // Login Message Dialog
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "LoginMessageDialog",
        inherits: "MessageDialog",
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-login-message-dialog");
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            // TODO: Duplicated from MessageDialog
            var
                messageDialog,
                messageQueue = [],
                item;

            function checkQueue()
            {
                if (!messageDialog)
                    messageDialog = new classConstructor();

                if (!messageDialog.opened && messageQueue.length)
                {
                    item = messageQueue.shift();

                    messageDialog.setProperties(item.properties);

                    messageDialog.openAsync()
                        .then((...args) => { item.promise.resolve.apply(item.promise, args); })
                        .catch(error => { item.promise.reject(error); })
                        .finally(() => { checkQueue(); });
                }
            }

            classConstructor.displayMessage = (title, text, buttonStyle) =>
            {
                var
                    promise = Promise.public();

                messageQueue.push({
                    properties: {
                        buttonStyle: buttonStyle !== undefined ? buttonStyle : namespace.Dialog.buttonStyle.okOnly,
                        text: text,
                        title: title
                    },
                    promise: promise
                });

                checkQueue();

                return promise;
            };

            // TODO: Duplicated from MessageDialog
        }
    });

    // Ajax Response Message Dialog
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "AjaxResponseMessageDialog",
        inherits: "Dialog",
        createPropertyDefaults: namespace =>
        {
            return {
                title: "Action Completed Successfully"
            };
        },
        createPrototype: namespace =>
        {
            return {
                // Protected Methods
                _createElement: function ()
                {
                    this.super._createElement();

                    var
                        $$containerElement = this.$$containerElementGet();

                    this.$$p =
                        $$.create$$("p", null, "Please note:")
                            .appendTo($$containerElement);

                    this.$$list =
                        $$.create$$("ul")
                            .appendTo($$containerElement);
                },

                // Public Methods
                openAsync: function (responseMessages)
                {
                    var
                        self = this;

                    self.$$list.empty();

                    responseMessages.each(item =>
                    {
                        self.$$list.append($$.create$$("li").text(item));
                    });

                    return self.super.openAsync();
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            // TODO: Duplication
            var
                messageDialog,
                messageQueue = [],
                item;

            function checkQueue()
            {
                if (!messageDialog)
                    messageDialog = new classConstructor();

                if (!messageDialog.opened && messageQueue.length)
                {
                    item = messageQueue.shift();

                    messageDialog.openAsync(item.properties.responseMessages)
                        .then((...args) => { item.promise.resolve.apply(item.promise, args); })
                        .catch(error => { item.promise.reject(error); })
                        .finally(() => { checkQueue(); });
                }
            }

            classConstructor.displayMessages = responseMessages =>
            {
                var
                    promise = Promise.public();

                messageQueue.push({
                    properties: {
                        responseMessages: responseMessages
                    },
                    promise: promise
                });

                checkQueue();

                return promise;
            };

            // TODO: Duplication
        }
    });

    // Parameter Dialog
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "ParameterDialog",
        inherits: "Dialog",
        abstract: true,
        createPropertyDefaults: namespace =>
        {
            return {
                title: "Filter"
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-parameter-dialog");
            };
        },
        createPrototype: namespace =>
        {
            return {
                // Public Methods
                buttonClicked: function ()
                {
                    this.promiseData = this.createExpression();
                    return this.super.buttonClicked();
                },
                createExpression: function ()
                {
                    return null;
                }
            };
        }
    });

    // Parameter Dialog 1: Text Search
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "TextParameterDialog",
        inherits: "ParameterDialog",
        createPropertyDefaults: namespace =>
        {
            return {
                buttonStyle: namespace.Dialog.buttonStyle.okCancel
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _createElement: function ()
                {
                    this.super._createElement();

                    var
                        $$containerElement = this.$$containerElementGet();

                    this.textBoxText = new namespace.TextBox();
                    new namespace.Label({ text: "Text", minWidth: 100, associatedControl: this.textBoxText }).appendTo($$containerElement);
                    this.textBoxText.appendTo($$containerElement);
                },

                // Public Methods
                createExpression: function ()
                {
                    var
                        expression = new seriouslyrad.AndExpression(),
                        text = this.textBoxText.valueGet();

                    if (text)
                        expression.add(new seriouslyrad.ComparisonExpression({ path: "text", value: text }));

                    return expression.count() > 0 ? expression : null;
                }
            };
        }
    });

    // Class Property Dialog
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "ClassPropertyDialog",
        inherits: "Dialog",
        properties: [
            { name: "classDefinition" },
            { name: "informationText" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                buttonStyle: namespace.Dialog.buttonStyle.okCancel,
                cancelButtonText: "Close",
                okButtonText: "Save"
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-class-property-dialog");
                this.detach();

                // Trigger Property Changes
                this.classDefinitionTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _activateAsync: function ()
                {
                    var
                        self = this;

                    return (
                        self.super._activateAsync()
                            .then(() =>
                            {
                                return (
                                    Promise.all(
                                        self._getPropertyEditors()
                                            .select(item => item.loadDataAsync())
                                    )
                                );
                            })
                            .then(() =>
                            {
                                if (!self.instancePropertyValuesLoaded)
                                    self._instancePropertyValuesLoad();
                            })
                    );
                },
                _classDefinitionChanged: function (change)
                {
                    this._tearDownItems();

                    if (change.currentValue)
                        this._setupItems();
                },
                _createElement: function ()
                {
                    this.super._createElement();

                    this.$$headerElement.append($$.create({ nodeName: "h3" }));

                    this.$$infoElement =
                        $$.create$$({
                            nodeName: "div",
                            attributes: { "class": "rad-info" },
                            children: [{
                                nodeName: "span",
                                attributes: { "class": "rad-title" }
                            },
                            {
                                nodeName: "span",
                                attributes: { "class": "rad-description" }
                            }]
                        }).insertBefore(this.$$footerElement);
                },
                _dataSourceChanged: function (change)
                {
                    var
                        self = this;

                    self.super._dataSourceChanged(change);

                    self.settingDataSource = true;
                    self._getPropertyEditors().each(item =>
                    {
                        item.dataSourceSet(change.currentValue);
                    });
                    self.settingDataSource = false;
                },
                _getPropertyEditorForProperty: function (property, constructionArguments)
                {
                    var
                        propertyEditorClass;

                    if (property.designer?.propertyEditorClass)
                    {
                        propertyEditorClass =
                            typeof property.designer.propertyEditorClass === "string"
                                ? classFactory.getObjectByPath({ path: property.designer.propertyEditorClass })
                                : property.designer.propertyEditorClass;

                        if (!window.objectHelper.classInheritsClass(propertyEditorClass, namespace.PropertyEditor))
                            console.error(String.format("Editor defined for property \"{0}\" is not a PropertyEditor", property.name));
                    }

                    if (!propertyEditorClass)
                    {
                        switch (property.type)
                        {
                            case "boolean":
                                propertyEditorClass = namespace.PropertyEditorSwitch;
                                break;
                            case "string":
                                propertyEditorClass = namespace.PropertyEditorTextBox;
                                break;
                            default:
                                propertyEditorClass = namespace.PropertyEditorTextBox;
                                break;
                        }
                    }

                    if (property.designer?.propertyEditorProperties)
                    {
                        for (let propertyEditorProperty in property.designer.propertyEditorProperties)
                            constructionArguments[propertyEditorProperty] = property.designer.propertyEditorProperties[propertyEditorProperty];
                    }

                    constructionArguments.page = this;

                    return new propertyEditorClass(constructionArguments);
                },
                _getPropertyEditors: function ()
                {
                    return (
                        this.controlsGet(true)
                        .where(item => item instanceof namespace.PropertyEditor)
                    );
                },
                _informationTextChanged: function (change)
                {
                    if (change.currentValue?.description)
                    {
                        this.$$infoElement.find(">.rad-title").text(change.currentValue.title);
                        this.$$infoElement.find(">.rad-description").text(change.currentValue.description);
                        this.$$infoElement.show();
                    }
                    else
                    {
                        this.$$infoElement.find(">.rad-title").text(String.empty);
                        this.$$infoElement.find(">.rad-description").text(String.empty);
                        this.$$infoElement.hide();
                    }
                },
                _instancePropertyValuesLoad: function ()
                {
                    var
                        self = this,
                        data = {};

                    if (!self.instance)
                        return;

                    this.titleSet(self.instance[".classDefinition"].className);

                    this.$$headerElement
                        .find(">h3").text(self.instance[".classDefinition"].namespacePath);

                    self._getPropertyEditors().each(item =>
                    {
                        var
                            dataSourceProperty = item.dataSourcePropertyGet();

                        if (!dataSourceProperty)
                            return;

                        var
                            indexOfDot = dataSourceProperty.indexOf("."),
                            propertyName =
                                indexOfDot > -1
                                ? dataSourceProperty.substr(0, indexOfDot)
                                : dataSourceProperty;

                        if (data[propertyName] === undefined)
                            data[propertyName] = self.instance[propertyName + "Get"]();
                    });

                    self.dataSourceSet(data);

                    self.instancePropertyValuesLoaded = true;
                },
                _instancePropertyValuesSave: function ()
                {
                    var
                        self = this,
                        dataSource = self.dataSourceGet();

                    if (!dataSource)
                        return;

                    var
                        data = dataSource.dataGet();

                    if (!data)
                        return;

                    for (let property in data)
                        self.instance[property + "Set"](data[property]);
                },
                _setupItems: function ()
                {
                    var
                        self = this,
                        $$containerElement = self.$$containerElementGet(),
                        classDefinition = self.classDefinitionGet();

                    self.accordion = $$containerElement.find(">.rad-control-accordion").radControl();

                    if (!self.accordion)
                    {
                        self.accordion =
                            new namespace.Accordion({ allowMultiplePanelsOpen: true })
                            .appendTo(self);
                    }

                    var
                        accordionPanel;

                    classDefinition.designablePropertiesGet()
                        .orderBy(designableProperty => (designableProperty.designer.category ? designableProperty.designer.category : String.empty) + "||" + (designableProperty.designer.order !== undefined ? designableProperty.designer.order : String.empty) + "||" + (designableProperty.designer.displayName ? designableProperty.designer.displayName : designableProperty.name))
                        .each(designableProperty =>
                        {
                            var
                                categoryName = designableProperty.designer.category ? designableProperty.designer.category : String.empty;

                            accordionPanel = self.accordion.controlsGet().firstOrDefault(item => item.textGet() === categoryName);

                            if (!accordionPanel)
                                accordionPanel = new namespace.AccordionPanel({ text: categoryName }).appendTo(self.accordion);

                            var
                                propertyEditor =
                                    self._getPropertyEditorForProperty(
                                        designableProperty,
                                        {
                                            dataSourceProperty: designableProperty.name,
                                            editMode: true,
                                            helpText: designableProperty.designer.helpText ? designableProperty.designer.helpText : String.empty,
                                            propertyDisplayName: designableProperty.designer.displayName ? designableProperty.designer.displayName : designableProperty.name
                                        }
                                    );

                            if (propertyEditor)
                                propertyEditor.appendTo(accordionPanel);
                        });
                },
                _tearDownItems: function ()
                {
                    if (this.accordion)
                        this.accordion.remove();
                },

                // Public Methods
                buttonClicked: function ()
                {
                    switch (this.dialogResult)
                    {
                        case namespace.Dialog.dialogResult.ok:
                            this.saveAndCloseAsync();
                            break;
                        case namespace.Dialog.dialogResult.cancel:
                            this.closeAsync();
                            break;
                    }
                },
                closeAsync: function ()
                {
                    var
                        self = this;

                    return (
                        self.super.closeAsync()
                            .then(() =>
                            {
                                self.openPromise.resolve();
                            })
                    );
                },
                openAsync: function (instance)
                {
                    this.instance = instance;
                    this.instancePropertyValuesLoaded = false;
                    return this.super.openAsync();
                },
                saveAndCloseAsync: function ()
                {
                    this._instancePropertyValuesSave();
                    return this.closeAsync();
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            $$(document).on("focus", ".rad-control-class-property-dialog .rad-control-property-editor", evt =>
            {
                evt.preventDefault();
                evt.stopPropagation();

                var
                    $$target = $$(evt.currentTarget),
                    propertyEditor = $$target.radControl(),
                    classPropertyDialog = $$target.closest(".rad-control-class-property-dialog").radControl();

                classPropertyDialog.informationTextSet({
                    title: propertyEditor.dataSourcePropertyGet(),
                    description: propertyEditor.helpTextGet()
                });
            });

            var
                classPropertyDialogs = [];

            classConstructor.forInstance = instance =>
            {
                var
                    classDefinition = instance[".classDefinition"],
                    classPropertyDialog;

                for (var i = 0; i < classPropertyDialogs.length; i++)
                {
                    if (classPropertyDialogs[i].classDefinition === classDefinition)
                    {
                        classPropertyDialog = classPropertyDialogs[i].classPropertyDialog;
                        break;
                    }
                }

                if (!classPropertyDialog)
                {
                    classPropertyDialog = new namespace.ClassPropertyDialog({ classDefinition: classDefinition });
                    classPropertyDialogs.push({ classDefinition: classDefinition, classPropertyDialog: classPropertyDialog });
                }

                return classPropertyDialog;
            };
        }
    });

    // Entity Audit Dialog
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "EntityAuditDialog",
        inherits: "Dialog",
        properties: [
            { name: "applicationEntitySupportsSoftDelete", type: "boolean" },
            { name: "entitySetName", type: "string" },
            { name: "recordId", type: "string" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                title: "Audit Information"
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-dialog-entity-audit");
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _activateAsync: function ()
                {
                    var
                        self = this,
                        promises = [],
                        entitySetName = self.entitySetNameGet(),
                        recordId = self.recordIdGet(),
                        properties = [
                            "createdByUser.Fullname",
                            "createdDate",
                            "lastUpdatedByUser.Fullname",
                            "lastUpdatedDate"
                        ];

                    if (self.applicationEntitySupportsSoftDeleteGet())
                    {
                        properties.push.apply(properties, [
                            "deletedByUser.Fullname",
                            "deletedDate",
                            "deletedGuid"
                        ]);
                    }

                    promises.push(
                        window.application.webApiClient
                            .createEntityGetRequest(
                                entitySetName,
                                recordId,
                                properties,
                                { "RAD-Option-Include-Soft-Deleted": true }
                            )
                            .executeAsync()
                    );

                    promises.push(
                        self.entitySearch
                            .searchAsync(0, new seriouslyrad.AndExpression({
                                expressions: [
                                    new seriouslyrad.ComparisonExpression({
                                        path: "entityProperty.entity.namePlural",
                                        value: entitySetName ? entitySetName : null
                                    }),
                                    new seriouslyrad.ComparisonExpression({
                                        path: "recordId",
                                        value: recordId ? recordId : null
                                    })
                                ]
                            }), true)
                            .then(() =>
                            {
                                if (self.entitySearch.searchResultsCountGet())
                                {
                                    self.entitySearch.show();
                                    self.$$noResults.hide();
                                }
                                else
                                {
                                    self.entitySearch.hide();
                                    self.$$noResults.show();
                                }
                            })
                    );

                    return (
                        Promise.all(promises)
                            .then(results =>
                            {
                                const
                                    data = results[0];

                                self.dataSourceSet(data);
                            })
                    );
                },
                _createContainerElement: function ()
                {
                    this.super._createContainerElement();

                    var
                        panel;

                    panel = new namespace.Panel().appendTo(this);
                    panel.append($$.create$$("h4", null, "Record Information"));

                    panel = new namespace.Panel().appendTo(this);
                    this.propertyEditorCreatedBy = new namespace.PropertyEditorText({ propertyDisplayName: "Created By", dataSourceProperty: "createdByUser.fullName" }).appendTo(panel);
                    this.propertyEditorCreatedDate = new namespace.PropertyEditorDateTime({ propertyDisplayName: "Created Date", dataSourceProperty: "createdDate" }).appendTo(panel);
                    this.propertyEditorLastUpdatedBy = new namespace.PropertyEditorText({ propertyDisplayName: "Last Updated By", dataSourceProperty: "lastUpdatedByUser.fullName" }).appendTo(panel);
                    this.propertyEditorLastUpdatedDate = new namespace.PropertyEditorDateTime({ propertyDisplayName: "Last Updated Date", dataSourceProperty: "lastUpdatedDate" }).appendTo(panel);
                    this.propertyEditorDeletedBy = new namespace.PropertyEditorText({ propertyDisplayName: "Deleted By", dataSourceProperty: "deletedByUser.fullName" }).appendTo(panel);
                    this.propertyEditorDeletedDate = new namespace.PropertyEditorDateTime({ propertyDisplayName: "Deleted Date", dataSourceProperty: "deletedDate" }).appendTo(panel);

                    panel = new namespace.Panel().appendTo(this);
                    panel.append($$.create$$("h4", null, "Property Change Information"));

                    this.$$noResults = $$.create$$("h4", null, "No property change information available").hide();
                    panel.append(this.$$noResults);

                    this.entitySearch =
                        new namespace.EntitySearch({
                            applicationEntityName: "EntityPropertyAuditLogItem",
                            applicationEntityNameFriendly: "Entity Property Audit Log Item",
                            applicationEntityNamePlural: "EntityPropertyAuditLogItems",
                            applicationEntityNameFriendlyPlural: "Entity Property Audit Log Items",
                            defaultSortListProperty: "createdDate",
                            defaultSortListPropertyDirection: namespace.EntitySearch.sortDirections.descending,
                            listProperties: [
                                { path: "createdDate", name: "Date" },
                                { path: "entityProperty.displayName", name: "Property", isString: true },
                                { path: "oldDescription", name: "From", isString: true },
                                { path: "newDescription", name: "To", isString: true },
                                { path: "createdByUser.fullName", name: "User", isString: true }
                            ],
                            showEntityCommands: false
                        })
                        .appendTo(this);

                    this.entitySearch.tableSearchResults.rowClickableSet(false);
                    this.entitySearch.tableSearchResults.rowIconSet(null);
                    this.entitySearch.tableSearchResults.rowIconMobileSet(null);
                },
                _dataSourceChanged: function (change)
                {
                    this.super._dataSourceChanged(change);

                    this.propertyEditorDeletedBy.visibleSet(!!(change.currentValue?.propertyValueByPathGet("deletedGuid")));
                    this.propertyEditorDeletedDate.visibleSet(!!(change.currentValue?.propertyValueByPathGet("deletedGuid")));
                },

                // Public Methods
                openAsync: function (entitySetName, recordId, applicationEntitySupportsSoftDelete)
                {
                    this.entitySetNameSet(entitySetName);
                    this.recordIdSet(recordId);
                    this.applicationEntitySupportsSoftDeleteSet(applicationEntitySupportsSoftDelete);
                    return this.super.openAsync();
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.getSingleInstance = () =>
            {
                if (!classConstructor.instance)
                    classConstructor.instance = new classConstructor();

                return classConstructor.instance;
            };
        }
    });

    // Mfa Setup Dialog
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "MfaSetupDialog",
        inherits: "Dialog",
        mixins: [
            "MfaProviderSelectionMixin"
        ],
        properties: [
            { name: "mode", type: "string" },
            { name: "mfaControl" },
            { name: "mfaUiClass", type: "string" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                buttonStyle: namespace.Dialog.buttonStyle.cancelOnly,
                cancelButtonText: "Close"
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-mfa-setup-dialog");

                // Trigger Property Changes
                this.modeTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _activateAsync: function ()
                {
                    var
                        self = this;

                    return (
                        self.super._activateAsync()
                            .then(() =>
                            {
                                return new Promise(resolve =>
                                {
                                    if (self.refreshRecoveryCodes)
                                    {
                                        self.modeSet(namespace.MfaSetupDialog.modes.mfaRequest);
                                        self._refreshRecoveryCodesAsync()
                                            .finally(() =>
                                            {
                                                resolve();
                                            });
                                    }
                                    else
                                    {
                                        self.modeSet(null);
                                        self._enableMfaAsync()
                                            .finally(() =>
                                            {
                                                resolve();
                                            });
                                    }
                                });
                            })
                    );
                },
                _createElement: function ()
                {
                    this.super._createElement();

                    this.validationPanel =
                        new namespace.ValidationPanel()
                            .prependTo(this);

                    this.wizard =
                        new namespace.Wizard()
                            .appendTo(this);

                    this.panelMfaSetup = new namespace.Panel({ cssClass: "rad-panel-mode-mfa-setup" });
                    this.panelMfaRequest = new namespace.Panel({ cssClass: "rad-panel-mode-mfa-request" });
                },
                _enableMfaAsync: function (mfaProviderId, mfaSetupData)
                {
                    var
                        self = this;

                    return (
                        window.application.webApiClient
                            .createApiMethodRequest("Security", "EnableMfa", { mfaProviderId: mfaProviderId, mfaSetupData: mfaSetupData ? mfaSetupData.toJson() : null })
                            .executeAsync()
                            .then(data =>
                            {
                                self.promiseData = data;

                                var
                                    mfaControl = self.mfaControlGet(),
                                    handled = mfaControl?.loginSuccessful(data.mfaRecoveryCodes).handled;

                                if (!handled)
                                    self.closeAsync();
                            })
                            .catch(error =>
                            {
                                var
                                    handled = false;

                                if (["MfaAuthenticationApiException"].contains(error.type))
                                {
                                    switch (error.reason)
                                    {
                                        case "mfaFailed":
                                            if (error.additionalData?.mfaUiClass)
                                            {
                                                self.mfaUiClassSet(error.additionalData.mfaUiClass);
                                                handled = self.mfaControlGet().loginFailed(error.subReason, error.additionalData).handled;
                                                if (handled)
                                                    self.modeSet(namespace.MfaSetupDialog.modes.mfaRequest);
                                            }
                                            break;
                                        case "mfaSetupRequired":
                                            self.panelMfaSetup.controlsClear();
                                            if (error.additionalData?.mfaProviders)
                                                self.addMfaProviderOptionsToPanel(error.additionalData.mfaProviders, self.panelMfaSetup, self.onButtonMfaProviderSelectClicked);

                                            self.modeSet(namespace.MfaSetupDialog.modes.mfaSetup);
                                            handled = true;
                                            break;
                                    }
                                }

                                if (!handled)
                                    namespace.LoginMessageDialog.displayMessage("Error", error.message);
                            })
                    );
                },
                _hideAllPanels: function ()
                {
                    this.controlsGet()
                        .where(item => item instanceof namespace.Panel && !(item instanceof namespace.Wizard))
                        .forEach(item => { item.hide(); });
                },
                _modeChanged: function (change)
                {
                    this._hideAllPanels();
                    this._resetValidation();

                    switch (change.currentValue)
                    {
                        case namespace.MfaSetupDialog.modes.mfaRequest:
                            this.titleSet("Multi Factor Authentication");
                            this.wizard.navigateToPanelAsync(this.panelMfaRequest);
                            break;
                        case namespace.MfaSetupDialog.modes.mfaSetup:
                            this.titleSet("Setup Multi Factor Authentication");
                            this.wizard.navigateToPanelAsync(this.panelMfaSetup, true)
                                .then(() =>
                                {
                                    const
                                        mfaControl = this.mfaControlGet();

                                    if (mfaControl)
                                        mfaControl.modeSet(null);
                                });
                            break;
                    }
                },
                _mfaControlChanged: function (change)
                {
                    if (change.originalValue)
                    {
                        change.originalValue.off("cancel", { self: this }, this.onMfaControlCancelled);
                        change.originalValue.off("close", { self: this }, this.onMfaControlClosed);
                        change.originalValue.off("login", { self: this }, this.onMfaControlLogin);
                        change.originalValue.off("resetValidation", { self: this }, this.onMfaControlResetValidation);
                        change.originalValue.off("titleChange", { self: this }, this.onMfaControlTitleChanged);
                        change.originalValue.off("validationFailed", { self: this }, this.onMfaControlValidationFailed);
                        change.originalValue.remove();
                    }

                    if (change.currentValue)
                    {
                        change.currentValue.shownInDialogSet(true);
                        change.currentValue.on("cancel", { self: this }, this.onMfaControlCancelled);
                        change.currentValue.on("close", { self: this }, this.onMfaControlClosed);
                        change.currentValue.on("login", { self: this }, this.onMfaControlLogin);
                        change.currentValue.on("resetValidation", { self: this }, this.onMfaControlResetValidation);
                        change.currentValue.on("titleChange", { self: this }, this.onMfaControlTitleChanged);
                        change.currentValue.on("validationFailed", { self: this }, this.onMfaControlValidationFailed);
                        change.currentValue.appendTo(this.panelMfaRequest);
                    }
                },
                _mfaUiClassChanged: function (change)
                {
                    this.mfaControlSet(change.currentValue ? namespace.Control.createFromClassPath(change.currentValue) : null);
                },
                _refreshRecoveryCodesAsync: function ()
                {
                    var
                        self = this;

                    return (
                        window.application.webApiClient
                            .createApiMethodRequest("Security", "RefreshMfaRecoveryCodes")
                            .executeAsync()
                            .then(data =>
                            {
                                self.promiseData = data;
                                self.mfaUiClassSet(data.uiClass);

                                var
                                    mfaControl = self.mfaControlGet(),
                                    handled = mfaControl?.loginSuccessful(data.mfaRecoveryCodes).handled;

                                if (!handled)
                                    self.closeAsync();
                            })
                            .catch(error =>
                            {
                                self.closeAsync();
                            })
                    );
                },
                _resetValidation: function ()
                {
                    this.validationPanel.setErrorMessages(null);

                    this.controlsGet(true)
                        .where(item => item.errorStateSet)
                        .forEach(item => { item.errorStateSet(false); });

                    this.controlsGet(true)
                        .where(item => item.validationMessagesSet)
                        .forEach(item => { item.validationMessagesSet([]); });
                },

                // Public Methods
                closeAsync: function ()
                {
                    return (
                        this.super.closeAsync()
                            .then(() => this.wizard.navigateToPanelAsync(this.panelMfaSetup, true))
                            .then(() =>
                            {
                                const
                                    mfaControl = this.mfaControlGet();

                                if (mfaControl)
                                    mfaControl.modeSet(null);
                            })
                        )
                },
                openAsync: function (refreshRecoveryCodes)
                {
                    this.refreshRecoveryCodes = refreshRecoveryCodes;
                    return this.super.openAsync();
                },

                // Event Handlers
                onButtonMfaProviderSelectClicked: function (evt)
                {
                    evt.preventDefault();
                    evt.stopPropagation();

                    var
                        self = evt.data.self,
                        button = $$.radControl(evt.currentTarget),
                        tag = button ? button.tagGet() : null;

                    if (!tag)
                        return;

                    self.mfaUiClassSet(tag ? tag.uiClass : null);
                    self._enableMfaAsync(tag.id);
                },
                onMfaControlCancelled: function (evt)
                {
                    evt.data.self.modeSet(namespace.MfaSetupDialog.modes.mfaSetup);
                },
                onMfaControlClosed: function (evt)
                {
                    evt.data.self.closeAsync();
                },
                onMfaControlLogin: function (evt, eventData)
                {
                    evt.data.self._enableMfaAsync(eventData.mfaProviderId, eventData.setupData);
                },
                onMfaControlResetValidation: function (evt)
                {
                    evt.data.self._resetValidation();
                },
                onMfaControlTitleChanged: function (evt, eventData)
                {
                    evt.data.self.titleSet(eventData.title);
                },
                onMfaControlValidationFailed: function (evt, eventData)
                {
                    evt.data.self.validationPanel.setErrorMessages(eventData.errorMessages);
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.modes =
            {
                mfaRequest: "mfaRequest",
                mfaSetup: "mfaSetup"
            };
        }
    });

    // Exception Detail Dialog
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "ExceptionDetailDialog",
        inherits: "Dialog",
        properties: [
            { name: "exceptionDetail" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                buttonStyle: namespace.Dialog.buttonStyle.okOnly,
                title: "Exception Detail"
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-exception-detail-dialog");

                // Trigger Property Changes
                this.exceptionDetailTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _createElement: function ()
                {
                    this.super._createElement();

                    this.accordion =
                        new seriouslyrad.ui.web.Accordion()
                            .appendTo(this);
                },
                _exceptionDetailChanged: function (change)
                {
                    this._updateDisplay();
                },
                _updateDisplay: function ()
                {
                    var
                        exceptionDetail = this.exceptionDetailGet();

                    this.accordion.controlsClear();

                    while (exceptionDetail)
                    {
                        var
                            accordionPanel =
                                new seriouslyrad.ui.web.AccordionPanel({ text: exceptionDetail.type })
                                    .appendTo(this.accordion);

                        accordionPanel
                            .append(
                                $$.create$$({
                                    nodeName: "p",
                                    children: [
                                        {
                                            nodeName: "strong",
                                            text: "Message:"
                                        },
                                        {
                                            nodeName: "br",
                                        },
                                        (new namespace.TextBox({ cssClass: "rad-message", enabled: false, type: namespace.TextBox.type.multiline, value: exceptionDetail.message }))
                                            .$$elementGet()[0]
                                    ]
                                })
                            );

                        accordionPanel
                            .append(
                                $$.create$$({
                                    nodeName: "p",
                                    children: [
                                        {
                                            nodeName: "strong",
                                            text: "Stack Trace:"
                                        },
                                        {
                                            nodeName: "br",
                                        },
                                        (new namespace.TextBox({ cssClass: "rad-stack-trace", enabled: false, type: namespace.TextBox.type.multiline, value: exceptionDetail.stackTrace }))
                                            .$$elementGet()[0]
                                    ]
                                })
                            );

                        exceptionDetail = exceptionDetail.innerExceptionDetail;
                    }
                },

                // Public Methods
                openAsync: function (exceptionDetail)
                {
                    this.exceptionDetailSet(exceptionDetail);
                    return this.super.openAsync();
                }
            };
        }
    });

    // Select Items Dialog
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "SelectItemsDialog",
        inherits: "Dialog2",
        properties: [
            { name: "allowMultipleSelection", type: "boolean" },
            { name: "loadDataFunction", type: "function" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                buttonStyle: namespace.Dialog2.buttonStyle.okCancel,
                okButtonText: "Done",
                title: "Select Items"
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-dialog-select-items");

                // Trigger Property Changes
                this.allowMultipleSelectionTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _allowMultipleSelectionChanged: function (change)
                {
                    this.tableOptions.allowMultipleSelectionSet(change.currentValue);
                },
                _cancel: function ()
                {
                    this.dialogResult = seriouslyrad.ui.web.Dialog.dialogResult.cancel;
                    this.promiseData = null;
                    this.closeAsync();
                },
                _createChildControls: function ()
                {
                    this.super._createChildControls();

                    this.tableOptions =
                        new namespace.TableSelectItems({ stackable: false })
                            .appendTo(this);

                    this.tableOptions.addColumn(new seriouslyrad.ui.web.TableColumn({
                        dataSourceProperty: "description"
                    }));

                    this.tableOptions.addColumn(new namespace.TableColumnTick({
                        dataSourceProperty: "selected"
                    }));
                },
                _loadAsync: function ()
                {
                    var
                        self = this;

                    return (
                        self.super._loadAsync()
                            .then(() =>
                            {
                                return self._updateDisplayAsync();
                            })
                            .then(() =>
                            {
                                self.valueSet(self.initialValue);
                            })
                    );
                },
                _updateDisplayAsync: function ()
                {
                    var
                        self = this,
                        loadDataFunction = self.loadDataFunctionGet();

                    if (!loadDataFunction)
                        return Promise.reject("Load Data Function not set");

                    return (
                        loadDataFunction()
                            .then(data =>
                            {
                                self.tableOptions.dataSourceSet(data);
                            })
                        );
                },

                // Public Methods
                onCloseAsync: function (result)
                {
                    if (result.dialogResult === seriouslyrad.ui.web.Dialog.dialogResult.ok)
                        this.promiseData = this.valueGet();

                    return this.super.onCloseAsync(result);
                },
                openAsync: function (value)
                {
                    this.initialValue = value;
                    return this.super.openAsync();
                },
                valueGet: function ()
                {
                    var
                        tableOptionsDataSource = this.tableOptions.dataSourceGet(),
                        tableOptionsData = tableOptionsDataSource ? tableOptionsDataSource.dataGet() : null;

                    if (!tableOptionsData)
                        return null;

                    return (
                        tableOptionsData
                            .where(item => item.selected === true)
                            .select(item => item.value)
                    );
                },
                valueSet: function (value)
                {
                    if (!Array.isArray(value))
                        value = [value];

                    var
                        tableRows = this.tableOptions.rowsGet();

                    tableRows.each(item =>
                    {
                        var
                            tableRowDataSource = item.dataSourceGet();

                        if (!tableRowDataSource)
                            return;

                        var
                            rowValue = tableRowDataSource.propertyValueByPathGet("value");

                        if (value.contains(rowValue))
                            tableRowDataSource.propertyValueByPathSet("selected", true);
                    });
                }
            }
        }
    });

    // Tenant Select Dialog
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "TenantSelectDialog",
        inherits: "Dialog",
        createPropertyDefaults: namespace => ({
            title: "Select an account"
        }),
        createConstructor: namespace =>
            function ()
            {
                this.addCssClass("rad-control-dialog-tenant-select")
            },
        createPrototype: namespace => ({
            // Protected Methods
            _activateAsync: function ()
            {
                this.controlsClear();

                this.append(
                    this.tenants
                        .orderBy(item => item.name)
                        .select(item => new seriouslyrad.ui.web.Button({ tag: item, text: item.name }))
                );

                return this.super._activateAsync();
            },
            _createElement: function ()
            {
                this.super._createElement();

                this.$$footerElement.hide();
            },
            _getDimmer: function ()
            {
                if (!this.dimmer)
                    this.dimmer = new namespace.PageDimmer({ animationIn: this.animationInGet(), animationOut: this.animationOutGet(), cssClass: "rad-dialog-dimmer rad-dialog-dimmer-tenant-select" });

                return this.dimmer;
            },

            // Public Methods
            openAsync: function (tenants)
            {
                this.tenants = tenants || [];
                return this.super.openAsync();
            }
        }),
        classCreated: (namespace, classConstructor) =>
        {
            $(document).on("click", ".rad-control-dialog-tenant-select .rad-control-button", evt =>
            {
                const
                    $$currentTarget = $$(evt.currentTarget),
                    button = $$currentTarget.radControl(),
                    tenantId = button?.tagGet()?.id,
                    dialog = button?.pageGet();
                    
                if (tenantId && dialog)
                {
                    const
                        additionalHeaders = {},
                        authenticationData = window.application.authenticationDataGet();

                    if (authenticationData)
                    {
                        switch (authenticationData.scheme)
                        {
                            case "Cookies":
                                additionalHeaders["X-XSRF-Token"] = authenticationData.antiForgeryToken;
                                break;
                            case "Bearer":
                                additionalHeaders["Authorization"] = `Bearer ${authenticationData.accessToken}`;
                                break;
                        }
                    }

                    $$
                        .ajax({
                            type: "POST",
                            headers: Object.extend(true, {}, seriouslyrad.server.WebApiClient.staticHeaders, additionalHeaders),
                            dataType: "json",
                            contentType: "application/json",
                            url: String.format("{0}api/Security/{1}", window.applicationInformation.serverVirtualDirectory, "SetTenant"),
                            data: { tenantId: tenantId }.toJson(),
                            xhrFields: {
                                withCredentials: true
                            }
                        })
                        .then(result =>
                        {
                            const
                                response = result[0];

                            dialog.dialogResult = seriouslyrad.ui.web.Dialog.dialogResult.ok;
                            dialog.promiseData = response;

                            return dialog.closeAsync();
                        })
                        .catch(error =>
                        {
                            namespace.ErrorDialog.displayError(error);
                        })
                }
            });
        }
    });

    // Picker Dialog
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "PickerDialog",
        inherits: "Dialog",
        abstract: true,
        properties: [
            { name: "addNew", type: "boolean" },
            { name: "columns", type: "array" },
            { name: "dataServiceId", type: "string" },
            { name: "dataServiceOperation", type: "string" },
            { name: "returnProperty", type: "string" },
            { name: "topN", type: "int" },
        ],
        createPropertyDefaults: namespace => ({
            addNew: true,
            buttonStyle: namespace.Dialog.buttonStyle.okCancel,
            returnProperty: "id",
            scrollable: false,
        }),
        createConstructor: namespace =>
            function ()
            {
                this.addCssClass("rad-dialog-picker");

                // Trigger Property Changes
                this.addNewTriggerChange();
                this.columnsTriggerChange();
                this.dataServiceIdTriggerChange();
                this.dataServiceOperationTriggerChange();
                this.topNTriggerChange();
            },
        createPrototype: namespace => ({
            // "Protected" Methods
            _bindEvents: function ()
            {
                this.super._bindEvents();

                this.buttonCancel.on("click", { self: this }, this.onButtonCancelClicked);
                this.infiniteScrollPanel.on("loadMore", { self: this }, this.onLoadMore);
                this.lazyDataTable.on("dataCleared", { self: this }, this.onLazyDataTableDataCleared);
                this.lazyDataTable.on("dataLoaded", { self: this }, this.onLazyDataTableDataLoaded);
                this.textBoxSearch.on("valueChanged", { self: this }, this.onTextBoxSearchValueChanged);
            },
            _checkLoadedEnough: function ()
            {
                if (!this._isShown())
                    return;

                if (this.infiniteScrollPanel.isContentScrollable())
                    return;

                this._loadLazyDataTableAsync();
            },
            _columnsChanged: function (change)
            {
                this.lazyDataTable.columnsSet(change.currentValue);
            },
            _createElement: function ()
            {
                this.super._createElement();

                this.$$iconElement =
                    $$.create$$({
                        nodeName: "i",
                        attributes: { "class": "icon rad-icon-default-32" },
                        children: [{ nodeName: "span" }]
                    }).appendTo(this.$$titleElement);

                this.panelSearch =
                    new seriouslyrad.ui.web.Panel({ cssClass: "rad-panel-search" })
                        .appendTo(this);

                this.textBoxSearch =
                    new seriouslyrad.ui.web.TextBox({ cssClass: "rad-input-search", svgKey: "icon-search" })
                        .appendTo(this.panelSearch);

                this.panelButtonContainer =
                    new seriouslyrad.ui.web.Panel({ cssClass: "rad-panel-button-container" })
                        .appendTo(this.panelSearch);

                this.buttonCancel =
                    new seriouslyrad.ui.web.Button({ cssClass: "rad-action-cancel", inline: true, text: "Cancel" })
                        .appendTo(this.panelButtonContainer);

                this.infiniteScrollPanel =
                    new seriouslyrad.ui.web.InfiniteScrollPanel({ hasPreviousResults: false })
                        .appendTo(this);

                this.lazyDataTable =
                    new seriouslyrad.ui.web.LazyDataTable()
                        .appendTo(this.infiniteScrollPanel);
            },
            _dataServiceIdChanged: function (change)
            {
                this.lazyDataTable.dataServiceIdSet(change.currentValue);
            },
            _dataServiceOperationChanged: function (change)
            {
                this.lazyDataTable.dataServiceOperationSet(change.currentValue);
            },
            _loadAsync: function ()
            {
                return (
                    this.super._loadAsync()
                        .then(() => this._loadLazyDataTableAsync())
                );
            },
            _loadLazyDataTableAsync: function (clear)
            {
                if (clear)
                    this.lazyDataTable.clearData();

                this.lazyDataTable.updateAdditionalDataServiceParameters({
                    searchText: this.textBoxSearch.valueGet()
                });

                return this.lazyDataTable.loadDataAsync();
            },
            _queueLoadLazyDataTableAsync: function ()
            {
                if (this._queueLoadLazyDataTableAsyncTimeoutId)
                    clearTimeout(this._queueLoadLazyDataTableAsyncTimeoutId);

                this._queueLoadLazyDataTableAsyncTimeoutId =
                    setTimeout(() =>
                    {
                        this._loadLazyDataTableAsync(true);
                    }, 300);
            },
            _select: function (data)
            {
                const
                    returnProperty = this.returnPropertyGet();

                this.promiseData = returnProperty ? data[returnProperty] : data;
                this.dialogResult = seriouslyrad.ui.web.Dialog.dialogResult.ok;
                this.buttonClicked();
            },
            _topNChanged: function (change)
            {
                this.lazyDataTable.topNSet(change.currentValue);
            },

            // Public Methods
            openAsync: function ()
            {
                this.textBoxSearch.valueSet(null);
                this.lazyDataTable.loadDataAsync(true);

                return this.super.openAsync();
            },

            // Event Handlers
            onButtonCancelClicked: function (evt)
            {
                const
                    self = evt.data.self;

                self.dialogResult = seriouslyrad.ui.web.Dialog.dialogResult.cancel;
                self.buttonClicked();
            },
            onLazyDataTableDataCleared: function (evt)
            {
                evt.data.self.infiniteScrollPanel.hasNextResultsSet(true);
            },
            onLazyDataTableDataLoaded: function (evt, eventData)
            {
                const
                    self = evt.data.self,
                    hasNextResults = eventData && eventData.results && eventData.results.length && eventData.results[0].length === self.topNGet();

                self.infiniteScrollPanel.hasNextResultsSet(hasNextResults);

                if (hasNextResults)
                    self._checkLoadedEnough();
            },
            onLoadMore: function (evt, eventData)
            {
                if (eventData.location !== "bottom")
                    return;

                var
                    self = evt.data.self;

                if (self.loadingMore)
                    return;

                self.loadingMore = true;

                self._loadLazyDataTableAsync()
                    .finally(() =>
                    {
                        self.loadingMore = false;
                        eventData.callback();
                    })
            },
            onTextBoxSearchValueChanged: function (evt)
            {
                evt.data.self._queueLoadLazyDataTableAsync();
            }
        }),
        classCreated: namespace =>
        {
            $$(document).on("click", ".rad-dialog-picker a.rad-action-select", evt =>
            {
                const
                    $$currentTarget = $$(evt.currentTarget),
                    page = $$currentTarget.closest(".rad-control-page").radControl(),
                    data = $$currentTarget.closest("tr").data();

                if (page && data)
                    page._select(data);
            });
        }
    });

    // #endregion

    // #region Entity Search

    // Table Column (Entity Search)
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "TableColumnEntitySearch",
        inherits: "TableColumn",
        properties: [
            { name: "applicationEntitySupportsSoftDelete", type: "boolean" },
            { name: "editorControl" },
            { name: "editorControlProperties" },
            { name: "hideTitle", type: "boolean" },
            { name: "manual", type: "boolean" },
            { name: "sortable", type: "boolean" },
            { name: "sortProperty", type: "string" },
            { name: "viewControl" },
            { name: "viewControlProperties" },
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                applicationEntitySupportsSoftDelete: false,
                manual: false,
                sortable: true,
                tableCellClass: namespace.TableCellEntitySearch
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-table-column-entity-search");

                // Trigger Property Changes
                this.hideTitleTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _createContainerElement: function ()
                {
                    var
                        $$element = this.$$elementGet(),
                        $$containerElement =
                            !this.sortableGet() || this.manualGet() && !this.sortPropertyGet()
                                ? $$.create$$({ nodeName: "span" })
                                : $$.create$$({ nodeName: "a", attributes: { href: "#" } });

                    $$containerElement.appendTo($$element);

                    this.$$containerElementSet($$containerElement);
                    this.$$sortDirectionElement =
                        $$.create$$({ nodeName: "i", attributes: { "class": "angle up icon rad-state-hidden" } })
                            .appendTo($$element);
                },
                _getEntitySearch: function ()
                {
                    return this.$$elementGet()?.closest(".rad-control-entity-search").radControl();
                },
                _hideTitleChanged: function (change)
                {
                    if (change.currentValue)
                        this.$$containerElementGet().hide();
                    else
                        this.$$containerElementGet().show();
                },
                _updateDisplay: function ()
                {
                    var
                        entitySearch = this._getEntitySearch();

                    if (!entitySearch)
                        return;

                    this.$$sortDirectionElement.removeClass("up");
                    this.$$sortDirectionElement.removeClass("down");
                    this.$$sortDirectionElement.addClass("rad-state-hidden");

                    if (this.manualGet() && !this.sortPropertyGet())
                        return;

                    if (entitySearch.sortByOrderPropertyGet())
                        return;

                    if (entitySearch.defaultSortListPropertyGet() === this.dataSourcePropertyGet())
                    {
                        this.$$sortDirectionElement.addClass(
                            entitySearch.defaultSortListPropertyDirectionGet() === namespace.EntitySearch.sortDirections.descending
                                ? "down"
                                : "up"
                        );
                        this.$$sortDirectionElement.removeClass("rad-state-hidden");
                    }
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.allowedParentControlClasses = [
                "seriouslyrad.ui.web.TableHead"
            ];

            $$(document).on("click", ".rad-control-table-column-entity-search a", evt =>
            {
                evt.preventDefault();
                evt.stopPropagation();

                var
                    tableColumn = $$(evt.currentTarget).closest(".rad-control-table-column-entity-search").radControl(),
                    entitySearch = tableColumn._getEntitySearch();

                if (!tableColumn || !entitySearch)
                    return;

                entitySearch._setSortListProperty(tableColumn.dataSourcePropertyGet());
            });
        }
    });

    // Table Row (Entity Search)
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "TableRowEntitySearch",
        inherits: "TableRow",
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-table-row-entity-search");
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _refreshFromDataSource: function ()
                {
                    this.super._refreshFromDataSource();

                    var
                        dataSource = this.dataSourceGet();

                    if (!dataSource)
                        return;

                    if (dataSource.propertyValueByPathGet("deletedGuid"))
                        this.addCssClass("rad-control-table-row-soft-deleted");
                    else
                        this.removeCssClass("rad-control-table-row-soft-deleted");
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.allowedParentControlClasses = [
                "seriouslyrad.ui.web.TableBody"
            ];
            classConstructor.allowedChildControlClasses = [
                "seriouslyrad.ui.web.TableCellBase"
            ];
        }
    });

    // Table Cell (Entity Search)
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "TableCellEntitySearch",
        inherits: "TableCell",
        properties: [
            { name: "applicationEntitySupportsSoftDelete", type: "boolean" },
            { name: "editMode", type: "boolean" },
            { name: "editorControl" },
            { name: "editorControlProperties" },
            { name: "viewControl" },
            { name: "viewControlProperties" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                applicationEntitySupportsSoftDelete: false,
                editMode: false
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _applySoftDeletedStyle: function ()
                {
                    if (!this.applicationEntitySupportsSoftDeleteGet())
                        return;

                    var
                        dataSourceProperty = this.dataSourcePropertyGet();

                    if (!dataSourceProperty)
                        return;

                    var
                        dataSource = this.dataSourceGet();

                    if (!dataSource)
                        return;

                    var
                        pathParts = dataSourceProperty.split(".");

                    if (pathParts.length <= 1)
                        return;

                    pathParts.pop();

                    if (dataSource.propertyValueByPathGet(String.format("{0}.deletedGuid", pathParts.join("."))))
                        this.addCssClass("rad-control-table-cell-soft-deleted");
                    else
                        this.removeCssClass("rad-control-table-cell-soft-deleted");
                },
                _createElement: function ()
                {
                    this.super._createElement();

                    this.panelViewControl = new namespace.Panel({ cssClass: "view-control" });

                    this.viewControl = namespace.TableCellEntitySearch._createViewEditControl(this.viewControlGet(), this.viewControlPropertiesGet(), this.dataSourcePropertyGet(), this.panelViewControl);

                    if (this.viewControl)
                    {
                        this.$$text.hide();
                        this.panelViewControl.hide();
                        this.panelViewControl.appendTo(this);
                        this.viewControl.show();
                    }
                    else
                        this.$$text.show();

                    this.editorControl = namespace.TableCellEntitySearch._createViewEditControl(this.editorControlGet(), this.editorControlPropertiesGet(), this.dataSourcePropertyGet(), this);
                },
                _dispose: function ()
                {
                    var
                        page = this.pageGet();

                    if (page)
                        page.off("editModeChanged", { self: this }, this.onPageEditModeChanged);

                    this.super._dispose();
                },
                _editModeChanged: function (change)
                {
                    this._updateControlDisplay();
                },
                _ensureViewEditControlLoadedAsync: function (variableName, permission)
                {
                    if (!this[variableName] || !this[variableName].loadDataAsync || this[variableName + "Loaded"])
                        return Promise.resolve();

                    var
                        entitySearch = this.$$elementGet().closest(".rad-control-entity-search").radControl(),
                        hasUpdatePermission =
                            entitySearch
                            && window.application?.permissionCache?.hasPermissionForEntity(entitySearch.applicationEntityNameGet(), permission);

                    if (!hasUpdatePermission)
                    {
                        this[variableName + "Loaded"] = true;
                        return Promise.reject();
                    }

                    return this[variableName].loadDataAsync();
                },
                _pageChanged: function (change)
                {
                    this.super._pageChanged(change);

                    if (change.originalValue)
                        change.originalValue.off("editModeChanged", { self: this }, this.onPageEditModeChanged);

                    if (change.currentValue)
                    {
                        change.currentValue.on("editModeChanged", { self: this }, this.onPageEditModeChanged);

                        if (!this.__isConstructing() && change.currentValue?.editModeGet)
                            this.editModeSet(change.currentValue.editModeGet());
                    }
                },
                _refreshFromDataSource: function ()
                {
                    var
                        self = this;

                    self._applySoftDeletedStyle();

                    Promise
                        .all([
                            self._ensureViewEditControlLoadedAsync("viewControl", seriouslyrad.logicevaluation.PermissionEvaluator.permissionLevels.read)
                                .then(() =>
                                {
                                    if (self.viewControl)
                                        self.viewControl.dataSourceSet(self.dataSourceGet());
                                }),
                            self._ensureViewEditControlLoadedAsync("editorControl", seriouslyrad.logicevaluation.PermissionEvaluator.permissionLevels.update)
                                .then(() =>
                                {
                                    if (self.editorControl)
                                        self.editorControl.dataSourceSet(self.dataSourceGet());
                                })
                        ])
                        .then(() =>
                        {
                            self._updateControlDisplay();
                        });

                    return self.super._refreshFromDataSource();
                },
                _shouldShowEditorControl: function ()
                {
                    return true;
                },
                _updateControlDisplay: function ()
                {
                    if (this.editorControl instanceof namespace.ComboBox || this.editorControl instanceof namespace.Calendar)
                    {
                        const
                            $$element = this.$$elementGet();

                        if ($$element)
                        {
                            $$element.css({ overflow: "visible" });
                            $$element.closest("tr").css({ overflow: "visible" });
                        }
                    }

                    if (this.editorControl && this.editModeGet() && this._shouldShowEditorControl())
                    {
                        if (this.$$contentsElement)
                            this.$$contentsElement.hide();

                        if (this.viewControl)
                            this.panelViewControl.hide();

                        this.editorControl.show();
                    }
                    else
                    {
                        if (this.viewControl)
                        {
                            this.panelViewControl.show();

                            if (this.$$contentsElement)
                                this.$$contentsElement.hide();
                        }
                        else if (this.$$contentsElement)
                            this.$$contentsElement.show();

                        if (this.editorControl)
                            this.editorControl.hide();
                    }
                },

                // Public Methods
                remove: function ()
                {
                    if (this.editorControl)
                    {
                        this.editorControl.remove();
                        this.editorControl = null;
                    }

                    this.super.remove();
                },

                // Event Handlers
                onPageEditModeChanged: function (evt, change)
                {
                    evt.data.self.editModeSet(change.currentValue);
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.allowedParentControlClasses = [
                "seriouslyrad.ui.web.TableRow"
            ];

            classConstructor.create = options =>
            {
                return new classConstructor({
                    table: options.table,
                    tableColumn: options.tableColumn,
                    tableRow: options.tableRow,
                    dataSourceProperty: options.tableColumn.dataSourcePropertyGet(),
                    formatString: options.tableColumn.formatStringGet(),
                    applicationEntitySupportsSoftDelete: options.tableColumn.applicationEntitySupportsSoftDeleteGet(),
                    editorControl: options.tableColumn.editorControlGet(),
                    editorControlProperties: options.tableColumn.editorControlPropertiesGet(),
                    viewControl: options.tableColumn.viewControlGet(),
                    viewControlProperties: options.tableColumn.viewControlPropertiesGet()
                });
            };

            classConstructor._createViewEditControl = (controlClass, controlProperties, dataSourceProperty, appendTo) =>
            {
                var
                    control = null;

                if (controlClass)
                {
                    controlProperties = controlProperties || {};

                    if (!controlProperties.dataSourceProperty)
                        controlProperties.dataSourceProperty = dataSourceProperty;

                    control =
                        namespace.Control.createFromClassPath(controlClass, null, controlProperties)
                            .appendTo(appendTo);

                    control.hide();
                }

                return control;
            };

            classConstructor.createLightweightContent = ($$tableCell, tableColumn, rowDataSource) =>
            {
                var
                    control = $$tableCell.dataGet("control") || {};

                control.tableColumn = tableColumn;
                control.rowDataSource = rowDataSource;

                control.viewControl = namespace.TableCellEntitySearch._createViewEditControl(tableColumn.viewControlGet(), tableColumn.viewControlPropertiesGet(), tableColumn.dataSourcePropertyGet(), $$tableCell);

                if (!control.viewControl)
                {
                    control.viewControl =
                        new namespace.Text({
                            dataSourceProperty: control.tableColumn.dataSourcePropertyGet()
                        })
                            .appendTo($$tableCell);
                }

                control.viewControl.show();

                if (control.viewControl.dataSourceSet)
                    control.viewControl.dataSourceSet(rowDataSource);

                control.editorControl = namespace.TableCellEntitySearch._createViewEditControl(tableColumn.editorControlGet(), tableColumn.editorControlPropertiesGet(), tableColumn.dataSourcePropertyGet(), $$tableCell);

                if (control.editorControl)
                {
                    control.viewControl.addCssClass("view-control");
                    control.editorControl.addCssClass("edit-control");
                    control.editorControl.show();

                    if (control.editorControl instanceof namespace.ComboBox || control.editorControl instanceof namespace.Calendar)
                    {
                        $$tableCell.css({ overflow: "visible" });
                        $$tableCell.closest("tr").css({ overflow: "visible" });
                    }

                    if (control.editorControl.loadDataAsync)
                    {
                        control.editorControl.loadDataAsync()
                            .then(() =>
                            {
                                if (control.editorControl.dataSourceSet)
                                    control.editorControl.dataSourceSet(rowDataSource);
                            });
                    }
                    else
                    {
                        if (control.editorControl.dataSourceSet)
                            control.editorControl.dataSourceSet(rowDataSource);
                    }
                }

                $$tableCell.data("control", control);
            };
        }
    });

    // Entity Search
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "EntitySearch",
        inherits: "Control",
        properties: [
            { name: "applicationEntityName", type: "string" },
            { name: "applicationEntityNameFriendly", type: "string" },
            { name: "applicationEntityNamePlural", type: "string" },
            { name: "applicationEntityNamePluralFriendly", type: "string" },
            { name: "applicationEntitySupportsRowVersion", type: "boolean" },
            { name: "applicationEntitySupportsSoftDelete", type: "boolean" },
            { name: "baseFilter" },
            { name: "dataSourcePropertyId", type: "string" },
            { name: "dataServiceId", type: "string" },
            { name: "dataServiceData", type: "string" },
            { name: "dataServiceOperation", type: "string" },
            { name: "defaultSortListProperty", type: "string" },
            { name: "defaultSortListPropertyDirection", type: "string" },
            { name: "editMode", type: "boolean" },
            { name: "entityIconDataSourcePath", type: "string" },
            { name: "foreignApplicationEntityAlias", type: "string" },
            { name: "includeSoftDeleted", type: "boolean" },
            { name: "hideSaveIndicator", type: "boolean" },
            { name: "lastSearch", type: "string" },
            { name: "lightweightTable", type: "boolean" },
            { name: "listProperties" },
            { name: "messageWhenNoResults", type: "string" },
            { name: "openRecordInDialog", type: "boolean" },
            { name: "pageSize", type: "int" },
            { name: "primaryApplicationEntityName", type: "string" },
            { name: "primaryApplicationEntityNameFriendly", type: "string" },
            { name: "primaryApplicationEntityNamePlural", type: "string" },
            { name: "primaryApplicationEntityNamePluralFriendly", type: "string" },
            { name: "requiredProperties", type: "array" },
            { name: "rowSelectType", type: "string" },
            { name: "searchResultsCount", type: "int" },
            { name: "searchResultsResponse" },
            { name: "sortable", type: "boolean" },
            { name: "showEntityCommands", type: "boolean" },
            { name: "showEntityIcons", type: "boolean" },
            { name: "showEntitySetCommands", type: "boolean" },
            { name: "showQuickSearch", type: "boolean" },
            { name: "sortByOrderProperty", type: "boolean" },
            { name: "tableColumnClass" },
            { name: "tableColumnEntityActionClass" },
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                applicationEntitySupportsSoftDelete: false,
                applicationEntitySupportsRowVersion: true,
                dataSourceControlSelector: ".rad-control-page",
                defaultSortListPropertyDirection: namespace.EntitySearch.sortDirections.ascending,
                editMode: false,
                hideSaveIndicator: false,
                includeSoftDeleted: false,
                lightweightTable: false,
                messageWhenNoResults: "No records found",
                pageSize: 10,
                rowSelectType: namespace.EntitySearch.rowSelectTypes.none,
                showEntityCommands: true,
                showEntityIcons: true,
                showEntitySetCommands: true,
                showQuickSearch: true,
                sortable: true,
                sortByOrderProperty: false,
                tableColumnClass: namespace.TableColumnEntitySearch,
                tableColumnEntityActionClass: namespace.TableColumnEntityAction
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-entity-search");
                this.tableSearchResults.addCssClass("rad-search-results");
                this.tableSearchResults.tableHead.addCssClass("rad-device-visible-when-narrow");

                this.loaded = false;
                this.currentPage = 0;
                this.totalRecords = null;

                this.currentFilter = null;

                this._textBoxSearchValueChangedTimeoutId = 0;

                // Trigger Property Changes
                this.applicationEntityNameTriggerChange();
                this.applicationEntityNameFriendlyTriggerChange();
                this.applicationEntityNamePluralTriggerChange();
                this.applicationEntityNamePluralFriendlyTriggerChange();
                this.applicationEntitySupportsSoftDeleteTriggerChange();
                this.defaultSortListPropertyTriggerChange();
                this.defaultSortListPropertyDirectionTriggerChange();
                this.editModeTriggerChange();
                this.includeSoftDeletedTriggerChange();
                this.lightweightTableTriggerChange();
                this.listPropertiesTriggerChange();
                this.pageSizeTriggerChange();
                this.rowSelectTypeTriggerChange();
                this.showQuickSearchTriggerChange();
                this.sortByOrderPropertyTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _applicationEntityNameChanged: function (change)
                {
                    this._setupEntityCommands();
                    this._setupEntitySetCommands();
                },
                _applicationEntityNamePluralChanged: function (change)
                {
                    this._setTableRowIcons();
                },
                _baseFilterChanged: function (change)
                {
                    this.searchAsync();
                },
                _bindEvents: function ()
                {
                    this.super._bindEvents();

                    this.textBoxSearch.on("valueChanged", { self: this }, this.onTextBoxSearchValueChanged);
                    this.textBoxSearch.on("keydown", { self: this }, this.onTextBoxSearchKeyDown);
                    this.tableSearchResults.on("rowClicked", { self: this }, this.onRowClicked);
                    this.tableSearchResults.on("rowDataSourceChanged", { self: this }, this.onRowDataSourceChanged);

                    this.buttonFirst.on("click", { self: this }, this.onButtonFirstClicked);
                    this.buttonPrevious.on("click", { self: this }, this.onButtonPreviousClicked);
                    this.buttonNext.on("click", { self: this }, this.onButtonNextClicked);
                    this.buttonLast.on("click", { self: this }, this.onButtonLastClicked);

                    $$(document).on("seriouslyrad.PermissionCache:PermissionsChanged", { self: this }, this.onPermissionsChanged);
                },
                _changeRowOrderAndRefresh: function (row, decrement)
                {
                    var
                        self = this,
                        rowDataSource = row.dataSourceGet();

                    if (!rowDataSource)
                        return;

                    var
                        id = rowDataSource.propertyValueByPathGet("id"),
                        rowVersion = rowDataSource.propertyValueByPathGet("rowVersion"),
                        order = rowDataSource.propertyValueByPathGet("order");

                    if (Object.isNullOrUndefined(order))
                        order = self._getRowRecordNumber(row);

                    order = order + (decrement ? -1 : 1);

                    self._loadingEnqueue();

                    window.application.webApiClient
                        .createEntitySaveRequest(
                            self.applicationEntityNamePluralGet(),
                            {
                                id: id,
                                rowVersion: rowVersion,
                                order: order
                            },
                            {
                                id: id,
                                rowVersion: rowVersion
                            },
                            false
                        )
                        .executeAsync()
                        .then(() =>
                        {
                            return self.searchAsync();
                        })
                        .finally(() =>
                        {
                            self._loadingDequeue();
                        });
                },
                _checkPermissions: function ()
                {
                    if (window.application?.permissionCache?.hasPermissionForEntity(this.applicationEntityNameGet(), seriouslyrad.logicevaluation.PermissionEvaluator.permissionLevels.update))
                        this.addCssClass("rad-permission-update");
                    else
                        this.removeCssClass("rad-permission-update");
                },
                _combineFilters: function (filter)
                {
                    var
                        expressions = [],
                        baseFilter = this.baseFilterGet(),
                        textBoxSearchValue = this.textBoxSearch.isVisibleGet() ? this.textBoxSearch.valueGet() : null;

                    if (baseFilter)
                        expressions.push(baseFilter);

                    if (filter)
                        expressions.push(filter);

                    if (!String.isNullOrEmpty(textBoxSearchValue))
                    {
                        var
                            listProperties = this.listPropertiesGet();

                        var
                            textBoxSearchValueAsFloat = parseFloat(textBoxSearchValue);

                        if (listProperties.length)
                        {
                            var
                                orExpression =
                                    new seriouslyrad.OrExpression({
                                        expressions:
                                            listProperties
                                                .where(item => !item.manual)
                                                .select(item =>
                                                {
                                                    if (item.isString)
                                                    {
                                                        return new seriouslyrad.ComparisonExpression({
                                                            path: item.path,
                                                            operator: seriouslyrad.ComparisonExpression.operators.contains,
                                                            value: textBoxSearchValue.replace(/'/gi, "''")
                                                        });
                                                    }

                                                    if (!isNaN(textBoxSearchValueAsFloat) && (item.path === "referenceNumber" || item.path.endsWith(".referenceNumber")))
                                                    {
                                                        return new seriouslyrad.ComparisonExpression({
                                                            path: item.path,
                                                            operator: seriouslyrad.ComparisonExpression.operators.equals,
                                                            value: textBoxSearchValueAsFloat
                                                        });
                                                    }

                                                    return null;
                                                })
                                                .where(item => item !== null)
                                    });

                            if (orExpression.expressionsGet().length)
                                expressions.push(orExpression);
                        }
                    }

                    if (expressions.length)
                    {
                        if (expressions.length === 1)
                            return expressions[0];

                        return new seriouslyrad.AndExpression({
                            expressions: expressions
                        });
                    }

                    return null;
                },
                _createEntityCommands: function ()
                {
                    return window.entityManager.getEntityCommands(seriouslyrad.EntityCommand.types.entity, this.applicationEntityNameGet());
                },
                _createEntitySetCommands: function ()
                {
                    return window.entityManager.getEntityCommands(seriouslyrad.EntityCommand.types.entitySet, this.applicationEntityNameGet());
                },
                _createElement: function ()
                {
                    this.super._createElement();

                    // Design Mode State
                    this.designModePanel =
                        new namespace.Panel({ cssClass: "rad-overlay-design-mode" });

                    this.designModePanel.$$containerElementGet().append(String.formatWithHtmlEncode("<span>Entity Search: {0}</span>", this.applicationEntityNamePluralFriendlyGet()));

                    var
                        $$element = this.$$elementGet(),
                        $$textBoxSearch = $$element.find(">.rad-search-text-box"),
                        $$tableSearchResults = $$element.find(">.rad-search-results");

                    this.textBoxSearch =
                        $$textBoxSearch.length
                            ? namespace.Control.createFromElement($$textBoxSearch)
                            : new namespace.TextBox({ icon: "search" });

                    this.textBoxSearch.autoCompleteSet(false);

                    this.tableSearchResults =
                        $$tableSearchResults.length
                            ? namespace.Control.createFromElement($$tableSearchResults)
                            : new namespace.Table({
                                columnClickable: true,
                                lightweight: this.lightweightTableGet(),
                                linkUrls: true,
                                messageWhenNoRows: this.messageWhenNoResultsGet(),
                                rowClickable: true,
                                rowSelectType: this.rowSelectTypeGet(),
                                tableRowClass: namespace.TableRowEntitySearch
                            });

                    this.buttonFirst = new namespace.Button({ enabled: false, inline: true, text: "First" })
                        .appendTo(this.tableSearchResults.tableFoot);

                    this.buttonPrevious = new namespace.Button({ enabled: false, inline: true, text: "Prev" })
                        .appendTo(this.tableSearchResults.tableFoot);

                    this.textPaginationStatus = new namespace.Text()
                        .appendTo(this.tableSearchResults.tableFoot);

                    this.buttonNext = new namespace.Button({ enabled: false, inline: true, text: "Next" })
                        .appendTo(this.tableSearchResults.tableFoot);

                    this.buttonLast = new namespace.Button({ enabled: false, inline: true, text: "Last" })
                        .appendTo(this.tableSearchResults.tableFoot);

                    // Add to control
                    this.textBoxSearch.appendTo($$element);
                    this.tableSearchResults.appendTo($$element);
                    this.designModePanel.$$elementGet().appendTo($$element);
                    this._updatePagination();
                },
                _createSearchWebRequest: function (page, filter, overridePageSize)
                {
                    var
                        self = this,
                        pageSize = overridePageSize !== undefined ? overridePageSize : self.pageSizeGet(),
                        properties = self.propertiesGet(),
                        defaultSortListProperty = self.defaultSortListPropertyGet(),
                        defaultSortListPropertyDirection = self.defaultSortListPropertyDirectionGet(),
                        sortByOrderProperty = self.sortByOrderPropertyGet(),
                        dataSource = self.dataSourceGet(),
                        primaryEntityId,
                        foreignApplicationEntityAlias = self.foreignApplicationEntityAliasGet(),
                        sortOrder,
                        additionalHeaders = {},
                        entityIconDataSourcePath = self.entityIconDataSourcePathGet(),
                        requiredProperties = self.requiredPropertiesGet();

                    if (!defaultSortListProperty && properties.length)
                        defaultSortListProperty = properties[0];

                    if (sortByOrderProperty)
                    {
                        sortOrder = "order asc";
                        if (!properties.any(item => item === "order"))
                            properties.push("order");
                    }
                    else if (defaultSortListProperty)
                        sortOrder = String.format("{0} {1}", window.oDataHelper.objectPropertyPathToODataPropertyPath(defaultSortListProperty), defaultSortListPropertyDirection === namespace.EntitySearch.sortDirections.descending ? "desc" : "asc");

                    if (entityIconDataSourcePath)
                        properties.push(entityIconDataSourcePath);

                    properties.push("id");

                    if (this.applicationEntitySupportsRowVersionGet())
                        properties.push("rowVersion");

                    self.tableSearchResults.columnsGet()
                        .where(item => item instanceof namespace.TableColumnEntitySearch)
                        .each(item =>
                        {
                            var
                                viewControlProperties = item.viewControlPropertiesGet();

                            if (viewControlProperties?.dataSourceProperty)
                                properties.push(viewControlProperties.dataSourceProperty);

                            var
                                editorControlProperties = item.editorControlPropertiesGet();

                            if (editorControlProperties?.dataSourceProperty)
                                properties.push(editorControlProperties.dataSourceProperty);
                        });

                    if (requiredProperties)
                        properties.addRange(requiredProperties);

                    properties =
                        properties
                            .where(item => !!item)
                            .distinct();

                    additionalHeaders["RAD-Option-Include-Soft-Deleted"] =
                        self.applicationEntitySupportsSoftDeleteGet() && self.includeSoftDeletedGet() ? "true" : "false";

                    if (foreignApplicationEntityAlias)
                    {
                        if (!dataSource)
                            console.error("No data source to bind foreign key to.");

                        primaryEntityId = dataSource.propertyValueByPathGet("id");

                        if (!primaryEntityId)
                            console.error("Invalid data source.");

                        return (
                            window.application.webApiClient
                                .createEntityListChildrenRequest(
                                    self.primaryApplicationEntityNamePluralGet(),
                                    primaryEntityId,
                                    foreignApplicationEntityAlias,
                                    filter,
                                    sortOrder,
                                    properties,
                                    pageSize ? page * pageSize : 0,
                                    pageSize,
                                    additionalHeaders,
                                    false
                                )
                        );
                    }

                    return (
                        window.application.webApiClient
                            .createEntitySearchRequest(
                                self.applicationEntityNamePluralGet(),
                                filter,
                                sortOrder,
                                properties,
                                pageSize ? page * pageSize : 0,
                                pageSize,
                                additionalHeaders,
                                false
                            )
                    );
                },
                _createSearchWebRequestDataService: function (page, overridePageSize)
                {
                    var
                        dataServiceId = this.dataServiceIdGet(),
                        dataServiceData = this.dataServiceDataGet(),
                        dataServiceOperation = this.dataServiceOperationGet(),
                        pageSize = overridePageSize !== undefined ? overridePageSize : this.pageSizeGet(),
                        defaultSortListProperty = this.defaultSortListPropertyGet(),
                        defaultSortListPropertyDirection = this.defaultSortListPropertyDirectionGet(),
                        data = dataServiceData ? dataServiceData.fromJson() : {};

                    data.skip = pageSize ? page * pageSize: 0,
                    data.top = pageSize;
                    data.orderBy = defaultSortListProperty;
                    data.orderByDescending = defaultSortListPropertyDirection === namespace.EntitySearch.sortDirections.descending;
                    data.searchText = this.textBoxSearch.isVisibleGet() ? this.textBoxSearch.valueGet() : null;

                    return (
                        window.application.webApiClient
                            .createApiMethodRequest(
                                "DataService",
                                "CallDataService",
                                {
                                    id: dataServiceId,
                                    operation: dataServiceOperation,
                                    data: data.toJson()
                                },
                                null,
                                false
                            )
                    );
                },
                _dataSourcePropertyIdChanged: function (change)
                {
                    var
                        self = this,
                        page = self.pageGet();

                    if (!(page instanceof namespace.DetailsPage))
                        return;

                    if (change.currentValue)
                    {
                        var
                            property = page.applicationEntityProperties
                                .firstOrDefault(item => item.id === change.currentValue);

                        if (property)
                            self.propertyDisplayNameSet(property.displayName);
                    }
                    else
                        self.propertyDisplayNameSet(null);
                },
                _defaultSortListPropertyChanged: function (change)
                {
                    if (this.__isConstructing())
                        return;

                    if (this._isSavingRows())
                        return;

                    this.defaultSortListPropertyDirectionSet(namespace.EntitySearch.sortDirections.ascending);

                    this._queueSearchAsync(0);
                },
                _defaultSortListPropertyDirectionChanged: function (change)
                {
                    if (this.__isConstructing())
                        return;

                    if (this._isSavingRows())
                        return;

                    this._queueSearchAsync(0);
                },
                _dispose: function ()
                {
                    // #region Bound Document Events

                    $$(document).off("seriouslyrad.PermissionCache:PermissionsChanged", this.onPermissionsChanged);

                    // #endregion

                    this.super._dispose();
                },
                _editModeChanged: function (change)
                {
                    if (change.currentValue)
                        this.addCssClass("rad-state-edit-mode");
                    else
                        this.removeCssClass("rad-state-edit-mode");

                    this._updateViewAndEditControls();
                },
                _filterCommandsForEntityCommandMenu: function (entityCommands)
                {
                    return entityCommands.where(item => !item.supportsMultipleRecordsGet());
                },
                _filterCommandsForEntitySetCommandMenu: function (entitySetCommands)
                {
                    return entitySetCommands;
                },
                _getEntityCommandInformation: function ()
                {
                    var
                        page = this.pageGet(),
                        pageDataSource = page ? page.dataSourceGet() : null,
                        pageData = pageDataSource ? pageDataSource.dataGet() : null;

                    return new seriouslyrad.EntityCommandInformation({
                        caller: this,
                        entityName: this.applicationEntityNameGet(),
                        entityNameFriendly: this.applicationEntityNameFriendlyGet(),
                        entitySetName: this.applicationEntityNamePluralGet(),
                        entitySetNameFriendly: this.applicationEntityNamePluralFriendlyGet(),
                        entitySupportsSoftDelete: this.applicationEntitySupportsSoftDeleteGet(),
                        foreignEntityAlias: this.foreignApplicationEntityAliasGet(),
                        parentEntityId: pageData ? pageData.id : null,
                        parentEntityName: page?.entityNameGet ? page.entityNameGet() : null,
                        parentEntitySetName: page?.entitySetNameGet ? page.entitySetNameGet() : null,
                        parentEntityUrl: page ? page.urlGet() : null,
                        openRecordInDialog: this.openRecordInDialogGet()
                    });
                },
                _getRowEditorControls: function (row, cell)
                {
                    var
                        $$tableCells = cell ? cell.$$elementGet() : row.$$elementGet().find(">td"),
                        editorControls = [];

                    $$tableCells.each((index, element) =>
                    {
                        var
                            control = $$.radControl(element);

                        if (control?.editorControl)
                            editorControls.push(control.editorControl);
                    });

                    return editorControls;
                },
                _getRowRecordNumber: function (row)
                {
                    var
                        $$row = row.$$elementGet();

                    return this.currentPage * this.pageSizeGet() + $$row.parent().children().index($$row);
                },
                _hasEntityCommandsForEntityCommandInformation: function (entityCommandInformation)
                {
                    if (this.entityCommandMenu)
                    {
                        this.entityCommandMenu.controlsGet()
                            .each(item =>
                            {
                                if (item.visibleEvaluator)
                                    item.visibleEvaluator.stateSet(entityCommandInformation);
                            });
                    }

                    return !!(this.entityCommandMenu?.visibleMenuItemCountGet());
                },
                _isSavingRows: function ()
                {
                    return this.tableSearchResults.$$elementGet().find(".rad-state-saving").length > 0;
                },
                _includeSoftDeletedChanged: function (change)
                {
                    if (this.__isConstructing())
                        return;

                    this.searchAsync();
                },
                _lightweightTableChanged: function (change)
                {
                    if (change.currentValue)
                        this.addCssClass("rad-feature-lightweight-table");
                    else
                        this.removeCssClass("rad-feature-lightweight-table");
                },
                _listPropertiesChanged: function (change)
                {
                    var
                        self = this,
                        tableColumnClass = this.tableColumnClassGet(),
                        sortable = this.sortableGet();

                    self.tableSearchResults.columnsClear();

                    if (change.currentValue)
                    {
                        var
                            hasEditorControls = false;

                        change.currentValue.each((item, index) =>
                        {
                            if (item.editorControl)
                                hasEditorControls = true;

                            var
                                tableColumnClassToUse = item.tableColumnClass || tableColumnClass;

                            self.tableSearchResults.addColumn(new tableColumnClassToUse({
                                dataSourceProperty: item.path,
                                text: item.name,
                                formatString: item.formatString,
                                applicationEntitySupportsSoftDelete: item.applicationEntitySupportsSoftDelete,
                                editorControl: item.editorControl,
                                editorControlProperties: item.editorControlProperties,
                                hideTitle: item.hideTitle,
                                manual: item.manual,
                                sortable: sortable && (item.sortable === undefined || item.sortable),
                                sortProperty: item.sortProperty,
                                viewControl: item.viewControl,
                                viewControlProperties: item.viewControlProperties,
                                width: item.width
                            }));

                            if (index === 0 && !self.defaultSortListPropertyGet())
                            {
                                self.defaultSortListPropertySet(item.path);
                                self.defaultSortListPropertyDirectionSet(namespace.EntitySearch.sortDirections.ascending);
                            }
                        });

                        if (hasEditorControls && !self.hideSaveIndicatorGet())
                            self.tableSearchResults.addColumn(new namespace.TableColumnEntitySaveIndicator());

                        var
                            tableColumnEntityActionClass = self.tableColumnEntityActionClassGet();

                        if (self.showEntityCommandsGet() && tableColumnEntityActionClass)
                            self.tableSearchResults.addColumn(new tableColumnEntityActionClass());
                    }

                    this._updateQuickSearch();
                },
                _openCommandMenuAsync: function (commandMenu, entityCommandInformation)
                {
                    var
                        self = this;

                    return new Promise((resolve, reject) =>
                    {
                        if (!commandMenu || !entityCommandInformation)
                            return resolve();

                        commandMenu
                            .openAsync()
                            .then(menuItem =>
                            {
                                if (!menuItem)
                                {
                                    resolve();
                                    return;
                                }

                                return menuItem.tagGet().entityCommand.executeAsync(entityCommandInformation, menuItem.toggleStateGet());
                            })
                            .then(() =>
                            {
                                self.searchAsync();
                                resolve();
                            })
                            .catch(error =>
                            {
                                if (error.type === "ValidationApiException")
                                    namespace.ErrorDialog.displayError(error.validationErrors[0].errorMessage);

                                reject(error);
                            });
                    });
                },
                _pageFirstAsync: function ()
                {
                    return this.searchAsync(0);
                },
                _pageLastAsync: function ()
                {
                    if (this.totalRecords === null)
                        return Promise.resolve();

                    return this.searchAsync(Math.ceil(this.totalRecords / this.pageSizeGet()) - 1);
                },
                _pageNextAsync: function ()
                {
                    return this.searchAsync(Math.min(Math.ceil(this.totalRecords / this.pageSizeGet()) - 1, this.currentPage + 1));
                },
                _pagePreviousAsync: function ()
                {
                    return this.searchAsync(Math.max(0, this.currentPage - 1));
                },
                _pageSizeChanged: function (change)
                {
                    this._updatePagination();
                },
                _postSaveRowAsync: function (record)
                {
                    return Promise.resolve();
                },
                _postSearchAsync: function (page, filter, results, count)
                {
                    return Promise.resolve();
                },
                _queueSearchAsync: function (...args)
                {
                    var
                        self = this;

                    if (self._queueSearchAsyncTimeoutId)
                        clearTimeout(self._queueSearchAsyncTimeoutId);

                    self._queueSearchAsyncTimeoutId = setTimeout(() =>
                    {
                        self._queueSearchAsyncTimeoutId = 0;
                        self.searchAsync.apply(self, args);
                    }, 100);
                },
                _rowDisable: function (row)
                {
                    row.enabledSet(false);
                    row.controlsGet().each(item => { if (item.editorControl) item.editorControl.enabledSet(false); });
                },
                _rowEnable: function (row)
                {
                    row.enabledSet(true);
                    row.controlsGet().each(item => { if (item.editorControl) item.editorControl.enabledSet(true); });
                },
                _rowSelectTypeChanged: function (change)
                {
                    if (!this.tableSearchResults)
                        return;

                    this.tableSearchResults.rowSelectTypeSet(change.currentValue);
                },
                _saveManualCellChangeAsync: function (listProperty, change)
                {
                    return Promise.resolve();
                },
                _saveRowAsync: function (row)
                {
                    var
                        self = this,
                        rowDataSource = row.dataSourceGet();

                    if (!rowDataSource)
                        return Promise.reject();

                    var
                        dataOriginal = rowDataSource.dataOriginalGet(),
                        data = rowDataSource.dataGet(),
                        manualListProperties = self.listPropertiesGet().where(item => item.manual),
                        dataOriginalWithoutManualProperties = {},
                        dataWithoutManualProperties = {};

                    window.objectHelper.copySimpleProperties(dataOriginal, dataOriginalWithoutManualProperties, property =>
                    {
                        return !manualListProperties.any(item => item.path === property);
                    });

                    window.objectHelper.copySimpleProperties(data, dataWithoutManualProperties, property =>
                    {
                        return !manualListProperties.any(item => item.path === property);
                    });

                    var
                        validationData = {
                            validationErrors: []
                        };

                    rowDataSource.triggerHandler("validating", validationData);

                    if (validationData.validationErrors.length)
                        return Promise.reject(validationData);

                    var
                        beforeSaveChangesData = {
                            promises: []
                        };

                    rowDataSource.triggerHandler("beforeSaveChanges", beforeSaveChangesData);

                    var
                        savedRecord;

                    return (
                        Promise.all(beforeSaveChangesData.promises)
                            .then(() =>
                            {
                                return (
                                    window.application.webApiClient
                                        .createEntitySaveRequest(
                                            self.applicationEntityNamePluralGet(),
                                            dataWithoutManualProperties,
                                            dataOriginalWithoutManualProperties,
                                            row.enabledGet()
                                        )
                                        .executeAsync()
                                );
                            })
                            .then(data =>
                            {
                                savedRecord = data;

                                var
                                    afterSaveChangesData = {
                                        promises: []
                                    };

                                rowDataSource.triggerHandler("afterSaveChanges", afterSaveChangesData);

                                return (
                                    Promise.all(afterSaveChangesData.promises)
                                        .then(() =>
                                        {
                                            return data;
                                        })
                                );
                            })
                            .then(data =>
                            {
                                if (self.dataServiceIdGet())
                                    return Promise.resolve([savedRecord]);
                                else
                                {
                                    return (
                                        self
                                            ._createSearchWebRequest(
                                                0,
                                                new seriouslyrad.ComparisonExpression({
                                                    path: "id",
                                                    value: data.id
                                                })
                                            )
                                            .executeAsync()
                                    );
                                }
                            })
                            .then(data =>
                            {
                                if (data?.length)
                                {
                                    return (
                                        self._postSaveRowAsync(data[0])
                                            .then(() =>
                                            {
                                                for (var property in data[0])
                                                    rowDataSource.propertyValueByPathSet(property, data[0][property]);

                                                rowDataSource.acceptChanges();
                                            })
                                    );
                                }
                            })
                    );
                },
                _searchAsync: function (page, filter)
                {
                    var
                        self = this;

                    if (self.designModeGet())
                        return Promise.resolve();

                    self._checkPermissions();

                    if (page === undefined)
                        page = self.currentPage;

                    var
                        combinedFilter = null;

                    if (filter === undefined)
                        filter = self.currentFilter;

                    combinedFilter = self._combineFilters(filter);

                    var
                        webRequest = self._createSearchWebRequest(page, combinedFilter);

                    self._loadingEnqueue();

                    var
                        searchResults,
                        searchResultsCount;

                    return (
                        webRequest
                            .executeAsync()
                            .then(data =>
                            {
                                searchResults = data;
                                searchResultsCount = data.total;
                                self.searchResultsCountSet(searchResultsCount);
                                self.searchResultsResponseSet(data);

                                return self._postSearchAsync(page, filter, searchResults, searchResultsCount);
                            })
                            .then(() =>
                            {
                                self.loaded = true;
                                self.currentPage = page;
                                self.totalRecords = searchResultsCount;
                                self.currentFilter = filter;

                                if (self.tableSearchResults)
                                {
                                    self.tableSearchResults.dataSourceSet(searchResults);
                                    self._updatePagination();
                                    self._updateTableHeader();
                                    self._updateViewAndEditControls();

                                    self._triggerSearchResultsUpdated();
                                }

                                self.lastSearchSet((new Date(Date.now())).toString("yyyy-MM-ddTHH:mm:ss.fffffff"));
                            })
                            .catch(error =>
                            {
                                if (self.tableSearchResults)
                                    self.tableSearchResults.dataSourceSet(null);

                                throw error;
                            })
                            .finally(() =>
                            {
                                self._loadingDequeue();
                                self = null;
                            })
                    );
                },
                _searchUsingDataServiceAsync: function (page)
                {
                    var
                        self = this;

                    if (self.designModeGet())
                        return Promise.resolve();

                    if (page === undefined)
                        page = self.currentPage;

                    var
                        webRequest = self._createSearchWebRequestDataService(page);

                    self._loadingEnqueue();

                    var
                        searchResults,
                        searchResultsCount;

                    return (
                        webRequest
                            .executeAsync()
                            .then(data =>
                            {
                                self.searchResultsResponseSet(data);
                                searchResults = data.results[0];
                                searchResultsCount = data.count;
                                self.searchResultsCountSet(searchResultsCount);

                                return self._postSearchAsync(page, null, searchResults, searchResultsCount, data);
                            })
                            .then(() =>
                            {
                                self.loaded = true;
                                self.currentPage = page;
                                self.totalRecords = searchResultsCount;
                                self.currentFilter = null;

                                if (self.tableSearchResults)
                                {
                                    self.tableSearchResults.dataSourceSet(searchResults);
                                    self._updatePagination();
                                    self._updateTableHeader();
                                    self._updateViewAndEditControls();

                                    self._triggerSearchResultsUpdated();
                                }

                                self.lastSearchSet((new Date(Date.now())).toString("yyyy-MM-ddTHH:mm:ss.fffffff"));
                            })
                            .catch(error =>
                            {
                                if (self.tableSearchResults)
                                    self.tableSearchResults.dataSourceSet(null);

                                throw error;
                            })
                            .finally(() =>
                            {
                                self._loadingDequeue();
                                self = null;
                            })
                    );
                },
                _setSortListProperty: function (propertyPath)
                {
                    if (this.sortByOrderPropertyGet())
                        return;

                    var
                        defaultSortListProperty = this.defaultSortListPropertyGet(),
                        defaultSortListPropertyDirection = this.defaultSortListPropertyDirectionGet();

                    if (defaultSortListProperty !== propertyPath)
                        this.defaultSortListPropertySet(propertyPath);
                    else
                    {
                        this.defaultSortListPropertyDirectionSet(
                            defaultSortListPropertyDirection === namespace.EntitySearch.sortDirections.ascending
                                ? namespace.EntitySearch.sortDirections.descending
                                : namespace.EntitySearch.sortDirections.ascending
                        );
                    }
                },
                _setTableRowIcons: function ()
                {
                    var
                        showEntityIcons = this.showEntityIconsGet(),
                        applicationEntityNamePlural = this.applicationEntityNamePluralGet();

                    this.tableSearchResults.rowIconSet(showEntityIcons && applicationEntityNamePlural ? String.format("rad-icon-{0}-16", applicationEntityNamePlural.toLowerCase()) : null);
                    this.tableSearchResults.rowIconDataSourcePathSet(this.entityIconDataSourcePathGet());
                    this.tableSearchResults.rowIconMobileSet(showEntityIcons && applicationEntityNamePlural ? String.format("rad-icon-{0}-48", applicationEntityNamePlural.toLowerCase()) : null);
                },
                _setupEntityCommands: function ()
                {
                    this.entityCommands = this._createEntityCommands();

                    if (!this.showEntityCommandsGet())
                        return;

                    var
                        entityName = this.applicationEntityNameGet();

                    if (this.entityCommandMenu)
                        this.entityCommandMenu.off("visibleMenuItemCountChanged", { self: this }, this.onEntityCommandMenuVisibleMenuItemCountChanged);

                    this.entityCommandMenu = window.entityManager.createCommandMenu(entityName, this._filterCommandsForEntityCommandMenu(this.entityCommands));

                    if (this.entityCommandMenu)
                        this.entityCommandMenu.on("visibleMenuItemCountChanged", { self: this }, this.onEntityCommandMenuVisibleMenuItemCountChanged);
                },
                _setupEntitySetCommands: function ()
                {
                    this.entitySetCommands = this._createEntitySetCommands();

                    const
                        entityName = this.applicationEntityNameGet();

                    if (this.entitySetCommandMenu)
                        this.entitySetCommandMenu.off("visibleMenuItemCountChanged", { self: this }, this.onEntitySetCommandMenuVisibleMenuItemCountChanged);

                    this.entitySetCommandMenu = window.entityManager.createCommandMenu(entityName, this._filterCommandsForEntitySetCommandMenu(this.entitySetCommands));

                    if (this.entitySetCommandMenu)
                        this.entitySetCommandMenu.on("visibleMenuItemCountChanged", { self: this }, this.onEntitySetCommandMenuVisibleMenuItemCountChanged);

                    this._updateEntitySetCommandsState();
                },
                _setupListPropertiesAsync: function ()
                {
                    return Promise.resolve();
                },
                _shouldSearch: function ()
                {
                    var
                        page = this.pageGet(),
                        pageInstanceOfDetailsPage = page instanceof namespace.DetailsPage,
                        pageDataSource = page ? page.dataSourceGet() : null;

                    if (!page)
                        return false;

                    return (
                        page.activatedGet()
                        && this._isShown()
                        && (
                            !pageInstanceOfDetailsPage
                            || pageDataSource
                        )
                    );
                },
                _showQuickSearchChanged: function (change)
                {
                    this._updateQuickSearch();
                },
                _sortByOrderPropertyChanged: function (change)
                {
                    if (change.currentValue)
                        this.addCssClass("rad-feature-sorted-by-order");
                    else
                        this.removeCssClass("rad-feature-sorted-by-order");

                    this._updateQuickSearch();
                },
                _triggerSearchResultsUpdated: function ()
                {
                    this.triggerHandler("searchResultsUpdated");
                },
                _updateEntitySetCommandsState: function ()
                {
                    if (this.entitySetCommandMenu?.visibleMenuItemCountGet())
                        this.removeCssClass("rad-state-no-entity-set-commands");
                    else
                        this.addCssClass("rad-state-no-entity-set-commands");

                    // bodge in extra entity set command controls for UI theming.

                    if (!this.panelEntitySetControls)
                    {
                        this.panelEntitySetControls =
                            new namespace.Panel({ cssClass: "rad-control-panel-entity-set-controls" });

                        this.panelEntitySetControls.prependTo(this.$$elementGet());

                        this.textBoxSearch.$$elementGet().appendTo(this.panelEntitySetControls.$$elementGet());

                        this.panelSpacer =
                            new namespace.Panel({ cssClass: "rad-spacer" })
                                .appendTo(this.panelEntitySetControls);
                    }

                    // TODO: base this on some magic for determining which actions want to be pulled out of the menu
                    /*if (!this.buttonEntitySetControlNew)
                        this.buttonEntitySetControlNew = new namespace.Button({ enabled: true, inline: true, text: "New" })
                            .appendTo(this.panelEntitySetControls);

                    if (!this.panelSpacerMobile)
                        this.panelSpacerMobile = new namespace.Panel({ cssClass: "rad-spacer rad-device-visible-when-narrow" })
                            .appendTo(this.panelEntitySetControls);

                    if (!this.comboBoxEntitySetControlSort)
                        this.comboBoxEntitySetControlSort = new namespace.ComboBox({ enabled: true, inline: true, placeholder: "Sort", listDataSource: [{ value: "name", description: "Name" }, { value: "type", description: "Type" }], listDataSourceValueProperty: "value" })
                            .appendTo(this.panelEntitySetControls);*/

                    if (!this.buttonRefresh)
                    {
                        this.buttonRefresh = new namespace.Button({ enabled: true, inline: true, icon: "refresh-search", showLabel: false, cssClass: "compact rad-refresh" })
                            .appendTo(this.panelEntitySetControls);

                        this.buttonRefresh.on("click", { self: this }, this.onButtonRefreshClicked);
                    }

                    if (!this.buttonEntitySetControlOpenActionMenu)
                    {
                        this.buttonEntitySetControlOpenActionMenu = new namespace.Button({ enabled: true, inline: true, icon: "rad-icon-vertical-ellipsis", showLabel: false, cssClass: "compact rad-action-entity-set-actions-open" })
                            .appendTo(this.panelEntitySetControls);

                        this.buttonEntitySetControlOpenActionMenu.on("click", { self: this }, this.onButtonEntitySetControlOpenActionMenuClicked);
                    }
                    
                    this.buttonEntitySetControlOpenActionMenu.visibleSet(this.showEntitySetCommandsGet());

                    this.textBoxSearch.placeholderSet(String.format("Search {0}", this.applicationEntityNamePluralFriendlyGet()));
                },
                _updatePagination: function ()
                {
                    if (!this.tableSearchResults)
                        return;

                    var
                        pageSize = this.pageSizeGet(),
                        isSavingRows = this._isSavingRows(),
                        lastPage = Math.ceil(this.totalRecords / this.pageSizeGet()) - 1,
                        onFirstPage = this.currentPage <= 0,
                        onLastPage = this.currentPage >= Math.ceil(this.totalRecords / this.pageSizeGet()) - 1;

                    this.tableSearchResults.footerVisibleSet(!!pageSize);

                    this.buttonFirst.enabledSet(!isSavingRows && !onFirstPage);
                    this.buttonPrevious.enabledSet(!isSavingRows && !onFirstPage);
                    this.buttonNext.enabledSet(!isSavingRows && !onLastPage);
                    this.buttonLast.enabledSet(!isSavingRows && !onLastPage);

                    this.textPaginationStatus.textSet(String.format("Page {0} of {1} ({2} records)", this.currentPage + 1, lastPage + 1, this.totalRecords));

                    if (this.totalRecords)
                        this.textPaginationStatus.show();
                    else
                        this.textPaginationStatus.hide();

                    if (onFirstPage)
                        this.addCssClass("rad-state-first-page");
                    else
                        this.removeCssClass("rad-state-first-page");

                    if (onLastPage)
                        this.addCssClass("rad-state-last-page");
                    else
                        this.removeCssClass("rad-state-last-page");
                },
                _updateQuickSearch: function ()
                {
                    if (!this.textBoxSearch)
                        return;

                    var
                        showQuickSearch = this.showQuickSearchGet(),
                        listProperties = this.listPropertiesGet(),
                        hasStringListProperty = listProperties ? listProperties.any(item => item.isString) : null,
                        sortByOrderProperty = this.sortByOrderPropertyGet();

                    if (showQuickSearch && hasStringListProperty && !sortByOrderProperty)
                        this.textBoxSearch.show();
                    else
                        this.textBoxSearch.hide();
                },
                _updateTableColumnEntityAction: function ()
                {
                    let
                        $$element = this.$$elementGet(),
                        $$entityActionCells = $$element.find(".rad-control-table-cell-entity-action"),
                        $$entityActionCellsWithoutCommands = $$entityActionCells.filter(".rad-state-no-entity-commands");

                    if ($$entityActionCells.length && $$entityActionCells.length !== $$entityActionCellsWithoutCommands.length)
                        this.removeCssClass("rad-state-no-entity-commands");
                    else
                        this.addCssClass("rad-state-no-entity-commands");
                },
                _updateTableHeader: function ()
                {
                    this.tableSearchResults.columnsGet().each(item =>
                    {
                        if (item._updateDisplay)
                            item._updateDisplay();
                    });
                },
                _updateViewAndEditControls: function ()
                {
                    var
                        $$element = this.$$elementGet(),
                        editMode = this.editModeGet();

                    $$element.find(".edit-control")
                        .each((index, element) =>
                        {
                            var
                                control = $$.radControl(element);

                            if (control)
                                control.visibleSet(editMode);
                        });

                    $$element.find(".view-control")
                        .each((index, element) =>
                        {
                            var
                                control = $$.radControl(element);

                            if (control)
                                control.visibleSet(!editMode);
                        });
                },
                _validationErrorsHide: function (row, cell)
                {
                    /* Intentionally empty */
                },
                _validationErrorsShow: function (row, cell, validationErrors)
                {
                    /* Intentionally empty */
                },

                // Public Methods
                includeSoftDeletedGet: function ()
                {
                    var
                        page = this.pageGet();

                    if (page?.isSoftDeletedGet && page.isSoftDeletedGet())
                        return true;

                    return this._includeSoftDeletedGet();
                },
                openEntityCommandMenuAsync: function (entityCommandInformation)
                {
                    if (this.entityCommandMenu)
                    {
                        this.entityCommandMenu.controlsGet()
                            .each(item =>
                            {
                                if (item.visibleEvaluator)
                                    item.visibleEvaluator.stateSet(entityCommandInformation);
                            });

                        return this._openCommandMenuAsync(this.entityCommandMenu, entityCommandInformation);
                    }

                    return Promise.resolve();
                },
                openEntitySetCommandMenuAsync: function (entityCommandInformation)
                {
                    this.entitySetCommandMenu.controlsGet()
                        .each(item =>
                        {
                            if (item.visibleEvaluator)
                                item.visibleEvaluator.stateSet(entityCommandInformation);
                        });

                    return this._openCommandMenuAsync(this.entitySetCommandMenu, entityCommandInformation);
                },
                propertiesGet: function ()
                {
                    var
                        properties = [];

                    this.tableSearchResults.columnsGet()
                        .where(item =>
                        {
                            if (!(item instanceof namespace.TableColumn))
                                return false;

                            if (!item.manualGet)
                                return true;

                            return !item.manualGet();
                        })
                        .each(item =>
                        {
                            var
                                dataSourceProperty = item.dataSourcePropertyGet();

                            if (dataSourceProperty)
                            {
                                properties.push(dataSourceProperty);

                                if (item.applicationEntitySupportsSoftDeleteGet())
                                {
                                    var
                                        pathParts = dataSourceProperty.split(".");

                                    if (pathParts.length > 1)
                                    {
                                        pathParts.pop();
                                        properties.push(String.format("{0}.deletedGuid", pathParts.join(".")));
                                    }
                                }
                            }
                            
                        });

                    if (this.applicationEntitySupportsSoftDeleteGet())
                        properties.push("deletedGuid");

                    return properties;
                },
                queueSearchAsync: function (...args)
                {
                    return this._queueSearchAsync.apply(this, args);
                },
                remove: function ()
                {
                    // #region Created Elements

                    this.removeControls([
                        this.designModePanel,
                        this.textBoxSearch,
                        this.tableSearchResults,
                        this.buttonFirst,
                        this.buttonPrevious,
                        this.buttonNext,
                        this.buttonLast,
                        this.textPaginationStatus,
                        this.entityCommandMenu,
                        this.entitySetCommandMenu,
                        this.panelEntitySetControls,
                        this.panelSpacer,
                        this.buttonEntitySetControlOpenActionMenu
                    ]);

                    // #endregion

                    this.super.remove();
                },
                rowMoveDown: function (row)
                {
                    var
                        self = this;

                    if (!self.sortByOrderPropertyGet())
                        return; // Not supported

                    self._changeRowOrderAndRefresh(row, false);
                },
                rowMoveUp: function (row)
                {
                    var
                        self = this;

                    if (!self.sortByOrderPropertyGet())
                        return; // Not supported
                    
                    self._changeRowOrderAndRefresh(row, true);
                },
                saveManualCellChangeAsync: function (listProperty, change)
                {
                    var
                        self = this,
                        row = change.tableRow,
                        tableCell = change.tableRow.controlsGet().firstOrDefault(item => item.dataSourcePropertyGet && item.dataSourcePropertyGet() === change.path),
                        $$tableCell = tableCell ? tableCell.$$elementGet() : null;

                    if (row.hasCssClass("rad-state-saving"))
                        return Promise.reject("Already saving");

                    if (!tableCell || tableCell.hasCssClass("rad-state-saving"))
                        return Promise.reject("Already saving");

                    row.removeCssClass("rad-state-error");
                    row.removeCssClass("rad-state-saved");
                    tableCell.removeCssClass("rad-state-error");
                    tableCell.removeCssClass("rad-state-saved");

                    row.addCssClass("rad-state-saving");
                    tableCell.addCssClass("rad-state-saving");

                    self._validationErrorsHide(row, tableCell);
                    self._updatePagination();

                    self._rowDisable(row);

                    $$tableCell.attr("tabindex", "0");
                    tableCell.focus();

                    return (
                        self._saveManualCellChangeAsync(listProperty, change)
                            .then(() =>
                            {
                                row.addCssClass("rad-state-saved");
                                tableCell.addCssClass("rad-state-saved");
                            })
                            .catch(error =>
                            {
                                row.addCssClass("rad-state-error");
                                tableCell.addCssClass("rad-state-error");

                                if (error?.validationErrors)
                                    self._validationErrorsShow(row, tableCell, error.validationErrors);

                                throw error;
                            })
                            .finally(() =>
                            {
                                row.removeCssClass("rad-state-saving");
                                tableCell.removeCssClass("rad-state-saving");

                                self._rowEnable(row);

                                if ($$(":focus").is($$tableCell))
                                    tableCell.editorControl.focusNextControl();

                                $$tableCell.removeAttr("tabindex");

                                self._updatePagination();
                            })
                    );
                },
                saveManualCellChangesAsync: function (row, changes)
                {
                    var
                        self = this;

                    if (row.hasCssClass("rad-state-saving"))
                        return Promise.reject("Already saving");

                    row.removeCssClass("rad-state-error");
                    row.removeCssClass("rad-state-saved");

                    row.addCssClass("rad-state-saving");

                    self._validationErrorsHide(row, null);
                    self._updatePagination();

                    self._rowDisable(row);

                    return (
                        Promise
                            .all(
                                changes
                                    .select(item => self._saveManualCellChangeAsync(item.listProperty, item.change))
                            )
                            .then(() =>
                            {
                                row.addCssClass("rad-state-saved");
                            })
                            .catch(error =>
                            {
                                row.addCssClass("rad-state-error");
                                tableCell.addCssClass("rad-state-error");

                                if (error?.validationErrors)
                                    self._validationErrorsShow(row, tableCell, error.validationErrors);

                                throw error;
                            })
                            .finally(() =>
                            {
                                row.removeCssClass("rad-state-saving");

                                self._rowEnable(row);

                                self._updatePagination();
                            })
                    );
                },
                saveRowAsync: function (row)
                {
                    var
                        self = this;

                    if (row.hasCssClass("rad-state-saving"))
                        return Promise.reject("Already saving");

                    row.removeCssClass("rad-state-error");
                    row.removeCssClass("rad-state-saved");

                    row.addCssClass("rad-state-saving");

                    self._validationErrorsHide(row, null);
                    self._updatePagination();

                    self._rowDisable(row);

                    return (
                        self._saveRowAsync(row)
                            .then(() =>
                            {
                                row.addCssClass("rad-state-saved");
                            })
                            .catch(error =>
                            {
                                row.addCssClass("rad-state-error");

                                if (error?.validationErrors)
                                    self._validationErrorsShow(row, null, error.validationErrors);

                                throw error;
                            })
                            .finally(() =>
                            {
                                row.removeCssClass("rad-state-saving");

                                self._rowEnable(row);

                                self._updatePagination();
                            })
                    );
                },
                searchAsync: function (page, filter, force)
                {
                    var
                        self = this;

                    if (!force && !self._shouldSearch())
                        return Promise.resolve();

                    var
                        initialPromise =
                            self.listPropertiesSetup
                                ? Promise.resolve()
                                : self.setupListPropertiesAsync()

                    self.listPropertiesSetup = true;

                    return (
                        initialPromise
                            .then(() =>
                            {
                                if (self.dataServiceIdGet())
                                    return self._searchUsingDataServiceAsync(page);

                                return self._searchAsync(page, filter);
                            })
                    );
                },
                setupListPropertiesAsync: function ()
                {
                    var
                        self = this;

                    self.__settingUpListProperties = true;

                    return (
                        self._setupListPropertiesAsync()
                            .then(() =>
                            {
                                self.__settingUpListProperties = false;
                            })
                    );
                },

                // Event Handlers
                onAncestorVisibilityChanged: function (evt, change)
                {
                    if (change.currentValue)
                        evt.data.self._queueSearchAsync();
                },
                onButtonEntitySetControlOpenActionMenuClicked: function (evt)
                {
                    evt.preventDefault();
                    evt.stopPropagation();

                    var
                        self = evt.data.self,
                        entityCommandInformation = self._getEntityCommandInformation();

                    if (!entityCommandInformation)
                        return;

                    self.openEntitySetCommandMenuAsync(entityCommandInformation);
                },
                onButtonFirstClicked: function (evt)
                {
                    evt.preventDefault();
                    evt.stopPropagation();

                    evt.data.self._pageFirstAsync()
                        .then(() =>
                        {
                            evt.data.self.scrollToAsync();
                        });
                },
                onButtonLastClicked: function (evt)
                {
                    evt.preventDefault();
                    evt.stopPropagation();

                    evt.data.self._pageLastAsync()
                        .then(() =>
                        {
                            evt.data.self.scrollToAsync();
                        });
                },
                onButtonNextClicked: function (evt)
                {
                    evt.preventDefault();
                    evt.stopPropagation();

                    evt.data.self._pageNextAsync()
                        .then(() =>
                        {
                            evt.data.self.scrollToAsync();
                        });
                },
                onButtonPreviousClicked: function (evt)
                {
                    evt.preventDefault();
                    evt.stopPropagation();

                    evt.data.self._pagePreviousAsync()
                        .then(() =>
                        {
                            evt.data.self.scrollToAsync();
                        });
                },
                onButtonRefreshClicked: function (evt)
                {
                    evt.data.self.searchAsync();
                },
                onEntityCommandMenuVisibleMenuItemCountChanged: function (evt, change)
                {
                    evt.data.self._updateEntitySetCommandsState();
                },
                onEntitySetCommandMenuVisibleMenuItemCountChanged: function (evt, change)
                {
                    evt.data.self._updateEntitySetCommandsState();
                },
                onPageActivated: function (evt, eventData)
                {
                    evt.data.self._queueSearchAsync();
                },
                onPermissionsChanged: function (evt)
                {
                    evt.data.self._checkPermissions();
                },
                onRowClicked: function (evt, row)
                {
                    evt.preventDefault();
                    evt.stopPropagation();

                    var
                        self = evt.data.self;

                    if (self._isSavingRows())
                        return;

                    var
                        rowDataSource = row ? row.dataSourceGet() : null,
                        record = rowDataSource ? rowDataSource.dataGet() : null;

                    if (!record)
                        return null;

                    var
                        entityCommand =
                            evt.data.self.entityCommands
                                .where(item => item.isDefaultGet())
                                .orderBy(item => !Object.isNullOrUndefined(item.entityNameGet()) ? "0" : "1")
                                .firstOrDefault();

                    if (!entityCommand)
                        return;

                    var
                        entityCommandInformation = self._getEntityCommandInformation();

                    if (!entityCommandInformation)
                        return;

                    entityCommandInformation.recordSet(record);

                    entityCommand.executeAsync(entityCommandInformation)
                        .then(() =>
                        {
                            self.searchAsync();
                        });
                },
                onRowDataSourceChanged: function (evt, change)
                {
                    var
                        self = evt.data.self;

                    if (self.__settingUpListProperties)
                        return;

                    var
                        listProperties = self.listPropertiesGet(),
                        listProperty = listProperties ? listProperties.firstOrDefault(item => item.path === change.path) : null;

                    if (listProperty?.manual)
                    {
                        self.saveManualCellChangeAsync(listProperty, change);
                        return;
                    }

                    self.saveRowAsync(change.tableRow);
                },
                onTextBoxSearchKeyDown: function (evt)
                {
                    var
                        self = evt.data.self;

                    if (evt.key === "Enter")
                    {
                        // If search queued, cancel and search now
                        if (self._queueSearchAsyncTimeoutId)
                        {
                            clearTimeout(self._queueSearchAsyncTimeoutId);
                            self._queueSearchAsyncTimeoutId = 0;
                            self.searchAsync();
                        }
                    }
                },
                onTextBoxSearchValueChanged: function (evt, change)
                {
                    var
                        self = evt.data.self;

                    if (String.isNullOrEmpty(change.currentValue) && String.isNullOrEmpty(change.originalValue))
                        return;

                    if (self._textBoxSearchValueChangedTimeoutId)
                        clearTimeout(self._textBoxSearchValueChangedTimeoutId);

                    self._textBoxSearchValueChangedTimeoutId = setTimeout(() =>
                    {
                        self._textBoxSearchValueChangedTimeoutId = 0;
                        self.searchAsync(0);
                    }, 500);
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.rowSelectTypes = namespace.Table.rowSelectTypes;
            classConstructor.sortDirections =
                {
                    ascending: "ascending",
                    descending: "descending"
                };

            classFactory.create({
                namespace: classConstructor,
                name: "EntityCommandSort",
                inherits: "seriouslyrad.EntityCommand",
                createPropertyDefaults: namespace =>
                {
                    return {
                        description: "Sort",
                        key: "SORT",
                        permission: seriouslyrad.logicevaluation.PermissionEvaluator.permissionLevels.read,
                        type: seriouslyrad.EntityCommand.types.entitySet
                    };
                },
                createPrototype: namespace =>
                {
                    return {
                        // "Protected" Methods
                        _executeAsync: function (entityCommandInformation, value)
                        {
                            var
                                self = this;

                            return (
                                self.super._executeAsync(entityCommandInformation, value)
                                    .then(() =>
                                    {
                                        var
                                            caller = entityCommandInformation.callerGet();

                                        if (!(caller instanceof seriouslyrad.ui.web.EntitySearch))
                                            return;

                                        return classConstructor.SortOrderDialog.getSingleInstance().openAsync(caller);
                                    })
                            );
                        }
                    };
                }
            });

            classFactory.create({
                namespace: classConstructor,
                name: "SortOrderDialog",
                inherits: "seriouslyrad.ui.web.Dialog",
                createPropertyDefaults: namespace =>
                {
                    return {
                        autoClose: false,
                        buttonStyle: seriouslyrad.ui.web.Dialog.buttonStyle.okCancel,
                        title: "Sort"
                    };
                },
                createPrototype: namespace =>
                {
                    return {
                        // "Protected" Methods
                        _createContainerElement: function ()
                        {
                            this.super._createContainerElement();

                            var
                                controlNamespace = seriouslyrad.ui.web;

                            this.propertyEditorColumn =
                                new controlNamespace.PropertyEditorComboBox({
                                    editMode: true,
                                    editorControlProperties: {
                                        allowEmptySelection: false
                                    },
                                    mandatory: true,
                                    propertyDisplayName: "Column"
                                })
                                    .appendTo(this);

                            this.propertyEditorDirection =
                                new controlNamespace.PropertyEditorComboBox({
                                    editMode: true,
                                    editorControlProperties: {
                                        allowEmptySelection: false
                                    },
                                    mandatory: true,
                                    propertyDisplayName: "Direction"
                                })
                                    .appendTo(this);
                        },
                        _populatePropertyEditorColumn: function ()
                        {
                            this.propertyEditorColumn.editorControlGet().listDataSourceSet(
                                this.entitySearch.tableSearchResults.columnsGet()
                                    .where(item =>
                                    {
                                        if (!item.manualGet)
                                            return true;

                                        return !item.manualGet();
                                    })
                                    .select(item =>
                                    {
                                        return {
                                            value: item.dataSourcePropertyGet ? item.dataSourcePropertyGet() : null,
                                            description: item.textGet()
                                        };
                                    })
                                    .where(item => item.value !== null)
                            );

                            this.propertyEditorColumn.valueSet(this.entitySearch.defaultSortListPropertyGet());
                        },
                        _populatePropertyEditorDirection: function ()
                        {
                            var
                                directions = [];

                            for (let property in seriouslyrad.ui.web.EntitySearch.sortDirections)
                                directions.push(property);

                            this.propertyEditorDirection.editorControlGet().listDataSourceSet(
                                directions
                                    .select(item =>
                                    {
                                        return {
                                            value: item,
                                            description: item.toUpperCamelCase()
                                        };
                                    })
                            );

                            this.propertyEditorDirection.valueSet(this.entitySearch.defaultSortListPropertyDirectionGet());
                        },
                        _setEntitySearch: function (entitySearch)
                        {
                            this.entitySearch = entitySearch;
                            this._populatePropertyEditorColumn();
                            this._populatePropertyEditorDirection();
                        },

                        // Public Methods
                        buttonClicked: function ()
                        {
                            var
                                self = this;

                            self.super.buttonClicked();

                            if (self.dialogResult === seriouslyrad.ui.web.Dialog.dialogResult.ok)
                            {
                                this.entitySearch.defaultSortListPropertySet(this.propertyEditorColumn.valueGet());
                                this.entitySearch.defaultSortListPropertyDirectionSet(this.propertyEditorDirection.valueGet());
                            }

                            self.closeAsync();
                        },
                        openAsync: function (entitySearch)
                        {
                            this._setEntitySearch(entitySearch);
                            return this.super.openAsync();
                        }
                    };
                },
                classCreated: (namespace, classConstructor) =>
                {
                    classConstructor.getSingleInstance = () =>
                    {
                        if (!classConstructor.instance)
                            classConstructor.instance = new classConstructor();

                        return classConstructor.instance;
                    };
                }
            });

            $$(document).on("seriouslyrad.EntityManager:registerEntityCommands", () =>
            {
                window.entityManager.registerCommand(new classConstructor.EntityCommandSort());
            });
        }
    });

    // #endregion

    // Interface Designer
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "InterfaceDesigner",
        inherits: "ContainerControl",
        properties: [
            { name: "editModeEnabled", type: "boolean" },
            { name: "dataSourceType" },
            { name: "dataTypeProvider" }
        ],
        createConstructor: namespace =>
        {
            return function ()
            {
                var
                    self = this;

                self.addCssClass("rad-control-interface-designer");
                self.focussedControl = null;
                self.registeredControlClasses = [];
                self.buildControlMenuTimeoutId = 0;

                $$(document).trigger("seriouslyrad.ui.web.InterfaceDesigner:registerControlClasses", (menuPath, classConstructor, tag) =>
                {
                    self.registerControlClass(menuPath, classConstructor, tag);
                });
            };
        },
        createPropertyDefaults: namespace =>
        {
            return {
                editModeEnabled: false
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _addNewControl: function (control, parentControl)
                {
                    this._makeControlDesignable(control);

                    if (parentControl)
                        parentControl.append(control);
                    else
                        this.append(control);
                },
                _bindEvents: function ()
                {
                    this.super._bindEvents();
                    this.toolbarMenuAddControl.on("click", { self: this }, this.onToolbarMenuAddControlClick);
                    this.toolbarMenuEditMode.on("stateChanged", { self: this }, this.onToolbarMenuEditModeStateChanged);

                    var
                        self = this;

                    self.on("focusin", ".rad-designer .rad-control", evt =>
                    {
                        self.focussedControl = $$.radControl(evt.currentTarget);
                        self.focussedControl.addCssClass("rad-state-focussed");
                        evt.stopPropagation();
                    });

                    self.on("focusout", ".rad-control", evt =>
                    {
                        if (self.focussedControl)
                        {
                            self.focussedControl.removeCssClass("rad-state-focussed");
                            self.focussedControl = null;
                        }
                    });

                    self.on("keydown", ".rad-control", evt =>
                    {
                        switch (evt.key)
                        {
                            case "Delete":
                                {
                                    self._deleteFocussedControl();
                                    break;
                                }
                        }
                    });
                },
                _buildControlMenu: function ()
                {
                    var
                        self = this,
                        currentMenuPath,
                        menuItem;

                    self.menuAddControl.controlsClear();

                    self.registeredControlClasses
                        .orderBy(item => item.path)
                        .each(item =>
                        {
                            var
                                pathParts = item.path.split("//"),
                                menuPath = pathParts.length > 1 ? pathParts.take(pathParts.length - 1).join("/") : String.empty,
                                className = pathParts.last();

                            if (!menuItem || menuPath !== currentMenuPath)
                                menuItem = self._createMenuPath(menuPath);

                            currentMenuPath = menuPath;

                            menuItem.append(
                                new namespace.MenuItem({ text: className, toggle: !!item.toggle, tag: { controlClass: item.classConstructor } })
                            );
                        });
                },
                _createChildControls: function ()
                {
                    var
                        self = this;

                    self.super._createChildControls();
                    self.controlsGet().each(item => { self._makeControlDesignable(item); });
                },
                _createContainerElement: function ()
                {
                    var
                        $$element = this.$$elementGet(),
                        $$containerElement = $$.create$$({ nodeName: "div", attributes: { "class": "rad-designer" } }).appendTo($$element);

                    window.dragDropManager
                        .createDragDropAreas($$containerElement);

                    $$containerElement.addClass("rad-drag-drop-container");

                    this.$$containerElementSet($$containerElement);
                },
                _createControlsFromControlDefinitions: function (arr, baseControl)
                {
                    if (!(baseControl instanceof namespace.ContainerControl))
                        console.error("Base control must be a container control");

                    baseControl.controlsClear();

                    var
                        self = this;

                    if (!arr || !Array.isArray(arr))
                        return;

                    arr
                        .each(controlDefinition =>
                        {
                            var
                                controlClass = objectHelper.propertyValueByPathGet(window, controlDefinition.classFullName);

                            if (!controlClass)
                                console.error(String.format("Control \"{0}\" not found", controlDefinition.classFullName));

                            if (!objectHelper.classInheritsClass(controlClass, seriouslyrad.ui.web.Control))
                                console.error(String.format("Control \"{0}\" does not inherit seriouslyrad.ui.web.Control", controlDefinition.classFullName));

                            var
                                control =
                                    new controlClass(controlDefinition.propertyValues)
                                        .appendTo(baseControl);

                            self._makeControlDesignable(control);

                            if (controlDefinition.controls?.length)
                            {
                                if (!(control instanceof namespace.ContainerControl))
                                    console.error(String.format("Control \"{0}\" has child controls specified but does not inherit from seriouslyrad.ui.web.ContainerControl", controlDefinition.classFullName));

                                self._createControlsFromControlDefinitions(controlDefinition.controls, control);
                            }
                        });
                },
                _createElement: function ()
                {
                    this.super._createElement();

                    var
                        $$element = this.$$elementGet();

                    // Design Mode State
                    this.designModePanel =
                        new namespace.Panel({ cssClass: "rad-overlay-design-mode" });

                    this.designModePanel.$$containerElementGet().append("<span>Interface Designer</span>");

                    // Toolbar
                    this.toolbar =
                        new namespace.Toolbar({ showLabels: false });

                    this.toolbarMenuAddControl =
                        new namespace.ToolbarButton({ icon: "add", text: "Add" })
                        .appendTo(this.toolbar);

                    this.toolbarMenuEditMode =
                        new namespace.ToolbarButton({ icon: "edit", text: "Edit Mode", mode: namespace.ToolbarButton.modes.toggle })
                        .appendTo(this.toolbar);

                    this.menuAddControl =
                        new namespace.Menu({ tag: { targetContainerControl: this }, text: "New Control" });

                    // Add to control
                    this.toolbar.$$elementGet().prependTo($$element);
                    this.designModePanel.$$elementGet().appendTo($$element);
                },
                _createMenuPath: function (path)
                {
                    var
                        pathParts = path.split("//"),
                        menuItem = this.menuAddControl;

                    pathParts
                        .each(item =>
                        {
                            var
                                nextMenuItem = menuItem.controlsGet().firstOrDefault(itemInner => itemInner.textGet() === item);

                            if (nextMenuItem)
                                menuItem = nextMenuItem;
                            else
                                menuItem = new namespace.MenuItem({ text: item }).appendTo(menuItem);
                        });

                    return menuItem;
                },
                _deleteFocussedControl: function ()
                {
                    if (this.focussedControl)
                    {
                        this.focussedControl.remove();
                        this.focussedControl = null;
                    }
                },
                _editModeEnabledChanged: function (change)
                {
                    var
                        self = this;

                    self.$$containerElementGet().find(".rad-control-property-editor").each((index, element) =>
                    {
                        $$.radControl(element).editModeSet(change.currentValue);
                    });
                },
                _getControlDefinitions: function (baseControl, arr)
                {
                    var
                        self = this;

                    baseControl.controlsGet()
                        .each(control =>
                        {
                            var
                                classDefinition = control[".classDefinition"],
                                controlInfo = {
                                    classFullName: classDefinition.classFullName,
                                    propertyValues: {}
                                };

                            classDefinition.designablePropertiesGet()
                                .each(propertyInfo =>
                                {
                                    var
                                        propertyValue = control[".properties"][propertyInfo.name];

                                    if (propertyValue !== undefined)
                                        controlInfo.propertyValues[propertyInfo.name] = propertyValue;
                                });

                            if (control instanceof seriouslyrad.ui.web.ContainerControl)
                            {
                                controlInfo.controls = [];
                                self._getControlDefinitions(control, controlInfo.controls);
                            }

                            arr.push(controlInfo);
                        });
                },
                _getRootElements: function ()
                {
                    return (
                        this.super._getRootElements()
                            .add(this.toolbar.$$elementGet())
                    );
                },
                _makeControlDesignable: function (control)
                {
                    var
                        self = this,
                        $$element = control.$$elementGet(),
                        $$buttonContainerElement = $$.create$$("div", "rad-button-container-design-options").appendTo($$element);

                    if (control instanceof namespace.ContainerControl && !(control instanceof namespace.InterfaceDesigner))
                        $$buttonContainerElement.append("<a href=\"#\" class=\"rad-action rad-action-add icon\"><i class=\"icon plus\"></i></a>");

                    $$buttonContainerElement.append("<a href=\"#\" class=\"rad-action rad-action-settings icon\"><i class=\"icon settings\"></i></a>");
                    $$buttonContainerElement.append("<a href=\"#\" class=\"rad-action rad-action-delete icon\"><i class=\"icon trash\"></i></a>");

                    $$element.attr("tabindex", "0");
                    control.designModeSet(true);

                    if (control instanceof namespace.PropertyEditor)
                        control.editModeSet(self.editModeEnabledGet());

                    window.dragDropManager.createDragDropItems($$element);
                    window.dragDropManager.createDragDropHandles($$element);

                    if (control instanceof namespace.ContainerControl)
                    {
                        window.dragDropManager.createDragDropAreas(control.$$containerElementGet());
                        control.controlsGet().each(item => { self._makeControlDesignable(item); });
                    }
                },
                _openClassPropertyDialogForControl: function (control)
                {
                    var
                        classPropertyDialog = namespace.ClassPropertyDialog.forInstance(control);

                    if (!classPropertyDialog)
                        return;

                    control.addCssClass("rad-action-edit-in-progress");

                    classPropertyDialog
                        .openAsync(control)
                        .then(() =>
                        {
                            control.focus();
                            control.removeCssClass("rad-action-edit-in-progress");
                        });
                },
                _setMenuItems: function (targetContainerControl, menuItems)
                {
                    var
                       self = this,
                       // The classes the target container control allows
                       allowedChildControlClasses = targetContainerControl[".classDefinition"].classConstructor.allowedChildControlClasses,
                       // Total number of options allowed in this list of menuItems. If 0, the parent menuItem will be hidden
                       numberAllowed = 0;

                    // Iterate through each menuItem in the current menuItem
                    menuItems.each(itemMenuItem =>
                    {
                        // Get menuItem children
                        var
                            childControls = itemMenuItem.controlsGet();

                        // If menuItem has children process them, else process this menuItem
                        if (childControls.length)
                            // Show / hide the menuItem based on the number of allowed options it contains
                            itemMenuItem.visibleSet(self._setMenuItems(targetContainerControl, childControls) > 0);
                        else
                        {
                            var
                                tag = itemMenuItem.tagGet(),
                                optionIsAllowed = true;

                            // Check allowed parent control classes
                            if (tag.controlClass.allowedParentControlClasses)
                            {
                                optionIsAllowed =
                                    tag
                                        .controlClass
                                        .allowedParentControlClasses
                                        .firstOrDefault(item =>
                                            classFactory.classDefinitionIsAssignableFrom(
                                                classFactory.getClassDefinition(item),
                                                classFactory.getClassDefinition(targetContainerControl)
                                            )
                                        ) !== null;
                            }

                            // Check allowed child control classes
                            if (optionIsAllowed && allowedChildControlClasses)
                            {
                                optionIsAllowed =
                                    allowedChildControlClasses
                                        .firstOrDefault(item =>
                                            classFactory.classDefinitionIsAssignableFrom(
                                                classFactory.getClassDefinition(item),
                                                classFactory.getClassDefinition(tag.controlClass)
                                            )
                                        ) !== null;
                            }

                            // Set visibility
                            itemMenuItem.visibleSet(optionIsAllowed);

                            // Increment number of options allowed
                            if (optionIsAllowed)
                                numberAllowed++;
                        }
                    });

                    return numberAllowed;
                },
                _showAddControlMenu: function (targetContainerControl)
                {
                    var
                        self = this;

                    self._setMenuItems(targetContainerControl, self.menuAddControl.controlsGet());
                    self.menuAddControl.tagSet({ targetContainerControl: targetContainerControl });
                    self.menuAddControl
                        .openAsync()
                        .then(menuItem =>
                        {
                            if (!menuItem)
                                return;

                            var
                                tag = menuItem.tagGet();

                            if (tag.controlClass)
                            {
                                self._addNewControl(
                                    tag.controlClass.createForInterfaceDesigner
                                        ? tag.controlClass.createForInterfaceDesigner()
                                        : new tag.controlClass(),
                                    menuItem.menuGet().tagGet().targetContainerControl
                                );
                            }
                        });
                },

                // Public Methods
                loadFromJson: function (json)
                {
                    this._createControlsFromControlDefinitions(json?.fromJson ? json.fromJson() : null, this);
                },
                registerControlClass: function (menuPath, classConstructor, tag)
                {
                    var
                        self = this;

                    if (!classConstructor)
                    {
                        console.warn(String.format("Class constructor not found for menu path '{0}'", menuPath));
                        return;
                    }

                    if (self.buildControlMenuTimeoutId)
                        clearTimeout(self.buildControlMenuTimeoutId);

                    self.registeredControlClasses.push({ path: menuPath, classConstructor: classConstructor, tag: tag });

                    self.buildControlMenuTimeoutId = setTimeout(() => { self._buildControlMenu(); });
                },
                saveToJson: function ()
                {
                    var
                        controlDefinitions = [];

                    this._getControlDefinitions(this, controlDefinitions);
                    return controlDefinitions.toJson();
                },

                // Event Handlers
                onToolbarMenuAddControlClick: function (evt)
                {
                    evt.data.self._showAddControlMenu(evt.data.self);
                },
                onToolbarMenuEditModeStateChanged: function (evt, change)
                {
                    evt.data.self.editModeEnabledSet(change.currentValue);
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            $$(document).on("mousedown", ".rad-control-interface-designer .rad-control.rad-state-design > .rad-button-container-design-options > a", evt =>
            {
                evt.preventDefault();
                evt.stopPropagation();
            });

            $$(document).on("click", ".rad-control-interface-designer .rad-control.rad-state-design > .rad-button-container-design-options > .rad-action-add", evt =>
            {
                evt.preventDefault();
                evt.stopPropagation();

                var
                    $$target = $$(evt.currentTarget),
                    control = $$target.closest(".rad-control").radControl(),
                    interfaceDesigner = control.$$elementGet().closest(".rad-control-interface-designer").radControl();

                interfaceDesigner._showAddControlMenu(control);
            });

            $$(document).on("click", ".rad-control-interface-designer .rad-control.rad-state-design > .rad-button-container-design-options > .rad-action-settings", evt =>
            {
                evt.preventDefault();
                evt.stopPropagation();

                var
                    $$target = $$(evt.currentTarget),
                    control = $$target.closest(".rad-control").radControl(),
                    interfaceDesigner = $$target.closest(".rad-control-interface-designer").radControl();

                interfaceDesigner._openClassPropertyDialogForControl(control);
            });

            $$(document).on("click", ".rad-control-interface-designer .rad-control.rad-state-design > .rad-button-container-design-options > .rad-action-delete", evt =>
            {
                evt.preventDefault();
                evt.stopPropagation();

                $$(evt.currentTarget)
                    .closest(".rad-control-interface-designer")
                    .radControl()
                    ._deleteFocussedControl();
            });
        }
    });

    // Index Page
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "IndexPage",
        inherits: "Page",
        properties: [
            { name: "editMode", type: "boolean" },
            { name: "entityName", type: "string" },
            { name: "entityNameFriendly", type: "string" },
            { name: "entitySetName", type: "string" },
            { name: "entitySetNameFriendly", type: "string" },
            { name: "showEntityIcon", type: "boolean" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                editMode: false,
                showEntityIcon: true
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-index-page");

                // Trigger Property Changes
                this.entityNameTriggerChange();
                this.entitySetNameTriggerChange();
                this.showEntityIconTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _createChildControls: function ()
                {
                    this.super._createChildControls();
                    this.entitySearch = this.$$containerElementGet().find(">.rad-control-entity-search").radControl();
                },
                _createElement: function ()
                {
                    this.super._createElement();

                    this.$$iconElement =
                        $$.create$$({
                            nodeName: "i",
                            attributes: { "class": "icon" },
                            children: [{ nodeName: "span" }]
                        }).appendTo(this.$$titleElement);
                    this.validationPanel = new namespace.ValidationPanel().appendTo(this.$$headerElement);
                },
                _editModeChanged: function (change)
                {
                    this.trigger("editModeChanged", change);
                },
                _entityNameChanged: function (change)
                {
                    if (change.originalValue)
                        this.removeCssClass(String.format("rad-control-index-page-{0}", change.originalValue.toDashed()));

                    if (change.currentValue)
                        this.addCssClass(String.format("rad-control-index-page-{0}", change.currentValue.toDashed()));
                },
                _entitySetNameChanged: function (change)
                {
                    if (change.originalValue)
                        this.$$iconElement.removeClass(String.format("rad-icon-{0}-32", change.originalValue.toLowerCase()));

                    if (change.currentValue)
                        this.$$iconElement.addClass(String.format("rad-icon-{0}-32", change.currentValue.toLowerCase()));
                },
                _loadAsync: function ()
                {
                    this.reset();
                    return this.super._loadAsync();
                },
                _showEntityIconChanged: function (change)
                {
                    if (!this.$$iconElement)
                        return;

                    if (change.currentValue)
                        this.$$iconElement.show();
                    else
                        this.$$iconElement.hide();
                },

                // Public Methods
                remove: function ()
                {
                    this.removeControls([
                        this.validationPanel,
                        this.entitySearch
                    ]);;

                    this.super.remove();
                },
                reset: function ()
                {
                    this.super.reset();

                    if (self.entitySearch)
                        self.entitySearch.page = 0;
                },
                titleSet: function (value)
                {
                    this.super.titleSet(value);
                    this.$$titleTextElement.text(value);
                },
                triggerEntitySetCommandAsync: function (key)
                {
                    var
                        entityCommand =
                            this.entitySearch
                                .entitySetCommands
                                .where(item => item.keyGet() === key)
                                .orderBy(item => !Object.isNullOrUndefined(item.entityNameGet()) ? "0" : "1")
                                .firstOrDefault();

                    if (!entityCommand)
                        return Promise.reject("Entity command not found");

                    var
                        entityCommandInformation = this._getEntityCommandInformation();

                    if (!entityCommandInformation)
                        return Promise.reject("Entity command information not available");

                    return entityCommand.executeAsync(entityCommandInformation);
                }
            };
        }
    });

    // Details Page
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "DetailsPage",
        inherits: "Page",
        properties: [
            { name: "autoCloseOnCancelIfOpenedAsDialog", type: "boolean" },
            { name: "confirmCancelOfUnsavedChanges", type: "boolean" },
            { name: "defaultToEditMode", type: "boolean" },
            { name: "editInProgress", type: "boolean" },
            { name: "editMode", type: "boolean" },
            { name: "entityId", type: "string" },
            { name: "entityName", type: "string" },
            { name: "entityNameFriendly", type: "string" },
            { name: "entitySetName", type: "string" },
            { name: "entitySetNameFriendly", type: "string" },
            { name: "isSaving", type: "boolean" },
            { name: "isSoftDeleted", type: "boolean" },
            { name: "loading", type: "boolean" },
            { name: "newRecord", type: "boolean" },
            { name: "recordId", type: "string" },
            { name: "showEntityIcon", type: "boolean" }
        ],
        propertyAttributes: [
            {
                propertyName: "entitySetName",
                designer: {
                    category: "Data",
                    displayName: "Entity Set Name"
                }
            }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                autoCloseOnCancelIfOpenedAsDialog: true,
                confirmCancelOfUnsavedChanges: true,
                defaultToEditMode: false,
                editMode: false,
                editInProgress: false,
                isSaving: false,
                loading: false,
                showEntityIcon: false
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                var
                    self = this;

                self.addCssClass("rad-control-details-page");
                self.titlePaths = [
                    "title",
                    "description",
                    "name",
                    "referenceNumber"
                ];
                self.queueCancelAsyncTimeoutId = 0;

                self.blockNavigation = blockedNavigationPromise =>
                {
                    self._queueCancelAsync(blockedNavigationPromise);
                    return true;
                };

                // Trigger Property Changes
                this.editModeTriggerChange();
                this.entityNameTriggerChange();
                this.entitySetNameTriggerChange();
                this.newRecordTriggerChange();
                this.showEntityIconTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _activateAsync: function ()
                {
                    var
                        self = this;

                    return self.loadRecordAsync()
                        .then(() =>
                        {
                            var
                                hasUpdatePermission = false,
                                entityName = self.entityNameGet(),
                                newRecord = self.newRecordGet(),
                                defaultToEditMode = self.defaultToEditModeGet();

                            if (entityName === "LookupItem")
                            {
                                var
                                    dataSource = self.dataSourceGet(),
                                    isLinkedToEnum = dataSource ? dataSource.propertyValueByPathGet("isLinkedToEnum") : false;

                                if (isLinkedToEnum)
                                    return;
                            }

                            hasUpdatePermission =
                                window.application?.permissionCache?.hasPermissionForEntity(self.entityNameGet(), seriouslyrad.logicevaluation.PermissionEvaluator.permissionLevels.update);

                            self._setModeLayout(newRecord || (defaultToEditMode && hasUpdatePermission));

                            return self._activateAsyncSuper();
                        });
                },
                _activateAsyncSuper: function ()
                {
                    return this.super._activateAsync();
                },
                _createChildControls: function ()
                {
                    this.super._createChildControls();

                    var
                        $$containerElement = this.$$containerElementGet();

                    this.tabPages = $$containerElement.find(">.rad-control-tab-pages").radControl();
                    this.accordion = $$containerElement.find(".rad-control-accordion").radControl();

                    this.messagePanel = new namespace.MessagePanel({
                        cssClass: "rad-message-panel-deleted-entity",
                        icon: "trash",
                        text: "This record has been deleted and is displayed for audit purposes only",
                        title: "Deleted Record",
                        type: namespace.MessagePanel.type.negative
                    });

                    $$(document).trigger("seriouslyrad.ui.web.DetailsPage:childControlsCreated", this);
                },
                _createElement: function ()
                {
                    this.super._createElement();

                    var
                        $$footerElement = this.pageFooter ? this.pageFooter.$$elementGet() : null;

                    if ($$footerElement)
                    {
                        this.buttonSave = $$footerElement.find(".rad-action-save").radControl();

                        if (this.buttonSave)
                            this.buttonSave.hide();

                        this.buttonSaveAndClose = $$footerElement.find(".rad-action-save-and-close").radControl();

                        if (this.buttonSaveAndClose)
                            this.buttonSaveAndClose.hide();

                        this.buttonCancel = $$footerElement.find(".rad-action-cancel").radControl();

                        if (this.buttonCancel)
                            this.buttonCancel.hide();

                        this.buttonEdit = $$footerElement.find(".rad-action-edit").radControl();
                        this.buttonClose = $$footerElement.find(".rad-action-close").radControl();
                    }

                    this.$$iconElement =
                        $$.create$$({
                            nodeName: "i",
                            attributes: { "class": "icon" },
                            children: [{ nodeName: "span" }]
                        }).appendTo(this.$$titleElement);
                    this.validationPanel = new namespace.ValidationPanel().appendTo(this.$$headerElement);
                },
                _createNewRecord: function ()
                {
                    return {};
                },
                _dataSourceChanged: function (change)
                {
                    this.super._dataSourceChanged(change);
                    this._hideLookupItemsByTypeIfChildLookupItem();
                    this._updateTitle();
                },
                _dialogViewChanged: function (change)
                {
                    this.super._dialogViewChanged(change);

                    if (change.currentValue)
                    {
                        var
                            $$buttonCancel = this.$$pageFooterElement.find(".rad-action-cancel");

                        if (!this.$$separator)
                            this.$$separator = $$.create$$({ nodeName: "div", attributes: { "class": "separator" } });

                        $$buttonCancel.parent().prepend(this.$$separator);
                        $$buttonCancel.parent().prepend($$buttonCancel);
                    }
                },
                _disableSaveButtons: function ()
                {
                    if (this.buttonSave)
                        this.buttonSave.enabledSet(false);

                    if (this.buttonSaveAndClose)
                        this.buttonSaveAndClose.enabledSet(false);
                },
                _editInProgressChanged: function (change)
                {
                    if (change.currentValue)
                    {
                        this._registerBlockNavigationFunction();
                        this._enableSaveButtons();
                    }
                    else
                    {
                        this._unRegisterBlockNavigationFunction();
                        this._disableSaveButtons();
                    }
                },
                _editModeChanged: function (change)
                {
                    this.trigger("editModeChanged", change);
                },
                _enableSaveButtons: function ()
                {
                    if (this.buttonSave)
                        this.buttonSave.enabledSet(true);

                    if (this.buttonSaveAndClose)
                        this.buttonSaveAndClose.enabledSet(true);
                },
                _entityNameChanged: function (change)
                {
                    if (change.originalValue)
                        this.removeCssClass(String.format("rad-control-details-page-{0}", change.originalValue.toDashed()));

                    if (change.currentValue)
                        this.addCssClass(String.format("rad-control-details-page-{0}", change.currentValue.toDashed()));
                },
                _entitySetNameChanged: function (change)
                {
                    // TODO: JS MERGE
                    if (change.originalValue)
                        this.$$iconElement.removeClass(String.format("rad-icon-{0}-32", change.originalValue.toLowerCase()));

                    if (change.currentValue)
                        this.$$iconElement.addClass(String.format("rad-icon-{0}-32", change.currentValue.toLowerCase()));
                },
                _getDetailsPageRelatedRecordsPanels: function ()
                {
                    return (
                        this.controlsGet(true)
                            .where(item => item instanceof seriouslyrad.ui.web.DetailsPageRelatedRecordsPanel)
                    );
                },
                _getEntityCommandInformation: function ()
                {
                    var
                        pageDataSource = this.dataSourceGet(),
                        pageData = pageDataSource ? pageDataSource.dataGet() : null;

                    return new seriouslyrad.EntityCommandInformation({
                        caller: this,
                        entityName: this.entityNameGet(),
                        entityNameFriendly: this.entityNameFriendlyGet(),
                        entitySetName: this.entityNamePluralGet(),
                        entitySetNameFriendly: this.entityNamePluralFriendlyGet(),
                        entitySupportsSoftDelete: this.entitySupportsSoftDeleteGet(),
                        record: pageData
                    });
                },
                _hasDetailsPageRelatedRecordsPanels: function ()
                {
                    return (
                        this._getDetailsPageRelatedRecordsPanels().any()
                    );
                },
                _hideLookupItemsByTypeIfChildLookupItem: function ()
                {
                    if (this.entityNameGet() !== "LookupItem")
                        return;

                    var
                        dataSource = this.dataSourceGet();

                    if (!dataSource || !dataSource.propertyValueByPathGet("typeLookupItemId"))
                        return;

                    if (this.accordion)
                    {
                        this.accordion
                            .controlsGet()
                            .where(item => item.textGet() === "Lookup Items by Type")
                            .each(item => { item.visibleSet(false); });
                    }
                },
                _isSoftDeletedChanged: function (change)
                {
                    if (change.currentValue)
                        this.messagePanel.prependTo(this.$$containerElementGet());
                    else
                        this.messagePanel.detach();

                    if (this.buttonEdit)
                        this.buttonEdit.visibleSet(!this.editModeGet() && !change.currentValue);
                },
                _loadApplicationEntityPropertiesAsync: function (dataSource)
                {
                    var
                        self = this;

                    return new Promise((resolve, reject) =>
                    {
                        if (self.applicationEntityProperties)
                            resolve();
                        else
                        {
                            var
                                data = dataSource.dataGet(),
                                applicationEntityId;

                            switch (self.entitySetNameGet())
                            {
                                case "ApplicationEntities":
                                    applicationEntityId = data.id;
                                    break;
                                case "ApplicationEntityProperties":
                                    applicationEntityId = data.applicationEntityId;
                                    break;
                            }

                            if (applicationEntityId)
                            {
                                window.application.webApiClient
                                    .createApiMethodRequest("DataService", "CallDataService", { id: "e616d5a7-cf0b-46de-8822-236a151b32e2", operation: "List", data: { applicationEntityId: applicationEntityId }.toJson() })
                                    .executeAsync()
                                    .then(results =>
                                    {
                                        self.applicationEntityProperties = results;
                                        resolve();
                                    })
                                    .catch(error => { reject(error); });
                            }
                            else
                                resolve();
                        }
                    });
                },
                _loadAsync: function ()
                {
                    var
                        self = this;

                    return new Promise((resolve, reject) =>
                    {
                        self.reset();
                        self.loadingSet(true);

                        window.application.webApiClient
                            .createEntitySearchRequest(
                                "Entities",
                                new seriouslyrad.ComparisonExpression({
                                    path: "name",
                                    value: self.entityNameGet()
                                }),
                                null,
                                ["id"]
                            )
                            .executeAsync()
                            .then(data =>
                            {
                                if (!data || !data.length)
                                {
                                    var
                                        errorMessage = String.format("Unable to load entity \"{0}\"", self.entityNameGet());

                                    namespace.ErrorDialog.displayError(errorMessage);
                                    reject(errorMessage);
                                    return;
                                }

                                self.entityIdSet(data[0].id);

                                return self._loadAsyncSuper();
                            })
                            .then(() =>
                            {
                                resolve();
                            })
                            .catch(error =>
                            {
                                reject(error);
                            })
                            .finally(() =>
                            {
                                self.loadingSet(false);
                            });
                    });
                },
                _loadAsyncSuper: function ()
                {
                    return this.super._loadAsync();
                },
                _newRecordChanged: function (change)
                {
                    var
                        detailsPageRecordPanel = this.$$elementGet().find(".rad-control-details-page-record-panel").radControl();

                    if (!detailsPageRecordPanel)
                        return;

                    detailsPageRecordPanel.newRecordSet(change.currentValue);
                    this._setModeLayout(change.currentValue);
                },
                _queueCancelAsync: function (blockedNavigationPromise)
                {
                    var
                        self = this;

                    if (self.queueCancelAsyncTimeoutId)
                        return;

                    self.queueCancelAsyncTimeoutId = setTimeout(() =>
                    {
                        self.queueCancelAsyncTimeoutId = 0;
                        self.cancelAsync(blockedNavigationPromise);
                    }, 100);
                },
                _registerBlockNavigationFunction: function ()
                {
                    window.pageManager.registerBlockNavigationFunction(this.blockNavigation);
                },
                _setModeLayout: function (mode)
                {
                    var
                        detailsPageRecordPanel = this.$$elementGet().find(".rad-control-details-page-record-panel").radControl();

                    if (!detailsPageRecordPanel)
                        return;

                    if (this.editModeGet() === mode)
                        return;

                    this.editModeSet(mode);

                    if (this.buttonSave)
                        this.buttonSave.visibleSet(mode && !this.isSoftDeletedGet());

                    if (this.buttonSaveAndClose)
                        this.buttonSaveAndClose.visibleSet(mode && !this.isSoftDeletedGet());

                    if (this.buttonCancel)
                        this.buttonCancel.visibleSet(mode);

                    if (this.buttonEdit)
                        this.buttonEdit.visibleSet(!mode && !this.isSoftDeletedGet());

                    if (this.buttonClose)
                        this.buttonClose.visibleSet(!mode);

                    //if (this.editModeGet() === mode)
                    //    return;

                    //this.editModeSet(mode);
                    //this.buttonSave.visibleSet(mode && !this.isSoftDeletedGet());
                    //this.buttonSaveAndClose.visibleSet(mode && !this.isSoftDeletedGet());
                    //this.buttonCancel.visibleSet(mode);
                    //this.buttonEdit.visibleSet(!mode && !this.isSoftDeletedGet());
                    //this.buttonClose.visibleSet(!mode );

                    //if (mode)
                    //{
                    //    if (this.accordion)
                    //    {
                    //        this.accordion
                    //            .controlsGet()
                    //            .where(item => !item.controlsGet(true).any(itemInner => itemInner instanceof namespace.PropertyEditor))
                    //            .each(item => { item.hide(); });
                    //    }
                    //}
                    //else
                    //{
                    //    if (this.accordion)
                    //    {
                    //        this.accordion
                    //            .controlsGet()
                    //            .each(item => { item.show(); });
                    //    }
                    //}

                    //if (this.accordion)
                    //{
                    //    this.accordion
                    //        .controlsGet()
                    //        .where(item => item.visibleGet())
                    //        .each((item, index) => { if (index === 0) item.open(); else item.close(); });
                    //}

                    //this._hideLookupItemsByTypeIfChildLookupItem();
                },
                _showEntityIconChanged: function (change)
                {
                    if (!this.$$iconElement)
                        return;

                    if (change.currentValue)
                        this.$$iconElement.show();
                    else
                        this.$$iconElement.hide();
                },
                _switchToModeAsync: function (options)
                {
                    var
                        self = this;

                    return new Promise(resolve =>
                    {
                        function animateIn()
                        {
                            $$("body").scrollTop(0);

                            self.$$containerWrapper
                                .animate({ opacity: 1 })
                                .promise()
                                .then(() => { resolve(); })
                        }

                        self.$$containerWrapper
                            .animate({ opacity: 0 })
                            .promise()
                            .then(() =>
                            {
                                self.resetValidation();

                                if (options.reload)
                                {
                                    self.loadRecordAsync()
                                        .then(() =>
                                        {
                                            self._setModeLayout(options.editMode);
                                            animateIn();
                                        });
                                }
                                else
                                {
                                    self._setModeLayout(options.editMode);
                                    animateIn();
                                }
                            })
                    });
                },
                _unRegisterBlockNavigationFunction: function ()
                {
                    window.pageManager.unRegisterBlockNavigationFunction(this.blockNavigation);
                },
                _updateDetailsPageRelatedRecordsPanels: function ()
                {
                    var
                        newRecord = this.newRecordGet();

                    this._getDetailsPageRelatedRecordsPanels()
                        .each(item =>
                        {
                            if (newRecord)
                                item.hide();
                            else
                                item.show();
                        });
                },
                _updateTitle: function ()
                {
                    var
                        dataSource = this.dataSourceGet(),
                        data = dataSource ? dataSource.dataGet() : null,
                        entityNameFriendly = this.entityNameFriendlyGet();

                    if (!entityNameFriendly)
                        return;

                    var
                        titlePath =
                            data ? this.titlePaths.firstOrDefault(item => data[item]) : null,
                        entityDescription = String.format(
                            "{0}{1}",
                            this.newRecordGet() ? "New " : String.empty,
                            entityNameFriendly
                        );

                    this.titleSet(
                        titlePath
                            ? String.format(
                                "{0}: {1}",
                                entityDescription,
                                data[titlePath]
                            )
                            : entityDescription
                    );
                },

                // Public Methods
                cancelAsync: function (blockedNavigationPromise)
                {
                    var
                        self = this;

                    if (self.confirmCancelOfUnsavedChangesGet() && self.editInProgressGet())
                    {
                        return (
                            namespace.ConfirmSaveChangesDialog.display()
                                .then(result =>
                                {
                                    if (!result[0])
                                        return;

                                    if (result[0] === seriouslyrad.ui.web.Dialog.dialogResult.ok)
                                    {
                                        return (
                                            self.saveAsync(blockedNavigationPromise ? false : true)
                                                .then(() =>
                                                {
                                                    if (blockedNavigationPromise)
                                                        blockedNavigationPromise.resolve();
                                                })
                                                .catch(() => { /* Intentionally empty */ })
                                        );
                                    }

                                    self._unRegisterBlockNavigationFunction();

                                    if (blockedNavigationPromise)
                                    {
                                        blockedNavigationPromise.resolve();
                                        return;
                                    }
                                    else
                                    {
                                        if (self.openedAsDialog)
                                        {
                                            if (self.newRecordGet() || self.autoCloseOnCancelIfOpenedAsDialogGet())
                                                return self.closeAsync();
                                        }
                                        else
                                        {
                                            if (self.newRecordGet() || self.defaultToEditModeGet())
                                            {
                                                window.history.back();
                                                return Promise.resolve();
                                            }
                                        }

                                        return self._switchToModeAsync({ editMode: false, reload: true });
                                    }
                                })
                        );
                    }

                    if (self.openedAsDialog)
                    {
                        if (self.newRecordGet() || self.autoCloseOnCancelIfOpenedAsDialogGet())
                            return self.closeAsync();
                    }
                    else
                    {
                        if (self.newRecordGet() || self.defaultToEditModeGet())
                        {
                            window.history.back();
                            return Promise.resolve();
                        }
                    }

                    return self._switchToModeAsync({ editMode: false, reload: true });
                },
                closeAsync: function ()
                {
                    var
                        self = this;

                    return (
                        self.super.closeAsync()
                            .then(() =>
                            {
                                self.editInProgressSet(false);
                            })
                    );
                },
                editAsync: function ()
                {
                    return this._switchToModeAsync({ editMode: true, reload: true });
                },
                editInProgressSet: function (value)
                {
                    if (!this.editModeGet())
                        value = false;

                    this._editInProgressSet(value);
                },
                getRecordIdFromUrl: function ()
                {
                    return (
                        window.pathHelper
                            .getLocation(this.urlGet())
                            .pathname
                            .trimEnd("/")
                            .split("/")
                            .last()
                    );
                },
                loadRecordAsync: function ()
                {
                    var
                        self = this,
                        id = self.getRecordIdFromUrl(),
                        navigationData = self.navigationDataGet(),
                        additionalHeaders = {};

                    self.reset();

                    if (id === "new")
                    {
                        self.newRecordSet(true);

                        return (
                            window.utility
                                .newGuidAsync()
                                .then(guid =>
                                {
                                    self.recordIdSet(guid);

                                    const
                                        record = self._createNewRecord();

                                    record.id = guid;

                                    return self.setDataRecordAsync(record);
                                })
                                .then(() =>
                                {
                                    self._setModeLayout(true);
                                })
                        );
                    }
                    else if (id.isGuid())
                    {
                        self.newRecordSet(false);
                        self.recordIdSet(id);

                        self.isSoftDeletedSet(!!(navigationData?.isSoftDeleted));

                        if (self.isSoftDeletedGet())
                            additionalHeaders["RAD-Option-Include-Soft-Deleted"] = "true";

                        return (
                            window.application.webApiClient
                                .createEntityGetRequest(self.entitySetNameGet(), id, null, additionalHeaders)
                                .executeAsync()
                                .then(data =>
                                {
                                    return self.setDataRecordAsync(data);
                                })
                        );
                    }

                    return Promise.resolve();
                },
                reset: function ()
                {
                    this.super.reset();
                    this._setModeLayout(false);
                    this.resetValidation();
                },
                resetValidation: function ()
                {
                    this.controlsGet(true)
                        .where(item => item instanceof namespace.PropertyEditor)
                        .each(item =>
                        {
                            item.errorStateSet(false);
                            item.validationMessagesSet(null);
                        });

                    this.validationPanel.setErrorMessages(null);
                },
                saveAsync: function (close)
                {
                    var
                        self = this,
                        dataSource = self.dataSourceGet(),
                        location = window.pathHelper.getLocation(self.urlGet()),
                        pathnameParts = location.pathname.trimEnd("/").split("/"),
                        reset = false,
                        batchData = {
                            afterSaveRecordRequests: [],
                            beforeSaveRecordRequests: [],
                            configureBatchRequest: function (batchRequest) { },
                            promises: []
                        },
                        record,
                        requests = [];

                    self.resetValidation();

                    var
                        validationData = {
                            validationErrors: []
                        };

                    dataSource.triggerHandler("validating", validationData);

                    if (validationData.validationErrors.length)
                    {
                        self.setValidation(validationData.validationErrors);
                        return Promise.reject("Validation error");
                    }

                    var
                        beforeSaveChangesData = {
                            promises: []
                        };

                    dataSource.triggerHandler("beforeSaveChanges", beforeSaveChangesData);

                    self.isSavingSet(true);

                    return (
                        Promise
                            .all(beforeSaveChangesData.promises)
                            .then(() =>
                            {
                                self.trigger("creatingSaveBatch", batchData);
                                return Promise.all(batchData.promises);
                            })
                            .then(() =>
                            {
                                requests.addRange(batchData.beforeSaveRecordRequests);
                                requests.add(
                                    window.application.webApiClient
                                        .createEntitySaveRequest(
                                            self.entitySetNameGet(),
                                            dataSource.dataGet(),
                                            dataSource.dataOriginalGet()
                                        )
                                );
                                requests.addRange(batchData.afterSaveRecordRequests);

                                var
                                    batchRequest =
                                        window.application.webApiClient
                                            .createBatchRequest(requests);

                                batchData.configureBatchRequest(batchRequest);

                                return batchRequest.executeAsync();
                            })
                            .then(data =>
                            {
                                if (reset)
                                    self.reset();

                                var
                                    afterSaveChangesData = {
                                        promises: []
                                    };

                                dataSource.triggerHandler("afterSaveChanges", afterSaveChangesData);

                                return (
                                    Promise.all(afterSaveChangesData.promises)
                                        .then(() =>
                                        {
                                            return data;
                                        })
                                );
                            })
                            .then(data =>
                            {
                                record = data[batchData.beforeSaveRecordRequests.length].response.response;
                                self.promiseData = record;
                                return self.setDataRecordAsync(record);
                            })
                            .then(() =>
                            {
                                if (self.newRecordGet())
                                {
                                    self.urlSet(pathnameParts.select((item, index) => { return index < pathnameParts.length - 1 ? item : record.id; }).join("/") + "/" + location.search);
                                    self.newRecordSet(false);
                                }

                                if (close)
                                {
                                    self.dialogResult = namespace.Dialog.dialogResult.ok;
                                    reset = true;
                                    return self.closeAsync();
                                }

                                var
                                    processRulesResult = namespace.DetailsPage.processRules("newRecordAdded", { page: self });

                                if (processRulesResult.handled)
                                    return;

                                return self._switchToModeAsync({ editMode: false, reload: false });
                            })
                            .then(() =>
                            {
                                if (reset)
                                    self.reset();

                                self._updateDetailsPageRelatedRecordsPanels();
                            })
                            .catch(error =>
                            {
                                if (error.type === "ValidationApiException")
                                {
                                    const
                                        entityName = self.entityNameGet(),
                                        validationErrorsForThisEntity =
                                            error.validationErrors
                                                .filter(item => item.entityName === entityName);

                                    self.setValidation(validationErrorsForThisEntity.length ? validationErrorsForThisEntity : error.validationErrors);
                                }

                                throw error;
                            })
                            .finally(() =>
                            {
                                self.isSavingSet(false);
                            })
                    );
                },
                saveAndCloseAsync: function ()
                {
                    this.saveAsync(true).catch(() => { /* Intentionally empty */ });
                },
                setDataRecordAsync: function (data)
                {
                    var
                        self = this,
                        dataSource = new seriouslyrad.data.DataSource({ data: data ? data : {} });

                    // TODO - Move to more specific class.
                    return (
                        self._loadApplicationEntityPropertiesAsync(dataSource)
                            .then(() =>
                            {
                                self.dataSourceSet(dataSource);
                                self.editInProgressSet(false);
                                self._updateDetailsPageRelatedRecordsPanels();
                            })
                    );
                },
                setValidation: function (validationErrors)
                {
                    var
                        self = this;

                    self.resetValidation();

                    if (validationErrors.length === 0)
                        return;

                    var
                        errorMessages = [],
                        controls = self.controlsGet(true),
                        shouldPushErrorMessage = true;

                    validationErrors.each(item =>
                    {
                        if (item.propertyName)
                        {
                            controls
                                .where(control => control instanceof namespace.PropertyEditor && item.propertyName.toLowerCase().split(",").contains(control.dataSourcePropertyGet().toLowerCase()))
                                .each(control =>
                                {
                                    if (control.showInlineValidationMessagesGet())
                                    {
                                        shouldPushErrorMessage = false;

                                        var
                                            controlValidationMessages = control.validationMessagesGet(),
                                            existingMessages = Array.isArray(controlValidationMessages) ? controlValidationMessages : [],
                                            messages = [];

                                        messages.addRange(existingMessages);
                                        messages.push(item.errorMessage);

                                        control.validationMessagesSet(messages);
                                    }

                                    control.errorStateSet(true);
                                });
                        }

                        if (shouldPushErrorMessage)
                            errorMessages.push(item.errorMessage);

                        shouldPushErrorMessage = true;
                    });

                    self.validationPanel.setErrorMessages(errorMessages);
                },
                titleSet: function (value)
                {
                    this.super.titleSet(value);
                    this.$$titleTextElement.text(value);
                },

                // Event Handlers
                onDataSourcePropertyValueChanged: function (evt, change)
                {
                    this.super.onDataSourcePropertyValueChanged(evt, change);

                    var
                        self = evt.data.self;

                    if (!self.loadingGet())
                        namespace.DetailsPage.processRules("dataSourcePropertyValueChanged", { page: self, change: change });

                    if (self.titlePaths.contains(change.path))
                        self._updateTitle();

                    self.editInProgressSet(!self.dataSourcePropertyFromUrl || change.path !== self.dataSourcePropertyFromUrl);
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            var
                rules = [];

            function registerRule(rule)
            {
                rules.push(rule);
            }

            classConstructor.processRules = (event, data) =>
            {
                var
                    processRulesResult = {
                        handled: false
                    };

                rules
                    .where(item =>
                    {
                        return (
                            item.entityName === data.page.entityNameGet()
                            && item.event === event
                        );
                    })
                    .each(item =>
                    {
                        if (item.action)
                            item.action(data, processRulesResult);
                    });

                return processRulesResult;
            };

            $$(() =>
            {
                $$(document).trigger("seriouslyrad.ui.web.DetailsPage:registerRules", registerRule);
            });
        }
    });

    // Details Page Record Panel
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "DetailsPageRecordPanel",
        inherits: "Panel",
        properties: [
            { name: "newRecord", type: "boolean" }
        ],
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-details-page-record-panel");

                // Trigger Property Changes
                this.newRecordTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _createContainerElement: function ()
                {
                    var
                        $$element = this.$$elementGet(),
                        $$containerWrapperElement = $$element.find(">.rad-control-container-wrapper"),
                        $$containerInnerWrapperElement = $$element.find(">.rad-control-container-inner-wrapper"),
                        $$containerElement = $$element.find(">.rad-control-container");

                    if ($$containerWrapperElement.length && !$$containerInnerWrapperElement.length)
                        $$containerInnerWrapperElement = $$containerWrapperElement.find(">.rad-control-container-inner-wrapper");

                    if ($$containerWrapperElement.length && !$$containerElement.length)
                        $$containerElement = $$containerWrapperElement.find(">.rad-control-container");

                    if ($$containerInnerWrapperElement.length && !$$containerElement.length)
                        $$containerElement = $$containerInnerWrapperElement.find(">.rad-control-container");

                    if (!$$containerWrapperElement.length)
                        $$containerWrapperElement = $$.create$$({ nodeName: "div" }).addClass("rad-control-container-wrapper").appendTo($$element);

                    if (!$$containerInnerWrapperElement.length)
                        $$containerInnerWrapperElement = $$.create$$({ nodeName: "div" }).addClass("rad-control-container-inner-wrapper").appendTo($$containerWrapperElement);

                    if (!$$containerElement.length)
                        $$containerElement = $$.create$$({ nodeName: "div" }).addClass("rad-control-container").appendTo($$containerInnerWrapperElement);

                    this.$$containerElementSet($$containerElement);

                    this.$$header =
                        $$.create$$({
                            nodeName: "h3",
                            attributes: { "class": "ui dividing header" },
                            children: [{ nodeName: "span", text: "General" }]
                        });
                    this.$$buttonContainerView = $$.create$$("div", "rad-button-container rad-button-container-view");
                    this.$$buttonContainerEdit = $$.create$$("div", "rad-button-container rad-button-container-edit");
                    this.$$saveToAccessOtherPropertiesMessage = $$.create$$("div", "rad-save-message", "Save the record to access related records").hide();

                    this.$$header.prependTo($$containerInnerWrapperElement);
                    this.$$buttonContainerView.appendTo($$containerInnerWrapperElement);
                    this.$$buttonContainerEdit.appendTo($$containerInnerWrapperElement);
                    this.$$saveToAccessOtherPropertiesMessage.appendTo($$element);
                },
                _newRecordChanged: function (change)
                {
                    var
                        page = this.pageGet(),
                        hasDetailsPageRelatedRecordsPanels = page ? page._hasDetailsPageRelatedRecordsPanels() : false;

                    if (change.currentValue && hasDetailsPageRelatedRecordsPanels)
                        this.$$saveToAccessOtherPropertiesMessage.show();
                    else
                        this.$$saveToAccessOtherPropertiesMessage.hide();
                },

                // Public Methods
                remove: function ()
                {
                    this.removeControls([
                        this.buttonEdit,
                        this.buttonCancel,
                        this.buttonSave,
                        this.buttonSaveAndClose,
                        this.buttonClose
                    ]);

                    this.super.remove();
                },

                // Event Handlers
                onPageLoaded: function (evt, eventData)
                {
                    var
                        self = evt.data.self,
                        page = self.pageGet();

                    if (page.validationPanel)
                    {
                        var
                            $$validationPanel = page.validationPanel.$$elementGet();

                        $$validationPanel.insertBefore(self.$$elementGet());
                    }

                    if (!page.openedAsDialog)
                    {
                        self.buttonEdit = page.buttonEdit;
                        self.buttonCancel = page.buttonCancel;
                        self.buttonSave = page.buttonSave;
                        self.buttonSaveAndClose = page.buttonSaveAndClose;
                        self.buttonClose = page.buttonClose;

                        if (self.buttonEdit)
                            self.buttonEdit.appendTo(self.$$buttonContainerView);

                        if (self.buttonCancel)
                            self.buttonCancel.appendTo(self.$$buttonContainerEdit);

                        if (self.buttonEdit || self.buttonCancel)
                            $$.create$$("div", "rad-space-filler").appendTo(self.$$buttonContainerEdit);

                        if (self.buttonSave)
                        {
                            self.buttonSave.enabledSet(false);
                            self.buttonSave.appendTo(self.$$buttonContainerEdit);
                        }

                        if (self.buttonSaveAndClose)
                        {
                            self.buttonSaveAndClose.enabledSet(false);
                            self.buttonSaveAndClose.appendTo(self.$$buttonContainerEdit);
                        }

                        if (self.buttonClose)
                            self.buttonClose.appendTo(self.$$buttonContainerView);

                        if (self.buttonSave || self.buttonSaveAndClose || self.buttonClose)
                            $$.create$$("div", "rad-space-filler").appendTo(self.$$buttonContainerView);

                        if (page.pageFooter)
                            page.pageFooter.hide();
                    }

                    if (page.buttonSave)
                        page.buttonSave.addCssClass("rad-default");

                    if (page.buttonSaveAndClose)
                        page.buttonSaveAndClose.addCssClass("rad-default");
                }
            };
        }
    });

    // Details Page Related Records Panel
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "DetailsPageRelatedRecordsPanel",
        inherits: "Panel",
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-details-page-related-records-panel");
            };
        }
    });

    // RSS Feed Page
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "RSSFeedPage",
        inherits: "Page",
        properties: [
            { name: "feedUrl", type: "string" },
            { name: "feedUrlBrowser", type: "string" }
        ],
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-page-rss-feed");
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _addItem: function (item)
                {
                    var
                        $$item =
                            $$(
                                String.format(
                                    "  <a target=\"_system\" href=\"{0}\" class=\"item\">" +
                                    "    <span class=\"middle aligned content\">" +
                                    "      {1}<br />" +
                                    "      <span>Click here for more information...</span>" +
                                    "    </span>" +
                                    "  </a>",
                                    encodeURI(item.link),
                                    String.htmlEncode(item.title)
                                )
                            );

                    $$item.appendTo(this.$$items);
                },
                _createChildControls: function ()
                {
                    this.super._createChildControls();

                    var
                        $$containerElement = this.$$containerElementGet();

                    this.$$items = $$.create$$({ nodeName: "div", attributes: { "class": "ui unstackable items" } });
                    $$containerElement.append(this.$$items);
                },
                _loadFeedAsync: function ()
                {
                    var
                        self = this;

                    return new Promise((resolve, reject) =>
                    {
                        var
                            feedUrl = this.feedUrlGet(),
                            feedUrlBrowser = this.feedUrlBrowserGet();

                        if (window.application._getPlatform() === "browser" && feedUrlBrowser)
                            feedUrl = feedUrlBrowser;

                        self.$$items.empty();

                        $$
                            .ajax({
                                url: feedUrl,
                                type: "GET",
                                dataType: "document"
                            })
                            .then(results =>
                            {
                                const
                                    xml = results[0];

                                $$.each($$("item", xml), (i, e) =>
                                {
                                    self._addItem({
                                        title: $$(e).find("title").text(),
                                        link: $$(e).find("link").text()
                                    });
                                });

                                resolve();
                            })
                            .catch(() =>
                            {
                                self._displayErrorDialogAsync("An error occurred while loading the feed")
                                    .then(result =>
                                    {
                                        if (result[0] === seriouslyrad.ui.web.Dialog.dialogResult.ok)
                                            self._loadFeedAsync();
                                    })
                                    .finally(() =>
                                    {
                                        reject();
                                    });
                            });
                    });
                },

                // Public Methods
                show: function ()
                {
                    this._loadFeedAsync();
                    return this.super.show();
                }
            };
        }
    });

    // Table Column Entity Action
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "TableColumnEntityAction",
        inherits: "TableColumnBase",
        createPropertyDefaults: namespace =>
        {
            return {
                tableCellClass: namespace.TableCellEntityAction
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-table-column-entity-action rad-device-visible-when-narrow");
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _createChildControls: function ()
                {
                    this.super._createChildControls();

                    this.buttonEntityAction = new namespace.Button({ icon: "caret down", inline: true, showLabel: false }).appendTo(this);
                    this.buttonEntityAction.on("click", { self: this }, this.onButtonClicked);
                },

                // Event Handlers
                onButtonClicked: function (evt)
                {
                    evt.preventDefault();
                    evt.stopPropagation();

                    var
                        self = evt.data.self,
                        $$element = self.$$elementGet(),
                        entitySearch = $$element.closest(".rad-control-entity-search").radControl(),
                        entityCommandInformation = entitySearch._getEntityCommandInformation();

                    if (!entityCommandInformation)
                        return;

                    entitySearch.openEntitySetCommandMenuAsync(entityCommandInformation);
                }
            };
        }
    });

    // Table Cell Entity Action
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "TableCellEntityAction",
        inherits: "TableCellBase",
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-table-cell-entity-action");
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _createElement: function ()
                {
                    this.super._createElement();

                    this.$$contentsElement.hide();
                },
                _createChildControls: function ()
                {
                    this.super._createChildControls();

                    this.panelSettings = new namespace.Panel({ cssClass: "rad-button-container-settings" }).appendTo(this);

                    this.buttonEntityAction = new namespace.Button({ icon: "setting", inline: true, showLabel: false }).appendTo(this.panelSettings);
                    this.buttonEntityAction.on("click", { self: this }, this.onButtonEntityActionClicked);

                    this.panelMove = new namespace.Panel({ cssClass: "rad-button-container-move" }).appendTo(this);

                    this.buttonMoveUp = new namespace.Button({ icon: "angle up", inline: true, showLabel: false }).appendTo(this.panelMove);
                    this.buttonMoveUp.on("click", { self: this }, this.onButtonMoveUpClicked);

                    this.buttonMoveDown = new namespace.Button({ icon: "angle down", inline: true, showLabel: false }).appendTo(this.panelMove);
                    this.buttonMoveDown.on("click", { self: this }, this.onButtonMoveDownClicked);
                },
                _dataSourceChanged: function (change)
                {
                    this.super._dataSourceChanged(change);
                    this._updateDisplay();
                },
                _getEntityCommandInformation: function ()
                {
                    var
                        entitySearch = this._getEntitySearch();

                    if (!entitySearch)
                        return null;

                    var
                        row = this._getRow(),
                        rowDataSource = row ? row.dataSourceGet() : null,
                        record = rowDataSource ? rowDataSource.dataGet() : null;

                    if (!record)
                        return null;

                    var
                        entityCommandInformation = entitySearch._getEntityCommandInformation();

                    if (!entityCommandInformation)
                        return null;

                    entityCommandInformation.recordSet(record);

                    return entityCommandInformation;
                },
                _getEntitySearch: function ()
                {
                    return this.$$elementGet()?.closest(".rad-control-entity-search").radControl();
                },
                _getRow: function ()
                {
                    return this.$$elementGet()?.closest(".rad-control-table-row").radControl();
                },
                _updateDisplay: function ()
                {
                    var
                        entitySearch = this._getEntitySearch(),
                        shouldDisplay = false;

                    if (entitySearch)
                        shouldDisplay = entitySearch._hasEntityCommandsForEntityCommandInformation(this._getEntityCommandInformation());

                    if (shouldDisplay)
                        this.removeCssClass("rad-state-no-entity-commands");
                    else
                        this.addCssClass("rad-state-no-entity-commands");

                    if (entitySearch)
                        entitySearch._updateTableColumnEntityAction();
                },

                // Event Handlers
                onAncestorChanged: function (evt)
                {
                    this.super.onAncestorChanged(evt);
                    evt.data.self._updateDisplay();
                },
                onButtonEntityActionClicked: function (evt)
                {
                    evt.preventDefault();
                    evt.stopPropagation();

                    var
                        self = evt.data.self,
                        entitySearch = self._getEntitySearch();

                    if (!entitySearch)
                        return;

                    var
                        entityCommandInformation = self._getEntityCommandInformation();

                    if (!entityCommandInformation)
                        return;

                    entitySearch.openEntityCommandMenuAsync(entityCommandInformation);
                },
                onButtonMoveDownClicked: function (evt)
                {
                    evt.preventDefault();
                    evt.stopPropagation();

                    var
                        self = evt.data.self,
                        row = self._getRow(),
                        entitySearch = self._getEntitySearch();

                    entitySearch.rowMoveDown(row);
                },
                onButtonMoveUpClicked: function (evt)
                {
                    evt.preventDefault();
                    evt.stopPropagation();

                    var
                        self = evt.data.self,
                        row = self._getRow(),
                        entitySearch = self._getEntitySearch();

                    entitySearch.rowMoveUp(row);
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.create = options =>
            {
                return new classConstructor({
                    table: options.table,
                    tableRow: options.tableRow
                });
            };

            classConstructor.createLightweightContent = ($$tableCell, tableColumn, rowDataSource) =>
            {
                $$tableCell.addClass("rad-control-table-cell-entity-action");
            };
        }
    });

    // Table Column (Entity Save Indicator)
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "TableColumnEntitySaveIndicator",
        inherits: "TableColumnBase",
        createPropertyDefaults: namespace =>
        {
            return {
                tableCellClass: namespace.TableCellEntitySaveIndicator
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-table-column-entity-save-indicator");
            };
        }
    });

    // Table Cell (Entity Save Indicator)
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "TableCellEntitySaveIndicator",
        inherits: "TableCellBase",
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-table-cell-entity-save-indicator");
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _createElement: function ()
                {
                    this.super._createElement();

                    this.$$contentsElement.hide();
                },
                _createChildControls: function ()
                {
                    this.super._createChildControls();

                    this.$$saveIndicator =
                        $$.create$$({
                            nodeName: "i",
                            attributes: { "class": "rad-save-indicator icon" }
                        });

                    this.append(this.$$saveIndicator);
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.create = options =>
            {
                return new classConstructor({
                    table: options.table,
                    tableRow: options.tableRow
                });
            };
        }
    });

    // Text Box Property Dialog
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        inherits: "Dialog",
        createPropertyDefaults: namespace =>
        {
            return {
                title: "Property Editor"
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-dialog-text-box-property");

                this.tabSet = new namespace.TabSet();
                this.tabSet.appendTo(this.$$containerElementGet());

                this.tabProperty = new namespace.Tab({ text: "Property" });
                this.tabProperty.appendTo(this.tabSet);

                // Property Fields

                this.textBoxPropertyEditorPropertyName = new namespace.TextBoxPropertyEditor({ propertyDisplayName: "Name" });
                this.textBoxPropertyEditorPropertyName.appendTo(this.tabProperty);

                this.comboBoxPropertyEditorDataType = new namespace.ComboBoxPropertyEditor({ propertyDisplayName: "Data Type" });
                this.comboBoxPropertyEditorDataType.appendTo(this.tabProperty);

                this.textBoxPropertyEditorDefaultValue = new namespace.TextBoxPropertyEditor({ propertyDisplayName: "Default Value" });
                this.textBoxPropertyEditorDefaultValue.appendTo(this.tabProperty);

                this.comboBoxPropertyEditorIsEncrypted = new namespace.ComboBoxPropertyEditor({ propertyDisplayName: "Is Encrypted" });
                this.comboBoxPropertyEditorIsEncrypted.appendTo(this.tabProperty);

                this.textBoxPropertyEditorOptions = new namespace.TextBoxPropertyEditor({ propertyDisplayName: "Options" });
                this.textBoxPropertyEditorOptions.appendTo(this.tabProperty);

                this.comboBoxPropertyEditorDataServiceId = new namespace.ComboBoxPropertyEditor({ propertyDisplayName: "Data Service" });
                this.comboBoxPropertyEditorDataServiceId.appendTo(this.tabProperty);

                this.textBoxPropertyEditorDataServiceData = new namespace.TextBoxPropertyEditor({ propertyDisplayName: "Data Service Data" });
                this.textBoxPropertyEditorDataServiceData.appendTo(this.tabProperty);

                this.tabLogic = new namespace.Tab({ text: "Logic" });
                this.tabLogic.appendTo(this.tabSet);

                this.evaluatorTreePropertyEditorIsMandatoryEvaluator = new namespace.EvaluatorTreePropertyEditor({ editorControl: new namespace.EvaluatorTree, propertyDisplayName: "Is Mandatory Logic" });
                this.evaluatorTreePropertyEditorIsMandatoryEvaluator.appendTo(this.tabLogic);

                this.evaluatorTreePropertyEditorValidationEvaluator = new namespace.EvaluatorTreePropertyEditor({ editorControl: new namespace.EvaluatorTree, propertyDisplayName: "Validation Logic" });
                this.evaluatorTreePropertyEditorValidationEvaluator.appendTo(this.tabLogic);

                // Component Fields

                this.tabComponent = new namespace.Tab({ text: "Component" });
                this.tabComponent.appendTo(this.tabSet);

                this.evaluatorTreePropertyEditorIsVisibleEvaluator = new namespace.EvaluatorTreePropertyEditor({ editorControl: new namespace.EvaluatorTree, propertyDisplayName: "Is Visible Logic" });
                this.evaluatorTreePropertyEditorIsVisibleEvaluator.appendTo(this.tabComponent);

                this.controlsGet(true)
                    .where(item => item instanceof namespace.PropertyEditor)
                    .each(item => { item.editModeSet(true); });
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            //namespace.TextBoxPropertyEditor.propertyDialog = new classConstructor({ minWidth: 300 });
        }
    });

    // Twitter Feed Page
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "TwitterFeedPage",
        inherits: "Page",
        properties: [
            { name: "linkColor", type: "string" },
            { name: "screenName", type: "string" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                linkColor: "#3b94d9"
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _activateAsync: function ()
                {
                    var
                        self = this,
                        $$containerElement = this.$$containerElementGet(),
                        linkColor = this.linkColorGet(),
                        screenName = this.screenNameGet();

                    $$containerElement.css({ display: "none" });

                    return (
                        this.super._activateAsync()
                            .then(() =>
                            {
                                $$containerElement.empty();
                                $$containerElement.append(
                                    $$(
                                        String.format(
                                            "<a class=\"twitter-timeline rad-state-hidden\" data-theme=\"light\" data-link-color=\"{0}\" href=\"{1}?ref_src=twsrc%5Etfw\">Tweets by {2}</a>",
                                            String.htmlEncode(linkColor),
                                            encodeURI(String.format("https://twitter.com/{0}", screenName)),
                                            String.htmlEncode(screenName)
                                        )
                                    )
                                );

                                return twttr.widgets.load($$containerElement[0]);
                            })
                            .catch(error =>
                            {
                                self._displayErrorDialogAsync("An error occurred while loading the twitter component")
                                    .then(result =>
                                    {
                                        if (result[0] === seriouslyrad.ui.web.Dialog.dialogResult.ok)
                                            self.activateAsync();
                                    });

                                throw error;
                            })
                            .finally(() =>
                            {
                                $$containerElement.css({ display: String.empty });
                            })

                    );
                }
            };
        }
    });

    // User Account Property Page
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "UserAccountDialog",
        inherits: "Dialog",
        createPropertyDefaults: namespace =>
        {
            return {
                buttonStyle: namespace.Dialog.buttonStyle.okCancel,
                cancelButtonText: "Close",
                okButtonText: "Save",
                title: "My Account"
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.loadedUserSettingTypes = false;
                this.userSettings = null;
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _bindEvents: function ()
                {
                    this.super._bindEvents();

                    this.textBoxNewPassword.on("keyup", { self: this }, this.onTextBoxNewPasswordKeyUp);
                    this.textBoxConfirmNewPassword.on("keyup", { self: this }, this.onTextBoxConfirmNewPasswordKeyUp);
                    this.textBoxCurrentPassword.on("keyup", { self: this }, this.onTextBoxCurrentPasswordKeyUp);
                },
                _createChildControls: function ()
                {
                    this.super._createChildControls();

                    this.accordion = new namespace.Accordion().appendTo(this);

                    this.accordionPanelSettings = new namespace.AccordionPanel({ text: "Settings" }).appendTo(this.accordion);

                    this.accordionPanelChangePassword = new namespace.AccordionPanel({ text: "Change Password" }).appendTo(this.accordion);
                    this.formChangePassword = new namespace.Form().appendTo(this.accordionPanelChangePassword);
                    this.validationPanelChangePassword = new namespace.ValidationPanel().appendTo(this.formChangePassword);
                    this.textBoxNewPassword = new namespace.PropertyEditorTextBoxPassword({ propertyDisplayName: "New Password", editMode: true }).appendTo(this.formChangePassword);
                    this.textBoxConfirmNewPassword = new namespace.PropertyEditorTextBoxPassword({ propertyDisplayName: "Confirm New Password", editMode: true }).appendTo(this.formChangePassword);
                    this.textBoxCurrentPassword = new namespace.PropertyEditorTextBoxPassword({ propertyDisplayName: "Current Password", editMode: true }).appendTo(this.formChangePassword);
                    this.buttonChangePassword = new namespace.Button({ cssClass: "primary positive", text: "Change Password" }).appendTo(this.formChangePassword);
                    this.buttonChangePassword.on("click", { self: this }, this.onChangePasswordClicked);
                },
                _createNewUserSettingAsync: function (userSettingTypeId, userSettingsArray, propertyEditor)
                {
                    return new Promise(resolve =>
                    {
                        var
                            userSetting = { userSettingTypeId: userSettingTypeId, value: null };

                        window.utility.newGuidAsync()
                            .then(guid =>
                            {
                                userSetting.id = guid;
                                userSettingsArray.push(userSetting);
                                resolve({ userSetting: userSetting, propertyEditor: propertyEditor });
                            });
                    });
                },
                _loadAsync: function ()
                {
                    var
                        self = this,
                        promises = [];

                    if (!self.loadedUserSettingTypes)
                        promises.push(self._loadUserSettingTypesAsync());

                    promises.push(self._loadUserSettingsAsync());

                    return (
                        Promise.all(promises)
                            .then(() =>
                            {
                                return self._updatePropertyEditorDataSourcesAsync();
                            })
                            .then(() =>
                            {
                                return self._loadAsyncSuper();
                            })
                    );
                },
                _loadAsyncSuper: function ()
                {
                    return this.super._loadAsync();
                },
                _loadUserSettingsAsync: function ()
                {
                    var
                        self = this;

                    return (
                        window.application.webApiClient
                            .createEntitySearchRequest("UserSettings", null, null, ["id", "rowVersion", "userSettingTypeId", "value"])
                            .executeAsync()
                            .then(data =>
                            {
                                self.dataSourceSet(data);
                            })
                    );
                },
                _loadUserSettingTypesAsync: function ()
                {
                    var
                        self = this;

                    return (
                        window.application.webApiClient
                            .createEntitySearchRequest("UserSettingTypes", null, null, ["id", "name", "dataTypeLookupItem.description"])
                            .executeAsync()
                            .then(data =>
                            {
                                data.each(item =>
                                {
                                    var
                                        propertyEditorConstructor;

                                    switch (item.dataTypeLookupItem.description.toLowerCase())
                                    {
                                        case "boolean":
                                            propertyEditorConstructor = namespace.PropertyEditorSwitch;
                                            break;
                                        case "date":
                                            propertyEditorConstructor = namespace.PropertyEditorDateTime;
                                            break;
                                        case "float":
                                        case "int":
                                            propertyEditorConstructor = namespace.PropertyEditorNumericUpDown;
                                            break;
                                        case "string":
                                            propertyEditorConstructor = namespace.PropertyEditorTextBox;
                                            break;
                                    }

                                    if (propertyEditorConstructor)
                                        new propertyEditorConstructor({ propertyDisplayName: item.name, editMode: true, dataSourceProperty: "value", dataSourcePropertyType: "string", tag: item }).appendTo(self.accordionPanelSettings);
                                });

                                if (data?.length)
                                {
                                    self.accordionPanelSettings.show();
                                    self.accordionPanelSettings.open();
                                    self.buttonStyleSet(namespace.Dialog.buttonStyle.okCancel);
                                }
                                else
                                {
                                    self.accordionPanelSettings.hide();
                                    self.accordionPanelChangePassword.open();
                                    self.buttonStyleSet(namespace.Dialog.buttonStyle.cancelOnly);
                                }

                                self.loadedUserSettingTypes = true;
                            })
                    );
                },
                _onPasswordTextBoxKeyUp: function (evt)
                {
                    switch (evt.key)
                    {
                        case "Enter":
                            {
                                evt.stopPropagation();
                                this.buttonChangePassword.click();
                                break;
                            }
                    }
                },
                _updatePropertyEditorDataSourcesAsync: function ()
                {
                    var
                        self = this,
                        promises = [],
                        dataSource = self.dataSourceGet();

                    if (!dataSource)
                        return;

                    var
                        data = dataSource.dataGet();

                    if (!data)
                        return;

                    self.accordionPanelSettings
                        .controlsGet(true)
                        .where(item => item instanceof namespace.PropertyEditor)
                        .each(item =>
                        {
                            var
                                tag = item.tagGet(),
                                userSetting = data.singleOrDefault(userSetting => userSetting.userSettingTypeId === tag.id);

                            if (!userSetting)
                            {
                                promises.push(
                                    self._createNewUserSettingAsync(tag.id, data, item)
                                        .then(result =>
                                        {
                                            const
                                                userSetting = result.userSetting,
                                                propertyEditor = result.propertyEditor;

                                            propertyEditor.dataSourceSet(userSetting);
                                        })
                                );
                            }
                            else
                                item.dataSourceSet(userSetting);
                        });

                    return Promise.all(promises);
                },

                // Public Methods
                buttonClicked: function ()
                {
                    switch (this.dialogResult)
                    {
                        case namespace.Dialog.dialogResult.ok:
                            this.saveAndCloseAsync();
                            break;
                        case namespace.Dialog.dialogResult.cancel:
                            this.closeAsync();
                            break;
                    }
                },
                saveAndCloseAsync: function ()
                {
                    var
                        self = this,
                        dataSource = self.dataSourceGet(),
                        data = dataSource.dataGet(),
                        dataOriginal = dataSource.dataOriginalGet(),
                        requests = [];

                    if (!data || !data.length)
                        return Promise.resolve();

                    data.each(item =>
                    {
                        var
                            itemOriginal = dataOriginal.singleOrDefault(itemInner => itemInner.id === item.id);

                        if (itemOriginal?.value === item.value)
                            return;

                        requests.push(
                            window.application.webApiClient
                                .createEntitySaveRequest("UserSettings", item, itemOriginal)
                        );
                    });

                    return (
                        window.application.webApiClient
                            .createBatchRequest(requests)
                            .executeAsync()
                            .then(data =>
                            {
                                dataSource.dataSet(data.select(item => item.response));
                                return self.closeAsync();
                            })
                    );
                },

                // Event Handlers
                onChangePasswordClicked: function (evt)
                {
                    var
                        self = evt.data.self;

                    self.validationPanelChangePassword.setErrorMessages(null);
                    self.textBoxNewPassword.errorStateSet(false);
                    self.textBoxConfirmNewPassword.errorStateSet(false);
                    self.textBoxCurrentPassword.errorStateSet(false);

                    var
                        newPassword = self.textBoxNewPassword.valueGet(),
                        confirmPassword = self.textBoxConfirmNewPassword.valueGet(),
                        currentPassword = self.textBoxCurrentPassword.valueGet(),
                        valid = true;

                    if (!newPassword || newPassword.length === 0 || newPassword !== confirmPassword)
                    {
                        self.textBoxNewPassword.errorStateSet(true);
                        valid = false;
                    }

                    if (!confirmPassword || confirmPassword.length === 0 || newPassword !== confirmPassword)
                    {
                        self.textBoxConfirmNewPassword.errorStateSet(true);
                        valid = false;
                    }

                    if (!currentPassword || currentPassword.length === 0)
                    {
                        self.textBoxCurrentPassword.errorStateSet(true);
                        valid = false;
                    }

                    if (!valid)
                        return;

                    window.application.webApiClient
                        .createApiMethodRequest("DataService", "CallDataService", { id: "a8a7e53b-6cf2-4324-86e4-83ec7c41bf01", operation: "ChangePassword", data: { newPassword: newPassword, currentPassword: currentPassword }.toJson() })
                        .executeAsync()
                        .then(data =>
                        {
                            if (!self.messageDialog)
                                self.messageDialog = new namespace.MessageDialog();

                            self.messageDialog.titleSet("Success");
                            self.messageDialog.textSet("Password changed successfully.");

                            self.messageDialog
                                .openAsync()
                                .then(() =>
                                {
                                    self.textBoxNewPassword.valueSet(null);
                                    self.textBoxConfirmNewPassword.valueSet(null);
                                    self.textBoxCurrentPassword.valueSet(null);
                                });
                        })
                        .catch(error =>
                        {
                            if (error.type === "ValidationApiException")
                                self.validationPanelChangePassword.setErrorMessages(error.validationErrors.select(item => item.errorMessage));
                        });
                },
                onTextBoxConfirmNewPasswordKeyUp: function (evt)
                {
                    evt.data.self._onPasswordTextBoxKeyUp(evt);
                },
                onTextBoxCurrentPasswordKeyUp: function (evt)
                {
                    evt.data.self._onPasswordTextBoxKeyUp(evt);
                },
                onTextBoxNewPasswordKeyUp: function (evt)
                {
                    evt.data.self._onPasswordTextBoxKeyUp(evt);
                }
            };
        }
    });

    // You Tube Channel Page
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "YouTubeChannelPage",
        inherits: "Page",
        properties: [
            { name: "channelId", type: "string" },
            { name: "nextPageToken", type: "string" }
        ],
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-you-tube-channel-page");
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _addItem: function (item)
                {
                    var
                        thumbnail = item.snippet.thumbnails.default,
                        text = item.snippet.title,
                        videoId = item.id.videoId;

                    var
                        $$item =
                            $$(
                                String.format(
                                    "  <a target=\"_system\" href=\"https://www.youtube.com/watch?v={0}\" class=\"item\">" +
                                    "    <span class=\"ui tiny image\">" +
                                    "      <img src=\"{1}\" width=\"{2}\" height=\"{3}\">" +
                                    "    </span>" +
                                    "    <span class=\"middle aligned content\">" +
                                    "      {4}" +
                                    "    </span>" +
                                    "  </a>",
                                    encodeURIComponent(videoId),
                                    encodeURI(thumbnail.url),
                                    String.htmlEncode(thumbnail.width),
                                    String.htmlEncode(thumbnail.height),
                                    String.htmlEncode(text)
                                )
                            );

                    $$item.appendTo(this.$$items);
                },
                _createChildControls: function ()
                {
                    this.super._createChildControls();

                    var
                        $$containerElement = this.$$containerElementGet();

                    this.$$items = $$.create$$("div", "ui unstackable items");
                    $$containerElement.append(this.$$items);
                },
                _getKey: function ()
                {
                    if (!window.application)
                        return null;

                    var
                        platform = window.application._getPlatform();

                    if (!window.applicationInformation || !window.applicationInformation.youTubeKeys || !window.applicationInformation.youTubeKeys[platform])
                        return null;

                    return window.applicationInformation.youTubeKeys[platform];
                },
                _loadFeedAsync: function ()
                {
                    var
                        self = this;

                    return new Promise((resolve, reject) =>
                    {
                        self.$$items.empty();

                        $$
                            .get(
                                "https://www.googleapis.com/youtube/v3/search",
                                {
                                    key: self._getKey(),
                                    channelId: self.channelIdGet(),
                                    part: "snippet",
                                    type: "video",
                                    order: "date",
                                    pageToken: null,
                                    maxResults: 50
                                }
                            )
                            .then(data =>
                            {
                                self.nextPageTokenSet(data.nextPageToken);

                                if (data.items)
                                {
                                    data.items
                                        .each(item => { self._addItem(item); });
                                }

                                resolve();
                            })
                            .catch(() =>
                            {
                                self._displayErrorDialogAsync("An error occurred while loading the feed")
                                    .then(result =>
                                    {
                                        if (result[0] === seriouslyrad.ui.web.Dialog.dialogResult.ok)
                                            self._loadFeedAsync();
                                        else
                                            window.history.back();
                                    })
                                    .catch(() =>
                                    {
                                        reject();
                                    });
                            });
                    });
                },

                // Public Methods
                show: function ()
                {
                    this._loadFeedAsync();
                    return this.super.show();
                }
            };
        }
    });

    // Photo Picker
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "PhotoPicker",
        createConstructor: namespace =>
        {
            return function ()
            {
                this.$$imageElement = $$.create$$({ nodeName: "img" }).css({ visibility: "hidden" });
                this.$$canvasElement = $$.create$$({ nodeName: "canvas" }).css({ visibility: "hidden" });
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _cleanUpCamera: function (callback)
                {
                    navigator.camera.cleanup(
                        () => { if (callback) callback(); },
                        () => { if (callback) callback(); }
                    );
                },
                _checkFeature: function ()
                {
                    if (!navigator.camera)
                    {
                        seriouslyrad.ui.web.ErrorDialog.displayError("The camera is not available");
                        return false;
                    }

                    return true;
                },
                _getPhotoFromCameraAsync: function ()
                {
                    if (!this._checkFeature())
                        return Promise.reject();

                    return this._getPhotoAsync(Camera.PictureSourceType.CAMERA);
                },
                _getPhotoFromGalleryAsync: function ()
                {
                    if (!this._checkFeature())
                        return Promise.reject();

                    return this._getPhotoAsync(Camera.PictureSourceType.PHOTOLIBRARY);
                },
                _getPhotoFromWebServer: function ()
                {
                    var
                        fullPath = String.format("{0}_test/pac-man.png", window.applicationInformation.virtualDirectory),
                        name = "pac-man.png";

                    return new Promise(resolve =>
                    {
                        setTimeout(() =>
                        {
                            resolve(new seriouslyrad.FileStorage.FileEntry({ fullPath: fullPath, name: name }));
                        });
                    });
                },
                _getPhotoAsync: function (sourceType)
                {
                    var
                        self = this;

                    return new Promise((resolve, reject) =>
                    {
                        if (!this._checkFeature())
                        {
                            reject();
                            return;
                        }

                        navigator.camera.getPicture(
                            imageUrl =>
                            {
                                window.application._savePhotoToTempFileAsync(imageUrl)
                                    .then(fileEntry =>
                                    {
                                        self._cleanUpCamera(() =>
                                        {
                                            resolve(fileEntry);
                                        });
                                    })
                                    .catch(error =>
                                    {
                                        self._cleanUpCamera(() =>
                                        {
                                            reject(error);
                                        });
                                    });
                            },
                            error =>
                            {
                                self._cleanUpCamera(() =>
                                {
                                    // Ignore errors
                                    //seriouslyrad.ui.web.ErrorDialog.displayError(error);
                                    reject(error);
                                });
                            },
                            {
                                quality: 80,
                                destinationType: Camera.DestinationType.FILE_URI,
                                sourceType: sourceType,
                                encodingType: Camera.EncodingType.JPEG,
                                //targetWidth: ?,
                                //targetHeight: ?,
                                mediaType: Camera.MediaType.PICTURE,
                                correctOrientation: true,
                                saveToPhotoAlbum: false,
                                // popoverOptions:  iOS
                                cameraDirection: Camera.Direction.Back
                            }
                        );
                    });
                },

                // Public Methods
                pickFromCameraAsync: function ()
                {
                    if (window.cordova)
                        return this._getPhotoFromCameraAsync();
                    else
                        return this._getPhotoFromWebServer();
                },
                pickFromGalleryAsync: function ()
                {
                    if (window.cordova)
                        return this._getPhotoFromGalleryAsync();
                    else
                        return this._getPhotoFromWebServer();
                }
            };
        }
    });

    // Photo Resizer
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "PhotoResizer",
        createConstructor: namespace =>
        {
            return function ()
            {
                this.$$imageElement = $$.create$$({ nodeName: "img" }).css({ visibility: "hidden" });
                this.$$canvasElement = $$.create$$({ nodeName: "canvas" }).css({ visibility: "hidden" });
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _createResizedImageAsync: function (targetDimensions)
                {
                    return new Promise((resolve, reject) =>
                    {
                        var
                            transformationInformation = this._getTransformInformation(targetDimensions);

                        this.$$canvasElement[0].width = transformationInformation.targetDimensions.width;
                        this.$$canvasElement[0].height = transformationInformation.targetDimensions.height;

                        var
                            context = this.$$canvasElement[0].getContext("2d");

                        context.drawImage(this.$$imageElement[0], transformationInformation.sourceArea.x, transformationInformation.sourceArea.y, transformationInformation.sourceArea.width, transformationInformation.sourceArea.height, 0, 0, transformationInformation.targetDimensions.width, transformationInformation.targetDimensions.height);

                        var
                            jpgData = this.$$canvasElement[0].toDataURL("image/jpeg"),
                            header = "data:image/jpeg;base64,";

                        if (jpgData.startsWith(header))
                            resolve(jpgData);
                        else
                            reject("Base64 image data not as expected");
                    });
                },
                _getPhotoSourceDimensions: function ()
                {
                    var
                        dimensions = { width: this.$$imageElement[0].naturalWidth, height: this.$$imageElement[0].naturalHeight };

                    return (
                        dimensions.width === 0 || dimensions.height === 0
                        ? null
                        : dimensions
                    );
                },
                _getTransformInformation: function (targetDimensions)
                {
                    var
                        sourceDimensions = this._getPhotoSourceDimensions();

                    if (!sourceDimensions)
                        console.error("Unable to obtain source dimensions");

                    if (!targetDimensions)
                    {
                        targetDimensions = {
                            width: sourceDimensions.width,
                            height: sourceDimensions.height
                        };
                    }

                    var
                        sourceAspectRatio = sourceDimensions.width / sourceDimensions.height,
                        targetAspectRatio = targetDimensions.width / targetDimensions.height,
                        sourceArea = { x: 0, y: 0, width: sourceDimensions.width, height: sourceDimensions.height };

                    if (sourceAspectRatio < targetAspectRatio)
                    {
                        // Crop Height
                        sourceArea.width = sourceDimensions.width;
                        sourceArea.height = Math.ceil(sourceDimensions.width / targetAspectRatio);
                        sourceArea.x = 0;
                        sourceArea.y = Math.floor((sourceDimensions.height - sourceArea.height) / 2);
                    }
                    else if (sourceAspectRatio > targetAspectRatio)
                    {
                        // Crop Width
                        sourceArea.width = Math.ceil(sourceDimensions.height * targetAspectRatio);
                        sourceArea.height = sourceDimensions.height;
                        sourceArea.x = Math.floor((sourceDimensions.width - sourceArea.width) / 2);
                        sourceArea.y = 0;
                    }

                    return {
                        sourceDimensions: sourceDimensions,
                        sourceAspectRatio: sourceAspectRatio,
                        targetDimensions: targetDimensions,
                        targetAspectRatio: targetAspectRatio,
                        sourceArea: sourceArea
                    };
                },
                _updateImageAsync: function (fileEntry)
                {
                    var
                        self = this;

                    if (window.cordova)
                    {
                        return new Promise((resolve, reject) =>
                        {
                            fileEntry.file(
                                file =>
                                {
                                    var
                                        fileReader = new FileReader();

                                    fileReader.onload = e =>
                                    {
                                        self.$$imageElement[0].onload = () => { resolve(); };
                                        self.$$imageElement[0].onerror = () => { reject(); };

                                        if (self.$$imageElement[0].src === fileReader.result)
                                            resolve();
                                        else
                                            self.$$imageElement[0].src = fileReader.result;
                                    };

                                    fileReader.onerror = e => { reject(e); };
                                    fileReader.readAsDataURL(file);
                                },
                                error => { reject(error); }
                            );
                        });
                        
                    }

                    return new Promise((resolve, reject) =>
                    {
                        self.$$imageElement[0].onload = () => { resolve(); };
                        self.$$imageElement[0].onerror = () => { reject(); };
                        self.$$imageElement[0].src = String.format("{0}?{1}", fileEntry.toURL(), new Date().getTime());
                    });
                },

                // Public Methods
                resizePhotoAsync: function (fileEntry, targetDimensions)
                {
                    var
                        self = this;

                    return (
                        self._updateImageAsync(fileEntry)
                            .then(() =>
                            {
                                return self._createResizedImageAsync(targetDimensions);
                            })
                    );
                }
            };
        }
    });

    // #region Surveys

    // Survey
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "Survey",
        inherits: "ContainerControl",
        properties: [
            { name: "isCompleted", type: "boolean" },
            { name: "isLoading", type: "boolean" },
            { name: "readOnly", type: "boolean" },
            { name: "surveyId", type: "string" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                isCompleted: false,
                isLoading: false
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-survey");

                // Trigger Property Changes
                this.isCompletedTriggerChange();
                this.isLoadingTriggerChange();
                this.readOnlyTriggerChange();
                this.surveyIdTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _isCompletedChanged: function (change)
                {
                    this.readOnlySet(change.currentValue);
                },
                _createContainerElement: function ()
                {
                    var
                        $$element = this.$$elementGet();

                    this.$$surveyHeader = $$element.find(">.rad-control-survey-header");

                    if (!this.$$surveyHeader.length)
                        this.$$surveyHeader = $$.create$$({ nodeName: "div" }).addClass("rad-control-survey-header").appendTo($$element);

                    this.$$surveyHeaderTitle = this.$$surveyHeader.find(">h2");

                    if (!this.$$surveyHeaderTitle.length)
                        this.$$surveyHeaderTitle = $$.create$$({ nodeName: "h2" }).appendTo(this.$$surveyHeader);

                    var
                        $$successPanelWrapper = $$.create$$({ nodeName: "div" }).appendTo($$element);

                    this.successPanel =
                        new namespace.SuccessPanel();

                    $$successPanelWrapper.append(this.successPanel.$$elementGet());

                    var
                        $$validationPanelWrapper = $$.create$$({ nodeName: "div" }).appendTo($$element);

                    this.validationPanel =
                        new namespace.ValidationPanel();

                    $$validationPanelWrapper.append(this.validationPanel.$$elementGet());

                    var
                        $$containerElement = $$element.find(">.rad-control-container");

                    if (!$$containerElement.length)
                        $$containerElement = $$.create$$({ nodeName: "div" }).addClass("rad-control-container").appendTo($$element);

                    this.$$containerElementSet($$containerElement);

                    this.$$surveyProgressContainer = $$element.find(">.rad-survey-progress-container");

                    if (!this.$$surveyProgressContainer.length)
                        this.$$surveyProgressContainer = $$.create$$({ nodeName: "div" }).addClass("rad-survey-progress-container").appendTo($$element);

                    var
                        page = this.pageGet();

                    if (page)
                    {
                        var
                            pageFooter = page.$$elementGet().find(".rad-control-page-footer").radControl();

                        if (pageFooter)
                            pageFooter.append(this.$$surveyProgressContainer);
                    }

                    this.panelProgress =
                        new namespace.Panel()
                            .appendTo(this.$$surveyProgressContainer);

                    this.$$progessDescription =
                        $$.create$$({ nodeName: "p" })
                            .appendTo(this.panelProgress.$$elementGet());

                    this.progressBar =
                        new namespace.ProgressBar({ total: 0, value: 0 })
                            .appendTo(this.panelProgress);
                },
                _dataSourceChanged: function (change)
                {
                    this.super._dataSourceChanged(change);

                    if (change.originalValue)
                        change.originalValue.off("propertyValueChanged", { self: this }, this.onDataSourcePropertyValueChanged);

                    if (change.currentValue)
                        change.currentValue.on("propertyValueChanged", { self: this }, this.onDataSourcePropertyValueChanged);
                },
                _getAnsweredQuestions: function ()
                {
                    return (
                        this._getSurveyQuestions()
                            .where(item => item.valueGet() !== null || !item.relevantGet())
                            .length
                    );
                },
                _getSurveyIdFromUrl: function ()
                {
                    return (
                        window.pathHelper
                            .getLocation(this.pageGet().urlGet())
                            .pathname
                            .trimEnd("/")
                            .split("/")
                            .last()
                    );
                },
                _getSurveyFooters: function ()
                {
                    return (
                        this.controlsGet()
                            .where(item => item instanceof namespace.SurveyFooter)
                    );
                },
                _getSurveyQuestions: function ()
                {
                    return (
                        this.controlsGet()
                            .where(item => item instanceof namespace.SurveyQuestion)
                    );
                },
                _getTotalQuestions: function ()
                {
                    return (
                        this.controlsGet()
                        .where(item => item instanceof namespace.SurveyQuestion)
                        .length
                    );
                },
                _readOnlyChanged: function (change)
                {
                    this._getSurveyQuestions()
                        .each(item => { item.readOnlySet(change.currentValue); });

                    this._getSurveyFooters()
                        .each(item => { item.visibleSet(!change.currentValue); });
                },
                _textChanged: function (change)
                {
                    this.super._textChanged(change);

                    this.$$surveyHeaderTitle.text(change.currentValue ? change.currentValue : String.empty);
                },
                _updateProgress: function ()
                {
                    var
                        answeredQuestions = 0,
                        totalQuestions = 10;

                    if (!this.isLoadingGet())
                    {
                        answeredQuestions = this._getAnsweredQuestions();
                        totalQuestions = this._getTotalQuestions();
                    }

                    this.$$progessDescription.text(String.format("{0} of {1} answered", answeredQuestions, totalQuestions));
                    this.progressBar.totalSet(totalQuestions);
                    this.progressBar.valueSet(answeredQuestions);
                },

                // Public Methods
                loadAsync: function ()
                {
                    return Promise.resolve();
                },
                submitAsync: function ()
                {
                    // TODO
                },

                // Event Handlers
                onDataSourcePropertyValueChanged: function (evt)
                {
                    evt.data.self._updateProgress();
                },
                onPageLoaded: function (evt, eventData)
                {
                    evt.data.self._updateProgress();
                    eventData.promises.push(evt.data.self.loadDataAsync());
                }
            };
        }
    });

    // Survey Section Header
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "SurveySectionHeader",
        inherits: "ContainerControl",
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-survey-section-header");
            };
        }
    });

    // Survey Footer
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "SurveyFooter",
        inherits: "Control",
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-survey-footer");
                this.onWindowResize({ data: { self: this } });
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _bindEvents: function ()
                {
                    this.super._bindEvents();

                    $$(window).on("resizeend", { self: this }, this.onWindowResize);
                    this.buttonDone.on("click", { self: this }, this.onButtonDoneClicked);
                },
                _createElement: function ()
                {
                    this.super._createElement();

                    var
                        $$element = this.$$elementGet();

                    this.panel =
                        new namespace.Panel()
                        .appendTo($$element);

                    this.buttonDone =
                        new namespace.Button({ text: "Done", cssClass: "rad-action-done" })
                        .appendTo(this.panel);

                    this.$$imagePoweredBy =
                        $$(
                            String.format(
                                "<img class=\"rad-powered-by\" src=\"{0}\" />",
                                encodeURI(String.format("{0}embeddedresources/seriouslyrad.framework.web/resources/content/images/survey/powered-by-seriouslyrad-logo-black.png", window.applicationInformation.virtualDirectory))
                            )
                        ).appendTo(this.panel.$$elementGet());
                },
                _setMinimumHeight: function ()
                {
                    this.$$elementGet().css({ "height": window.innerHeight, "min-height": window.innerHeight });
                },
                _submitSurvey: function ()
                {
                    var
                        self = this,
                        survey = self.parentControlGet();

                    if (!survey)
                        return;

                    survey.submitAsync(true);
                },

                // Event Handlers
                onButtonDoneClicked: function (evt)
                {
                    evt.data.self._submitSurvey();
                },
                onWindowResize: function (evt)
                {
                    evt.data.self._setMinimumHeight();
                }
            };
        }
    });

    // Survey Question
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "SurveyQuestion",
        inherits: "ContainerControl",
        abstract: true,
        properties: [
            { name: "dataSourcePropertyType", type: "string" },
            { name: "inputControl" },
            { name: "questionTitle", type: "string" },
            { name: "readOnly", type: "boolean" },
            { name: "relevant", type: "boolean" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                dataSourceControlSelector: ".rad-control-survey",
                dataSourcePropertyType: "string",
                relevant: true
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-survey-question");

                // Trigger Property Changes
                this.inputControlGet().dataSourcePropertySet("Q" + this._getQuestionNumber());
                this.dataSourcePropertyTypeTriggerChange();
                this.questionTitleTriggerChange();

                this.onWindowResize({ data: { self: this } });
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _bindEvents: function ()
                {
                    this.super._bindEvents();
                    $$(window).on("resizeend", { self: this }, this.onWindowResize);
                    this.buttonNext.on("click", { self: this }, this.onButtonNextClicked);
                    this.inputControlGet().on("valueChanged", { self: this }, this.onInputControlValueChanged);
                },
                _createContainerElement: function ()
                {
                    var
                        $$element = this.$$elementGet();

                    this.$$title = $$element.find(">.rad-title");

                    if (!this.$$title.length)
                        this.$$title = $$.create$$({ nodeName: "h4" }).addClass("rad-title").hide().appendTo($$element);

                    var
                        $$containerElement = $$element.find(">.rad-control-container");

                    if (!$$containerElement.length)
                        $$containerElement = $$.create$$({ nodeName: "div" }).addClass("rad-control-container").appendTo($$element);

                    this.$$containerElementSet($$containerElement);

                    this.$$notRelevant =
                        $$.create$$("p", null, "Not Relevant")
                            .hide()
                            .appendTo($$containerElement);

                    this.inputControlGet()
                        .appendTo(this);

                    this.buttonNext =
                        new namespace.Button({ inline: true, text: "Next" });

                    this.$$elementGet()
                        .append(this.buttonNext.$$elementGet());

                    this.buttonNext.hide();
                },
                _dataSourceChanged: function (change)
                {
                    this.super._dataSourceChanged(change);
                    this.inputControlGet().dataSourceSet(change.currentValue);
                },
                _dataSourcePropertyTypeChanged: function (change)
                {
                    this.inputControlGet().dataSourcePropertyTypeSet(change.currentValue);
                },
                _getQuestionNumber: function ()
                {
                    var
                        survey = this.parentControlGet();

                    if (!survey)
                        return null;

                    var
                        self = this,
                        questionNumber = -1;

                    survey.controlsGet().each((item, index) =>
                    {
                        if (item instanceof namespace.SurveyQuestion)
                            questionNumber++;

                        if (item === self)
                            return false;
                    });

                    return questionNumber > -1 ? questionNumber + 1 : null;
                },
                _questionTitleChanged: function (change)
                {
                    this._updateTitle();
                },
                _readOnlyChanged: function(change)
                {
                    this.inputControlGet().readOnlySet(change.currentValue);
                },
                _relevantChanged: function (change)
                {
                    var
                        inputControl = this.inputControlGet();

                    if (!change.currentValue)
                        inputControl.valueSet(null);

                    inputControl.readOnlySet(!change.currentValue);

                    if (!change.currentValue)
                    {
                        this.$$notRelevant.show();
                        inputControl.hide();
                    }
                    else
                    {
                        this.$$notRelevant.hide();
                        inputControl.show();
                    }

                    this.onInputControlValueChanged({ data: { self: this } });
                },
                _setMinimumHeight: function ()
                {
                    this.$$elementGet().css({ "min-height": window.innerHeight });
                },
                _updateTitle: function ()
                {
                    this.$$title.empty();

                    var
                        questionNumber = this._getQuestionNumber(),
                        questionTitle = this.questionTitleGet();

                    if (questionNumber && questionTitle)
                    {
                        this.$$title.append(
                            $$(
                                String.formatWithHtmlEncode(
                                    "<span>{0}.</span> <span>{1}</span>",
                                    questionNumber,
                                    questionTitle
                                )
                            )
                        );
                        this.$$title.show();
                    }
                    else
                        this.$$title.hide();
                },

                // Public Methods
                scrollToNextQuestion: function ()
                {
                    var
                        survey = this.parentControlGet();

                    if (!survey || survey.isLoadingGet())
                        return;

                    var
                        surveyReadOnly = survey.readOnlyGet(),
                        nextControl = this.nextControl();

                    if (!nextControl)
                        return;

                    if (!surveyReadOnly)
                    {
                        while (!nextControl.isVisibleGet())
                        {
                            nextControl = nextControl.nextControl();

                            if (!nextControl)
                                return;
                        }
                    }

                    nextControl.scrollToAsync();
                },
                updateVisibility: function ()
                {
                    this.super.updateVisibility();

                    if (this.hasCssClass("rad-state-hidden"))
                    {
                        this.removeCssClass("rad-state-hidden");
                        this.relevantSet(false);
                    }
                    else
                        this.relevantSet(true);
                },
                valueGet: function ()
                {
                    return this.inputControlGet().valueGet();
                },

                // Event Handlers
                onButtonNextClicked: function (evt)
                {
                    var
                        self = evt.data.self,
                        survey = self.parentControlGet();

                    if (!survey)
                        return;

                    survey.submitAsync(false);

                    self.scrollToNextQuestion();
                },
                onInputControlValueChanged: function (evt)
                {
                    var
                        self = evt.data.self,
                        value = self.inputControlGet().valueGet();

                    if (value !== null && value !== String.empty || !self.relevantGet())
                        self.buttonNext.show();
                    else
                        self.buttonNext.hide();
                },
                onWindowResize: function (evt)
                {
                    evt.data.self._setMinimumHeight();
                }
            };
        }
    });

    // Survey Question (Check Box List)
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "SurveyQuestionCheckBoxList",
        inherits: "SurveyQuestion",
        properties: [
            { name: "autoScroll", type: "boolean" },
            { name: "checkBoxType", type: "string" },
            { name: "horizontal", type: "boolean" },
            { name: "listDataSource" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                autoScroll: true,
                checkBoxType: namespace.CheckBox.type.checkBox,
                horizontal: false,
                inputControl: new namespace.CheckBoxList()
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                // Trigger Property Changes
                this.checkBoxTypeTriggerChange();
                this.horizontalTriggerChange();
                this.listDataSourceTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _checkBoxTypeChanged: function (change)
                {
                    this.inputControlGet().checkBoxTypeSet(change.currentValue);
                },
                _horizontalChanged: function (change)
                {
                    this.inputControlGet().horizontalSet(change.currentValue);
                },
                _listDataSourceChanged: function (change)
                {
                    this.inputControlGet().listDataSourceSet(change.currentValue);
                },

                // Event Handlers
                onInputControlValueChanged: function (evt)
                {
                    this.super.onInputControlValueChanged(evt);

                    var
                        self = evt.data.self;

                    if (self.autoScrollGet())
                    {
                        if (self.checkBoxTypeGet() === namespace.CheckBox.type.radio)
                        {
                            var
                                value = self.inputControlGet().valueGet();

                            if (value !== null && value !== String.empty)
                                self.onButtonNextClicked({ data: { self: self } });
                        }
                    }
                }
            };
        }
    });

    // Survey Question (Combo Box)
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "SurveyQuestionComboBox",
        inherits: "SurveyQuestion",
        properties: [
            { name: "listDataSource" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                inputControl: new namespace.ComboBox()
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                // Trigger Property Changes
                this.listDataSourceTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _listDataSourceChanged: function (change)
                {
                    this.inputControlGet().listDataSourceSet(change.currentValue);
                }
            };
        }
    });

    // Survey Question (Rank)
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "SurveyQuestionRank",
        inherits: "SurveyQuestion",
        properties: [
            { name: "autoScroll", type: "boolean" },
            { name: "listDataSource" },
            { name: "numberOfRanks", type: "int" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                autoScroll: false,
                inputControl: new namespace.Rank()
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                // Trigger Property Changes
                this.listDataSourceTriggerChange();
                this.numberOfRanksTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _listDataSourceChanged: function (change)
                {
                    this.inputControlGet().listDataSourceSet(change.currentValue);
                },
                _numberOfRanksChanged: function (change)
                {
                    this.inputControlGet().numberOfRanksSet(change.currentValue);
                },

                // Event Handlers
                onInputControlValueChanged: function (evt)
                {
                    this.super.onInputControlValueChanged(evt);

                    var
                        self = evt.data.self;

                    if (self.autoScrollGet())
                    {
                        var
                            value = self.inputControlGet().valueGet();

                        if (value !== null && value !== String.empty)
                            self.onButtonNextClicked({ data: { self: self } });
                    }
                }
            };
        }
    });

    // Survey Question (Text Box)
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "SurveyQuestionTextBox",
        inherits: "SurveyQuestion",
        properties: [
            { name: "textBoxType", type: "string" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                inputControl: new namespace.TextBox(),
                textBoxType: namespace.TextBox.type.normal
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                // Trigger Property Changes
                this.textBoxTypeTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _textBoxTypeChanged: function (change)
                {
                    this.inputControlGet().typeSet(change.currentValue);
                }
            };
        }
    });

    // Survey Question Evaluator
    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "SurveyQuestionEvaluator",
        inherits: "seriouslyrad.logicevaluation.Evaluator",
        properties: [
            { name: "questionNumber", type: "string" },
            { name: "questionValue", type: "string" }
        ],
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _contextChanged: function (change)
                {
                    if (change.originalValue)
                        change.originalValue.off("dataSourceChanged", { self: this }, this.onContextDataSourceChanged);

                    if (change.currentValue)
                        change.currentValue.on("dataSourceChanged", { self: this }, this.onContextDataSourceChanged);

                    this.super._contextChanged(change);
                },

                // Public Methods
                evaluate: function ()
                {
                    if (this.__isConstructing())
                        return;

                    var
                        value = false,
                        context = this.contextGet();

                    if (context)
                    {
                        var
                            dataSource = context.dataSourceGet();

                        if (dataSource)
                        {
                            var
                                propertyValue = dataSource.propertyValueByPathGet("Q" + this.questionNumberGet());

                            if (propertyValue === null)
                                value = true;
                            else
                                value = propertyValue === this.questionValueGet();
                        }
                    }

                    this.valueSet(value);

                    return value;
                },

                // Event Handlers
                onContextDataSourceChanged: function (evt)
                {
                    var
                        self = evt.data.self,
                        context = self.contextGet(),
                        dataSource = context ? context.dataSourceGet() : null;

                    if (self.currentDataSource)
                        self.currentDataSource.off("propertyValueChanged", { self: this }, self.onDataSourcePropertyValueChanged);

                    self.currentDataSource = dataSource;

                    if (self.currentDataSource)
                        self.currentDataSource.on("propertyValueChanged", { self: self }, self.onDataSourcePropertyValueChanged);

                    self.evaluate();
                },
                onDataSourcePropertyValueChanged: function (evt, change)
                {
                    var
                        self = evt.data.self;

                    if (change.path === "Q" + self.questionNumberGet())
                        self.evaluate();
                }
            };
        }
    });

    $$(document).on("seriouslyrad.logicevaluation.Evaluator:RegisterEvaluators", (evt, registerEvaluatorCallback) =>
    {
        registerEvaluatorCallback(seriouslyrad.ui.web.SurveyQuestionEvaluator, "SurveyQuestion");
    });

    // #endregion

    // #region File Viewer

    classFactory.create({
        namespace: "seriouslyrad.ui.web",
        name: "FileViewer",
        abstract: true,
        inherits: "Control",
        properties: [
            { name: "currentPage", type: "int" },
            { name: "entityFileId", type: "string" },
            { name: "totalPages", type: "int" },
            { name: "zoomLevels", type: "array" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                zoomLevels: [
                    "Adaptive",
                    "25%",
                    "50%",
                    "75%",
                    "100%",
                    "200%",
                    "Fit Page",
                    "Fit Width"
                ]
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-file-viewer");

                this.currentPageTriggerChange();
                this.entityFileIdTriggerChange();
                this.totalPagesTriggerChange();
                this.zoomLevelsTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _bindEvents: function ()
                {
                    this.super._bindEvents();

                    this.toolbarButtonFirst.on("click", { self: this }, this.onToolbarButtonFirstClicked);
                    this.toolbarButtonPrevious.on("click", { self: this }, this.onToolbarButtonPreviousClicked);
                    this.toolbarButtonNext.on("click", { self: this }, this.onToolbarButtonNextClicked);
                    this.toolbarButtonLast.on("click", { self: this }, this.onToolbarButtonLastClicked);
                    this.toolbarButtonDownload.on("click", { self: this }, this.onToolbarButtonDownloadClicked);
                    this.toolbarMenuZoom.on("menuItemClicked", { self: this }, this.onToolbarMenuZoomMenuItemClicked);
                },
                _createElement: function ()
                {
                    var
                        self = this;

                    self.super._createElement();

                    var
                        $$element = self.$$elementGet();

                    self.toolbar =
                        new seriouslyrad.ui.web.Toolbar()
                            .appendTo($$element);

                    self.toolbarButtonFirst =
                        new seriouslyrad.ui.web.ToolbarButton({ icon: "angle double left", text: "First Page" })
                            .appendTo(self.toolbar);

                    self.toolbarButtonPrevious =
                        new seriouslyrad.ui.web.ToolbarButton({ icon: "angle left", text: "Previous Page" })
                            .appendTo(self.toolbar);

                    self.toolbarButtonNext =
                        new seriouslyrad.ui.web.ToolbarButton({ icon: "angle right", text: "Next Page" })
                            .appendTo(self.toolbar);

                    self.toolbarButtonLast =
                        new seriouslyrad.ui.web.ToolbarButton({ icon: "angle double right", text: "Last Page" })
                            .appendTo(self.toolbar);

                    self.toolbarSplitter =
                        new seriouslyrad.ui.web.ToolbarSplitter({ text: "Page X of Y" })
                            .appendTo(self.toolbar);

                    self.menuZoom =
                        new seriouslyrad.ui.web.Menu({
                            text: "Zoom"
                        });

                    self.zoomLevelsGet()
                        .each(item =>
                        {
                            self.menuZoom.append(new seriouslyrad.ui.web.MenuItem({ text: item, tag: item }));
                        });

                    self.toolbarMenuZoom =
                        new seriouslyrad.ui.web.ToolbarMenu({ icon: "zoom", menu: self.menuZoom, text: "Zoom" })
                            .appendTo(self.toolbar);

                    self.toolbarButtonDownload =
                        new seriouslyrad.ui.web.ToolbarButton({ icon: "cloud download", text: "Download" })
                            .appendTo(self.toolbar);

                    self.panel =
                        new seriouslyrad.ui.web.Panel({ cssClass: "document-container" })
                            .appendTo($$element);

                    self.$$imageWrapper =
                        $$.create$$("div", "image-wrapper");

                    self.panel.append(self.$$imageWrapper);

                    self.$$image =
                        $$.create$$({ nodeName: "img" })
                            .appendTo(self.$$imageWrapper);

                    self.$$downloadLink =
                        $$.create$$({
                            nodeName: "a",
                            attributes: { style: "display: none" }
                        }).appendTo($$element);
                    
                    self._updateLayout();
                },
                _currentPageChanged: function (change)
                {
                    this._loadImage();
                    this._updateLayout();
                },
                _entityFileIdChanged: function (change)
                {
                    this.$$image.hide();
                },
                _getImageDownloadUrl: function ()
                {
                    var
                        entityFileId = this.entityFileIdGet();

                    return (
                        String.format(
                            "{0}api/filedownload/downloadfile/{1}",
                            window.applicationInformation.serverVirtualDirectory,
                            entityFileId
                        )
                    );
                },
                _getImagePreviewUrl: function ()
                {
                    var
                        entityFileId = this.entityFileIdGet(),
                        currentPage = this.currentPageGet();

                    return (
                        String.format(
                            "{0}api/entityfile/getentityfilepageasimage/{1}/{2}",
                            window.applicationInformation.serverVirtualDirectory,
                            entityFileId,
                            currentPage
                        )
                    );
                },
                _loadImage: function ()
                {
                    var
                        self = this,
                        entityFileId = self.entityFileIdGet(),
                        currentPage = self.currentPageGet();

                    if (entityFileId === null || currentPage === null)
                        return;

                    self._loadingEnqueue();

                    self.$$image
                        .on("error", () =>
                        {
                            self.$$image.off("error load");
                            self.$$image.hide();
                            self._loadingDequeue();

                            seriouslyrad.ui.web.ErrorDialog.displayError("An error occurred while loading the file");
                        })
                        .on("load", () =>
                        {
                            self.$$image.off("error load");
                            self.$$image.show();
                            self._loadingDequeue();
                        });

                    var
                        authenticationData = window.application.authenticationDataGet(),
                        imagePreviewUrl = self._getImagePreviewUrl();

                    if (authenticationData?.scheme === "Bearer")
                    {
                        new seriouslyrad.server
                            .BlobDownloader({
                                headers: {
                                    "Authorization": String.format("Bearer {0}", authenticationData.accessToken)
                                }
                            })
                            .executeAsync(imagePreviewUrl)
                            .then(response =>
                            {
                                self.$$image.prop("src", window.URL.createObjectURL(response.blob));
                            });
                    }
                    else
                        self.$$image.prop("src", imagePreviewUrl);
                },
                _pageChanged: function (change)
                {
                    if (change.originalValue)
                        change.originalValue.off("shown", { self: this }, this.onPageShown);

                    if (change.currentValue)
                        change.currentValue.on("shown", { self: this }, this.onPageShown);
                },
                _totalPagesChanged: function (change)
                {
                    this._updateLayout();
                },
                _updateLayout: function ()
                {
                    var
                        currentPage = this.currentPageGet(),
                        totalPages = this.totalPagesGet();

                    if (currentPage === null || totalPages === null)
                    {
                        this.toolbarSplitter.textSet(String.empty);
                        this.toolbarButtonFirst.enabledSet(false);
                        this.toolbarButtonPrevious.enabledSet(false);
                        this.toolbarButtonNext.enabledSet(false);
                        this.toolbarButtonLast.enabledSet(false);
                        return;
                    }

                    this.toolbarSplitter.textSet(String.format("Page {0} of {1}", currentPage + 1, totalPages));
                    this.toolbarButtonFirst.enabledSet(currentPage > 0);
                    this.toolbarButtonPrevious.enabledSet(currentPage > 0);
                    this.toolbarButtonNext.enabledSet(currentPage < totalPages - 1);
                    this.toolbarButtonLast.enabledSet(currentPage < totalPages - 1);

                    this.trigger("updateLayout");
                },

                // Public Methods
                downloadFile: function ()
                {
                    var
                        authenticationData = window.application.authenticationDataGet(),
                        entityFileId = this.entityFileIdGet(),
                        imageDownloadUrl = this._getImageDownloadUrl();

                    if (authenticationData?.scheme === "Bearer")
                    {
                        new seriouslyrad.server
                            .BlobDownloader({
                                headers: {
                                    "Authorization": String.format("Bearer {0}", authenticationData.accessToken)
                                }
                            })
                            .downloadAsync(imageDownloadUrl, this.$$downloadLink);
                    }
                    else
                        window.open(imageDownloadUrl);
                },
                firstPage: function ()
                {
                    this.currentPageSet(0);
                },
                lastPage: function ()
                {
                    var
                        totalPages = this.totalPagesGet();

                    this.currentPageSet(totalPages - 1);
                },
                loadAsync: function ()
                {
                    console.error("Not Implemented");
                },
                nextPage: function ()
                {
                    var
                        currentPage = this.currentPageGet(),
                        totalPages = this.totalPagesGet();

                    if (currentPage < totalPages - 1)
                        this.currentPageSet(currentPage + 1);
                },
                previousPage: function ()
                {
                    var
                        currentPage = this.currentPageGet();

                    if (currentPage > 0)
                        this.currentPageSet(currentPage - 1);
                },
                setZoomLevel: function (zoomLevel)
                {
                    if (!zoomLevel)
                        return;

                    if (zoomLevel.endsWith("%"))
                    {
                        var
                            zoom = parseInt(zoomLevel);

                        this.$$imageWrapper.css({
                            "max-width": "initial",
                            "width": Math.round(this.$$image[0].naturalWidth * zoom / 100) + "px"
                        });
                        this.$$image.css({
                            "height": "auto",
                            "width": "100%"
                        });
                    }
                    else if (zoomLevel === "Adaptive")
                    {
                        this.$$imageWrapper.css({
                            "height": String.empty,
                            "max-width": String.empty,
                            "width": String.empty
                        });
                        this.$$image.css({
                            "height": String.empty,
                            "width": String.empty
                        });
                    }
                    else if (zoomLevel === "Fit Page")
                    {
                        this.$$imageWrapper.css({
                            "height": "100%",
                            "max-width": String.empty,
                            "width": String.empty
                        });
                        this.$$image.css({
                            "height": "100%",
                            "object-fit": "contain",
                            "width": "100%"
                        });
                    }
                    else if (zoomLevel === "Fit Width")
                    {
                        this.$$imageWrapper.css({
                            "height": "auto",
                            "max-width": "initial",
                            "width": "100%"
                        });
                        this.$$image.css({
                            "height": "auto",
                            "width": "100%"
                        });
                    }

                    var
                        panelElement = this.panel.$$elementGet()[0];

                    panelElement.scrollTop = 0;
                    panelElement.scrollLeft =
                        panelElement.scrollWidth > panelElement.clientWidth
                            ? (panelElement.scrollWidth - panelElement.clientWidth) / 2
                            : 0;
                },

                // Event Handlers
                onPageShown: function (evt)
                {
                    evt.data.self.loadAsync();
                },
                onToolbarButtonFirstClicked: function (evt)
                {
                    evt.data.self.firstPage();
                },
                onToolbarButtonPreviousClicked: function (evt)
                {
                    evt.data.self.previousPage();
                },
                onToolbarButtonNextClicked: function (evt)
                {
                    evt.data.self.nextPage();
                },
                onToolbarButtonLastClicked: function (evt)
                {
                    evt.data.self.lastPage();
                },
                onToolbarButtonDownloadClicked: function (evt)
                {
                    evt.data.self.downloadFile();
                },
                onToolbarMenuZoomMenuItemClicked: function (evt, menuItem)
                {
                    if (!menuItem)
                        return;

                    var
                        self = evt.data.self,
                        zoomLevel = menuItem.tagGet();

                    if (zoomLevel)
                        self.setZoomLevel(zoomLevel);
                }
            };
        }
    });

    // #endregion
